/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 381);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(575);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curry2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__ = __webpack_require__(139);



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(a) ? f2 : Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_b) {
          return fn(a, _b);
        });
      default:
        return Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(b) ? f2 : Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(a) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_a) {
          return fn(_a, b);
        }) : Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(27);
var hide = __webpack_require__(43);
var redefine = __webpack_require__(37);
var ctx = __webpack_require__(56);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return userAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return componentFamilyAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return systemAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trailerAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return oilAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return inspectionAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return componentAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return manufacturerAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boatAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
// TODO: check is qs lib nesscesary?
var userAPI={token:'/user/oauth/token',info:'/user/userInfo',revoke:'/user/oauth/revoke',sendResetPasswordEmail:function sendResetPasswordEmail(email){return'/crm/api/v1/user/resetPassword/email?email='+email;},resetPassword:function resetPassword(email,newPassword,resetToken){return'/crm/api/v1/user/resetPassword?email='+email+'&newPassword='+newPassword+'&resetToken='+resetToken;},getManufacturersByCredentials:function getManufacturersByCredentials(_ref){var username=_ref.username,password=_ref.password;return'/crm/api/v1/user/manufacturers?email='+username+'&password='+password;},getManufacturersByAccountId:function getManufacturersByAccountId(_ref2){var accountId=_ref2.accountId;return'/crm/api/v1/user/manufacturers?userid='+accountId;}};var componentFamilyAPI={list:'/component/api/v1/component_family/',listByType:function listByType(typeId){return'/component/api/v1/component_family?componentTypeId='+typeId;},info:function info(id){return'/component/api/v1/component_family/'+id;},submit:'/component/api/v1/component_family/',approve:function approve(id){return'/component/api/v1/component_family/'+id+'/approve';},downloadReport:function downloadReport(familyId,id){return'/component/api/v1/component_family/'+familyId+'/test-report/'+id;}};var systemAPI={getAvailableBoatSystemsList:'/component/api/v1/componentSystem',getBoatSystemStructure:function getBoatSystemStructure(id){return'/component/api/v1/componentSystem/'+id;},saveSystem:'/component/api/v1/componentSystemValue',deleteSystem:function deleteSystem(systemId){return'/component/api/v1/componentSystemValue?componentSystemValueId='+systemId;},getComponentsByType:function getComponentsByType(typeId,isActive){return'/component/api/v1/componentSystemValue/components/type/'+typeId+'?isManufacturerActive='+isActive;},getSystemsForBoat:function getSystemsForBoat(boatId){return'/component/api/v1/componentSystemValue/'+boatId;},getComponent:function getComponent(componentIds){return'/component/api/v1/componentSystemValue/components?componentIds='+(componentIds&&componentIds.join?componentIds:componentIds.join(','));}};var trailerAPI={trailers:'/trailer/api/v1/trailers/',trailersByYear:function trailersByYear(){var year=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var isInspection=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return'/trailer/api/v1/trailers?year='+year+'&inspectionList='+isInspection;},getPermissibleModelYears:'/trailer/api/v1/util/model/years',currentModelYear:'/trailer/api/v1/util/model/year',rollOver:function rollOver(trailerId){return'/trailer/api/v1/rollOver'+(trailerId?'/'+trailerId:'');},reactivate:function reactivate(trailerId){return'/trailer/api/v1/trailers/reactivate?trailerId='+trailerId;},deactivate:function deactivate(trailerId){return'/trailer/api/v1/trailers/deactivate?trailerId='+trailerId;},delete:function _delete(trailerId){return'/trailer/api/v1/trailers/'+trailerId;},getMMLReport:function getMMLReport(modelYear,contact){return'/trailer/api/v1/report/mml/'+modelYear+'?contact='+contact;},getHistoricMMLReport:function getHistoricMMLReport(modelYear,dateString){return'/trailer/api/v1/report/mml/historic/'+modelYear+'?date='+dateString;},newTrailersCount:function newTrailersCount(modelYear,calendarYear,month){return'/trailer/api/v1/trailers/number/new?year='+modelYear+'&month='+calendarYear+'-'+month;}};var oilAPI={engineTypes:'/oil/api/v1/formula/engineTypes',formula:function formula(id){return'/oil/api/v1/formula/'+id;},formulasList:'/oil/api/v1/formula/',submitFormula:'/oil/api/v1/formula/',updateFormula:'/oil/api/v1/formula/update',approveFormula:function approveFormula(id){return'/oil/api/v1/formula/approve/'+id;},deactivateFormula:function deactivateFormula(id){return'/oil/api/v1/formula/deactivate/'+id;},incompleteFormula:function incompleteFormula(id){return'/oil/api/v1/formula/incomplete/'+id;},pendFormula:function pendFormula(id){return'/oil/api/v1/formula/submit/'+id;},changeFormulaPaymentStatus:function changeFormulaPaymentStatus(id,isPaid){return'/oil/api/v1/formula/paid/'+id+'?isPaid='+isPaid;},downloadFormulaCertLetter:function downloadFormulaCertLetter(id){return'/oil/api/v1/formula/cert/letter/'+id;},brand:function brand(id){return'/oil/api/v1/brand/'+id;},brandsList:function brandsList(signed,year){return'/oil/api/v1/brand'+__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({signed:signed,year:year},{addQueryPrefix:true});},submitBrand:'/oil/api/v1/brand',updateBrand:'/oil/api/v1/brand/update',approveBrand:function approveBrand(id){return'/oil/api/v1/brand/approve/'+id;},deactivateBrand:function deactivateBrand(id){return'/oil/api/v1/brand/deactivate/'+id;},incompleteBrand:function incompleteBrand(id){return'/oil/api/v1/brand/incomplete/'+id;},pendBrand:function pendBrand(id){return'/oil/api/v1/brand/submit/'+id;},rollOverBrand:function rollOverBrand(id){return'/oil/api/v1/rollOver/'+id;},downloadReport:function downloadReport(formulaId,reportId){return'/oil/api/v1/formula/'+formulaId+'/report/'+reportId;},downloadBrandCertLetter:function downloadBrandCertLetter(id){return'/oil/api/v1/brand/cert/letter/'+id;},eSignBrandLicense:function eSignBrandLicense(id){return'/oil/api/v1/brand/license/'+id;},downloadBrandDocumentsList:function downloadBrandDocumentsList(id,year){return'esign/api/v1/es/brand?brandNumber='+id+'&modelYear='+year;},newOilBrandsCount:function newOilBrandsCount(modelYear,calendarYear,month){return'/oil/api/v1/brand/number/new?year='+modelYear+'&month='+calendarYear+'-'+month;},downloadActiveOilReport:function downloadActiveOilReport(modelYear){return'/oil/api/v1/brand/active/report/download?year='+modelYear;},downloadActiveOilFormulationsReport:function downloadActiveOilFormulationsReport(modelYear){return'/oil/api/v1/formula/active/report/download?year='+modelYear;}};var inspectionAPI={inspectionList:function inspectionList(boatInspecFlag){return'inspection/api/v1/inspect?boatInspecFlag='+boatInspecFlag;},inspectionDetails:function inspectionDetails(id){return'inspection/api/v1/inspect/'+id;},submitInspectionRequest:'inspection/api/v1/inspect/',incompleteReport:function incompleteReport(id){return'inspection/api/v1/inspect/incomplete/'+id;},incompleteResponse:function incompleteResponse(id){return'inspection/api/v1/var/incomplete/'+id;},resubmitReport:function resubmitReport(id){return'inspection/api/v1/inspect/resubmit/'+id;},approveReport:function approveReport(id){var isRequired=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return'inspection/api/v1/inspect/complete/'+id+'/'+isRequired;},approveResponse:function approveResponse(id){return'inspection/api/v1/var/complete/'+id;},downloadReportDocument:function downloadReportDocument(inspectionReportId,docId){return'inspection/api/v1/doc/download/inspection/'+inspectionReportId+'/doc/'+docId;},downloadResponseDocument:function downloadResponseDocument(varId,reportId){return'inspection/api/v1/report/download/var/'+varId+'/report/'+reportId;},requestResponse:function requestResponse(id,isRequired){return'inspection/api/v1/inspect/'+id+'/var/'+isRequired;},submitVarianceResponse:function submitVarianceResponse(id){return'inspection/api/v1/var/submit/'+id;},saveVarianceResponse:'inspection/api/v1/var/',deleteReport:function deleteReport(id){return'inspection/api/v1/inspect/'+id;},eSignReport:function eSignReport(id){return'inspection/api/v1/inspect/sign/'+id;},newBoatInspectionsCount:function newBoatInspectionsCount(modelYear,calendarYear,month){return'inspection/api/v1/inspect/number/new?year='+modelYear+'&month='+calendarYear+'-'+month+'&boatInspecFlag=true';},newTrailerInspectionsCount:function newTrailerInspectionsCount(modelYear,calendarYear,month){return'inspection/api/v1/inspect/number/new?year='+modelYear+'&month='+calendarYear+'-'+month+'&boatInspecFlag=false';}};var componentAPI={categories:'/component/api/v1/component/categories',types:'/component/api/v1/component_types',list:'/component/api/v1/components/?includeReports=false',listWithoutFamily:'/component/api/v1/components/without-family',listWithReports:'/component/api/v1/components/test-report/list-to-copy-from',create:'/component/api/v1/components/',categoriesWithTypes:'/component/api/v1/components/categories/types',componentInfo:function componentInfo(id){return'/component/api/v1/components/'+id;},componentReportsInfo:function componentReportsInfo(id){return'/component/api/v1/report/all/'+id;},downloadReport:function downloadReport(componentId,reportId){return'/component/api/v1/components/'+componentId+'/test-report/'+reportId;},approve:function approve(id){return'/component/api/v1/components/'+id+'/approve';},deactivate:function deactivate(id){return'/component/api/v1/components/'+id+'/deactivate';},incomplete:function incomplete(id){return'/component/api/v1/components/'+id+'/incomplete';},reactivate:function reactivate(id){return'/component/api/v1/components/'+id+'/reactivate';},submit:function submit(id){return'/component/api/v1/components/'+id+'/submit';},newComponentsCount:function newComponentsCount(modelYear,calendarYear,month){return'/component/api/v1/components/number/new?month='+calendarYear+'-'+month;},listReport:function listReport(typeIds){return'/component/api/v1/component/report?componentTypeIds='+typeIds.join();}};var manufacturerAPI={addressesList:function addressesList(manufacturerId){return'/manufacturer/api/v1/crmInfo/addresses?accountCode='+manufacturerId;},list:function list(role){return'/manufacturer/api/v1/manufacturer?role='+role;},inspectorsList:function inspectorsList(role){return'/manufacturer/api/v1/manufacturer/inspector?inspectedRole='+role;},listWithChecklistItems:function listWithChecklistItems(role,year,signStatus,inspectorCode,withBrands){return'/manufacturer/api/v1/manufacturer/'+(withBrands?'withChecklistAndBoatBrands':'withChecklist')+'?role='+role+'&year='+year+(signStatus!==undefined?'&signed='+signStatus:'')+(inspectorCode?'&inspectorCode='+inspectorCode:'');},addBrand:'manufacturer/api/v1/brand',deleteBrand:function deleteBrand(brandId){return'/manufacturer/api/v1/brand/'+brandId;},details:function details(manufacturerId){return'/manufacturer/api/v1/manufacturer/'+manufacturerId;},changeStatus:function changeStatus(id,status){return'/manufacturer/api/v1/manufacturer/changeStatus/'+id+'?active='+status;},getEngineeringContacts:function getEngineeringContacts(manufacturerId){return'/manufacturer/api/v1/manufacturer/'+manufacturerId+'/engineeringContacts';},getInspectorContacts:function getInspectorContacts(manufacturerId){return'/manufacturer/api/v1/manufacturer/'+manufacturerId+'/inspectorContacts';},checkList:function checkList(role,year){return'manufacturer/api/v1/checklist?role='+role+'&year='+year;},eSignDocumentsList:function eSignDocumentsList(year,role){return'esign/api/v1/es?manufacturerRole='+role+(year!=='All'?'&modelYear='+year:'');},eSignDocumentDownload:function eSignDocumentDownload(envelopeId){return'esign/api/v1/es/download?envelopeId='+envelopeId;},eSignBoatCertAgreement:function eSignBoatCertAgreement(year,isPWC){return'manufacturer/api/v1/cert/boat?isPWC='+!!isPWC+'&year='+year;},eSignComponentCertAgreement:function eSignComponentCertAgreement(year){return'manufacturer/api/v1/cert/component?year='+year;},eSignTrailerCertAgreement:function eSignTrailerCertAgreement(year){return'manufacturer/api/v1/cert/trailer?year='+year;},capacityTagStatus:'manufacturer/api/v1/capacityTag',micNumber:'/crm/api/v1/mic/number'};var boatAPI={list:'/boat/api/v1/boats/',create:'/boat/api/v1/boats/',details:function details(boatId){return'/boat/api/v1/boats/'+boatId;},boatByYear:function boatByYear(year){return'/boat/api/v1/boats/year/'+year;},approvedBoatsByYear:function approvedBoatsByYear(){var year=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var isInspection=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return'/boat/api/v1/boats/approved/year/'+year+'?inspectionList='+isInspection;},saveCubicCapacity:'/boat/api/v1/cubicCapacity',savePowerCapacity:function savePowerCapacity(boatId){return'/boat/api/v1/calcs/mpc/'+boatId;},checkMatrix:function checkMatrix(boatId){return'/boat/api/v1/cubicCapacity/calculateArea?boatId='+boatId;},calculateCapacity:function calculateCapacity(boatId){return'/boat/api/v1/cubicCapacity/calculateCapacity?boatId='+boatId;},calculatPontoonCapacity:function calculatPontoonCapacity(boatId){return'/boat/api/v1/calcs/pontoon/'+boatId;},getEnteredCubicCapacity:function getEnteredCubicCapacity(boatId){return'/boat/api/v1/cubicCapacity/list?boatId='+boatId;},currentModelYear:'/boat/api/v1/util/model/year',modelYears:'/boat/api/v1/util/model/years',stateCodes:'/boat/api/v1/cityAndState/stateCodes',calculatePersonWeightCapacity:function calculatePersonWeightCapacity(boatId){return'/boat/api/v1/calcs/pw/'+boatId;},getFloatationTestReports:function getFloatationTestReports(boatId){return'/boat/api/v1/flotationReport/'+boatId;},uploadFloatationTestReports:function uploadFloatationTestReports(boatId){return'/boat/api/v1/flotationReport/upload/'+boatId;},deleteFloatationTestReports:function deleteFloatationTestReports(boatId){return'/boat/api/v1/flotationReport/remove/'+boatId;},downloadReport:function downloadReport(boatId,reportId){return'/boat/api/v1/flotationReport/download/boat/'+boatId+'/document/'+reportId;},getAdditionalDocs:function getAdditionalDocs(boatId){return'/boat/api/v1/additionalDoc/'+boatId;},uploadAdditionalDocs:function uploadAdditionalDocs(boatId){return'/boat/api/v1/additionalDoc/upload/'+boatId;},deleteAdditionalDocs:function deleteAdditionalDocs(boatId){return'/boat/api/v1/additionalDoc/remove/'+boatId;},downloadFile:function downloadFile(boatId,docId){return'/boat/api/v1/additionalDoc/download/boat/'+boatId+'/document/'+docId;},submit:function submit(boatId){return'/boat/api/v1/boats/submit?boatId='+boatId;},deactivate:function deactivate(boatId){return'/boat/api/v1/boats/deactivate?boatId='+boatId;},reactivate:function reactivate(boatId){return'/boat/api/v1/boats/reactivate?boatId='+boatId;},saveSteeringSystem:function saveSteeringSystem(boatId,dualSteering){return'/boat/api/v1/boats/dualsteering/'+boatId+'?dualSteering='+dualSteering;},getMMLReport:function getMMLReport(modelYear,contact){return'/boat/api/v1/mmlReport/'+modelYear+'?contact='+contact;},getHistoricMMLReport:function getHistoricMMLReport(modelYear,dateString){return'/boat/api/v1/mmlReport/historic/'+modelYear+'?date='+dateString;},getCARBReport:'/boat/api/v1/capacityTagReport/download',rollOver:function rollOver(boatId){return'/boat/api/v1/rollOver/'+boatId;},newBoatsCount:function newBoatsCount(modelYear,calendarYear,month){return'/boat/api/v1/calcs/number/new?year='+modelYear+'&month='+calendarYear+'-'+month;},approvedBoatsCount:function approvedBoatsCount(modelYear,calendarYear,month){return'/boat/api/v1/calcs/number/approved?year='+modelYear+'&month='+calendarYear+'-'+month;},approvedActiveBoatsCount:function approvedActiveBoatsCount(modelYear){return'/boat/api/v1/calcs/number/approved/active?year='+modelYear;},approvedCertifiedBoatsCount:function approvedCertifiedBoatsCount(modelYear){return'/boat/api/v1/calcs/number/certified?year='+modelYear;},getCertifiedBrandsCount:function getCertifiedBrandsCount(modelYear){return'/manufacturer/api/v1/brand/certified/'+modelYear+'/count';},getActiveBrandsCount:function getActiveBrandsCount(modelYear){return'/manufacturer/api/v1/brand/active/'+modelYear+'/count';}};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_actionTypes__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__ = __webpack_require__(16);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var instance=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:__WEBPACK_IMPORTED_MODULE_4_config__["a" /* default */].baseURL});instance.interceptors.request.use(function(cfg){getAuthorizationHeader(cfg);getManufacturerCode(cfg);return cfg;});instance.interceptors.response.use(function(response){return response;},function(error){if(error.response){if(error.response.status===401||error.response.status===403)__WEBPACK_IMPORTED_MODULE_3_App__["b" /* store */].dispatch({type:__WEBPACK_IMPORTED_MODULE_5_store_actionTypes__["o" /* USER_LOG_OUT_SUCCESS */]});if(error.response.status===500&&error.response.data&&_typeof(error.response.data)==='object'&&(error.response.data.message==='403 Forbidden'||error.response.data.status==='FORBIDDEN')){__WEBPACK_IMPORTED_MODULE_3_App__["b" /* store */].dispatch({type:__WEBPACK_IMPORTED_MODULE_5_store_actionTypes__["o" /* USER_LOG_OUT_SUCCESS */]});}if(error.response.status>299&&error.response.status<400){return Promise.resolve(error.response);}else{var message='';if(typeof error.response==='string'){message=error.response;}else if(typeof error.response.data==='string'){message=error.response.data;}else{message=error.response.data.error_description||error.response.data.message;}if(!message){var reader=new FileReader();reader.onloadend=function(event){try{__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error(error.response.status,JSON.parse(event.target.result).message);}catch(e){__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error(error.response.status,event.target.result);}};reader.readAsText(error.response.data);}else{__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error(error.response.status,message);}return Promise.reject(error);}}return Promise.reject(error);});function isCommunityHubOAuthUrl(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return url.includes('/services/oauth2/');}function getAuthorizationHeader(cfg){if(cfg.headers&&cfg.headers.Authorization)return;if(isCommunityHubOAuthUrl(cfg.url))return;if(!cfg.url.includes('/user/oauth/token')&&!cfg.url.includes('/user/userInfo')){var state=__WEBPACK_IMPORTED_MODULE_3_App__["b" /* store */].getState();var token=state.user.token;cfg.headers.Authorization='Bearer '+token;}}function getManufacturerCode(cfg){if(isCommunityHubOAuthUrl(cfg.url))return;if(!cfg.url.includes('/user/oauth/token')&&!cfg.url.includes('/user/userInfo')&&!cfg.url.includes('/manufacturer/api/v1/manufacturer?role=')&&!cfg.url.includes('/revoke')&&!cfg.url.includes('/component_types')&&!cfg.url.includes('/manufacturer/api/v1/manufacturer/changeStatus')){var state=__WEBPACK_IMPORTED_MODULE_3_App__["b" /* store */].getState();if(cfg.url.includes('/checklist')||cfg.url.includes('/brand')||cfg.url.includes('/mic/number')||cfg.url.includes('/api/')||cfg.url.includes('manufacturer/api/v1/cert/')||cfg.url.includes(__WEBPACK_IMPORTED_MODULE_1__requests__["e" /* manufacturerAPI */].capacityTagStatus)||state.user.roles[0]===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].INTERNAL.serverName||state.user.roles[0]===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].INSPECTION.serverName){var code=undefined;if(state.user.selectedManufacturer){code=state.user.selectedManufacturer.code;}else if(state.user.manufacturer){code=state.user.manufacturer.code;}else{code=state.user.accountCode;}if(code){var separator=cfg.url.includes('?')?'&':'?';cfg.url=''+cfg.url+separator+'mnfCode='+code;}}}}/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curry1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlaceholder_js__ = __webpack_require__(139);


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || Object(__WEBPACK_IMPORTED_MODULE_0__isPlaceholder_js__["a" /* default */])(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buttonType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var buttonType={primary:'primary',secondary:'secondary',additional:'additional'};var buttonColor={blue:'blue',lightBlue:'light-blue',green:'green',red:'red',gray:'gray',orange:'orange',planeOrange:'planeOrange',planeRed:'planeRed',darkGreen:'dark-green',darkRed:'dark-red'};var Button=function Button(props){var buttonClasses='ect-button ect-button_'+props.type+' '+props.color+' '+props.buttonClassName+'\n  '+(props.disabledWithSpinner?'ect-spinner':'')+' '+(props.disabled?'disabled':'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:props.formButtonType,className:buttonClasses,disabled:props.disabled||props.disabledWithSpinner,onClick:props.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.disabledWithSpinner?'ect-spinner__image ect-spinner__image_for-button':props.iconClassName}),!props.disabledWithSpinner&&props.label);};Button.propTypes={formButtonType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,buttonClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabledWithSpinner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,iconClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Button.defaultProps={formButtonType:'button',buttonClassName:'',label:'',type:buttonType.primary,color:buttonColor.blue,disabled:false,disabledWithSpinner:false,iconClassName:'icon-not-displayed',onClick:function onClick(){}};/* harmony default export */ __webpack_exports__["c"] = (Button);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Info__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var selectType={primary:'primary',primarySmall:'primary_small',secondary:'secondary',listFilter:'filters',listActions:'actions'};var Select=function(_React$Component){_inherits(Select,_React$Component);function Select(props){_classCallCheck(this,Select);var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));_this._keyboardActions=function(event){var isOpen=_this.state.isOpen;if(isOpen){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();_this.keySelectedIndex=_this.state.keySelectedIndex;switch(event.key){case'ArrowDown':case'Down':return _this.setState(function(prevState){var keySelectedIndex=_this.props.selectionList.length-1;if(prevState.keySelectedIndex!==keySelectedIndex){keySelectedIndex=++prevState.keySelectedIndex;}return{keySelectedIndex:keySelectedIndex};});case'ArrowUp':case'Up':return _this.setState(function(prevState){var keySelectedIndex=-1;if(prevState.keySelectedIndex!==keySelectedIndex){keySelectedIndex=--prevState.keySelectedIndex;}return{keySelectedIndex:keySelectedIndex};});case'Enter':if(_this.state.keySelectedIndex!==-1){_this.handleSelect(_this.props.selectionList[_this.state.keySelectedIndex],_this.state.keySelectedIndex)(event);}}}};_this.getValue=function(selectedItem){var itemNameIndicator=_this.props.itemNameIndicator;if(itemNameIndicator===''){return selectedItem.toString();}else if(typeof itemNameIndicator==='string'){return selectedItem[itemNameIndicator]||'';}else if(itemNameIndicator.length!==undefined){return itemNameIndicator.reduce(function(string,indicator){if(selectedItem[indicator]===undefined)return string;return string+selectedItem[indicator]+' - ';},'').slice(0,-3);}};_this.getSelectedValue=function(){var isSlave=_this.props.isSlave;var _this$state=_this.state,selectedItem=_this$state.selectedItem,filterValue=_this$state.filterValue;if(filterValue===null){if(selectedItem===''||isSlave)return _this.getValue(_this.props.defaultItem);else return _this.getValue(selectedItem);}return filterValue;};_this.getDropDownList=function(){var _this$state2=_this.state,filterValue=_this$state2.filterValue,textWrappersRefs=_this$state2.textWrappersRefs;var _this$props=_this.props,selectionList=_this$props.selectionList,itemClassName=_this$props.itemClassName,type=_this$props.type,withCheckBoxes=_this$props.withCheckBoxes,defaultItem=_this$props.defaultItem,isSlave=_this$props.isSlave,checkBoxClassName=_this$props.checkBoxClassName,disabledInfoText=_this$props.disabledInfoText;return selectionList.filter(function(element){if(filterValue===null)return true;var el=_this.getValue(element).toLowerCase();return el.indexOf(filterValue.toLowerCase())!==-1;}).map(function(element,index){var selectedByKeyboard=_this.state.keySelectedIndex!==-1&&index===_this.state.keySelectedIndex;var isSelectedItem=isSlave?element===defaultItem:element===_this.state.selectedItem;var selectedClass=selectedByKeyboard||_this.state.keySelectedIndex===-1&&isSelectedItem?'select__drop-down-item_selected':'';if(withCheckBoxes&&element.disabled&&disabledInfoText)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'select__drop-down-item select__drop-down-item_'+type+' '+itemClassName+' '+selectedClass+' select__drop-down-item_'+type+'_with-checkbox '+(element.disabled?'select__drop-down-item_disabled':''),onClick:_this.handleSelect(element,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__drop-down-item-tex-wrapper',style:{right:_this.getTextWrapperRightShift(textWrappersRefs[index])},ref:_this.saveTextWrapperRef},_this.getValue(element)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__checkBoxIcon\n              '+(element.checked?'__checkbox_checked':'__checkbox_empty')+'\n              '+(checkBoxClassName||'_top_0 _left_0')+' _position_absolute '})),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},disabledInfoText)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'select__drop-down-item select__drop-down-item_'+type+' '+itemClassName+' '+selectedClass+'\n               '+(withCheckBoxes?'select__drop-down-item_'+type+'_with-checkbox':'')+'\n               '+(withCheckBoxes&&element.disabled?'select__drop-down-item_disabled':''),onClick:_this.handleSelect(element,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__drop-down-item-tex-wrapper',style:{right:_this.getTextWrapperRightShift(textWrappersRefs[index])},ref:_this.saveTextWrapperRef},_this.getValue(element)),withCheckBoxes&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__checkBoxIcon\n              '+(element.checked?'__checkbox_checked':'__checkbox_empty')+'\n              '+(checkBoxClassName||'_top_0 _left_0')+' _position_absolute '}));});};_this.saveTextWrapperRef=function(ref){var textWrappersRefs=_this.state.textWrappersRefs;textWrappersRefs.push(ref);_this.setState({textWrappersRefs:textWrappersRefs});};_this.getTextWrapperRightShift=function(DOMObj){if(DOMObj){return DOMObj.scrollWidth-DOMObj.offsetWidth;}return 0;};_this.openDropDown=function(event){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();if(!_this.state.isOpen){if(_this.props.withoutSearch){_this.inputRef.current.blur();}var _event={};if(typeof Event==='function'){_event=new Event('click');}else{_event=document.createEvent('Event');_event.initEvent('click',true,true);}document.dispatchEvent(_event);_this.setState({isOpen:true,filterValue:_this.props.withoutSearch?null:''},function(){_this.inputRef.current.focus();document.addEventListener('click',_this.closeDropDown);document.addEventListener('keydown',_this._keyboardActions,true);_this.forceUpdate();});}};_this.closeDropDown=function(event){if(_this.state.isOpen){document.removeEventListener('click',_this.closeDropDown);document.removeEventListener('keydown',_this._keyboardActions);_this.setState({isOpen:false,filterValue:null,keySelectedIndex:-1});}};_this.handleInputChange=function(_ref){var target=_ref.target;_this.setState({filterValue:target.value});};_this.handleSelect=function(selectedItem,keySelectedIndex){return function(event){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();if(!_this.props.multiSelect){_this.setState({selectedItem:selectedItem,keySelectedIndex:keySelectedIndex,filterValue:null},function(){_this.props.handleSelect(selectedItem);if(!(document.documentMode||/Edge/.test(navigator.userAgent)))_this.inputRef.current.focus();_this.closeDropDown();});}else{_this.props.handleSelect(selectedItem,event);}};};_this.handleClearInputClick=function(event){var _this$state3=_this.state,selectedItem=_this$state3.selectedItem,filterValue=_this$state3.filterValue;var _this$props2=_this.props,defaultItem=_this$props2.defaultItem,handleSelect=_this$props2.handleSelect,unclearable=_this$props2.unclearable;if((selectedItem||filterValue||defaultItem)&&!unclearable){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();_this.setState({selectedItem:'',filterValue:null,keySelectedIndex:-1},function(){if(defaultItem)handleSelect('',event);});}};_this.state={isOpen:false,filterValue:null,selectedItem:'',keySelectedIndex:-1,textWrappersRefs:[]};_this.inputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.keySelectedIndex=-1;_this.uniqueIdNumber=Math.floor(Math.random()*9000);return _this;}_createClass(Select,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(this.getValue(nextProps.defaultItem)!==this.getValue(this.props.defaultItem)){this.setState({selectedItem:nextProps.defaultItem});}return true;}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.isSlave&&this.props.defaultItem===''&&this.state.selectedItem!==''){this.setState({selectedItem:''});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.closeDropDown);document.removeEventListener('keydown',this._keyboardActions);}},{key:'render',value:function render(){var isOpen=this.state.isOpen;var _props=this.props,type=_props.type,label=_props.label,placeholder=_props.placeholder,error=_props.error,capitalizeLabel=_props.capitalizeLabel,disabled=_props.disabled,inputClassName=_props.inputClassName,dropDownClassName=_props.dropDownClassName,mainWrapperClassName=_props.mainWrapperClassName,inputFieldWrapperClassName=_props.inputFieldWrapperClassName,labelClassName=_props.labelClassName,iconClassName=_props.iconClassName,isLoading=_props.isLoading,tabIndex=_props.tabIndex,withoutSearch=_props.withoutSearch,unclearable=_props.unclearable,selectAll=_props.selectAll,unselectAll=_props.unselectAll;var updatedLabel=label&&capitalizeLabel?label[0].toUpperCase()+label.slice(1).toLowerCase():label;var errorTextElement=error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__error'},error):null;var inputValue=this.getSelectedValue();var isOpenClass=isOpen?'open':'';var errorClass=''+(error?'error':'');var mainWrapperOldOrNewClass=type===selectType.listFilter||type===selectType.listActions||type===selectType.primary||type===selectType.primarySmall?'select__main-wrapper select__main-wrapper_'+type:'ect-select';var leaveSpaceForLabelButtons=!updatedLabel&&(selectAll||unselectAll);var mainWrapperClasses=mainWrapperOldOrNewClass+' '+errorClass+' '+type+' '+mainWrapperClassName+' '+(leaveSpaceForLabelButtons?'_padding_top_20':'');var labelClasses='select__label select__label_'+type+' '+labelClassName;var inputFieldWrapperClasses='select__input-field-wrapper\n    select__input-field-wrapper_'+type+' '+inputFieldWrapperClassName;var loadPlaceholderClasses='select__loading-placeholder select__loading-placeholder_'+type+' '+inputClassName;var inputFieldClasses='select__input select__input_'+type+'\n                   '+(withoutSearch?'select__input_'+type+'_not-searchable':'')+'\n                   '+inputClassName+' '+(disabled?'select__input_'+type+'_disabled':'')+' '+isOpenClass+' '+errorClass;var inputFieldIconClasses='select__input-icon select__input-icon_'+type+'\n              '+(inputValue&&!unclearable&&'select__input-icon_'+type+'_clear-mode')+'\n              '+iconClassName+' '+(leaveSpaceForLabelButtons?'_top_25':'');var dropDownListClasses='select__drop-down-list select__drop-down-list_'+type+'\n    '+isOpenClass+' '+dropDownClassName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:mainWrapperClasses},isOpen&&(selectAll||unselectAll)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__label-buttons-placeholder'},selectAll&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__sub-label _cursor_pointer',onClick:selectAll},'Select All'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__sub-label _cursor_pointer',onClick:unselectAll},'Unselect All')),updatedLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'ect-select-field_'+this.uniqueIdNumber,className:labelClasses},updatedLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputFieldWrapperClasses},!disabled&&isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:loadPlaceholderClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'jumping-dot'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'jumping-dot'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'jumping-dot'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'ect-select-field_'+this.uniqueIdNumber,value:inputValue,className:inputFieldClasses,placeholder:placeholder,disabled:disabled,onChange:this.handleInputChange,tabIndex:tabIndex,ref:this.inputRef,autoComplete:'off',onFocus:this.openDropDown,onClick:this.openDropDown}),!withoutSearch&&!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputFieldIconClasses,onClick:this.handleClearInputClick})),errorTextElement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dropDownListClasses},this.getDropDownList()));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Select.propTypes={defaultItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),handleSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selectionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,itemNameIndicator:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),capitalizeLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,multiSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSlave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,inputClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dropDownClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mainWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputFieldWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,iconClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,itemClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tabIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,withoutSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,unclearable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withCheckBoxes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,checkBoxClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),unselectAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])};Select.defaultProps={defaultItem:'',handleSelect:function handleSelect(){},selectionList:[],type:'primary',label:'',placeholder:'',itemNameIndicator:'',error:'',capitalizeLabel:false,disabled:false,isLoading:false,multiSelect:false,isSlave:false,inputClassName:'',dropDownClassName:'',mainWrapperClassName:'',inputFieldWrapperClassName:'',labelClassName:'',iconClassName:'',itemClassName:'',tabIndex:0,withoutSearch:false,unclearable:false,withCheckBoxes:false,checkBoxClassName:'',selectAll:false,unselectAll:false};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curry3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__ = __webpack_require__(139);




/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) ? f3 : Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(b) ? f3 : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (_a, _c) {
          return fn(_a, b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (_b, _c) {
          return fn(a, _b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(b) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(c) ? f3 : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (_a, _b) {
          return fn(_a, _b, c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(c) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (_a, _c) {
          return fn(_a, b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(b) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(c) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (_b, _c) {
          return fn(a, _b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(a) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_a) {
          return fn(_a, b, c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_b) {
          return fn(a, _b, c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder_js__["a" /* default */])(c) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INSPECTION_STATUS; });
var ACTION={ROLL_OVER:'Roll Over',EDIT:'Edit',DEACTIVATE:'Deactivate',REACTIVATE:'Reactivate',DELETE:'Delete',DETAILS:'Details',APPROVE:'Approve',INCOMPLETE:'Incomplete',INCOMPLETE_REPORT:'Incomplete Inspection',RESUBMIT:'Submit',NEED_RESPONSE:'Request Variation ',// Last space is very important. Never delete this!!!
DELETE_RESPONSE:'Delete Variation',APPROVE_WITH_RESPONSE:'Request Variation',APPROVE_WITHOUT_RESPONSE:'Complete w/o Variation',INCOMPLETE_RESPONSE:'Incomplete Variation',APPROVE_RESPONSE:'Complete Variation',SUBMIT_RESPONSE:'Submit Variation',E_SIGN_AGREEMENT:'E-Sign License Agreement',E_SIGN_REPORT:'E-sign Inspection Report',BULK_APPROVE:'Bulk Approve'};var STATUS={APPROVED:'APPROVED',PENDING:'PENDING',INCOMPLETE:'INCOMPLETE',COMPLETE:'COMPLETE',DEACTIVATED:'DEACTIVATED',DRAFT:'DRAFT'};var INSPECTION_STATUS={REPORT_PENDING:'REPORT_PENDING',REPORT_INCOMPLETE:'REPORT_INCOMPLETE',RESPONSE_PENDING:'RESPONSE_PENDING',RESPONSE_INCOMPLETE:'RESPONSE_INCOMPLETE',COMPLETE:'COMPLETE'};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* unused harmony export Link */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(275);
/* unused harmony reexport MemoryRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* unused harmony reexport Router */
/* unused harmony reexport StaticRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });
/* unused harmony reexport generatePath */
/* unused harmony reexport matchPath */
/* unused harmony reexport useHistory */
/* unused harmony reexport useLocation */
/* unused harmony reexport useParams */
/* unused harmony reexport useRouteMatch */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(197);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var isDuplicateNavigation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(context.location) === Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(normalizeToLocation(location));
        var method = replace || isDuplicateNavigation ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["g" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
    var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;

    if (isActive) {
      className = joinClassnames(className, activeClassName);
      style = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, activeStyle);
    }

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true", "false"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOAT_TYPE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return STEP_ID; });
/* unused harmony export STEP_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AREA_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return YACHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAILBOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PONTOON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CATAMARAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return JON_BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PWC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INFLATABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CANOE_KAYAK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return OUTBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return INBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NON_POWERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return INFLATABLE_ENGINE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SINGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TWIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MODIFIED_V; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SEMI_V; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TRI_HULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return V; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ROUND_BILGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FLAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DIESEL_POWER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ENGINE_SUB_TYPES_NAMES; });
/* unused harmony export BOAT_STEPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getBoatSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOAT_APPLICATION_ALLOWED_UNCONFIRMED_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOAT_STATUSES; });
var BOAT_TYPE_LIST=[{name:'All',value:'All'},{name:'Boat',value:'BOAT'},{name:'Yacht',value:'YACHT'},{name:'Sailboat',value:'SAILBOAT'},{name:'Pontoon',value:'PONTOON'},{name:'Catamaran',value:'CATAMARAN'},{name:'Jonboat',value:'JON_BOAT'},{name:'PWC',value:'PWC'},{name:'Inflatable',value:'INFLATABLE'},{name:'Kayak / Canoe',value:'CANOE_KAYAK'}];var STEP_ID={BOAT_TYPE:'boat_type',ENGINE_TYPE:'engine_type',BOAT_SPECIFICATIONS:'boat_specifications',ADD_COMPONENTS:'add_components',CUBIC_CAPACITY:'cubic_capacity',WEIGHT_CAPACITY:'weight_capacity',POWER_CAPACITY:'power_capacity',FLOATATION_CAPACITY:'floatation_capacity',FINAL_REVIEW:'final_review',LOAD_DOCUMENTS:'load_documents'};var STEP_NAME={BOAT_TYPE:'Boat Type',ENGINE_TYPE:'Engine Type',BOAT_SPECIFICATIONS:'Boat Specifications',ADD_COMPONENTS:'Add Components',CUBIC_CAPACITY:'Cubic Capacity',HULL_CALCULATIONS:'Hull Calculations',WEIGHT_CAPACITY:'Weight/ HP Capacity',POWER_CAPACITY:'Max Power Capacity',FLOATATION_CAPACITY:'Flotation Capacity',FINAL_REVIEW:'Final Review',LOAD_DOCUMENTS:'Load Documents'};var AREA_TYPES={AA_EIGHTH_LENGTH_FORWARD:'AA_EIGHTH_LENGTH_FORWARD',A_QTR_LENGTH_FORWARD:'A_QTR_LENGTH_FORWARD',B_AMIDSHIPS:'B_AMIDSHIPS',C_QTR_LENGTH_AFT:'C_QTR_LENGTH_AFT',D_TRANSOM:'D_TRANSOM'};var BOAT='BOAT';var YACHT='YACHT';var SAILBOAT='SAILBOAT';var PONTOON='PONTOON';var CATAMARAN='CATAMARAN';var JON_BOAT='JON_BOAT';var PWC='PWC';var INFLATABLE='INFLATABLE';var CANOE_KAYAK='CANOE_KAYAK';var OUTBOARD='OUTBOARD';var INBOARD='INBOARD';var NON_POWERED='NON_POWERED';var INFLATABLE_ENGINE_TYPES=[INBOARD,OUTBOARD,NON_POWERED];var SINGLE='SINGLE';var TWIN='TWIN';var MODIFIED_V='MODIFIED_V';var SEMI_V='SEMI_V';var TRI_HULL='TRI_HULL';var V='V';var ROUND_BILGE='ROUND_BILGE';var FLAT='FLAT';var DIESEL_POWER_TYPE=['Standard','Optional'];var ENGINE_SUB_TYPES_NAMES=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];var BOAT_STEPS={BOAT:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.CUBIC_CAPACITY,name:STEP_NAME.CUBIC_CAPACITY},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.FLOATATION_CAPACITY,name:STEP_NAME.FLOATATION_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],YACHT:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],SAILBOAT:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.CUBIC_CAPACITY,name:STEP_NAME.CUBIC_CAPACITY},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.FLOATATION_CAPACITY,name:STEP_NAME.FLOATATION_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],PONTOON:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.CUBIC_CAPACITY,name:STEP_NAME.HULL_CALCULATIONS},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],CATAMARAN:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.CUBIC_CAPACITY,name:STEP_NAME.CUBIC_CAPACITY},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.FLOATATION_CAPACITY,name:STEP_NAME.FLOATATION_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],JON_BOAT:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.CUBIC_CAPACITY,name:STEP_NAME.CUBIC_CAPACITY},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.FLOATATION_CAPACITY,name:STEP_NAME.FLOATATION_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],PWC:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],INFLATABLE:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}],CANOE_KAYAK:[{id:STEP_ID.BOAT_TYPE,name:STEP_NAME.BOAT_TYPE},{id:STEP_ID.ENGINE_TYPE,name:STEP_NAME.ENGINE_TYPE},{id:STEP_ID.BOAT_SPECIFICATIONS,name:STEP_NAME.BOAT_SPECIFICATIONS},{id:STEP_ID.ADD_COMPONENTS,name:STEP_NAME.ADD_COMPONENTS},{id:STEP_ID.WEIGHT_CAPACITY,name:STEP_NAME.WEIGHT_CAPACITY},{id:STEP_ID.POWER_CAPACITY,name:STEP_NAME.POWER_CAPACITY},{id:STEP_ID.FLOATATION_CAPACITY,name:STEP_NAME.FLOATATION_CAPACITY},{id:STEP_ID.LOAD_DOCUMENTS,name:STEP_NAME.LOAD_DOCUMENTS},{id:STEP_ID.FINAL_REVIEW,name:STEP_NAME.FINAL_REVIEW}]};var getBoatSteps=function getBoatSteps(){var boatType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:BOAT;var engineType=arguments[1];return BOAT_STEPS[boatType||BOAT].filter(function(step){return engineType===OUTBOARD||step.id!==STEP_ID.FLOATATION_CAPACITY;});};var BOAT_APPLICATION_ALLOWED_UNCONFIRMED_TRANSITIONS=[STEP_ID.BOAT_TYPE,STEP_ID.ENGINE_TYPE,STEP_ID.BOAT_SPECIFICATIONS,STEP_ID.ADD_COMPONENTS,STEP_ID.CUBIC_CAPACITY,STEP_ID.WEIGHT_CAPACITY,STEP_ID.POWER_CAPACITY,STEP_ID.FLOATATION_CAPACITY,STEP_ID.FINAL_REVIEW];var BOAT_STATUSES=[{id:0,value:'All',name:'All statuses',active:true},{id:1,value:'DRAFT',name:'Draft',active:true},{id:2,value:'APPROVED',name:'Approved',active:true},{id:3,value:'DEACTIVATED',name:'Deactivated',active:true},{id:4,value:'INCOMPLETE',name:'Incomplete',active:true}];

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function Text(props){var value=props.value,label=props.label,removeUnderlines=props.removeUnderlines,decimalDigits=props.decimalDigits,units=props.units,placeholder=props.placeholder,mainWrapperClassName=props.mainWrapperClassName,textClassName=props.textClassName,labelClassName=props.labelClassName,alwaysTextField=props.alwaysTextField,clickHandler=props.clickHandler;var updatedValue=value;if((typeof value==='undefined'?'undefined':_typeof(value))!=='object'||value===null){if(updatedValue===undefined||updatedValue===null||updatedValue==='')updatedValue=placeholder;else if(removeUnderlines)updatedValue=updatedValue.toString().replace(/_/g,' ');else if(isFinite(value)&&!alwaysTextField)updatedValue=(+value).toFixed(decimalDigits||0)+' '+(units||'');else updatedValue=value+' '+(units||'');}else{var valuesPresented=false;updatedValue=value.map(function(singleValue,index){if(singleValue===undefined||singleValue===null||singleValue===''){return 0 .toFixed(decimalDigits[index]||0)+' '+(units[index]||'');}else if(isFinite(singleValue)){valuesPresented=true;return(+singleValue||0).toFixed(decimalDigits[index]||0)+' '+(units[index]||'');}else{valuesPresented=true;return value+' '+(units[index]||'');}});if(!valuesPresented)updatedValue=placeholder;else updatedValue=updatedValue.join(' and ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-text '+mainWrapperClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelClassName||'label'},label.toString().replace(/_/g,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(textClassName||'text')+' '+(clickHandler?'_cursor_pointer':''),onClick:clickHandler},updatedValue));}Text.defaultProps={value:'',label:'',removeUnderlines:false,placeholder:'N/A',alwaysTextField:false,clickHandler:undefined};/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.3';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(196)(module)))

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inputStyleClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MultiInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _class2,_temp;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var inputStyleClasses={searchBar:'search-bar',searchBarSmall:'search-bar_small',primary:'primary'};var Input=function(_React$Component){_inherits(Input,_React$Component);function Input(props){_classCallCheck(this,Input);var _this=_possibleConstructorReturn(this,(Input.__proto__||Object.getPrototypeOf(Input)).call(this,props));_this.numericInput=function(value){var _this$props=_this.props,onChange=_this$props.onChange,maxValue=_this$props.maxValue,minValue=_this$props.minValue,additionalValidation=_this$props.additionalValidation,allowNegative=_this$props.allowNegative,digitsAfterDot=_this$props.digitsAfterDot;var internalError='';if(isFinite(value)&&(allowNegative||+value>=0)||allowNegative&&value==='-'){if(maxValue&&value>maxValue){internalError='Max value is '+maxValue;}else if(minValue&&value<minValue){internalError='Min value is '+minValue;}else{internalError=internalError||additionalValidation?additionalValidation(value):'';}var stringifiedValue=value.toString();var dotIndex=stringifiedValue.indexOf('.');if(dotIndex!==-1){var decimalDigitsAmount=stringifiedValue.length-dotIndex-1;if(decimalDigitsAmount>digitsAfterDot){value=stringifiedValue.slice(0,digitsAfterDot-decimalDigitsAmount-(digitsAfterDot===0?1:0));}}onChange(value,internalError);_this.setState({internalError:internalError});}};_this.sliceAdditionalDigitsAfterDot=function(value){var digitsAfterDot=_this.props.digitsAfterDot;var stringifiedValue=value.toString();var dotIndex=stringifiedValue.indexOf('.');var decimalDigitsAmount=stringifiedValue.length-dotIndex-1;if(dotIndex!==-1&&decimalDigitsAmount>digitsAfterDot)return(+value).toFixed(digitsAfterDot);return value;};_this.stringInput=function(value){var _this$props2=_this.props,onChange=_this$props2.onChange,maxLength=_this$props2.maxLength,additionalValidation=_this$props2.additionalValidation;var internalError='';if(maxLength&&maxLength<value.length){internalError='Max length is '+maxLength+' characters';}else{internalError=additionalValidation?additionalValidation(value):'';}if(!internalError){onChange(value,internalError);}_this.setState({internalError:internalError});};_this.onChange=function(_ref){var target=_ref.target;var isNumeric=_this.props.isNumeric;var value=target.value;if(!isNumeric){_this.stringInput(value);}else{_this.numericInput(value);}};_this.state={internalError:''};return _this;}_createClass(Input,[{key:'render',value:function render(){var _props=this.props,mainWrapperClassName=_props.mainWrapperClassName,labelClassName=_props.labelClassName,subLabelClassName=_props.subLabelClassName,subLabelIconClassName=_props.subLabelIconClassName,inputClassName=_props.inputClassName,inputFieldWrapperClassName=_props.inputFieldWrapperClassName,errorMessageClassName=_props.errorMessageClassName,isNumeric=_props.isNumeric,placeholder=_props.placeholder,type=_props.type,value=_props.value,error=_props.error,label=_props.label,subLabel=_props.subLabel,secondarySubLabel=_props.secondarySubLabel,onBlur=_props.onBlur,onFocus=_props.onFocus,units=_props.units,capitalizeLabel=_props.capitalizeLabel,disabled=_props.disabled,unitsTop=_props.unitsTop,tabIndex=_props.tabIndex,styleClass=_props.styleClass,isTextArea=_props.isTextArea;var internalError=this.state.internalError;var currentError=typeof error==='string'&&error.length?error:internalError||error;//TODO upon next style refactor remove this part and set appropriate styleClass everywhere
var mainWrapperClasses='';var inputWrapperClasses='';var inputClasses='';var errorTextElementClass='';var textStyles='';var labelClasses='';var subLabelClasses='';var unitsPosition={};if(styleClass){mainWrapperClasses='input__main-wrapper input__main-wrapper_'+styleClass+' '+(currentError?'error':'')+' '+(units?'with-units':'')+' '+(disabled?'disabled':'');inputWrapperClasses='input__input-field-wrapper input__input-field-wrapper_'+styleClass;inputClasses='input__input-field input__input-field_'+styleClass+' '+(currentError?'error':'');errorTextElementClass='input__error-message input__error-message_'+styleClass;labelClasses='input__label input__label_'+styleClass;subLabelClasses='input__sub-label input__sub-label_'+styleClass;}else{mainWrapperClasses='ect-input '+(currentError?'error':'')+' '+(units?'with-units':'')+' '+(disabled?'disabled':'');inputWrapperClasses='ect-input-wrapper';inputClasses=(currentError?'error':'')+' '+(units?'with-units':'')+' '+(disabled?'disabled':'');errorTextElementClass='input__error-message';subLabelClasses='input__sub-label';textStyles={textAlign:'center'};if(units){unitsPosition.left='52%';unitsPosition.top=unitsTop;textStyles.textAlign='right';textStyles.paddingRight='50%';}}var errorTextElement=currentError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:errorTextElementClass+' '+errorMessageClassName},currentError):null;var updatedLabel=label&&capitalizeLabel?label[0].toUpperCase()+label.slice(1).toLowerCase():label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:mainWrapperClasses+' '+mainWrapperClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelClasses+' '+labelClassName},updatedLabel),subLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:subLabelClasses+' '+subLabelClassName},subLabelIconClassName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input__sub-label-icon '+subLabelIconClassName}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,subLabel)),secondarySubLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:subLabelClasses+' '+subLabelClassName},subLabelIconClassName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input__sub-label-icon '+subLabelIconClassName}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,secondarySubLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputWrapperClasses+' '+inputFieldWrapperClassName},!isTextArea?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:inputClasses+' '+inputClassName,type:type,style:Object.assign({},textStyles),placeholder:placeholder,value:isNumeric&&value?this.sliceAdditionalDigitsAfterDot(value):value,onBlur:onBlur,onFocus:onFocus,onChange:this.onChange,autoComplete:'off',tabIndex:tabIndex,disabled:disabled?'disabled':''}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:inputClasses+' '+inputClassName,type:type,placeholder:placeholder,value:isNumeric&&value?this.sliceAdditionalDigitsAfterDot(value):value,onBlur:onBlur,onFocus:onFocus,onChange:this.onChange,autoComplete:'off',tabIndex:tabIndex,disabled:disabled?'disabled':''}),errorTextElement,units?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'units',style:Object.assign({},unitsPosition,{textAlign:'left'})},units):null,this.props.children));}}]);return Input;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Input.propTypes={mainWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subLabelClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subLabelIconClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputFieldWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,styleClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,secondarySubLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,units:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,textAlign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,maxLength:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isNumeric:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,capitalizeLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,digitsAfterDot:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,unitsTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tabIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,minValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,maxValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,isTextArea:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Input.defaultProps={mainWrapperClassName:'',labelClassName:'',subLabelClassName:'',subLabelIconClassName:'',inputClassName:'',inputFieldWrapperClassName:'',errorMessageClassName:'',placeholder:'',type:'text',styleClass:'',value:'',onChange:function onChange(){},onBlur:function onBlur(){},onFocus:function onFocus(){},error:'',label:'',subLabel:'',secondarySubLabel:'',units:'',textAlign:'center',maxLength:null,isNumeric:false,capitalizeLabel:false,digitsAfterDot:2,unitsTop:25,tabIndex:0,isTextArea:false};var MultiInput=(_temp=_class2=function(_React$Component2){_inherits(MultiInput,_React$Component2);function MultiInput(props){_classCallCheck(this,MultiInput);var _this2=_possibleConstructorReturn(this,(MultiInput.__proto__||Object.getPrototypeOf(MultiInput)).call(this,props));_this2.numericInternalValidation=function(value){var _this2$props=_this2.props,onChange=_this2$props.onChange,digitsAfterDot=_this2$props.digitsAfterDot,maxValue=_this2$props.maxValue,minValue=_this2$props.minValue,additionalValidation=_this2$props.additionalValidation,allowNegative=_this2$props.allowNegative;var internalError='';if(isFinite(value)&&(allowNegative||+value>=0)||allowNegative&&value==='-'){if(maxValue&&value>maxValue){internalError='Max value is '+maxValue;}else if(minValue&&value<minValue){internalError='Min value is '+minValue;}else{internalError=internalError||additionalValidation?additionalValidation(value):'';}var dotIndex=value.indexOf('.');if(dotIndex!==-1){value=value.slice(0,dotIndex+digitsAfterDot+(digitsAfterDot===0?0:1));}onChange(value,internalError);_this2.setState({internalError:internalError});}};_this2.stringInternalValidation=function(value){var _this2$props2=_this2.props,onChange=_this2$props2.onChange,maxLength=_this2$props2.maxLength,additionalValidation=_this2$props2.additionalValidation;var internalError='';if(maxLength&&maxLength<=value.length){internalError='Max length is '+maxLength+' characters';}else{internalError=additionalValidation?additionalValidation(value):'';}onChange(value,internalError);_this2.setState({internalError:internalError});};_this2.onChange=function(_ref2){var target=_ref2.target;var isNumeric=_this2.props.isNumeric;var value=target.value;if(!isNumeric){_this2.stringInternalValidation(value);}else{_this2.numericInternalValidation(value);}};_this2.state={internalError:''};return _this2;}_createClass(MultiInput,[{key:'render',value:function render(){var _props2=this.props,textAlign=_props2.textAlign,placeholder=_props2.placeholder,type=_props2.type,value=_props2.value,error=_props2.error,label=_props2.label,styles=_props2.styles,onBlur=_props2.onBlur,units=_props2.units;var internalError=this.state.internalError;var currentError=typeof error==='string'&&error.length?error:internalError||error;var classes=(currentError?'error':'')+' '+(units?'with-units':'');var errorTextElement=currentError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-input-error'},currentError):null;delete styles.textAlign;var unitsPosition=_defineProperty({},textAlign==='center'&&units?'left':'right',textAlign==='center'&&units?'52%':10);var textStyles={textAlign:textAlign==='center'&&units?'right':textAlign,paddingRight:textAlign==='center'&&units?'50%':30};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-multi-input '+classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:label.length?'':'invisible'},label.length?label:'invisible text'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:classes,type:type,style:Object.assign({},textStyles,styles),placeholder:placeholder,value:value,onBlur:onBlur,onChange:this.onChange,autoComplete:'off'}),units?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'units',style:unitsPosition},units):null),errorTextElement);}}]);return MultiInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class2.defaultProps={placeholder:'',type:'text',value:'',onChange:function onChange(){},onBlur:function onBlur(){},label:'',units:'',styles:{width:'inherit',height:40,paddingLeft:20},textAlign:'center',maxLength:256,numbersOnly:false,maxValue:Infinity,minValue:-Infinity,digitsAfterDot:2},_temp);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROLE_MENU_NAMES; });
var _ROLE_MENU_NAMES;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ROLES={COMPONENT_MANUFACTURER:{nameForUrl:'component',serverName:'CMPNT_MNFCTR',readableName:'Component Manufacturer',listSceneUrlPostfix:''},BOAT_MANUFACTURER:{nameForUrl:'boat',serverName:'BT_MNFCTR',readableName:'Boat Manufacturer',listSceneUrlPostfix:''},TRAILER_MANUFACTURER:{nameForUrl:'trailer',serverName:'TRLR_MNFCTR',readableName:'Trailer Manufacturer',listSceneUrlPostfix:''},OIL_BRANDER:{nameForUrl:'oil',serverName:'OIL_BRNDR',readableName:'Oil Manufacturer',listSceneUrlPostfix:'/brand'},OIL_MANUFACTURER:{nameForUrl:'oil',serverName:'OIL_FRMLTR',readableName:'Oil Manufacturer',listSceneUrlPostfix:'/formula'},INTERNAL:{nameForUrl:'internal',serverName:'INTERNAL_USER',readableName:'Internal user',listSceneUrlPostfix:''},INSPECTION:{nameForUrl:'inspection',serverName:'INSPEC',readableName:'Inspection',listSceneUrlPostfix:''}};var ROLE_MENU_NAMES=(_ROLE_MENU_NAMES={},_defineProperty(_ROLE_MENU_NAMES,ROLES.COMPONENT_MANUFACTURER.serverName,'Type Accepted'),_defineProperty(_ROLE_MENU_NAMES,ROLES.BOAT_MANUFACTURER.serverName,'Boat Certification'),_defineProperty(_ROLE_MENU_NAMES,ROLES.TRAILER_MANUFACTURER.serverName,'Trailer Certification'),_defineProperty(_ROLE_MENU_NAMES,ROLES.OIL_BRANDER.serverName,'Oil Certification'),_defineProperty(_ROLE_MENU_NAMES,ROLES.OIL_MANUFACTURER.serverName,'Oil Certification'),_ROLE_MENU_NAMES);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function mountNotification(status,messageHeader,messageText){var notifier=document.getElementById('NotificationComponentForReact');if(notifier)removeNotifier(notifier);notifier=document.createElement('aside');notifier.id='NotificationComponentForReact';var icon=document.createElement('figure');switch(status){case 1:/// Update status success
icon.classList.add('note-to-user');break;case 2:icon.classList.add('bad-configuration');break;case 500:icon.classList.add('server-error');break;case 400:icon.classList.add('incorrect-sign-in');break;case 401:icon.classList.add('session-timed-out');break;case'note':icon.classList.add('note-to-user');break;case'autosave':icon.classList.add('notification__autosave-icon');break;default:icon.classList.add('server-error');}notifier.appendChild(icon);var messageElement=document.createElement('div');if(status!=='autosave'){var closeButton=document.createElement('div');messageElement.appendChild(closeButton);closeButton.classList.add('notification-close-button');}var messageHeaderHolder=document.createElement('h4');messageHeaderHolder.innerText=messageHeader;messageElement.appendChild(messageHeaderHolder);if(messageText){var messageTextHolder=document.createElement('p');messageTextHolder.innerText=messageText;messageElement.appendChild(messageTextHolder);}notifier.appendChild(messageElement);document.body.appendChild(notifier);notifier.addEventListener('click',function(){closeNotification(notifier);});notifier.addEventListener('animationend',function(){removeNotifier(notifier);});return notifier;}function closeNotification(notifier){if(!notifier.classList.contains('close'))notifier.classList.add('close');}function removeNotifier(notifier){document.body.removeChild(notifier);}var NotificationManager={autosave:function autosave(){var messageHeader=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'Auto Saved';var notifier=mountNotification('autosave',messageHeader);notifier.classList.add('notification__autosave-wrapper');},success:function success(status,messageHeader,messageText){var notifier=mountNotification(status,messageHeader,messageText);notifier.classList.add('notification-success');},error:function error(status,messageHeader,messageText){var notifier=mountNotification(status,messageHeader,messageText);notifier.classList.add('notification-error');}};/* harmony default export */ __webpack_exports__["a"] = (NotificationManager);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(581)();
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Button__ = __webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var backButtonLabel=_ref.backButtonLabel,backButtonAction=_ref.backButtonAction,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess,cancelButtonLabel=_ref.cancelButtonLabel,cancelButtonAction=_ref.cancelButtonAction,disableSaveButton=_ref.disableSaveButton,saveButtonLabel=_ref.saveButtonLabel,saveButtonAction=_ref.saveButtonAction,saveAndSubmitButtonLabel=_ref.saveAndSubmitButtonLabel,saveAndSubmitAction=_ref.saveAndSubmitAction;if(boatDetailsRequestInProcess)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section __actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__action_left'},!!backButtonLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:backButtonLabel,color:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["a" /* buttonColor */].planeOrange,buttonClassName:'_height_40 _width_120',onClick:backButtonAction})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__actions_right'},!!cancelButtonLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:cancelButtonLabel,type:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_120',onClick:cancelButtonAction}),!!saveButtonLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:saveButtonLabel,disabledWithSpinner:disableSaveButton,buttonClassName:'_height_40 _width_120',onClick:saveButtonAction}),!!saveAndSubmitButtonLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:saveAndSubmitButtonLabel,buttonClassName:'_height_40 _width_170 _margin_left_20',onClick:saveAndSubmitAction,disabledWithSpinner:disableSaveButton})));});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(119)('wks');
var uid = __webpack_require__(78);
var Symbol = __webpack_require__(17).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(58);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Checkbox__ = __webpack_require__(89);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children,isOpen=_ref.isOpen,option=_ref.option,_ref$showOption=_ref.showOption,showOption=_ref$showOption===undefined?false:_ref$showOption,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className,_ref$rootClassName=_ref.rootClassName,rootClassName=_ref$rootClassName===undefined?'modal-open':_ref$rootClassName;if(isOpen){document.getElementById('root').classList.add(rootClassName);}else{document.getElementById('root').classList.remove(rootClassName);}return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'ect-modal '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content '+(showOption?'option':'')},children.map(function(child,index){if(index===children.length-1&&showOption){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Checkbox__["a" /* default */],{label:option.label,value:option.value,onChange:option.onChange}),child);}else{return child;}}))):null,document.body);});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FilePicker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadButton__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileList__ = __webpack_require__(1008);
function FilePicker(_ref){var handleFileSelect=_ref.handleFileSelect,isEditable=_ref.isEditable,files=_ref.files,handleRemoveFile=_ref.handleRemoveFile,httpParams=_ref.httpParams,error=_ref.error,errorClassName=_ref.errorClassName,mainWrapperClassName=_ref.mainWrapperClassName,editableStateSectionHeader=_ref.editableStateSectionHeader,notEditableStateSectionHeader=_ref.notEditableStateSectionHeader,sectionHeaderClassName=_ref.sectionHeaderClassName,uploadButtonText=_ref.uploadButtonText,doNotRemoveFiles=_ref.doNotRemoveFiles,infoMessage=_ref.infoMessage,listSectionId=_ref.listSectionId;if(!isEditable&&!files.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ect-file-picker _width_pc_100 '+mainWrapperClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(sectionHeaderClassName?'':'ect-file-picker__header _color_gray')+' '+sectionHeaderClassName},isEditable?editableStateSectionHeader:notEditableStateSectionHeader),infoMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label _margin_top_0'},infoMessage),isEditable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UploadButton__["a" /* default */],{files:files,handleFileSelect:handleFileSelect,errorClassName:errorClassName,error:error,uploadButtonText:uploadButtonText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileList__["a" /* default */],{files:files,isEditable:isEditable,httpParams:httpParams,handleRemoveFile:handleRemoveFile,doNotRemoveFiles:doNotRemoveFiles,listSectionId:listSectionId}));}FilePicker.propTypes={handleFileSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleRemoveFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDownloadFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isEditable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,files:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mainWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,errorClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,httpParams:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({currentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),currentAPI:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),editableStateSectionHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notEditableStateSectionHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,sectionHeaderClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uploadButtonText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,doNotRemoveFiles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,infoMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};FilePicker.defaultProps={handleFileSelect:function handleFileSelect(){},isEditable:true,files:[],error:'',mainWrapperClassName:'',errorClassName:'',httpParams:{currentId:0,currentMethod:''},editableStateSectionHeader:'Upload Test Report *',uploadButtonText:'Upload Test Report',notEditableStateSectionHeader:'Uploaded documents',sectionHeaderClassName:'',doNotRemoveFiles:false,infoMessage:''};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _dispatchable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isTransformer_js__ = __webpack_require__(209);



/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_1__isTransformer_js__["a" /* default */])(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var allRowsCount=_ref.allRowsCount,handleRowsSelect=_ref.handleRowsSelect,selectedRowsCount=_ref.selectedRowsCount,className=_ref.className;var getActiveClass=function getActiveClass(value){if(value===selectedRowsCount)return'active';return'';};var handleInnerRowsSelect=function handleInnerRowsSelect(value){return function(){handleRowsSelect(value,allRowsCount);};};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-rows-selector '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleInnerRowsSelect(10),className:'ect-row '+getActiveClass(10)},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleInnerRowsSelect(25),className:'ect-row '+getActiveClass(25)},'25'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleInnerRowsSelect(50),className:'ect-row '+getActiveClass(50)},'50'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleInnerRowsSelect(100),className:'ect-row '+getActiveClass(100)},'100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleInnerRowsSelect(0),className:'ect-row '+getActiveClass(0)},'All'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-all-rows'},'records out of ',allRowsCount,' total'));});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(18)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(231);
var toPrimitive = __webpack_require__(71);
var dP = Object.defineProperty;

exports.f = __webpack_require__(30) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_curryN_js__ = __webpack_require__(140);





/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */
var curryN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_curry2_js__["a" /* default */])(function curryN(length, fn) {
  if (length === 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(fn);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(length, Object(__WEBPACK_IMPORTED_MODULE_3__internal_curryN_js__["a" /* default */])(length, [], fn));
});
/* harmony default export */ __webpack_exports__["a"] = (curryN);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = stopPropagation;
/* harmony export (immutable) */ __webpack_exports__["b"] = downloadFile;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIsBoatManufacturer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIsTrailerManufacturer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIsComponentManufacturer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIsOilManufacturer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getIsOilBrander; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_roles__ = __webpack_require__(15);
function stopPropagation(event){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();}function downloadFile(data,filename){if(window.navigator.appVersion.toString().indexOf('.NET')>0)window.navigator.msSaveOrOpenBlob(data,filename);else{var a=document.createElement('a');a.setAttribute('type','hidden');a.href=window.URL.createObjectURL(new Blob([data]));a.download=filename;document.body.appendChild(a);a.click();document.body.removeChild(a);}}var debounce=function debounce(func){var timeoutId=void 0;return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var context=this;if(timeoutId){clearTimeout(timeoutId);}timeoutId=setTimeout(function(){timeoutId=null;func.apply(context,args);},400);};};var getServerName=Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["f" /* path */])(['activeRole','serverName']);var getIsBoatManufacturer=Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* pipe */])(getServerName,Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["c" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName));var getIsTrailerManufacturer=Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* pipe */])(getServerName,Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["c" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName));var getIsComponentManufacturer=Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* pipe */])(getServerName,Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["c" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName));var getIsOilManufacturer=Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* pipe */])(getServerName,Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["c" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName));var getIsOilBrander=Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* pipe */])(getServerName,Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["c" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(65);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_quill__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_quill__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notes=function(_React$Component){_inherits(Notes,_React$Component);function Notes(props){_classCallCheck(this,Notes);return _possibleConstructorReturn(this,(Notes.__proto__||Object.getPrototypeOf(Notes)).call(this,props));}_createClass(Notes,[{key:'render',value:function render(){var _props=this.props,text=_props.text,handleInputChange=_props.handleInputChange,disabled=_props.disabled;var modules=disabled?{toolbar:false}:{toolbar:[[{'header':'1'},{'header':'2'},{'font':[]}],[{size:[]}],['bold','italic','underline','strike','blockquote'],[{'list':'ordered'},{'list':'bullet'},{'indent':'-1'},{'indent':'+1'}],['link'],['clean']]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_quill___default.a,{className:'_margin_top_20',readOnly:disabled,value:text,onChange:handleInputChange,theme:'snow',modules:modules});}}]);return Notes;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Notes.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,handleInputChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Notes.defaultProps={text:'',handleInputChange:function handleInputChange(){},disabled:false};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var hide = __webpack_require__(43);
var has = __webpack_require__(42);
var SRC = __webpack_require__(78)('src');
var $toString = __webpack_require__(392);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(27).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(18);
var defined = __webpack_require__(65);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _reduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xwrap_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind_js__ = __webpack_require__(297);




function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}

function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}

function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](Object(__WEBPACK_IMPORTED_MODULE_2__bind_js__["a" /* default */])(xf['@@transducer/step'], xf), acc));
}

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

function _reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = Object(__WEBPACK_IMPORTED_MODULE_1__xwrap_js__["a" /* default */])(fn);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _has;
function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleClick=_ref.handleClick,activePage=_ref.activePage,className=_ref.className,allRowsCount=_ref.allRowsCount,selectedRowsCount=_ref.selectedRowsCount;var lastPage=+selectedRowsCount?Math.ceil(allRowsCount/selectedRowsCount):1;var firstButtonClasses=activePage===1?'ect-pagination_disabled':'';var lastButtonClasses=activePage===lastPage?'ect-pagination_disabled':'';function getPaginationNumbers(){var from=activePage-2;var to=activePage+2;if(lastPage<6)return printNumbers(1,lastPage);if(from<1)return printNumbers(1,5);if(to>lastPage)return printNumbers(lastPage-4,lastPage);return printNumbers(from,to);function printNumbers(from,to){var numbers=[];var numberElement=function numberElement(number,active){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:number,className:'ect-pagination__number '+(active?'active':''),onClick:handleNumberClick(number)},number);};for(var i=from;i<=to;i++){var isActive=+activePage===i;numbers.push(numberElement(i,isActive));}return numbers;}}function handleFirstClick(){handleClick(1);}function handleLastClick(){handleClick(lastPage);}function handleNextClick(){var nextPage=activePage+1;if(nextPage<=lastPage)handleClick(nextPage);}function handlePrevClick(){var prevPage=activePage-1;if(prevPage>0)handleClick(prevPage);}function handleNumberClick(number){return function(){handleClick(number);};}if(lastPage<2)return null;if(lastPage===null)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ect-pagination '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleFirstClick,className:'ect-pagination__first '+firstButtonClasses},'First'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handlePrevClick,className:'ect-pagination__first '+firstButtonClasses},'<'),getPaginationNumbers(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleNextClick,className:'ect-pagination__last '+lastButtonClasses},'>'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:handleLastClick,className:'ect-pagination__last '+lastButtonClasses},'Last'));});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var createDesc = __webpack_require__(77);
module.exports = __webpack_require__(30) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(103);
var defined = __webpack_require__(65);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(278);
var isBuffer = __webpack_require__(638);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_map_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_xmap_js__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys_js__ = __webpack_require__(53);








/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
var map = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['fantasy-land/map', 'map'], __WEBPACK_IMPORTED_MODULE_4__internal_xmap_js__["a" /* default */], function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return Object(__WEBPACK_IMPORTED_MODULE_5__curryN_js__["a" /* default */])(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__["a" /* default */])(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, Object(__WEBPACK_IMPORTED_MODULE_6__keys_js__["a" /* default */])(functor));
    default:
      return Object(__WEBPACK_IMPORTED_MODULE_2__internal_map_js__["a" /* default */])(fn, functor);
  }
}));
/* harmony default export */ __webpack_exports__["a"] = (map);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_equals_js__ = __webpack_require__(726);



/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
var equals = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function equals(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_equals_js__["a" /* default */])(a, b, [], []);
});
/* harmony default export */ __webpack_exports__["a"] = (equals);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_roles__ = __webpack_require__(15);
var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DBName='ectNMMAdb';var Store=(_temp=_class=function Store(dbVersion){_classCallCheck(this,Store);openDB(dbVersion);},_class.insert=function(store,insartion,code){return openDB().then(function(db){return new Promise(function(resolve,reject){var transaction=getTransaction(db,store);var storeObject=getStoreObject(transaction,store);if(insartion.length===undefined){if(code)insartion.primaryAccount=code;storeObject.put(insartion);}else{insartion.forEach(function(value){if(code)value.primaryAccount=code;storeObject.put(value);});storeObject.openCursor().onsuccess=function(_ref){var target=_ref.target;var cursor=target.result;if(cursor){if(code&&+code===+cursor.value.primaryAccount){if(!insartion.find(function(ins){return ins.id&&+ins.id===+cursor.value.id||ins.code&&+ins.code===+cursor.value.code;})){cursor.delete();}}else if(!code){if(!insartion.find(function(ins){return+ins.code===+cursor.value.code;})){cursor.delete();}}cursor.continue();}};}transaction.oncomplete=function(_ref2){var target=_ref2.target;resolve(target.result);};transaction.onerror=function(_ref3){var target=_ref3.target;reject(target);};});});},_class.delete=function(store,itemToDelete){return openDB().then(function(db){return new Promise(function(resolve,reject){var transaction=getTransaction(db,store);var storeObject=getStoreObject(transaction,store);storeObject.delete(itemToDelete.id||itemToDelete.code);transaction.oncomplete=function(_ref4){var target=_ref4.target;resolve(target.result);};transaction.onerror=function(_ref5){var target=_ref5.target;reject(target);};});});},_class.select=function(store,key){return openDB().then(function(db){return new Promise(function(resolve,reject){var transaction=getTransaction(db,store);var storeObject=getStoreObject(transaction,store);var resultArray=[];var map=key?storeObject.index('primaryAccount').openCursor(IDBKeyRange.only(key.toString())):storeObject.openCursor();map.onsuccess=function(_ref6){var target=_ref6.target;var cursor=target.result;if(cursor){resultArray.push(cursor.value);cursor.continue();}};transaction.oncomplete=function(){resolve(resultArray);};transaction.onerror=function(_ref7){var target=_ref7.target;reject(target);};});});},_temp);function openDB(DBVersion){return new Promise(function(resolve,reject){var _indexedDB;var params=[DBName];if(DBVersion)params.push(DBVersion);var dbRequest=(_indexedDB=indexedDB).open.apply(_indexedDB,params);dbRequest.onupgradeneeded=function(_ref8){var target=_ref8.target;var db=target.result;Object.keys(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */]).forEach(function(role){try{db.deleteObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName);}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{var manufacturers=db.createObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName,{keyPath:'dbKey'});manufacturers.createIndex('primaryAccount','primaryAccount',{unique:false});}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{db.deleteObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName+'_inspectors');}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{var inspectors=db.createObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName+'_inspectors',{keyPath:'code'});inspectors.createIndex('code','code',{unique:false});}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{db.deleteObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName+'_documents');}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{var _manufacturers=db.createObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName+'_documents',{keyPath:'id'});_manufacturers.createIndex('primaryAccount','primaryAccount',{unique:false});}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{if(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName==='INSPEC'){db.deleteObjectStore('INSPEC_'+__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName+'_LISTS');db.deleteObjectStore('INSPEC_'+__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName+'_LISTS');}else{db.deleteObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName+'_lists');}}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{if(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName==='INSPEC'){var boat=db.createObjectStore('INSPEC_'+__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName+'_LISTS',{keyPath:'id'});boat.createIndex('primaryAccount','primaryAccount',{unique:false});var trailer=db.createObjectStore('INSPEC_'+__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName+'_LISTS',{keyPath:'id'});trailer.createIndex('primaryAccount','primaryAccount',{unique:false});}else{var obj=db.createObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][role].serverName+'_lists',{keyPath:'id'});obj.createIndex('primaryAccount','primaryAccount',{unique:false});}}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}});try{db.deleteObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName+'_families_lists');}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}try{var obj=db.createObjectStore(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName+'_families_lists',{keyPath:'id'});obj.createIndex('primaryAccount','primaryAccount',{unique:false});}catch(e){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])(e);}};dbRequest.onsuccess=function(_ref9){var target=_ref9.target;var db=target.result;db.onerror=errorHandler;resolve(db);};dbRequest.onerror=function(_ref10){var target=_ref10.target;return reject(target);};});}function getTransaction(db,store){return db.transaction([store],'readwrite');}function getStoreObject(transaction,store){return transaction.objectStore(store);}function errorHandler(error){if(false){consoleError(error);}else{Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])('You have a problems with local database connection.');}}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
var EditApplicationButton=function EditApplicationButton(_ref){var className=_ref.className,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Button__["c" /* default */],{label:'Edit Application',iconClassName:'icon-pencil-orange',buttonClassName:className||'_height_30 _width_pc_100 _max_width_170 _font_size_16',onClick:onClick});};/* harmony default export */ __webpack_exports__["a"] = (EditApplicationButton);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(18);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _concat;
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arity;
function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArguments_js__ = __webpack_require__(298);




// cover IE < 9 keys issues
var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {
  'use strict';

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArguments_js__["a" /* default */])(obj);
  for (prop in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__ = __webpack_require__(8);



/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
var slice = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__["a" /* default */])('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
/* harmony default export */ __webpack_exports__["a"] = (slice);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-empty-list '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-empty-list__search-icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-empty-list__text'},children));});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(57);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(104);
var createDesc = __webpack_require__(77);
var toIObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(71);
var has = __webpack_require__(42);
var IE8_DOM_DEFINE = __webpack_require__(231);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(30) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(27);
var fails = __webpack_require__(18);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(56);
var IObject = __webpack_require__(103);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(24);
var asc = __webpack_require__(247);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BaseBoat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _initBoatSystems; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BaseBoat=function BaseBoat(boat){_classCallCheck(this,BaseBoat);this.id='new';this.boatType=boat.boatType||null;this.status='DRAFT';this.engineType=boat.engineType||null;this.powerCapacity={};this.cubicCapacity={};this.boatSystems=[];this.personPowerCapacity={};this.bottomContourList=[];this.engineTypesList=[];this.engineSubTypesList=[];this.floatationCapacity={};this.boatSpecifications={};this.stepValidationFunction=function(stepID){};};var _initBoatSystems=function _initBoatSystems(){var systems=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return systems.map(function(system){delete system.createdBy;delete system.creationDate;delete system.manufacturerCode;if(system.ruleValues&&system.ruleValues.length){system.ruleValueRequests=system.ruleValues.map(function(rule){var componentIdWithQuantityMap={};rule.ruleValueComponents.forEach(function(rule){return componentIdWithQuantityMap[rule.componentId]=rule.quantity;});return{ruleId:rule.ruleId,componentIdWithQuantityMap:componentIdWithQuantityMap};});delete system.ruleValues;}if(system.optionValues){system.optionValueRequests=system.optionValues.map(function(_ref){var optionId=_ref.optionId,value=_ref.value;return{optionId:optionId,value:value};});delete system.optionValues;}return system;});};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__ = __webpack_require__(39);



/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
var reduce = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (reduce);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(30)) {
  var LIBRARY = __webpack_require__(79);
  var global = __webpack_require__(17);
  var fails = __webpack_require__(18);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(130);
  var $buffer = __webpack_require__(187);
  var ctx = __webpack_require__(56);
  var anInstance = __webpack_require__(95);
  var propertyDesc = __webpack_require__(77);
  var hide = __webpack_require__(43);
  var redefineAll = __webpack_require__(96);
  var toInteger = __webpack_require__(58);
  var toLength = __webpack_require__(24);
  var toIndex = __webpack_require__(258);
  var toAbsoluteIndex = __webpack_require__(81);
  var toPrimitive = __webpack_require__(71);
  var has = __webpack_require__(42);
  var classof = __webpack_require__(105);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(35);
  var isArrayIter = __webpack_require__(179);
  var create = __webpack_require__(82);
  var getPrototypeOf = __webpack_require__(84);
  var gOPN = __webpack_require__(83).f;
  var getIterFn = __webpack_require__(181);
  var uid = __webpack_require__(78);
  var wks = __webpack_require__(23);
  var createArrayMethod = __webpack_require__(61);
  var createArrayIncludes = __webpack_require__(120);
  var speciesConstructor = __webpack_require__(106);
  var ArrayIterators = __webpack_require__(183);
  var Iterators = __webpack_require__(93);
  var $iterDetect = __webpack_require__(123);
  var setSpecies = __webpack_require__(94);
  var arrayFill = __webpack_require__(182);
  var arrayCopyWithin = __webpack_require__(249);
  var $DP = __webpack_require__(31);
  var $GOPD = __webpack_require__(59);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__F_js__ = __webpack_require__(695);
/* unused harmony reexport F */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__T_js__ = __webpack_require__(696);
/* unused harmony reexport T */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js__ = __webpack_require__(697);
/* unused harmony reexport __ */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add_js__ = __webpack_require__(138);
/* unused harmony reexport add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addIndex_js__ = __webpack_require__(698);
/* unused harmony reexport addIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adjust_js__ = __webpack_require__(294);
/* unused harmony reexport adjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__all_js__ = __webpack_require__(295);
/* unused harmony reexport all */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allPass_js__ = __webpack_require__(700);
/* unused harmony reexport allPass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__always_js__ = __webpack_require__(143);
/* unused harmony reexport always */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__and_js__ = __webpack_require__(299);
/* unused harmony reexport and */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__any_js__ = __webpack_require__(702);
/* unused harmony reexport any */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__anyPass_js__ = __webpack_require__(704);
/* unused harmony reexport anyPass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ap_js__ = __webpack_require__(211);
/* unused harmony reexport ap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__aperture_js__ = __webpack_require__(705);
/* unused harmony reexport aperture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__append_js__ = __webpack_require__(708);
/* unused harmony reexport append */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__apply_js__ = __webpack_require__(300);
/* unused harmony reexport apply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__applySpec_js__ = __webpack_require__(709);
/* unused harmony reexport applySpec */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__applyTo_js__ = __webpack_require__(710);
/* unused harmony reexport applyTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ascend_js__ = __webpack_require__(711);
/* unused harmony reexport ascend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assoc_js__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_19__assoc_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assocPath_js__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_20__assocPath_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__binary_js__ = __webpack_require__(712);
/* unused harmony reexport binary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__bind_js__ = __webpack_require__(297);
/* unused harmony reexport bind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__both_js__ = __webpack_require__(713);
/* unused harmony reexport both */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__call_js__ = __webpack_require__(714);
/* unused harmony reexport call */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__chain_js__ = __webpack_require__(214);
/* unused harmony reexport chain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clamp_js__ = __webpack_require__(718);
/* unused harmony reexport clamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__clone_js__ = __webpack_require__(719);
/* unused harmony reexport clone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__comparator_js__ = __webpack_require__(720);
/* unused harmony reexport comparator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__complement_js__ = __webpack_require__(721);
/* unused harmony reexport complement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__compose_js__ = __webpack_require__(216);
/* unused harmony reexport compose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__composeK_js__ = __webpack_require__(310);
/* unused harmony reexport composeK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__composeP_js__ = __webpack_require__(723);
/* unused harmony reexport composeP */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__composeWith_js__ = __webpack_require__(725);
/* unused harmony reexport composeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__concat_js__ = __webpack_require__(218);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__cond_js__ = __webpack_require__(732);
/* unused harmony reexport cond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__construct_js__ = __webpack_require__(733);
/* unused harmony reexport construct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__constructN_js__ = __webpack_require__(318);
/* unused harmony reexport constructN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__contains_js__ = __webpack_require__(734);
/* unused harmony reexport contains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__converge_js__ = __webpack_require__(319);
/* unused harmony reexport converge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__countBy_js__ = __webpack_require__(735);
/* unused harmony reexport countBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__curry_js__ = __webpack_require__(213);
/* unused harmony reexport curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__curryN_js__ = __webpack_require__(33);
/* unused harmony reexport curryN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__dec_js__ = __webpack_require__(737);
/* unused harmony reexport dec */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__defaultTo_js__ = __webpack_require__(320);
/* unused harmony reexport defaultTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__descend_js__ = __webpack_require__(738);
/* unused harmony reexport descend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__difference_js__ = __webpack_require__(321);
/* unused harmony reexport difference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__differenceWith_js__ = __webpack_require__(323);
/* unused harmony reexport differenceWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__dissoc_js__ = __webpack_require__(324);
/* unused harmony reexport dissoc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__dissocPath_js__ = __webpack_require__(739);
/* unused harmony reexport dissocPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__divide_js__ = __webpack_require__(740);
/* unused harmony reexport divide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__drop_js__ = __webpack_require__(326);
/* unused harmony reexport drop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__dropLast_js__ = __webpack_require__(742);
/* unused harmony reexport dropLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__dropLastWhile_js__ = __webpack_require__(746);
/* unused harmony reexport dropLastWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__dropRepeats_js__ = __webpack_require__(749);
/* unused harmony reexport dropRepeats */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__dropRepeatsWith_js__ = __webpack_require__(328);
/* unused harmony reexport dropRepeatsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__dropWhile_js__ = __webpack_require__(750);
/* unused harmony reexport dropWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__either_js__ = __webpack_require__(752);
/* unused harmony reexport either */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__empty_js__ = __webpack_require__(331);
/* unused harmony reexport empty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__endsWith_js__ = __webpack_require__(753);
/* unused harmony reexport endsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__eqBy_js__ = __webpack_require__(754);
/* unused harmony reexport eqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__eqProps_js__ = __webpack_require__(755);
/* unused harmony reexport eqProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__equals_js__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_62__equals_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__evolve_js__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_63__evolve_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__filter_js__ = __webpack_require__(219);
/* unused harmony reexport filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__find_js__ = __webpack_require__(757);
/* unused harmony reexport find */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__findIndex_js__ = __webpack_require__(759);
/* unused harmony reexport findIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__findLast_js__ = __webpack_require__(761);
/* unused harmony reexport findLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__findLastIndex_js__ = __webpack_require__(763);
/* unused harmony reexport findLastIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__flatten_js__ = __webpack_require__(765);
/* unused harmony reexport flatten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__flip_js__ = __webpack_require__(153);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__forEach_js__ = __webpack_require__(766);
/* unused harmony reexport forEach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__forEachObjIndexed_js__ = __webpack_require__(767);
/* unused harmony reexport forEachObjIndexed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__fromPairs_js__ = __webpack_require__(768);
/* unused harmony reexport fromPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__groupBy_js__ = __webpack_require__(769);
/* unused harmony reexport groupBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__groupWith_js__ = __webpack_require__(770);
/* unused harmony reexport groupWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__gt_js__ = __webpack_require__(771);
/* unused harmony reexport gt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__gte_js__ = __webpack_require__(772);
/* unused harmony reexport gte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__has_js__ = __webpack_require__(773);
/* unused harmony reexport has */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__hasIn_js__ = __webpack_require__(774);
/* unused harmony reexport hasIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__hasPath_js__ = __webpack_require__(333);
/* unused harmony reexport hasPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__head_js__ = __webpack_require__(313);
/* unused harmony reexport head */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__identical_js__ = __webpack_require__(775);
/* unused harmony reexport identical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__identity_js__ = __webpack_require__(148);
/* unused harmony reexport identity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__ifElse_js__ = __webpack_require__(776);
/* unused harmony reexport ifElse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__inc_js__ = __webpack_require__(777);
/* unused harmony reexport inc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__includes_js__ = __webpack_require__(778);
/* unused harmony reexport includes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__indexBy_js__ = __webpack_require__(779);
/* unused harmony reexport indexBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__indexOf_js__ = __webpack_require__(780);
/* unused harmony reexport indexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__init_js__ = __webpack_require__(781);
/* unused harmony reexport init */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__innerJoin_js__ = __webpack_require__(782);
/* unused harmony reexport innerJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__insert_js__ = __webpack_require__(783);
/* unused harmony reexport insert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__insertAll_js__ = __webpack_require__(784);
/* unused harmony reexport insertAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__intersection_js__ = __webpack_require__(785);
/* unused harmony reexport intersection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__intersperse_js__ = __webpack_require__(786);
/* unused harmony reexport intersperse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__into_js__ = __webpack_require__(787);
/* unused harmony reexport into */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__invert_js__ = __webpack_require__(789);
/* unused harmony reexport invert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__invertObj_js__ = __webpack_require__(790);
/* unused harmony reexport invertObj */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__invoker_js__ = __webpack_require__(118);
/* unused harmony reexport invoker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__is_js__ = __webpack_require__(336);
/* unused harmony reexport is */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__isEmpty_js__ = __webpack_require__(791);
/* unused harmony reexport isEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__isNil_js__ = __webpack_require__(303);
/* unused harmony reexport isNil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__join_js__ = __webpack_require__(792);
/* unused harmony reexport join */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__juxt_js__ = __webpack_require__(337);
/* unused harmony reexport juxt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__keys_js__ = __webpack_require__(53);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__keysIn_js__ = __webpack_require__(793);
/* unused harmony reexport keysIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__last_js__ = __webpack_require__(329);
/* unused harmony reexport last */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__lastIndexOf_js__ = __webpack_require__(794);
/* unused harmony reexport lastIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__length_js__ = __webpack_require__(338);
/* unused harmony reexport length */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__lens_js__ = __webpack_require__(154);
/* unused harmony reexport lens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__lensIndex_js__ = __webpack_require__(795);
/* unused harmony reexport lensIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__lensPath_js__ = __webpack_require__(796);
/* unused harmony reexport lensPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__lensProp_js__ = __webpack_require__(797);
/* unused harmony reexport lensProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__lift_js__ = __webpack_require__(146);
/* unused harmony reexport lift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__liftN_js__ = __webpack_require__(304);
/* unused harmony reexport liftN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__lt_js__ = __webpack_require__(798);
/* unused harmony reexport lt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__lte_js__ = __webpack_require__(799);
/* unused harmony reexport lte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__map_js__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_117__map_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__mapAccum_js__ = __webpack_require__(800);
/* unused harmony reexport mapAccum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__mapAccumRight_js__ = __webpack_require__(801);
/* unused harmony reexport mapAccumRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__mapObjIndexed_js__ = __webpack_require__(802);
/* unused harmony reexport mapObjIndexed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__match_js__ = __webpack_require__(803);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__mathMod_js__ = __webpack_require__(804);
/* unused harmony reexport mathMod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__max_js__ = __webpack_require__(97);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__maxBy_js__ = __webpack_require__(805);
/* unused harmony reexport maxBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__mean_js__ = __webpack_require__(340);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__median_js__ = __webpack_require__(806);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__memoizeWith_js__ = __webpack_require__(807);
/* unused harmony reexport memoizeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__merge_js__ = __webpack_require__(808);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__mergeAll_js__ = __webpack_require__(809);
/* unused harmony reexport mergeAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__mergeDeepLeft_js__ = __webpack_require__(810);
/* unused harmony reexport mergeDeepLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__mergeDeepRight_js__ = __webpack_require__(811);
/* unused harmony reexport mergeDeepRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__mergeDeepWith_js__ = __webpack_require__(812);
/* unused harmony reexport mergeDeepWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__mergeDeepWithKey_js__ = __webpack_require__(155);
/* unused harmony reexport mergeDeepWithKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__mergeLeft_js__ = __webpack_require__(813);
/* unused harmony reexport mergeLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__mergeRight_js__ = __webpack_require__(814);
/* unused harmony reexport mergeRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__mergeWith_js__ = __webpack_require__(815);
/* unused harmony reexport mergeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__mergeWithKey_js__ = __webpack_require__(225);
/* unused harmony reexport mergeWithKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__min_js__ = __webpack_require__(816);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__minBy_js__ = __webpack_require__(817);
/* unused harmony reexport minBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__modulo_js__ = __webpack_require__(818);
/* unused harmony reexport modulo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__multiply_js__ = __webpack_require__(342);
/* unused harmony reexport multiply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__nAry_js__ = __webpack_require__(145);
/* unused harmony reexport nAry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__negate_js__ = __webpack_require__(819);
/* unused harmony reexport negate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__none_js__ = __webpack_require__(820);
/* unused harmony reexport none */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__not_js__ = __webpack_require__(308);
/* unused harmony reexport not */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__nth_js__ = __webpack_require__(116);
/* unused harmony reexport nth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__nthArg_js__ = __webpack_require__(821);
/* unused harmony reexport nthArg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__o_js__ = __webpack_require__(822);
/* unused harmony reexport o */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__objOf_js__ = __webpack_require__(335);
/* unused harmony reexport objOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__of_js__ = __webpack_require__(823);
/* unused harmony reexport of */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__omit_js__ = __webpack_require__(825);
/* unused harmony reexport omit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__once_js__ = __webpack_require__(826);
/* unused harmony reexport once */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__or_js__ = __webpack_require__(330);
/* unused harmony reexport or */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__otherwise_js__ = __webpack_require__(827);
/* unused harmony reexport otherwise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__over_js__ = __webpack_require__(344);
/* unused harmony reexport over */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__pair_js__ = __webpack_require__(828);
/* unused harmony reexport pair */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__partial_js__ = __webpack_require__(829);
/* unused harmony reexport partial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__partialRight_js__ = __webpack_require__(830);
/* unused harmony reexport partialRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__partition_js__ = __webpack_require__(831);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__path_js__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_160__path_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__pathEq_js__ = __webpack_require__(832);
/* unused harmony reexport pathEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__pathOr_js__ = __webpack_require__(346);
/* unused harmony reexport pathOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__pathSatisfies_js__ = __webpack_require__(833);
/* unused harmony reexport pathSatisfies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__pick_js__ = __webpack_require__(834);
/* unused harmony reexport pick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__pickAll_js__ = __webpack_require__(347);
/* unused harmony reexport pickAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__pickBy_js__ = __webpack_require__(835);
/* unused harmony reexport pickBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__pipe_js__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_167__pipe_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__pipeK_js__ = __webpack_require__(836);
/* unused harmony reexport pipeK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__pipeP_js__ = __webpack_require__(311);
/* unused harmony reexport pipeP */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__pipeWith_js__ = __webpack_require__(312);
/* unused harmony reexport pipeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__pluck_js__ = __webpack_require__(111);
/* unused harmony reexport pluck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__prepend_js__ = __webpack_require__(348);
/* unused harmony reexport prepend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__product_js__ = __webpack_require__(837);
/* unused harmony reexport product */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__project_js__ = __webpack_require__(838);
/* unused harmony reexport project */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__prop_js__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_175__prop_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__propEq_js__ = __webpack_require__(839);
/* unused harmony reexport propEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__propIs_js__ = __webpack_require__(840);
/* unused harmony reexport propIs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__propOr_js__ = __webpack_require__(841);
/* unused harmony reexport propOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__propSatisfies_js__ = __webpack_require__(842);
/* unused harmony reexport propSatisfies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__props_js__ = __webpack_require__(843);
/* unused harmony reexport props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__range_js__ = __webpack_require__(844);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__reduce_js__ = __webpack_require__(63);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__reduceBy_js__ = __webpack_require__(152);
/* unused harmony reexport reduceBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__reduceRight_js__ = __webpack_require__(350);
/* unused harmony reexport reduceRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__reduceWhile_js__ = __webpack_require__(845);
/* unused harmony reexport reduceWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__reduced_js__ = __webpack_require__(846);
/* unused harmony reexport reduced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__reject_js__ = __webpack_require__(151);
/* unused harmony reexport reject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__remove_js__ = __webpack_require__(325);
/* unused harmony reexport remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__repeat_js__ = __webpack_require__(847);
/* unused harmony reexport repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__replace_js__ = __webpack_require__(848);
/* unused harmony reexport replace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__reverse_js__ = __webpack_require__(115);
/* unused harmony reexport reverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__scan_js__ = __webpack_require__(849);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__sequence_js__ = __webpack_require__(352);
/* unused harmony reexport sequence */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__set_js__ = __webpack_require__(850);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__slice_js__ = __webpack_require__(54);
/* unused harmony reexport slice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__sort_js__ = __webpack_require__(851);
/* unused harmony reexport sort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__sortBy_js__ = __webpack_require__(852);
/* unused harmony reexport sortBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__sortWith_js__ = __webpack_require__(853);
/* unused harmony reexport sortWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__split_js__ = __webpack_require__(854);
/* unused harmony reexport split */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__splitAt_js__ = __webpack_require__(855);
/* unused harmony reexport splitAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__splitEvery_js__ = __webpack_require__(856);
/* unused harmony reexport splitEvery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__splitWhen_js__ = __webpack_require__(857);
/* unused harmony reexport splitWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__startsWith_js__ = __webpack_require__(858);
/* unused harmony reexport startsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__subtract_js__ = __webpack_require__(859);
/* unused harmony reexport subtract */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__sum_js__ = __webpack_require__(341);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__symmetricDifference_js__ = __webpack_require__(860);
/* unused harmony reexport symmetricDifference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__symmetricDifferenceWith_js__ = __webpack_require__(861);
/* unused harmony reexport symmetricDifferenceWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__tail_js__ = __webpack_require__(147);
/* unused harmony reexport tail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__take_js__ = __webpack_require__(223);
/* unused harmony reexport take */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__takeLast_js__ = __webpack_require__(332);
/* unused harmony reexport takeLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__takeLastWhile_js__ = __webpack_require__(862);
/* unused harmony reexport takeLastWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__takeWhile_js__ = __webpack_require__(863);
/* unused harmony reexport takeWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__tap_js__ = __webpack_require__(865);
/* unused harmony reexport tap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__test_js__ = __webpack_require__(867);
/* unused harmony reexport test */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__then_js__ = __webpack_require__(869);
/* unused harmony reexport then */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__times_js__ = __webpack_require__(351);
/* unused harmony reexport times */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__toLower_js__ = __webpack_require__(870);
/* unused harmony reexport toLower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__toPairs_js__ = __webpack_require__(871);
/* unused harmony reexport toPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__toPairsIn_js__ = __webpack_require__(872);
/* unused harmony reexport toPairsIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__toString_js__ = __webpack_require__(149);
/* unused harmony reexport toString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__toUpper_js__ = __webpack_require__(873);
/* unused harmony reexport toUpper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__transduce_js__ = __webpack_require__(874);
/* unused harmony reexport transduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__transpose_js__ = __webpack_require__(875);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__traverse_js__ = __webpack_require__(876);
/* unused harmony reexport traverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__trim_js__ = __webpack_require__(877);
/* unused harmony reexport trim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__tryCatch_js__ = __webpack_require__(878);
/* unused harmony reexport tryCatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__type_js__ = __webpack_require__(215);
/* unused harmony reexport type */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__unapply_js__ = __webpack_require__(879);
/* unused harmony reexport unapply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__unary_js__ = __webpack_require__(880);
/* unused harmony reexport unary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__uncurryN_js__ = __webpack_require__(881);
/* unused harmony reexport uncurryN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__unfold_js__ = __webpack_require__(882);
/* unused harmony reexport unfold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__union_js__ = __webpack_require__(883);
/* unused harmony reexport union */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__unionWith_js__ = __webpack_require__(884);
/* unused harmony reexport unionWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__uniq_js__ = __webpack_require__(224);
/* unused harmony reexport uniq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__uniqBy_js__ = __webpack_require__(334);
/* unused harmony reexport uniqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__uniqWith_js__ = __webpack_require__(353);
/* unused harmony reexport uniqWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__unless_js__ = __webpack_require__(885);
/* unused harmony reexport unless */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__unnest_js__ = __webpack_require__(886);
/* unused harmony reexport unnest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__until_js__ = __webpack_require__(887);
/* unused harmony reexport until */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__update_js__ = __webpack_require__(222);
/* unused harmony reexport update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__useWith_js__ = __webpack_require__(349);
/* unused harmony reexport useWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__values_js__ = __webpack_require__(301);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__valuesIn_js__ = __webpack_require__(888);
/* unused harmony reexport valuesIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__view_js__ = __webpack_require__(889);
/* unused harmony reexport view */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__when_js__ = __webpack_require__(890);
/* unused harmony reexport when */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__where_js__ = __webpack_require__(354);
/* unused harmony reexport where */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__whereEq_js__ = __webpack_require__(891);
/* unused harmony reexport whereEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__without_js__ = __webpack_require__(892);
/* unused harmony reexport without */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__xprod_js__ = __webpack_require__(893);
/* unused harmony reexport xprod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__zip_js__ = __webpack_require__(894);
/* unused harmony reexport zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__zipObj_js__ = __webpack_require__(895);
/* unused harmony reexport zipObj */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__zipWith_js__ = __webpack_require__(896);
/* unused harmony reexport zipWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__thunkify_js__ = __webpack_require__(897);
/* unused harmony reexport thunkify */































































































































































































































































/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
/* harmony default export */ __webpack_exports__["a"] = (Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(357);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(78)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(42);
var setDesc = __webpack_require__(31).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(18)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* unused harmony export legacy_createStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(588);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HASH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__roles__ = __webpack_require__(15);
var ACTION={POP:'POP',PUSH:'PUSH',REPLACE:'REPLACE'};var ROUTE={LOGIN:'/',DASHBOARD:'/:manufacturerRole/dashboard',INSPECTOR_DASHBOARD:'/inspectorDashboard',METRICS:'/metrics',SUMMARY:'/:manufacturerCode/:manufacturerRole/summary',REPORT:'/:manufacturerId/:manufacturerRole/report',BOAT_MANUFACTURER:'/:manufacturerCode/'+__WEBPACK_IMPORTED_MODULE_0__roles__["a" /* ROLES */].BOAT_MANUFACTURER.nameForUrl,TRAILER_MANUFACTURER:'/:manufacturerCode/'+__WEBPACK_IMPORTED_MODULE_0__roles__["a" /* ROLES */].TRAILER_MANUFACTURER.nameForUrl,COMPONENT_MANUFACTURER:'/:manufacturerCode/'+__WEBPACK_IMPORTED_MODULE_0__roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.nameForUrl,OIL_MANUFACTURER:'/:manufacturerCode/'+__WEBPACK_IMPORTED_MODULE_0__roles__["a" /* ROLES */].OIL_MANUFACTURER.nameForUrl,OIL_BRANDER:'/:manufacturerCode/'+__WEBPACK_IMPORTED_MODULE_0__roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl,INSPECTION:'/:manufacturerCode/:manufacturerRole/'+__WEBPACK_IMPORTED_MODULE_0__roles__["a" /* ROLES */].INSPECTION.nameForUrl,DOCUMENTS:'/:manufacturerCode/:manufacturerRole/documents'};var LINK={LIST:{TRAILER:'trailer',COMPONENT:'component'},MANUFACTURER:{TRAILER:'trailer',COMPONENT:'component',BOAT:'boat',OIL:'oil'}};var HASH={ADD:'add',EDIT:'edit'};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _reduced;
function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Slider=function Slider(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider '+props.mainWrapperClassName},props.label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'main-label'},props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'slider-body '+props.sliderBodyClassName+' '+(props.disabled?'slider-body_disabled':''),onClick:props.disabled?function(){}:props.toggleAction},props.onLabel,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(props.state?'on':'off')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-slider-dot'})),props.offLabel));};Slider.defaultProps={color:''};/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(233);
var enumBugKeys = __webpack_require__(166);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(19);
var dPs = __webpack_require__(234);
var enumBugKeys = __webpack_require__(166);
var IE_PROTO = __webpack_require__(165)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(163)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(167).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(233);
var hiddenKeys = __webpack_require__(166).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(42);
var toObject = __webpack_require__(35);
var IE_PROTO = __webpack_require__(165)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(23)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(43)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_actions_user__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_routing__ = __webpack_require__(74);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _class2,_temp,_initialiseProps;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(TargetComponent){var _dec,_class;var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{signIn:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["g" /* signIn */],dispatch),logOut:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["c" /* logOut */],dispatch),changeMenu:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["a" /* changeMenu */],dispatch),selectManufacturer:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["f" /* selectManufacturer */],dispatch),selectInspector:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["e" /* selectInspector */],dispatch),updateManufacturer:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["i" /* updateManufacturer */],dispatch),saveUrlToRedirect:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["d" /* saveUrlToRedirect */],dispatch),clearUrlToRedirect:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["b" /* clearUrlToRedirect */],dispatch),storeSelectedYear:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5_store_actions_user__["h" /* storeSelectedYear */],dispatch)};};var WithUser=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(_class=_dec(_class=function(_React$Component){_inherits(WithUser,_React$Component);function WithUser(props){_classCallCheck(this,WithUser);var _this=_possibleConstructorReturn(this,(WithUser.__proto__||Object.getPrototypeOf(WithUser)).call(this,props));_this.state={user:{}};return _this;}_createClass(WithUser,[{key:'render',value:function render(){var _props$match$params=this.props.match.params,step=_props$match$params.step,applicationId=_props$match$params.applicationId;var passedProps={signIn:this.props.signIn,logOut:this.props.logOut,changeMenu:this.props.changeMenu,updateManufacturer:this.props.updateManufacturer,saveUrlToRedirect:this.props.saveUrlToRedirect,clearUrlToRedirect:this.props.clearUrlToRedirect};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TargetComponent,Object.assign({user:this.state.user,step:step,location:this.props.location,history:this.props.history,match:this.props.match,applicationId:applicationId},passedProps));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(_ref){var user=_ref.user,history=_ref.history,location=_ref.location,selectManufacturer=_ref.selectManufacturer,selectInspector=_ref.selectInspector,changeMenu=_ref.changeMenu,saveUrlToRedirect=_ref.saveUrlToRedirect,clearUrlToRedirect=_ref.clearUrlToRedirect,storeSelectedYear=_ref.storeSelectedYear;return{user:new User(user,history,location,selectManufacturer,selectInspector,changeMenu,saveUrlToRedirect,clearUrlToRedirect,storeSelectedYear)};}}]);return WithUser;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component))||_class)||_class);return WithUser;});var User=(_temp=_class2=function User(user,history,location,selectManufacturer,selectInspector,changeMenu,saveUrlToRedirect,clearUrlToRedirect,storeSelectedYear){var _this2=this;_classCallCheck(this,User);_initialiseProps.call(this);var setActiveRole=function setActiveRole(){var rolesOrder=[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName];if(user.activeRole)return user.activeRole;if(_this2.isInternal()||_this2.isInspector())return rolesOrder[0];var _loop=function _loop(i,l){var role=_this2.roles.find(function(role){return role===rolesOrder[i];});if(role)return{v:role};};for(var i=0,l=rolesOrder.length;i<l;i++){var _ret=_loop(i,l);if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}};this.id=user.id;this.token=user.token;this.roles=user.roles;var activeRoleServerName=setActiveRole();var newRoleKey=Object.keys(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */]).find(function(roleKey){return __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey].serverName===activeRoleServerName;});this.activeRole=__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][newRoleKey];this.selectedManufacturer=user.selectedManufacturer;this.selectedInspector=user.selectedInspector;this.selectedYear=user.selectedYear;this.manufacturer=user.manufacturer;this.firstName=user.firstName;this.lastName=user.lastName;this.email=user.email;this.accountCode=user.accountCode;this.changeStoredMenuState=changeMenu;this.redirect=user.redirect;this.history=history;this.location=location;this.storeSelectManufacturer=selectManufacturer;this.storeSelectInspector=selectInspector;this.saveUrlToRedirect=saveUrlToRedirect;this.clearUrlToRedirect=clearUrlToRedirect;this.storeSelectedYear=storeSelectedYear;this.lastManufacturerCode=0;}//TODO remove and replace everywhere with call to constants/ROLES
,_initialiseProps=function _initialiseProps(){var _this3=this;this.COMPONENT_MANUFACTURER='CMPNT_MNFCTR';this.BOAT_MANUFACTURER='BT_MNFCTR';this.TRAILER_MANUFACTURER='TRLR_MNFCTR';this.OIL_BRANDER='OIL_BRNDR';this.OIL_MANUFACTURER='OIL_FRMLTR';this.INTERNAL='INTERNAL_USER';this.INSPECTION='INSPEC';this.getAditionalMenu=function(){var ADDITIONAL_MENU={};if(_this3.isInternal()&&!_this3.selectedManufacturer){var _ADDITIONAL_MENU;ADDITIONAL_MENU=(_ADDITIONAL_MENU={},_defineProperty(_ADDITIONAL_MENU,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.readableName,[{name:'Manufacturers',link:_this3.getDashboardLink(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.nameForUrl),index:0},{name:'Metrics',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].METRICS,index:0}]),_defineProperty(_ADDITIONAL_MENU,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.readableName,[{name:'Inspectors',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].INSPECTOR_DASHBOARD,index:0},{name:'Manufacturers',link:_this3.getDashboardLink(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.nameForUrl),index:0},{name:'Metrics',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].METRICS,index:0}]),_defineProperty(_ADDITIONAL_MENU,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName,[{name:'Inspectors',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].INSPECTOR_DASHBOARD,index:0},{name:'Manufacturers',link:_this3.getDashboardLink(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.nameForUrl),index:0},{name:'Metrics',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].METRICS,index:0}]),_defineProperty(_ADDITIONAL_MENU,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName,[{name:'Manufacturers',link:_this3.getDashboardLink(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl),index:0},{name:'Metrics',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].METRICS,index:0}]),_defineProperty(_ADDITIONAL_MENU,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName,[{name:'Manufacturers',link:_this3.getDashboardLink(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.nameForUrl),index:0},{name:'Metrics',link:__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].METRICS,index:0}]),_ADDITIONAL_MENU);}else if(!_this3.isInspector()){var _ADDITIONAL_MENU2;ADDITIONAL_MENU=(_ADDITIONAL_MENU2={},_defineProperty(_ADDITIONAL_MENU2,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.readableName,[{name:'Summary',link:_this3.getSummaryLink(),index:0},{name:'Documents',link:_this3.getDocumentsLink(),index:0},{name:'REPORTS',link:_this3.getReportLink(),index:0},{name:'Component List',link:_this3.getListLink(),index:0},{name:'Family List',link:_this3.getFamiliesLink(),index:0},{name:'+ New Component',link:_this3.getNewApplicationLink(),index:1},{name:'+ New Component Family',link:_this3.getNewFamilyLink(),index:1}]),_defineProperty(_ADDITIONAL_MENU2,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.readableName,[{name:'Summary',link:_this3.getSummaryLink(),index:0},{name:'Documents',link:_this3.getDocumentsLink(),index:0},{name:'REPORTS',link:_this3.getReportLink(),index:0},{name:'Inspection List',link:_this3.getInspectionsLink(),index:2},{name:'Boat Model List',link:_this3.getListLink(),index:0},{name:'+ New boat model',link:_this3.getBoatApplicationLink(),index:1}]),_defineProperty(_ADDITIONAL_MENU2,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName,[{name:'Summary',link:_this3.getSummaryLink(),index:0},{name:'Documents',link:_this3.getDocumentsLink(),index:0},{name:'REPORTS',link:_this3.getReportLink(),index:0},{name:'Inspection List',link:_this3.getInspectionsLink(),index:0},{name:'Trailer List',link:'/'+_this3.getManufacturerCode()+'/trailer',index:2},{name:'+ New Trailer',link:'/'+_this3.getManufacturerCode()+'/trailer#add',index:1}]),_defineProperty(_ADDITIONAL_MENU2,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName,[{name:'Summary',link:_this3.getSummaryLink(),index:0}]),_ADDITIONAL_MENU2);var userIsOilBrander=_this3.isOilBrander();var userIsOilManufacturer=_this3.isOilManufacturer();if(userIsOilBrander&&userIsOilManufacturer){ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName]=ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName].concat([{name:'Formulation List',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/formula',index:0},{name:'Brand List',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/brand',index:0},{name:'+ New Formulation',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/formula/new',index:1},{name:'+ New Brand',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/brand/new',index:1}]);}else{if(userIsOilManufacturer){ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.readableName]=ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName].concat([{name:'Formulation List',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/formula',index:0},{name:'+ New Formulation',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/formula/new',index:1}]);}if(userIsOilBrander){ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName]=ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.readableName].concat([{name:'Brand List',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/brand',index:0},{name:'+ New Brand',link:'/'+_this3.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+'/brand/new',index:1}]);}}if(_this3.isInternal()){ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.readableName].push({name:'+ New Inspection',link:_this3.getNewInspectionsLink(),index:1});ADDITIONAL_MENU[__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName].push({name:'+ New Inspection',link:_this3.getNewInspectionsLink(),index:1});}}else{var _ADDITIONAL_MENU3;ADDITIONAL_MENU=(_ADDITIONAL_MENU3={},_defineProperty(_ADDITIONAL_MENU3,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.readableName,[{name:'Summary',link:_this3.getSummaryLink(),index:0},{name:'Documents',link:_this3.getDocumentsLink(),index:0},{name:'REPORTS',link:_this3.getReportLink(),index:0},{name:'Inspection List',link:_this3.getInspectionsLink(),index:2},{name:'Boat Model List',link:_this3.getListLink(),index:0},{name:'+ New Inspection',link:_this3.getNewInspectionsLink(),index:1}]),_defineProperty(_ADDITIONAL_MENU3,__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName,[{name:'Summary',link:_this3.getSummaryLink(),index:0},{name:'Documents',link:_this3.getDocumentsLink(),index:0},{name:'REPORTS',link:_this3.getReportLink(),index:0},{name:'Inspection List',link:_this3.getInspectionsLink(),index:0},{name:'Trailer List',link:'/'+_this3.getManufacturerCode()+'/trailer',index:2},{name:'+ New Inspection',link:_this3.getNewInspectionsLink(),index:1}]),_ADDITIONAL_MENU3);}return ADDITIONAL_MENU;};this.isOilBrander=function(){var rolesList=[];if(_this3.selectedManufacturer){rolesList=_this3.selectedManufacturer.allRoles.split(',').map(function(roleString){return roleString.trim();});}else if(_this3.manufacturer){rolesList=_this3.manufacturer.roles;}if(!rolesList)rolesList=[];var availableForThisUserRoles=rolesList.filter(function(role){return _this3.roles.indexOf(role)!==-1||_this3.roles[0]===__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].INTERNAL.serverName;});return availableForThisUserRoles.indexOf(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName)!==-1;};this.isOilManufacturer=function(){var rolesList=[];if(_this3.selectedManufacturer){rolesList=_this3.selectedManufacturer.allRoles.split(',').map(function(roleString){return roleString.trim();});}else if(_this3.manufacturer){rolesList=_this3.manufacturer.roles;}if(!rolesList)rolesList=[];var availableForThisUserRoles=rolesList.filter(function(role){return _this3.roles.indexOf(role)!==-1||_this3.roles[0]===__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].INTERNAL.serverName;});return availableForThisUserRoles.indexOf(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName)!==-1;};this.isInternal=function(){return _this3.roles[0]===_this3.INTERNAL;};this.isInspector=function(){return _this3.roles[0]===_this3.INSPECTION;};this.isManufacturerSelected=function(){return!!_this3.selectedManufacturer;};this.changeMenu=function(userRole){var newRoleKey=Object.keys(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */]).find(function(roleKey){return __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey].serverName===userRole;});_this3.activeRole=__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][newRoleKey];_this3.changeStoredMenuState(userRole);_this3.clearListState();//setTimeout(() => {window.sessionStorage.clear();}, 0);
};this.setActiveRole=function(userRole){var newRoleKey=Object.keys(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */]).find(function(roleKey){return __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey].serverName===userRole;});_this3.activeRole=__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][newRoleKey];_this3.changeStoredMenuState(userRole);};this.getManufacturerName=function(){return _this3.selectedManufacturer?_this3.selectedManufacturer.name:_this3.isInternal()||_this3.isInspector()?'':_this3.manufacturer.name;};this.getManufacturerCode=function(){return _this3.selectedManufacturer?_this3.selectedManufacturer.code:_this3.isInternal()||_this3.isInspector()?0:_this3.manufacturer.code;};this.getManufacturerStatus=function(){return _this3.selectedManufacturer?_this3.selectedManufacturer.active:false;};this.getInspectorName=function(){return _this3.selectedInspector?_this3.selectedInspector.name:'';};this.getInspectorCode=function(){return _this3.selectedInspector?_this3.selectedInspector.code:'';};this.getActiveRole=function(){return _this3.activeRole.serverName;};this.isMultipleRoles=function(){return _this3.roles.length>1||_this3.isInternal()||_this3.isInspector();};this.getRoleNameForURL=function(){return _this3.activeRole.nameForUrl;};this.getRoleListSceneUrlPostfix=function(){return _this3.activeRole.listSceneUrlPostfix;};this.getRoleName=function(roleServerName){if(!roleServerName)return _this3.activeRole.readableName;var roleKey=Object.keys(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */]).find(function(roleKey){return __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey].serverName===roleServerName;});return __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey].readableName;};this.goTo=function(link){_this3.history.push(link);};this.replaceLocation=function(link){_this3.history.replace(link);};this.goToUserStartPage=function(code){if(!code)_this3.goToDashboard();else if(_this3.isInspector())_this3.goToList(code);else _this3.goToSummary(code);};this.goToLogin=function(){_this3.history.push(__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].LOGIN);};this.goToDashboard=function(role){_this3.history.push(_this3.getDashboardLink(role));};this.goToInspectorDashboard=function(){_this3.history.push(__WEBPACK_IMPORTED_MODULE_7_constants_routing__["d" /* ROUTE */].INSPECTOR_DASHBOARD);};this.goToSummary=function(code,role){var url='/'+(code||_this3.getManufacturerCode())+'/'+(role||_this3.activeRole.nameForUrl)+'/summary';_this3.history.push(url);};this.goToList=function(manufacturerCode,params){var url=_this3.getListLink(manufacturerCode);if(params){var searchString=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params,{addQueryPrefix:true});_this3.history.replace(url+searchString);}else{_this3.history.push(url);}};this.goToInspectionList=function(params){var url=_this3.getInspectionsLink();if(params){var searchString=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params,{addQueryPrefix:true});_this3.history.replace(url+searchString);}else{_this3.history.push(url);}};this.goToInspectionDetails=function(id){_this3.history.push(_this3.getInspectionsLink()+'/'+id+'/details');};this.goToInspectionEdit=function(id){_this3.history.push(_this3.getInspectionsLink()+'/'+id+'/edit');};this.goToFamilyList=function(params){var url=_this3.getFamiliesLink();if(params){var searchString=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params,{addQueryPrefix:true});_this3.history.replace(url+searchString);}else{_this3.history.push(url);}};this.goToFamilyDetails=function(id){_this3.history.push(_this3.getFamiliesLink()+'/'+id+'/details');};this.goToFamilyEdit=function(id){_this3.history.push(_this3.getFamiliesLink()+'/'+id+'/edit');};this.goToReport=function(manufacturerCode){var url='/'+(manufacturerCode||_this3.getManufacturerCode())+'/'+_this3.getRoleNameForURL()+'/report';_this3.history.push(url);};this.goToApplication=function(){var url='/'+_this3.getManufacturerCode()+'/'+_this3.getRoleNameForURL()+'/application';_this3.history.push(url);};this.goToApplicationStep=function(id,step,options){options=options||{};var url='/'+_this3.getManufacturerCode()+'/'+_this3.getRoleNameForURL()+'/application/'+id+'/'+step;_this3.history[options.replace?'replace':'push'](url);};this.goToApplicationDetails=function(id){var url='/'+_this3.getManufacturerCode()+'/'+_this3.getRoleNameForURL()+'/application/'+id;_this3.history.push(url);};this.getSummaryLink=function(){return'/'+_this3.getManufacturerCode()+'/'+_this3.activeRole.nameForUrl+'/summary';};this.getDocumentsLink=function(params){var url='/'+_this3.getManufacturerCode()+'/'+_this3.activeRole.nameForUrl+'/documents';if(params){var searchString=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params,{addQueryPrefix:true});return url+searchString;}else{return url;}};this.getDashboardLink=function(role){return'/'+(role||_this3.activeRole.nameForUrl)+'/dashboard';};this.getNewInspectionsLink=function(){return'/'+_this3.getManufacturerCode()+'/'+_this3.activeRole.nameForUrl+'/inspection/new';};this.getInspectionsLink=function(){return'/'+_this3.getManufacturerCode()+'/'+_this3.activeRole.nameForUrl+'/inspection';};this.getFamiliesLink=function(){return'/'+_this3.getManufacturerCode()+'/'+_this3.activeRole.nameForUrl+'/family';};this.getListLink=function(manufacturerCode){return'/'+(manufacturerCode||_this3.getManufacturerCode())+'/'+_this3.getRoleNameForURL()+_this3.getRoleListSceneUrlPostfix();};this.getReportLink=function(manufacturerCode){return'/'+_this3.getManufacturerCode()+'/'+(manufacturerCode||_this3.getRoleNameForURL())+'/report';};this.getNewApplicationLink=function(){return'/'+_this3.getManufacturerCode()+'/'+_this3.getRoleNameForURL()+'/application/new';};this.getBoatApplicationLink=function(){return'/'+_this3.getManufacturerCode()+'/'+_this3.getRoleNameForURL()+'/application/new/InitNewBoat';};this.getNewFamilyLink=function(){return _this3.getFamiliesLink()+'/new';};this.goBack=function(){_this3.history.goBack();};this.selectManufacturer=function(manufacturer,withoutRedirect){_this3.clearListState();_this3.storeSelectManufacturer(manufacturer);if(manufacturer&&!withoutRedirect){_this3.goToUserStartPage(manufacturer.code);}};this.selectInspector=function(inspector){return function(){_this3.clearListState();_this3.storeSelectInspector(inspector);if(inspector){_this3.goToDashboard();}else{_this3.goToInspectorDashboard();}};};this.clearListState=function(){window.sessionStorage.removeItem('listState');window.sessionStorage.removeItem('brandListState');window.sessionStorage.removeItem('formulaListState');window.sessionStorage.removeItem('boatListState');window.sessionStorage.removeItem('inspectionListState');window.sessionStorage.removeItem('documentsListState');//this.updateURLSearchString({});
};this.saveState=function(key,state){var excludedFields=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var stateToSave=Object.assign({},state);excludedFields.forEach(function(fieldName){delete stateToSave[fieldName];});window.sessionStorage.setItem(key,JSON.stringify(stateToSave));};this.getStoredState=function(key){var defaultState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var stateFromURLSearchString=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(_this3.location.search,{ignoreQueryPrefix:true});var stateFromSessionStorage=JSON.parse(window.sessionStorage.getItem(key));var parseStrings=function parseStrings(stateToParse){var parsedState={};for(var field in stateToParse){if(stateToParse[field]==='false'||stateToParse[field]==='true'){parsedState[field]=stateToParse[field]!=='false';}else if(isFinite(stateToParse[field])){parsedState[field]=+stateToParse[field];}else if(_typeof(stateToParse[field])==='object'&&!stateToParse[field].length){parsedState[field]=parseStrings(stateToParse[field]);}else{parsedState[field]=stateToParse[field];}}return parsedState;};var removeDefaultValuesFromNewState=function removeDefaultValuesFromNewState(defaultState,stateToClear){for(var param in stateToClear){if(stateToClear[param]===defaultState[param]){delete stateToClear[param];}else{if(_typeof(stateToClear[param])==='object'&&Object.keys(stateToClear[param]).length===0){delete stateToClear[param];}}}return stateToClear;};var removeValuesSetAsDefaultInURL=function removeValuesSetAsDefaultInURL(stateFromURLSearchString,stateToClear){for(var param in stateToClear){if(stateFromURLSearchString[param]==='default')delete stateToClear[param];}return stateToClear;};var storedState=Object.assign({},stateFromSessionStorage,parseStrings(stateFromURLSearchString));removeValuesSetAsDefaultInURL(stateFromURLSearchString,storedState);removeDefaultValuesFromNewState(defaultState,storedState);return storedState;};this.updateURLSearchString=function(paramsObj){var urlParams=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(_this3.location.search,{ignoreQueryPrefix:true});var newUrlParams=Object.assign({},urlParams,paramsObj);for(var param in newUrlParams){if(newUrlParams[param]==='default'||newUrlParams[param]==='')delete newUrlParams[param];}var searchString=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(newUrlParams,{addQueryPrefix:true});_this3.history.replace(_this3.location.pathname+searchString+_this3.location.hash);};this.saveSelectedYear=function(year){var role=_this3.getRoleNameForURL();_this3.storeSelectedYear(role,year);};this.getSelectedYear=function(){var role=_this3.getRoleNameForURL();return _this3.selectedYear?_this3.selectedYear[role]:'';};},_temp);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Checkbox=function(_React$Component){_inherits(Checkbox,_React$Component);function Checkbox(){_classCallCheck(this,Checkbox);return _possibleConstructorReturn(this,(Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).apply(this,arguments));}_createClass(Checkbox,[{key:'render',value:function render(){var _props=this.props,label=_props.label,value=_props.value,onChange=_props.onChange,labelType=_props.labelType,inputType=_props.inputType,markStyleClass=_props.markStyleClass,isLoading=_props.isLoading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'ect-checkbox '+labelType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'ectCheckbox',className:'ect-checkbox-input '+inputType,checked:value?'checked':'',onChange:onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ect-checkbox-mark '+markStyleClass+' '+(isLoading?'__spinner _border_none':value?'checked':'')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ect-checkbox-label'},label));}}]);return Checkbox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Checkbox.defaultProps={label:'',value:false,onChange:function onChange(){},inputType:'checkbox',labelType:''};/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YearPicker=function(_React$Component){_inherits(YearPicker,_React$Component);function YearPicker(props){_classCallCheck(this,YearPicker);var _this=_possibleConstructorReturn(this,(YearPicker.__proto__||Object.getPrototypeOf(YearPicker)).call(this,props));_this.toggle=function(){var expanded=_this.state.expanded;if(!expanded){document.addEventListener('click',_this.toggle);_this.setState({expanded:true});}else{document.removeEventListener('click',_this.toggle);_this.setState({expanded:false});}};_this.getYears=function(){var _this$props=_this.props,year=_this$props.year,endYear=_this$props.endYear,withAllOption=_this$props.withAllOption;var i=0;var yearsList=[];var startYear=endYear-20;while(startYear+i!==endYear+1){yearsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:startYear+i,className:'year '+(startYear+i===year?'active':''),onClick:_this.handleYearChoose(startYear+i)},startYear+i));startYear<endYear+1?i++:i--;}if(withAllOption){yearsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'All',className:'year '+(year?'':'active'),onClick:_this.handleYearChoose('All')},'All'));}return yearsList.reverse();};_this.handleYearChoose=function(year){return function(){var yearPickAction=_this.props.yearPickAction;yearPickAction(year);_this.toggle();};};_this.state={expanded:false};return _this;}_createClass(YearPicker,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.toggle);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,width=_props.width,height=_props.height,year=_props.year,label=_props.label,disabled=_props.disabled;var expanded=this.state.expanded;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'year-picker '+(expanded?'expanded':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chosen-year-holder '+(disabled?'chosen-year-holder_disabled':''),style:{width:width,height:height},onClick:function onClick(){if(!disabled)_this2.toggle();}},year||'All',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'open-arrow'})),expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drop-down',style:{width:width}},this.getYears()):null);}}]);return YearPicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);YearPicker.propTypes={width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),startYear:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,endYear:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,year:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,yearPickAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,withAllOption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};YearPicker.defaultProps={width:'100%',height:'100%',endYear:new Date().getFullYear()+1,label:'by Model Year',withAllOption:false,disabled:false};/* harmony default export */ __webpack_exports__["a"] = (YearPicker);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(31).f;
var has = __webpack_require__(42);
var TAG = __webpack_require__(23)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(65);
var fails = __webpack_require__(18);
var spaces = __webpack_require__(169);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var dP = __webpack_require__(31);
var DESCRIPTORS = __webpack_require__(30);
var SPECIES = __webpack_require__(23)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(37);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
var max = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function max(a, b) {
  return b > a ? b : a;
});
/* harmony default export */ __webpack_exports__["a"] = (max);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
var path = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});
/* harmony default export */ __webpack_exports__["a"] = (path);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _includes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indexOf_js__ = __webpack_require__(315);


function _includes(a, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__indexOf_js__["a" /* default */])(list, a, 0) >= 0;
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(913),
    getValue = __webpack_require__(918);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLACEHOLDER='MM / DD / YYYY';var SELECT_DATE_TYPE={INC:'INC',DEC:'DEC'};var DatePicker=function(_React$Component){_inherits(DatePicker,_React$Component);function DatePicker(props){_classCallCheck(this,DatePicker);var _this=_possibleConstructorReturn(this,(DatePicker.__proto__||Object.getPrototypeOf(DatePicker)).call(this,props));_this._toggle=function(){var expanded=_this.state.expanded;if(!expanded){document.addEventListener('click',_this._toggle);_this.setState({expanded:true});}else{document.removeEventListener('click',_this._toggle);_this.setState({expanded:false});}};_this.__getIEKey=function(keyCode){if(keyCode>95&&keyCode<106)return keyCode-96;// Numpad
if(keyCode>47&&keyCode<58)return keyCode-48;// Numbers
if(keyCode===37||keyCode===39){// Arrows
switch(keyCode){case 37:return'ArrowLeft';case 39:return'ArrowRight';default:return null;}}return null;};_this._handleDateInput=function(event){var handleSelectDate=_this.props.handleSelectDate;_this.cursorPosition=event.target.selectionStart;var target=event.target;var key=event.nativeEvent.key;if(!key){key=_this.__getIEKey(event.which);}switch(key){case'ArrowLeft':return _this.__updateLeftCursorPosition(event);case'ArrowRight':return _this.__updateRightCursorPosition(event);case'Delete':return _this.__deleteRightCursorPosition(event);case'Backspace':return _this.__deleteLeftCursorPosition(event);default:break;}if(_this.cursorPosition!==14&&isFinite(key)&&key!==null){var inputDate=_this.__updateInputDate(key);_this.setState({inputDate:inputDate},function(){var date=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(inputDate.slice(0,14)+'Z',PLACEHOLDER);if(date.isValid()){_this.temporaryDate=date;handleSelectDate(date);_this.forceUpdate();}else{handleSelectDate('',true);}target.setSelectionRange(_this.cursorPosition+1,_this.cursorPosition+1);});}};_this.__updateLeftCursorPosition=function(event){if(_this.cursorPosition>2&&_this.cursorPosition<6){_this.cursorPosition=3;event.target.setSelectionRange(_this.cursorPosition,_this.cursorPosition);}if(_this.cursorPosition>7&&_this.cursorPosition<11){_this.cursorPosition=8;event.target.setSelectionRange(_this.cursorPosition,_this.cursorPosition);}};_this.__updateRightCursorPosition=function(event){if(_this.cursorPosition>1&&_this.cursorPosition<5){_this.cursorPosition=4;event.target.setSelectionRange(_this.cursorPosition,_this.cursorPosition);}if(_this.cursorPosition>6&&_this.cursorPosition<10){_this.cursorPosition=9;event.target.setSelectionRange(_this.cursorPosition,_this.cursorPosition);}};_this.__deleteLeftCursorPosition=function(){};_this.__deleteRightCursorPosition=function(){};_this.__updateInputDate=function(key){if(_this.cursorPosition===1){_this.cursorPosition=4;return _this.state.inputDate.slice(0,1)+key+' / '+_this.state.inputDate.slice(5);}if(_this.cursorPosition===6){_this.cursorPosition=9;return _this.state.inputDate.slice(0,6)+key+' / '+_this.state.inputDate.slice(10);}if(_this.cursorPosition>1&&_this.cursorPosition<5){_this.cursorPosition=5;return _this.state.inputDate.slice(0,2)+' / '+key+_this.state.inputDate.slice(6);}if(_this.cursorPosition>6&&_this.cursorPosition<10){_this.cursorPosition=10;return _this.state.inputDate.slice(0,7)+' / '+key+_this.state.inputDate.slice(11);}return _this.state.inputDate.slice(0,_this.cursorPosition)+key+_this.state.inputDate.slice(_this.cursorPosition+1);};_this._clearDate=function(event){var handleSelectDate=_this.props.handleSelectDate;event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();_this.setState({inputDate:''},function(){handleSelectDate('');});};_this._handleYearSelect=function(selectType){return function(event){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();switch(selectType){case SELECT_DATE_TYPE.INC:_this.temporaryDate.year(_this.temporaryDate.year()+1);break;case SELECT_DATE_TYPE.DEC:_this.temporaryDate.year(_this.temporaryDate.year()-1);break;default:break;}_this.forceUpdate();};};_this._handleMonthSelect=function(selectType){return function(event){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();switch(selectType){case SELECT_DATE_TYPE.INC:_this.temporaryDate.month(_this.temporaryDate.month()+1);break;case SELECT_DATE_TYPE.DEC:_this.temporaryDate.month(_this.temporaryDate.month()-1);break;default:break;}_this.forceUpdate();};};_this._handleDaySelect=function(day){return function(event){var handleSelectDate=_this.props.handleSelectDate;event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();_this.temporaryDate.date(day);_this.setState({inputDate:_this.temporaryDate.format(PLACEHOLDER)},function(){handleSelectDate(_this.temporaryDate);_this._toggle();});};};_this._getDays=function(){var days=[];for(var i=0,l=_this.temporaryDate.daysInMonth();i<l;i++){days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'day '+(i+1===_this.temporaryDate.date()?'active':''),onClick:_this._handleDaySelect(i+1)},i+1));}return days;};_this.saveInputFieldRef=function(ref){_this.inputFieldRef=ref;};_this.state={expanded:false,inputDate:props.selectedDate?__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.selectedDate).format(PLACEHOLDER):''};_this.cursorPosition=0;_this.temporaryDate=props.selectedDate?__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.selectedDate):__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc();_this.months=['January','February','March','April','May','June','July','August','September','October','November','December'];_this.inputFieldRef={};return _this;}_createClass(DatePicker,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(_ref){var selectedDate=_ref.selectedDate;var inputDate=this.state.inputDate;if(selectedDate.isValid&&selectedDate.isValid()&&!selectedDate.isSame(this.props.selectedDate)){this.setState({inputDate:selectedDate.format(PLACEHOLDER)});}else if(!selectedDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(inputDate,PLACEHOLDER).isValid()){this.setState({inputDate:''});}return true;}},{key:'render',value:function render(){var _state=this.state,inputDate=_state.inputDate,expanded=_state.expanded;var _props=this.props,error=_props.error,label=_props.label,mainWrapperClassName=_props.mainWrapperClassName,noInput=_props.noInput;var date=__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.temporaryDate,PLACEHOLDER);var dropDownLeftPosition=noInput?'-72px':'0px';var dropDownTopPosition=noInput?'25px':label?'59px':'54px';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-wrapper '+(noInput?'date-picker-wrapper_noInput':'')+' '+mainWrapperClassName},label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),!noInput&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'date-input '+(error?'error':''),value:inputDate,placeholder:PLACEHOLDER,onKeyDown:this._handleDateInput,onFocus:this._handleDateInput,spellCheck:false,ref:this.saveInputFieldRef,autoComplete:'off'}),inputDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-clear-button',onClick:this._clearDate}),typeof error==='string'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-text'},error)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-open-button',onClick:this._toggle}),expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-dropdown',style:{top:dropDownTopPosition,left:dropDownLeftPosition}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'year-choose-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow decrease',onClick:this._handleYearSelect(SELECT_DATE_TYPE.DEC)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-holder'},date.year()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow increase',onClick:this._handleYearSelect(SELECT_DATE_TYPE.INC)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'month-choose-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow decrease',onClick:this._handleMonthSelect(SELECT_DATE_TYPE.DEC)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-holder'},this.months[date.month()]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow increase',onClick:this._handleMonthSelect(SELECT_DATE_TYPE.INC)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day-choose-section'},this._getDays())):null);}}]);return DatePicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);DatePicker.propTypes={selectedDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),handleSelectDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mainWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,noInput:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};DatePicker.defaultProps={selectedDate:'',handleSelectDate:function handleSelectDate(){},label:'',error:'',mainWrapperClassName:'',noInput:false};

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'not-found-scene'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,'404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,'PAGE',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'NOT FOUND'));});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(64);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(64);
var TAG = __webpack_require__(23)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(19);
var aFunction = __webpack_require__(57);
var SPECIES = __webpack_require__(23)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return USER_SIGN_IN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return USER_SIGN_IN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return USER_SIGN_IN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return USER_LOG_OUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return USER_LOG_OUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USER_LOG_OUT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return USER_SAVE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return USER_CLEAR_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MENU_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SELECT_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SELECT_INSPECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SELECT_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOAT_SET_DETAILS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOAT_SET_DETAILS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOAT_SELECT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOAT_SELECT_ENGINE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOAT_UPDATE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT_CLEAR_DETAILS; });
var USER_SIGN_IN_REQUEST='USER_SIGN_IN_REQUEST';var USER_SIGN_IN_SUCCESS='USER_SIGN_IN_SUCCESS';var USER_SIGN_IN_ERROR='USER_SIGN_IN_ERROR';var USER_LOG_OUT_REQUEST='USER_LOG_OUT_REQUEST';var USER_LOG_OUT_SUCCESS='USER_LOG_OUT_SUCCESS';var USER_LOG_OUT_ERROR='USER_LOG_OUT_ERROR';var USER_SAVE_URL='USER_SAVE_URL';var USER_CLEAR_URL='USER_CLEAR_URL';var MENU_CHANGED='MENU_CHANGED';var SELECT_MANUFACTURER='SELECT_MANUFACTURER';var SELECT_INSPECTOR='SELECT_INSPECTOR';var UPDATE_MANUFACTURER='UPDATE_MANUFACTURER';var SELECT_YEAR='SELECT_YEAR';var BOAT_SET_DETAILS_SUCCESS='BOAT_SET_DETAILS_SUCCESS';var BOAT_SET_DETAILS_ERROR='BOAT_SET_DETAILS_ERROR';var BOAT_SELECT_TYPE='BOAT_SELECT_TYPE';var BOAT_SELECT_ENGINE_TYPE='BOAT_SELECT_ENGINE_TYPE';var BOAT_UPDATE_DETAILS='BOAT_UPDATE_DETAILS';var BOAT_CLEAR_DETAILS='BOAT_CLEAR_DETAILS';

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consoleLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consoleWarninig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consoleError; });
/* eslint-disable no-console */var consoleLog=function consoleLog(warn){return console.log(warn);};var consoleWarninig=function consoleWarninig(warn){return console.warn(warn);};var consoleError=function consoleError(error){return console.error(error);};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(286);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(681)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_js__ = __webpack_require__(210);




/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
var pluck = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function pluck(p, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__prop_js__["a" /* default */])(p), list);
});
/* harmony default export */ __webpack_exports__["a"] = (pluck);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isString;
function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isFunction;
function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _checkForMethod;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(68);


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
function _checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isString_js__ = __webpack_require__(112);



/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
var reverse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function reverse(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isString_js__["a" /* default */])(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});
/* harmony default export */ __webpack_exports__["a"] = (reverse);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isString_js__ = __webpack_require__(112);



/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
var nth = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isString_js__["a" /* default */])(list) ? list.charAt(idx) : list[idx];
});
/* harmony default export */ __webpack_exports__["a"] = (nth);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(40);


// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
function _objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;
  while (idx < length) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
}

/* harmony default export */ __webpack_exports__["a"] = (typeof Object.assign === 'function' ? Object.assign : _objectAssign);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isFunction_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(149);





/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
var invoker = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function invoker(arity, method) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN_js__["a" /* default */])(arity + 1, function () {
    var target = arguments[arity];
    if (target != null && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isFunction_js__["a" /* default */])(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(target) + ' does not have a method named "' + method + '"');
  });
});
/* harmony default export */ __webpack_exports__["a"] = (invoker);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(27);
var global = __webpack_require__(17);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(79) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(44);
var toLength = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(81);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(64);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(23)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(19);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(105);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(251);
var redefine = __webpack_require__(37);
var hide = __webpack_require__(43);
var fails = __webpack_require__(18);
var defined = __webpack_require__(65);
var wks = __webpack_require__(23);
var regexpExec = __webpack_require__(184);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(56);
var call = __webpack_require__(246);
var isArrayIter = __webpack_require__(179);
var anObject = __webpack_require__(19);
var toLength = __webpack_require__(24);
var getIterFn = __webpack_require__(181);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(37);
var redefineAll = __webpack_require__(96);
var meta = __webpack_require__(72);
var forOf = __webpack_require__(127);
var anInstance = __webpack_require__(95);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var $iterDetect = __webpack_require__(123);
var setToStringTag = __webpack_require__(91);
var inheritIfRequired = __webpack_require__(170);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var hide = __webpack_require__(43);
var uid = __webpack_require__(78);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(576);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseURL= false?'https://api-staging.ect.nmma.org': false?'http://localhost:8765': true?'https://api.ect.nmma.org':process.env.STAGING==='local'?'http://localhost:8765':'https://api-staging.ect.nmma.org';var isDev="production"!=='production'&&"production"!=='staging';/* harmony default export */ __webpack_exports__["a"] = ({baseURL:baseURL,store:'root',client_id:'nmma',communityHub: true?{authorizationEndpoint:'https://engage.nmma.org/services/oauth2/authorize',tokenEndpoint:'/user/oauth/token',clientId:'3MVG9FINO1nsxRuAqq2SfGKT6TFAKhnl86KK20fol9ndkhgtRLbAKbFq1yXwa4ztHWEMRT8K3ga2MjVKw5Dh1'}:{authorizationEndpoint:'https://nmma--staging.sandbox.my.site.com/communityhub/services/oauth2/authorize',tokenEndpoint:'/user/oauth/token',clientId:'3MVG9Fob0S.D_AiRbYaRTQl8lX9Wf9Fq4DXbXTrXQ2dYLcm3m.JMT0j0ubkDQHRR.Ibk97NcriTjDf5qf.ddg'}});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(657)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(200);
var hasOwn = __webpack_require__(659);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(665);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper_tooltip__ = __webpack_require__(669);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Info=function(_React$Component){_inherits(Info,_React$Component);function Info(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Info);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Info.__proto__||Object.getPrototypeOf(Info)).call.apply(_ref,[this].concat(args))),_this),_this.Tooltip=function(_ref2){var getTooltipProps=_ref2.getTooltipProps,tooltipRef=_ref2.tooltipRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',getTooltipProps({ref:tooltipRef,className:'tooltip-container _z_index_20000'}),_this.props.popperElement);},_this.Trigger=function(_ref3){var getTriggerProps=_ref3.getTriggerProps,triggerRef=_ref3.triggerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',getTriggerProps({ref:triggerRef,className:'trigger '+_this.props.triggerWrapperClassName}),_this.props.triggerElement);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Info,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_popper_tooltip__["a" /* default */],{placement:'right-start',trigger:'hover',tooltip:this.Tooltip},this.Trigger);}}]);return Info;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Info.propTypes={triggerElement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,popperElement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,triggerWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Info.defaultProps={triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),triggerWrapperClassName:''};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
var add = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function add(a, b) {
  return Number(a) + Number(b);
});
/* harmony default export */ __webpack_exports__["a"] = (add);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isPlaceholder;
function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curryN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__ = __webpack_require__(139);



/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder_js__["a" /* default */])(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : Object(__WEBPACK_IMPORTED_MODULE_0__arity_js__["a" /* default */])(left, _curryN(length, combined, fn));
  };
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _map;
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(112);




/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
var _isArrayLike = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry1_js__["a" /* default */])(function isArrayLike(x) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== 'object') {
    return false;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(x)) {
    return false;
  }
  if (x.nodeType === 1) {
    return !!x.length;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});
/* harmony default export */ __webpack_exports__["a"] = (_isArrayLike);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
var always = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function always(val) {
  return function () {
    return val;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (always);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
var assoc = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (assoc);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */
var nAry = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function nAry(n, fn) {
  switch (n) {
    case 0:
      return function () {
        return fn.call(this);
      };
    case 1:
      return function (a0) {
        return fn.call(this, a0);
      };
    case 2:
      return function (a0, a1) {
        return fn.call(this, a0, a1);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.call(this, a0, a1, a2);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.call(this, a0, a1, a2, a3);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.call(this, a0, a1, a2, a3, a4);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.call(this, a0, a1, a2, a3, a4, a5);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
      };
    default:
      throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
  }
});
/* harmony default export */ __webpack_exports__["a"] = (nAry);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__liftN_js__ = __webpack_require__(304);



/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
var lift = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function lift(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__liftN_js__["a" /* default */])(fn.length, fn);
});
/* harmony default export */ __webpack_exports__["a"] = (lift);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slice_js__ = __webpack_require__(54);




/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
var tail = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__["a" /* default */])('tail', /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__slice_js__["a" /* default */])(1, Infinity)));
/* harmony default export */ __webpack_exports__["a"] = (tail);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_identity_js__ = __webpack_require__(217);



/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
var identity = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_identity_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (identity);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_toString_js__ = __webpack_require__(314);



/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
var toString = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function toString(val) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_toString_js__["a" /* default */])(val, []);
});
/* harmony default export */ __webpack_exports__["a"] = (toString);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _includesWith;
function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_complement_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_js__ = __webpack_require__(219);




/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var reject = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function reject(pred, filterable) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__filter_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__internal_complement_js__["a" /* default */])(pred), filterable);
});
/* harmony default export */ __webpack_exports__["a"] = (reject);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curryN_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_has_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_xreduceBy_js__ = __webpack_require__(736);






/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */
var reduceBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curryN_js__["a" /* default */])(4, [], /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_4__internal_xreduceBy_js__["a" /* default */], function reduceBy(valueFn, valueAcc, keyFn, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__["a" /* default */])(function (acc, elt) {
    var key = keyFn(elt);
    acc[key] = valueFn(Object(__WEBPACK_IMPORTED_MODULE_2__internal_has_js__["a" /* default */])(key, acc) ? acc[key] : valueAcc, elt);
    return acc;
  }, {}, list);
}));
/* harmony default export */ __webpack_exports__["a"] = (reduceBy);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);



/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
var flip = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function flip(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(fn.length, function (a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});
/* harmony default export */ __webpack_exports__["a"] = (flip);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(46);



/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
var lens = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function lens(getter, setter) {
  return function (toFunctorFn) {
    return function (target) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(function (focus) {
        return setter(focus, target);
      }, toFunctorFn(getter(target)));
    };
  };
});
/* harmony default export */ __webpack_exports__["a"] = (lens);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isObject_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mergeWithKey_js__ = __webpack_require__(225);




/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */
var mergeDeepWithKey = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function mergeDeepWithKey(fn, lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__mergeWithKey_js__["a" /* default */])(function (k, lVal, rVal) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isObject_js__["a" /* default */])(lVal) && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isObject_js__["a" /* default */])(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});
/* harmony default export */ __webpack_exports__["a"] = (mergeDeepWithKey);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(903),
    listCacheDelete = __webpack_require__(904),
    listCacheGet = __webpack_require__(905),
    listCacheHas = __webpack_require__(906),
    listCacheSet = __webpack_require__(907);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(355);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(227),
    getRawTag = __webpack_require__(914),
    objectToString = __webpack_require__(915);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(927);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(17).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(23);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(119)('keys');
var uid = __webpack_require__(78);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(17).document;
module.exports = document && document.documentElement;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(19);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(56)(Function.call, __webpack_require__(59).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(168).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(58);
var defined = __webpack_require__(65);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 172 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var defined = __webpack_require__(65);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(79);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(37);
var hide = __webpack_require__(43);
var Iterators = __webpack_require__(93);
var $iterCreate = __webpack_require__(245);
var setToStringTag = __webpack_require__(91);
var getPrototypeOf = __webpack_require__(84);
var ITERATOR = __webpack_require__(23)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(177);
var defined = __webpack_require__(65);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(64);
var MATCH = __webpack_require__(23)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(23)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(93);
var ITERATOR = __webpack_require__(23)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(31);
var createDesc = __webpack_require__(77);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(105);
var ITERATOR = __webpack_require__(23)('iterator');
var Iterators = __webpack_require__(93);
module.exports = __webpack_require__(27).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(24);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(85);
var step = __webpack_require__(250);
var Iterators = __webpack_require__(93);
var toIObject = __webpack_require__(44);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(175)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(124);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(174)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(56);
var invoke = __webpack_require__(239);
var html = __webpack_require__(167);
var cel = __webpack_require__(163);
var global = __webpack_require__(17);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(64)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(30);
var LIBRARY = __webpack_require__(79);
var $typed = __webpack_require__(130);
var hide = __webpack_require__(43);
var redefineAll = __webpack_require__(96);
var fails = __webpack_require__(18);
var anInstance = __webpack_require__(95);
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(24);
var toIndex = __webpack_require__(258);
var gOPN = __webpack_require__(83).f;
var dP = __webpack_require__(31).f;
var arrayFill = __webpack_require__(182);
var setToStringTag = __webpack_require__(91);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(263)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(580);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(583);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(274);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}




/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(45);
var normalizeHeaderName = __webpack_require__(641);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(279);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(279);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(640)))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(655);
var parse = __webpack_require__(662);
var formats = __webpack_require__(203);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(658);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(135);

var callBind = __webpack_require__(202);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(200);
var GetIntrinsic = __webpack_require__(135);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(676);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 206 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(283);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this)), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isTransformer;
function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_js__ = __webpack_require__(98);



/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */

var prop = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function prop(p, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__path_js__["a" /* default */])([p], obj);
});
/* harmony default export */ __webpack_exports__["a"] = (prop);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_js__ = __webpack_require__(46);





/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
var ap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function ap(applyF, applyX) {
  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
    return applyF(x)(applyX(x));
  } : Object(__WEBPACK_IMPORTED_MODULE_2__internal_reduce_js__["a" /* default */])(function (acc, f) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */])(acc, Object(__WEBPACK_IMPORTED_MODULE_3__map_js__["a" /* default */])(f, applyX));
  }, [], applyF);
});
/* harmony default export */ __webpack_exports__["a"] = (ap);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
/* harmony default export */ __webpack_exports__["a"] = (Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);



/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */
var curry = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function curry(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(fn.length, fn);
});
/* harmony default export */ __webpack_exports__["a"] = (curry);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_makeFlat_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xchain_js__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_js__ = __webpack_require__(46);






/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
var chain = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['fantasy-land/chain', 'chain'], __WEBPACK_IMPORTED_MODULE_3__internal_xchain_js__["a" /* default */], function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function (x) {
      return fn(monad(x))(x);
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__internal_makeFlat_js__["a" /* default */])(false)(Object(__WEBPACK_IMPORTED_MODULE_4__map_js__["a" /* default */])(fn, monad));
}));
/* harmony default export */ __webpack_exports__["a"] = (chain);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */
var type = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipe_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reverse_js__ = __webpack_require__(115);



/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      const classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      const yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return __WEBPACK_IMPORTED_MODULE_0__pipe_js__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__reverse_js__["a" /* default */])(arguments));
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _identity;
function _identity(x) {
  return x;
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isFunction_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isString_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toString_js__ = __webpack_require__(149);






/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */
var concat = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function concat(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArray_js__["a" /* default */])(a)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArray_js__["a" /* default */])(b)) {
      return a.concat(b);
    }
    throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_4__toString_js__["a" /* default */])(b) + ' is not an array');
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__internal_isString_js__["a" /* default */])(a)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_3__internal_isString_js__["a" /* default */])(b)) {
      return a + b;
    }
    throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_4__toString_js__["a" /* default */])(b) + ' is not a string');
  }
  if (a != null && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isFunction_js__["a" /* default */])(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }
  if (a != null && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isFunction_js__["a" /* default */])(a.concat)) {
    return a.concat(b);
  }
  throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_4__toString_js__["a" /* default */])(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
/* harmony default export */ __webpack_exports__["a"] = (concat);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_filter_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isObject_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_xfilter_js__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys_js__ = __webpack_require__(53);








/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var filter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['filter'], __WEBPACK_IMPORTED_MODULE_5__internal_xfilter_js__["a" /* default */], function (pred, filterable) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__internal_isObject_js__["a" /* default */])(filterable) ? Object(__WEBPACK_IMPORTED_MODULE_4__internal_reduce_js__["a" /* default */])(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, Object(__WEBPACK_IMPORTED_MODULE_6__keys_js__["a" /* default */])(filterable)) :
  // else
  Object(__WEBPACK_IMPORTED_MODULE_2__internal_filter_js__["a" /* default */])(pred, filterable);
}));
/* harmony default export */ __webpack_exports__["a"] = (filter);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _filter;
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isObject;
function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adjust_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__always_js__ = __webpack_require__(143);




/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */
var update = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function update(idx, x, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__adjust_js__["a" /* default */])(idx, Object(__WEBPACK_IMPORTED_MODULE_2__always_js__["a" /* default */])(x), list);
});
/* harmony default export */ __webpack_exports__["a"] = (update);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xtake_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice_js__ = __webpack_require__(54);





/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */
var take = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['take'], __WEBPACK_IMPORTED_MODULE_2__internal_xtake_js__["a" /* default */], function take(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice_js__["a" /* default */])(0, n < 0 ? Infinity : n, xs);
}));
/* harmony default export */ __webpack_exports__["a"] = (take);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uniqBy_js__ = __webpack_require__(334);



/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
var uniq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__uniqBy_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (uniq);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);



/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */
var mergeWithKey = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;

  for (k in l) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(k, l)) {
      result[k] = Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(k, r) && !Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(k, result)) {
      result[k] = r[k];
    }
  }

  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (mergeWithKey);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(69);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(69);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CalculatedOutput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatedMultiOutput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CalculatedOutput=function CalculatedOutput(_ref){var value=_ref.value,units=_ref.units,label=_ref.label,color=_ref.color,error=_ref.error,_ref$removeUnderlines=_ref.removeUnderlines,removeUnderlines=_ref$removeUnderlines===undefined?false:_ref$removeUnderlines,_ref$mainWrapperClass=_ref.mainWrapperClassName,mainWrapperClassName=_ref$mainWrapperClass===undefined?'':_ref$mainWrapperClass;if(removeUnderlines&&typeof value==='string')value=value.replace(/_/g,' ');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-output '+mainWrapperClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'output '+(error?'red':color||'green')},(value!==undefined&&value!==null?fixedValue(value):'')+' '+(units||'')),typeof error==='string'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-message'},error));};var CalculatedMultiOutput=function CalculatedMultiOutput(_ref2){var value=_ref2.value,units=_ref2.units,label=_ref2.label,color=_ref2.color,error=_ref2.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-multi-output'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'output '+(error?'red':color||'green')},(value!==undefined&&value!==null?fixedValue(value):'')+' '+(units||'')),typeof error==='string'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-message'},error));};function fixedValue(value){if(value===null)return 0;var dotIndex=value.toString().indexOf('.');if(dotIndex!==-1&&dotIndex+3<value.toString().length)return(+value).toFixed(2);return value;}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(384);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(30) && !__webpack_require__(18)(function () {
  return Object.defineProperty(__webpack_require__(163)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(27);
var LIBRARY = __webpack_require__(79);
var wksExt = __webpack_require__(164);
var defineProperty = __webpack_require__(31).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(42);
var toIObject = __webpack_require__(44);
var arrayIndexOf = __webpack_require__(120)(false);
var IE_PROTO = __webpack_require__(165)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var anObject = __webpack_require__(19);
var getKeys = __webpack_require__(80);

module.exports = __webpack_require__(30) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(44);
var gOPN = __webpack_require__(83).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(30);
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(121);
var pIE = __webpack_require__(104);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(103);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(18)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(57);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(239);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(17).parseInt;
var $trim = __webpack_require__(92).trim;
var ws = __webpack_require__(169);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(17).parseFloat;
var $trim = __webpack_require__(92).trim;

module.exports = 1 / $parseFloat(__webpack_require__(169) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(64);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(82);
var descriptor = __webpack_require__(77);
var setToStringTag = __webpack_require__(91);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(43)(IteratorPrototype, __webpack_require__(23)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(19);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(482);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(57);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(103);
var toLength = __webpack_require__(24);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(24);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(184);
__webpack_require__(2)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(30) && /./g.flags != 'g') __webpack_require__(31).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(124)
});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(79);
var global = __webpack_require__(17);
var ctx = __webpack_require__(56);
var classof = __webpack_require__(105);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(57);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(127);
var speciesConstructor = __webpack_require__(106);
var task = __webpack_require__(186).set;
var microtask = __webpack_require__(502)();
var newPromiseCapabilityModule = __webpack_require__(254);
var perform = __webpack_require__(503);
var userAgent = __webpack_require__(128);
var promiseResolve = __webpack_require__(255);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(23)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(96)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(91)($Promise, PROMISE);
__webpack_require__(94)(PROMISE);
Wrapper = __webpack_require__(27)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(123)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(57);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(254);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(31).f;
var create = __webpack_require__(82);
var redefineAll = __webpack_require__(96);
var ctx = __webpack_require__(56);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(127);
var $iterDefine = __webpack_require__(175);
var step = __webpack_require__(250);
var setSpecies = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(30);
var fastKey = __webpack_require__(72).fastKey;
var validate = __webpack_require__(86);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(96);
var getWeak = __webpack_require__(72).getWeak;
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(127);
var createArrayMethod = __webpack_require__(61);
var $has = __webpack_require__(42);
var validate = __webpack_require__(86);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(24);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(83);
var gOPS = __webpack_require__(121);
var anObject = __webpack_require__(19);
var Reflect = __webpack_require__(17).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(24);
var repeat = __webpack_require__(171);
var defined = __webpack_require__(65);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(30);
var getKeys = __webpack_require__(80);
var toIObject = __webpack_require__(44);
var isEnum = __webpack_require__(104).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_configureStore__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_persist_integration_react__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Routing_RootRouter__ = __webpack_require__(636);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _configureStore=Object(__WEBPACK_IMPORTED_MODULE_2_store_configureStore__["a" /* default */])({}),store=_configureStore.store,persistor=_configureStore.persistor;var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_persist_integration_react__["a" /* PersistGate */],{persistor:persistor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Routing_RootRouter__["a" /* default */],null)))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(265);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(194);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(593);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(271);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(193);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(87);


// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    //if any key is missing in the new state which was present in the lastState,
    //add it for processing too
    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined) {
        keysToProcess.push(key);
      }
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });

    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(87);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(87);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Prompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var historyContext = /*#__PURE__*/createNamedContext("Router-History");

var context = /*#__PURE__*/createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        _this._pendingLocation = location;
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    if (this.unlisten) {
      // Any pre-mount location changes have been captured at
      // this point, so unregister the listener.
      this.unlisten();
    }

    if (!this.props.staticContext) {
      this.unlisten = this.props.history.listen(function (location) {
        if (_this2._isMounted) {
          _this2.setState({
            location: location
          });
        }
      });
    }

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
      this._isMounted = false;
      this._pendingLocation = null;
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && isEmptyChildren(children)) {
        children = null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(197);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(637);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);
var settle = __webpack_require__(642);
var buildURL = __webpack_require__(644);
var parseHeaders = __webpack_require__(645);
var isURLSameOrigin = __webpack_require__(646);
var createError = __webpack_require__(280);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(647);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(643);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(203);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 285 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(287);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(678);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(288);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveConfigurableNames = __webpack_require__(685).functionsHaveConfigurableNames();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, 'name', { value: 'get flags' });
}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(290);

var supportsDescriptors = __webpack_require__(110).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__ = __webpack_require__(8);



/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */
var adjust = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__["a" /* default */])(function adjust(idx, fn, list) {
  if (idx >= list.length || idx < -list.length) {
    return list;
  }
  var start = idx < 0 ? list.length : 0;
  var _idx = start + idx;
  var _list = Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */])(list);
  _list[_idx] = fn(list[_idx]);
  return _list;
});
/* harmony default export */ __webpack_exports__["a"] = (adjust);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xall_js__ = __webpack_require__(699);




/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */
var all = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['all'], __WEBPACK_IMPORTED_MODULE_2__internal_xall_js__["a" /* default */], function all(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (!fn(list[idx])) {
      return false;
    }
    idx += 1;
  }
  return true;
}));
/* harmony default export */ __webpack_exports__["a"] = (all);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _xwrap;
var XWrap = /*#__PURE__*/function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap(fn) {
  return new XWrap(fn);
}

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
var bind = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function bind(fn, thisObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
/* harmony default export */ __webpack_exports__["a"] = (bind);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(40);


var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])('callee', x);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (_isArguments);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */
var and = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function and(a, b) {
  return a && b;
});
/* harmony default export */ __webpack_exports__["a"] = (and);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */
var apply = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function apply(fn, args) {
  return fn.apply(this, args);
});
/* harmony default export */ __webpack_exports__["a"] = (apply);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(53);



/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */
var values = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function values(obj) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});
/* harmony default export */ __webpack_exports__["a"] = (values);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isInteger_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assoc_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isNil_js__ = __webpack_require__(303);







/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */
var assocPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function assocPath(path, val, obj) {
  if (path.length === 0) {
    return val;
  }
  var idx = path[0];
  if (path.length > 1) {
    var nextObj = !Object(__WEBPACK_IMPORTED_MODULE_5__isNil_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(idx, obj) ? obj[idx] : Object(__WEBPACK_IMPORTED_MODULE_3__internal_isInteger_js__["a" /* default */])(path[1]) ? [] : {};
    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__internal_isInteger_js__["a" /* default */])(idx) && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__["a" /* default */])(obj)) {
    var arr = [].concat(obj);
    arr[idx] = val;
    return arr;
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_4__assoc_js__["a" /* default */])(idx, val, obj);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (assocPath);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
var isNil = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function isNil(x) {
  return x == null;
});
/* harmony default export */ __webpack_exports__["a"] = (isNil);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ap_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_js__ = __webpack_require__(46);






/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
var liftN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function liftN(arity, fn) {
  var lifted = Object(__WEBPACK_IMPORTED_MODULE_3__curryN_js__["a" /* default */])(arity, fn);
  return Object(__WEBPACK_IMPORTED_MODULE_3__curryN_js__["a" /* default */])(arity, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__ap_js__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__map_js__["a" /* default */])(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});
/* harmony default export */ __webpack_exports__["a"] = (liftN);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _makeFlat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(142);


/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneRegExp_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_js__ = __webpack_require__(215);



/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */
function _clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx + 1] = value;
    refTo[idx + 1] = copiedValue;
    for (var key in value) {
      copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
    }
    return copiedValue;
  };
  switch (Object(__WEBPACK_IMPORTED_MODULE_1__type_js__["a" /* default */])(value)) {
    case 'Object':
      return copy({});
    case 'Array':
      return copy([]);
    case 'Date':
      return new Date(value.valueOf());
    case 'RegExp':
      return Object(__WEBPACK_IMPORTED_MODULE_0__cloneRegExp_js__["a" /* default */])(value);
    default:
      return value;
  }
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _cloneRegExp;
function _cloneRegExp(pattern) {
                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
var not = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function not(a) {
  return !a;
});
/* harmony default export */ __webpack_exports__["a"] = (not);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_pipe_js__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tail_js__ = __webpack_require__(147);





/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(arguments[0].length, Object(__WEBPACK_IMPORTED_MODULE_2__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_pipe_js__["a" /* default */], arguments[0], Object(__WEBPACK_IMPORTED_MODULE_3__tail_js__["a" /* default */])(arguments)));
}

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = composeK;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chain_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(46);




/**
 * Returns the right-to-left Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipeK
 * @deprecated since v0.26.0
 * @example
 *
 *       //  get :: String -> Object -> Maybe *
 *       const get = R.curry((propName, obj) => Maybe(obj[propName]))
 *
 *       //  getStateCode :: Maybe String -> Maybe String
 *       const getStateCode = R.composeK(
 *         R.compose(Maybe.of, R.toUpper),
 *         get('state'),
 *         get('address'),
 *         get('user'),
 *       );
 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
 *       getStateCode({}); //=> Maybe.Nothing()
 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
 */
function composeK() {
  if (arguments.length === 0) {
    throw new Error('composeK requires at least one argument');
  }
  var init = Array.prototype.slice.call(arguments);
  var last = init.pop();
  return Object(__WEBPACK_IMPORTED_MODULE_1__compose_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__compose_js__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__chain_js__["a" /* default */], init)), last);
}

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipeP;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_pipeP_js__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tail_js__ = __webpack_require__(147);





/**
 * Performs left-to-right composition of one or more Promise-returning
 * functions. The leftmost function may have any arity; the remaining functions
 * must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeP
 * @deprecated since v0.26.0
 * @example
 *
 *      //  followersForUser :: String -> Promise [User]
 *      const followersForUser = R.pipeP(db.getUserById, db.getFollowers);
 */
function pipeP() {
  if (arguments.length === 0) {
    throw new Error('pipeP requires at least one argument');
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(arguments[0].length, Object(__WEBPACK_IMPORTED_MODULE_2__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_pipeP_js__["a" /* default */], arguments[0], Object(__WEBPACK_IMPORTED_MODULE_3__tail_js__["a" /* default */])(arguments)));
}

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__head_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tail_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__identity_js__ = __webpack_require__(148);







/**
 * Performs left-to-right function composition using transforming function. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, f(g, ...args)))
 */
var pipeWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function pipeWith(xf, list) {
  if (list.length <= 0) {
    return __WEBPACK_IMPORTED_MODULE_5__identity_js__["a" /* default */];
  }

  const headList = Object(__WEBPACK_IMPORTED_MODULE_2__head_js__["a" /* default */])(list);
  const tailList = Object(__WEBPACK_IMPORTED_MODULE_4__tail_js__["a" /* default */])(list);

  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(headList.length, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__["a" /* default */])(function (result, f) {
      return xf.call(this, f, result);
    }, headList.apply(this, arguments), tailList);
  });
});
/* harmony default export */ __webpack_exports__["a"] = (pipeWith);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nth_js__ = __webpack_require__(116);


/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
var head = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__nth_js__["a" /* default */])(0);
/* harmony default export */ __webpack_exports__["a"] = (head);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__includes_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quote_js__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toISOString_js__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reject_js__ = __webpack_require__(151);







function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return Object(__WEBPACK_IMPORTED_MODULE_0__includes_js__["a" /* default */])(y, xs) ? '<Circular>' : _toString(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function (obj, keys) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(function (k) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__quote_js__["a" /* default */])(k) + ': ' + recur(obj[k]);
    }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(recur, x).concat(mapPairs(x, Object(__WEBPACK_IMPORTED_MODULE_5__reject_js__["a" /* default */])(function (k) {
        return (/^\d+$/.test(k)
        );
      }, Object(__WEBPACK_IMPORTED_MODULE_4__keys_js__["a" /* default */])(x)))).join(', ') + ']';
    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : Object(__WEBPACK_IMPORTED_MODULE_2__quote_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toISOString_js__["a" /* default */])(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : Object(__WEBPACK_IMPORTED_MODULE_2__quote_js__["a" /* default */])(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, Object(__WEBPACK_IMPORTED_MODULE_4__keys_js__["a" /* default */])(x)).join(', ') + '}';
  }
}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _indexOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__equals_js__ = __webpack_require__(47);


function _indexOf(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__equals_js__["a" /* default */])(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (typeof Object.is === 'function' ? Object.is : _objectIs);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _complement;
function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nAry_js__ = __webpack_require__(145);




/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */
var constructN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function constructN(n, Fn) {
  if (n > 10) {
    throw new Error('Constructor with greater than ten arguments');
  }
  if (n === 0) {
    return function () {
      return new Fn();
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__curry_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__nAry_js__["a" /* default */])(n, function ($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
    switch (arguments.length) {
      case 1:
        return new Fn($0);
      case 2:
        return new Fn($0, $1);
      case 3:
        return new Fn($0, $1, $2);
      case 4:
        return new Fn($0, $1, $2, $3);
      case 5:
        return new Fn($0, $1, $2, $3, $4);
      case 6:
        return new Fn($0, $1, $2, $3, $4, $5);
      case 7:
        return new Fn($0, $1, $2, $3, $4, $5, $6);
      case 8:
        return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
      case 9:
        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
      case 10:
        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
    }
  }));
});
/* harmony default export */ __webpack_exports__["a"] = (constructN);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_map_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__max_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pluck_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reduce_js__ = __webpack_require__(63);







/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
var converge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function converge(after, fns) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__max_js__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_4__pluck_js__["a" /* default */])('length', fns)), function () {
    var args = arguments;
    var context = this;
    return after.apply(context, Object(__WEBPACK_IMPORTED_MODULE_1__internal_map_js__["a" /* default */])(function (fn) {
      return fn.apply(context, args);
    }, fns));
  });
});
/* harmony default export */ __webpack_exports__["a"] = (converge);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */
var defaultTo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function defaultTo(d, v) {
  return v == null || v !== v ? d : v;
});
/* harmony default export */ __webpack_exports__["a"] = (defaultTo);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_Set_js__ = __webpack_require__(322);



/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */
var difference = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function difference(first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  var secondLen = second.length;
  var toFilterOut = new __WEBPACK_IMPORTED_MODULE_1__internal_Set_js__["a" /* default */]();

  for (var i = 0; i < secondLen; i += 1) {
    toFilterOut.add(second[i]);
  }

  while (idx < firstLen) {
    if (toFilterOut.add(first[idx])) {
      out[out.length] = first[idx];
    }
    idx += 1;
  }
  return out;
});
/* harmony default export */ __webpack_exports__["a"] = (difference);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__includes_js__ = __webpack_require__(99);


var _Set = /*#__PURE__*/function () {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  return _Set;
}();

function hasOrAdd(item, shouldAdd, set) {
  var type = typeof item;
  var prevSize, newSize;
  switch (type) {
    case 'string':
    case 'number':
      // distinguish between +0 and -0
      if (item === 0 && 1 / item === -Infinity) {
        if (set._items['-0']) {
          return true;
        } else {
          if (shouldAdd) {
            set._items['-0'] = true;
          }
          return false;
        }
      }
      // these types can all utilise the native Set
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = {};
            set._items[type][item] = true;
          }
          return false;
        } else if (item in set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][item] = true;
          }
          return false;
        }
      }

    case 'boolean':
      // set._items['boolean'] holds a two element array
      // representing [ falseExists, trueExists ]
      if (type in set._items) {
        var bIdx = item ? 1 : 0;
        if (set._items[type][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set._items[type] = item ? [false, true] : [true, false];
        }
        return false;
      }

    case 'function':
      // compare functions for reference equality
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }
          return false;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__includes_js__["a" /* default */])(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }
          return false;
        }
        return true;
      }

    case 'undefined':
      if (set._items[type]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type] = true;
        }
        return false;
      }

    case 'object':
      if (item === null) {
        if (!set._items['null']) {
          if (shouldAdd) {
            set._items['null'] = true;
          }
          return false;
        }
        return true;
      }
    /* falls through */
    default:
      // reduce the search size of heterogeneous sets by creating buckets
      // for each type.
      type = Object.prototype.toString.call(item);
      if (!(type in set._items)) {
        if (shouldAdd) {
          set._items[type] = [item];
        }
        return false;
      }
      // scan through all previously applied items
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__includes_js__["a" /* default */])(item, set._items[type])) {
        if (shouldAdd) {
          set._items[type].push(item);
        }
        return false;
      }
      return true;
  }
}

// A simple Set type that honours R.equals semantics
/* harmony default export */ __webpack_exports__["a"] = (_Set);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__ = __webpack_require__(8);



/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */
var differenceWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__["a" /* default */])(function differenceWith(pred, first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__["a" /* default */])(pred, first[idx], second) && !Object(__WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__["a" /* default */])(pred, first[idx], out)) {
      out.push(first[idx]);
    }
    idx += 1;
  }
  return out;
});
/* harmony default export */ __webpack_exports__["a"] = (differenceWith);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
var dissoc = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (dissoc);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */
var remove = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function remove(start, count, list) {
  var result = Array.prototype.slice.call(list, 0);
  result.splice(start, count);
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (remove);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdrop_js__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice_js__ = __webpack_require__(54);





/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */
var drop = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['drop'], __WEBPACK_IMPORTED_MODULE_2__internal_xdrop_js__["a" /* default */], function drop(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice_js__["a" /* default */])(Math.max(0, n), Infinity, xs);
}));
/* harmony default export */ __webpack_exports__["a"] = (drop);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XDropRepeatsWith = /*#__PURE__*/function () {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XDropRepeatsWith.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return XDropRepeatsWith;
}();

var _xdropRepeatsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xdropRepeatsWith(pred, xf) {
  return new XDropRepeatsWith(pred, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropRepeatsWith);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__last_js__ = __webpack_require__(329);





/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
var dropRepeatsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith_js__["a" /* default */], function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(Object(__WEBPACK_IMPORTED_MODULE_3__last_js__["a" /* default */])(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));
/* harmony default export */ __webpack_exports__["a"] = (dropRepeatsWith);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nth_js__ = __webpack_require__(116);


/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
var last = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__nth_js__["a" /* default */])(-1);
/* harmony default export */ __webpack_exports__["a"] = (last);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */
var or = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function or(a, b) {
  return a || b;
});
/* harmony default export */ __webpack_exports__["a"] = (or);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isArguments_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isObject_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_isString_js__ = __webpack_require__(112);






/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */
var empty = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function empty(x) {
  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__["a" /* default */])(x) ? [] : Object(__WEBPACK_IMPORTED_MODULE_4__internal_isString_js__["a" /* default */])(x) ? '' : Object(__WEBPACK_IMPORTED_MODULE_3__internal_isObject_js__["a" /* default */])(x) ? {} : Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArguments_js__["a" /* default */])(x) ? function () {
    return arguments;
  }() : void 0 // else
  ;
});
/* harmony default export */ __webpack_exports__["a"] = (empty);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drop_js__ = __webpack_require__(326);



/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */
var takeLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function takeLast(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__drop_js__["a" /* default */])(n >= 0 ? xs.length - n : 0, xs);
});
/* harmony default export */ __webpack_exports__["a"] = (takeLast);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);



/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */
var hasPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function hasPath(_path, obj) {
  if (_path.length === 0) {
    return false;
  }
  var val = obj;
  var idx = 0;
  while (idx < _path.length) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(_path[idx], val)) {
      val = val[_path[idx]];
      idx += 1;
    } else {
      return false;
    }
  }
  return true;
});
/* harmony default export */ __webpack_exports__["a"] = (hasPath);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_Set_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
var uniqBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function uniqBy(fn, list) {
  var set = new __WEBPACK_IMPORTED_MODULE_0__internal_Set_js__["a" /* default */]();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (uniqBy);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */
var objOf = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function objOf(key, val) {
  var obj = {};
  obj[key] = val;
  return obj;
});
/* harmony default export */ __webpack_exports__["a"] = (objOf);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */
var is = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function is(Ctor, val) {
  return val != null && val.constructor === Ctor || val instanceof Ctor;
});
/* harmony default export */ __webpack_exports__["a"] = (is);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__converge_js__ = __webpack_require__(319);



/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
var juxt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function juxt(fns) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__converge_js__["a" /* default */])(function () {
    return Array.prototype.slice.call(arguments, 0);
  }, fns);
});
/* harmony default export */ __webpack_exports__["a"] = (juxt);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isNumber_js__ = __webpack_require__(339);



/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */
var length = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function length(list) {
  return list != null && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isNumber_js__["a" /* default */])(list.length) ? list.length : NaN;
});
/* harmony default export */ __webpack_exports__["a"] = (length);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNumber;
function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sum_js__ = __webpack_require__(341);



/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */
var mean = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function mean(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__sum_js__["a" /* default */])(list) / list.length;
});
/* harmony default export */ __webpack_exports__["a"] = (mean);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce_js__ = __webpack_require__(63);



/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
var sum = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__add_js__["a" /* default */], 0);
/* harmony default export */ __webpack_exports__["a"] = (sum);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
var multiply = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function multiply(a, b) {
  return a * b;
});
/* harmony default export */ __webpack_exports__["a"] = (multiply);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString_js__ = __webpack_require__(314);



function _assertPromise(name, p) {
  if (p == null || !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(p.then)) {
    throw new TypeError('`' + name + '` expected a Promise, received ' + Object(__WEBPACK_IMPORTED_MODULE_1__toString_js__["a" /* default */])(p, []));
  }
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


// `Identity` is a functor that holds a single value, where `map` simply
// transforms the held value with the provided function.
var Identity = function (x) {
  return { value: x, map: function (f) {
      return Identity(f(x));
    } };
};

/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */
var over = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function over(lens, f, x) {
  // The value returned by the getter function is first transformed with `f`,
  // then set as the value of an `Identity`. This is then mapped over with the
  // setter function of the lens.
  return lens(function (y) {
    return Identity(f(y));
  })(x).value;
});
/* harmony default export */ __webpack_exports__["a"] = (over);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createPartialApplicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry2_js__ = __webpack_require__(1);



function _createPartialApplicator(concat) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function (fn, args) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arity_js__["a" /* default */])(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultTo_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path_js__ = __webpack_require__(98);




/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */
var pathOr = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function pathOr(d, p, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defaultTo_js__["a" /* default */])(d, Object(__WEBPACK_IMPORTED_MODULE_2__path_js__["a" /* default */])(p, obj));
});
/* harmony default export */ __webpack_exports__["a"] = (pathOr);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
var pickAll = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (pickAll);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */
var prepend = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function prepend(el, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */])([el], list);
});
/* harmony default export */ __webpack_exports__["a"] = (prepend);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);



/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
var useWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function useWith(fn, transformers) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(transformers.length, function () {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});
/* harmony default export */ __webpack_exports__["a"] = (useWith);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */
var reduceRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function reduceRight(fn, acc, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    acc = fn(list[idx], acc);
    idx -= 1;
  }
  return acc;
});
/* harmony default export */ __webpack_exports__["a"] = (reduceRight);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
var times = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});
/* harmony default export */ __webpack_exports__["a"] = (times);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ap_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prepend_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduceRight_js__ = __webpack_require__(350);






/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */
var sequence = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function sequence(of, traversable) {
  return typeof traversable.sequence === 'function' ? traversable.sequence(of) : Object(__WEBPACK_IMPORTED_MODULE_4__reduceRight_js__["a" /* default */])(function (x, acc) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__ap_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__prepend_js__["a" /* default */], x), acc);
  }, of([]), traversable);
});
/* harmony default export */ __webpack_exports__["a"] = (sequence);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */
var uniqWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;
  while (idx < len) {
    item = list[idx];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__["a" /* default */])(pred, item, result)) {
      result[result.length] = item;
    }
    idx += 1;
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (uniqWith);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);



/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */
var where = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function where(spec, testObj) {
  for (var prop in spec) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(prop, spec) && !spec[prop](testObj[prop])) {
      return false;
    }
  }
  return true;
});
/* harmony default export */ __webpack_exports__["a"] = (where);

/***/ }),
/* 355 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(158),
    isObject = __webpack_require__(358);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)))

/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(919),
    mapCacheDelete = __webpack_require__(926),
    mapCacheGet = __webpack_require__(928),
    mapCacheHas = __webpack_require__(929),
    mapCacheSet = __webpack_require__(930);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(931),
    arraySome = __webpack_require__(934),
    cacheHas = __webpack_require__(935);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(69),
    stubFalse = __webpack_require__(952);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(196)(module)))

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(954),
    baseUnary = __webpack_require__(955),
    nodeUtil = __webpack_require__(956);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPLICATION_MODE; });
var APPLICATION_MODE={OPENED:'OPENED',CLOSED:'CLOSED',OPENING:'OPENING',CLOSING:'CLOSING'};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = selectBoatType;
/* harmony export (immutable) */ __webpack_exports__["c"] = selectEngineType;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateBoatDetails;
/* harmony export (immutable) */ __webpack_exports__["d"] = setBoatDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearBoatDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(108);
function selectBoatType(boatType){return function(dispatch){return new Promise(function(resolve){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* BOAT_SELECT_TYPE */],payload:boatType});resolve();});};}function selectEngineType(engineType){return{type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* BOAT_SELECT_ENGINE_TYPE */],payload:engineType};}function updateBoatDetails(payload){return{type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["f" /* BOAT_UPDATE_DETAILS */],payload:payload};}function setBoatDetails(id){return function(dispatch){var payload={};return __WEBPACK_IMPORTED_MODULE_0_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1_api_requests__["a" /* boatAPI */].details(id)).then(function(_ref){var data=_ref.data;payload=data;return Promise.all([__WEBPACK_IMPORTED_MODULE_0_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1_api_requests__["g" /* systemAPI */].getSystemsForBoat(id)),__WEBPACK_IMPORTED_MODULE_0_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1_api_requests__["a" /* boatAPI */].getEnteredCubicCapacity(id)),__WEBPACK_IMPORTED_MODULE_0_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1_api_requests__["a" /* boatAPI */].getFloatationTestReports(id)),__WEBPACK_IMPORTED_MODULE_0_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1_api_requests__["a" /* boatAPI */].getAdditionalDocs(id))]);}).then(function(result){payload.boatSystems=result[0].data;payload.cubicCapacity=result[1].data;payload.floatationCapacity=result[2].data;payload.additionalFiles=result[3].data;return dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* BOAT_SET_DETAILS_SUCCESS */],payload:payload});}).catch(function(error){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* BOAT_SET_DETAILS_ERROR */]});});};}function clearBoatDetails(){return{type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* BOAT_CLEAR_DETAILS */]};}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var applicationStatus=_ref.applicationStatus,boat=_ref.boat,canEdit=_ref.canEdit,canDelete=_ref.canDelete,isFinalReview=_ref.isFinalReview,loadInProgress=_ref.loadInProgress,performAction=_ref.performAction,user=_ref.user;var _getHeaderText=function _getHeaderText(){return boat.boatType?__WEBPACK_IMPORTED_MODULE_4__constants_boatApplication__["e" /* BOAT_TYPE_LIST */].find(function(type){return type.value===boat.boatType;}).name+' Application':'Boat Details';};var _print=function _print(){window.print();};if(loadInProgress)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,_getHeaderText()));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header '+(isFinalReview?'_border_bottom_none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,_getHeaderText()),!isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,canEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].EDIT,boat)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase())),canDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Delete',type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeRed,buttonClassName:'_height_30 _width_90 _margin_left_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].DELETE,boat)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].gray,iconClassName:'button__icon_printer',buttonClassName:'_height_30 _width_40 _margin_left_30',onClick:_print}));});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var boat=_ref.boat,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'ect-spinner__image',style:{width:50,height:50}})));}if(!boat)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Basic info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Boat ID',removeUnderlines:true,value:boat.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Boat Type',removeUnderlines:true,value:boat.boatType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Engine Type',removeUnderlines:true,value:boat.engineType}));});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoatInfo=function(_React$Component){_inherits(BoatInfo,_React$Component);function BoatInfo(){_classCallCheck(this,BoatInfo);return _possibleConstructorReturn(this,(BoatInfo.__proto__||Object.getPrototypeOf(BoatInfo)).apply(this,arguments));}_createClass(BoatInfo,[{key:'render',value:function render(){var _props=this.props,boatSpecifications=_props.boatSpecifications,isFinalReview=_props.isFinalReview,goToStep=_props.goToStep,boatDetailsRequestInProcess=_props.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(boatSpecifications===undefined)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Boat Name',value:boatSpecifications.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Model Year',value:boatSpecifications.year}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Manufacturer Plant',value:boatSpecifications.cityAndStateForCapacityTag}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].BOAT_SPECIFICATIONS,true);}}));}}]);return BoatInfo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var boatSpecifications=_ref.boatSpecifications,dualSteering=_ref.dualSteering,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(!boatSpecifications)return null;var additionalSectionTitle='';if(boatSpecifications.motorType!==undefined)additionalSectionTitle='Motor Specification';else if(boatSpecifications.dieselPower)additionalSectionTitle='Fuel Type';var _getSubType=function _getSubType(){var subType=__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["i" /* ENGINE_SUB_TYPES_NAMES */].find(function(subType){return boatSpecifications.subType===subType.value;});if(subType){return subType.name;}return'';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General info'),boatSpecifications.lengthFeet!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Overall Length',value:[boatSpecifications.lengthFeet,boatSpecifications.lengthInches],units:['Ft.','In.'],decimalDigits:[0,2]}),boatSpecifications.maxBoatBeamFeet!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Max Boat Beam',value:[boatSpecifications.maxBoatBeamFeet,boatSpecifications.maxBoatBeamInches],units:['Ft.','In.'],decimalDigits:[0,2]}),boatSpecifications.inboardLengthFeet!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Inboard Length',value:[boatSpecifications.inboardLengthFeet,boatSpecifications.inboardLengthInches],units:['Ft.','In.'],decimalDigits:[0,2]}),boatSpecifications.inboardArea!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Inboard Area',value:boatSpecifications.inboardArea,units:' Lbs.',decimalDigits:2}),boatSpecifications.bottomContour!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Bottom Contour',value:boatSpecifications.bottomContour,removeUnderlines:true}),boatSpecifications.weightOfFinishedBoat!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Weight of Finished Boat',value:boatSpecifications.weightOfFinishedBoat,units:' Lbs.'}),boatSpecifications.unavInboardArea!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Unavailable Inboard Area',value:boatSpecifications.unavInboardArea,units:' Sq. Ft.',decimalDigits:2}),boatSpecifications.widthFeet!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Overall Stern Width',value:[boatSpecifications.widthFeet,boatSpecifications.widthInches],units:['Ft.','In.'],decimalDigits:[0,2]}),boatSpecifications.transformHeightAtCenterline!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Transom Height at Centerline',value:boatSpecifications.transformHeightAtCenterline,units:' In.',decimalDigits:2}),boatSpecifications.fuelTankCapacity!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Fuel Tank Capacity',value:boatSpecifications.fuelTankCapacity,units:' Gal.',decimalDigits:2}),boatSpecifications.displacement!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Displacement',value:boatSpecifications.displacement,units:' cc'}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].BOAT_SPECIFICATIONS,true);}})),boatSpecifications.transformFlag!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Air Chambers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Transom',value:boatSpecifications.transformFlag?'Yes':'No'}),boatSpecifications.ribFlag!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'RIB',value:boatSpecifications.ribFlag?'Yes':'No'}),boatSpecifications.combinedAirChambersVolume!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Combined Volume of all Air Chambers',value:boatSpecifications.combinedAirChambersVolume,units:' Cu. Ft.',decimalDigits:2}),boatSpecifications.inherentBuoyancyVolume!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Inherent Buoyancy Volume',value:boatSpecifications.inherentBuoyancyVolume,units:' Cu. Ft.',decimalDigits:2}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].BOAT_SPECIFICATIONS,true);}})),boatSpecifications.subType!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Engine'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Motor Type',value:_getSubType()}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].BOAT_SPECIFICATIONS,true);}})),additionalSectionTitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,additionalSectionTitle),boatSpecifications.motorType!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Motor Type',value:boatSpecifications.motorType}),dualSteering!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Dual Steering',value:dualSteering?'Yes':'No'}),boatSpecifications.hasElectricPropulsion!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Electric Propulsion',value:boatSpecifications.hasElectricPropulsion?'Yes':'No'}),boatSpecifications.dieselPower!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Diesel Power Type',value:boatSpecifications.dieselPowerCode}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].BOAT_SPECIFICATIONS,true);}})));});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatSystems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__System__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdditionalSection__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CombinationSection__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoatSystems=function(_React$Component){_inherits(BoatSystems,_React$Component);function BoatSystems(props){_classCallCheck(this,BoatSystems);var _this=_possibleConstructorReturn(this,(BoatSystems.__proto__||Object.getPrototypeOf(BoatSystems)).call(this,props));_this.handleSystemChoose=function(currentSystemIndex){_this.setState({currentSystemIndex:currentSystemIndex});};_this.state={currentSystemIndex:undefined,systemConfigurations:[],allComponents:{},allSystemsList:[],requestInProcess:true};return _this;}_createClass(BoatSystems,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getAvailableBoatSystemsList).then(function(_ref){var allSystemsList=_ref.data;_this2.setState({allSystemsList:allSystemsList});});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this3=this;var _state=this.state,allComponents=_state.allComponents,currentSystemIndex=_state.currentSystemIndex,systemConfigurations=_state.systemConfigurations;var boatSystems=this.props.boatSystems;var requests=[];if(boatSystems.length&&currentSystemIndex===undefined){var _loop=function _loop(system){var ids=[];if(system.ruleValueRequests)system.ruleValueRequests.forEach(function(rule){Object.keys(rule.componentIdWithQuantityMap).forEach(function(id){if(!ids.find(function(element){return element===id;})&&!allComponents[id]){ids.push(id);}});});requests.push(__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getComponent(ids)));requests.push(__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getBoatSystemStructure(system.componentSystemId)));};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=boatSystems[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var system=_step.value;_loop(system);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}Promise.all(requests).then(function(result){for(var i=0,length=result.length;i<length;i++){if(i%2===0){if(result[i].data.length){result[i].data.forEach(function(component){allComponents[component.id]=component;});}}else{systemConfigurations.push(result[i]);}}_this3.setState({allComponents:allComponents,systemConfigurations:systemConfigurations,requestInProcess:false});_this3.handleSystemChoose(0);});}}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,currentSystemIndex=_state2.currentSystemIndex,allComponents=_state2.allComponents,systemConfigurations=_state2.systemConfigurations,allSystemsList=_state2.allSystemsList,requestInProcess=_state2.requestInProcess;var _props=this.props,boatSystems=_props.boatSystems,boatDetailsRequestInProcess=_props.boatDetailsRequestInProcess;if(!boatSystems||!boatSystems.length)return null;if(boatDetailsRequestInProcess)return null;if(requestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section boat-systems-details-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Systems'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section boat-systems-details-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Systems'),this.props.isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_6_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return _this4.props.goToStep(__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["x" /* STEP_ID */].ADD_COMPONENTS,true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-systems-details-section__systems-banners-section final-review'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banners-wrapper'},boatSystems.map(function(system,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__System__["a" /* default */],{key:system.id,isActive:currentSystemIndex===index,system:system,boatSystems:boatSystems,currentSystemIndex:currentSystemIndex,allSystemsList:allSystemsList,indexKey:index,handleSystemChoose:_this4.handleSystemChoose});}))),boatSystems.map(function(system,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__System__["a" /* default */],{key:system.id,isActive:true,isPrintable:true,system:system,boatSystems:boatSystems,currentSystemIndex:currentSystemIndex,allSystemsList:allSystemsList,indexKey:key,handleSystemChoose:_this4.handleSystemChoose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AdditionalSection__["a" /* default */],{system:system,isActive:currentSystemIndex===key,currentSystemConfiguration:systemConfigurations[key]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CombinationSection__["a" /* default */],{system:system,isActive:currentSystemIndex===key,currentSystemConfiguration:systemConfigurations[key],allComponents:allComponents}));}));}}]);return BoatSystems;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var personPowerCapacity=_ref.personPowerCapacity,plateType=_ref.plateType,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(!personPowerCapacity)return null;if(personPowerCapacity.calBoatWeight===undefined)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Weight / Plate Type'),personPowerCapacity.calBoatWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Calculated Boat Weight',value:personPowerCapacity.calBoatWeight,units:' Lbs.',decimalDigits:2}),plateType!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Plate Type',value:plateType,removeUnderlines:true}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].WEIGHT_CAPACITY,true);}}));});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Button__ = __webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var cubicCapacity=_ref.cubicCapacity,boatType=_ref.boatType,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(!cubicCapacity)return null;if(boatDetailsRequestInProcess)return null;if(boatType===__WEBPACK_IMPORTED_MODULE_2_constants_boatApplication__["r" /* PONTOON */]){var tubesKeys=Object.keys(cubicCapacity.tubes);if(!tubesKeys.length)return null;var tubesNumber=cubicCapacity.hasCenterTube?'Three (3)':'Two (2)';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Hull Calculations Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Number of Tubes',value:tubesNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Average of Pontoon Diameter',value:cubicCapacity.calculatedPontoonDiameter,units:' In.',decimalDigits:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Average of Total Pontoon Length',value:cubicCapacity.calculatedPontoonLength,units:' In.',decimalDigits:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Total Volume of All Tubes',value:cubicCapacity.calculatedTubesVolume,units:' Cu. Ft.',decimalDigits:2}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_2_constants_boatApplication__["x" /* STEP_ID */].CUBIC_CAPACITY,true);}}));}else{if(cubicCapacity.cubicCapacity===undefined)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Cubic Capacity Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Calculated Cubic Capacity',value:cubicCapacity.cubicCapacity,units:' Cu. Ft.',decimalDigits:2}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_2_constants_boatApplication__["x" /* STEP_ID */].CUBIC_CAPACITY,true);}}));}});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var personPowerCapacity=_ref.personPowerCapacity,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(!personPowerCapacity)return null;var hasSpecifiedEngineWeight=Number(personPowerCapacity.reqSpecifiedEngineWeight)>0;if(personPowerCapacity.appMaxNumberOfPersons===undefined&&personPowerCapacity.apprMaxHP===undefined&&personPowerCapacity.appMaxWeight===undefined&&personPowerCapacity.apprMaxHPDualSteering===undefined&&!hasSpecifiedEngineWeight)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Approved Person/ Weight Capacities'),personPowerCapacity.appMaxNumberOfPersons!==undefined&&personPowerCapacity.appMaxPersonsWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Approved Max. Persons / Max. Persons Weight',value:[personPowerCapacity.appMaxNumberOfPersons?personPowerCapacity.appMaxNumberOfPersons.toString():'',personPowerCapacity.appMaxPersonsWeight],units:['','Lbs.'],decimalDigits:[0,0]}),personPowerCapacity.appMaxWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Approved Maximum Weight',value:personPowerCapacity.appMaxWeight,units:' Lbs.',decimalDigits:0}),personPowerCapacity.appMaxNumberOfPersons!==undefined&&personPowerCapacity.appMaxPersonsWeight===undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Approved Max. Persons',value:personPowerCapacity.appMaxNumberOfPersons}),personPowerCapacity.apprMaxHPDualSteering!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Approved Maximum Horsepower with Remote Steering',value:personPowerCapacity.apprMaxHPDualSteering,units:' HP',decimalDigits:2}),personPowerCapacity.apprMaxHP!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Approved Maximum Horsepower',value:personPowerCapacity.apprMaxHP,units:' HP'}),hasSpecifiedEngineWeight&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Specified Engine Weight',value:personPowerCapacity.reqSpecifiedEngineWeight,units:' Lbs.',decimalDigits:0}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].WEIGHT_CAPACITY,true);}}));});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var powerCapacity=_ref.powerCapacity,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(!powerCapacity)return null;var value='';if(powerCapacity.maxSpeedLessThan30)value='Less Than 30';else if(powerCapacity.passesTestAtFullPower)value='More Than 30';else value=(+powerCapacity.maneuveringSpeed||0).toFixed(0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Max Power Capacity Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Maneuvering Speed',value:value,units:' Mph',decimalDigits:0}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].POWER_CAPACITY,true);}}));});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_FilePicker__ = __webpack_require__(26);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var floatationCapacity=_ref.floatationCapacity,applicationId=_ref.applicationId,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(!floatationCapacity||!floatationCapacity.files||!floatationCapacity.files.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Flotation Test Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Text__["a" /* default */],{mainWrapperClassName:'_margin_top_30',label:'Date',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(floatationCapacity.testDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_FilePicker__["a" /* default */],{isEditable:false,files:floatationCapacity.files,notEditableStateSectionHeader:'Flotation Test Reports',httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].downloadReport,currentId:applicationId}}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_4_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_5_constants_boatApplication__["x" /* STEP_ID */].FLOATATION_CAPACITY,true);}}));});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_FilePicker__ = __webpack_require__(26);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var additionalFiles=_ref.additionalFiles,applicationId=_ref.applicationId,isFinalReview=_ref.isFinalReview,goToStep=_ref.goToStep,boatDetailsRequestInProcess=_ref.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return null;if(!additionalFiles.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_FilePicker__["a" /* default */],{isEditable:false,files:additionalFiles,notEditableStateSectionHeader:'Additional Documents',httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_1_api_requests__["a" /* boatAPI */].downloadFile,currentId:applicationId}}),isFinalReview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].planeOrange,label:'Edit',buttonClassName:'_height_20 _width_60 _position_absolute _right_130 _font_size_14',fontSize:14,onClick:function onClick(){return goToStep(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["x" /* STEP_ID */].LOAD_DOCUMENTS,true);}}));});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SubHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function SubHeader(_ref){var label=_ref.label,number=_ref.number;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__sub-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__sub-header_number'},number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__sub-header_text'},label));}SubHeader.defaultProps={label:'',number:''};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SubHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function SubHeader(_ref){var label=_ref.label,number=_ref.number;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__sub-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__sub-header_number'},number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__sub-header_text'},label));}SubHeader.defaultProps={label:'',number:''};

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLIANCE_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INSPECTION_WARNING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getComplianceRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getInspectionComplianceRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getComplianceStages; });
/* unused harmony export getComplianceStage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildComplianceWarnings; });
/* unused harmony export getCurrentModelYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildInspectionWarnings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sortComplianceWarnings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_roles__ = __webpack_require__(15);
var _PROGRAMS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var COMPLIANCE_LEVEL={WARNING:0,RENEWAL:1,OVERDUE:2,RESTRICTED:3};var INSPECTION_WARNING_TYPE='INSPECTION';var PROGRAMS=(_PROGRAMS={},_defineProperty(_PROGRAMS,__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName,{name:'Boat/PWC',renewalEndMonth:6,overdueEndMonth:8,dueDate:'June 1st',lockedDate:'August 1st',order:0}),_defineProperty(_PROGRAMS,__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName,{name:'Type Accepted',renewalEndMonth:6,overdueEndMonth:8,dueDate:'June 1st',lockedDate:'August 1st',order:1}),_defineProperty(_PROGRAMS,__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName,{name:'Trailer',renewalEndMonth:8,overdueEndMonth:10,dueDate:'August 1st',lockedDate:'October 1st',order:2}),_PROGRAMS);var dateNumber=function dateNumber(date){return(date.getMonth()+1)*100+date.getDate();};var getComplianceRoles=function getComplianceRoles(user){if(!user||!user.token||user.isInternal()||user.isInspector())return[];return(user.roles||[]).filter(function(role){return PROGRAMS[role];});};var getInspectionComplianceRoles=function getInspectionComplianceRoles(user){return getComplianceRoles(user).filter(function(role){return role===__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName||role===__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName;});};var getComplianceStages=function getComplianceStages(role){var date=arguments.length>1&&arguments[1]!==undefined?arguments[1]:new Date();var program=PROGRAMS[role];if(!program)return[];var currentYear=date.getFullYear();var currentDate=dateNumber(date);var renewalStart=415;var membershipStart=program.renewalEndMonth*100+1;var restrictedStart=program.overdueEndMonth*100+1;if(currentDate>=renewalStart&&currentDate<membershipStart){var renewal={level:COMPLIANCE_LEVEL.RENEWAL,modelYear:currentYear+1};return date.getMonth()<5?[{level:COMPLIANCE_LEVEL.RESTRICTED,modelYear:currentYear},renewal]:[renewal];}if(currentDate>=membershipStart&&currentDate<restrictedStart){return[{level:COMPLIANCE_LEVEL.OVERDUE,modelYear:currentYear+1}];}return[{level:COMPLIANCE_LEVEL.RESTRICTED,modelYear:date.getMonth()<5?currentYear:currentYear+1}];};var getComplianceStage=function getComplianceStage(role){var date=arguments.length>1&&arguments[1]!==undefined?arguments[1]:new Date();return getComplianceStages(role,date)[0]||null;};var getItemType=function getItemType(item){return item.statusType||(item.name||'').toUpperCase();};var getAgreementWarning=function getAgreementWarning(program,level){if(level===COMPLIANCE_LEVEL.RENEWAL){return{title:program.name+' Annual Agreement Reminder',message:'The '+program.name+' Annual Agreement must be signed before '+program.dueDate+'. Failure to do so will suspend your access to ECT system until the signature is completed.'};}var instructions='The '+program.name+' Annual Agreement has not been signed. All Agreements were sent on April 15th. Check your inbox (and spam) on that date for a DocuSign email and follow the link inside that email to electronically sign the Agreement. If you cannot find that email, please contact Lucyna Koscielniak at lkoscielniak@nmma.org.';return{title:program.name+' Annual Agreement Signature Needed',message:level===COMPLIANCE_LEVEL.OVERDUE?instructions+' Please note your ECT account will be locked as of '+program.lockedDate+' due to a lack of a signed agreement.':instructions+' Please note, your ECT account is now locked due to a lack of signed agreement.'};};var getPaymentWarning=function getPaymentWarning(program,level){if(level===COMPLIANCE_LEVEL.RENEWAL){return{title:program.name+' Annual Fee Reminder',message:'The '+program.name+' Annual Certification Fee must be paid before '+program.dueDate+'. Failure to do so will suspend your access to ECT system until the payment is completed.'};}if(level===COMPLIANCE_LEVEL.OVERDUE){return{title:program.name+' Annual Certification Fee Due',message:'The '+program.name+' Annual Certification Fee has not been made. Please contact Lucyna Koscielniak at lkoscielniak@nmma.org for your Annual Fee invoice or check your payment portal for any outstanding fees. Please note your ECT account will be locked as of '+program.lockedDate+' due to non-payment.'};}return{title:program.name+' Annual Certification Fee Due',message:'The '+program.name+' Annual Certification Fee has not been made. Please contact Lucyna Koscielniak at lkoscielniak@nmma.org for your annual fee invoice or check your payment portal for any outstanding fees. Your account will be unlocked once the payment has been made.'};};var buildComplianceWarnings=function buildComplianceWarnings(_ref){var role=_ref.role,checklist=_ref.checklist,_ref$date=_ref.date,date=_ref$date===undefined?new Date():_ref$date,requestedStage=_ref.stage;var program=PROGRAMS[role];var stage=requestedStage||getComplianceStage(role,date);if(!program||!stage||!checklist||!Array.isArray(checklist.itemValues))return[];var warningFactories={AGREEMENT:getAgreementWarning,PAYMENT:getPaymentWarning};var outstandingItems=checklist.itemValues.filter(function(item){return item.isApplicable&&!item.isChecked&&warningFactories[getItemType(item)];});var hasOutstandingAgreement=outstandingItems.some(function(item){return getItemType(item)==='AGREEMENT';});var displayedItems=stage.level===COMPLIANCE_LEVEL.RESTRICTED&&hasOutstandingAgreement?outstandingItems.filter(function(item){return getItemType(item)==='AGREEMENT';}):outstandingItems;return displayedItems.sort(function(left,right){return(getItemType(left)==='AGREEMENT'?-1:1)-(getItemType(right)==='AGREEMENT'?-1:1);}).map(function(item){return Object.assign({},warningFactories[getItemType(item)](program,stage.level),{level:stage.level,modelYear:stage.modelYear,programOrder:program.order,itemType:getItemType(item),role:role});});};var getCurrentModelYear=function getCurrentModelYear(value){var year=Array.isArray(value)?value[1]||value[0]:value;if(year===null||year===undefined||year==='')return null;var numericYear=Number(year);return Number.isFinite(numericYear)?numericYear:null;};var buildInspectionWarnings=function buildInspectionWarnings(_ref2){var role=_ref2.role,inspections=_ref2.inspections,currentModelYear=_ref2.currentModelYear,_ref2$date=_ref2.date,date=_ref2$date===undefined?new Date():_ref2$date;var program=PROGRAMS[role];var modelYear=getCurrentModelYear(currentModelYear);var isInspectionProgram=role===__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName||role===__WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName;if(!program||!isInspectionProgram||!Array.isArray(inspections)||modelYear===null){return[];}var currentTime=date.getTime();var requiresResponse=inspections.some(function(inspection){var approvalTime=inspection.approvalDate?new Date(inspection.approvalDate).getTime():NaN;return Number(inspection.year)===modelYear&&inspection.vresponseRequired===true&&inspection.response&&inspection.response.status!=='COMPLETE'&&Number.isFinite(approvalTime)&&currentTime>=approvalTime+30*24*60*60*1000;});return requiresResponse?[{title:program.name+' Inspection Variation Response Required',message:program.name+' inspection for '+modelYear+' requires a variation response in order to continue your certification.',level:COMPLIANCE_LEVEL.WARNING,modelYear:modelYear,programOrder:program.order,itemType:INSPECTION_WARNING_TYPE,role:role}]:[];};var sortComplianceWarnings=function sortComplianceWarnings(warnings){return warnings.sort(function(left,right){return right.level-left.level||left.programOrder-right.programOrder||(left.itemType==='AGREEMENT'?-1:1)-(right.itemType==='AGREEMENT'?-1:1);});};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(382);
module.exports = __webpack_require__(387);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  __webpack_require__(383).enable();
  window.Promise = __webpack_require__(385);
}

__webpack_require__(386);

Object.assign = __webpack_require__(162);

if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(230);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)))

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(230);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_search_params_polyfill__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_search_params_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_App__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_index_scss__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_index_scss__);
var DB_VERSION=35;__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__app_App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();new __WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__["a" /* default */](DB_VERSION);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(389);

var _global = _interopRequireDefault(__webpack_require__(561));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(390);

__webpack_require__(533);

__webpack_require__(535);

__webpack_require__(538);

__webpack_require__(540);

__webpack_require__(542);

__webpack_require__(544);

__webpack_require__(546);

__webpack_require__(548);

__webpack_require__(550);

__webpack_require__(552);

__webpack_require__(554);

__webpack_require__(556);

__webpack_require__(560);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(391);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(183);
__webpack_require__(496);
__webpack_require__(251);
__webpack_require__(497);
__webpack_require__(252);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(253);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
module.exports = __webpack_require__(27);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(42);
var DESCRIPTORS = __webpack_require__(30);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(37);
var META = __webpack_require__(72).KEY;
var $fails = __webpack_require__(18);
var shared = __webpack_require__(119);
var setToStringTag = __webpack_require__(91);
var uid = __webpack_require__(78);
var wks = __webpack_require__(23);
var wksExt = __webpack_require__(164);
var wksDefine = __webpack_require__(232);
var enumKeys = __webpack_require__(393);
var isArray = __webpack_require__(122);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(35);
var toIObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(71);
var createDesc = __webpack_require__(77);
var _create = __webpack_require__(82);
var gOPNExt = __webpack_require__(235);
var $GOPD = __webpack_require__(59);
var $GOPS = __webpack_require__(121);
var $DP = __webpack_require__(31);
var $keys = __webpack_require__(80);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(83).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(104).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(79)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(43)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(119)('native-function-to-string', Function.toString);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(121);
var pIE = __webpack_require__(104);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(82) });


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperty: __webpack_require__(31).f });


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperties: __webpack_require__(234) });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(44);
var $getOwnPropertyDescriptor = __webpack_require__(59).f;

__webpack_require__(60)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(35);
var $getPrototypeOf = __webpack_require__(84);

__webpack_require__(60)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(35);
var $keys = __webpack_require__(80);

__webpack_require__(60)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(60)('getOwnPropertyNames', function () {
  return __webpack_require__(235).f;
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(60)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(60)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(60)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(60)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(60)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(60)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(236) });


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(237) });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(168).set });


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(105);
var test = {};
test[__webpack_require__(23)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(37)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(238) });


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(30) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(84);
var HAS_INSTANCE = __webpack_require__(23)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(31).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(240);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(241);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var has = __webpack_require__(42);
var cof = __webpack_require__(64);
var inheritIfRequired = __webpack_require__(170);
var toPrimitive = __webpack_require__(71);
var fails = __webpack_require__(18);
var gOPN = __webpack_require__(83).f;
var gOPD = __webpack_require__(59).f;
var dP = __webpack_require__(31).f;
var $trim = __webpack_require__(92).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(82)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(30) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(37)(global, NUMBER, $Number);
}


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(58);
var aNumberValue = __webpack_require__(242);
var repeat = __webpack_require__(171);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(18)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(18);
var aNumberValue = __webpack_require__(242);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(17).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(243) });


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(243);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(241);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(240);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(244);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(172);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(173);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(436) });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(172);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(244) });


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(172) });


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(173);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(173);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(81);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(44);
var toLength = __webpack_require__(24);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(92)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(174)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(175)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(174)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(24);
var context = __webpack_require__(176);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(178)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(176);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(178)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(171)
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(24);
var context = __webpack_require__(176);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(178)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(38)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(38)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(38)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(38)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(38)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(38)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(38)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(38)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(38)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(38)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(38)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(38)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(38)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(71);

$export($export.P + $export.F * __webpack_require__(18)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(471);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(18);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(37)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(23)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(43)(proto, TO_PRIMITIVE, __webpack_require__(474));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(71);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(122) });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(56);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(35);
var call = __webpack_require__(246);
var isArrayIter = __webpack_require__(179);
var toLength = __webpack_require__(24);
var createProperty = __webpack_require__(180);
var getIterFn = __webpack_require__(181);

$export($export.S + $export.F * !__webpack_require__(123)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(180);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(18)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(44);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(103) != Object || !__webpack_require__(50)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(167);
var cof = __webpack_require__(64);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(24);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(18)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(57);
var toObject = __webpack_require__(35);
var fails = __webpack_require__(18);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(50)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(61)(0);
var STRICT = __webpack_require__(50)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(122);
var SPECIES = __webpack_require__(23)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(61)(1);

$export($export.P + $export.F * !__webpack_require__(50)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(61)(2);

$export($export.P + $export.F * !__webpack_require__(50)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(61)(3);

$export($export.P + $export.F * !__webpack_require__(50)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(61)(4);

$export($export.P + $export.F * !__webpack_require__(50)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(248);

$export($export.P + $export.F * !__webpack_require__(50)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(248);

$export($export.P + $export.F * !__webpack_require__(50)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(120)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(50)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(44);
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(24);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(50)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(249) });

__webpack_require__(85)('copyWithin');


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(182) });

__webpack_require__(85)('fill');


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(61)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(85)(KEY);


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(61)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(85)(KEY);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94)('Array');


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var inheritIfRequired = __webpack_require__(170);
var dP = __webpack_require__(31).f;
var gOPN = __webpack_require__(83).f;
var isRegExp = __webpack_require__(177);
var $flags = __webpack_require__(124);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(30) && (!CORRECT_NEW || __webpack_require__(18)(function () {
  re2[__webpack_require__(23)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(37)(global, 'RegExp', $RegExp);
}

__webpack_require__(94)('RegExp');


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(252);
var anObject = __webpack_require__(19);
var $flags = __webpack_require__(124);
var DESCRIPTORS = __webpack_require__(30);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(37)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(18)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var toLength = __webpack_require__(24);
var advanceStringIndex = __webpack_require__(185);
var regExpExec = __webpack_require__(125);

// @@match logic
__webpack_require__(126)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(24);
var toInteger = __webpack_require__(58);
var advanceStringIndex = __webpack_require__(185);
var regExpExec = __webpack_require__(125);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(126)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var sameValue = __webpack_require__(237);
var regExpExec = __webpack_require__(125);

// @@search logic
__webpack_require__(126)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(177);
var anObject = __webpack_require__(19);
var speciesConstructor = __webpack_require__(106);
var advanceStringIndex = __webpack_require__(185);
var toLength = __webpack_require__(24);
var callRegExpExec = __webpack_require__(125);
var regexpExec = __webpack_require__(184);
var fails = __webpack_require__(18);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(126)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var macrotask = __webpack_require__(186).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(64)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(256);
var validate = __webpack_require__(86);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(129)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(256);
var validate = __webpack_require__(86);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(129)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var each = __webpack_require__(61)(0);
var redefine = __webpack_require__(37);
var meta = __webpack_require__(72);
var assign = __webpack_require__(236);
var weak = __webpack_require__(257);
var isObject = __webpack_require__(20);
var validate = __webpack_require__(86);
var NATIVE_WEAK_MAP = __webpack_require__(86);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(129)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(257);
var validate = __webpack_require__(86);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(129)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(130);
var buffer = __webpack_require__(187);
var anObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(81);
var toLength = __webpack_require__(24);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(17).ArrayBuffer;
var speciesConstructor = __webpack_require__(106);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(18)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(94)(ARRAY_BUFFER);


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(130).ABV, {
  DataView: __webpack_require__(187).DataView
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(57);
var anObject = __webpack_require__(19);
var rApply = (__webpack_require__(17).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(18)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(82);
var aFunction = __webpack_require__(57);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var bind = __webpack_require__(238);
var rConstruct = (__webpack_require__(17).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(31);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(71);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(18)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(59).f;
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(19);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(245)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(59);
var getPrototypeOf = __webpack_require__(84);
var has = __webpack_require__(42);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(19);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(59);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(84);
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(19);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(259) });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(19);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(31);
var gOPD = __webpack_require__(59);
var getPrototypeOf = __webpack_require__(84);
var has = __webpack_require__(42);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(77);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(168);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(534);
module.exports = __webpack_require__(27).Array.includes;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(120)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(85)('includes');


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(536);
module.exports = __webpack_require__(27).Array.flatMap;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(537);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(24);
var aFunction = __webpack_require__(57);
var arraySpeciesCreate = __webpack_require__(247);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(85)('flatMap');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(122);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(24);
var ctx = __webpack_require__(56);
var IS_CONCAT_SPREADABLE = __webpack_require__(23)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(539);
module.exports = __webpack_require__(27).String.padStart;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(260);
var userAgent = __webpack_require__(128);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(541);
module.exports = __webpack_require__(27).String.padEnd;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(260);
var userAgent = __webpack_require__(128);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(543);
module.exports = __webpack_require__(27).String.trimLeft;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(92)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(545);
module.exports = __webpack_require__(27).String.trimRight;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(92)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(547);
module.exports = __webpack_require__(164).f('asyncIterator');


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(232)('asyncIterator');


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(549);
module.exports = __webpack_require__(27).Object.getOwnPropertyDescriptors;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(259);
var toIObject = __webpack_require__(44);
var gOPD = __webpack_require__(59);
var createProperty = __webpack_require__(180);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(551);
module.exports = __webpack_require__(27).Object.values;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(261)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(553);
module.exports = __webpack_require__(27).Object.entries;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(261)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(253);
__webpack_require__(555);
module.exports = __webpack_require__(27).Promise['finally'];


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(27);
var global = __webpack_require__(17);
var speciesConstructor = __webpack_require__(106);
var promiseResolve = __webpack_require__(255);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
module.exports = __webpack_require__(27);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(17);
var $export = __webpack_require__(2);
var userAgent = __webpack_require__(128);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(186);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(183);
var getKeys = __webpack_require__(80);
var redefine = __webpack_require__(37);
var global = __webpack_require__(17);
var hide = __webpack_require__(43);
var Iterators = __webpack_require__(93);
var wks = __webpack_require__(23);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(562);
module.exports = __webpack_require__(262).global;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(563);

$export($export.G, { global: __webpack_require__(188) });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(188);
var core = __webpack_require__(262);
var ctx = __webpack_require__(564);
var hide = __webpack_require__(566);
var has = __webpack_require__(573);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(565);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(567);
var createDesc = __webpack_require__(572);
module.exports = __webpack_require__(190) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(568);
var IE8_DOM_DEFINE = __webpack_require__(569);
var toPrimitive = __webpack_require__(571);
var dP = Object.defineProperty;

exports.f = __webpack_require__(190) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(189);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(190) && !__webpack_require__(263)(function () {
  return Object.defineProperty(__webpack_require__(570)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(189);
var document = __webpack_require__(188).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(189);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 573 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = (self.URLSearchParams && self.URLSearchParams.prototype.get) ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        // Fix bug in Edge which cannot encode ' &' correctly
        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
            var ampersandTest = new nativeURLSearchParams();
            ampersandTest.append('s', ' &');
            return ampersandTest.toString() === 's=+%26';
        })() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype['delete'] = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return name in this [__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy)
    /*
     * Apply polifill to global object and append other prototype into it
     */
    Object.defineProperty(self, 'URLSearchParams', {
        value: (useProxy ?
            // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
            new Proxy(nativeURLSearchParams, {
                construct: function(target, args) {
                    return new target((new URLSearchParamsPolyfill(args[0]).toString()));
                }
            }) :
            URLSearchParamsPolyfill)
    });

    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this['delete'](keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            for (var key in search) {
                if (search.hasOwnProperty(key)) {
                    appendTo(dict, key, search[key])
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        )

        if (name in dict) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)))

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(162),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(162),r=__webpack_require__(577);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(578);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(193);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(582);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(270);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(589);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(270);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(271);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(594);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(193);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_persist__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_logger__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_root__ = __webpack_require__(608);
var persistConfig={key:__WEBPACK_IMPORTED_MODULE_5_config__["a" /* default */].store,storage:__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default.a};var loggerConfig={collapsed:true};var persistedReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux_persist__["a" /* persistReducer */])(persistConfig,__WEBPACK_IMPORTED_MODULE_6__reducers_root__["a" /* default */]);var composeEnchancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];/* harmony default export */ __webpack_exports__["a"] = (function(initState){var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(persistedReducer,initState,composeEnchancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_4_redux_thunk__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_3_redux_logger__["createLogger"])(loggerConfig))));var persistor=Object(__WEBPACK_IMPORTED_MODULE_1_redux_persist__["b" /* persistStore */])(store);return{store:store,persistor:persistor};});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(598);
/* unused harmony reexport persistCombineReducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(600);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(601);
/* unused harmony reexport createMigrate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(602);
/* unused harmony reexport createTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(273);
/* unused harmony reexport getStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(272);
/* unused harmony reexport createPersistoid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(274);
/* unused harmony reexport purgeStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(87);
/* unused harmony namespace reexport */











/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(599);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers));
}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
      });
    },
    persist: function persist() {
      store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(87);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(604);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(605);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)))

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boat__ = __webpack_require__(610);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({user:__WEBPACK_IMPORTED_MODULE_1__user__["a" /* default */],boat:__WEBPACK_IMPORTED_MODULE_2__boat__["a" /* default */]}));

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(108);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initState={token:null,redirect:null,firstName:'',lastName:'',roles:[],activeRole:null,selectedManufacturer:null,selectedInspector:null,manufacturer:{},email:''};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["r" /* USER_SIGN_IN_REQUEST */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["s" /* USER_SIGN_IN_SUCCESS */]:return Object.assign({},state,action.payload);case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["q" /* USER_SIGN_IN_ERROR */]:return Object.assign({},state,{token:null});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["n" /* USER_LOG_OUT_REQUEST */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["o" /* USER_LOG_OUT_SUCCESS */]:return Object.assign({},initState,{redirect:initState.redirect});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["m" /* USER_LOG_OUT_ERROR */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["p" /* USER_SAVE_URL */]:return Object.assign({},state,{redirect:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* USER_CLEAR_URL */]:return Object.assign({},state,{redirect:initState.redirect});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["g" /* MENU_CHANGED */]:return Object.assign({},state,{activeRole:action.payload,selectedManufacturer:initState.selectedManufacturer,selectedInspector:initState.selectedInspector});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* SELECT_MANUFACTURER */]:return Object.assign({},state,{selectedManufacturer:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* SELECT_INSPECTOR */]:return Object.assign({},state,{selectedInspector:action.payload,selectedManufacturer:null});case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["k" /* UPDATE_MANUFACTURER */]:{var selectedManufacturer=state.selectedManufacturer?state.selectedManufacturer:{};return Object.assign({},state,{selectedManufacturer:Object.assign({},selectedManufacturer,action.payload)});}case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["j" /* SELECT_YEAR */]:return Object.assign({},state,{selectedYear:Object.assign({},state.selectedYear,_defineProperty({},action.payload.role,action.payload.year))});default:return state;}});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Boat__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Yacht__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Canoe__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Catamaran__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Inflatable__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_JonBoat__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Pontoon__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Pwc__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_SailBoat__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_BaseBoat__ = __webpack_require__(62);
var initState={id:'new',boatType:null,status:'DRAFT',engineType:null,powerCapacity:{},cubicCapacity:{},boatSystems:[],personPowerCapacity:{},bottomContourList:[],engineTypesList:[],engineSubTypesList:[],floatationCapacity:{},boatSpecifications:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];var _createBoat=function _createBoat(data){switch(data.boatType){case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["b" /* BOAT */]:return new __WEBPACK_IMPORTED_MODULE_2__models_Boat__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["B" /* YACHT */]:return new __WEBPACK_IMPORTED_MODULE_3__models_Yacht__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["f" /* CANOE_KAYAK */]:return new __WEBPACK_IMPORTED_MODULE_4__models_Canoe__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["g" /* CATAMARAN */]:return new __WEBPACK_IMPORTED_MODULE_5__models_Catamaran__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["l" /* INFLATABLE */]:return new __WEBPACK_IMPORTED_MODULE_6__models_Inflatable__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["n" /* JON_BOAT */]:return new __WEBPACK_IMPORTED_MODULE_7__models_JonBoat__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["r" /* PONTOON */]:return new __WEBPACK_IMPORTED_MODULE_8__models_Pontoon__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["s" /* PWC */]:return new __WEBPACK_IMPORTED_MODULE_9__models_Pwc__["a" /* default */](data);case __WEBPACK_IMPORTED_MODULE_1__constants_boatApplication__["u" /* SAILBOAT */]:return new __WEBPACK_IMPORTED_MODULE_10__models_SailBoat__["a" /* default */](data);default:return new __WEBPACK_IMPORTED_MODULE_11__models_BaseBoat__["b" /* default */](data);}};var _updateDualSteering=function _updateDualSteering(){if(action.payload.dualSteering===undefined||action.payload.dualSteering===state.dualSteering){return{};}else{return{reqMaxHPDualSteering:action.payload.dualSteering?'':undefined,calcMaxHPDualSteering:action.payload.dualSteering?'':undefined,apprMaxHPDualSteering:action.payload.dualSteering?'':undefined};}};switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["c" /* BOAT_SELECT_TYPE */]:if(action.payload!==state.boatType){return _createBoat(Object.assign({},initState,{boatType:action.payload}));}else{return Object.assign({},state);}case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["b" /* BOAT_SELECT_ENGINE_TYPE */]:if(action.payload!==state.engineType){return _createBoat(Object.assign({},initState,{boatType:state.boatType,engineType:action.payload}));}else{return Object.assign({},state,{engineType:action.payload});}case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["e" /* BOAT_SET_DETAILS_SUCCESS */]:return _createBoat(Object.assign({},action.payload));case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["d" /* BOAT_SET_DETAILS_ERROR */]:case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* BOAT_CLEAR_DETAILS */]:return Object.assign({},initState);case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["f" /* BOAT_UPDATE_DETAILS */]:return Object.assign({},state,action.payload,{personPowerCapacity:Object.assign({},action.payload.personPowerCapacity?action.payload.personPowerCapacity:state.personPowerCapacity,_updateDualSteering())});default:return state;}});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Boat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseBoat__ = __webpack_require__(62);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["b" /* BOAT */],status:'DRAFT',engineType:null,boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var Boat=function Boat(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Boat);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["b" /* BOAT */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.dualSteering=_initDualSteering.call(this,boat);this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_2__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.cubicCapacity=_initCubicCapacity(boat.cubicCapacity);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]},{name:'Round Bilge',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["t" /* ROUND_BILGE */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){var requiredFieldsList=['name','year','lengthFeet','bottomContour','fuelTankCapacity','cityAndStateForCapacityTag'];if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])requiredFieldsList.push('widthFeet','weightOfFinishedBoat','transformHeightAtCenterline');if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */])requiredFieldsList.push('engineAndDriveWeight','weightOfUnfinishedBoat');return requiredFieldsList;}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches,bottomContour:boat.bottomContour||'',fuelTankCapacity:boat.fuelTankCapacity===undefined?'':boat.fuelTankCapacity};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.widthFeet=boat.widthFeet===undefined?'':boat.widthFeet;boatSpecifications.widthInches=boat.widthInches===undefined?'':boat.widthInches;boatSpecifications.weightOfFinishedBoat=boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat;boatSpecifications.transformHeightAtCenterline=boat.transformHeightAtCenterline===undefined?'':boat.transformHeightAtCenterline;boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];boatSpecifications.hasElectricPropulsion=!!boat.hasElectricPropulsion;}if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */]){boatSpecifications.engineAndDriveWeight=boat.engineAndDriveWeight===undefined?'':boat.engineAndDriveWeight;boatSpecifications.weightOfUnfinishedBoat=boat.weightOfUnfinishedBoat===undefined?'':boat.weightOfUnfinishedBoat;boatSpecifications.dieselPower=boat.dieselPower||false;boatSpecifications.dieselPowerCode=boat.dieselPowerCode||'';}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues,preferredTagType:boat.preferredTagType,useManufacturerEngineWeight:boat.useManufacturerEngineWeight};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;capacity.reqSpecifiedEngineWeight=boat.reqSpecifiedEngineWeight!==undefined?boat.reqSpecifiedEngineWeight:boat.specifiedEngineWeight===undefined||boat.specifiedEngineWeight===null?'':boat.specifiedEngineWeight;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_1_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}function _initDualSteering(boat){if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])return undefined;return boat.dualSteering!==undefined?boat.dualSteering:false;}function _initCubicCapacity(boat){var cubicCapacity={};if(boat.areas&&boat.areas.length!==undefined){var loadedAreas={};boat.areas.forEach(function(element){loadedAreas[element.type]=element;});cubicCapacity.areas=loadedAreas;cubicCapacity.isAreas=boat.manualAreas===undefined?false:boat.manualAreas;cubicCapacity.isManual=boat.manualCubicCapacity===undefined?true:boat.manualCubicCapacity;}else if(boat.areas){cubicCapacity.areas=boat.areas;cubicCapacity.isAreas=boat.isAreas===undefined?false:boat.isAreas;cubicCapacity.isManual=boat.isManual===undefined?true:boat.isManual;}else{var _cubicCapacity$areas;cubicCapacity.areas=(_cubicCapacity$areas={},_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].AA_EIGHTH_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].A_QTR_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].B_AMIDSHIPS,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].C_QTR_LENGTH_AFT,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].D_TRANSOM,{}),_cubicCapacity$areas);cubicCapacity.isAreas=false;cubicCapacity.isManual=true;}cubicCapacity.cubicCapacity=boat.cubicCapacity===undefined?'':boat.cubicCapacity;cubicCapacity.calculationLength=boat.calculationLength===undefined?'':boat.calculationLength;cubicCapacity.volumeWithinMotor=boat.volumeWithinMotor===undefined?'':boat.volumeWithinMotor;return cubicCapacity;}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Yacht; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["B" /* YACHT */],status:'DRAFT',engineType:null,boatSpecifications:{},boatSystems:[],floatationCapacity:{},additionalFiles:[]};var Yacht=function Yacht(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Yacht);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["B" /* YACHT */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.boatSpecifications=_initBoatSpecifications(boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.cubicCapacity={};this.personPowerCapacity={};this.powerCapacity=null;this.floatationCapacity={};this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){return['name','year','cityAndStateForCapacityTag','lengthFeet'];}function _initBoatSpecifications(boat){return{name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches};}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Canoe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["f" /* CANOE_KAYAK */],status:'DRAFT',engineType:null,boatSpecifications:{},boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var Canoe=function Canoe(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Canoe);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["f" /* CANOE_KAYAK */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.dualSteering=_initDualSteering.call(this,boat);this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.cubicCapacity={};this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["p" /* NON_POWERED */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){return['name','year','cityAndStateForCapacityTag','lengthFeet','weightOfFinishedBoat','fuelTankCapacity'];}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches,weightOfFinishedBoat:boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat,fuelTankCapacity:boat.fuelTankCapacity===undefined?'':boat.fuelTankCapacity};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];boatSpecifications.hasElectricPropulsion=!!boat.hasElectricPropulsion;}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}function _initDualSteering(boat){if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])return undefined;return boat.dualSteering!==undefined?boat.dualSteering:false;}

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Catamaran; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["g" /* CATAMARAN */],status:'DRAFT',engineType:null,boatSpecifications:{},boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var Catamaran=function Catamaran(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Catamaran);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["g" /* CATAMARAN */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.dualSteering=_initDualSteering.call(this,boat);this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.cubicCapacity=_initCubicCapacity(boat.cubicCapacity||initState.cubicCapacity);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]},{name:'Round Bilge',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["t" /* ROUND_BILGE */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){var requiredFieldsList=['name','year','cityAndStateForCapacityTag','lengthFeet','bottomContour','fuelTankCapacity'];if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])requiredFieldsList.push('widthFeet','weightOfFinishedBoat','transformHeightAtCenterline');if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */])requiredFieldsList.push('engineAndDriveWeight','weightOfUnfinishedBoat');return requiredFieldsList;}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches,bottomContour:boat.bottomContour||'',fuelTankCapacity:boat.fuelTankCapacity===undefined?'':boat.fuelTankCapacity};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.widthFeet=boat.widthFeet===undefined?'':boat.widthFeet;boatSpecifications.widthInches=boat.widthInches===undefined?'':boat.widthInches;boatSpecifications.weightOfFinishedBoat=boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat;boatSpecifications.transformHeightAtCenterline=boat.transformHeightAtCenterline===undefined?'':boat.transformHeightAtCenterline;boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];boatSpecifications.hasElectricPropulsion=!!boat.hasElectricPropulsion;}if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */]){boatSpecifications.engineAndDriveWeight=boat.engineAndDriveWeight===undefined?'':boat.engineAndDriveWeight;boatSpecifications.weightOfUnfinishedBoat=boat.weightOfUnfinishedBoat===undefined?'':boat.weightOfUnfinishedBoat;boatSpecifications.dieselPower=boat.dieselPower||false;boatSpecifications.dieselPowerCode=boat.dieselPowerCode||'';}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}function _initDualSteering(boat){if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])return undefined;return boat.dualSteering!==undefined?boat.dualSteering:false;}function _initCubicCapacity(boat){var cubicCapacity={};if(boat.areas&&boat.areas.length!==undefined){var loadedAreas={};boat.areas.forEach(function(element){loadedAreas[element.type]=element;});cubicCapacity.areas=loadedAreas;cubicCapacity.isAreas=boat.manualAreas===undefined?false:boat.manualAreas;cubicCapacity.isManual=boat.manualCubicCapacity===undefined?true:boat.manualCubicCapacity;}else if(boat.areas){cubicCapacity.areas=boat.areas;cubicCapacity.isAreas=boat.isAreas===undefined?false:boat.isAreas;cubicCapacity.isManual=boat.isManual===undefined?true:boat.isManual;}else{var _cubicCapacity$areas;cubicCapacity.areas=(_cubicCapacity$areas={},_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].AA_EIGHTH_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].A_QTR_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].B_AMIDSHIPS,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].C_QTR_LENGTH_AFT,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].D_TRANSOM,{}),_cubicCapacity$areas);cubicCapacity.isAreas=false;cubicCapacity.isManual=true;}cubicCapacity.cubicCapacity=boat.cubicCapacity===undefined?'':boat.cubicCapacity;cubicCapacity.calculationLength=boat.calculationLength===undefined?'':boat.calculationLength;cubicCapacity.volumeWithinMotor=boat.volumeWithinMotor===undefined?'':boat.volumeWithinMotor;return cubicCapacity;}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inflatable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["l" /* INFLATABLE */],status:'DRAFT',engineType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */],boatSpecifications:{},boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var Inflatable=function Inflatable(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Inflatable);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["l" /* INFLATABLE */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.cubicCapacity={};this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]}];this.engineTypesList=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["m" /* INFLATABLE_ENGINE_TYPES */]));this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){return['name','year','cityAndStateForCapacityTag','lengthFeet','weightOfFinishedBoat','maxBoatBeamFeet','inboardArea','unavInboardArea','inboardLengthFeet','combinedAirChambersVolume','subType'];}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches,weightOfFinishedBoat:boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat,transformFlag:!!boat.transformFlag,ribFlag:boat.ribFlag,maxBoatBeamFeet:boat.maxBoatBeamFeet===undefined?'':boat.maxBoatBeamFeet,maxBoatBeamInches:boat.maxBoatBeamInches===undefined?'':boat.maxBoatBeamInches,inboardArea:boat.inboardArea===undefined?'':boat.inboardArea,unavInboardArea:boat.unavInboardArea===undefined?'':boat.unavInboardArea,inboardLengthFeet:boat.inboardLengthFeet===undefined?'':boat.inboardLengthFeet,inboardLengthInches:boat.inboardLengthInches===undefined?'':boat.inboardLengthInches,combinedAirChambersVolume:boat.combinedAirChambersVolume===undefined?'':boat.combinedAirChambersVolume,inherentBuoyancyVolume:boat.inherentBuoyancyVolume===undefined?'':boat.inherentBuoyancyVolume,subType:boat.subType===undefined?'':boat.subType};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JonBoat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["n" /* JON_BOAT */],status:'DRAFT',engineType:null,boatSpecifications:{},boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var JonBoat=function JonBoat(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,JonBoat);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["n" /* JON_BOAT */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.dualSteering=_initDualSteering.call(this,boat);this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.cubicCapacity=_initCubicCapacity(boat.cubicCapacity||initState.cubicCapacity);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Flat',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["j" /* FLAT */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["p" /* NON_POWERED */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){return['name','year','cityAndStateForCapacityTag','lengthFeet','fuelTankCapacity','widthFeet','weightOfFinishedBoat','transformHeightAtCenterline'];}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches,bottomContour:'FLAT',fuelTankCapacity:boat.fuelTankCapacity===undefined?'':boat.fuelTankCapacity,widthFeet:boat.widthFeet===undefined?'':boat.widthFeet,widthInches:boat.widthInches===undefined?'':boat.widthInches,weightOfFinishedBoat:boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat,transformHeightAtCenterline:boat.transformHeightAtCenterline===undefined?'':boat.transformHeightAtCenterline};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];boatSpecifications.hasElectricPropulsion=!!boat.hasElectricPropulsion;}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}function _initDualSteering(boat){if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])return undefined;return boat.dualSteering!==undefined?boat.dualSteering:false;}function _initCubicCapacity(boat){var cubicCapacity={};if(boat.areas&&boat.areas.length!==undefined){var loadedAreas={};boat.areas.forEach(function(element){loadedAreas[element.type]=element;});cubicCapacity.areas=loadedAreas;cubicCapacity.isAreas=boat.manualAreas===undefined?false:boat.manualAreas;cubicCapacity.isManual=boat.manualCubicCapacity===undefined?true:boat.manualCubicCapacity;}else if(boat.areas){cubicCapacity.areas=boat.areas;cubicCapacity.isAreas=boat.isAreas===undefined?false:boat.isAreas;cubicCapacity.isManual=boat.isManual===undefined?true:boat.isManual;}else{var _cubicCapacity$areas;cubicCapacity.areas=(_cubicCapacity$areas={},_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].AA_EIGHTH_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].A_QTR_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].B_AMIDSHIPS,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].C_QTR_LENGTH_AFT,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].D_TRANSOM,{}),_cubicCapacity$areas);cubicCapacity.isAreas=false;cubicCapacity.isManual=true;}cubicCapacity.cubicCapacity=boat.cubicCapacity===undefined?'':boat.cubicCapacity;cubicCapacity.calculationLength=boat.calculationLength===undefined?'':boat.calculationLength;cubicCapacity.volumeWithinMotor=boat.volumeWithinMotor===undefined?'':boat.volumeWithinMotor;return cubicCapacity;}

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pontoon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["r" /* PONTOON */],status:'DRAFT',engineType:null,boatSpecifications:{},boatSystems:[],cubicCapacity:{tubes:{'PORT':{},'CENTER':{},'STARBOARD':{}},invalidCells:{'PORT':{},'CENTER':{},'STARBOARD':{}},hasCenterTube:false},floatationCapacity:{},additionalFiles:[]};var Pontoon=function Pontoon(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Pontoon);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["r" /* PONTOON */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.cubicCapacity=_initHullCalculations(boat);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["p" /* NON_POWERED */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){var requiredFieldsList=['name','year','cityAndStateForCapacityTag','weightOfFinishedBoat','fuelTankCapacity'];if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */])requiredFieldsList.push('engineAndDriveWeight');if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */])requiredFieldsList.push('transformHeightAtCenterline');return requiredFieldsList;}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',fuelTankCapacity:boat.fuelTankCapacity===undefined?'':boat.fuelTankCapacity,weightOfFinishedBoat:boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];boatSpecifications.hasElectricPropulsion=!!boat.hasElectricPropulsion;}if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */]){boatSpecifications.engineAndDriveWeight=boat.engineAndDriveWeight===undefined?'':boat.engineAndDriveWeight;}if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */]){boatSpecifications.transformHeightAtCenterline=boat.transformHeightAtCenterline===undefined?'':boat.transformHeightAtCenterline;}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues,preferredTagType:boat.preferredTagType,useManufacturerEngineWeight:boat.useManufacturerEngineWeight};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;capacity.reqSpecifiedEngineWeight=boat.reqSpecifiedEngineWeight!==undefined?boat.reqSpecifiedEngineWeight:boat.specifiedEngineWeight===undefined||boat.specifiedEngineWeight===null?'':boat.specifiedEngineWeight;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initHullCalculations(boat){if(!boat.tubes&&boat.cubicCapacity.tubes){return Object.assign({},boat.cubicCapacity);}else if(boat.tubes&&boat.tubes.length){var newCubicCapacity={calculatedPontoonDiameter:boat.avgOfDiameter,calculatedPontoonLength:boat.avgOfTotalLength,calculatedTubesVolume:boat.totalVolumeOfAllTubes,hasCenterTube:boat.hasCenterTube,tubes:{},invalidCells:Object.assign({},initState.cubicCapacity.invalidCells)};boat.tubes.forEach(function(tube){newCubicCapacity.tubes[tube.type]=tube;});return newCubicCapacity;}return{tubes:{'PORT':{},'CENTER':{},'STARBOARD':{}},invalidCells:{'PORT':{},'CENTER':{},'STARBOARD':{}},hasCenterTube:false};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pwc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["s" /* PWC */],engineType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */],status:'DRAFT',boatSpecifications:{},boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var Pwc=function Pwc(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,Pwc);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["s" /* PWC */];this.status=boat.status||initState.status;this.engineType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */];this.plateType=boat.plateType;this.boatSpecifications=_initBoatSpecifications(boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])();this.cubicCapacity={};this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity||boat);this.powerCapacity=null;this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){return['name','year','cityAndStateForCapacityTag','weightOfFinishedBoat','displacement'];}function _initBoatSpecifications(boat){return{name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',weightOfFinishedBoat:boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat,displacement:boat.displacement||''};}function _initPersonPowerCapacity(boat){return{reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SailBoat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBoat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var initState={id:'new',boatType:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["u" /* SAILBOAT */],status:'DRAFT',engineType:null,boatSystems:[],cubicCapacity:{},floatationCapacity:{},additionalFiles:[]};var SailBoat=function SailBoat(){var boat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;_classCallCheck(this,SailBoat);this.id=boat.id||initState.id;this.boatType=__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["u" /* SAILBOAT */];this.status=boat.status||initState.status;this.engineType=boat.engineType;this.plateType=boat.plateType;this.dualSteering=_initDualSteering.call(this,boat);this.boatSpecifications=_initBoatSpecifications.call(this,boat.boatSpecifications||boat);this.boatSystems=Object(__WEBPACK_IMPORTED_MODULE_1__BaseBoat__["a" /* _initBoatSystems */])(boat.boatSystems);this.specificationsRequiredFieldsList=getSpecificationsRequiredFieldsList.call(this);this.cubicCapacity=_initCubicCapacity(boat.cubicCapacity||initState.cubicCapacity);this.personPowerCapacity=_initPersonPowerCapacity.call(this,boat.personPowerCapacity?Object.assign({},boat.personPowerCapacity,{dualSteering:boat.dualSteering}):boat);this.powerCapacity=_initPowerCapacity(boat.powerCapacity||boat);this.floatationCapacity=_initFloatationCapacity(boat.floatationCapacity);this.additionalFiles=boat.additionalFiles?[].concat(_toConsumableArray(boat.additionalFiles)):initState.additionalFiles;this.isFloatationTestReportRequired=boat.boatSpecifications?boat.boatSpecifications.lengthFeet<20:boat.lengthFeet<20;this.bottomContourList=[{name:'Modified V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["o" /* MODIFIED_V */]},{name:'Semi V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["v" /* SEMI_V */]},{name:'Tri Hull',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["y" /* TRI_HULL */]},{name:'V',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["A" /* V */]},{name:'Round Bilge',value:__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["t" /* ROUND_BILGE */]}];this.engineTypesList=[__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */],__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["p" /* NON_POWERED */]];this.engineSubTypesList=[{name:'Up to 6 HP.',value:'SUB_TYPE_1'},{name:'Over 6 HP. and up to 20 HP.',value:'SUB_TYPE_2'},{name:'Over 20 HP. and up to 100 HP.',value:'SUB_TYPE_3'},{name:'Over 100 HP.',value:'SUB_TYPE_4'}];};function getSpecificationsRequiredFieldsList(){var requiredFieldsList=['name','year','cityAndStateForCapacityTag','lengthFeet','bottomContour','fuelTankCapacity'];if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])requiredFieldsList.push('widthFeet','weightOfFinishedBoat','transformHeightAtCenterline');if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */])requiredFieldsList.push('engineAndDriveWeight','weightOfUnfinishedBoat');if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["p" /* NON_POWERED */])requiredFieldsList.push('widthFeet','weightOfFinishedBoat','transformHeightAtCenterline');return requiredFieldsList;}function _initBoatSpecifications(boat){var boatSpecifications={name:boat.name||'',year:boat.year||'',cityAndStateForCapacityTag:boat.cityAndStateForCapacityTag||'',lengthFeet:boat.lengthFeet===undefined?'':boat.lengthFeet,lengthInches:boat.lengthInches===undefined?'':boat.lengthInches,bottomContour:boat.bottomContour||'',fuelTankCapacity:boat.fuelTankCapacity===undefined?'':boat.fuelTankCapacity};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){boatSpecifications.widthFeet=boat.widthFeet===undefined?'':boat.widthFeet;boatSpecifications.widthInches=boat.widthInches===undefined?'':boat.widthInches;boatSpecifications.weightOfFinishedBoat=boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat;boatSpecifications.transformHeightAtCenterline=boat.transformHeightAtCenterline===undefined?'':boat.transformHeightAtCenterline;boatSpecifications.motorType=boat.motorType||__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["w" /* SINGLE */];boatSpecifications.hasElectricPropulsion=!!boat.hasElectricPropulsion;}if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["k" /* INBOARD */]){boatSpecifications.engineAndDriveWeight=boat.engineAndDriveWeight===undefined?'':boat.engineAndDriveWeight;boatSpecifications.weightOfUnfinishedBoat=boat.weightOfUnfinishedBoat===undefined?'':boat.weightOfUnfinishedBoat;boatSpecifications.dieselPower=boat.dieselPower||false;boatSpecifications.dieselPowerCode=boat.dieselPowerCode||'';}if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["p" /* NON_POWERED */]){boatSpecifications.widthFeet=boat.widthFeet===undefined?'':boat.widthFeet;boatSpecifications.widthInches=boat.widthInches===undefined?'':boat.widthInches;boatSpecifications.weightOfFinishedBoat=boat.weightOfFinishedBoat===undefined?'':boat.weightOfFinishedBoat;boatSpecifications.transformHeightAtCenterline=boat.transformHeightAtCenterline===undefined?'':boat.transformHeightAtCenterline;}return boatSpecifications;}function _initPersonPowerCapacity(boat){var capacity={plateType:boat.plateType||'',calBoatWeight:boat.calBoatWeight===undefined?'':boat.calBoatWeight,reqMaxNumberOfPersons:boat.reqMaxNumberOfPersons===undefined?'':boat.reqMaxNumberOfPersons,reqMaxPersonsWeight:boat.reqMaxPersonsWeight===undefined?'':boat.reqMaxPersonsWeight,reqMaxWeight:boat.reqMaxWeight===undefined?'':boat.reqMaxWeight,calMaxNumberOfPersons:boat.calMaxNumberOfPersons===undefined?'':boat.calMaxNumberOfPersons,calMaxPersonsWeight:boat.calMaxPersonsWeight===undefined?'':boat.calMaxPersonsWeight,calMaxWeight:boat.calMaxWeight===undefined?'':boat.calMaxWeight,appMaxWeight:boat.appMaxWeight===undefined?'':boat.appMaxWeight,appMaxNumberOfPersons:boat.appMaxNumberOfPersons===undefined?'':boat.appMaxNumberOfPersons,appMaxPersonsWeight:boat.appMaxPersonsWeight===undefined?'':boat.appMaxPersonsWeight,overrideApprovedValues:boat.overrideApprovedValues};if(this.engineType===__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */]){capacity.reqMaxHP=boat.reqMaxHP===undefined?'':boat.reqMaxHP;capacity.calcMaxHP=boat.calcMaxHP===undefined?'':boat.calcMaxHP;capacity.apprMaxHP=boat.apprMaxHP===undefined?'':boat.apprMaxHP;}if(boat.dualSteering){capacity.reqMaxHPDualSteering=boat.reqMaxHPDualSteering||'';capacity.calcMaxHPDualSteering=boat.calcMaxHPDualSteering||'';capacity.apprMaxHPDualSteering=boat.apprMaxHPDualSteering||'';}return capacity;}function _initPowerCapacity(boat){return{maxSpeedLessThan30:boat.maxSpeedLessThan30!==undefined?boat.maxSpeedLessThan30:true,passesTestAtFullPower:!!boat.passesTestAtFullPower,maneuveringSpeed:boat.maneuveringSpeed===undefined?'':boat.maneuveringSpeed};}function _initFloatationCapacity(floatation){if(floatation&&floatation.length){return{testDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(floatation[0].testDate).utc(),files:floatation};}else{return{};}}function _initDualSteering(boat){if(this.engineType!==__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["q" /* OUTBOARD */])return undefined;return boat.dualSteering!==undefined?boat.dualSteering:false;}function _initCubicCapacity(boat){var cubicCapacity={};if(boat.areas&&boat.areas.length!==undefined){var loadedAreas={};boat.areas.forEach(function(element){loadedAreas[element.type]=element;});cubicCapacity.areas=loadedAreas;cubicCapacity.isAreas=boat.manualAreas===undefined?false:boat.manualAreas;cubicCapacity.isManual=boat.manualCubicCapacity===undefined?true:boat.manualCubicCapacity;}else if(boat.areas){cubicCapacity.areas=boat.areas;cubicCapacity.isAreas=boat.isAreas===undefined?false:boat.isAreas;cubicCapacity.isManual=boat.isManual===undefined?true:boat.isManual;}else{var _cubicCapacity$areas;cubicCapacity.areas=(_cubicCapacity$areas={},_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].AA_EIGHTH_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].A_QTR_LENGTH_FORWARD,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].B_AMIDSHIPS,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].C_QTR_LENGTH_AFT,{}),_defineProperty(_cubicCapacity$areas,__WEBPACK_IMPORTED_MODULE_0_constants_boatApplication__["a" /* AREA_TYPES */].D_TRANSOM,{}),_cubicCapacity$areas);cubicCapacity.isAreas=false;cubicCapacity.isManual=true;}cubicCapacity.cubicCapacity=boat.cubicCapacity===undefined?'':boat.cubicCapacity;cubicCapacity.calculationLength=boat.calculationLength===undefined?'':boat.calculationLength;cubicCapacity.volumeWithinMotor=boat.volumeWithinMotor===undefined?'':boat.volumeWithinMotor;return cubicCapacity;}

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersistGate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(622);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(134);





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(70)))

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(627);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(630)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(633);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Scenes_LoginScene_index__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Scenes_SummaryScene__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Scenes_NotFoundScene__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Scenes_ReportScene__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Scenes_InspectorDashboardScene__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Scenes_DashboardScene__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Scenes_Metrics__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Scenes_OilManufacturer__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Scenes_TrailerManufacturer__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Scenes_ComponentManufacturer__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Scenes_BoatManufacturer__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_Scenes_Inspection__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_Scenes_DocumentsList__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_Components_AnnualComplianceModal__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__annualCompliance__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Header__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Footer__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_constants_routing__ = __webpack_require__(74);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var RootRouter=Object(__WEBPACK_IMPORTED_MODULE_4_HOC_User__["a" /* default */])(_class=function(_React$Component){_inherits(RootRouter,_React$Component);function RootRouter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RootRouter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RootRouter.__proto__||Object.getPrototypeOf(RootRouter)).call.apply(_ref,[this].concat(args))),_this),_this.state={complianceWarnings:[]},_this.getComplianceIdentity=function(user){if(!user||!user.token)return'';return user.token+'|'+user.getManufacturerCode()+'|'+(user.roles||[]).join(',')+'|'+user.isInternal()+'|'+user.isInspector();},_this.scheduleComplianceRefresh=function(){clearTimeout(_this.complianceRefreshTimer);var now=new Date();var tomorrow=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1);var isRestricted=_this.state.complianceWarnings.some(function(warning){return warning.level===__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["a" /* COMPLIANCE_LEVEL */].RESTRICTED;});var refreshDelay=isRestricted?Math.min(5*60*1000,tomorrow.getTime()-now.getTime()+1000):tomorrow.getTime()-now.getTime()+1000;_this.complianceRefreshTimer=setTimeout(function(){_this.loadAnnualComplianceWarnings();_this.scheduleComplianceRefresh();},refreshDelay);},_this.loadAnnualComplianceWarnings=function(){var user=_this.props.user;var roles=Object(__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["e" /* getComplianceRoles */])(user);var requestId=(_this.complianceRequestId||0)+1;_this.complianceRequestId=requestId;if(!roles.length){_this.setState({complianceWarnings:[]});return;}var date=new Date();var complianceRequests=[];roles.forEach(function(role){Object(__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["f" /* getComplianceStages */])(role,date).forEach(function(stage){complianceRequests.push(__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].checkList(role,stage.modelYear)).then(function(_ref2){var checklist=_ref2.data;return Object(__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["c" /* buildComplianceWarnings */])({role:role,checklist:checklist,date:date,stage:stage});}).catch(function(){return[];}));});});Object(__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["g" /* getInspectionComplianceRoles */])(user).forEach(function(role){var isBoat=role===__WEBPACK_IMPORTED_MODULE_23_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName;var currentModelYearAPI=isBoat?__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].currentModelYear:__WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */].currentModelYear;complianceRequests.push(Promise.all([__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(currentModelYearAPI),__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["d" /* inspectionAPI */].inspectionList(isBoat))]).then(function(_ref3){var _ref4=_slicedToArray(_ref3,2),currentModelYear=_ref4[0].data,inspections=_ref4[1].data;return Object(__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["d" /* buildInspectionWarnings */])({role:role,inspections:inspections,currentModelYear:currentModelYear,date:date});}).catch(function(){return[];}));});Promise.all(complianceRequests).then(function(warningLists){var _ref5;if(requestId!==_this.complianceRequestId)return;var warnings=Object(__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["h" /* sortComplianceWarnings */])((_ref5=[]).concat.apply(_ref5,_toConsumableArray(warningLists)));var restrictedWarnings=warnings.filter(function(warning){return warning.level===__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["a" /* COMPLIANCE_LEVEL */].RESTRICTED;});var inspectionWarnings=warnings.filter(function(warning){return warning.itemType===__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["b" /* INSPECTION_WARNING_TYPE */];});_this.setState({complianceWarnings:restrictedWarnings.length?restrictedWarnings.concat(inspectionWarnings):warnings},_this.scheduleComplianceRefresh);});},_this.dismissComplianceWarning=function(){_this.setState(function(_ref6){var complianceWarnings=_ref6.complianceWarnings;return{complianceWarnings:complianceWarnings.slice(1)};});},_this._isUserWithoutOrg=function(){var user=_this.props.user;return(user.isInternal()||user.isInspector())&&!user.isManufacturerSelected();},_this.renderScene=function(Scene){return function(_ref7){var match=_ref7.match;var _this$props=_this.props,user=_this$props.user,location=_this$props.location,history=_this$props.history;var manufacturerCodeFromURL=null;var pathname=location.pathname.split('/');if(pathname.length>2)manufacturerCodeFromURL=pathname[1];var selectedManufacturerCode=user.getManufacturerCode();if(user.token){if(manufacturerCodeFromURL&&manufacturerCodeFromURL!==selectedManufacturerCode&&Scene!==__WEBPACK_IMPORTED_MODULE_11_Scenes_DashboardScene__["a" /* default */]){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].details(manufacturerCodeFromURL)).then(function(_ref8){var data=_ref8.data;return user.selectManufacturer(data,true);});return null;}else if(_this._isUserWithoutOrg()&&Scene!==__WEBPACK_IMPORTED_MODULE_11_Scenes_DashboardScene__["a" /* default */]&&Scene!==__WEBPACK_IMPORTED_MODULE_12_Scenes_Metrics__["a" /* default */]&&Scene!==__WEBPACK_IMPORTED_MODULE_10_Scenes_InspectorDashboardScene__["a" /* default */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:user.getDashboardLink()});}else if(!(user.isInternal()||user.isInspector())&&Scene===__WEBPACK_IMPORTED_MODULE_11_Scenes_DashboardScene__["a" /* default */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:user.getSummaryLink()});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene,{user:user,location:location,history:history,match:match});}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].LOGIN});}};},_this.renderLoginScene=function(){var _this$props2=_this.props,user=_this$props2.user,signIn=_this$props2.signIn;if(user.token){if(user.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:user.redirect});}else if(user.isInternal()||user.isInspector()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:user.getDashboardLink()});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:user.getSummaryLink()});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Scenes_LoginScene_index__["a" /* default */],{signIn:signIn,user:user});},_this.getQueryStringVariable=function(variable){var location=_this.props.location;var query=new URLSearchParams(location.search);return query.get(variable);},_this.clearOAuthParamsFromUrl=function(){var _this$props3=_this.props,location=_this$props3.location,history=_this$props3.history;var cleanPath=location.pathname+location.search.split('?')[0];history.replace(cleanPath);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RootRouter,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,user=_props.user,location=_props.location;if(!user.token&&location.pathname!==__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].LOGIN){user.saveUrlToRedirect(''+location.pathname+location.hash+location.search);}this.loadAnnualComplianceWarnings();this.scheduleComplianceRefresh();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.getComplianceIdentity(prevProps.user)!==this.getComplianceIdentity(this.props.user)){this.loadAnnualComplianceWarnings();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.complianceRefreshTimer);this.complianceRequestId=(this.complianceRequestId||0)+1;}},{key:'render',value:function render(){var _props2=this.props,user=_props2.user,changeMenu=_props2.changeMenu,logOut=_props2.logOut,location=_props2.location;var complianceWarnings=this.state.complianceWarnings;var complianceWarning=complianceWarnings[0];var isComplianceRestricted=!!complianceWarning&&complianceWarning.level===__WEBPACK_IMPORTED_MODULE_20__annualCompliance__["a" /* COMPLIANCE_LEVEL */].RESTRICTED;var error=this.getQueryStringVariable('error');var errorDescription=this.getQueryStringVariable('error_description');if(error){this.clearOAuthParamsFromUrl();var message=(errorDescription||error||'').replace(/\+/g,' ');__WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__["a" /* default */].error(401,message);return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Header__["a" /* default */],{user:user,changeMenu:changeMenu,location:location,logOut:logOut,isComplianceRestricted:isComplianceRestricted}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'ect-root '+(!user.token?'login':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].DASHBOARD,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_11_Scenes_DashboardScene__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].DOCUMENTS,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_18_Scenes_DocumentsList__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].REPORT,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_9_Scenes_ReportScene__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].INSPECTOR_DASHBOARD,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_10_Scenes_InspectorDashboardScene__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].METRICS,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_12_Scenes_Metrics__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].SUMMARY,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_7_Scenes_SummaryScene__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].INSPECTION,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_17_Scenes_Inspection__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].BOAT_MANUFACTURER,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_16_Scenes_BoatManufacturer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].COMPONENT_MANUFACTURER,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_15_Scenes_ComponentManufacturer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].OIL_MANUFACTURER,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_13_Scenes_OilManufacturer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].TRAILER_MANUFACTURER,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_14_Scenes_TrailerManufacturer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:__WEBPACK_IMPORTED_MODULE_24_constants_routing__["d" /* ROUTE */].LOGIN,render:this.renderLoginScene}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:this.renderScene(__WEBPACK_IMPORTED_MODULE_8_Scenes_NotFoundScene__["a" /* default */])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Footer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_Components_AnnualComplianceModal__["a" /* default */],{warning:complianceWarning,warnings:complianceWarnings,onDismiss:this.dismissComplianceWarning}));}}]);return RootRouter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;/* harmony default export */ __webpack_exports__["a"] = (RootRouter);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);
var bind = __webpack_require__(278);
var Axios = __webpack_require__(639);
var defaults = __webpack_require__(198);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(282);
axios.CancelToken = __webpack_require__(653);
axios.isCancel = __webpack_require__(281);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(654);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(198);
var utils = __webpack_require__(45);
var InterceptorManager = __webpack_require__(648);
var dispatchRequest = __webpack_require__(649);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(280);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);
var transformData = __webpack_require__(650);
var isCancel = __webpack_require__(281);
var defaults = __webpack_require__(198);
var isAbsoluteURL = __webpack_require__(651);
var combineURLs = __webpack_require__(652);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(45);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(282);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(656);
var utils = __webpack_require__(284);
var formats = __webpack_require__(203);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(135);
var callBound = __webpack_require__(201);
var inspect = __webpack_require__(660);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(283);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(200);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = __webpack_require__(661).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 661 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(284);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = signIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = logOut;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeMenu;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectManufacturer;
/* harmony export (immutable) */ __webpack_exports__["e"] = selectInspector;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateManufacturer;
/* harmony export (immutable) */ __webpack_exports__["h"] = storeSelectedYear;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveUrlToRedirect;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearUrlToRedirect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(108);
function signIn(_ref,mnfCode){var accessToken=_ref.accessToken;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["r" /* USER_SIGN_IN_REQUEST */]});var infoUrl=mnfCode?__WEBPACK_IMPORTED_MODULE_2_api_requests__["i" /* userAPI */].info+'?mnfCode='+encodeURIComponent(mnfCode):__WEBPACK_IMPORTED_MODULE_2_api_requests__["i" /* userAPI */].info;return __WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(infoUrl,{headers:{Authorization:'Bearer '+accessToken}}).then(function(_ref2){var data=_ref2.data;return dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["s" /* USER_SIGN_IN_SUCCESS */],payload:Object.assign({},data,{token:accessToken})});}).catch(function(error){return dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["q" /* USER_SIGN_IN_ERROR */],payload:error});});};}function logOut(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["n" /* USER_LOG_OUT_REQUEST */]});dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["o" /* USER_LOG_OUT_SUCCESS */]});window.sessionStorage.clear();/* http.post(userAPI.revoke)
      .then(() => {
        dispatch({
          type: USER_LOG_OUT_SUCCESS
        });
        window.sessionStorage.clear();
      })
      .catch((error) => {
        consoleError(error);
        dispatch({
          type: USER_LOG_OUT_ERROR
        });
      }); */};}function changeMenu(role){return{type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* MENU_CHANGED */],payload:role};}function selectManufacturer(manufacturer){return{type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* SELECT_MANUFACTURER */],payload:manufacturer};}function selectInspector(inspector){return{type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* SELECT_INSPECTOR */],payload:inspector};}function updateManufacturer(manufacturer){return{type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* UPDATE_MANUFACTURER */],payload:manufacturer};}function storeSelectedYear(role,year){return{type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* SELECT_YEAR */],payload:{role:[role],year:year}};}function saveUrlToRedirect(url){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["p" /* USER_SAVE_URL */],payload:url});};}function clearUrlToRedirect(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actionTypes__["l" /* USER_CLEAR_URL */],payload:id});};}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LoginPasswordInput__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManufacturerSelect__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_api_communityHubOAuth__ = __webpack_require__(693);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginScene=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(LoginScene,_React$Component);function LoginScene(props){var _this2=this;_classCallCheck(this,LoginScene);var _this=_possibleConstructorReturn(this,(LoginScene.__proto__||Object.getPrototypeOf(LoginScene)).call(this,props));_this.getRedirectUri=function(){return window.location.origin+'/';};_this.clearOAuthParamsFromUrl=function(){var _this$props=_this.props,history=_this$props.history,location=_this$props.location;history.replace(location.pathname);};_this.handleOAuthCallback=function(_ref){var code=_ref.code,returnedState=_ref.returnedState;var redirectUri=_this.getRedirectUri();_this.setState({requestInProcess:true},function(){Promise.resolve().then(function(){var codeVerifier=Object(__WEBPACK_IMPORTED_MODULE_9_api_communityHubOAuth__["b" /* consumePkceVerifierForState */])(returnedState);return Object(__WEBPACK_IMPORTED_MODULE_9_api_communityHubOAuth__["c" /* exchangeCodeForToken */])({tokenEndpoint:__WEBPACK_IMPORTED_MODULE_5_config__["a" /* default */].communityHub.tokenEndpoint,redirectUri:redirectUri,code:code,codeVerifier:codeVerifier});}).then(function(_ref2){var data=_ref2.data;var accessToken=data.access_token;if(!accessToken)throw new Error('Missing access token from token response');// Fetch userInfo to get AccountID (NOT in token response)
return __WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["i" /* userAPI */].info,{headers:{Authorization:'Bearer '+accessToken}}).then(function(_ref3){var userInfo=_ref3.data;var accountId=userInfo&&userInfo.id;if(!accountId)throw new Error('Unable to determine AccountID from userInfo');_this.setState({oauthAccessToken:accessToken});// Use AccountID to look up manufacturers
return __WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["i" /* userAPI */].getManufacturersByAccountId({accountId:accountId}),{headers:{Authorization:'Bearer '+accessToken}});});}).then(function(_ref4){var manufacturerList=_ref4.data;_this.clearOAuthParamsFromUrl();if(!manufacturerList||manufacturerList.length<2){return _this.props.signIn({accessToken:_this.state.oauthAccessToken}).finally(function(){return _this.setState({requestInProcess:false});});}_this.setState({mode:'manufacturerSelect',manufacturerList:manufacturerList,requestInProcess:false});}).catch(function(err){_this.setState({requestInProcess:false});var message=err&&err.response&&err.response.data&&(err.response.data.error_description||err.response.data.error)||err&&err.message||'OAuth login failed';__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error(401,String(message).replace(/\+/g,' '));});});};_this.handleSignInClick=function(event){event.preventDefault();if(event.nativeEvent)event.nativeEvent.preventDefault();var _this$state=_this.state,mode=_this$state.mode,oauthAccessToken=_this$state.oauthAccessToken;if(mode==='manufacturerSelect'){_this.setState({requestInProcess:true},function(){_this.props.signIn({accessToken:oauthAccessToken},event.mnfCode).finally(function(){return _this.setState({requestInProcess:false});});});return;}var redirectUri=_this.getRedirectUri();_this.setState({requestInProcess:true},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var authorizeUrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_9_api_communityHubOAuth__["a" /* buildAuthorizeUrl */])({authorizationEndpoint:__WEBPACK_IMPORTED_MODULE_5_config__["a" /* default */].communityHub.authorizationEndpoint,clientId:__WEBPACK_IMPORTED_MODULE_5_config__["a" /* default */].communityHub.clientId,redirectUri:redirectUri});case 3:authorizeUrl=_context.sent;window.location.assign(authorizeUrl);_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](0);_this.setState({requestInProcess:false});__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error(500,_context.t0&&_context.t0.message?_context.t0.message:'Unable to start OAuth login');case 11:case'end':return _context.stop();}}},_callee,_this2,[[0,7]]);})));};_this.state={mode:'none',// 'none' | 'manufacturerSelect'
manufacturerList:[],requestInProcess:false,oauthAccessToken:null,oauthUserId:null};return _this;}_createClass(LoginScene,[{key:'componentDidMount',value:function componentDidMount(){var code=this.getQueryStringVariable('code');var returnedState=this.getQueryStringVariable('state');var error=this.getQueryStringVariable('error');if(error){this.clearOAuthParamsFromUrl();__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error(401,error);return;}if(code){// Run callback processing automatically.
this.handleOAuthCallback({code:code,returnedState:returnedState});}}},{key:'getQueryStringVariable',value:function getQueryStringVariable(variable){var urlParams=new URLSearchParams(this.props.location.search);return urlParams.get(variable);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,mode=_state.mode,manufacturerList=_state.manufacturerList,requestInProcess=_state.requestInProcess;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('main',{className:'login-scene'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('figure',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fields-wrapper'},mode==='none'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LoginPasswordInput__["a" /* default */],{requestInProcess:requestInProcess,handleSignInClick:this.handleSignInClick}),mode==='manufacturerSelect'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ManufacturerSelect__["a" /* default */],{toggleMode:function toggleMode(){return _this3.setState({mode:'none'});},handleSignInClick:this.handleSignInClick,requestInProcess:requestInProcess,manufacturerList:manufacturerList}))));}}]);return LoginScene;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component))||_class;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(666);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 666 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Button__ = __webpack_require__(6);
/**
 * Components
 *//* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSignInClick=_ref.handleSignInClick,requestInProcess=_ref.requestInProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSignInClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Sign in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'Sign in with NMMA Member Portal',formButtonType:'submit',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_330 login-button',type:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["b" /* buttonType */].primary})));});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManufacturerSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Select__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var ManufacturerSelect=function(_React$Component){_inherits(ManufacturerSelect,_React$Component);function ManufacturerSelect(props){_classCallCheck(this,ManufacturerSelect);var _this=_possibleConstructorReturn(this,(ManufacturerSelect.__proto__||Object.getPrototypeOf(ManufacturerSelect)).call(this,props));_this.handleSelect=function(manufacturer){_this.setState({manufacturer:manufacturer});};_this.handleSignInClick=function(event){var manufacturer=_this.state.manufacturer;var handleSignInClick=_this.props.handleSignInClick;event.preventDefault();if(event.nativeEvent)event.nativeEvent.preventDefault();if(manufacturer){event.mnfCode=manufacturer.code;handleSignInClick(event);}};_this.state={manufacturer:null};return _this;}_createClass(ManufacturerSelect,[{key:'render',value:function render(){var _props=this.props,manufacturerList=_props.manufacturerList,toggleMode=_props.toggleMode,requestInProcess=_props.requestInProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'manufacturer-select-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSignInClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Sign In as'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reminder'},'Your account is linked to multiple organizations. Please select the one you would like to log in to:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Select__["a" /* default */],{selectionList:manufacturerList,type:__WEBPACK_IMPORTED_MODULE_2__Components_Select__["b" /* selectType */].primary,inputClassName:'_margin_top_0 _margin_bottom_20',iconClassName:'_top_12',dropDownClassName:'_top_39',placeholder:'Select organization',itemNameIndicator:'name',handleSelect:this.handleSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'Back',buttonClassName:'_height_40 _width_120',color:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["a" /* buttonColor */].gray,type:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["b" /* buttonType */].secondary,onClick:toggleMode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'Login',formButtonType:'submit',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_120',type:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["b" /* buttonType */].primary}))));}}]);return ManufacturerSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_popper__ = __webpack_require__(673);









var TooltipContext = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createContext({}); // eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var callAll = function callAll() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};
var noop = function noop() {// do nothing
};
var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
var setRef = function setRef(ref, node) {
  if (typeof ref === 'function') {
    return ref(node);
  } else if (ref != null) {
    ref.current = node;
  }
};

var Tooltip = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Tooltip, _Component);

  function Tooltip() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.observer = void 0;
    _this.tooltipRef = void 0;

    _this.handleOutsideClick = function (event) {
      if (_this.tooltipRef && !_this.tooltipRef.contains(event.target)) {
        var parentOutsideClickHandler = _this.context.parentOutsideClickHandler;
        var _this$props = _this.props,
            hideTooltip = _this$props.hideTooltip,
            clearScheduled = _this$props.clearScheduled;
        clearScheduled();
        hideTooltip();

        if (parentOutsideClickHandler) {
          parentOutsideClickHandler(event);
        }
      }
    };

    _this.handleOutsideRightClick = function (event) {
      if (_this.tooltipRef && !_this.tooltipRef.contains(event.target)) {
        var parentOutsideRightClickHandler = _this.context.parentOutsideRightClickHandler;
        var _this$props2 = _this.props,
            hideTooltip = _this$props2.hideTooltip,
            clearScheduled = _this$props2.clearScheduled;
        clearScheduled();
        hideTooltip();

        if (parentOutsideRightClickHandler) {
          parentOutsideRightClickHandler(event);
        }
      }
    };

    _this.addOutsideClickHandler = function () {
      document.body.addEventListener('touchend', _this.handleOutsideClick);
      document.body.addEventListener('click', _this.handleOutsideClick);
    };

    _this.removeOutsideClickHandler = function () {
      document.body.removeEventListener('touchend', _this.handleOutsideClick);
      document.body.removeEventListener('click', _this.handleOutsideClick);
    };

    _this.addOutsideRightClickHandler = function () {
      return document.body.addEventListener('contextmenu', _this.handleOutsideRightClick);
    };

    _this.removeOutsideRightClickHandler = function () {
      return document.body.removeEventListener('contextmenu', _this.handleOutsideRightClick);
    };

    _this.getTooltipRef = function (node) {
      _this.tooltipRef = node;
      setRef(_this.props.innerRef, node);
    };

    _this.getArrowProps = function (props) {
      if (props === void 0) {
        props = {};
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props.style, {}, _this.props.arrowProps.style)
      });
    };

    _this.getTooltipProps = function (props) {
      if (props === void 0) {
        props = {};
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {}, _this.isTriggeredBy('hover') && {
        onMouseEnter: callAll(_this.props.clearScheduled, props.onMouseEnter),
        onMouseLeave: callAll(_this.props.hideTooltip, props.onMouseLeave)
      }, {
        style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props.style, {}, _this.props.style)
      });
    };

    _this.contextValue = {
      isParentNoneTriggered: _this.props.trigger === 'none',
      addParentOutsideClickHandler: _this.addOutsideClickHandler,
      addParentOutsideRightClickHandler: _this.addOutsideRightClickHandler,
      parentOutsideClickHandler: _this.handleOutsideClick,
      parentOutsideRightClickHandler: _this.handleOutsideRightClick,
      removeParentOutsideClickHandler: _this.removeOutsideClickHandler,
      removeParentOutsideRightClickHandler: _this.removeOutsideRightClickHandler
    };
    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var observer = this.observer = new MutationObserver(function () {
      _this2.props.scheduleUpdate();
    });
    observer.observe(this.tooltipRef, this.props.mutationObserverOptions);

    if (this.isTriggeredBy('hover') || this.isTriggeredBy('click') || this.isTriggeredBy('right-click')) {
      var _this$context = this.context,
          removeParentOutsideClickHandler = _this$context.removeParentOutsideClickHandler,
          removeParentOutsideRightClickHandler = _this$context.removeParentOutsideRightClickHandler;
      this.addOutsideClickHandler();
      this.addOutsideRightClickHandler();

      if (removeParentOutsideClickHandler) {
        removeParentOutsideClickHandler();
      }

      if (removeParentOutsideRightClickHandler) {
        removeParentOutsideRightClickHandler();
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.closeOnOutOfBoundaries && this.props.outOfBoundaries) {
      this.props.hideTooltip();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.isTriggeredBy('hover') || this.isTriggeredBy('click') || this.isTriggeredBy('right-click')) {
      var _this$context2 = this.context,
          isParentNoneTriggered = _this$context2.isParentNoneTriggered,
          addParentOutsideClickHandler = _this$context2.addParentOutsideClickHandler,
          addParentOutsideRightClickHandler = _this$context2.addParentOutsideRightClickHandler;
      this.removeOutsideClickHandler();
      this.removeOutsideRightClickHandler();
      this.handleOutsideClick = undefined;
      this.handleOutsideRightClick = undefined;

      if (!isParentNoneTriggered && addParentOutsideClickHandler) {
        addParentOutsideClickHandler();
      }

      if (!isParentNoneTriggered && addParentOutsideRightClickHandler) {
        addParentOutsideRightClickHandler();
      }
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        arrowProps = _this$props3.arrowProps,
        placement = _this$props3.placement,
        tooltip = _this$props3.tooltip;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TooltipContext.Provider, {
      value: this.contextValue
    }, tooltip({
      arrowRef: arrowProps.ref,
      getArrowProps: this.getArrowProps,
      getTooltipProps: this.getTooltipProps,
      placement: placement,
      tooltipRef: this.getTooltipRef
    }));
  };

  _proto.isTriggeredBy = function isTriggeredBy(event) {
    var trigger = this.props.trigger;
    return trigger === event || Array.isArray(trigger) && trigger.includes(event);
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.contextType = TooltipContext;

var DEFAULT_MODIFIERS = {
  preventOverflow: {
    boundariesElement: 'viewport'
  }
};
var DEFAULT_MUTATION_OBSERVER_CONFIG = {
  childList: true,
  subtree: true
};

var TooltipTrigger = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TooltipTrigger, _Component);

  function TooltipTrigger() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      tooltipShown: _this.props.defaultTooltipShown
    };
    _this.hideTimeout = void 0;
    _this.showTimeout = void 0;
    _this.popperOffset = void 0;

    _this.setTooltipState = function (state) {
      var cb = function cb() {
        return _this.props.onVisibilityChange(state.tooltipShown);
      };

      _this.isControlled() ? cb() : _this.setState(state, cb);
    };

    _this.clearScheduled = function () {
      clearTimeout(_this.hideTimeout);
      clearTimeout(_this.showTimeout);
    };

    _this.showTooltip = function (_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY;

      _this.clearScheduled();

      var state = {
        tooltipShown: true
      };

      if (_this.props.followCursor) {
        state = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          pageX: pageX,
          pageY: pageY
        });
      }

      _this.showTimeout = window.setTimeout(function () {
        return _this.setTooltipState(state);
      }, _this.props.delayShow);
    };

    _this.hideTooltip = function () {
      _this.clearScheduled();

      _this.hideTimeout = window.setTimeout(function () {
        return _this.setTooltipState({
          tooltipShown: false
        });
      }, _this.props.delayHide);
    };

    _this.toggleTooltip = function (_ref2) {
      var pageX = _ref2.pageX,
          pageY = _ref2.pageY;
      var action = _this.getState() ? 'hideTooltip' : 'showTooltip';

      _this[action]({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.clickToggle = function (event) {
      event.preventDefault();
      var pageX = event.pageX,
          pageY = event.pageY;
      var action = _this.props.followCursor ? 'showTooltip' : 'toggleTooltip';

      _this[action]({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.contextMenuToggle = function (event) {
      event.preventDefault();
      var pageX = event.pageX,
          pageY = event.pageY;
      var action = _this.props.followCursor ? 'showTooltip' : 'toggleTooltip';

      _this[action]({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.getTriggerProps = function (props) {
      if (props === void 0) {
        props = {};
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {}, _this.isTriggeredBy('click') && {
        onClick: callAll(_this.clickToggle, props.onClick),
        onTouchEnd: callAll(_this.clickToggle, props.onTouchEnd)
      }, {}, _this.isTriggeredBy('right-click') && {
        onContextMenu: callAll(_this.contextMenuToggle, props.onContextMenu)
      }, {}, _this.isTriggeredBy('hover') && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        onMouseEnter: callAll(_this.showTooltip, props.onMouseEnter),
        onMouseLeave: callAll(_this.hideTooltip, props.onMouseLeave)
      }, _this.props.followCursor && {
        onMouseMove: callAll(_this.showTooltip, props.onMouseMove)
      }), {}, _this.isTriggeredBy('focus') && {
        onFocus: callAll(_this.showTooltip, props.onFocus),
        onBlur: callAll(_this.hideTooltip, props.onBlur)
      });
    };

    return _this;
  }

  var _proto = TooltipTrigger.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearScheduled();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        tooltip = _this$props.tooltip,
        placement = _this$props.placement,
        trigger = _this$props.trigger,
        getTriggerRef = _this$props.getTriggerRef,
        modifiers = _this$props.modifiers,
        closeOnOutOfBoundaries = _this$props.closeOnOutOfBoundaries,
        usePortal = _this$props.usePortal,
        portalContainer = _this$props.portalContainer,
        followCursor = _this$props.followCursor,
        getTooltipRef = _this$props.getTooltipRef,
        mutationObserverOptions = _this$props.mutationObserverOptions,
        restProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "tooltip", "placement", "trigger", "getTriggerRef", "modifiers", "closeOnOutOfBoundaries", "usePortal", "portalContainer", "followCursor", "getTooltipRef", "mutationObserverOptions"]);

    var popper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["b" /* Popper */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      innerRef: getTooltipRef,
      placement: placement,
      modifiers: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, DEFAULT_MODIFIERS, {}, followCursor && {
        followCursorModifier: {
          enabled: true,
          fn: function fn(data) {
            _this2.popperOffset = data.offsets.popper;
            return data;
          },
          order: 1000
        }
      }, {}, modifiers)
    }, restProps), function (_ref3) {
      var ref = _ref3.ref,
          style = _ref3.style,
          placement = _ref3.placement,
          arrowProps = _ref3.arrowProps,
          outOfBoundaries = _ref3.outOfBoundaries,
          scheduleUpdate = _ref3.scheduleUpdate;

      if (followCursor && _this2.popperOffset) {
        var _this2$state = _this2.state,
            pageX = _this2$state.pageX,
            pageY = _this2$state.pageY;
        var _this2$popperOffset = _this2.popperOffset,
            width = _this2$popperOffset.width,
            height = _this2$popperOffset.height;
        var x = pageX + width > window.scrollX + document.body.offsetWidth ? pageX - width : pageX;
        var y = pageY + height > window.scrollY + document.body.offsetHeight ? pageY - height : pageY;
        style.transform = "translate3d(" + x + "px, " + y + "px, 0";
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tooltip, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        arrowProps: arrowProps,
        closeOnOutOfBoundaries: closeOnOutOfBoundaries,
        outOfBoundaries: outOfBoundaries,
        placement: placement,
        scheduleUpdate: scheduleUpdate,
        style: style,
        tooltip: tooltip,
        trigger: trigger,
        mutationObserverOptions: mutationObserverOptions
      }, {
        clearScheduled: _this2.clearScheduled,
        hideTooltip: _this2.hideTooltip,
        innerRef: ref
      }));
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["a" /* Manager */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["c" /* Reference */], {
      innerRef: getTriggerRef
    }, function (_ref4) {
      var ref = _ref4.ref;
      return children({
        getTriggerProps: _this2.getTriggerProps,
        triggerRef: ref
      });
    }), this.getState() && (usePortal ? Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"])(popper, portalContainer) : popper));
  };

  _proto.isControlled = function isControlled() {
    return this.props.tooltipShown !== undefined;
  };

  _proto.getState = function getState() {
    return this.isControlled() ? this.props.tooltipShown : this.state.tooltipShown;
  };

  _proto.isTriggeredBy = function isTriggeredBy(event) {
    var trigger = this.props.trigger;
    return trigger === event || Array.isArray(trigger) && trigger.includes(event);
  };

  return TooltipTrigger;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

TooltipTrigger.defaultProps = {
  closeOnOutOfBoundaries: true,
  defaultTooltipShown: false,
  delayHide: 0,
  delayShow: 0,
  followCursor: false,
  onVisibilityChange: noop,
  placement: 'right',
  portalContainer: canUseDOM() ? document.body : null,
  trigger: 'hover',
  usePortal: canUseDOM(),
  mutationObserverOptions: DEFAULT_MUTATION_OBSERVER_CONFIG
};

/* harmony default export */ __webpack_exports__["a"] = (TooltipTrigger);
//# sourceMappingURL=react-popper-tooltip.js.map


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(267);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(293);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 676 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(286);
var isArguments = __webpack_require__(679);
var is = __webpack_require__(680);
var isRegex = __webpack_require__(683);
var flags = __webpack_require__(684);
var isDate = __webpack_require__(687);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(287); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(207)();
var callBound = __webpack_require__(201);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(110);
var callBind = __webpack_require__(202);

var implementation = __webpack_require__(288);
var getPolyfill = __webpack_require__(289);
var shim = __webpack_require__(682);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(135);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(289);
var define = __webpack_require__(110);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(201);
var hasToStringTag = __webpack_require__(207)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(110);
var callBind = __webpack_require__(202);

var implementation = __webpack_require__(290);
var getPolyfill = __webpack_require__(291);
var shim = __webpack_require__(686);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(110).supportsDescriptors;
var getPolyfill = __webpack_require__(291);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(207)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(70)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(690);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(691);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(292);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)))

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(293);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildAuthorizeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exchangeCodeForToken; });
/* harmony export (immutable) */ __webpack_exports__["b"] = consumePkceVerifierForState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
var sha256=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(plain){var encoder,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:encoder=new TextEncoder();data=encoder.encode(plain);return _context.abrupt('return',window.crypto.subtle.digest('SHA-256',data));case 3:case'end':return _context.stop();}}},_callee,this);}));return function sha256(_x2){return _ref.apply(this,arguments);};}();var pkceChallengeFromVerifier=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(verifier){var hashed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return sha256(verifier);case 2:hashed=_context2.sent;return _context2.abrupt('return',base64UrlEncode(hashed));case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function pkceChallengeFromVerifier(_x3){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var PKCE_VERIFIER_KEY_PREFIX='ch_pkce_verifier';var OAUTH_STATE_KEY='ch_oauth_state';function base64UrlEncode(arrayBuffer){var bytes=new Uint8Array(arrayBuffer);var binary='';for(var i=0;i<bytes.byteLength;i++){binary+=String.fromCharCode(bytes[i]);}return btoa(binary).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/g,'');}function randomString(){var length=arguments.length>0&&arguments[0]!==undefined?arguments[0]:64;var charset='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';var randomValues=new Uint8Array(length);window.crypto.getRandomValues(randomValues);var result='';for(var i=0;i<randomValues.length;i++){result+=charset[randomValues[i]%charset.length];}return result;}var buildAuthorizeUrl=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref3){var authorizationEndpoint=_ref3.authorizationEndpoint,clientId=_ref3.clientId,redirectUri=_ref3.redirectUri;var state,verifier,challenge,params;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:state=randomString(32);verifier=randomString(96);_context3.next=4;return pkceChallengeFromVerifier(verifier);case 4:challenge=_context3.sent;window.sessionStorage.setItem('ch_pkce_challenge:'+state,challenge);window.sessionStorage.setItem(''+PKCE_VERIFIER_KEY_PREFIX+state,verifier);window.sessionStorage.setItem(OAUTH_STATE_KEY,state);params=new URLSearchParams({response_type:'code',client_id:clientId,redirect_uri:redirectUri,scope:'openid',state:state,code_challenge:challenge,code_challenge_method:'S256'});//console.log({state, verifier, challenge, redirectUri});
return _context3.abrupt('return',authorizationEndpoint+'?'+params.toString());case 10:case'end':return _context3.stop();}}},_callee3,this);}));return function buildAuthorizeUrl(_x4){return _ref4.apply(this,arguments);};}();var exchangeCodeForToken=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5){var tokenEndpoint=_ref5.tokenEndpoint,redirectUri=_ref5.redirectUri,code=_ref5.code,codeVerifier=_ref5.codeVerifier;var body;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(codeVerifier){_context4.next=2;break;}throw new Error('Missing PKCE verifier');case 2:body=new URLSearchParams({grant_type:'authorization_code',code:code,code_verifier:codeVerifier,redirect_uri:redirectUri}).toString();return _context4.abrupt('return',__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(tokenEndpoint,body,{headers:{'Content-Type':'application/x-www-form-urlencoded'}}));case 4:case'end':return _context4.stop();}}},_callee4,this);}));return function exchangeCodeForToken(_x5){return _ref6.apply(this,arguments);};}();function consumePkceVerifierForState(returnedState){if(!returnedState)throw new Error('Missing OAuth state');var key=''+PKCE_VERIFIER_KEY_PREFIX+returnedState;var verifier=window.sessionStorage.getItem(key);window.sessionStorage.removeItem(key);if(!verifier)throw new Error('Missing PKCE verifier for returned state');return verifier;}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SummaryScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Notes__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Header__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Certification__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GeneralInfo__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CheckList__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Brand__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BrandsList__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Contacts__ = __webpack_require__(979);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CLICKABLE_LIST_ITEM_DOCUMENT_TYPE={AGREEMENT:'Certification Agreement',MML:'MML',INSPECTION_REPORT:'Inspection Report'};var SummaryScene=Object(__WEBPACK_IMPORTED_MODULE_6_HOC_User__["a" /* default */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(SummaryScene,_React$Component);function SummaryScene(props){_classCallCheck(this,SummaryScene);var _this=_possibleConstructorReturn(this,(SummaryScene.__proto__||Object.getPrototypeOf(SummaryScene)).call(this,props));_this.roleSwitch=function(){var _this$props=_this.props,user=_this$props.user,match=_this$props.match;var URLRole='';Object.keys(__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */]).forEach(function(roleKey){if(match.params.manufacturerRole===__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */][roleKey].nameForUrl)URLRole=__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */][roleKey];});if(URLRole===__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER&&!user.isOilManufacturer())URLRole=__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].OIL_BRANDER;if(URLRole&&user.getActiveRole()!==URLRole.serverName){user.changeMenu(URLRole.serverName);}};_this.getCurrentYear=function(){var user=_this.props.user;_this.modelYearReminder='(June 1 - May 31)';_this.yearSelectHeader='Model year';return new Promise(function(resolve,reject){switch(user.getActiveRole()){case __WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref){var data=_ref.data;return resolve(data[1]||data[0]);}).catch(function(){reject();});break;case __WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref2){var data=_ref2.data;return resolve(data[1]||data[0]);}).catch(function(){reject();});break;case __WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["h" /* trailerAPI */].currentModelYear).then(function(_ref3){var data=_ref3.data;return resolve(data);}).catch(function(){reject();});break;default:resolve(new Date().getFullYear());}});};_this._showAnnualCertificationAgreement=function(){var user=_this.props.user;return(Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* getIsBoatManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["g" /* getIsTrailerManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["d" /* getIsComponentManufacturer */])(user))&&!user.isInspector();};_this.handleRoleChange=function(_ref4){var role=_ref4.value;var user=_this.props.user;user.setActiveRole(role);_this.getChecklistInfo({role:role});};_this.handleYearSelect=function(year){var user=_this.props.user;user.saveSelectedYear(year);_this.setState({year:year},function(){_this.getChecklistInfo({year:year});});};_this.getChecklistInfo=function(_ref5){var role=_ref5.role,year=_ref5.year;var user=_this.props.user;var currentYearInfo=_this.state.currentYearInfo;if(!role)role=user.getActiveRole();if(!year)year=currentYearInfo.year;_this.setState({currentYearInfo:''},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].checkList(role,year)).then(function(_ref6){var data=_ref6.data;_this.setState({currentYearInfo:data,year:year},_this.promptCertificationStatusChange);}).catch(function(){return _this.setState({yearInfoFetchFailed:true});});});};_this.handleNotesChange=Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* debounce */])(function(value){return _this.setState(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["b" /* assocPath */])(['currentYearInfo','notes'],value),_this.saveChecklistInfo);});_this.saveChecklistInfo=function(){var user=_this.props.user;var currentYearInfo=_this.state.currentYearInfo;var role=user.getActiveRole();var year=currentYearInfo.year;var itemValueMap={};currentYearInfo.itemValues.forEach(function(checklistItem){itemValueMap[checklistItem.id]={isApplicable:checklistItem.isApplicable,autoSet:checklistItem.autoSet,isChecked:checklistItem.isChecked,date:checklistItem.date,id:checklistItem.id};});var dataPayload={id:currentYearInfo.id,notes:currentYearInfo.notes,isCertified:currentYearInfo.isCertified,itemValueMap:itemValueMap};return __WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].checkList(role,year),dataPayload);};_this.closeModal=function(){_this.setState({isModalOpen:false,modalRequestInProcess:false});};_this.changeManufacturerStatus=function(){var _this$props2=_this.props,user=_this$props2.user,updateManufacturer=_this$props2.updateManufacturer;var _toggleManufacturerStatus=function _toggleManufacturerStatus(){_this.setState({modalRequestInProcess:true});__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].changeStatus(user.getManufacturerCode(),!user.getManufacturerStatus())).then(function(){updateManufacturer({active:!user.getManufacturerStatus()});__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Manufacturer status successfully changed');}).finally(_this.closeModal);};_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to '+(user.getManufacturerStatus()?'Deactivate':'Activate')+' '+user.getManufacturerName()+'?';_this.modalConfirmAction=_toggleManufacturerStatus;_this.setState({isModalOpen:true});};_this.onCheckListStatusChange=function(id){if(_this.isInternalUser&&_this.requestedToUpdateFieldsIds.indexOf(id)===-1){_this.requestedToUpdateFieldsIds.push(id);var currentYearInfo=_this.state.currentYearInfo;var dataEntryToChange=currentYearInfo.itemValues.find(function(entry){return entry.id===id;});dataEntryToChange.isChecked=!dataEntryToChange.isChecked;dataEntryToChange.date=new Date();_this.setState({currentYearInfo:currentYearInfo});_this.saveChecklistInfo().then(function(){_this.promptCertificationStatusChange(!dataEntryToChange.isChecked);}).catch(function(){var dataEntryToChange=currentYearInfo.itemValues.find(function(entry){return entry.id===id;});dataEntryToChange.isChecked=!dataEntryToChange.isChecked;dataEntryToChange.date=new Date();_this.setState({currentYearInfo:currentYearInfo});}).finally(function(){var indexOfIdInRequestsList=_this.requestedToUpdateFieldsIds.indexOf(id);if(indexOfIdInRequestsList!==-1)_this.requestedToUpdateFieldsIds.splice(indexOfIdInRequestsList,1);});}};_this.onCheckListApplicableChange=function(_ref7){var id=_ref7.id,prevValue=_ref7.prevValue;var toggleApplicable=Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* evolve */])({currentYearInfo:Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* evolve */])({itemValues:Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["e" /* map */])(function(listItem){return listItem.id===id?Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* assoc */])('isApplicable',!listItem.isApplicable,listItem):listItem;})})});_this.setState(toggleApplicable,function(){return _this.saveChecklistInfo().then(function(){return _this.promptCertificationStatusChange(prevValue);}).catch(function(){return _this.setState(toggleApplicable);});});};_this.onCheckListAutomationChange=function(id){if(_this.isInternalUser&&_this.requestedToUpdateFieldsIds.indexOf(id)===-1){_this.requestedToUpdateFieldsIds.push(id);var currentYearInfo=_this.state.currentYearInfo;var dataEntryToChange=currentYearInfo.itemValues.find(function(entry){return entry.id===id;});dataEntryToChange.autoSet=!dataEntryToChange.autoSet;_this.setState({currentYearInfo:currentYearInfo});_this.saveChecklistInfo().catch(function(){var dataEntryToChange=currentYearInfo.itemValues.find(function(entry){return entry.id===id;});dataEntryToChange.autoSet=!dataEntryToChange.autoSet;_this.setState({currentYearInfo:currentYearInfo});}).finally(function(){var indexOfIdInRequestsList=_this.requestedToUpdateFieldsIds.indexOf(id);if(indexOfIdInRequestsList!==-1)_this.requestedToUpdateFieldsIds.splice(indexOfIdInRequestsList,1);});}};_this.onCheckListDateChange=function(id){return function(newDate){if(_this.isInternalUser&&_this.requestedToUpdateFieldsIds.indexOf(id)===-1){_this.requestedToUpdateFieldsIds.push(id);var currentYearInfo=_this.state.currentYearInfo;var dataEntryToChange=currentYearInfo.itemValues.find(function(entry){return entry.id===id;});var oldDate=dataEntryToChange.date;dataEntryToChange.date=newDate;_this.setState({currentYearInfo:currentYearInfo});_this.saveChecklistInfo().catch(function(){var dataEntryToChange=currentYearInfo.itemValues.find(function(entry){return entry.id===id;});dataEntryToChange.date=oldDate;_this.setState({currentYearInfo:currentYearInfo});}).finally(function(){var indexOfIdInRequestsList=_this.requestedToUpdateFieldsIds.indexOf(id);if(indexOfIdInRequestsList!==-1)_this.requestedToUpdateFieldsIds.splice(indexOfIdInRequestsList,1);});}};};_this.promptCertificationStatusChange=function(itemWasUnchecked){var currentYearInfo=_this.state.currentYearInfo;var user=_this.props.user;var uncheckedItemsCount=currentYearInfo.itemValues.filter(function(_ref8){var isChecked=_ref8.isChecked,isApplicable=_ref8.isApplicable;return!isChecked&&isApplicable;}).length;var isOilRelated=Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["f" /* getIsOilManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["e" /* getIsOilBrander */])(user);if(!(isOilRelated||uncheckedItemsCount||currentYearInfo.isCertified||user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName)){_this.modalHeader='Confirmation';_this.modalBody='All checklist items are checked. Would you like to update Certification status to Certified?';_this.modalConfirmAction=_this.toggleCertificationStatus;_this.setState({isModalOpen:true});}else if(uncheckedItemsCount===1&&itemWasUnchecked&&currentYearInfo.isCertified){_this.modalHeader='Confirmation';_this.modalBody='One of checklist items has been unchecked. Would you like to update Certification status to Certification Pending?';_this.modalConfirmAction=_this.toggleCertificationStatus;_this.setState({isModalOpen:true});}};_this.toggleCertificationStatus=function(){var currentYearInfo=_this.state.currentYearInfo;currentYearInfo.isCertified=!currentYearInfo.isCertified;_this.requestedToUpdateFieldsIds.push('modal');_this.setState({currentYearInfo:currentYearInfo},function(){_this.saveChecklistInfo().catch(function(){_this.setState(function(prevState){return{currentYearInfo:!prevState.currentYearInfo};});}).finally(function(){var indexOfIdInRequestsList=_this.requestedToUpdateFieldsIds.indexOf('modal');if(indexOfIdInRequestsList!==-1)_this.requestedToUpdateFieldsIds.splice(indexOfIdInRequestsList,1);_this.setState({isModalOpen:false});});});};_this.eSignAgreement=function(){var user=_this.props.user;var _this$state=_this.state,isPWCAgreement=_this$state.isPWCAgreement,currentYearInfo=_this$state.currentYearInfo;switch(user.getActiveRole()){case __WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName:_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to generate and e-sign the annual agreement?';_this.modalConfirmAction=function(){_this.setState({modalRequestInProcess:true});__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].eSignBoatCertAgreement(currentYearInfo.year,isPWCAgreement)).then(function(){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Certification Agreement has been successfully generated and sent for e-signature to DocuSign.');}).finally(_this.closeModal);};_this.setState({isModalOpen:true});break;case __WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName:_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to generate and e-sign the annual agreement?';_this.modalConfirmAction=function(){_this.setState({modalRequestInProcess:true});__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].eSignComponentCertAgreement(currentYearInfo.year)).then(function(){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Certification Agreement has been successfully generated and sent for e-signature to DocuSign.');}).finally(_this.closeModal);};_this.setState({isModalOpen:true});break;case __WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName:_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to generate and e-sign the annual agreement?';_this.modalConfirmAction=function(){_this.setState({modalRequestInProcess:true});__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].eSignTrailerCertAgreement(currentYearInfo.year)).then(function(){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Certification Agreement has been successfully generated and sent for e-signature to DocuSign.');}).finally(_this.closeModal);};_this.setState({isModalOpen:true});break;default:break;}};_this.toggleIsPWCFlag=function(){_this.setState(function(prevState){return{isPWCAgreement:!prevState.isPWCAgreement};});};_this.addBrand=function(){_this.modalHeader='Add Brand';_this.modalBody=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Brand__["a" /* default */],{handleInputChange:_this.handleBrandDetailsChange,brandDetails:_this.state.brandDetails});};_this.modalConfirmAction=function(){_this.handleBrandSave();};_this.setState({isModalOpen:true,brandDetails:{errors:{}}});};_this.editBrand=function(brandDetails){return function(){_this.modalHeader='Edit Brand';_this.modalBody=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Brand__["a" /* default */],{handleInputChange:_this.handleBrandDetailsChange,brandDetails:_this.state.brandDetails});};_this.modalConfirmAction=function(){_this.handleBrandSave();};_this.setState({isModalOpen:true,brandDetails:Object.assign({},brandDetails,{errors:{}})});};};_this.handleBrandDetailsChange=function(fieldName){return function(input){var brandDetails=_this.state.brandDetails;brandDetails[fieldName]=input.value||input;_this.setState({brandDetails:brandDetails});};};_this.handleBrandSave=function(){var user=_this.props.user;var brandDetails=_this.state.brandDetails;var brandWebAddress=brandDetails.web;if(!brandWebAddress.match(/https?:\/\//)){brandWebAddress='http://'+brandWebAddress;}__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].addBrand,{id:brandDetails.id,boatType:brandDetails.boatType,web:brandWebAddress,name:brandDetails.name,mnfCode:user.getManufacturerCode()}).then(function(_ref9){var newBrandEntry=_ref9.data;var brandsList=_this.state.brandsList;if(brandDetails.id){var brandEntryIndex=brandsList.findIndex(function(brand){return brand.id===newBrandEntry.id;});brandsList.splice(brandEntryIndex,1,newBrandEntry);}else{brandsList.push(newBrandEntry);}_this.setState({brandsList:brandsList});}).finally(function(){_this.setState({isModalOpen:false});});};_this.deleteBrand=function(id){return function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].deleteBrand(id)).then(function(){var brandsList=_this.state.brandsList;var brandEntryIndex=brandsList.findIndex(function(brand){return brand.id===id;});brandsList.splice(brandEntryIndex,1);_this.setState({brandsList:brandsList,isModalOpen:false});});};};_this.modalHeader='';_this.modalBody='';_this.modalConfirmAction=function(){};_this.requestedToUpdateFieldsIds=[];_this.isInternalUser=props.user.isInternal();_this.state={isModalOpen:false,currentYearInfo:'',isPWCAgreement:false,currentYear:'',year:'',brandsList:[],brandDetails:{errors:{}},yearInfoFetchFailed:false};return _this;}_createClass(SummaryScene,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,updateManufacturer=_props.updateManufacturer,user=_props.user;var manufacturerCode=user.getManufacturerCode();this.roleSwitch();__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].details(manufacturerCode)).then(function(_ref10){var data=_ref10.data;return updateManufacturer(data);}).catch(function(){return _this2.setState({yearInfoFetchFailed:true});});if(Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* getIsBoatManufacturer */])(user)){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].addBrand).then(function(_ref11){var brandsList=_ref11.data;_this2.setState({brandsList:brandsList});});}this.getCurrentYear().then(function(year){_this2.setState({currentYear:year},function(){if(user.getSelectedYear()){_this2.handleYearSelect(user.getSelectedYear());}else{_this2.handleYearSelect(year);}});}).catch(function(){_this2.setState({yearInfoFetchFailed:true});});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.match.params.manufacturerRole!==this.props.match.params.manufacturerRole){this.roleSwitch();this.handleYearSelect(this.state.year);}}},{key:'render',value:function render(){var _state=this.state,isModalOpen=_state.isModalOpen,currentYearInfo=_state.currentYearInfo,modalRequestInProcess=_state.modalRequestInProcess,isPWCAgreement=_state.isPWCAgreement,currentYear=_state.currentYear,year=_state.year,brandsList=_state.brandsList,yearInfoFetchFailed=_state.yearInfoFetchFailed;var user=this.props.user;var agreementStatusEntry=this._showAnnualCertificationAgreement()&&currentYearInfo?currentYearInfo.itemValues.find(function(entry){return entry.statusType==='AGREEMENT';}):'';var agreementIsSigned=agreementStatusEntry&&agreementStatusEntry.isChecked;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["a" /* default */],{manufacturerName:user.getManufacturerName(),manufacturerStatus:user.getManufacturerStatus(),selectedManufacturer:user.selectedManufacturer,isBoatManufacturer:Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* getIsBoatManufacturer */])(user)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Contacts__["a" /* default */],{user:user}),Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* getIsBoatManufacturer */])(user)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__BrandsList__["a" /* default */],{list:brandsList,isInternalUser:this.isInternalUser,isInspector:user.isInspector(),addBrand:this.addBrand,editBrand:this.editBrand,deleteBrand:this.deleteBrand}),Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('hasCertification',currentYearInfo)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Certification__["a" /* default */],{user:user,currentYearInfo:currentYearInfo,toggleCertificationStatus:this.toggleCertificationStatus}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__GeneralInfo__["a" /* default */],{user:user,currentYearInfo:currentYearInfo,currentYear:currentYear,year:year,handleYearSelect:this.handleYearSelect,handleRoleChange:this.handleRoleChange}),yearInfoFetchFailed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _ai_center _jc_center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Something went wrong. Please try again later.')):currentYearInfo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this._showAnnualCertificationAgreement()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section  _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_margin_bottom_16'},'Annual Certification Agreement'),Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* getIsBoatManufacturer */])(user)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Slider__["a" /* default */],{state:!isPWCAgreement,mainWrapperClassName:'green _margin_top_30 _margin_right_150',onLabel:'Boat / Yacht',offLabel:'PWC',disabled:agreementIsSigned&&!this.isInternalUser,toggleAction:this.toggleIsPWCFlag}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_12 _font_weight_100 _color_light_gray _margin_bottom_10'},'E-Sign Annual Agreement with NMMA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'Sign',type:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].green,buttonClassName:'_height_40 _width_160',disabled:agreementIsSigned&&!this.isInternalUser,onClick:this.eSignAgreement}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CheckList__["a" /* default */],{user:user,isInternalUser:this.isInternalUser,checklist:currentYearInfo.itemValues,chosenYear:year,onCheckListDateChange:this.onCheckListDateChange,onCheckListStatusChange:this.onCheckListStatusChange,onCheckListAutomationChange:this.onCheckListAutomationChange,onCheckListApplicableChange:this.onCheckListApplicableChange,documentTypeForListLink:CLICKABLE_LIST_ITEM_DOCUMENT_TYPE}),(this.isInternalUser||user.isInspector()&&currentYearInfo.notes)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section notesScene__history-section _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Notes__["a" /* default */],{text:currentYearInfo.notes||'',handleInputChange:this.handleNotesChange,disabled:!this.isInternalUser}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'History'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'history-section'},currentYearInfo.notesHistory.map(function(_ref12){var year=_ref12.year,notes=_ref12.notes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'history',key:year},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,''+year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notes',dangerouslySetInnerHTML:{__html:notes}}));}))),this.isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section  _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Change Manufacturer Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:user.getManufacturerStatus()?'Deactivate':'Activate',type:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["b" /* buttonType */].primary,color:user.getManufacturerStatus()?__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].red:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].green,buttonClassName:'_height_40 _width_160',onClick:this.changeManufacturerStatus}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _ai_center _jc_center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__spinner _width_90 _height_90'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},this.modalHeader),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},typeof this.modalBody==='function'?this.modalBody():this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction,disabledWithSpinner:modalRequestInProcess}))));}}]);return SummaryScene;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class)||_class;

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */
var F = function () {
  return false;
};
/* unused harmony default export */ var _unused_webpack_default_export = (F);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */
var T = function () {
  return true;
};
/* unused harmony default export */ var _unused_webpack_default_export = (T);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
/* unused harmony default export */ var _unused_webpack_default_export = ({ '@@functional/placeholder': true });

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN_js__ = __webpack_require__(33);




/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
var addIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(function addIndex(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN_js__["a" /* default */])(fn.length, function () {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function () {
      var result = origFn.apply(this, Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */])(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (addIndex);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XAll = /*#__PURE__*/function () {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }
  XAll.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XAll.prototype['@@transducer/result'] = function (result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAll.prototype['@@transducer/step'] = function (result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced_js__["a" /* default */])(this.xf['@@transducer/step'](result, false));
    }
    return result;
  };

  return XAll;
}();

var _xall = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xall(f, xf) {
  return new XAll(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xall);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__max_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pluck_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduce_js__ = __webpack_require__(63);






/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */
var allPass = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function allPass(preds) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__max_js__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_3__pluck_js__["a" /* default */])('length', preds)), function () {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (!preds[idx].apply(this, arguments)) {
        return false;
      }
      idx += 1;
    }
    return true;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (allPass);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XMap = /*#__PURE__*/function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XMap.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xmap(f, xf) {
  return new XMap(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xmap);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xany_js__ = __webpack_require__(703);




/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */
var any = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['any'], __WEBPACK_IMPORTED_MODULE_2__internal_xany_js__["a" /* default */], function any(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (fn(list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (any);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XAny = /*#__PURE__*/function () {
  function XAny(f, xf) {
    this.xf = xf;
    this.f = f;
    this.any = false;
  }
  XAny.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XAny.prototype['@@transducer/result'] = function (result) {
    if (!this.any) {
      result = this.xf['@@transducer/step'](result, false);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAny.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.any = true;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced_js__["a" /* default */])(this.xf['@@transducer/step'](result, true));
    }
    return result;
  };

  return XAny;
}();

var _xany = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xany(f, xf) {
  return new XAny(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xany);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__max_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pluck_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduce_js__ = __webpack_require__(63);






/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */
var anyPass = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function anyPass(preds) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__max_js__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_3__pluck_js__["a" /* default */])('length', preds)), function () {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }
      idx += 1;
    }
    return false;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (anyPass);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_aperture_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xaperture_js__ = __webpack_require__(707);





/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */
var aperture = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_3__internal_xaperture_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__internal_aperture_js__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (aperture);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _aperture;
function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
}

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XAperture = /*#__PURE__*/function () {
  function XAperture(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XAperture.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XAperture.prototype['@@transducer/result'] = function (result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XAperture.prototype['@@transducer/step'] = function (result, input) {
    this.store(input);
    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
  };
  XAperture.prototype.store = function (input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };
  XAperture.prototype.getCopy = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__concat_js__["a" /* default */])(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
  };

  return XAperture;
}();

var _xaperture = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__curry2_js__["a" /* default */])(function _xaperture(n, xf) {
  return new XAperture(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xaperture);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */
var append = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function append(el, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */])(list, [el]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (append);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apply_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__max_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pluck_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reduce_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__values_js__ = __webpack_require__(301);









// Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
// delegating calls to .map
function mapValues(fn, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_6__keys_js__["a" /* default */])(obj).reduce(function (acc, key) {
    acc[key] = fn(obj[key]);
    return acc;
  }, {});
}

/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */
var applySpec = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function applySpec(spec) {
  spec = mapValues(function (v) {
    return typeof v == 'function' ? v : applySpec(v);
  }, spec);

  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__max_js__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_4__pluck_js__["a" /* default */])('length', Object(__WEBPACK_IMPORTED_MODULE_7__values_js__["a" /* default */])(spec))), function () {
    var args = arguments;
    return mapValues(function (f) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__apply_js__["a" /* default */])(f, args);
    }, spec);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (applySpec);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */
var applyTo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function applyTo(x, f) {
  return f(x);
});
/* unused harmony default export */ var _unused_webpack_default_export = (applyTo);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */
var ascend = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function ascend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa < bb ? -1 : aa > bb ? 1 : 0;
});
/* unused harmony default export */ var _unused_webpack_default_export = (ascend);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nAry_js__ = __webpack_require__(145);



/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */
var binary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function binary(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__nAry_js__["a" /* default */])(2, fn);
});
/* unused harmony default export */ var _unused_webpack_default_export = (binary);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isFunction_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__and_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lift_js__ = __webpack_require__(146);





/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */
var both = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function both(f, g) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isFunction_js__["a" /* default */])(f) ? function _both() {
    return f.apply(this, arguments) && g.apply(this, arguments);
  } : Object(__WEBPACK_IMPORTED_MODULE_3__lift_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__and_js__["a" /* default */])(f, g);
});
/* unused harmony default export */ var _unused_webpack_default_export = (both);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry_js__ = __webpack_require__(213);


/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      const format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
var call = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry_js__["a" /* default */])(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
/* unused harmony default export */ var _unused_webpack_default_export = (call);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatCat_js__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(46);




var _xchain = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xchain(f, xf) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(f, Object(__WEBPACK_IMPORTED_MODULE_1__flatCat_js__["a" /* default */])(xf));
});
/* harmony default export */ __webpack_exports__["a"] = (_xchain);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forceReduced_js__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xfBase_js__ = __webpack_require__(32);





var preservingReduced = function (xf) {
  return {
    '@@transducer/init': __WEBPACK_IMPORTED_MODULE_3__xfBase_js__["a" /* default */].init,
    '@@transducer/result': function (result) {
      return xf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      var ret = xf['@@transducer/step'](result, input);
      return ret['@@transducer/reduced'] ? Object(__WEBPACK_IMPORTED_MODULE_0__forceReduced_js__["a" /* default */])(ret) : ret;
    }
  };
};

var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    '@@transducer/init': __WEBPACK_IMPORTED_MODULE_3__xfBase_js__["a" /* default */].init,
    '@@transducer/result': function (result) {
      return rxf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      return !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(input) ? Object(__WEBPACK_IMPORTED_MODULE_2__reduce_js__["a" /* default */])(rxf, result, [input]) : Object(__WEBPACK_IMPORTED_MODULE_2__reduce_js__["a" /* default */])(rxf, result, input);
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (_flatCat);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _forceReduced;
function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */
var clamp = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function clamp(min, max, value) {
  if (min > max) {
    throw new Error('min must not be greater than max in clamp(min, max, value)');
  }
  return value < min ? min : value > max ? max : value;
});
/* unused harmony default export */ var _unused_webpack_default_export = (clamp);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_clone_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);



/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */
var clone = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(function clone(value) {
  return value != null && typeof value.clone === 'function' ? value.clone() : Object(__WEBPACK_IMPORTED_MODULE_0__internal_clone_js__["a" /* default */])(value, [], [], true);
});
/* unused harmony default export */ var _unused_webpack_default_export = (clone);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */
var comparator = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function comparator(pred) {
  return function (a, b) {
    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
  };
});
/* unused harmony default export */ var _unused_webpack_default_export = (comparator);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lift_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__not_js__ = __webpack_require__(308);



/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
var complement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__lift_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__not_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (complement);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _pipe;
function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipeP_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reverse_js__ = __webpack_require__(115);



/**
 * Performs right-to-left composition of one or more Promise-returning
 * functions. The rightmost function may have any arity; the remaining
 * functions must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
 * @param {...Function} functions The functions to compose
 * @return {Function}
 * @see R.pipeP
 * @deprecated since v0.26.0
 * @example
 *
 *      const db = {
 *        users: {
 *          JOE: {
 *            name: 'Joe',
 *            followers: ['STEVE', 'SUZY']
 *          }
 *        }
 *      }
 *
 *      // We'll pretend to do a db lookup which returns a promise
 *      const lookupUser = (userId) => Promise.resolve(db.users[userId])
 *      const lookupFollowers = (user) => Promise.resolve(user.followers)
 *      lookupUser('JOE').then(lookupFollowers)
 *
 *      //  followersForUser :: String -> Promise [UserId]
 *      const followersForUser = R.composeP(lookupFollowers, lookupUser);
 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
 *      // Followers: ["STEVE","SUZY"]
 */
function composeP() {
  if (arguments.length === 0) {
    throw new Error('composeP requires at least one argument');
  }
  return __WEBPACK_IMPORTED_MODULE_0__pipeP_js__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__reverse_js__["a" /* default */])(arguments));
}

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _pipeP;
function _pipeP(f, g) {
  return function () {
    var ctx = this;
    return f.apply(ctx, arguments).then(function (x) {
      return g.call(ctx, x);
    });
  };
}

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pipeWith_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reverse_js__ = __webpack_require__(115);




/**
 * Performs right-to-left function composition using transforming function. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> null
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, f(i, ...args)))
 */
var composeWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function composeWith(xf, list) {
  return __WEBPACK_IMPORTED_MODULE_1__pipeWith_js__["a" /* default */].apply(this, [xf, Object(__WEBPACK_IMPORTED_MODULE_2__reverse_js__["a" /* default */])(list)]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (composeWith);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _equals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFromIterator_js__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__includesWith_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functionName_js__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__has_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objectIs_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_js__ = __webpack_require__(215);








/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = Object(__WEBPACK_IMPORTED_MODULE_0__arrayFromIterator_js__["a" /* default */])(aIterator);
  var b = Object(__WEBPACK_IMPORTED_MODULE_0__arrayFromIterator_js__["a" /* default */])(bIterator);

  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }

  // if *a* array contains any element that is not included in *b*
  return !Object(__WEBPACK_IMPORTED_MODULE_1__includesWith_js__["a" /* default */])(function (b, aItem) {
    return !Object(__WEBPACK_IMPORTED_MODULE_1__includesWith_js__["a" /* default */])(eq, aItem, b);
  }, b, a);
}

function _equals(a, b, stackA, stackB) {
  if (Object(__WEBPACK_IMPORTED_MODULE_4__objectIs_js__["a" /* default */])(a, b)) {
    return true;
  }

  var typeA = Object(__WEBPACK_IMPORTED_MODULE_6__type_js__["a" /* default */])(a);

  if (typeA !== Object(__WEBPACK_IMPORTED_MODULE_6__type_js__["a" /* default */])(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && Object(__WEBPACK_IMPORTED_MODULE_2__functionName_js__["a" /* default */])(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && Object(__WEBPACK_IMPORTED_MODULE_4__objectIs_js__["a" /* default */])(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!Object(__WEBPACK_IMPORTED_MODULE_4__objectIs_js__["a" /* default */])(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = Object(__WEBPACK_IMPORTED_MODULE_5__keys_js__["a" /* default */])(a);
  if (keysA.length !== Object(__WEBPACK_IMPORTED_MODULE_5__keys_js__["a" /* default */])(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);

  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(Object(__WEBPACK_IMPORTED_MODULE_3__has_js__["a" /* default */])(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayFromIterator;
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _functionName;
function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _quote;
function _quote(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

/* harmony default export */ __webpack_exports__["a"] = (_toISOString);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XFilter = /*#__PURE__*/function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XFilter.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].result;
  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xfilter(f, xf) {
  return new XFilter(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfilter);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__max_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduce_js__ = __webpack_require__(63);






/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */
var cond = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(function cond(pairs) {
  var arity = Object(__WEBPACK_IMPORTED_MODULE_4__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__max_js__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(function (pair) {
    return pair[0].length;
  }, pairs));
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(arity, function () {
    var idx = 0;
    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }
      idx += 1;
    }
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (cond);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructN_js__ = __webpack_require__(318);



/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */
var construct = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function construct(Fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__constructN_js__["a" /* default */])(Fn.length, Fn);
});
/* unused harmony default export */ var _unused_webpack_default_export = (construct);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includes_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.includes
 * @deprecated since v0.26.0
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 *      R.contains('ba', 'banana'); //=>true
 */
var contains = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_includes_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (contains);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduceBy_js__ = __webpack_require__(152);


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
var countBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__reduceBy_js__["a" /* default */])(function (acc, elem) {
  return acc + 1;
}, 0);
/* unused harmony default export */ var _unused_webpack_default_export = (countBy);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curryN_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XReduceBy = /*#__PURE__*/function () {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XReduceBy.prototype['@@transducer/result'] = function (result) {
    var key;
    for (key in this.inputs) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return XReduceBy;
}();

var _xreduceBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curryN_js__["a" /* default */])(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xreduceBy);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_js__ = __webpack_require__(138);


/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
var dec = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__add_js__["a" /* default */])(-1);
/* unused harmony default export */ var _unused_webpack_default_export = (dec);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */
var descend = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function descend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa > bb ? -1 : aa < bb ? 1 : 0;
});
/* unused harmony default export */ var _unused_webpack_default_export = (descend);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isInteger_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assoc_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dissoc_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__update_js__ = __webpack_require__(222);








/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */
var dissocPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function dissocPath(path, obj) {
  switch (path.length) {
    case 0:
      return obj;
    case 1:
      return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger_js__["a" /* default */])(path[0]) && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__["a" /* default */])(obj) ? Object(__WEBPACK_IMPORTED_MODULE_5__remove_js__["a" /* default */])(path[0], 1, obj) : Object(__WEBPACK_IMPORTED_MODULE_4__dissoc_js__["a" /* default */])(path[0], obj);
    default:
      var head = path[0];
      var tail = Array.prototype.slice.call(path, 1);
      if (obj[head] == null) {
        return obj;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger_js__["a" /* default */])(head) && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__["a" /* default */])(obj)) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__update_js__["a" /* default */])(head, dissocPath(tail, obj[head]), obj);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_3__assoc_js__["a" /* default */])(head, dissocPath(tail, obj[head]), obj);
      }
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (dissocPath);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */
var divide = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function divide(a, b) {
  return a / b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (divide);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XDrop = /*#__PURE__*/function () {
  function XDrop(n, xf) {
    this.xf = xf;
    this.n = n;
  }
  XDrop.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XDrop.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].result;
  XDrop.prototype['@@transducer/step'] = function (result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return XDrop;
}();

var _xdrop = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xdrop(n, xf) {
  return new XDrop(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdrop);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dropLast_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xdropLast_js__ = __webpack_require__(745);





/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */
var dropLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_3__internal_xdropLast_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__internal_dropLast_js__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (dropLast);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dropLast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__take_js__ = __webpack_require__(223);


function dropLast(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__take_js__["a" /* default */])(n < xs.length ? xs.length - n : 0, xs);
}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XTake = /*#__PURE__*/function () {
  function XTake(n, xf) {
    this.xf = xf;
    this.n = n;
    this.i = 0;
  }
  XTake.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XTake.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].result;
  XTake.prototype['@@transducer/step'] = function (result, input) {
    this.i += 1;
    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
    return this.n >= 0 && this.i >= this.n ? Object(__WEBPACK_IMPORTED_MODULE_1__reduced_js__["a" /* default */])(ret) : ret;
  };

  return XTake;
}();

var _xtake = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xtake(n, xf) {
  return new XTake(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xtake);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XDropLast = /*#__PURE__*/function () {
  function XDropLast(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XDropLast.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XDropLast.prototype['@@transducer/result'] = function (result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLast.prototype['@@transducer/step'] = function (result, input) {
    if (this.full) {
      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
    }
    this.store(input);
    return result;
  };
  XDropLast.prototype.store = function (input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  return XDropLast;
}();

var _xdropLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xdropLast(n, xf) {
  return new XDropLast(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropLast);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dropLastWhile_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xdropLastWhile_js__ = __webpack_require__(748);





/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */
var dropLastWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_3__internal_xdropLastWhile_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__internal_dropLastWhile_js__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (dropLastWhile);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dropLastWhile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slice_js__ = __webpack_require__(54);


function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__slice_js__["a" /* default */])(0, idx + 1, xs);
}

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XDropLastWhile = /*#__PURE__*/function () {
  function XDropLastWhile(fn, xf) {
    this.f = fn;
    this.retained = [];
    this.xf = xf;
  }
  XDropLastWhile.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XDropLastWhile.prototype['@@transducer/result'] = function (result) {
    this.retained = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLastWhile.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.retain(result, input) : this.flush(result, input);
  };
  XDropLastWhile.prototype.flush = function (result, input) {
    result = Object(__WEBPACK_IMPORTED_MODULE_1__reduce_js__["a" /* default */])(this.xf['@@transducer/step'], result, this.retained);
    this.retained = [];
    return this.xf['@@transducer/step'](result, input);
  };
  XDropLastWhile.prototype.retain = function (result, input) {
    this.retained.push(input);
    return result;
  };

  return XDropLastWhile;
}();

var _xdropLastWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xdropLastWhile(fn, xf) {
  return new XDropLastWhile(fn, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropLastWhile);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropRepeatsWith_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__equals_js__ = __webpack_require__(47);






/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
var dropRepeats = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__equals_js__["a" /* default */]), /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__dropRepeatsWith_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__equals_js__["a" /* default */])));
/* unused harmony default export */ var _unused_webpack_default_export = (dropRepeats);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdropWhile_js__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice_js__ = __webpack_require__(54);





/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */
var dropWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['dropWhile'], __WEBPACK_IMPORTED_MODULE_2__internal_xdropWhile_js__["a" /* default */], function dropWhile(pred, xs) {
  var idx = 0;
  var len = xs.length;
  while (idx < len && pred(xs[idx])) {
    idx += 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice_js__["a" /* default */])(idx, Infinity, xs);
}));
/* unused harmony default export */ var _unused_webpack_default_export = (dropWhile);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XDropWhile = /*#__PURE__*/function () {
  function XDropWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XDropWhile.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XDropWhile.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].result;
  XDropWhile.prototype['@@transducer/step'] = function (result, input) {
    if (this.f) {
      if (this.f(input)) {
        return result;
      }
      this.f = null;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return XDropWhile;
}();

var _xdropWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xdropWhile(f, xf) {
  return new XDropWhile(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropWhile);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isFunction_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lift_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__or_js__ = __webpack_require__(330);





/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */
var either = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function either(f, g) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isFunction_js__["a" /* default */])(f) ? function _either() {
    return f.apply(this, arguments) || g.apply(this, arguments);
  } : Object(__WEBPACK_IMPORTED_MODULE_2__lift_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__or_js__["a" /* default */])(f, g);
});
/* unused harmony default export */ var _unused_webpack_default_export = (either);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__takeLast_js__ = __webpack_require__(332);




/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
var endsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function (suffix, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__takeLast_js__["a" /* default */])(suffix.length, list), suffix);
});
/* unused harmony default export */ var _unused_webpack_default_export = (endsWith);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);



/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */
var eqBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function eqBy(f, x, y) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */])(f(x), f(y));
});
/* unused harmony default export */ var _unused_webpack_default_export = (eqBy);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);



/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */
var eqProps = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function eqProps(prop, obj1, obj2) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */])(obj1[prop], obj2[prop]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (eqProps);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */
var evolve = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function evolve(transformations, object) {
  var result = object instanceof Array ? [] : {};
  var transformation, key, type;
  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (evolve);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfind_js__ = __webpack_require__(758);




/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */
var find = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['find'], __WEBPACK_IMPORTED_MODULE_2__internal_xfind_js__["a" /* default */], function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));
/* unused harmony default export */ var _unused_webpack_default_export = (find);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XFind = /*#__PURE__*/function () {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XFind.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.found = true;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced_js__["a" /* default */])(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return XFind;
}();

var _xfind = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xfind(f, xf) {
  return new XFind(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfind);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfindIndex_js__ = __webpack_require__(760);




/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */
var findIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xfindIndex_js__["a" /* default */], function findIndex(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (findIndex);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XFindIndex = /*#__PURE__*/function () {
  function XFindIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.found = false;
  }
  XFindIndex.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XFindIndex.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, -1);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFindIndex.prototype['@@transducer/step'] = function (result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.found = true;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced_js__["a" /* default */])(this.xf['@@transducer/step'](result, this.idx));
    }
    return result;
  };

  return XFindIndex;
}();

var _xfindIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xfindIndex(f, xf) {
  return new XFindIndex(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfindIndex);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfindLast_js__ = __webpack_require__(762);




/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */
var findLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xfindLast_js__["a" /* default */], function findLast(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx -= 1;
  }
}));
/* unused harmony default export */ var _unused_webpack_default_export = (findLast);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XFindLast = /*#__PURE__*/function () {
  function XFindLast(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFindLast.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XFindLast.prototype['@@transducer/result'] = function (result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
  };
  XFindLast.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.last = input;
    }
    return result;
  };

  return XFindLast;
}();

var _xfindLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xfindLast(f, xf) {
  return new XFindLast(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfindLast);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfindLastIndex_js__ = __webpack_require__(764);




/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */
var findLastIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xfindLastIndex_js__["a" /* default */], function findLastIndex(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return idx;
    }
    idx -= 1;
  }
  return -1;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (findLastIndex);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XFindLastIndex = /*#__PURE__*/function () {
  function XFindLastIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.lastIdx = -1;
  }
  XFindLastIndex.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XFindLastIndex.prototype['@@transducer/result'] = function (result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
  };
  XFindLastIndex.prototype['@@transducer/step'] = function (result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.lastIdx = this.idx;
    }
    return result;
  };

  return XFindLastIndex;
}();

var _xfindLastIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xfindLastIndex(f, xf) {
  return new XFindLastIndex(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfindLastIndex);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_makeFlat_js__ = __webpack_require__(305);



/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */
var flatten = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_makeFlat_js__["a" /* default */])(true));
/* unused harmony default export */ var _unused_webpack_default_export = (flatten);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */
var forEach = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__["a" /* default */])('forEach', function forEach(fn, list) {
  var len = list.length;
  var idx = 0;
  while (idx < len) {
    fn(list[idx]);
    idx += 1;
  }
  return list;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (forEach);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(53);



/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */
var forEachObjIndexed = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function forEachObjIndexed(fn, obj) {
  var keyList = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj);
  var idx = 0;
  while (idx < keyList.length) {
    var key = keyList[idx];
    fn(obj[key], key, obj);
    idx += 1;
  }
  return obj;
});
/* unused harmony default export */ var _unused_webpack_default_export = (forEachObjIndexed);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */
var fromPairs = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function fromPairs(pairs) {
  var result = {};
  var idx = 0;
  while (idx < pairs.length) {
    result[pairs[idx][0]] = pairs[idx][1];
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (fromPairs);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduceBy_js__ = __webpack_require__(152);




/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
var groupBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__["a" /* default */])('groupBy', /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__reduceBy_js__["a" /* default */])(function (acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));
/* unused harmony default export */ var _unused_webpack_default_export = (groupBy);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */
var groupWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function (fn, list) {
  var res = [];
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    var nextidx = idx + 1;
    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
      nextidx += 1;
    }
    res.push(list.slice(idx, nextidx));
    idx = nextidx;
  }
  return res;
});
/* unused harmony default export */ var _unused_webpack_default_export = (groupWith);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */
var gt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function gt(a, b) {
  return a > b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (gt);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */
var gte = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function gte(a, b) {
  return a >= b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (gte);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(333);



/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */
var has = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function has(prop, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])([prop], obj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (has);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */
var hasIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function hasIn(prop, obj) {
  return prop in obj;
});
/* unused harmony default export */ var _unused_webpack_default_export = (hasIn);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_objectIs_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
var identical = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_objectIs_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (identical);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);



/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */
var ifElse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function ifElse(condition, onTrue, onFalse) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
    return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (ifElse);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_js__ = __webpack_require__(138);


/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
var inc = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__add_js__["a" /* default */])(1);
/* unused harmony default export */ var _unused_webpack_default_export = (inc);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includes_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */
var includes = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_includes_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (includes);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduceBy_js__ = __webpack_require__(152);


/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
var indexBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__reduceBy_js__["a" /* default */])(function (acc, elem) {
  return elem;
}, null);
/* unused harmony default export */ var _unused_webpack_default_export = (indexBy);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_indexOf_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__ = __webpack_require__(68);




/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */
var indexOf = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function indexOf(target, xs) {
  return typeof xs.indexOf === 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray_js__["a" /* default */])(xs) ? xs.indexOf(target) : Object(__WEBPACK_IMPORTED_MODULE_1__internal_indexOf_js__["a" /* default */])(xs, target, 0);
});
/* unused harmony default export */ var _unused_webpack_default_export = (indexOf);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slice_js__ = __webpack_require__(54);


/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
var init = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__slice_js__["a" /* default */])(0, -1);
/* unused harmony default export */ var _unused_webpack_default_export = (init);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_filter_js__ = __webpack_require__(220);




/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
var innerJoin = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__["a" /* default */])(function innerJoin(pred, xs, ys) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__internal_filter_js__["a" /* default */])(function (x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__internal_includesWith_js__["a" /* default */])(pred, x, ys);
  }, xs);
});
/* unused harmony default export */ var _unused_webpack_default_export = (innerJoin);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */
var insert = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function insert(idx, elt, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  var result = Array.prototype.slice.call(list, 0);
  result.splice(idx, 0, elt);
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (insert);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */
var insertAll = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function insertAll(idx, elts, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
/* unused harmony default export */ var _unused_webpack_default_export = (insertAll);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includes_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_filter_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flip_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__uniq_js__ = __webpack_require__(224);






/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */
var intersection = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function intersection(list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__uniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__internal_filter_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__flip_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_includes_js__["a" /* default */])(lookupList), filteredList));
});
/* unused harmony default export */ var _unused_webpack_default_export = (intersection);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */
var intersperse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod_js__["a" /* default */])('intersperse', function intersperse(separator, list) {
  var out = [];
  var idx = 0;
  var length = list.length;
  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], separator);
    }
    idx += 1;
  }
  return out;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (intersperse);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_clone_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isTransformer_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_stepCat_js__ = __webpack_require__(788);






/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */
var into = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__["a" /* default */])(function into(acc, xf, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__internal_isTransformer_js__["a" /* default */])(acc) ? Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__["a" /* default */])(xf(acc), acc['@@transducer/init'](), list) : Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce_js__["a" /* default */])(xf(Object(__WEBPACK_IMPORTED_MODULE_4__internal_stepCat_js__["a" /* default */])(acc)), Object(__WEBPACK_IMPORTED_MODULE_0__internal_clone_js__["a" /* default */])(acc, [], [], false), list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (into);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _stepCat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectAssign_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTransformer_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objOf_js__ = __webpack_require__(335);






var _stepCatArray = {
  '@@transducer/init': Array,
  '@@transducer/step': function (xs, x) {
    xs.push(x);
    return xs;
  },
  '@@transducer/result': __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */]
};
var _stepCatString = {
  '@@transducer/init': String,
  '@@transducer/step': function (a, b) {
    return a + b;
  },
  '@@transducer/result': __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */]
};
var _stepCatObject = {
  '@@transducer/init': Object,
  '@@transducer/step': function (result, input) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__objectAssign_js__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(input) ? Object(__WEBPACK_IMPORTED_MODULE_4__objOf_js__["a" /* default */])(input[0], input[1]) : input);
  },
  '@@transducer/result': __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */]
};

function _stepCat(obj) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isTransformer_js__["a" /* default */])(obj)) {
    return obj;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(obj)) {
    return _stepCatArray;
  }
  if (typeof obj === 'string') {
    return _stepCatString;
  }
  if (typeof obj === 'object') {
    return _stepCatObject;
  }
  throw new Error('Cannot create transformer for ' + obj);
}

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(53);




/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */
var invert = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function invert(obj) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    var val = obj[key];
    var list = Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(val, out) ? out[val] : out[val] = [];
    list[list.length] = key;
    idx += 1;
  }
  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (invert);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(53);



/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */
var invertObj = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function invertObj(obj) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    out[obj[key]] = key;
    idx += 1;
  }
  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (invertObj);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__empty_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equals_js__ = __webpack_require__(47);




/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */
var isEmpty = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function isEmpty(x) {
  return x != null && Object(__WEBPACK_IMPORTED_MODULE_2__equals_js__["a" /* default */])(x, Object(__WEBPACK_IMPORTED_MODULE_1__empty_js__["a" /* default */])(x));
});
/* unused harmony default export */ var _unused_webpack_default_export = (isEmpty);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker_js__ = __webpack_require__(118);


/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
var join = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker_js__["a" /* default */])(1, 'join');
/* unused harmony default export */ var _unused_webpack_default_export = (join);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */
var keysIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function keysIn(obj) {
  var prop;
  var ks = [];
  for (prop in obj) {
    ks[ks.length] = prop;
  }
  return ks;
});
/* unused harmony default export */ var _unused_webpack_default_export = (keysIn);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isArray_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equals_js__ = __webpack_require__(47);




/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */
var lastIndexOf = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function lastIndexOf(target, xs) {
  if (typeof xs.lastIndexOf === 'function' && !Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArray_js__["a" /* default */])(xs)) {
    return xs.lastIndexOf(target);
  } else {
    var idx = xs.length - 1;
    while (idx >= 0) {
      if (Object(__WEBPACK_IMPORTED_MODULE_2__equals_js__["a" /* default */])(xs[idx], target)) {
        return idx;
      }
      idx -= 1;
    }
    return -1;
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (lastIndexOf);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lens_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nth_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__update_js__ = __webpack_require__(222);





/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */
var lensIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function lensIndex(n) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__lens_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__nth_js__["a" /* default */])(n), Object(__WEBPACK_IMPORTED_MODULE_3__update_js__["a" /* default */])(n));
});
/* unused harmony default export */ var _unused_webpack_default_export = (lensIndex);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assocPath_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lens_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__path_js__ = __webpack_require__(98);





/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */
var lensPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function lensPath(p) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__lens_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__path_js__["a" /* default */])(p), Object(__WEBPACK_IMPORTED_MODULE_1__assocPath_js__["a" /* default */])(p));
});
/* unused harmony default export */ var _unused_webpack_default_export = (lensPath);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assoc_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lens_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_js__ = __webpack_require__(210);





/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
var lensProp = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function lensProp(k) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__lens_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__prop_js__["a" /* default */])(k), Object(__WEBPACK_IMPORTED_MODULE_1__assoc_js__["a" /* default */])(k));
});
/* unused harmony default export */ var _unused_webpack_default_export = (lensProp);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */
var lt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function lt(a, b) {
  return a < b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (lt);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */
var lte = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function lte(a, b) {
  return a <= b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (lte);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */
var mapAccum = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function mapAccum(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var tuple = [acc];
  while (idx < len) {
    tuple = fn(tuple[0], list[idx]);
    result[idx] = tuple[1];
    idx += 1;
  }
  return [tuple[0], result];
});
/* unused harmony default export */ var _unused_webpack_default_export = (mapAccum);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */
var mapAccumRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function mapAccumRight(fn, acc, list) {
  var idx = list.length - 1;
  var result = [];
  var tuple = [acc];
  while (idx >= 0) {
    tuple = fn(tuple[0], list[idx]);
    result[idx] = tuple[1];
    idx -= 1;
  }
  return [tuple[0], result];
});
/* unused harmony default export */ var _unused_webpack_default_export = (mapAccumRight);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(53);




/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */
var mapObjIndexed = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function mapObjIndexed(fn, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__["a" /* default */])(function (acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj));
});
/* unused harmony default export */ var _unused_webpack_default_export = (mapObjIndexed);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */
var match = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function match(rx, str) {
  return str.match(rx) || [];
});
/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isInteger_js__ = __webpack_require__(212);



/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */
var mathMod = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function mathMod(m, p) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger_js__["a" /* default */])(m)) {
    return NaN;
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger_js__["a" /* default */])(p) || p < 1) {
    return NaN;
  }
  return (m % p + p) % p;
});
/* unused harmony default export */ var _unused_webpack_default_export = (mathMod);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */
var maxBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function maxBy(f, a, b) {
  return f(b) > f(a) ? b : a;
});
/* unused harmony default export */ var _unused_webpack_default_export = (maxBy);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mean_js__ = __webpack_require__(340);



/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */
var median = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function median(list) {
  var len = list.length;
  if (len === 0) {
    return NaN;
  }
  var width = 2 - len % 2;
  var idx = (len - width) / 2;
  return Object(__WEBPACK_IMPORTED_MODULE_1__mean_js__["a" /* default */])(Array.prototype.slice.call(list, 0).sort(function (a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }).slice(idx, idx + width));
});
/* unused harmony default export */ var _unused_webpack_default_export = (median);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_has_js__ = __webpack_require__(40);




/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoizeWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function memoizeWith(mFn, fn) {
  var cache = {};
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(fn.length, function () {
    var key = mFn.apply(this, arguments);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__internal_has_js__["a" /* default */])(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (memoizeWith);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */
var merge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function merge(l, r) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__["a" /* default */])({}, l, r);
});
/* unused harmony default export */ var _unused_webpack_default_export = (merge);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);



/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */
var mergeAll = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(function mergeAll(list) {
  return __WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__["a" /* default */].apply(null, [{}].concat(list));
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeAll);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey_js__ = __webpack_require__(155);



/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */
var mergeDeepLeft = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function mergeDeepLeft(lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey_js__["a" /* default */])(function (k, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeDeepLeft);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey_js__ = __webpack_require__(155);



/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */
var mergeDeepRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function mergeDeepRight(lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey_js__["a" /* default */])(function (k, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeDeepRight);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey_js__ = __webpack_require__(155);



/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */
var mergeDeepWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function mergeDeepWith(fn, lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey_js__["a" /* default */])(function (k, lVal, rVal) {
    return fn(lVal, rVal);
  }, lObj, rObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeDeepWith);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */
var mergeLeft = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function mergeLeft(l, r) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__["a" /* default */])({}, r, l);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeLeft);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);



/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */
var mergeRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function mergeRight(l, r) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_objectAssign_js__["a" /* default */])({}, l, r);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeRight);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeWithKey_js__ = __webpack_require__(225);



/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */
var mergeWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function mergeWith(fn, l, r) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeWithKey_js__["a" /* default */])(function (_, _l, _r) {
    return fn(_l, _r);
  }, l, r);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeWith);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */
var min = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function min(a, b) {
  return b < a ? b : a;
});
/* unused harmony default export */ var _unused_webpack_default_export = (min);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */
var minBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function minBy(f, a, b) {
  return f(b) < f(a) ? b : a;
});
/* unused harmony default export */ var _unused_webpack_default_export = (minBy);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */
var modulo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function modulo(a, b) {
  return a % b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (modulo);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
var negate = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function negate(n) {
  return -n;
});
/* unused harmony default export */ var _unused_webpack_default_export = (negate);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_complement_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__all_js__ = __webpack_require__(295);




/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */
const none = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function none(fn, input) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__all_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__internal_complement_js__["a" /* default */])(fn), input);
});
/* unused harmony default export */ var _unused_webpack_default_export = (none);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nth_js__ = __webpack_require__(116);




/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */
var nthArg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function nthArg(n) {
  var arity = n < 0 ? 1 : n + 1;
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(arity, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nth_js__["a" /* default */])(n, arguments);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (nthArg);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */
var o = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function o(f, g, x) {
  return f(g(x));
});
/* unused harmony default export */ var _unused_webpack_default_export = (o);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_of_js__ = __webpack_require__(824);



/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */
var of = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_of_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (of);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _of;
function _of(x) {
  return [x];
}

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */
var omit = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function omit(names, obj) {
  var result = {};
  var index = {};
  var idx = 0;
  var len = names.length;

  while (idx < len) {
    index[names[idx]] = 1;
    idx += 1;
  }

  for (var prop in obj) {
    if (!index.hasOwnProperty(prop)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (omit);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);



/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */
var once = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(function once(fn) {
  var called = false;
  var result;
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(fn.length, function () {
    if (called) {
      return result;
    }
    called = true;
    result = fn.apply(this, arguments);
    return result;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (once);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_assertPromise_js__ = __webpack_require__(343);



/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.then
 * @example
 *
 *      var failedFetch = (id) => Promise.reject('bad ID');
 *      var useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' })
 *
 *      //recoverFromFailure :: String -> Promise ({firstName, lastName})
 *      var recoverFromFailure = R.pipe(
 *        failedFetch(12345),
 *        R.otherwise(useDefault),
 *        R.then(R.pick(['firstName', 'lastName']))
 *      );
 */
const otherwise = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function otherwise(f, p) {
  Object(__WEBPACK_IMPORTED_MODULE_1__internal_assertPromise_js__["a" /* default */])('otherwise', p);

  return p.then(null, f);
});
/* unused harmony default export */ var _unused_webpack_default_export = (otherwise);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */
var pair = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function pair(fst, snd) {
  return [fst, snd];
});
/* unused harmony default export */ var _unused_webpack_default_export = (pair);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator_js__ = __webpack_require__(345);



/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */
var partial = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (partial);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flip_js__ = __webpack_require__(153);




/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
var partialRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__flip_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (partialRight);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__juxt_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reject_js__ = __webpack_require__(151);




/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
var partition = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__juxt_js__["a" /* default */])([__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__reject_js__["a" /* default */]]);
/* unused harmony default export */ var _unused_webpack_default_export = (partition);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path_js__ = __webpack_require__(98);




/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */
var pathEq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function pathEq(_path, val, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__path_js__["a" /* default */])(_path, obj), val);
});
/* unused harmony default export */ var _unused_webpack_default_export = (pathEq);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_js__ = __webpack_require__(98);



/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */
var pathSatisfies = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function pathSatisfies(pred, propPath, obj) {
  return propPath.length > 0 && pred(Object(__WEBPACK_IMPORTED_MODULE_1__path_js__["a" /* default */])(propPath, obj));
});
/* unused harmony default export */ var _unused_webpack_default_export = (pathSatisfies);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */
var pick = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function pick(names, obj) {
  var result = {};
  var idx = 0;
  while (idx < names.length) {
    if (names[idx] in obj) {
      result[names[idx]] = obj[names[idx]];
    }
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (pick);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
var pickBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (pickBy);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composeK_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reverse_js__ = __webpack_require__(115);



/**
 * Returns the left-to-right Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(f, R.chain(g), R.chain(h))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
 * @param {...Function}
 * @return {Function}
 * @see R.composeK
 * @deprecated since v0.26.0
 * @example
 *
 *      //  parseJson :: String -> Maybe *
 *      //  get :: String -> Object -> Maybe *
 *
 *      //  getStateCode :: Maybe String -> Maybe String
 *      const getStateCode = R.pipeK(
 *        parseJson,
 *        get('user'),
 *        get('address'),
 *        get('state'),
 *        R.compose(Maybe.of, R.toUpper)
 *      );
 *
 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
 *      //=> Just('NY')
 *      getStateCode('[Invalid JSON]');
 *      //=> Nothing()
 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
 */
function pipeK() {
  if (arguments.length === 0) {
    throw new Error('pipeK requires at least one argument');
  }
  return __WEBPACK_IMPORTED_MODULE_0__composeK_js__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__reverse_js__["a" /* default */])(arguments));
}

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiply_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce_js__ = __webpack_require__(63);



/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
var product = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__reduce_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__multiply_js__["a" /* default */], 1);
/* unused harmony default export */ var _unused_webpack_default_export = (product);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_map_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pickAll_js__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useWith_js__ = __webpack_require__(349);





/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
var project = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__useWith_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_map_js__["a" /* default */], [__WEBPACK_IMPORTED_MODULE_2__pickAll_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */]]); // passing `identity` gives correct arity
/* unused harmony default export */ var _unused_webpack_default_export = (project);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);



/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */
var propEq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function propEq(name, val, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */])(val, obj[name]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (propEq);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_js__ = __webpack_require__(336);



/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */
var propIs = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function propIs(type, name, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__is_js__["a" /* default */])(type, obj[name]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (propIs);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pathOr_js__ = __webpack_require__(346);



/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */
var propOr = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function propOr(val, p, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__pathOr_js__["a" /* default */])(val, [p], obj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (propOr);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */
var propSatisfies = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function propSatisfies(pred, name, obj) {
  return pred(obj[name]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (propSatisfies);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */
var props = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function props(ps, obj) {
  var len = ps.length;
  var out = [];
  var idx = 0;

  while (idx < len) {
    out[idx] = obj[ps[idx]];
    idx += 1;
  }

  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (props);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isNumber_js__ = __webpack_require__(339);



/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */
var range = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function range(from, to) {
  if (!(Object(__WEBPACK_IMPORTED_MODULE_1__internal_isNumber_js__["a" /* default */])(from) && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isNumber_js__["a" /* default */])(to))) {
    throw new TypeError('Both arguments to range must be numbers');
  }
  var result = [];
  var n = from;
  while (n < to) {
    result.push(n);
    n += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (range);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curryN_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_reduced_js__ = __webpack_require__(75);




/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 === 1;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */
var reduceWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curryN_js__["a" /* default */])(4, [], function _reduceWhile(pred, fn, a, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_reduce_js__["a" /* default */])(function (acc, x) {
    return pred(acc, x) ? fn(acc, x) : Object(__WEBPACK_IMPORTED_MODULE_2__internal_reduced_js__["a" /* default */])(acc);
  }, a, list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (reduceWhile);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduced_js__ = __webpack_require__(75);



/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is only available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */
var reduced = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_reduced_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (reduced);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__always_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__times_js__ = __webpack_require__(351);




/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */
var repeat = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function repeat(value, n) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__times_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__always_js__["a" /* default */])(value), n);
});
/* unused harmony default export */ var _unused_webpack_default_export = (repeat);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */
var replace = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function replace(regex, replacement, str) {
  return str.replace(regex, replacement);
});
/* unused harmony default export */ var _unused_webpack_default_export = (replace);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */
var scan = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function scan(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [acc];
  while (idx < len) {
    acc = fn(acc, list[idx]);
    result[idx + 1] = acc;
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (scan);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__always_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__over_js__ = __webpack_require__(344);




/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */
var set = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function set(lens, v, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__over_js__["a" /* default */])(lens, Object(__WEBPACK_IMPORTED_MODULE_1__always_js__["a" /* default */])(v), x);
});
/* unused harmony default export */ var _unused_webpack_default_export = (set);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */
var sort = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function sort(comparator, list) {
  return Array.prototype.slice.call(list, 0).sort(comparator);
});
/* unused harmony default export */ var _unused_webpack_default_export = (sort);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */
var sortBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (sortBy);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */
var sortWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function sortWith(fns, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var result = 0;
    var i = 0;
    while (result === 0 && i < fns.length) {
      result = fns[i](a, b);
      i += 1;
    }
    return result;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (sortWith);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker_js__ = __webpack_require__(118);


/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
var split = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker_js__["a" /* default */])(1, 'split');
/* unused harmony default export */ var _unused_webpack_default_export = (split);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__length_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slice_js__ = __webpack_require__(54);




/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */
var splitAt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function splitAt(index, array) {
  return [Object(__WEBPACK_IMPORTED_MODULE_2__slice_js__["a" /* default */])(0, index, array), Object(__WEBPACK_IMPORTED_MODULE_2__slice_js__["a" /* default */])(index, Object(__WEBPACK_IMPORTED_MODULE_1__length_js__["a" /* default */])(array), array)];
});
/* unused harmony default export */ var _unused_webpack_default_export = (splitAt);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(54);



/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */
var splitEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function splitEvery(n, list) {
  if (n <= 0) {
    throw new Error('First argument to splitEvery must be a positive integer');
  }
  var result = [];
  var idx = 0;
  while (idx < list.length) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */])(idx, idx += n, list));
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (splitEvery);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */
var splitWhen = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function splitWhen(pred, list) {
  var idx = 0;
  var len = list.length;
  var prefix = [];

  while (idx < len && !pred(list[idx])) {
    prefix.push(list[idx]);
    idx += 1;
  }

  return [prefix, Array.prototype.slice.call(list, idx)];
});
/* unused harmony default export */ var _unused_webpack_default_export = (splitWhen);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__take_js__ = __webpack_require__(223);




/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
var startsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function (prefix, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__take_js__["a" /* default */])(prefix.length, list), prefix);
});
/* unused harmony default export */ var _unused_webpack_default_export = (startsWith);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */
var subtract = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function subtract(a, b) {
  return Number(a) - Number(b);
});
/* unused harmony default export */ var _unused_webpack_default_export = (subtract);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__concat_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__difference_js__ = __webpack_require__(321);




/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */
var symmetricDifference = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function symmetricDifference(list1, list2) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__concat_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__difference_js__["a" /* default */])(list1, list2), Object(__WEBPACK_IMPORTED_MODULE_2__difference_js__["a" /* default */])(list2, list1));
});
/* unused harmony default export */ var _unused_webpack_default_export = (symmetricDifference);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__concat_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceWith_js__ = __webpack_require__(323);




/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */
var symmetricDifferenceWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function symmetricDifferenceWith(pred, list1, list2) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__concat_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__differenceWith_js__["a" /* default */])(pred, list1, list2), Object(__WEBPACK_IMPORTED_MODULE_2__differenceWith_js__["a" /* default */])(pred, list2, list1));
});
/* unused harmony default export */ var _unused_webpack_default_export = (symmetricDifferenceWith);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(54);



/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */
var takeLastWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function takeLastWhile(fn, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && fn(xs[idx])) {
    idx -= 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */])(idx + 1, Infinity, xs);
});
/* unused harmony default export */ var _unused_webpack_default_export = (takeLastWhile);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xtakeWhile_js__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice_js__ = __webpack_require__(54);





/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */
var takeWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])(['takeWhile'], __WEBPACK_IMPORTED_MODULE_2__internal_xtakeWhile_js__["a" /* default */], function takeWhile(fn, xs) {
  var idx = 0;
  var len = xs.length;
  while (idx < len && fn(xs[idx])) {
    idx += 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice_js__["a" /* default */])(0, idx, xs);
}));
/* unused harmony default export */ var _unused_webpack_default_export = (takeWhile);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase_js__ = __webpack_require__(32);




var XTakeWhile = /*#__PURE__*/function () {
  function XTakeWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTakeWhile.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].init;
  XTakeWhile.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_2__xfBase_js__["a" /* default */].result;
  XTakeWhile.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : Object(__WEBPACK_IMPORTED_MODULE_1__reduced_js__["a" /* default */])(result);
  };

  return XTakeWhile;
}();

var _xtakeWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xtakeWhile(f, xf) {
  return new XTakeWhile(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xtakeWhile);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xtap_js__ = __webpack_require__(866);




/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */
var tap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable_js__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xtap_js__["a" /* default */], function tap(fn, x) {
  fn(x);
  return x;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (tap);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase_js__ = __webpack_require__(32);



var XTap = /*#__PURE__*/function () {
  function XTap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTap.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].init;
  XTap.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase_js__["a" /* default */].result;
  XTap.prototype['@@transducer/step'] = function (result, input) {
    this.f(input);
    return this.xf['@@transducer/step'](result, input);
  };

  return XTap;
}();

var _xtap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2_js__["a" /* default */])(function _xtap(f, xf) {
  return new XTap(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xtap);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_cloneRegExp_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isRegExp_js__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(149);





/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */
var test = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function test(pattern, str) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__internal_isRegExp_js__["a" /* default */])(pattern)) {
    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(pattern));
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_cloneRegExp_js__["a" /* default */])(pattern).test(str);
});
/* unused harmony default export */ var _unused_webpack_default_export = (test);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isRegExp;
function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_assertPromise_js__ = __webpack_require__(343);



/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      var makeQuery = (email) => ({ query: { email }});
 *
 *      //getMemberName :: String -> Promise ({firstName, lastName})
 *      var getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.then(R.pick(['firstName', 'lastName']))
 *      );
 */
const then = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function then(f, p) {
  Object(__WEBPACK_IMPORTED_MODULE_1__internal_assertPromise_js__["a" /* default */])('then', p);

  return p.then(f);
});
/* unused harmony default export */ var _unused_webpack_default_export = (then);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker_js__ = __webpack_require__(118);


/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
var toLower = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker_js__["a" /* default */])(0, 'toLowerCase');
/* unused harmony default export */ var _unused_webpack_default_export = (toLower);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has_js__ = __webpack_require__(40);



/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
var toPairs = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has_js__["a" /* default */])(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});
/* unused harmony default export */ var _unused_webpack_default_export = (toPairs);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */
var toPairsIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function toPairsIn(obj) {
  var pairs = [];
  for (var prop in obj) {
    pairs[pairs.length] = [prop, obj[prop]];
  }
  return pairs;
});
/* unused harmony default export */ var _unused_webpack_default_export = (toPairsIn);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker_js__ = __webpack_require__(118);


/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
var toUpper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker_js__["a" /* default */])(0, 'toUpperCase');
/* unused harmony default export */ var _unused_webpack_default_export = (toUpper);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_reduce_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_xwrap_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN_js__ = __webpack_require__(33);




/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 === 1;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */
var transduce = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__curryN_js__["a" /* default */])(4, function transduce(xf, fn, acc, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_reduce_js__["a" /* default */])(xf(typeof fn === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__internal_xwrap_js__["a" /* default */])(fn) : fn), acc, list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (transduce);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */
var transpose = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function transpose(outerlist) {
  var i = 0;
  var result = [];
  while (i < outerlist.length) {
    var innerlist = outerlist[i];
    var j = 0;
    while (j < innerlist.length) {
      if (typeof result[j] === 'undefined') {
        result[j] = [];
      }
      result[j].push(innerlist[j]);
      j += 1;
    }
    i += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (transpose);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sequence_js__ = __webpack_require__(352);




/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */
var traverse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function traverse(of, f, traversable) {
  return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : Object(__WEBPACK_IMPORTED_MODULE_2__sequence_js__["a" /* default */])(of, Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(f, traversable));
});
/* unused harmony default export */ var _unused_webpack_default_export = (traverse);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
var zeroWidth = '\u200b';
var hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
var trim = !hasProtoTrim || /*#__PURE__*/ws.trim() || ! /*#__PURE__*/zeroWidth.trim() ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function trim(str) {
  var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
  var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
  return str.replace(beginRx, '').replace(endRx, '');
}) : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function trim(str) {
  return str.trim();
});
/* unused harmony default export */ var _unused_webpack_default_export = (trim);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_curry2_js__ = __webpack_require__(1);




/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('catched'))('bar') // => 'catched'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 `` */
var tryCatch = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_curry2_js__["a" /* default */])(function _tryCatch(tryer, catcher) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity_js__["a" /* default */])(tryer.length, function () {
    try {
      return tryer.apply(this, arguments);
    } catch (e) {
      return catcher.apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__internal_concat_js__["a" /* default */])([e], arguments));
    }
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (tryCatch);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */
var unapply = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function unapply(fn) {
  return function () {
    return fn(Array.prototype.slice.call(arguments, 0));
  };
});
/* unused harmony default export */ var _unused_webpack_default_export = (unapply);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nAry_js__ = __webpack_require__(145);



/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */
var unary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function unary(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__nAry_js__["a" /* default */])(1, fn);
});
/* unused harmony default export */ var _unused_webpack_default_export = (unary);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN_js__ = __webpack_require__(33);



/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */
var uncurryN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function uncurryN(depth, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN_js__["a" /* default */])(depth, function () {
    var currentDepth = 1;
    var value = fn;
    var idx = 0;
    var endIdx;
    while (currentDepth <= depth && typeof value === 'function') {
      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
      currentDepth += 1;
      idx = endIdx;
    }
    return value;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (uncurryN);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */
var unfold = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function unfold(fn, seed) {
  var pair = fn(seed);
  var result = [];
  while (pair && pair.length) {
    result[result.length] = pair[0];
    pair = fn(pair[1]);
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (unfold);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uniq_js__ = __webpack_require__(224);





/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
var union = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__compose_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__uniq_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (union);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uniqWith_js__ = __webpack_require__(353);




/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */
var unionWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3_js__["a" /* default */])(function unionWith(pred, list1, list2) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__uniqWith_js__["a" /* default */])(pred, Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat_js__["a" /* default */])(list1, list2));
});
/* unused harmony default export */ var _unused_webpack_default_export = (unionWith);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */
var unless = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function unless(pred, whenFalseFn, x) {
  return pred(x) ? x : whenFalseFn(x);
});
/* unused harmony default export */ var _unused_webpack_default_export = (unless);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_identity_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chain_js__ = __webpack_require__(214);



/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
var unnest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__chain_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_identity_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (unnest);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */
var until = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function until(pred, fn, init) {
  var val = init;
  while (!pred(val)) {
    val = fn(val);
  }
  return val;
});
/* unused harmony default export */ var _unused_webpack_default_export = (until);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__ = __webpack_require__(5);


/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */
var valuesIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1_js__["a" /* default */])(function valuesIn(obj) {
  var prop;
  var vs = [];
  for (prop in obj) {
    vs[vs.length] = obj[prop];
  }
  return vs;
});
/* unused harmony default export */ var _unused_webpack_default_export = (valuesIn);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


// `Const` is a functor that effectively ignores the function given to `map`.
var Const = function (x) {
  return { value: x, 'fantasy-land/map': function () {
      return this;
    } };
};

/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */
var view = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function view(lens, x) {
  // Using `Const` effectively ignores the setter function of the `lens`,
  // leaving the value returned by the getter function unmodified.
  return lens(Const)(x).value;
});
/* unused harmony default export */ var _unused_webpack_default_export = (view);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */
var when = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function when(pred, whenTrueFn, x) {
  return pred(x) ? whenTrueFn(x) : x;
});
/* unused harmony default export */ var _unused_webpack_default_export = (when);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__where_js__ = __webpack_require__(354);





/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */
var whereEq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function whereEq(spec, testObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__where_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__equals_js__["a" /* default */], spec), testObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (whereEq);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_includes_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flip_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reject_js__ = __webpack_require__(151);





/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */
var without = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2_js__["a" /* default */])(function (xs, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__reject_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__flip_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_includes_js__["a" /* default */])(xs), list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (without);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */
var xprod = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function xprod(a, b) {
  // = xprodWith(prepend); (takes about 3 times as long...)
  var idx = 0;
  var ilen = a.length;
  var j;
  var jlen = b.length;
  var result = [];
  while (idx < ilen) {
    j = 0;
    while (j < jlen) {
      result[result.length] = [a[idx], b[j]];
      j += 1;
    }
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (xprod);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */
var zip = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function zip(a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = [a[idx], b[idx]];
    idx += 1;
  }
  return rv;
});
/* unused harmony default export */ var _unused_webpack_default_export = (zip);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__ = __webpack_require__(1);


/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */
var zipObj = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2_js__["a" /* default */])(function zipObj(keys, values) {
  var idx = 0;
  var len = Math.min(keys.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys[idx]] = values[idx];
    idx += 1;
  }
  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (zipObj);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__ = __webpack_require__(8);


/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */
var zipWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3_js__["a" /* default */])(function zipWith(fn, a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = fn(a[idx], b[idx]);
    idx += 1;
  }
  return rv;
});
/* unused harmony default export */ var _unused_webpack_default_export = (zipWith);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curryN_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__ = __webpack_require__(5);



/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */
var thunkify = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1_js__["a" /* default */])(function thunkify(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__curryN_js__["a" /* default */])(fn.length, function createThunk() {
    const fnArgs = arguments;
    return function invokeThunk() {
      return fn.apply(this, fnArgs);
    };
  });
});

/* unused harmony default export */ var _unused_webpack_default_export = (thunkify);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
React-Quill
https://github.com/zenoamaro/react-quill
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(131));
var isEqual_1 = __importDefault(__webpack_require__(899));
var quill_1 = __importDefault(__webpack_require__(967));
var ReactQuill = /** @class */ (function (_super) {
    __extends(ReactQuill, _super);
    function ReactQuill(props) {
        var _this = _super.call(this, props) || this;
        /*
        Changing one of these props should cause a full re-render and a
        re-instantiation of the Quill editor.
        */
        _this.dirtyProps = [
            'modules',
            'formats',
            'bounds',
            'theme',
            'children',
        ];
        /*
        Changing one of these props should cause a regular update. These are mostly
        props that act on the container, rather than the quillized editing area.
        */
        _this.cleanProps = [
            'id',
            'className',
            'style',
            'placeholder',
            'tabIndex',
            'onChange',
            'onChangeSelection',
            'onFocus',
            'onBlur',
            'onKeyPress',
            'onKeyDown',
            'onKeyUp',
        ];
        _this.state = {
            generation: 0,
        };
        /*
        Tracks the internal selection of the Quill editor
        */
        _this.selection = null;
        _this.onEditorChange = function (eventName, rangeOrDelta, oldRangeOrDelta, source) {
            var _a, _b, _c, _d;
            if (eventName === 'text-change') {
                (_b = (_a = _this).onEditorChangeText) === null || _b === void 0 ? void 0 : _b.call(_a, _this.editor.root.innerHTML, rangeOrDelta, source, _this.unprivilegedEditor);
            }
            else if (eventName === 'selection-change') {
                (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 ? void 0 : _d.call(_c, rangeOrDelta, source, _this.unprivilegedEditor);
            }
        };
        var value = _this.isControlled() ? props.value : props.defaultValue;
        _this.value = (value !== null && value !== void 0 ? value : '');
        return _this;
    }
    ReactQuill.prototype.validateProps = function (props) {
        var _a;
        if (react_1.default.Children.count(props.children) > 1)
            throw new Error('The Quill editing area can only be composed of a single React element.');
        if (react_1.default.Children.count(props.children)) {
            var child = react_1.default.Children.only(props.children);
            if (((_a = child) === null || _a === void 0 ? void 0 : _a.type) === 'textarea')
                throw new Error('Quill does not support editing on a <textarea>. Use a <div> instead.');
        }
        if (this.lastDeltaChangeSet &&
            props.value === this.lastDeltaChangeSet)
            throw new Error('You are passing the `delta` object from the `onChange` event back ' +
                'as `value`. You most probably want `editor.getContents()` instead. ' +
                'See: https://github.com/zenoamaro/react-quill#using-deltas');
    };
    ReactQuill.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var _this = this;
        var _a;
        this.validateProps(nextProps);
        // If the editor hasn't been instantiated yet, or the component has been
        // regenerated, we already know we should update.
        if (!this.editor || this.state.generation !== nextState.generation) {
            return true;
        }
        // Handle value changes in-place
        if ('value' in nextProps) {
            var prevContents = this.getEditorContents();
            var nextContents = (_a = nextProps.value, (_a !== null && _a !== void 0 ? _a : ''));
            // NOTE: Seeing that Quill is missing a way to prevent edits, we have to
            //       settle for a hybrid between controlled and uncontrolled mode. We
            //       can't prevent the change, but we'll still override content
            //       whenever `value` differs from current state.
            // NOTE: Comparing an HTML string and a Quill Delta will always trigger a
            //       change, regardless of whether they represent the same document.
            if (!this.isEqualValue(nextContents, prevContents)) {
                this.setEditorContents(this.editor, nextContents);
            }
        }
        // Handle read-only changes in-place
        if (nextProps.readOnly !== this.props.readOnly) {
            this.setEditorReadOnly(this.editor, nextProps.readOnly);
        }
        // Clean and Dirty props require a render
        return __spreadArrays(this.cleanProps, this.dirtyProps).some(function (prop) {
            return !isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.shouldComponentRegenerate = function (nextProps) {
        var _this = this;
        // Whenever a `dirtyProp` changes, the editor needs reinstantiation.
        return this.dirtyProps.some(function (prop) {
            return !isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.componentDidMount = function () {
        this.instantiateEditor();
        this.setEditorContents(this.editor, this.getEditorContents());
    };
    ReactQuill.prototype.componentWillUnmount = function () {
        this.destroyEditor();
    };
    ReactQuill.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        // If we're changing one of the `dirtyProps`, the entire Quill Editor needs
        // to be re-instantiated. Regenerating the editor will cause the whole tree,
        // including the container, to be cleaned up and re-rendered from scratch.
        // Store the contents so they can be restored later.
        if (this.editor && this.shouldComponentRegenerate(prevProps)) {
            var delta = this.editor.getContents();
            var selection = this.editor.getSelection();
            this.regenerationSnapshot = { delta: delta, selection: selection };
            this.setState({ generation: this.state.generation + 1 });
            this.destroyEditor();
        }
        // The component has been regenerated, so it must be re-instantiated, and
        // its content must be restored to the previous values from the snapshot.
        if (this.state.generation !== prevState.generation) {
            var _a = this.regenerationSnapshot, delta = _a.delta, selection_1 = _a.selection;
            delete this.regenerationSnapshot;
            this.instantiateEditor();
            var editor_1 = this.editor;
            editor_1.setContents(delta);
            postpone(function () { return _this.setEditorSelection(editor_1, selection_1); });
        }
    };
    ReactQuill.prototype.instantiateEditor = function () {
        if (this.editor)
            return;
        this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
    };
    ReactQuill.prototype.destroyEditor = function () {
        if (!this.editor)
            return;
        this.unhookEditor(this.editor);
        delete this.editor;
    };
    /*
    We consider the component to be controlled if `value` is being sent in props.
    */
    ReactQuill.prototype.isControlled = function () {
        return 'value' in this.props;
    };
    ReactQuill.prototype.getEditorConfig = function () {
        return {
            bounds: this.props.bounds,
            formats: this.props.formats,
            modules: this.props.modules,
            placeholder: this.props.placeholder,
            readOnly: this.props.readOnly,
            scrollingContainer: this.props.scrollingContainer,
            tabIndex: this.props.tabIndex,
            theme: this.props.theme,
        };
    };
    ReactQuill.prototype.getEditor = function () {
        if (!this.editor)
            throw new Error('Accessing non-instantiated editor');
        return this.editor;
    };
    /**
    Creates an editor on the given element. The editor will be passed the
    configuration, have its events bound,
    */
    ReactQuill.prototype.createEditor = function (element, config) {
        var editor = new quill_1.default(element, config);
        if (config.tabIndex != null) {
            this.setEditorTabIndex(editor, config.tabIndex);
        }
        this.hookEditor(editor);
        return editor;
    };
    ReactQuill.prototype.hookEditor = function (editor) {
        // Expose the editor on change events via a weaker, unprivileged proxy
        // object that does not allow accidentally modifying editor state.
        this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
        // Using `editor-change` allows picking up silent updates, like selection
        // changes on typing.
        editor.on('editor-change', this.onEditorChange);
    };
    ReactQuill.prototype.unhookEditor = function (editor) {
        editor.off('editor-change', this.onEditorChange);
    };
    ReactQuill.prototype.getEditorContents = function () {
        return this.value;
    };
    ReactQuill.prototype.getEditorSelection = function () {
        return this.selection;
    };
    /*
    True if the value is a Delta instance or a Delta look-alike.
    */
    ReactQuill.prototype.isDelta = function (value) {
        return value && value.ops;
    };
    /*
    Special comparison function that knows how to compare Deltas.
    */
    ReactQuill.prototype.isEqualValue = function (value, nextValue) {
        if (this.isDelta(value) && this.isDelta(nextValue)) {
            return isEqual_1.default(value.ops, nextValue.ops);
        }
        else {
            return isEqual_1.default(value, nextValue);
        }
    };
    /*
    Replace the contents of the editor, but keep the previous selection hanging
    around so that the cursor won't move.
    */
    ReactQuill.prototype.setEditorContents = function (editor, value) {
        var _this = this;
        this.value = value;
        var sel = this.getEditorSelection();
        if (typeof value === 'string') {
            editor.setContents(editor.clipboard.convert(value));
        }
        else {
            editor.setContents(value);
        }
        postpone(function () { return _this.setEditorSelection(editor, sel); });
    };
    ReactQuill.prototype.setEditorSelection = function (editor, range) {
        this.selection = range;
        if (range) {
            // Validate bounds before applying.
            var length_1 = editor.getLength();
            range.index = Math.max(0, Math.min(range.index, length_1 - 1));
            range.length = Math.max(0, Math.min(range.length, (length_1 - 1) - range.index));
            editor.setSelection(range);
        }
    };
    ReactQuill.prototype.setEditorTabIndex = function (editor, tabIndex) {
        var _a, _b;
        if ((_b = (_a = editor) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.domNode) {
            editor.scroll.domNode.tabIndex = tabIndex;
        }
    };
    ReactQuill.prototype.setEditorReadOnly = function (editor, value) {
        if (value) {
            editor.disable();
        }
        else {
            editor.enable();
        }
    };
    /*
    Returns a weaker, unprivileged proxy object that only exposes read-only
    accessors found on the editor instance, without any state-modifying methods.
    */
    ReactQuill.prototype.makeUnprivilegedEditor = function (editor) {
        var e = editor;
        return {
            getHTML: function () { return e.root.innerHTML; },
            getLength: e.getLength.bind(e),
            getText: e.getText.bind(e),
            getContents: e.getContents.bind(e),
            getSelection: e.getSelection.bind(e),
            getBounds: e.getBounds.bind(e),
        };
    };
    ReactQuill.prototype.getEditingArea = function () {
        if (!this.editingArea) {
            throw new Error('Instantiating on missing editing area');
        }
        var element = react_dom_1.default.findDOMNode(this.editingArea);
        if (!element) {
            throw new Error('Cannot find element for editing area');
        }
        if (element.nodeType === 3) {
            throw new Error('Editing area cannot be a text node');
        }
        return element;
    };
    /*
    Renders an editor area, unless it has been provided one to clone.
    */
    ReactQuill.prototype.renderEditingArea = function () {
        var _this = this;
        var _a = this.props, children = _a.children, preserveWhitespace = _a.preserveWhitespace;
        var generation = this.state.generation;
        var properties = {
            key: generation,
            ref: function (instance) {
                _this.editingArea = instance;
            },
        };
        if (react_1.default.Children.count(children)) {
            return react_1.default.cloneElement(react_1.default.Children.only(children), properties);
        }
        return preserveWhitespace ?
            react_1.default.createElement("pre", __assign({}, properties)) :
            react_1.default.createElement("div", __assign({}, properties));
    };
    ReactQuill.prototype.render = function () {
        var _a;
        return (react_1.default.createElement("div", { id: this.props.id, style: this.props.style, key: this.state.generation, className: "quill " + (_a = this.props.className, (_a !== null && _a !== void 0 ? _a : '')), onKeyPress: this.props.onKeyPress, onKeyDown: this.props.onKeyDown, onKeyUp: this.props.onKeyUp }, this.renderEditingArea()));
    };
    ReactQuill.prototype.onEditorChangeText = function (value, delta, source, editor) {
        var _a, _b;
        if (!this.editor)
            return;
        // We keep storing the same type of value as what the user gives us,
        // so that value comparisons will be more stable and predictable.
        var nextContents = this.isDelta(this.value)
            ? editor.getContents()
            : editor.getHTML();
        if (nextContents !== this.getEditorContents()) {
            // Taint this `delta` object, so we can recognize whether the user
            // is trying to send it back as `value`, preventing a likely loop.
            this.lastDeltaChangeSet = delta;
            this.value = nextContents;
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value, delta, source, editor);
        }
    };
    ReactQuill.prototype.onEditorChangeSelection = function (nextSelection, source, editor) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.editor)
            return;
        var currentSelection = this.getEditorSelection();
        var hasGainedFocus = !currentSelection && nextSelection;
        var hasLostFocus = currentSelection && !nextSelection;
        if (isEqual_1.default(nextSelection, currentSelection))
            return;
        this.selection = nextSelection;
        (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 ? void 0 : _b.call(_a, nextSelection, source, editor);
        if (hasGainedFocus) {
            (_d = (_c = this.props).onFocus) === null || _d === void 0 ? void 0 : _d.call(_c, nextSelection, source, editor);
        }
        else if (hasLostFocus) {
            (_f = (_e = this.props).onBlur) === null || _f === void 0 ? void 0 : _f.call(_e, currentSelection, source, editor);
        }
    };
    ReactQuill.prototype.focus = function () {
        if (!this.editor)
            return;
        this.editor.focus();
    };
    ReactQuill.prototype.blur = function () {
        if (!this.editor)
            return;
        this.selection = null;
        this.editor.blur();
    };
    ReactQuill.displayName = 'React Quill';
    /*
    Export Quill to be able to call `register`
    */
    ReactQuill.Quill = quill_1.default;
    ReactQuill.defaultProps = {
        theme: 'snow',
        modules: {},
        readOnly: false,
    };
    return ReactQuill;
}(react_1.default.Component));
/*
Small helper to execute a function in the next micro-tick.
*/
function postpone(fn) {
    Promise.resolve().then(fn);
}
module.exports = ReactQuill;
//# sourceMappingURL=index.js.map

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(900);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(901),
    isObjectLike = __webpack_require__(161);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(902),
    equalArrays = __webpack_require__(361),
    equalByTag = __webpack_require__(936),
    equalObjects = __webpack_require__(940),
    getTag = __webpack_require__(962),
    isArray = __webpack_require__(228),
    isBuffer = __webpack_require__(362),
    isTypedArray = __webpack_require__(363);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(156),
    stackClear = __webpack_require__(908),
    stackDelete = __webpack_require__(909),
    stackGet = __webpack_require__(910),
    stackHas = __webpack_require__(911),
    stackSet = __webpack_require__(912);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(156);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 911 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(156),
    Map = __webpack_require__(226),
    MapCache = __webpack_require__(360);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(356),
    isMasked = __webpack_require__(916),
    isObject = __webpack_require__(358),
    toSource = __webpack_require__(359);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(227);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(917);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(69);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(920),
    ListCache = __webpack_require__(156),
    Map = __webpack_require__(226);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(921),
    hashDelete = __webpack_require__(922),
    hashGet = __webpack_require__(923),
    hashHas = __webpack_require__(924),
    hashSet = __webpack_require__(925);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 922 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(360),
    setCacheAdd = __webpack_require__(932),
    setCacheHas = __webpack_require__(933);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 932 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 933 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(227),
    Uint8Array = __webpack_require__(937),
    eq = __webpack_require__(355),
    equalArrays = __webpack_require__(361),
    mapToArray = __webpack_require__(938),
    setToArray = __webpack_require__(939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(69);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 939 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(941);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(942),
    getSymbols = __webpack_require__(944),
    keys = __webpack_require__(947);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(943),
    isArray = __webpack_require__(228);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(945),
    stubArray = __webpack_require__(946);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 945 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 946 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(948),
    baseKeys = __webpack_require__(957),
    isArrayLike = __webpack_require__(961);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(949),
    isArguments = __webpack_require__(950),
    isArray = __webpack_require__(228),
    isBuffer = __webpack_require__(362),
    isIndex = __webpack_require__(953),
    isTypedArray = __webpack_require__(363);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(951),
    isObjectLike = __webpack_require__(161);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(158),
    isObjectLike = __webpack_require__(161);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 952 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(158),
    isLength = __webpack_require__(364),
    isObjectLike = __webpack_require__(161);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 955 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(357);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(196)(module)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(958),
    nativeKeys = __webpack_require__(959);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(960);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 960 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(356),
    isLength = __webpack_require__(364);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(963),
    Map = __webpack_require__(226),
    Promise = __webpack_require__(964),
    Set = __webpack_require__(965),
    WeakMap = __webpack_require__(966),
    baseGetTag = __webpack_require__(158),
    toSource = __webpack_require__(359);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(69);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(69);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(69);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(69);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(968).Buffer))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(969)
var ieee754 = __webpack_require__(970)
var isArray = __webpack_require__(971)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)))

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 970 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 971 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getManufacturerContacts=function getManufacturerContacts(_ref){var address=_ref.address,city=_ref.city,country=_ref.country,contactInfo=_ref.contactInfo,state=_ref.state,postalcode=_ref.postalcode;return Object.entries({Address:[address,city,state,postalcode,country].filter(Boolean).join(', '),Web:contactInfo.webAddress,Phone:contactInfo.phone}).filter(function(_ref2){var _ref3=_slicedToArray(_ref2,2),value=_ref3[1];return value;}).map(function(_ref4,index,initArr){var _ref5=_slicedToArray(_ref4,2),key=_ref5[0],value=_ref5[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,key,':'),' ',value,index+1===initArr.length?'':', ');});};var SummaryHeader=function(_React$Component){_inherits(SummaryHeader,_React$Component);function SummaryHeader(props){_classCallCheck(this,SummaryHeader);var _this=_possibleConstructorReturn(this,(SummaryHeader.__proto__||Object.getPrototypeOf(SummaryHeader)).call(this,props));_this.state={micNumber:null,isMicNumberLoading:true};return _this;}_createClass(SummaryHeader,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var isBoatManufacturer=this.props.isBoatManufacturer;if(isBoatManufacturer){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].micNumber).then(function(response){return _this2.setState({isMicNumberLoading:false,micNumber:response.data});}).catch(function(){return _this2.setState({isMicNumberLoading:false,micNumber:null});});}}},{key:'render',value:function render(){var _state=this.state,isMicNumberLoading=_state.isMicNumberLoading,micNumber=_state.micNumber;var _props=this.props,manufacturerName=_props.manufacturerName,manufacturerStatus=_props.manufacturerStatus,selectedManufacturer=_props.selectedManufacturer,isBoatManufacturer=_props.isBoatManufacturer;var manufacturerContacts=!!selectedManufacturer&&getManufacturerContacts(selectedManufacturer);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header summary-scene__scene-header'},manufacturerName+' Summary',isBoatManufacturer&&!isMicNumberLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary_mic_number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Manufacturer\'s Identification Code: '),micNumber||'—'),!!Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('length',manufacturerContacts)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary_header_contact'},manufacturerContacts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary-scene__manufacturer-status '+(manufacturerStatus?'active':'inactive')},manufacturerStatus?'Active':'Inactive'));}}]);return SummaryHeader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SummaryHeader);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CertificationSection=function(_React$Component){_inherits(CertificationSection,_React$Component);function CertificationSection(props){_classCallCheck(this,CertificationSection);var _this=_possibleConstructorReturn(this,(CertificationSection.__proto__||Object.getPrototypeOf(CertificationSection)).call(this,props));_this.saveCapacityTagInfo=Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["a" /* debounce */])(function(){return __WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].capacityTagStatus,{mnfCode:_this.props.user.selectedManufacturer.code,supplier:_this.state.supplier,isNmma:_this.state.isNmma});});_this.onChangeCapacityTagInfo=function(fieldName,fieldValue){_this.setState(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* assoc */])(fieldName,fieldValue));_this.saveCapacityTagInfo();};_this.state={isCapacityTagLoading:true,isNmma:null,supplier:null};return _this;}_createClass(CertificationSection,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].capacityTagStatus).then(function(_ref){var _ref$data=_ref.data,isNmma=_ref$data.isNmma,supplier=_ref$data.supplier;return _this2.setState({isCapacityTagLoading:false,isNmma:isNmma,supplier:supplier});}).catch(function(){return _this2.setState({isCapacityTagLoading:false});});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,currentYearInfo=_props.currentYearInfo,toggleCertificationStatus=_props.toggleCertificationStatus,user=_props.user;var _state=this.state,isCapacityTagLoading=_state.isCapacityTagLoading,isNmma=_state.isNmma,supplier=_state.supplier;var isBoatManufacturer=user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName;var getCertifiedIconClass=function getCertifiedIconClass(){var roleName=user.getRoleName();if(currentYearInfo.isCertified){return roleName===__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName?'__nmma-certified-icon':'__nmma-certified-ABYC-icon';}else{return roleName===__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName?'__nmma-not-certified-icon':'__nmma-not-certified-ABYC-icon';}};var getCertifiedStatusClass=function getCertifiedStatusClass(){return'summary-scene__certification-text summary-scene__certification-text_'+(currentYearInfo.isCertified?'certified':'not-certified');};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary_certification_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:getCertifiedIconClass()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:getCertifiedStatusClass()},currentYearInfo.isCertified?'Certified':'Certification Pending')),user.isInternal()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Slider__["a" /* default */],{mainWrapperClassName:'_margin_top_20 '+(currentYearInfo.isCertified?'green':''),state:!currentYearInfo.isCertified,label:'Certification',toggleAction:toggleCertificationStatus})),isBoatManufacturer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary_certification_column'},isCapacityTagLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _margin_top_40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Input__["a" /* Input */],{label:'Capacity Tag Supplier',placeholder:'Supplier...',inputClassName:'input__input-field_primary',onChange:function onChange(value){return _this3.onChangeCapacityTagInfo('supplier',value);},value:supplier,disabled:!user.isInternal()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Slider__["a" /* default */],{mainWrapperClassName:'_margin_top_20 '+(isNmma?'green':''),state:!isNmma,label:'NMMA as Supplier',toggleAction:function toggleAction(){return _this3.onChangeCapacityTagInfo('isNmma',!isNmma);},disabled:!user.isInternal()}))));}}]);return CertificationSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CertificationSection);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SummaryGeneralInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SummaryGeneralInfo=function(_PureComponent){_inherits(SummaryGeneralInfo,_PureComponent);function SummaryGeneralInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SummaryGeneralInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SummaryGeneralInfo.__proto__||Object.getPrototypeOf(SummaryGeneralInfo)).call.apply(_ref,[this].concat(args))),_this),_this._getYearsList=function(){var currentYear=_this.props.currentYear;var list=[];for(var i=-1;i<20;i++){list.push(currentYear-i);}return list;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SummaryGeneralInfo,[{key:'render',value:function render(){var _props=this.props,user=_props.user,currentYear=_props.currentYear,year=_props.year,handleRoleChange=_props.handleRoleChange,handleYearSelect=_props.handleYearSelect;if(!user.isInternal()&&(user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName||user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-header _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-header__text _color_dark_blue_2 _width_pc_100 _text_align_center'},'Welcome to NMMA Oil Certification!')));var _ref2=function(){var oilRoles=[];if(user.isOilManufacturer())oilRoles.push({name:'Oil formulator',value:__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName});if(user.isOilBrander())oilRoles.push({name:'Oil brander',value:__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName});var isTwoOilRolesAvailable=user.getRoleName()===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.readableName&&oilRoles.length===2;return{oilRoles:oilRoles,isTwoOilRolesAvailable:isTwoOilRolesAvailable};}(),oilRoles=_ref2.oilRoles,isTwoOilRolesAvailable=_ref2.isTwoOilRolesAvailable;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section scene_section_two-columns  _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName||user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_2_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName?'General Info':'Model Year'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{isSlave:true,withoutSearch:true,mainWrapperClassName:isTwoOilRolesAvailable?'_margin_top_34':'',selectionList:this._getYearsList(),defaultItem:year?year.toString():'',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primary,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.yearSelectHeader,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select__sub-label'},this.modelYearReminder)),labelClassName:'_flex',placeholder:'Type year or pick-up one',handleSelect:handleYearSelect,isLoading:!currentYear}),isTwoOilRolesAvailable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{withoutSearch:true,selectionList:oilRoles,itemNameIndicator:'name',defaultItem:oilRoles[0],type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primary,label:'Manufacturer role',handleSelect:handleRoleChange}));}}]);return SummaryGeneralInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SummaryCheckList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Info__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_DatePicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_ProgressBar__ = __webpack_require__(976);
var EMPTY_CELL=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'-');function SummaryCheckList(_ref){var checklist=_ref.checklist,user=_ref.user,isInternalUser=_ref.isInternalUser,chosenYear=_ref.chosenYear,documentTypeForListLink=_ref.documentTypeForListLink,onCheckListStatusChange=_ref.onCheckListStatusChange,onCheckListDateChange=_ref.onCheckListDateChange,onCheckListAutomationChange=_ref.onCheckListAutomationChange,onCheckListApplicableChange=_ref.onCheckListApplicableChange;if(!checklist.length){return null;}var redirectToDocuments=function redirectToDocuments(statusType){return function(){if(documentTypeForListLink[statusType]){user.goTo(user.getDocumentsLink({chosenYear:chosenYear,filter:{typeTitle:documentTypeForListLink[statusType]}}));}};};var totalItemsAmount=checklist.filter(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["h" /* prop */])('isApplicable')).length;var checkedItemsAmount=checklist.reduce(function(acc,_ref2){var isChecked=_ref2.isChecked,isApplicable=_ref2.isApplicable;return isApplicable&&isChecked?acc+1:acc;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section  _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Checklist Progress '+checkedItemsAmount+' of '+totalItemsAmount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_ProgressBar__["a" /* default */],{maxValue:totalItemsAmount,value:checkedItemsAmount,mainWrapperClassName:'_margin_top_20'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section  _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Certification Checklist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper _margin_top_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small list__row-item_place-filler'},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20'},'Date'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20 _text_align_center'},'Automatic'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20 _text_align_center'},'Passed or Signed'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20 _text_align_center'},'Not Applicable')),checklist.map(function(_ref3,index){var id=_ref3.id,autoSet=_ref3.autoSet,date=_ref3.date,hasAutoSet=_ref3.hasAutoSet,name=_ref3.name,statusType=_ref3.statusType,isChecked=_ref3.isChecked,isApplicable=_ref3.isApplicable,updated=_ref3.updated;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'list__row list__row_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_place-filler '+(documentTypeForListLink[statusType]?'_cursor_pointer __hover-bold-text':''),onClick:redirectToDocuments(statusType)},index+1+'. '+name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_20 _jc_start'},!isApplicable?EMPTY_CELL:isChecked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(date||updated).local().format('MM/DD/YYYY'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_DatePicker__["a" /* default */],{selectedDate:date||updated,noInput:true,handleSelectDate:onCheckListDateChange(id)})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_margin_left_30'},'-')),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_20'},!isApplicable||!hasAutoSet?EMPTY_CELL:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Slider__["a" /* default */],{state:!autoSet,mainWrapperClassName:''+(autoSet?'green':''),sliderBodyClassName:'slider-body_small',toggleAction:function toggleAction(){return onCheckListAutomationChange(id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_20'},!isApplicable?EMPTY_CELL:autoSet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(isChecked?'__checkbox_checked __checkbox_checked_frozen':'__checkbox_red-exclamation-mark ')}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Will be updated automatically')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(isChecked?'__checkbox_checked':'__checkbox_empty')+' '+(user.isInternal()?'_cursor_pointer':''),onClick:function onClick(){return onCheckListStatusChange(id);}})),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_20'},hasAutoSet?EMPTY_CELL:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(isApplicable?'__checkbox_empty':'__checkbox_checked')+' '+(user.isInternal()?'_cursor_pointer':''),onClick:function onClick(){return onCheckListApplicableChange({id:id,prevValue:isApplicable});}})));}))));}

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var maxValue=_ref.maxValue,value=_ref.value,_ref$mainWrapperClass=_ref.mainWrapperClassName,mainWrapperClassName=_ref$mainWrapperClass===undefined?'':_ref$mainWrapperClass,_ref$textClassName=_ref.textClassName,textClassName=_ref$textClassName===undefined?'':_ref$textClassName,_ref$barClassName=_ref.barClassName,barClassName=_ref$barClassName===undefined?'':_ref$barClassName;var percent=(value/maxValue*100).toFixed(1);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progressBar_wrapper '+mainWrapperClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progressBar_text '+textClassName},percent+'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progressBar_bar '+barClassName,style:{width:percent+'%'}}));});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BRAND_TYPES=[{name:'Boat',value:'BOAT'},{name:'PWC',value:'PWC'}];var BrandDetailsModal=function(_React$Component){_inherits(BrandDetailsModal,_React$Component);function BrandDetailsModal(){_classCallCheck(this,BrandDetailsModal);return _possibleConstructorReturn(this,(BrandDetailsModal.__proto__||Object.getPrototypeOf(BrandDetailsModal)).apply(this,arguments));}_createClass(BrandDetailsModal,[{key:'render',value:function render(){var _props=this.props,brandDetails=_props.brandDetails,handleInputChange=_props.handleInputChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Input__["a" /* Input */],{styleClass:'primary',mainWrapperClassName:'_width_pc_100 _text_align_left',label:'Brand Name *',value:brandDetails.name,error:brandDetails.errors.name,onChange:handleInputChange('name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Input__["a" /* Input */],{styleClass:'primary',mainWrapperClassName:'_width_pc_100 _text_align_left',label:'Website Address *',value:brandDetails.web,error:brandDetails.errors.web,onChange:handleInputChange('web')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{selectionList:BRAND_TYPES,type:'primary',mainWrapperClassName:'_width_pc_100',itemNameIndicator:'name',defaultItem:BRAND_TYPES.find(function(item){return item.value===brandDetails.boatType;}),label:'Boat Type *',error:brandDetails.errors.boatType,withoutSearch:true,handleSelect:handleInputChange('boatType')}));}}]);return BrandDetailsModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BrandDetailsModal);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BrandsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Button__ = __webpack_require__(6);
function BrandsList(_ref){var list=_ref.list,isInternalUser=_ref.isInternalUser,addBrand=_ref.addBrand,editBrand=_ref.editBrand,deleteBrand=_ref.deleteBrand,isInspector=_ref.isInspector;if(isInspector&&!list.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Brands'),!isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene_section_subheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__attention-icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_margin_left_10'},'Please contact NMMA if you don\'t see any of your brands below.')),!!list.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper _margin_top_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small list__row-item_place-filler'},'Brand Name'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20'},'Website Address'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20'},'Boat Type'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_10 _text_align_center'},'Edit'),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_10 _text_align_center'},'Delete')),list.map(function(ListItem,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__row_small',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'list__row-item list__row-item_small list__row-item_place-filler',href:ListItem.web,target:'_blank',rel:'noreferrer'},index+1+'. '+ListItem.name),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_20'},ListItem.web),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_20'},ListItem.boatType),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small list__row-item_component _width_pc_10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_download-icon',onClick:editBrand(ListItem)})),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small list__row-item_component _width_pc_10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__remove-icon',onClick:deleteBrand(ListItem.id)})));}))),isInternalUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'+ Add Brand',buttonClassName:'_height_40 _width_160 _margin_top_20',onClick:addBrand}));}

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getShouldLoadInspectorContacts=function getShouldLoadInspectorContacts(user){return Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["c" /* getIsBoatManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["g" /* getIsTrailerManufacturer */])(user);};//const getShouldLoadInspectorContacts = user => true;
var Contacts=function(_React$Component){_inherits(Contacts,_React$Component);function Contacts(props){_classCallCheck(this,Contacts);var _this=_possibleConstructorReturn(this,(Contacts.__proto__||Object.getPrototypeOf(Contacts)).call(this,props));_this.state={engineeringContacts:null,inspectionContacts:null,isEngineeringContactsLoading:true,isInspectionContactsLoading:true};return _this;}_createClass(Contacts,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;//const code = user.selectedManufacturer.code;
var code=user.getManufacturerCode();var shouldLoadInspectorContacts=getShouldLoadInspectorContacts(user);__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].getEngineeringContacts(code)).then(function(response){return _this2.setState({isEngineeringContactsLoading:false,engineeringContacts:response.data});}).catch(function(){return _this2.setState({isEngineeringContactsLoading:false,engineeringContacts:null});}).finally(function(){if(shouldLoadInspectorContacts){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].getInspectorContacts(code)).then(function(response){return _this2.setState({isInspectionContactsLoading:false,inspectionContacts:response.data});}).catch(function(){return _this2.setState({isInspectionContactsLoading:false,inspectionContacts:null});});}else{_this2.setState({isInspectionContactsLoading:false});}});}},{key:'render',value:function render(){var user=this.props.user;var _state=this.state,engineeringContacts=_state.engineeringContacts,inspectionContacts=_state.inspectionContacts,isEngineeringContactsLoading=_state.isEngineeringContactsLoading,isInspectionContactsLoading=_state.isInspectionContactsLoading;var shouldLoadInspectorContacts=getShouldLoadInspectorContacts(user);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Engineering Standards Contact'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_margin_top_10'},isEngineeringContactsLoading?'Loading...':!Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('length',engineeringContacts)?'No Contacts':engineeringContacts.map(function(_ref){var firstName=_ref.firstName,lastName=_ref.lastName,email=_ref.email;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:email,className:'engineering_contacts_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,firstName,' ',lastName),' - ',email);}))),shouldLoadInspectorContacts&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_15 _padding_bottom_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Inspector Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_margin_top_10'},isInspectionContactsLoading?'Loading...':!Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('length',inspectionContacts)?'No Contacts':inspectionContacts.map(function(_ref2){var company=_ref2.company,firstName=_ref2.firstName,lastName=_ref2.lastName,email=_ref2.email;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:email,className:'engineering_contacts_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,firstName,' ',lastName,' (',company.name,')'),' - ',email);}))));}}]);return Contacts;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Contacts);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MMLReport__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HistoricMMLReport__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CARBReport__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ComponentList__ = __webpack_require__(985);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportScene=function(_React$Component){_inherits(ReportScene,_React$Component);function ReportScene(props){_classCallCheck(this,ReportScene);var _this=_possibleConstructorReturn(this,(ReportScene.__proto__||Object.getPrototypeOf(ReportScene)).call(this,props));_this._initReportTypes=function(){var user=_this.props.user;var reportTypes=[];if(!user.isInspector()&&(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName||user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName)){reportTypes.push({name:'Master Model List',type:'MML',requiredFields:['reportYear','contact'],actionButtonLabel:'E-Sign',actionConfirmMessage:'Are you sure you want to generate and e-sign the Master Model List?'});}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName||user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){reportTypes.push({name:'Historic Master Model List',type:'HistoricMML',requiredFields:['reportYear','reportDate'],actionButtonLabel:'Download',actionConfirmMessage:'Are you sure you want to generate and e-sign the Master Model List?'});}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){reportTypes.push({name:'Capacity tag',type:'CARB',requiredFields:['reportYear','reportSubType','tagType','selectedBoatsList'],requiredBoatListFields:['qty'],additionalRequiredFieldsByReportSubType:{'CARB':{requiredFields:[],requiredBoatListFields:['EVAPFamily','emission']}},actionButtonLabel:'Download',actionConfirmMessage:''});}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName){reportTypes.push({name:'List report',type:'ComponentList',requiredFields:['selectedTypesList'],additionalRequiredFieldsByReportSubType:{},actionButtonLabel:'Download',actionConfirmMessage:''});}return reportTypes;};_this._initAPI=function(){var user=_this.props.user;if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */];}else if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */];}else if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_14_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */];}};_this.handleReportTypeSelect=function(selectedReport){var user=_this.props.user;var selectedBoatsList=_this.state.selectedBoatsList;_this.modalBody='If you change this setting, all previously added data will be deleted';_this.modalConfirmAction=function(){_this.requiredFields=[].concat(_toConsumableArray(selectedReport.requiredFields));_this.requiredBoatListFields=selectedReport.requiredBoatListFields?[].concat(_toConsumableArray(selectedReport.requiredBoatListFields)):[];_this.setState({reportSubType:'',inputErrors:{},reportYear:'',//contact: '',
reportDate:'',selectedBoatsList:[],isModalOpen:false,modalRequestInProcess:false,downloadRequestInProcess:false,tagType:'Mylar',PO:'',RUSH:'',selectedTypesList:[],selectedReport:selectedReport},function(){return _this.handleYearSelect(user.getSelectedYear()||_this.currentModelYear);});};if(!selectedBoatsList.length)_this.modalConfirmAction();else _this.setState({isModalOpen:true});};_this.handleReportSubTypeSelect=function(type){var _this$state=_this.state,selectedBoatsList=_this$state.selectedBoatsList,selectedReport=_this$state.selectedReport;_this.modalBody='If you change this setting, all previously added data will be deleted';_this.modalConfirmAction=function(){_this.setState({reportSubType:type,inputErrors:{},isModalOpen:false,selectedBoatsList:[]},function(){var additionalFieldsLists=selectedReport.additionalRequiredFieldsByReportSubType[type];if(additionalFieldsLists){_this.requiredFields=[].concat(_toConsumableArray(selectedReport.requiredFields),_toConsumableArray(additionalFieldsLists.requiredFields));_this.requiredBoatListFields=selectedReport.requiredBoatListFields&&additionalFieldsLists.requiredBoatListFields?[].concat(_toConsumableArray(selectedReport.requiredBoatListFields),_toConsumableArray(additionalFieldsLists.requiredBoatListFields)):[];}else{_this.requiredFields=[].concat(_toConsumableArray(selectedReport.requiredFields));_this.requiredBoatListFields=selectedReport.requiredBoatListFields?[].concat(_toConsumableArray(selectedReport.requiredBoatListFields)):[];}});};if(!selectedBoatsList.length)_this.modalConfirmAction();else _this.setState({isModalOpen:true});};_this.handleYearSelect=function(inputYear){var user=_this.props.user;var _this$state2=_this.state,inputErrors=_this$state2.inputErrors,selectedBoatsList=_this$state2.selectedBoatsList,reportYear=_this$state2.reportYear;if(inputYear!==reportYear){delete inputErrors.reportYear;user.saveSelectedYear(inputYear);_this.modalBody='If you change this setting, all previously added data will be deleted';_this.modalConfirmAction=function(){_this.setState({reportYear:inputYear,inputErrors:inputErrors,isModalOpen:false,selectedBoatsList:[]});};if(!selectedBoatsList.length)_this.modalConfirmAction();else _this.setState({isModalOpen:true});}};_this.handleContactSelect=function(input){var _this$state3=_this.state,inputErrors=_this$state3.inputErrors,contact=_this$state3.contact;var newInputErrors=inputErrors;var selectedItem=input.value||input;delete newInputErrors.contact;_this.setState({contact:selectedItem,inputErrors:newInputErrors});};_this.handleDateChoose=function(utcDate,error){var _this$state4=_this.state,inputErrors=_this$state4.inputErrors,selectedReport=_this$state4.selectedReport;delete inputErrors.reportDate;if(error)inputErrors.reportDate='Provide valid date, or completely delete it';else if(selectedReport.type==='HistoricMML'&&utcDate>__WEBPACK_IMPORTED_MODULE_1_moment___default()().utc())inputErrors.reportDate='Unable to provide historic report for future date';_this.setState({reportDate:utcDate,inputErrors:inputErrors});};_this.handleTagTypeSelect=function(tag){var _this$state5=_this.state,selectedBoatsList=_this$state5.selectedBoatsList,inputErrors=_this$state5.inputErrors;var newInputErrors=inputErrors;delete newInputErrors.tagType;_this.modalBody='If you change this setting, all previously added data will be deleted';_this.modalConfirmAction=function(){_this.setState({tagType:tag,inputErrors:newInputErrors,isModalOpen:false,selectedBoatsList:[]});};if(!selectedBoatsList.length)_this.modalConfirmAction();else _this.setState({isModalOpen:true});};_this.handleSelect=function(fieldName){return function(input){var _this$setState;var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var selectedItem=input.value||input;delete newInputErrors[fieldName];_this.setState((_this$setState={},_defineProperty(_this$setState,fieldName,selectedItem),_defineProperty(_this$setState,'inputErrors',newInputErrors),_this$setState));};};_this.closeModal=function(){_this.setState({modalRequestInProcess:false,isModalOpen:false});};_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;if(!error||error.ops){var _this$setState2;var newInputErrors=inputErrors;delete newInputErrors[field];_this.setState((_this$setState2={},_defineProperty(_this$setState2,field,value),_defineProperty(_this$setState2,'inputErrors',newInputErrors),_this$setState2));}};};_this.handleToggleValue=function(field){return function(){_this.setState(function(prevState){return _defineProperty({},field,!prevState[field]);});};};_this.addBoat=function(boat){var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;delete newInputErrors.selectedBoatsList;var newSelectedBoatsList=_this.state.selectedBoatsList;newSelectedBoatsList.push(boat);_this.setState({selectedBoatsList:newSelectedBoatsList,inputErrors:newInputErrors});};_this.removeBoat=function(index){return function(){var newSelectedBoatsList=_this.state.selectedBoatsList;newSelectedBoatsList.splice(index,1);_this.setState({selectedBoatsList:newSelectedBoatsList});};};_this.handleBoatParamChange=function(boatId,index,param){return function(value){var _this$state6=_this.state,selectedBoatsList=_this$state6.selectedBoatsList,inputErrors=_this$state6.inputErrors;var newSelectedBoatsList=selectedBoatsList;var newInputErrors=inputErrors;if(newInputErrors.boatsListErrors&&newInputErrors.boatsListErrors[boatId]){delete newInputErrors.boatsListErrors[boatId][param];if(!Object.keys(newInputErrors.boatsListErrors[boatId]).length)delete newInputErrors.boatsListErrors[boatId];if(!Object.keys(newInputErrors.boatsListErrors).length)delete newInputErrors.boatsListErrors;}newSelectedBoatsList[index][param]=value;_this.setState({selectedBoatsList:newSelectedBoatsList,inputErrors:newInputErrors});};};_this.addComponentTypeId=function(typeId){var _this$state7=_this.state,selectedTypesList=_this$state7.selectedTypesList,inputErrors=_this$state7.inputErrors;selectedTypesList.push(typeId);delete inputErrors.selectedTypesList;_this.setState({selectedTypesList:selectedTypesList});};_this.removeComponentTypeId=function(typeId){var selectedTypesList=_this.state.selectedTypesList;var typeIndex=selectedTypesList.indexOf(typeId);if(typeIndex!==-1)selectedTypesList.splice(typeIndex,1);_this.setState({selectedTypesList:selectedTypesList});};_this.clearComponentTypeIds=function(){_this.setState({selectedTypesList:[]});};_this.normalizePlateType=function(plateType){if(!plateType)return plateType;var stringifiedPlateType=plateType.toString();return stringifiedPlateType.includes('PLATE_TYPE_')?stringifiedPlateType:'PLATE_TYPE_'+stringifiedPlateType;};_this.getReportFilters=function(){var _this$state8=_this.state,selectedReport=_this$state8.selectedReport,inputErrors=_this$state8.inputErrors,reportYear=_this$state8.reportYear,contact=_this$state8.contact,reportDate=_this$state8.reportDate,selectedBoatsList=_this$state8.selectedBoatsList,reportSubType=_this$state8.reportSubType,tagType=_this$state8.tagType,RUSH=_this$state8.RUSH,PO=_this$state8.PO,selectedTypesList=_this$state8.selectedTypesList;switch(selectedReport.type){case'MML':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MMLReport__["a" /* default */],{inputErrors:inputErrors,handleSelect:_this.handleSelect,handleYearSelect:_this.handleYearSelect,handleContactSelect:_this.handleContactSelect,yearsList:_this.yearsList,contactsList:_this.contactsList,reportYear:reportYear,contact:contact});case'HistoricMML':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HistoricMMLReport__["a" /* default */],{inputErrors:inputErrors,handleSelect:_this.handleSelect,handleYearSelect:_this.handleYearSelect,yearsList:_this.yearsList,reportYear:reportYear,reportDate:reportDate,handleDateChoose:_this.handleDateChoose});case'CARB':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CARBReport__["a" /* default */],{inputErrors:inputErrors,handleSelect:_this.handleSelect,handleYearSelect:_this.handleYearSelect,yearsList:_this.yearsList,handleTagTypeSelect:_this.handleTagTypeSelect,handleReportSubTypeSelect:_this.handleReportSubTypeSelect,handleDateChoose:_this.handleDateChoose,handleInputChange:_this.handleInputChange,handleToggleValue:_this.handleToggleValue,reportSubType:reportSubType,tagType:tagType,reportYear:reportYear,RUSH:RUSH,PO:PO,reportDate:reportDate,addBoat:_this.addBoat,removeBoat:_this.removeBoat,selectedBoatsList:selectedBoatsList,handleBoatParamChange:_this.handleBoatParamChange});case'ComponentList':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ComponentList__["a" /* default */],{inputErrors:inputErrors,addComponentTypeId:_this.addComponentTypeId,removeComponentTypeId:_this.removeComponentTypeId,selectedTypesList:selectedTypesList,clearComponentTypeIds:_this.clearComponentTypeIds});default:return null;}};_this.validateForm=function(){var _this$state9=_this.state,selectedReport=_this$state9.selectedReport,inputErrors=_this$state9.inputErrors,selectedBoatsList=_this$state9.selectedBoatsList;var newInputErrors=inputErrors;if(!selectedReport.type)newInputErrors.selectedReport='Please choose report type';else{_this.requiredFields.forEach(function(fieldname){var fieldToCheck=_this.state[fieldname];if(!fieldToCheck||Array.isArray(fieldToCheck)&&!fieldToCheck.length)newInputErrors[fieldname]=true;});if(_this.requiredBoatListFields.length){selectedBoatsList.forEach(function(boat){_this.requiredBoatListFields.forEach(function(fieldName){if(!boat[fieldName]){if(!newInputErrors.boatsListErrors)newInputErrors.boatsListErrors={};if(!newInputErrors.boatsListErrors[boat.id])newInputErrors.boatsListErrors[boat.id]={};newInputErrors.boatsListErrors[boat.id][fieldName]=true;if(fieldName==='qty')__WEBPACK_IMPORTED_MODULE_13_dom_managers_notification__["a" /* default */].error('note','Please enter quantity for every boat in a list');}});});}}return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length)reject();else resolve();});});};_this.downloadOrSignReport=function(){var _this$state10=_this.state,selectedReport=_this$state10.selectedReport,reportYear=_this$state10.reportYear,contact=_this$state10.contact,reportSubType=_this$state10.reportSubType,RUSH=_this$state10.RUSH,PO=_this$state10.PO,tagType=_this$state10.tagType,selectedBoatsList=_this$state10.selectedBoatsList,reportDate=_this$state10.reportDate,selectedTypesList=_this$state10.selectedTypesList;var user=_this.props.user;_this.validateForm().then(function(){var name='';switch(selectedReport.type){case'MML':_this.modalBody=selectedReport.actionConfirmMessage;_this.modalConfirmAction=function(){_this.setState({modalRequestInProcess:true});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(_this.api.getMMLReport(reportYear,encodeURIComponent(contact.email)),{responseType:'blob'}).then(function(){return __WEBPACK_IMPORTED_MODULE_13_dom_managers_notification__["a" /* default */].success(1,'Master Model List has been successfully generated and sent for e-signature to DocuSign.');}).finally(_this.closeModal);};_this.setState({isModalOpen:true});break;case'HistoricMML':name='Historic_MML_'+reportDate.format('YYYY-MM-DD')+'_'+user.getManufacturerName()+'.pdf';_this.setState({downloadRequestInProcess:true},function(){var dateString=reportDate.utc().format('YYYY-MM-DD');__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(_this.api.getHistoricMMLReport(reportYear,dateString),{responseType:'blob'}).then(function(_ref2){var data=_ref2.data;Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["b" /* downloadFile */])(data,name);}).finally(function(){_this.setState({downloadRequestInProcess:false});});});break;case'CARB':{name=reportSubType.toUpperCase()+'_'+reportYear+'_'+user.getManufacturerName()+'.xlsx';var dataPayload={'capacityTagReportType':reportSubType.toUpperCase(),'deliveryDate':reportDate.isValid&&reportDate.isValid()?reportDate.utc():null,'isRush':!!RUSH,'modelYear':reportYear,'poNumber':!PO?null:PO,'tagType':tagType.toUpperCase()};dataPayload.boatReportRequests=selectedBoatsList.map(function(boat){return{'boatId':boat.id,'californiaEVAPFamily':boat.EVAPFamily,'emissionControlSystem':boat.emission,'plateType':_this.normalizePlateType(boat.plateType),'quantity':boat.qty};});_this.setState({downloadRequestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(_this.api.getCARBReport,dataPayload,{responseType:'blob'}).then(function(_ref3){var data=_ref3.data;Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["b" /* downloadFile */])(data,name);}).finally(function(){_this.setState({selectedBoatsList:[]},function(){_this.handleReportTypeSelect(_this.reportTypes[2]);});});});break;}case'ComponentList':{name='ComponentList_'+user.getManufacturerName()+'.pdf';_this.setState({downloadRequestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].listReport(selectedTypesList),{responseType:'blob'}).then(function(_ref4){var data=_ref4.data;Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["b" /* downloadFile */])(data,name);}).finally(function(){_this.setState({downloadRequestInProcess:false});});});break;}default:Object(__WEBPACK_IMPORTED_MODULE_4_utils__["c" /* consoleWarninig */])('Attempted to download unknown report of '+selectedReport.type+' type');}});};_this.state={selectedReport:{},reportSubType:'',inputErrors:{},reportYear:'',contact:null,reportDate:'',selectedBoatsList:[],isModalOpen:false,modalRequestInProcess:false,downloadRequestInProcess:false,tagType:'Mylar',PO:'',RUSH:'',selectedTypesList:[]};_this.requiredFields=[];_this.requiredBoatListFields=[];_this.currentModelYear=new Date().getFullYear();_this.yearsList=[];_this.contactsList=[];_this.modalBody='';_this.reportTypes=_this._initReportTypes();_this.api=_this._initAPI();return _this;}_createClass(ReportScene,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;var code=user.selectedManufacturer.code;if(this.api.currentModelYear){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(this.api.currentModelYear).then(function(_ref5){var currentModelYear=_ref5.data;_this2.currentModelYear=currentModelYear.length?+(currentModelYear[1]||currentModelYear[0]):+currentModelYear;for(var i=+_this2.currentModelYear+1;i>_this2.currentModelYear-20;i--){_this2.yearsList.push(i);}});}__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].getEngineeringContacts(code)).then(function(response){_this2.contactsList=response.data;var c=response.data[0];_this2.setState({contact:c});}).catch(function(){_this2.setState({contact:null});_this2.contactsList=[];});if(this.reportTypes.length===1)this.handleReportTypeSelect(this.reportTypes[0]);}},{key:'render',value:function render(){var _state=this.state,selectedReport=_state.selectedReport,inputErrors=_state.inputErrors,isModalOpen=_state.isModalOpen,modalRequestInProcess=_state.modalRequestInProcess,downloadRequestInProcess=_state.downloadRequestInProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'application-scene'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Reports'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-type-choose-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Report'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Select__["a" /* default */],{selectionList:this.reportTypes,defaultItem:selectedReport,type:__WEBPACK_IMPORTED_MODULE_6_Components_Select__["b" /* selectType */].primary,dropDownClassName:'_top_51',withoutSearch:true,placeholder:'Please select report\u2026',itemNameIndicator:'name',error:inputErrors.selectedReport,handleSelect:this.handleReportTypeSelect})),selectedReport.type&&this.getReportFilters(),selectedReport.type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_ApplicationActions__["a" /* default */],{saveButtonLabel:selectedReport.actionButtonLabel,disableSaveButton:downloadRequestInProcess,saveButtonAction:this.downloadOrSignReport})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_11_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_11_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',disabledWithSpinner:modalRequestInProcess,onClick:this.modalConfirmAction}))));}}]);return ReportScene;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/**
 * Components
 *//* harmony default export */ __webpack_exports__["a"] = (function(_ref){var inputErrors=_ref.inputErrors,handleSelect=_ref.handleSelect,handleYearSelect=_ref.handleYearSelect,handleContactSelect=_ref.handleContactSelect,yearsList=_ref.yearsList,contactsList=_ref.contactsList,reportYear=_ref.reportYear,contact=_ref.contact;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-filters-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Report Filters'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:yearsList,defaultItem:reportYear,mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',label:'Model Year *',error:inputErrors.reportYear,withoutSearch:true,handleSelect:handleYearSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:contactsList,defaultItem:contact,itemNameIndicator:'email',mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',label:'Recipient *',error:inputErrors.contact,withoutSearch:true,handleSelect:handleSelect('contact')}));});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_DatePicker__ = __webpack_require__(101);
/**
 * Components
 *//* harmony default export */ __webpack_exports__["a"] = (function(_ref){var inputErrors=_ref.inputErrors,handleSelect=_ref.handleSelect,handleYearSelect=_ref.handleYearSelect,yearsList=_ref.yearsList,reportYear=_ref.reportYear,monthsList=_ref.monthsList,reportDate=_ref.reportDate,isHistoric=_ref.isHistoric,handleDateChoose=_ref.handleDateChoose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-filters-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Report Filters'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-fields-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:yearsList,defaultItem:reportYear,type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primary,mainWrapperClassName:'_margin_top_0 _margin_right_30',label:'Model Year *',error:inputErrors.reportYear,withoutSearch:true,handleSelect:handleYearSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_DatePicker__["a" /* default */],{error:inputErrors.reportDate,selectedDate:reportDate,handleSelectDate:handleDateChoose,mainWrapperClassName:'_margin_top_12'})));});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BoatsList__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Checkbox__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_DatePicker__ = __webpack_require__(101);
/**
 * Components
 *//* harmony default export */ __webpack_exports__["a"] = (function(_ref){var inputErrors=_ref.inputErrors,handleSelect=_ref.handleSelect,handleYearSelect=_ref.handleYearSelect,yearsList=_ref.yearsList,handleTagTypeSelect=_ref.handleTagTypeSelect,handleReportSubTypeSelect=_ref.handleReportSubTypeSelect,handleToggleValue=_ref.handleToggleValue,handleInputChange=_ref.handleInputChange,addBoat=_ref.addBoat,removeBoat=_ref.removeBoat,reportSubType=_ref.reportSubType,tagType=_ref.tagType,reportYear=_ref.reportYear,RUSH=_ref.RUSH,PO=_ref.PO,reportDate=_ref.reportDate,selectedBoatsList=_ref.selectedBoatsList,handleBoatParamChange=_ref.handleBoatParamChange,handleDateChoose=_ref.handleDateChoose;var reportSubTypesList=['Regular','CARB'];var tagTypesList=['Mylar','Aluminum'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-subtype-choose-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Report Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:reportSubTypesList,mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',defaultItem:reportSubType,withoutSearch:true,isSlave:true,label:'Report Subtype *',error:inputErrors.reportSubType,handleSelect:handleReportSubTypeSelect}),reportSubType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:tagTypesList,mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',defaultItem:tagType,label:'Tag Type *',error:inputErrors.tagType,handleSelect:handleTagTypeSelect,withoutSearch:true,disabled:reportSubType==='CARB'})),reportSubType&&tagType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-filters-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Additional Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:yearsList,mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',defaultItem:reportYear,label:'Model Year *',error:inputErrors.reportYear,withoutSearch:true,handleSelect:handleYearSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Checkbox__["a" /* default */],{label:'RUSH',value:RUSH,onChange:handleToggleValue('RUSH')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{label:'PO #',inputClassName:'_border_radius_10 _margin_bottom_20 _margin_top_12 _height_40 _width_330',error:inputErrors.PO,value:PO,onChange:handleInputChange('PO')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_DatePicker__["a" /* default */],{label:'Delivery Date',error:inputErrors.reportDate,selectedDate:reportDate,handleSelectDate:handleDateChoose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BoatsList__["a" /* default */],{reportSubType:reportSubType,tagType:tagType,handleInputChange:handleInputChange,addBoat:addBoat,removeBoat:removeBoat,selectedBoatsList:selectedBoatsList,handleBoatParamChange:handleBoatParamChange,inputErrors:inputErrors,reportYear:reportYear})));});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLATE_TYPE_OPTIONS=['1','2','3','4','5','6','7','8','9','10'];var BoatsList=function(_React$Component){_inherits(BoatsList,_React$Component);function BoatsList(props){_classCallCheck(this,BoatsList);var _this=_possibleConstructorReturn(this,(BoatsList.__proto__||Object.getPrototypeOf(BoatsList)).call(this,props));_this.updateBoatsList=function(){var reportYear=_this.props.reportYear;if(reportYear){_this.setState({boatsListYear:reportYear,boatListRequestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].approvedBoatsByYear(reportYear)).then(function(_ref){var data=_ref.data;_this.setState({availableBoatsList:data,boatListRequestInProcess:false});if(!data.length)__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error('note','Cannot generate a Capacity tag report: there are no approved boat models for a selected year.');});});}else{_this.setState({boatsListYear:reportYear,availableBoatsList:[],boatListRequestInProcess:false});}};_this.getPlateTypeOption=function(plateType){if(!plateType)return'';return plateType.toString().replace('PLATE_TYPE_','');};_this.state={boatListRequestInProcess:true,availableBoatsList:[],boatsListYear:''};return _this;}_createClass(BoatsList,[{key:'componentDidMount',value:function componentDidMount(){this.updateBoatsList();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.reportYear!==this.state.boatsListYear){this.updateBoatsList();}}},{key:'render',value:function render(){var _props=this.props,selectedBoatsList=_props.selectedBoatsList,reportSubType=_props.reportSubType,tagType=_props.tagType,addBoat=_props.addBoat,removeBoat=_props.removeBoat,handleBoatParamChange=_props.handleBoatParamChange,inputErrors=_props.inputErrors,reportYear=_props.reportYear;var _state=this.state,boatListRequestInProcess=_state.boatListRequestInProcess,availableBoatsList=_state.availableBoatsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-boat-list-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Report Boat List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Select__["a" /* default */],{multiSelect:true,mainWrapperClassName:'_width_450',type:__WEBPACK_IMPORTED_MODULE_5_Components_Select__["b" /* selectType */].primarySmall,disabled:!reportYear||!availableBoatsList.length,isLoading:boatListRequestInProcess,selectionList:availableBoatsList.filter(function(boat){return(tagType!=='Mylar'||boat.boatType!==__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["B" /* YACHT */])&&!selectedBoatsList.find(function(selectedBoat){return selectedBoat.id===boat.id;});}),error:inputErrors.selectedBoatsList,itemNameIndicator:['id','name'],handleSelect:addBoat,placeholder:'ID or Model Name'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boats-list '+(reportSubType==='CARB'?'with-CARB-fields':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column model-name'},'Model Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column id'},'ID'),reportSubType==='CARB'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column EVAP-family'},'California EVAP Family*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column emission'},'Emission ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Control System*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column qty'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column remove'},'Remove')),selectedBoatsList.map(function(boat,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'componentRow'+boat.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column model-name'},boat.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column id'},boat.id),reportSubType==='CARB'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column EVAP-family'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{value:boat.EVAPFamily,inputClassName:'_border_radius_10 _height_20 _width_110',error:inputErrors.boatsListErrors&&inputErrors.boatsListErrors[boat.id]&&inputErrors.boatsListErrors[boat.id].EVAPFamily,onChange:handleBoatParamChange(boat.id,index,'EVAPFamily')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column emission'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{value:boat.emission,inputClassName:'_border_radius_10 _height_20 _width_50',error:inputErrors.boatsListErrors&&inputErrors.boatsListErrors[boat.id]&&inputErrors.boatsListErrors[boat.id].emission,onChange:handleBoatParamChange(boat.id,index,'emission')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column qty'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,inputClassName:'_border_radius_10 _height_20 _width_50',digitsAfterDot:0,value:boat.qty,error:inputErrors.boatsListErrors&&inputErrors.boatsListErrors[boat.id]&&inputErrors.boatsListErrors[boat.id].qty,onChange:handleBoatParamChange(boat.id,index,'qty')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column remove'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delete',onClick:removeBoat(index)})));})));}}]);return BoatsList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_managers_notification__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentList=function(_React$Component){_inherits(ComponentList,_React$Component);function ComponentList(props){_classCallCheck(this,ComponentList);var _this=_possibleConstructorReturn(this,(ComponentList.__proto__||Object.getPrototypeOf(ComponentList)).call(this,props));_this.handleCategorySelect=function(newChosenCategory){var _this$state=_this.state,categories=_this$state.categories,types=_this$state.types;var checkCategoty=function checkCategoty(category){if(!category.checked&&category.componentTypes)types.push.apply(types,_toConsumableArray(category.componentTypes));if(types.length>1&&types[0].componentTypeName!=='All')types.unshift({componentTypeName:'All'});category.checked=true;};var unCheckCategory=function unCheckCategory(category){category.checked=false;if(category.componentTypes){category.componentTypes.forEach(function(categoryType){var storedTypeIndex=types.findIndex(function(storedType){return storedType.id===categoryType.id;});if(storedTypeIndex!==-1)types.splice(storedTypeIndex,1);categoryType.checked=false;_this.props.removeComponentTypeId(categoryType.id);});if((types.length===2||types.length===1)&&types[0].componentTypeName==='All')types.shift();}};var toggleCategory=function toggleCategory(category){if(category.checked){unCheckCategory(category);}else{checkCategoty(category);}};if(newChosenCategory.name==='All'){if(newChosenCategory.checked){newChosenCategory.checked=false;categories.forEach(function(category){unCheckCategory(category);});}else{newChosenCategory.checked=true;categories.forEach(function(category){checkCategoty(category);});}}else{toggleCategory(newChosenCategory);}_this.setState({categories:categories,types:types});};_this.handleTypeSelect=function(chosenType){var _this$props=_this.props,removeComponentTypeId=_this$props.removeComponentTypeId,addComponentTypeId=_this$props.addComponentTypeId;var types=_this.state.types;var checkType=function checkType(type){type.checked=true;if(type.id)addComponentTypeId(type.id);};var uncheckType=function uncheckType(type){type.checked=false;removeComponentTypeId(type.id);};var toggleType=function toggleType(type){if(type.checked){uncheckType(type);}else{checkType(type);}};if(chosenType.componentTypeName==='All'){if(chosenType.checked){types.forEach(function(type){uncheckType(type);});}else{types.forEach(function(type){checkType(type);});}}else{toggleType(chosenType);}_this.forceUpdate();};_this.state={categories:[],types:[]};return _this;}_createClass(ComponentList,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].categoriesWithTypes).then(function(_ref){var data=_ref.data;if(data.length>1)data.unshift({name:'All',value:{}});if(!data.length)__WEBPACK_IMPORTED_MODULE_4_dom_managers_notification__["a" /* default */].error('note','Cannot generate a Components list report: there are no approved components.');_this2.setState({categories:data});});}},{key:'render',value:function render(){var inputErrors=this.props.inputErrors;var _state=this.state,categories=_state.categories,types=_state.types;var selectedCategoriesAmount=categories.filter(function(category){return category.checked;}).length;var selectedTypesAmount=types.filter(function(type){return type.checked;}).length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'report-filters-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component Category / Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:categories,mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',checkBoxClassName:'_top_12 _left_10',label:'Component Category *',itemNameIndicator:'name',multiSelect:true,withCheckBoxes:true,withoutSearch:true,disabled:!categories.length,placeholder:selectedCategoriesAmount?selectedCategoriesAmount+' is selected':'None',handleSelect:this.handleCategorySelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:types,mainWrapperClassName:'_width_330 _height_90',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',checkBoxClassName:'_top_12 _left_10',label:'Component Type *',itemNameIndicator:'componentTypeName',multiSelect:true,withCheckBoxes:true,withoutSearch:true,disabled:!types.length,placeholder:selectedTypesAmount?selectedTypesAmount+' is selected':'None',error:inputErrors.selectedTypesList,handleSelect:this.handleTypeSelect}));}}]);return ComponentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InspectorDashboardScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Header__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableHeader__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableBody__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Modal__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['name','code'];var InspectorDashboardScene=Object(__WEBPACK_IMPORTED_MODULE_4_HOC_User__["a" /* default */])(_class=function(_React$Component){_inherits(InspectorDashboardScene,_React$Component);function InspectorDashboardScene(props){_classCallCheck(this,InspectorDashboardScene);var _this=_possibleConstructorReturn(this,(InspectorDashboardScene.__proto__||Object.getPrototypeOf(InspectorDashboardScene)).call(this,props));_this.updateListData=function(){var user=_this.props.user;var requestedRole=user.getActiveRole();__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].inspectorsList(requestedRole)).then(function(_ref){var data=_ref.data;__WEBPACK_IMPORTED_MODULE_3__registerIDBWorker__["a" /* default */].insert(requestedRole+'_inspectors',data).then(function(){_this.setState({listRequestInProcess:false});_this.loadFromStore();});});};_this.loadFromStore=function(){var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_3__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_inspectors').then(function(data){_this.allInspectors=data;_this.filterList();_this.sortList();});};_this.handleSortClick=function(field){return function(){_this.setState(function(prevState){return{sortedBy:field,sortOrder:prevState.sortedBy===field?-prevState.sortOrder:prevState.sortOrder,activePage:1};},_this.sortList);};};_this.sortList=function(){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortOrder=_this$state.sortOrder;var inspectors=_this.state.inspectors;inspectors.sort(function(a,b){switch(sortedBy){case'active':return a.active>b.active?sortOrder:-sortOrder;default:return a[sortedBy].toLowerCase().replace(/\s+/g,' ')>b[sortedBy].toLowerCase().replace(/\s+/g,' ')?sortOrder:-sortOrder;}});_this.setState({inspectors:inspectors});};_this.handleRowSelect=function(rowsCountSelected,totalRowsCount){var rowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;_this.setState({rowsCount:rowsCount,activePage:1});};_this.handlePaginationClick=function(activePage){_this.setState({activePage:activePage});};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){_this.filterList();user.updateURLSearchString({searchString:value});});};_this.filterList=function(){var searchString=_this.state.searchString;var inspectors=_this.allInspectors;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};if(searchString)inspectors=inspectors.filter(function(element){return doesSearchableFieldsContainSearchString(element);});_this.setState({inspectors:inspectors},_this.sortList);};_this.state={rowsCount:10,activePage:1,sortedBy:'name',sortOrder:1,inspectors:[],filterState:{active:true},additionalFilterState:{},searchString:'',isModalOpen:'',requestInProcess:false,listRequestInProcess:true,selectedYear:'',currentYear:0};_this.allInspectors=[];_this.previousRole=null;_this.isOilDashboard=props.user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName||props.user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName;_this.isWithPaymentStatus=false;_this.isWithCertificationStatus=false;props.user.selectInspector(null)();return _this;}_createClass(InspectorDashboardScene,[{key:'componentDidMount',value:function componentDidMount(){var user=this.props.user;this.previousRole=user.getActiveRole();this.loadFromStore();this.updateListData();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;var user=this.props.user;if(this.previousRole!==user.getActiveRole()){this.previousRole=user.getActiveRole();this.setState({inspectors:[],listRequestInProcess:true},function(){_this2.loadFromStore();_this2.updateListData();});}}},{key:'render',value:function render(){var _state=this.state,inspectors=_state.inspectors,rowsCount=_state.rowsCount,activePage=_state.activePage,sortedBy=_state.sortedBy,sortOrder=_state.sortOrder,searchString=_state.searchString,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess,listRequestInProcess=_state.listRequestInProcess;var user=this.props.user;var tableColumnsWidths=this.isOilDashboard?{code:'_width_pc_10',allRoles:'_width_pc_20',isCertified:'_width_pc_12',active:'_width_pc_12',actions:'_width_pc_12',isPaid:'_width_pc_12'}:{code:'_width_pc_10',isCertified:'_width_pc_12',active:'_width_pc_12',actions:'_width_pc_12',isPaid:'_width_pc_12'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper dashboard-scene'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__scene-header list-scene__scene-header'},user.getRoleName().split(' ')[0]+' Inspectors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Header__["a" /* default */],{user:user,rowsCount:rowsCount,outCount:inspectors.length,handleRowCountSelect:this.handleRowSelect,listRequestInProcess:listRequestInProcess,searchString:searchString,handleSearchStringInput:this.handleSearchStringInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableHeader__["a" /* default */],{user:user,handleSortClick:this.handleSortClick,order:sortOrder===1,sortedBy:sortedBy}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TableBody__["a" /* default */],{noEntrysForThisInspector:!this.allInspectors.length,listRequestInProcess:listRequestInProcess,inspectors:inspectors,user:user,rowsCount:rowsCount,activePage:activePage,isOilDashboard:this.isOilDashboard,tableColumnsWidths:tableColumnsWidths,handleStatusChangeClick:this.handleStatusChangeClick,sortedBy:sortedBy,isWithPaymentStatus:this.isWithPaymentStatus,isWithCertificationStatus:this.isWithCertificationStatus}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Footer__["a" /* default */],{handleClick:this.handlePaginationClick,handleSelect:this.handleRowSelect,activePage:activePage,rowsCount:rowsCount,outCount:inspectors.length}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.$modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'No',buttonClassName:'_width_135 _height_40',onClick:this._closeModal,color:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["a" /* buttonColor */].gray,type:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["b" /* buttonType */].secondary}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_width_135 _height_40',onClick:this.$confirmModalAction}))));}}]);return InspectorDashboardScene;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var outCount=_ref.outCount,handleRowCountSelect=_ref.handleRowCountSelect,rowsCount=_ref.rowsCount,searchString=_ref.searchString,handleSearchStringInput=_ref.handleSearchStringInput;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_1_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowCountSelect,selectedRowsCount:rowsCount}))));});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy,isOilDashboard=_ref.isOilDashboard,tableColumnsWidths=_ref.tableColumnsWidths,isWithPaymentStatus=_ref.isWithPaymentStatus,isWithCertificationStatus=_ref.isWithCertificationStatus,user=_ref.user;function createClasses(id){if(sortedBy===id)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('code')+' _width_pc_12',onClick:handleSortClick('code')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element list-scene__table-row-element_place_filler\n      '+createClasses('name'),onClick:handleSortClick('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Inspector Company Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})));});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_EmptyList__ = __webpack_require__(55);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var user=_ref.user,inspectors=_ref.inspectors,activePage=_ref.activePage,rowsCount=_ref.rowsCount,sortedBy=_ref.sortedBy,listRequestInProcess=_ref.listRequestInProcess,noEntrysForThisInspector=_ref.noEntrysForThisInspector;var _getTextColourStyle=function _getTextColourStyle(key){if(sortedBy===key)return'active';return'';};var _getBackgroundColourStyle=function _getBackgroundColourStyle(index){return index%2?'_background_color_pale_gray':'_background_color_white';};var _getStatusColor=function _getStatusColor(inspector){return'list-scene__status-label_'+(inspector.active?'approved':'deactivated');};function getTableBody(){if(noEntrysForThisInspector){if(listRequestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_EmptyList__["a" /* default */],null,'No inspectors found for this role');}}else if(!inspectors.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_EmptyList__["a" /* default */],null,'No inspectors found with selected search phrase.');}var sliceFrom=(activePage-1)*rowsCount;var sliceTo=rowsCount?activePage*rowsCount:inspectors.length;return inspectors.slice(sliceFrom,sliceTo).map(function(inspector,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectorRowId'+inspector.code,key:inspector.code,onClick:user.selectInspector(inspector),className:'list-scene__table-row '+_getBackgroundColourStyle(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+_getStatusColor(inspector)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectorCodeField',className:'list-scene__table-row-element\n                           list-scene__table-row-element_text-element\n                           '+_getTextColourStyle('code')+'\n                           _width_pc_12'},inspector.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectorNameField',className:'list-scene__table-row-element\n          list-scene__table-row-element_place_filler\n                           list-scene__table-row-element_text-element\n                           '+_getTextColourStyle('name')},inspector.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+_getStatusColor(inspector)}));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-body'},getTableBody());});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleClick=_ref.handleClick,activePage=_ref.activePage,outCount=_ref.outCount,handleSelect=_ref.handleSelect,rowsCount=_ref.rowsCount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleSelect,selectedRowsCount:rowsCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Pagination__["a" /* default */],{handleClick:handleClick,activePage:activePage,allRowsCount:outCount,selectedRowsCount:rowsCount}));});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Header__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TableBody__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TableHeader__ = __webpack_require__(995);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var getSearchableFields=function getSearchableFields(isBoatManufacturer){return[{fieldName:'name'},{fieldName:'code'}].concat(_toConsumableArray(isBoatManufacturer?[{fieldName:'boatBrands',nestedFieldName:'name',isArrayOfObjects:true}]:[]));};// TODO: rewrite and move to helpers
var isStringIncludes=function isStringIncludes(strA,strB){return strA.toLowerCase().includes(strB.toLowerCase());};var DashboardScene=Object(__WEBPACK_IMPORTED_MODULE_7_HOC_User__["a" /* default */])(_class=function(_React$Component){_inherits(DashboardScene,_React$Component);function DashboardScene(props){_classCallCheck(this,DashboardScene);var _this=_possibleConstructorReturn(this,(DashboardScene.__proto__||Object.getPrototypeOf(DashboardScene)).call(this,props));_this.roleSwitch=function(){var _this$props=_this.props,user=_this$props.user,match=_this$props.match;var roleServerName=Object.values(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */]).reduce(function(acc,role){if(match.params.manufacturerRole===role.nameForUrl){return role.serverName;}return acc;},null);if(user.getActiveRole()!==roleServerName){user.changeMenu(roleServerName);}};_this.getCurrentYear=function(){var user=_this.props.user;var storedSelectedYear=user.getSelectedYear();return new Promise(function(resolve,reject){switch(user.getActiveRole()){case __WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref){var data=_ref.data;_this.setState({selectedYear:storedSelectedYear||data[1]||data[0],currentYear:data[1]||data[0]},resolve);});break;case __WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref2){var data=_ref2.data;_this.setState({selectedYear:storedSelectedYear||data[1]||data[0],currentYear:data[1]||data[0]},resolve);});break;case __WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].currentModelYear).then(function(_ref3){var data=_ref3.data;_this.setState({selectedYear:storedSelectedYear||data,currentYear:data},resolve);});break;default:{var currentCalendarYear=new Date().getFullYear();_this.setState({selectedYear:storedSelectedYear||currentCalendarYear,currentYear:currentCalendarYear},resolve);break;}}});};_this.updateListData=function(){var _this$props2=_this.props,user=_this$props2.user,match=_this$props2.match;var _this$state=_this.state,filterState=_this$state.filterState,selectedYear=_this$state.selectedYear;var roleServerName=Object.values(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */]).reduce(function(acc,role){if(match.params.manufacturerRole===role.nameForUrl){return role.serverName;}return acc;},null);if(_this.isOilDashboard){new Promise(function(res,rej){Promise.all([__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].listWithChecklistItems(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName,selectedYear)),__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].listWithChecklistItems(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName,selectedYear,filterState.brandSignStatus))]).then(function(result){__WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__["a" /* default */].insert(roleServerName,_this.addDBKeyToEntries(_this.createOilListWithCombinedChecklistData(result[1].data,result[0].data),selectedYear),selectedYear.toString()).then(function(){_this.setState({listRequestInProcess:false});_this.loadFromStore();});});});}else{new Promise(function(res,rej){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].listWithChecklistItems(roleServerName,selectedYear,false,user.getInspectorCode(),user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName)).then(function(_ref4){var data=_ref4.data;__WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__["a" /* default */].insert(roleServerName,_this.addDBKeyToEntries(data,selectedYear),selectedYear.toString()).then(function(){_this.setState({listRequestInProcess:false});_this.loadFromStore();res();});});});}};_this.addDBKeyToEntries=function(list,selectedYear){list.forEach(function(entry){return entry.dbKey=entry.code+'_'+selectedYear;});return list;};_this.createOilListWithCombinedChecklistData=function(brandersList,formulatorsList){var filterState=_this.state.filterState;formulatorsList.forEach(function(formulator){var matchedBranderEntry=brandersList.find(function(brander){return brander.name===formulator.name;});if(matchedBranderEntry){matchedBranderEntry.checklists=[formulator.checklist,matchedBranderEntry.checklist];matchedBranderEntry.checklist=formulator.checklist;}else if(!filterState.brandSignStatus){brandersList.push(formulator);}});return brandersList;};_this.loadFromStore=function(){var user=_this.props.user;var selectedYear=_this.state.selectedYear;_this.allManufacturers=[];__WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__["a" /* default */].select(user.getActiveRole(),selectedYear.toString()).then(function(data){_this.allManufacturers=data;_this.initCheckListItems(data);_this.filterList();_this.sortList();});};_this.initCheckListItems=function(data){var allPossibleChecklistItemNamesArray={};_this.isWithPaymentStatus=false;_this.isWithCertificationStatus=false;var addChecklistItemsFromCurrentEntryToFilterList=function addChecklistItemsFromCurrentEntryToFilterList(entry){if(entry.hasCertification){_this.isWithCertificationStatus=true;allPossibleChecklistItemNamesArray.Certification=true;}entry.itemValues.forEach(function(item){allPossibleChecklistItemNamesArray[item.name]=true;if(item.statusType==='PAYMENT'){_this.isWithPaymentStatus=true;}});};data.forEach(function(manufacturerEntry){if(manufacturerEntry.checklists){manufacturerEntry.checklists.forEach(function(checklist){addChecklistItemsFromCurrentEntryToFilterList(checklist);});}else{addChecklistItemsFromCurrentEntryToFilterList(manufacturerEntry.checklist);}});_this.checklistItems=Object.keys(allPossibleChecklistItemNamesArray).map(function(checklistItemName){return{name:checklistItemName,checked:false};});};_this.handleYearSelect=function(selectedYear){var user=_this.props.user;user.saveSelectedYear(selectedYear);_this.setState({selectedYear:selectedYear,listRequestInProcess:true,manufacturers:[]},function(){_this.loadFromStore();_this.updateListData();});};_this.handleSortClick=function(field){return function(){_this.setState(function(prevState){return{sortedBy:field,sortOrder:prevState.sortedBy===field?-prevState.sortOrder:prevState.sortOrder,activePage:1};},_this.sortList);};};_this.sortList=function(){var _this$state2=_this.state,sortedBy=_this$state2.sortedBy,sortOrder=_this$state2.sortOrder;var manufacturers=_this.state.manufacturers;manufacturers.sort(function(a,b){switch(sortedBy){case'isCertified':return a.checklist.isCertified>b.checklist.isCertified?sortOrder:-sortOrder;case'isPaid':{var paymentStatusA=a.checklist.itemValues.find(function(checklistItem){return checklistItem.statusType==='PAYMENT';});var paymentStatusB=b.checklist.itemValues.find(function(checklistItem){return checklistItem.statusType==='PAYMENT';});return(paymentStatusA&&paymentStatusA.isChecked)>(paymentStatusB&&paymentStatusB.isChecked)?sortOrder:-sortOrder;}case'active':return a.active>b.active?sortOrder:-sortOrder;case'allRoles':{var aRoleSummaryWeight=0;var bRoleSummaryWeight=0;if(a.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName)!==-1)aRoleSummaryWeight+=2;if(a.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName)!==-1)aRoleSummaryWeight+=1;if(b.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName)!==-1)bRoleSummaryWeight+=2;if(b.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName)!==-1)bRoleSummaryWeight+=1;return aRoleSummaryWeight>bRoleSummaryWeight?sortOrder:-sortOrder;}default:return a[sortedBy].toLowerCase().replace(/\s+/g,' ')>b[sortedBy].toLowerCase().replace(/\s+/g,' ')?sortOrder:-sortOrder;}});_this.setState({manufacturers:manufacturers});};_this.handleRowSelect=function(rowsCountSelected,totalRowsCount){var rowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;_this.setState({rowsCount:rowsCount,activePage:1});};_this.handlePaginationClick=function(activePage){_this.setState({activePage:activePage});};_this.handleSelectFilter=function(filterType){return function(filterElement){var filterState=_this.state.filterState;var newFilterState=Object.assign({},filterState);if(filterElement.value==='All')delete newFilterState[filterType];else newFilterState[filterType]=filterElement.value;if(filterType==='brandSignStatus'&&filterElement!=='All'){newFilterState.allRoles=__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName;_this.setState({filterState:newFilterState},_this.updateListData);}else if(filterType==='allRoles'&&filterElement.value!==__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName&&newFilterState.brandSignStatus!==undefined){delete newFilterState.brandSignStatus;_this.setState({filterState:newFilterState},_this.updateListData);}else{_this.setState({filterState:newFilterState},_this.filterList);}};};_this.handleSelectAdditionalFilter=function(filterItem){var additionalFilterState=_this.state.additionalFilterState;var newFilterState=Object.assign({},additionalFilterState);var filterItemName=filterItem.name;var user=_this.props.user;if(newFilterState[filterItemName]===undefined){_this.checklistItems.find(function(item){return item.name===filterItemName;}).checked=true;newFilterState[filterItemName]=true;}else if(filterItemName==='searchString'){delete newFilterState[filterItemName];}else{_this.checklistItems.find(function(item){return item.name===filterItemName;}).checked=false;delete newFilterState[filterItemName];//user.updateURLSearchString({searchString: null});
//this.setState({ searchString: null });
_this.handleSearchStringInput('');}_this.setState({additionalFilterState:newFilterState},_this.filterList);};_this.toggleAdditionalFilterItem=function(filterItemName){return function(){var additionalFilterState=_this.state.additionalFilterState;additionalFilterState[filterItemName]=!additionalFilterState[filterItemName];_this.setState({additionalFilterState:additionalFilterState},_this.filterList);};};_this.clearAdditionalFilter=function(){window.sessionStorage.removeItem('dashboardListState');window.sessionStorage.removeItem('dashboardListAdditionalState');_this.checklistItems.forEach(function(item){return item.checked=false;});_this.setState({filterState:{active:true},additionalFilterState:{},manufacturers:[],listRequestInProcess:true},_this.filterList);};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){_this.filterList();user.updateURLSearchString({searchString:value});});};_this.filterList=function(){var user=_this.props.user;var _this$state3=_this.state,filterState=_this$state3.filterState,searchString=_this$state3.searchString,additionalFilterState=_this$state3.additionalFilterState;var searchableFields=getSearchableFields(user.activeRole.serverName===__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName);var manufacturers=[].concat(_toConsumableArray(_this.allManufacturers));var isMatchingSearchString=function isMatchingSearchString(manufacturer){return searchableFields.map(function(_ref5){var fieldName=_ref5.fieldName,nestedFieldName=_ref5.nestedFieldName,isArrayOfObjects=_ref5.isArrayOfObjects;return isArrayOfObjects?manufacturer[fieldName].some(function(_ref6){var fieldName=_ref6[nestedFieldName];return isStringIncludes(fieldName,searchString);}):isStringIncludes(manufacturer[fieldName].toString(),searchString);}).some(function(field){return field;});};Object.keys(filterState).forEach(function(filterFieldName){switch(filterFieldName){case'allRoles':manufacturers=manufacturers.filter(function(element){return element[filterFieldName].indexOf(filterState[filterFieldName])!==-1;});break;case'brandSignStatus':break;default:manufacturers=manufacturers.filter(function(element){return element[filterFieldName]===filterState[filterFieldName];});}});if(searchString)manufacturers=manufacturers.filter(isMatchingSearchString);Object.keys(additionalFilterState).forEach(function(additionalFilterFieldName){manufacturers=manufacturers.filter(function(manufacturerEntry){switch(additionalFilterFieldName){case'Certification':if(manufacturerEntry.checklists){if(filterState.allRoles){var checklistToFilterBy=manufacturerEntry.checklists.find(function(entry){return entry.manufacturerRole===filterState.allRoles;});var checklistItem=checklistToFilterBy.isCertified;return checklistItem!==undefined?checklistItem===additionalFilterState[additionalFilterFieldName]:!additionalFilterState[additionalFilterFieldName];}else{var filterPassed=false;manufacturerEntry.checklists.forEach(function(checklist){var checklistItem=checklist.isCertified;if(checklistItem!==undefined?checklistItem===additionalFilterState[additionalFilterFieldName]:!additionalFilterState[additionalFilterFieldName])filterPassed=true;});return filterPassed;}}else{var _checklistItem=manufacturerEntry.checklist.isCertified;return _checklistItem!==undefined?_checklistItem===additionalFilterState[additionalFilterFieldName]:!additionalFilterState[additionalFilterFieldName];}default:if(manufacturerEntry.checklists){if(filterState.allRoles){var _checklistToFilterBy=manufacturerEntry.checklists.find(function(entry){return entry.manufacturerRole===filterState.allRoles;});var _checklistItem2=_checklistToFilterBy.itemValues.find(function(checklistItem){return checklistItem.name===additionalFilterFieldName;});return _checklistItem2?_checklistItem2.isChecked===additionalFilterState[additionalFilterFieldName]:!additionalFilterState[additionalFilterFieldName];}else{var _filterPassed=false;manufacturerEntry.checklists.forEach(function(checklist){var checklistItem=checklist.itemValues.find(function(checklistItem){return checklistItem.name===additionalFilterFieldName;});if(checklistItem?checklistItem.isChecked===additionalFilterState[additionalFilterFieldName]:!additionalFilterState[additionalFilterFieldName])_filterPassed=true;});return _filterPassed;}}else{var _checklistItem3=manufacturerEntry.checklist.itemValues.find(function(checklistItem){return checklistItem.name===additionalFilterFieldName;});return _checklistItem3?_checklistItem3.isChecked===additionalFilterState[additionalFilterFieldName]:!additionalFilterState[additionalFilterFieldName];}}});});_this.setState({manufacturers:manufacturers},_this.sortList);};_this.handleSelectManufacturer=function(manufacturer){return function(){var user=_this.props.user;if(_this.isOilDashboard){if(manufacturer.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName)!==-1)user.setActiveRole(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName);else user.setActiveRole(__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName);}user.selectManufacturer(manufacturer);};};_this.handleStatusChangeClick=function(manufacturer){return function(event){Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["h" /* stopPropagation */])(event);_this.$modalBody='Are you sure you want to '+(manufacturer.active?'Deactivate':'Reactivate')+' this manufacturer?';_this.$confirmModalAction=_this._toggleStatus(manufacturer);_this.setState({isModalOpen:true});};};_this._toggleStatus=function(manufacturer){return function(){var requestInProcess=_this.state.requestInProcess;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].changeStatus(manufacturer.code,!manufacturer.active)).then(function(_ref7){var data=_ref7.data;_this._updateListEntry(manufacturer,data);__WEBPACK_IMPORTED_MODULE_4_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(function(){_this.setState({requestInProcess:false});_this._closeModal();});});};};_this._updateListEntry=function(oldEntry,newEntry){var user=_this.props.user;var manufacturers=_this.state.manufacturers;newEntry.checklist=oldEntry.checklist;if(oldEntry.checklists)newEntry.checklists=oldEntry.checklists;var oldEntryIndex=manufacturers.indexOf(oldEntry);manufacturers.splice(oldEntryIndex,1,newEntry);__WEBPACK_IMPORTED_MODULE_6__registerIDBWorker__["a" /* default */].insert(user.getActiveRole(),newEntry);_this.setState({manufacturers:manufacturers});};_this._closeModal=function(){_this.setState({isModalOpen:false});};_this.state={rowsCount:10,activePage:1,sortedBy:'name',sortOrder:1,manufacturers:[],filterState:{active:true},additionalFilterState:{},searchString:'',isModalOpen:'',requestInProcess:false,listRequestInProcess:true,selectedYear:'',currentYear:0};var storedState=props.user.getStoredState('dashboardListState',_this.state.filterState);//props.user.updateURLSearchString(storedState);
_this.state.filterState=Object.assign({},_this.state.filterState,storedState);var storedAdditionalState=props.user.getStoredState('dashboardListAdditionalState',_this.state.additionalFilterState);_this.state.additionalFilterState=Object.assign({},_this.state.additionalFilterState,storedAdditionalState);_this.allManufacturers=[];_this.isOilDashboard=_this.props.match.params.manufacturerRole===__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.nameForUrl;_this.isWithPaymentStatus=false;_this.isWithCertificationStatus=false;props.user.selectManufacturer(null);return _this;}_createClass(DashboardScene,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.roleSwitch();this.getCurrentYear().then(function(){_this2.loadFromStore();_this2.updateListData();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.user.saveState('dashboardListState',this.state.filterState,[]);this.props.user.saveState('dashboardListAdditionalState',this.state.additionalFilterState,[]);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(prevProps.match.params.manufacturerRole!==this.props.match.params.manufacturerRole){this.roleSwitch();this.isOilDashboard=this.props.match.params.manufacturerRole===__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.nameForUrl;window.sessionStorage.removeItem('dashboardListState');window.sessionStorage.removeItem('dashboardListAdditionalState');this.checklistItems.forEach(function(item){return item.checked=false;});this.setState({filterState:{active:true},additionalFilterState:{},manufacturers:[],listRequestInProcess:true,searchString:''},this.filterList);this.setState(function(){_this3.getCurrentYear().then(function(){_this3.loadFromStore();_this3.updateListData();});});}}},{key:'render',value:function render(){var _state=this.state,activePage=_state.activePage,additionalFilterState=_state.additionalFilterState,currentYear=_state.currentYear,filterState=_state.filterState,isModalOpen=_state.isModalOpen,manufacturers=_state.manufacturers,requestInProcess=_state.requestInProcess,rowsCount=_state.rowsCount,sortedBy=_state.sortedBy,sortOrder=_state.sortOrder,searchString=_state.searchString,listRequestInProcess=_state.listRequestInProcess,selectedYear=_state.selectedYear;var user=this.props.user;var tableColumnsWidths=this.isOilDashboard?{code:'_width_pc_10',allRoles:'_width_pc_20',isCertified:'_width_pc_12',active:'_width_pc_10',isPaid:'_width_pc_10',isComplete:'_width_pc_10',actions:'_width_pc_12'}:{code:'_width_pc_10',isCertified:'_width_pc_12',active:'_width_pc_10',isPaid:'_width_pc_10',isComplete:'_width_pc_10',actions:'_width_pc_12'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper dashboard-scene'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__scene-header list-scene__scene-header'},user.getRoleName().split(' ')[0]+' Manufacturers',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_9_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Header__["a" /* default */],{handleSelectFilter:this.handleSelectFilter,handleBrandSignStatusSelect:this.handleBrandSignStatusSelect,user:user,filterState:filterState,rowsCount:rowsCount,outCount:manufacturers.length,handleRowCountSelect:this.handleRowSelect,isOilDashboard:this.isOilDashboard,checklistItems:this.checklistItems||[],additionalFilterState:additionalFilterState,handleSelectAdditionalFilter:this.handleSelectAdditionalFilter,toggleAdditionalFilterItem:this.toggleAdditionalFilterItem,clearAdditionalFilter:this.clearAdditionalFilter,isWithPaymentStatus:this.isWithPaymentStatus,isWithCertificationStatus:this.isWithCertificationStatus,selectedYear:selectedYear,currentYear:currentYear,handleYearSelect:this.handleYearSelect,listRequestInProcess:listRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__TableHeader__["a" /* default */],{user:user,handleSortClick:this.handleSortClick,order:sortOrder===1,sortedBy:sortedBy,isOilDashboard:this.isOilDashboard,tableColumnsWidths:tableColumnsWidths,isWithPaymentStatus:this.isWithPaymentStatus,isWithCertificationStatus:this.isWithCertificationStatus}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__TableBody__["a" /* default */],{noEntrysForThisManufacturer:!this.allManufacturers.length,listRequestInProcess:listRequestInProcess,manufacturers:manufacturers,user:user,handleSelectManufacturer:this.handleSelectManufacturer,rowsCount:rowsCount,activePage:activePage,isOilDashboard:this.isOilDashboard,tableColumnsWidths:tableColumnsWidths,handleStatusChangeClick:this.handleStatusChangeClick,sortedBy:sortedBy,isWithPaymentStatus:this.isWithPaymentStatus,isWithCertificationStatus:this.isWithCertificationStatus}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Footer__["a" /* default */],{handleClick:this.handlePaginationClick,handleSelect:this.handleRowSelect,activePage:activePage,rowsCount:rowsCount,outCount:manufacturers.length}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.$modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'No',buttonClassName:'_width_135 _height_40',onClick:this._closeModal,color:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["a" /* buttonColor */].gray,type:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["b" /* buttonType */].secondary}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_width_135 _height_40',onClick:this.$confirmModalAction}))));}}]);return DashboardScene;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_YearPicker__ = __webpack_require__(90);
var filterOptions={active:[{name:'All',value:'All'},{name:'Active',value:true},{name:'Inactive',value:false}],allRoles:[{name:'All',value:'All'},{name:'Oil formulator',value:__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName},{name:'Oil brander',value:__WEBPACK_IMPORTED_MODULE_3_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName}],isCertified:[{name:'All',value:'All'},{name:'Certified',value:true},{name:'Certification Pending',value:false}],isPaid:[{name:'All',value:'All'},{name:'Paid',value:true},{name:'Unpaid',value:false}],brandSignStatus:[{name:'All',value:'All'},{name:'Signed',value:true},{name:'Not signed',value:false}]};/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var filterState=_ref.filterState,handleSelectFilter=_ref.handleSelectFilter,user=_ref.user,outCount=_ref.outCount,handleRowCountSelect=_ref.handleRowCountSelect,rowsCount=_ref.rowsCount,isOilDashboard=_ref.isOilDashboard,checklistItems=_ref.checklistItems,additionalFilterState=_ref.additionalFilterState,handleSelectAdditionalFilter=_ref.handleSelectAdditionalFilter,toggleAdditionalFilterItem=_ref.toggleAdditionalFilterItem,clearAdditionalFilter=_ref.clearAdditionalFilter,isWithPaymentStatus=_ref.isWithPaymentStatus,isWithCertificationStatus=_ref.isWithCertificationStatus,currentYear=_ref.currentYear,selectedYear=_ref.selectedYear,handleYearSelect=_ref.handleYearSelect,listRequestInProcess=_ref.listRequestInProcess;var additionalFiltersItemsNames=Object.keys(additionalFilterState);var getSelectedItem=function getSelectedItem(key){if(filterState[key]===undefined)return filterOptions[key][0];return filterOptions[key].find(function(item){return item.value===filterState[key];});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header _margin_left_10'},'Year select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_YearPicker__["a" /* default */],{endYear:currentYear+1,startYear:currentYear-20,yearPickAction:handleYearSelect,label:'Checklist Items Year',year:selectedYear?Number(selectedYear):undefined,width:160,height:18,disabled:listRequestInProcess})),!user.isInspector()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header _margin_left_10'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:filterOptions.active,handleSelect:handleSelectFilter('active'),defaultItem:getSelectedItem('active'),isSlave:true,itemNameIndicator:'name',label:'by Status',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),isOilDashboard&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:filterOptions.allRoles,handleSelect:handleSelectFilter('allRoles'),defaultItem:getSelectedItem('allRoles'),isSlave:true,itemNameIndicator:'name',label:'by Type',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:filterOptions.brandSignStatus,handleSelect:handleSelectFilter('brandSignStatus'),defaultItem:getSelectedItem('brandSignStatus'),isSlave:true,itemNameIndicator:'name',label:'by Agreement Status',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}))),!!checklistItems.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header _margin_left_10'},'Additional Filters'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:checklistItems,handleSelect:handleSelectAdditionalFilter,defaultItem:'',multiSelect:true,withCheckBoxes:true,itemNameIndicator:'name',placeholder:additionalFiltersItemsNames.length?additionalFiltersItemsNames.length+' is selected':'None',mainWrapperClassName:'_margin_top_12',dropDownClassName:'_top_22',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowCountSelect,selectedRowsCount:rowsCount}))),!!additionalFiltersItemsNames.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__additional-filters-bubbles-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__bubble-hover-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__additional-filter-bubble _text-decoration_underline',onClick:clearAdditionalFilter},'Clear All')),additionalFiltersItemsNames.map(function(filterItemName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:filterItemName,className:'list-scene__bubble-hover-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__additional-filter-bubble '+(additionalFilterState[filterItemName]?'list-scene__additional-filter-bubble_true':'list-scene__additional-filter-bubble_false'),onClick:toggleAdditionalFilterItem(filterItemName)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__up-down-arrows-icon _display_none _position_absolute _left_5 _top_2'}),filterItemName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-delete-button _top_5 _right_10',onClick:function onClick(event){Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["h" /* stopPropagation */])(event);handleSelectAdditionalFilter({name:filterItemName});}}));})));});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleClick=_ref.handleClick,activePage=_ref.activePage,outCount=_ref.outCount,handleSelect=_ref.handleSelect,rowsCount=_ref.rowsCount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleSelect,selectedRowsCount:rowsCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Pagination__["a" /* default */],{handleClick:handleClick,activePage:activePage,allRowsCount:outCount,selectedRowsCount:rowsCount}));});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_EmptyList__ = __webpack_require__(55);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var manufacturers=_ref.manufacturers,activePage=_ref.activePage,rowsCount=_ref.rowsCount,handleSelectManufacturer=_ref.handleSelectManufacturer,sortedBy=_ref.sortedBy,tableColumnsWidths=_ref.tableColumnsWidths,isOilDashboard=_ref.isOilDashboard,user=_ref.user,handleStatusChangeClick=_ref.handleStatusChangeClick,isWithPaymentStatus=_ref.isWithPaymentStatus,isWithCertificationStatus=_ref.isWithCertificationStatus,listRequestInProcess=_ref.listRequestInProcess,noEntrysForThisManufacturer=_ref.noEntrysForThisManufacturer;var _getTextColourStyle=function _getTextColourStyle(key){if(sortedBy===key)return'active';return'';};var _getBackgroundColourStyle=function _getBackgroundColourStyle(index){return index%2?'_background_color_pale_gray':'_background_color_white';};var _getStatusColor=function _getStatusColor(manufacturer){return'list-scene__status-label_'+(manufacturer.active?'approved':'deactivated');};var _getManufacturerType=function _getManufacturerType(manufacturer){var isBrander=manufacturer.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName)!==-1;var isFormulator=manufacturer.allRoles.indexOf(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName)!==-1;if(isBrander&&isFormulator){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_line-height_30'},'Formulator'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_line-height_30'},'Brander'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,isFormulator?'Formulator':'Brander');}};function getTableBody(){if(noEntrysForThisManufacturer){if(listRequestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}));}else{if(user.selectedInspector){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_EmptyList__["a" /* default */],null,'No manufacturers found for this inspector');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_EmptyList__["a" /* default */],null,'No manufacturers found for this role');}}}else if(!manufacturers.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_EmptyList__["a" /* default */],null,'No manufacturers found with selected filters.');}var sliceFrom=(activePage-1)*rowsCount;var sliceTo=rowsCount?activePage*rowsCount:manufacturers.length;return manufacturers.slice(sliceFrom,sliceTo).map(function(manufacturer,index){var paymentStatus=manufacturer.checklist.itemValues.find(function(checklistItem){return checklistItem.statusType==='PAYMENT';});var completeStatus=manufacturer.checklist.itemValues.find(function(checklistItem){return checklistItem.statusType==='AGREEMENT';});var isPaid=isWithPaymentStatus&&paymentStatus&&paymentStatus.isChecked;var isComplete=completeStatus&&completeStatus.isChecked;var isCompleteColumnShown=Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* getIsBoatManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["g" /* getIsTrailerManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["d" /* getIsComponentManufacturer */])(user);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerRowId'+manufacturer.code,key:manufacturer.code,onClick:handleSelectManufacturer(manufacturer),className:'list-scene__table-row '+_getBackgroundColourStyle(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+_getStatusColor(manufacturer)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerCodeField',className:'list-scene__table-row-element\n                           list-scene__table-row-element_text-element\n                           '+_getTextColourStyle('code')+'\n                           '+tableColumnsWidths['code']},manufacturer.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerNameField',className:'list-scene__table-row-element\n          list-scene__table-row-element_place_filler\n                           list-scene__table-row-element_text-element\n                           '+_getTextColourStyle('name')},manufacturer.name),isOilDashboard&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerTypeField',className:'list-scene__table-row-element\n                           list-scene__table-row-element_text-element\n                           '+_getTextColourStyle('allRoles')+'\n                           '+tableColumnsWidths['allRoles']},_getManufacturerType(manufacturer)),isWithCertificationStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element\n              '+tableColumnsWidths['isCertified']+' '+(manufacturer.checklists?'_flex_col _ai_start _jc_center':'')},user.getRoleName()===__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.readableName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerCertificationStatusField',className:''+(manufacturer.checklist.isCertified?'__nmma-certified-icon  _height_28 _margin_top_5':'__nmma-not-certified-icon _height_50')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerCertificationStatusField',className:''+(manufacturer.checklist.isCertified?'__nmma-certified-ABYC-icon  _height_28 _margin_top_5':'__nmma-not-certified-ABYC-icon _height_50')}),manufacturer.checklists&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerCertificationStatusField',className:(manufacturer.checklists[1].isCertified?'__nmma-certified-icon':'__nmma-not-certified-icon')+' _height_40 _margin_top_12'})),!user.isInspector()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element '+tableColumnsWidths['active']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerStatusField',className:'list-scene__status-label _width_60 '+_getStatusColor(manufacturer)+' '+_getTextColourStyle('active')},manufacturer.active?'Active':'Inactive')),isWithPaymentStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'manufacturerFeeStatusField',className:'list-scene__table-row-element\n                           list-scene__table-row-element_text-element\n                           _flex _ai_center\n                           '+_getTextColourStyle('isPaid')+'\n                           '+tableColumnsWidths['isPaid']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(isPaid?'__checkbox_checked':'__checkbox_red-close-button')+'\n            _margin_right_5'}),isPaid?'Paid':'Unpaid'),isCompleteColumnShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'\n                list-scene__table-row-element\n                list-scene__table-row-element_text-element\n                _flex\n                _ai_center\n                '+_getTextColourStyle('isComplete')+'\n                '+tableColumnsWidths['isComplete']+'\n              '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(isComplete?'__checkbox_checked':'__checkbox_red-close-button')+' _margin_right_5'}),isComplete?'Complete':'Incomplete'),user.isInternal()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandActionsField',className:'list-scene__table-row-element list-scene__table-row-element_item-element\n               '+tableColumnsWidths['actions']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__single-action-button',onClick:handleStatusChangeClick(manufacturer)},manufacturer.active?'Deactivate':'Reactivate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+_getStatusColor(manufacturer)}));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-body'},getTableBody());});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(34);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy,isOilDashboard=_ref.isOilDashboard,tableColumnsWidths=_ref.tableColumnsWidths,isWithPaymentStatus=_ref.isWithPaymentStatus,isWithCertificationStatus=_ref.isWithCertificationStatus,user=_ref.user;var isCompleteColumnShown=Object(__WEBPACK_IMPORTED_MODULE_1_helpers__["c" /* getIsBoatManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_1_helpers__["g" /* getIsTrailerManufacturer */])(user)||Object(__WEBPACK_IMPORTED_MODULE_1_helpers__["d" /* getIsComponentManufacturer */])(user);function createClasses(id){if(sortedBy===id)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('code')+' '+tableColumnsWidths['code'],onClick:handleSortClick('code')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element list-scene__table-row-element_place_filler\n      '+createClasses('name'),onClick:handleSortClick('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Manufacturer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),isOilDashboard&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('allRoles')+' '+tableColumnsWidths['allRoles'],onClick:handleSortClick('allRoles')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Manufacturer Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),isWithCertificationStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('isCertified')+' '+tableColumnsWidths['isCertified'],onClick:handleSortClick('isCertified')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Certification'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),!user.isInspector()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('active')+' '+tableColumnsWidths['active'],onClick:handleSortClick('active')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),isWithPaymentStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('isPaid')+' '+tableColumnsWidths['isPaid'],onClick:handleSortClick('isPaid')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Payment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),isCompleteColumnShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('isComplete')+' '+tableColumnsWidths['isComplete']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Agreements'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),user.isInternal()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('active')+' '+tableColumnsWidths['actions']}));});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricsScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_metrics__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_MonthPicker__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MetricsScene=function(_React$Component){_inherits(MetricsScene,_React$Component);function MetricsScene(props){_classCallCheck(this,MetricsScene);var _this=_possibleConstructorReturn(this,(MetricsScene.__proto__||Object.getPrototypeOf(MetricsScene)).call(this,props));_this.roleSwitch=function(){var _this$props=_this.props,user=_this$props.user,match=_this$props.match;var URLRole='';Object.keys(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */]).forEach(function(roleKey){if(match.params.manufacturerRole===__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey].nameForUrl)URLRole=__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */][roleKey];});if(URLRole&&user.getActiveRole()!==URLRole.serverName){user.changeMenu(URLRole.serverName);}};_this.getMetricResult=function(){var _this$state=_this.state,selectedMetric=_this$state.selectedMetric,modelYear=_this$state.modelYear,calendarYear=_this$state.calendarYear,calendarMonth=_this$state.calendarMonth,dateError=_this$state.dateError;if(!dateError&&selectedMetric.requestPath){_this.setState({requestInProcess:true,metricResult:undefined},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(selectedMetric.requestPath(modelYear,calendarYear,calendarMonth)).then(function(_ref){var metricResult=_ref.data;_this.setState({metricResult:metricResult,requestInProcess:false});});});}};_this.getCurrentYear=function(){var user=_this.props.user;return new Promise(function(resolve,reject){switch(user.getActiveRole()){case __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref2){var data=_ref2.data;return resolve(data[1]||data[0]);});break;case __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref3){var data=_ref3.data;return resolve(data[1]||data[0]);});break;case __WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].currentModelYear).then(function(_ref4){var data=_ref4.data;return resolve(data);});break;default:resolve(new Date().getFullYear());}});};_this.selectModelYear=function(modelYear){var _this$state2=_this.state,selectedMetric=_this$state2.selectedMetric,currentYear=_this$state2.currentYear;_this.setState({modelYear:modelYear||currentYear,calendarMonth:0,dateError:'',metricResult:undefined},function(){if(!selectedMetric.withMonth){_this.getMetricResult();}});};_this.selectPreviousMonth=function(){var currentMonth=new Date().getMonth();var currentYear=+new Date().getFullYear();currentMonth=currentMonth.toString().length===1?'0'+currentMonth:currentMonth;if(!currentMonth){currentYear=currentYear-1;currentMonth=12;}_this.setState({calendarYear:currentYear,calendarMonth:currentMonth,metricResult:undefined},function(){_this.getMetricResult();});};_this.selectCalendarYear=function(calendarYear){var dateError='';if(calendarYear>+new Date().getFullYear()){dateError='Please select a month in the past';}_this.setState({calendarYear:calendarYear,dateError:dateError,calendarMonth:0});};_this.selectMonth=function(calendarMonth){var currentMonth=new Date().getMonth();var currentYear=+new Date().getFullYear();var dateError='';if(calendarMonth&&_this.state.calendarYear>=currentYear&&+calendarMonth>+currentMonth){dateError='Please select a month in the past';}if(calendarMonth.toString().length===1)calendarMonth='0'+calendarMonth;_this.setState({calendarMonth:calendarMonth,dateError:dateError,metricResult:undefined},function(){_this.getMetricResult();});};_this.selectMetricType=function(metricInfo){_this.setState({selectedMetric:metricInfo,modelYear:'',calendarMonth:'',metricResult:undefined},function(){_this.selectModelYear();if(metricInfo.withMonth)_this.selectPreviousMonth();});};_this.downloadReport=function(){var accountCode=_this.props.user.accountCode;var _this$state3=_this.state,selectedMetric=_this$state3.selectedMetric,modelYear=_this$state3.modelYear;if(selectedMetric.downloadPath){_this.setState({downloadRequestInProcess:true});var fileName=selectedMetric.downloadFileName?selectedMetric.downloadFileName(accountCode,modelYear):'Metric_Report_'+accountCode+'.xlsx';__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(selectedMetric.downloadPath(modelYear),{responseType:'blob'}).then(function(_ref5){var data=_ref5.data;Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["b" /* downloadFile */])(data,fileName);}).finally(function(){_this.setState({downloadRequestInProcess:false});});}};_this.state={selectedMetric:'',metricResult:undefined,modelYear:'',calendarMonth:'',currentYear:'',calendarYear:'',yearsList:[],requestInProcess:false,dateError:'',downloadRequestInProcess:false};return _this;}_createClass(MetricsScene,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.roleSwitch();this.getCurrentYear().then(function(currentYear){var yearsList=[];for(var i=-1;i<20;i++){yearsList.push(currentYear-i);}_this2.setState({currentYear:currentYear,yearsList:yearsList});});}},{key:'render',value:function render(){var user=this.props.user;var _state=this.state,selectedMetric=_state.selectedMetric,modelYear=_state.modelYear,calendarMonth=_state.calendarMonth,yearsList=_state.yearsList,metricResult=_state.metricResult,requestInProcess=_state.requestInProcess,calendarYear=_state.calendarYear,dateError=_state.dateError,downloadRequestInProcess=_state.downloadRequestInProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Metrics')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:__WEBPACK_IMPORTED_MODULE_5_constants_metrics__["a" /* METRICS */][user.getActiveRole()],defaultItem:selectedMetric,type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].primary,dropDownClassName:'_top_51',withoutSearch:true,placeholder:'Please select metric type',itemNameIndicator:'name',handleSelect:this.selectMetricType})),selectedMetric&&(selectedMetric.withYear||selectedMetric.withMonth)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Time period'),selectedMetric.withYear&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:yearsList,defaultItem:typeof modelYear==='number'?modelYear.toString():modelYear,type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].primary,mainWrapperClassName:'_margin_right_30',label:'Model year *',handleSelect:this.selectModelYear}),selectedMetric.withMonth&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_MonthPicker__["a" /* default */],{mainWrapperClassName:'_margin_top_18',label:'Calendar month and year *',handleSelectYear:this.selectCalendarYear,handleSelectMonth:this.selectMonth,chosenYear:calendarYear?Number(calendarYear):undefined,chosenMonth:calendarMonth,error:dateError})),selectedMetric&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},selectedMetric.downloadPath?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'Download',buttonClassName:'_height_40 _width_120',onClick:this.downloadReport,disabledWithSpinner:downloadRequestInProcess}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Result'),requestInProcess?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_flex _ai_center _jc_center _width_pc_100 _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__spinner _width_90 _height_90'})):metricResult!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:selectedMetric.resultText,value:metricResult}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)))));}}]);return MetricsScene;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return METRICS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__roles__ = __webpack_require__(15);
var _METRICS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var METRICS=(_METRICS={},_defineProperty(_METRICS,__WEBPACK_IMPORTED_MODULE_1__roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName,[{name:'New Applications',resultText:'Components created this month',withYear:false,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["b" /* componentAPI */].newComponentsCount}]),_defineProperty(_METRICS,__WEBPACK_IMPORTED_MODULE_1__roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName,[{name:'New Boats',resultText:'Boats created this month',withYear:true,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["a" /* boatAPI */].newBoatsCount},{name:'New Inspections',resultText:'Boat inspections created this month',withYear:true,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["d" /* inspectionAPI */].newBoatInspectionsCount},{name:'Approved Boats',resultText:'Boats approved for Active Manufacturers as of now',withYear:true,withMonth:false,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["a" /* boatAPI */].approvedActiveBoatsCount},{name:'Certified Boats',resultText:'Boats certified as of now',withYear:true,withMonth:false,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["a" /* boatAPI */].approvedCertifiedBoatsCount},{name:'Active Brands',resultText:'Brands active as of now',withYear:true,withMonth:false,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["a" /* boatAPI */].getActiveBrandsCount},{name:'Certified Brands',resultText:'Brands certified as of now',withYear:true,withMonth:false,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["a" /* boatAPI */].getCertifiedBrandsCount}]),_defineProperty(_METRICS,__WEBPACK_IMPORTED_MODULE_1__roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName,[{name:'New Trailers',resultText:'Trailers created this month',withYear:true,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["h" /* trailerAPI */].newTrailersCount},{name:'New Inspections',resultText:'Trailer inspections created this month',withYear:true,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["d" /* inspectionAPI */].newTrailerInspectionsCount}]),_defineProperty(_METRICS,__WEBPACK_IMPORTED_MODULE_1__roles__["a" /* ROLES */].OIL_BRANDER.serverName,[{name:'New brands',resultText:'Brands created this month',withYear:true,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["f" /* oilAPI */].newOilBrandsCount},{name:'Active Oil Brands',resultText:'',withYear:true,withMonth:false,requestPath:null,downloadPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["f" /* oilAPI */].downloadActiveOilReport,downloadFileName:function downloadFileName(accountCode,modelYear){return'Active_Oil_Brands_'+accountCode+'_'+modelYear+'.xlsx';}}]),_defineProperty(_METRICS,__WEBPACK_IMPORTED_MODULE_1__roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName,[{name:'New brands',resultText:'Brands created this month',withYear:true,withMonth:true,requestPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["f" /* oilAPI */].newOilBrandsCount},{name:'Active Oil Brands',resultText:'',withYear:true,withMonth:false,requestPath:null,downloadPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["f" /* oilAPI */].downloadActiveOilReport,downloadFileName:function downloadFileName(accountCode,modelYear){return'Active_Oil_Brands_'+accountCode+'_'+modelYear+'.xlsx';}},{name:'Active Oil Formulations',resultText:'',withYear:true,withMonth:false,requestPath:null,downloadPath:__WEBPACK_IMPORTED_MODULE_0_api_requests__["f" /* oilAPI */].downloadActiveOilFormulationsReport,downloadFileName:function downloadFileName(accountCode,modelYear){return'Active_Oil_Formulations_'+accountCode+'_'+modelYear+'.xlsx';}}]),_METRICS);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonthPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLACEHOLDER='YYYY - MM';var SELECT_DATE_TYPE={INC:'INC',DEC:'DEC'};var MonthPicker=function(_React$Component){_inherits(MonthPicker,_React$Component);function MonthPicker(props){_classCallCheck(this,MonthPicker);var _this=_possibleConstructorReturn(this,(MonthPicker.__proto__||Object.getPrototypeOf(MonthPicker)).call(this,props));_this._toggle=function(){var expanded=_this.state.expanded;if(!expanded){document.addEventListener('click',_this._toggle);_this.setState({expanded:true});}else{document.removeEventListener('click',_this._toggle);_this.setState({expanded:false});}};_this._handleYearSelect=function(selectType){return function(event){var _this$props=_this.props,chosenYear=_this$props.chosenYear,handleSelectYear=_this$props.handleSelectYear;event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();switch(selectType){case SELECT_DATE_TYPE.INC:handleSelectYear(+chosenYear+1);break;case SELECT_DATE_TYPE.DEC:handleSelectYear(+chosenYear-1);break;default:break;}};};_this.handleMonthSelect=function(month){return function(event){var handleSelectMonth=_this.props.handleSelectMonth;event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();handleSelectMonth(month);_this._toggle();};};_this.getMonths=function(){var chosenMonth=_this.props.chosenMonth;var months=[];for(var i=1,l=13;i<l;i++){months.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'day '+(i===+chosenMonth?'active':''),onClick:_this.handleMonthSelect(i)},_this.months[i-1]));}return months;};_this.state={expanded:false};_this.months=['January','February','March','April','May','June','July','August','September','October','November','December'];return _this;}_createClass(MonthPicker,[{key:'render',value:function render(){var expanded=this.state.expanded;var _props=this.props,error=_props.error,label=_props.label,mainWrapperClassName=_props.mainWrapperClassName,chosenYear=_props.chosenYear,chosenMonth=_props.chosenMonth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-wrapper date-picker-wrapper_noInput} '+mainWrapperClassName},label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'month-picker_input '+(error?'error':'')},chosenYear&&chosenMonth?chosenYear+' - '+chosenMonth:PLACEHOLDER),typeof error==='string'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-text'},error)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-picker-open-button',onClick:this._toggle}),expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'month-picker_dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'year-choose-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow decrease',onClick:this._handleYearSelect(SELECT_DATE_TYPE.DEC)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-holder'},chosenYear),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow increase',onClick:this._handleYearSelect(SELECT_DATE_TYPE.INC)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day-choose-section'},this.getMonths())):null);}}]);return MonthPicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MonthPicker.propTypes={chosenMonth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),chosenYear:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,handleSelectMonth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSelectYear:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mainWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};MonthPicker.defaultProps={chosenMonth:0,chosenYear:0,handleSelectYear:function handleSelectYear(){},handleSelectMonth:function handleSelectMonth(){},label:'',error:'',mainWrapperClassName:''};

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_routing__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Scenes_NotFoundScene__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__formula__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__brand__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OilManufacturerRouter=Object(__WEBPACK_IMPORTED_MODULE_4_HOC_User__["a" /* default */])(_class=function(_React$Component){_inherits(OilManufacturerRouter,_React$Component);function OilManufacturerRouter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OilManufacturerRouter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OilManufacturerRouter.__proto__||Object.getPrototypeOf(OilManufacturerRouter)).call.apply(_ref,[this].concat(args))),_this),_this.updateUserRole=function(role){var user=_this.props.user;if(role!==user.getActiveRole()){user.setActiveRole(role);}},_this.componentDidMount=function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].addressesList(_this.props.user.getManufacturerCode())).then(function(_ref2){var data=_ref2.data;_this.manufacturerAddresses=data.map(function(addressObject){return{name:[addressObject.Address1,addressObject.Address2,addressObject.Address3,addressObject.Address4,addressObject.City,addressObject.State,addressObject.PostalCode,addressObject.Country].filter(function(object){return object;}).join(', '),value:{address1:addressObject.Address1,address2:addressObject.Address2,address3:addressObject.Address3,address4:addressObject.Address4,city:addressObject.City,country:addressObject.Country,countryId:addressObject.CountryId,postalCode:addressObject.PostalCode,state:addressObject.State}};});_this.forceUpdate();});},_this.renderScene=function(Scene){return function(){var _this$props=_this.props,user=_this$props.user,location=_this$props.location,history=_this$props.history;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene,{user:user,location:location,history:history,updateUserRole:_this.updateUserRole,manufacturerAddresses:_this.manufacturerAddresses});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OilManufacturerRouter,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:''+__WEBPACK_IMPORTED_MODULE_5_constants_routing__["d" /* ROUTE */].OIL_MANUFACTURER+__WEBPACK_IMPORTED_MODULE_9_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.listSceneUrlPostfix,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_7__formula__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:''+__WEBPACK_IMPORTED_MODULE_5_constants_routing__["d" /* ROUTE */].OIL_BRANDER+__WEBPACK_IMPORTED_MODULE_9_constants_roles__["a" /* ROLES */].OIL_BRANDER.listSceneUrlPostfix,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_8__brand__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{render:this.renderScene(__WEBPACK_IMPORTED_MODULE_6_Scenes_NotFoundScene__["a" /* default */])}));}}]);return OilManufacturerRouter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;/* harmony default export */ __webpack_exports__["a"] = (OilManufacturerRouter);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_routing__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Scenes_NotFoundScene__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Application__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__registerIDBWorker__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OilFormulatorRouter=function(_React$Component){_inherits(OilFormulatorRouter,_React$Component);function OilFormulatorRouter(props){_classCallCheck(this,OilFormulatorRouter);props.updateUserRole(__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName);var _this=_possibleConstructorReturn(this,(OilFormulatorRouter.__proto__||Object.getPrototypeOf(OilFormulatorRouter)).call(this,props));_this.roleSwitch=function(){var user=_this.props.user;if(user.getActiveRole()!==__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName){user.changeMenu(__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.serverName);}};_this._loadFromStore=function(){var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_13__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_lists',user.getManufacturerCode()).then(function(list){_this.formulasList=list;_this.forceUpdate();});};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this._changeStatus=function(api,applicationId,applicationDataUpdateCallback){return function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].patch(api(applicationId)).then(function(_ref){var data=_ref.data;if(applicationDataUpdateCallback)applicationDataUpdateCallback(data);else _this.updateSingleListEntry(applicationId)(data);__WEBPACK_IMPORTED_MODULE_9_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(_this._closeModal);});};};_this.handleChangeStatusClick=function(api,applicationId,modalBody,applicationDataUpdateCallback){return function(){_this.modalConfirmAction=_this._changeStatus(api,applicationId,applicationDataUpdateCallback);_this.modalBody=modalBody;_this._openModal();};};_this._handleTogglePaymentStatus=function(applicationId,isPaid,applicationDataUpdateCallback){return function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].changeFormulaPaymentStatus(applicationId,!isPaid)).then(function(_ref2){var data=_ref2.data;if(applicationDataUpdateCallback)applicationDataUpdateCallback(data);else _this.updateSingleListEntry(applicationId)(data);__WEBPACK_IMPORTED_MODULE_9_dom_managers_notification__["a" /* default */].success(1,'The payment status was updated successfully.');}).finally(_this._closeModal);});};};_this.handleTogglePaymentStatusClick=function(applicationId,isPaid,applicationDataUpdateCallback){return function(){_this.modalConfirmAction=_this._handleTogglePaymentStatus(applicationId,isPaid,applicationDataUpdateCallback);_this.modalBody='Are you sure you want to mark this formulation as '+(isPaid?'Unpaid':'Paid')+'?';_this._openModal();};};_this.getAvailableActionsListBasedOnStatusAndYear=function(applicationStatus,applicationYear,applicationId,applicationDataUpdateCallback,applicationIsPaid){var user=_this.props.user;var isInternalUser=user.isInternal();var availableActionsList=[{name:'Details',action:function action(){user.goTo('/'+user.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.nameForUrl+__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.listSceneUrlPostfix+'/'+applicationId);}}];if((isInternalUser||applicationStatus!==__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].APPROVED)&&applicationStatus!==__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].DEACTIVATED)availableActionsList.push({name:'Edit',action:function action(){user.goTo('/'+user.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.nameForUrl+__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.listSceneUrlPostfix+'/'+applicationId+'/edit');}});if(isInternalUser&&applicationStatus===__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].PENDING)availableActionsList.push({name:'Approve',key:__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].APPROVED,action:_this.handleChangeStatusClick(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].approveFormula,applicationId,'Are you sure you want to Approve this application?',applicationDataUpdateCallback)});if(isInternalUser&&applicationStatus!==__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].DEACTIVATED)availableActionsList.push({name:'Deactivate',key:__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].DEACTIVATED,action:_this.handleChangeStatusClick(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].deactivateFormula,applicationId,'Are you sure you want to Deactivate this application?',applicationDataUpdateCallback)});if(isInternalUser&&applicationStatus===__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].PENDING)availableActionsList.push({name:'Incomplete',key:__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].INCOMPLETE,action:_this.handleChangeStatusClick(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].incompleteFormula,applicationId,'Are you sure you want to mark this application as Incomplete?',applicationDataUpdateCallback)});if(applicationStatus===__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].INCOMPLETE)availableActionsList.push({name:'Submit',key:__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].PENDING,action:_this.handleChangeStatusClick(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].pendFormula,applicationId,'Are you sure you want to Submit this application?',applicationDataUpdateCallback)});if(isInternalUser)availableActionsList.push({name:applicationIsPaid?'Set Unpaid':'Set Paid',action:_this.handleTogglePaymentStatusClick(applicationId,applicationIsPaid,applicationDataUpdateCallback)});//TODO RollOver goes here
return availableActionsList;};_this.updateSingleListEntry=function(oldEntryId){return function(newEntry){var user=_this.props.user;if(oldEntryId){var oldEntryIndex=0;_this.formulasList.forEach(function(entry,index){if(entry.id==oldEntryId)oldEntryIndex=index;});_this.formulasList.splice(oldEntryIndex,1,newEntry);}else{_this.formulasList.unshift(newEntry);}__WEBPACK_IMPORTED_MODULE_13__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',_this.formulasList,user.getManufacturerCode()).then(function(){_this._loadFromStore();});};};_this.renderScene=function(Scene){return function(_ref3){var match=_ref3.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene,{user:_this.props.user,getAvailableActionsListBasedOnStatusAndYear:_this.getAvailableActionsListBasedOnStatusAndYear,formulasList:_this.formulasList,listRequestInProgress:_this.listRequestInProgress,engineTypes:_this.engineTypes,match:match,updateSingleListEntry:_this.updateSingleListEntry,manufacturerAddresses:_this.props.manufacturerAddresses});};};_this.state={isModalOpen:false};_this.engineTypes=[];_this.formulasList=[];_this.listRequestInProgress=true;_this._loadFromStore();return _this;}_createClass(OilFormulatorRouter,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;this.roleSwitch();__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].engineTypes).then(function(_ref4){var data=_ref4.data;_this2.engineTypes=data;_this2.forceUpdate();});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].formulasList).then(function(_ref5){var list=_ref5.data;__WEBPACK_IMPORTED_MODULE_13__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',list,user.getManufacturerCode()).then(function(){_this2.listRequestInProgress=false;_this2._loadFromStore();});});}},{key:'render',value:function render(){var _state=this.state,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess;var rootRoute=''+__WEBPACK_IMPORTED_MODULE_4_constants_routing__["d" /* ROUTE */].OIL_MANUFACTURER+__WEBPACK_IMPORTED_MODULE_8_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.listSceneUrlPostfix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:rootRoute+'/:applicationId',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_7__Application__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:''+rootRoute,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_6__List__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:this.renderScene(__WEBPACK_IMPORTED_MODULE_5_Scenes_NotFoundScene__["a" /* default */])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))));}}]);return OilFormulatorRouter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OilFormulatorRouter);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormulasList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltersSection__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableHeader__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Row__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['baseOilNumber','baseFormulaBaseOilNumber','formulatorNumber'];var FormulasList=function(_React$Component){_inherits(FormulasList,_React$Component);function FormulasList(props){_classCallCheck(this,FormulasList);var _this=_possibleConstructorReturn(this,(FormulasList.__proto__||Object.getPrototypeOf(FormulasList)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,applicationStatus:'All',selectedType:'All',sortedBy:'baseOilNumber',sortAsc:-1,filter:{},searchString:''};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this.handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},function(){user.updateURLSearchString({activePage:activePage});});};_this._filterList=function(componentList){var _this$state=_this.state,filter=_this$state.filter,searchString=_this$state.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return componentList.filter(function(element){for(var filterFieldName in filter){if(element[filterFieldName]!==filter[filterFieldName])return false;}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this._sortList=function(a,b){var _this$state2=_this.state,sortedBy=_this$state2.sortedBy,sortAsc=_this$state2.sortAsc;switch(sortedBy){case'isPaid':case'isReadAcrossFormula':return a[sortedBy]>b[sortedBy]?sortAsc:-sortAsc;default:if(a[sortedBy]&&b[sortedBy])return a[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')>b[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;else return a[sortedBy]>b[sortedBy]?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){var user=_this.props.user;_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc,activePage:1};},function(){user.updateURLSearchString({sortedBy:_this.state.sortedBy,sortAsc:_this.state.sortAsc,activePage:1});});};};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(newFilterFieldValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=newFilterFieldValue;_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});});};};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this._getList=function(){var _this$props=_this.props,user=_this$props.user,listRequestInProgress=_this$props.listRequestInProgress,formulasList=_this$props.formulasList,getAvailableActionsListBasedOnStatusAndYear=_this$props.getAvailableActionsListBasedOnStatusAndYear;var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var resultList=[];var resultLength=0;if(!formulasList.length){if(listRequestInProgress){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'spinner',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EmptyList__["a" /* default */],{key:'empty'},'No formulas for selected manufacturer.')];}}else{var filteredList=_this._filterList(formulasList).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EmptyList__["a" /* default */],{key:'empty'},'No formulas found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(formula,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Row__["a" /* default */],{key:formula.id,user:user,formula:formula,isOdd:!!(index%2),sortedBy:sortedBy,availableActionsList:getAvailableActionsListBasedOnStatusAndYear(formula.applicationStatus,8000,formula.id,undefined,formula.isPaid)});});resultLength=filteredList.length;}}return{resultList:resultList,resultLength:resultLength};};var storedState=props.user.getStoredState('formulaListState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);return _this;}_createClass(FormulasList,[{key:'componentWillUnmount',value:function componentWillUnmount(){var user=this.props.user;user.saveState('formulaListState',this.state,[]);}},{key:'render',value:function render(){var engineTypes=this.props.engineTypes;var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,filter=_state.filter,searchString=_state.searchString;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Formulation List',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_7_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowCountSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,filterState:filter,engineTypes:engineTypes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this.handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return FormulasList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var outCount=_ref.outCount,handleRowCountSelect=_ref.handleRowCountSelect,rowsCount=_ref.rowsCount,handleSelectFilter=_ref.handleSelectFilter,filterState=_ref.filterState,engineTypes=_ref.engineTypes;var FORMULA_TYPES=[{name:'All',value:'All'},{name:'Base',value:false},{name:'Read-across',value:true}];var FORMULA_STATUSES=[{name:'All',value:'All'},{name:'Approved',value:'APPROVED'},{name:'Pending',value:'PENDING'},{name:'Incomplete',value:'INCOMPLETE'},{name:'Deactivated',value:'DEACTIVATED'}];var FEE_STATUSES=[{name:'All',value:'All'},{name:'Unpaid',value:false},{name:'Paid',value:true}];var engineTypesWithAllField=['All'].concat(engineTypes);var getSelectedItem=function getSelectedItem(key,possibleItemsList){if(filterState[key]===undefined)return possibleItemsList[0];return possibleItemsList.find(function(item){return item.value===filterState[key];});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:FORMULA_TYPES,handleSelect:handleSelectFilter('isReadAcrossFormula'),placeholder:'All',defaultItem:getSelectedItem('isReadAcrossFormula',FORMULA_TYPES),label:'by Formulation Type',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:engineTypesWithAllField,handleSelect:handleSelectFilter('engineType'),label:'by Engine Oil Type',placeholder:'All',defaultItem:filterState.engineType||engineTypesWithAllField[0],type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:FORMULA_STATUSES,handleSelect:handleSelectFilter('applicationStatus'),placeholder:'All',defaultItem:getSelectedItem('applicationStatus',FORMULA_STATUSES),label:'by Application Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:FEE_STATUSES,handleSelect:handleSelectFilter('isPaid'),placeholder:'All',defaultItem:getSelectedItem('isPaid',FEE_STATUSES),label:'by Fee Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowCountSelect,selectedRowsCount:rowsCount})));});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('baseOilNumber')+' _width_pc_12',onClick:handleSortClick('baseOilNumber')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Base Oil No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('baseFormulaBaseOilNumber')+' _width_pc_12',onClick:handleSortClick('baseFormulaBaseOilNumber')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Read Across Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('formulatorNumber')+' _width_pc_18',onClick:handleSortClick('formulatorNumber')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Formulation Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('isReadAcrossFormula')+' _width_pc_12',onClick:handleSortClick('isReadAcrossFormula')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Formulation Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('engineType')+' _width_pc_10',onClick:handleSortClick('engineType')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Engine Oil Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('applicationStatus')+' _width_pc_12',onClick:handleSortClick('applicationStatus')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('isPaid')+' _width_pc_12',onClick:handleSortClick('isPaid')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Fee status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element  _width_pc_12'}));});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Text__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._selectAction=function(action){action.action();},_this._getStatusColor=function(){var formula=_this.props.formula;if(formula&&formula.applicationStatus){return'list-scene__status-label_'+formula.applicationStatus.toString().toLowerCase();}return'';},_this._getFormulaReadableStatus=function(){var formula=_this.props.formula;if(formula&&formula.applicationStatus){return formula.applicationStatus[0].toUpperCase()+formula.applicationStatus.slice(1).toLowerCase();}return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,formula=_props.formula,availableActionsList=_props.availableActionsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaRowId'+formula.baseOilNumber,className:'list-scene__table-row '+this._getBackgroundColourStyle(),onClick:availableActionsList[0].action},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaOilNumberField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n          '+this._getTextColourStyle('baseOilNumber')+' _width_pc_12'},formula.baseOilNumber||'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaBaseFormulaOilNumberField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n          '+this._getTextColourStyle('baseFormulaBaseOilNumber')+' _width_pc_12'},formula.baseFormulaBaseOilNumber||'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaFormulatorNumberField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n          '+this._getTextColourStyle('formulatorNumber')+' _width_pc_18'},formula.formulatorNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaIsReadAcrossField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n          '+this._getTextColourStyle('isReadAcrossFormula')+' _width_pc_12'},formula.isReadAcrossFormula?'Read-across':'Base'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaEngineTypeField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n          '+this._getTextColourStyle('engineType')+' _width_pc_10'},formula.engineType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('applicationStatus')},this._getFormulaReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaFeeStatusField',className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_90 _margin_0',textClassName:'text__binary-status-text '+(formula.isPaid?'true':'false')+' _margin_0 '+this._getTextColourStyle('isPaid'),value:formula.isPaid?'Paid':'Unpaid'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'formulaActionsField',className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{placeholder:'Actions',selectionList:availableActionsList,itemNameIndicator:'name',multiSelect:true,handleSelect:this._selectAction,type:__WEBPACK_IMPORTED_MODULE_2_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()}));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={formula:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_routing__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Scenes_NotFoundScene__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Create__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Details__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Edit__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OilFormulatorRouter=function(_React$Component){_inherits(OilFormulatorRouter,_React$Component);function OilFormulatorRouter(props){_classCallCheck(this,OilFormulatorRouter);var _this=_possibleConstructorReturn(this,(OilFormulatorRouter.__proto__||Object.getPrototypeOf(OilFormulatorRouter)).call(this,props));_this.updateAddressesList=function(){var manufacturerAddresses=_this.props.manufacturerAddresses;var manufacturerAddress=_this.state.applicationData.manufacturerAddress;var manufacturerAddressesWithCurrent=[].concat(_toConsumableArray(manufacturerAddresses));if(manufacturerAddress){var address=manufacturerAddresses.find(function(address){var isSame=true;Object.keys(address.value).forEach(function(addressField){if(address.value[addressField]!==manufacturerAddress[addressField])isSame=false;});return isSame;});if(!address){address={name:[manufacturerAddress.address1,manufacturerAddress.address2,manufacturerAddress.address3,manufacturerAddress.address4,manufacturerAddress.city,manufacturerAddress.state,manufacturerAddress.postalCode,manufacturerAddress.country].filter(function(object){return object;}).join(', '),value:Object.assign({},manufacturerAddress)};if(address.name){manufacturerAddressesWithCurrent.unshift(address);}}}_this.setState({manufacturerAddressesWithCurrent:manufacturerAddressesWithCurrent});};_this.updateApplicationData=function(data){var _this$props=_this.props,updateSingleListEntry=_this$props.updateSingleListEntry,match=_this$props.match;updateSingleListEntry(match.params.applicationId)(data);_this.setState({applicationData:data});};_this.renderScene=function(Scene){var manufacturerAddresses=_this.props.manufacturerAddresses;var _this$state=_this.state,applicationData=_this$state.applicationData,manufacturerAddressesWithCurrent=_this$state.manufacturerAddressesWithCurrent;return function(_ref){var match=_ref.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene,Object.assign({},_this.props,{manufacturerAddresses:isFinite(match.params.applicationId)?manufacturerAddressesWithCurrent:manufacturerAddresses,applicationData:applicationData,updateApplicationData:_this.updateApplicationData,match:match}));};};_this.state={manufacturerAddressesWithCurrent:[]};return _this;}_createClass(OilFormulatorRouter,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var match=this.props.match;if(isFinite(match.params.applicationId)){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].formula(match.params.applicationId)).then(function(_ref2){var data=_ref2.data;_this2.setState({applicationData:data});});}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.state.manufacturerAddressesWithCurrent.length&&this.state.applicationData&&this.props.manufacturerAddresses)this.updateAddressesList();}},{key:'render',value:function render(){var rootRoute=''+__WEBPACK_IMPORTED_MODULE_4_constants_routing__["d" /* ROUTE */].OIL_MANUFACTURER+__WEBPACK_IMPORTED_MODULE_9_constants_roles__["a" /* ROLES */].OIL_MANUFACTURER.listSceneUrlPostfix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:rootRoute+'/new',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_6__Create__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:rootRoute+'/:applicationId',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_7__Details__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:rootRoute+'/:applicationId/edit',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_8__Edit__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:this.renderScene(__WEBPACK_IMPORTED_MODULE_5_Scenes_NotFoundScene__["a" /* default */])}));}}]);return OilFormulatorRouter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OilFormulatorRouter);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormulaCreate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Modal__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormulaCreate=function(_React$Component){_inherits(FormulaCreate,_React$Component);function FormulaCreate(props){_classCallCheck(this,FormulaCreate);var _this=_possibleConstructorReturn(this,(FormulaCreate.__proto__||Object.getPrototypeOf(FormulaCreate)).call(this,props));_this.handleSelect=function(fieldName){return function(input){var _this$setState;var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var selectedItem=input;delete newInputErrors[fieldName];_this.someDataWasInputted=true;_this.setState((_this$setState={},_defineProperty(_this$setState,fieldName,selectedItem),_defineProperty(_this$setState,'inputErrors',newInputErrors),_this$setState));};};_this.handleFormulaTypeSelect=function(input){_this.someDataWasInputted=true;_this.setState({chosenFormulaType:input,inputErrors:{}});};_this.handleEngineTypeSelect=function(input){var inputErrors=_this.state.inputErrors;delete inputErrors.chosenEngineType;delete inputErrors.chosenBaseFormula;_this.someDataWasInputted=true;_this.setState({chosenEngineType:input,chosenBaseFormula:'',inputErrors:inputErrors});};_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;if(!error||error.ops){var _this$setState2;delete inputErrors[field];_this.someDataWasInputted=true;_this.setState((_this$setState2={},_defineProperty(_this$setState2,field,value),_defineProperty(_this$setState2,'inputErrors',inputErrors),_this$setState2));}};};_this.handleFileSelect=function(files){var newInputErrors=_this.state.inputErrors;delete newInputErrors.testReports;_this.someDataWasInputted=true;_this.setState(function(prevState){return{testReports:[].concat(_toConsumableArray(prevState.testReports),_toConsumableArray(files)),inputErrors:newInputErrors};});};_this.handleRemoveFile=function(index){return function(){_this.setState(function(prevState){prevState.testReports.splice(index,1);return{testReports:prevState.testReports};});};};_this.validateForm=function(){var _this$state=_this.state,inputErrors=_this$state.inputErrors,chosenFormulaType=_this$state.chosenFormulaType;var newInputErrors=inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};chosenFormulaType.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))newInputErrors[fieldName]=true;});return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length)reject();else resolve();});});};_this.submitFormula=function(){var _this$state2=_this.state,chosenFormulaType=_this$state2.chosenFormulaType,chosenEngineType=_this$state2.chosenEngineType,formulatorNumber=_this$state2.formulatorNumber,manufacturerAddress=_this$state2.manufacturerAddress,testReports=_this$state2.testReports,chosenBaseFormula=_this$state2.chosenBaseFormula,description=_this$state2.description;var _this$props=_this.props,user=_this$props.user,updateSingleListEntry=_this$props.updateSingleListEntry;_this.validateForm().then(function(){var headers={'Content-Type':'multipart/form-data'};var dataPayload={formulatorNumber:formulatorNumber,engineType:chosenEngineType,manufacturerAddress:manufacturerAddress.value,isReadAcrossFormula:chosenFormulaType.isReadAcrossFormula,description:description};if(dataPayload.isReadAcrossFormula)dataPayload.baseFormulaId=chosenBaseFormula;var data=new FormData();data.append('requestJson',JSON.stringify(dataPayload));testReports.forEach(function(file){return data.append('reports',file);});_this.modalBody='Are you sure you want to submit this application?';_this.modalConfirmAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].submitFormula,data,{headers:headers}).then(function(_ref){var data=_ref.data;__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'Your application was submitted successfully');updateSingleListEntry()(data);_this.someDataWasInputted=false;user.goToList(false,false);}).finally(function(){_this.setState({requestInProcess:false});_this._closeModal();});});};_this._openModal();});};_this.handleBackButtonClick=function(){var user=_this.props.user;user.goToList();};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this._closeModal();user.goTo(location);};_this._openModal();return false;}return true;};_this.formulaTypes=[{name:'Base Formulation',requiredFields:['formulatorNumber','manufacturerAddress','testReports','chosenEngineType'],isReadAcrossFormula:false},{name:'Read Across Formulation',requiredFields:['formulatorNumber','manufacturerAddress','testReports','chosenEngineType','chosenBaseFormula'],isReadAcrossFormula:true}];_this.state={chosenFormulaType:{},inputErrors:{},formulatorNumber:'',chosenEngineType:'',manufacturerAddress:'',testReports:[],chosenBaseFormula:'',description:'',isModalOpen:false,requestInProcess:false};_this.someDataWasInputted=false;_this.modalBody='';return _this;}_createClass(FormulaCreate,[{key:'render',value:function render(){var _state=this.state,chosenFormulaType=_state.chosenFormulaType,inputErrors=_state.inputErrors,chosenEngineType=_state.chosenEngineType,formulatorNumber=_state.formulatorNumber,manufacturerAddress=_state.manufacturerAddress,testReports=_state.testReports,chosenBaseFormula=_state.chosenBaseFormula,description=_state.description,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess;var _props=this.props,engineTypes=_props.engineTypes,formulasList=_props.formulasList,listRequestInProgress=_props.listRequestInProgress,manufacturerAddresses=_props.manufacturerAddresses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:this.handleBackButtonClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'New Formulation Application')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:this.formulaTypes,defaultItem:chosenFormulaType,type:'primary',inputClassName:'',dropDownClassName:'',label:'Formulation Type *',placeholder:'Please select formulation type',itemNameIndicator:'name',error:inputErrors.chosenFormulaType,handleSelect:this.handleFormulaTypeSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',maxLength:250,label:'Formulation Number *',value:formulatorNumber,error:inputErrors.formulatorNumber,onChange:this.handleInputChange('formulatorNumber')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:engineTypes,defaultItem:chosenEngineType,type:'primary',mainWrapperClassName:'_margin_right_30',label:'Engine Oil Type *',placeholder:'Please select engine type',error:inputErrors.chosenEngineType,handleSelect:this.handleEngineTypeSelect}),chosenFormulaType.isReadAcrossFormula&&/*
                { <Select
                  selectionList={formulasList.filter(
                    formula => formula.applicationStatus === 'APPROVED' && (formula.engineType === chosenEngineType || (chosenEngineType === 'FC-W(CAT)' && formula.engineType === 'FC-W'  ))
                  )}
                  defaultItem={chosenBaseFormula}
                  isSlave
                  type='primary'
                  label='Read Across Source *'
                  placeholder='Please select base Oil number'
                  disabled={!chosenEngineType}
                  isLoading={listRequestInProgress}
                  itemNameIndicator='baseOilNumber'
                  error={inputErrors.chosenBaseFormula}
                  handleSelect={this.handleSelect('chosenBaseFormula')}
                /> */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Read Across Source *',maxLength:30,placeholder:'Please provide base Oil number',value:chosenBaseFormula,onChange:this.handleInputChange('chosenBaseFormula')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Description',maxLength:250,placeholder:'Provide some description if necessary',value:description,onChange:this.handleInputChange('description')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:manufacturerAddresses,type:'primary',mainWrapperClassName:'select__main-wrapper_primary _width_pc_100',defaultItem:manufacturerAddress,label:'Select Address *',itemNameIndicator:'name',error:inputErrors.manufacturerAddress,handleSelect:this.handleSelect('manufacturerAddress')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__["a" /* default */],{files:testReports,handleFileSelect:this.handleFileSelect,handleRemoveFile:this.handleRemoveFile,editableStateSectionHeader:'Upload Test Report and Supporting Documentation',sectionHeaderClassName:'_margin_top_0 _font_size_14',error:inputErrors.testReports?'Please upload at least one report':''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_ApplicationActions__["a" /* default */],{saveButtonLabel:'Submit',saveButtonAction:this.submitFormula,cancelButtonLabel:'Cancel',cancelButtonAction:this.handleBackButtonClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_9_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_9_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}]);return FormulaCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UploadButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_managers_notification__ = __webpack_require__(16);
var availableFileExtensions=/\.(pdf|png|doc|docx|xls|xlsx|jpg|jpeg|txt|msg)$/;var maxSize=26214400;var forbidenSumbols=/\/|\\|\?|%|\*|:|\||"|<|>|#/;function UploadButton(_ref){var error=_ref.error,errorClassName=_ref.errorClassName,handleFileSelect=_ref.handleFileSelect,editableStateSectionHeader=_ref.editableStateSectionHeader,sectionHeaderClassName=_ref.sectionHeaderClassName,uploadButtonText=_ref.uploadButtonText,files=_ref.files;var _handleFileChoose=function _handleFileChoose(event){var files=event.target.files;files.filter=Array.prototype.filter;var approvedFiles=event.target.files.filter(function(file){return!forbidenSumbols.test(file.name.toLowerCase());});if(files.length!==approvedFiles.length){__WEBPACK_IMPORTED_MODULE_1_dom_managers_notification__["a" /* default */].error('note','File name contains prohibited characters. The following characters are not allowed: / \\ ? % * : | " < > #');}else{approvedFiles=approvedFiles.filter(function(file){return availableFileExtensions.test(file.name.toLowerCase())&&file.size<=maxSize;});if(files.length!==approvedFiles.length){__WEBPACK_IMPORTED_MODULE_1_dom_managers_notification__["a" /* default */].error('note','One of files was of wrong format or too big');}else{handleFileSelect(approvedFiles);}}event.target.value='';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__button-wrapper '+(files.length?'_margin_bottom_30':'')},error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__error-message '+errorClassName},error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fileButton',className:'ect-file-picker__button _height_34 _width_145'},uploadButtonText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',className:'ect-file-picker__input',multiple:true,onChange:_handleFileChoose,id:'fileButton'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ect-file-picker__hint'},'(Pdf, Doc, Docx, Xls, Xlsx, Png, Jpg, Jpeg, Txt, Msg / Max. 25Mb)')));}

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FileList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FileRow__ = __webpack_require__(1009);
function FileList(_ref){var httpParams=_ref.httpParams,files=_ref.files,handleRemoveFile=_ref.handleRemoveFile,isEditable=_ref.isEditable,doNotRemoveFiles=_ref.doNotRemoveFiles,listSectionId=_ref.listSectionId;if(!files.length)return null;var hasUploadDates=function hasUploadDates(){return!!files.find(function(file){return file.created;});};var idObj={};if(listSectionId)idObj.id=listSectionId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',Object.assign({},idObj,{className:'ect-file-picker__files-list'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__files-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_name'},'File name'),hasUploadDates()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_upload-date'},'Upload date'),hasUploadDates()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_download'},'Download'),isEditable&&!doNotRemoveFiles&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_remove'},'Remove')),files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FileRow__["a" /* default */],{key:index,file:file,index:index,isEditable:isEditable,httpParams:httpParams,handleRemoveFile:handleRemoveFile,doNotRemoveFiles:doNotRemoveFiles});}));}

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FileRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_managers_notification__ = __webpack_require__(16);
function FileRow(_ref){var file=_ref.file,index=_ref.index,handleRemoveFile=_ref.handleRemoveFile,httpParams=_ref.httpParams,isEditable=_ref.isEditable,doNotRemoveFiles=_ref.doNotRemoveFiles;var handleDownloadFile=function handleDownloadFile(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(httpParams.currentMethod(httpParams.currentId,file[httpParams.fileIdFieldName||'id']),{responseType:'blob'}).then(function(_ref2){var data=_ref2.data;Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["b" /* downloadFile */])(data,file.name);});};var fileIsNotExist=file.hasOwnProperty('exists')&&file.exists===false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__files-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_name ect-file-picker__col_name_icon'},file.name),file.created&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_upload-date'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(file.created).format('MM/DD/YYYY')),file.created&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_download'},fileIsNotExist?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_download-attention-icon',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_4_dom_managers_notification__["a" /* default */].error(1,'Uploaded file no longer exists on server.');}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_download-icon',onClick:handleDownloadFile})),isEditable&&!doNotRemoveFiles&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_remove'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__remove-icon',onClick:handleRemoveFile(index)})));}

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormulaTypeSection__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotesSection__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GeneralInformation__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChangeStatus__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContactDetails__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DownloadSection__ = __webpack_require__(1017);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsApplication=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsApplication);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call.apply(_ref,[this].concat(args))),_this),_this._handleBackClick=function(){var user=_this.props.user;user.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsApplication,[{key:'render',value:function render(){var _props=this.props,user=_props.user,match=_props.match,applicationData=_props.applicationData,getAvailableActionsListBasedOnStatusAndYear=_props.getAvailableActionsListBasedOnStatusAndYear,updateApplicationData=_props.updateApplicationData;var applicationId=match.params.applicationId;if(!applicationData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */],{user:user,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{var applicationStatus=applicationData.applicationStatus,isReadAcrossFormula=applicationData.isReadAcrossFormula,baseOilNumber=applicationData.baseOilNumber,isPaid=applicationData.isPaid,notes=applicationData.notes,submissionDate=applicationData.submissionDate,formulatorNumber=applicationData.formulatorNumber,baseFormulaBaseOilNumber=applicationData.baseFormulaBaseOilNumber,engineType=applicationData.engineType,testReports=applicationData.testReports,description=applicationData.description,approvalDate=applicationData.approvalDate,submittedBy=applicationData.submittedBy,manufacturerAddress=applicationData.manufacturerAddress;var availableActions=getAvailableActionsListBasedOnStatusAndYear(applicationStatus,8000,applicationId,updateApplicationData,isPaid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+applicationStatus.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */],{applicationStatus:applicationStatus,applicationId:applicationId,availableActions:availableActions,user:user,loadInProgress:!applicationData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormulaTypeSection__["a" /* default */],{isReadAcrossFormula:isReadAcrossFormula,baseOilNumber:baseOilNumber,isPaid:isPaid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GeneralInformation__["a" /* default */],{submissionDate:submissionDate,approvalDate:approvalDate,formulatorNumber:formulatorNumber,baseFormulaBaseOilNumber:baseFormulaBaseOilNumber,engineType:engineType,isReadAcrossFormula:isReadAcrossFormula,description:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotesSection__["a" /* default */],{notes:notes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ContactDetails__["a" /* default */],{submittedBy:submittedBy,manufacturerAddress:manufacturerAddress}),!!testReports.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__["a" /* default */],{isEditable:false,files:testReports,sectionHeaderClassName:'_margin_top_0 _font_size_14',httpParams:{currentId:applicationId,currentMethod:__WEBPACK_IMPORTED_MODULE_1_api_requests__["f" /* oilAPI */].downloadReport}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ChangeStatus__["a" /* default */],{applicationId:applicationId,user:user,status:applicationStatus,availableActions:availableActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DownloadSection__["a" /* default */],{user:user,applicationStatus:applicationStatus,applicationId:applicationId,name:baseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Back',backButtonAction:this._handleBackClick}))));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleEditClick=_ref.handleEditClick,applicationStatus=_ref.applicationStatus,user=_ref.user,applicationId=_ref.applicationId,loadInProgress=_ref.loadInProgress,availableActions=_ref.availableActions;var link='/'+user.getManufacturerCode()+'/oil/formula/'+applicationId+'/edit';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Oil Formulation Details'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,availableActions.find(function(act){return act.name===__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ACTION */].EDIT;})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase())));});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var isReadAcrossFormula=_ref.isReadAcrossFormula,baseOilNumber=_ref.baseOilNumber,isPaid=_ref.isPaid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Formulation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Formulation Type',value:isReadAcrossFormula?'Read Across Formulation':'Base Formulation'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Base Oil Number',value:baseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_90',textClassName:'text__binary-status-text '+(isPaid?'true':'false'),label:'Payment Status',value:isPaid?'Paid':'Unpaid'}));});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes;if(!notes)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,disabled:true}));}

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submissionDate=_ref.submissionDate,approvalDate=_ref.approvalDate,formulatorNumber=_ref.formulatorNumber,baseFormulaBaseOilNumber=_ref.baseFormulaBaseOilNumber,engineType=_ref.engineType,isReadAcrossFormula=_ref.isReadAcrossFormula,description=_ref.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Submission Date',value:submissionDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Approval Date',value:approvalDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Formulation Number',value:formulatorNumber}),isReadAcrossFormula&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Read Across Source',value:baseFormulaBaseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Engine Oil Type',value:engineType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Description',value:description}));});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeStatus=function(_React$Component){_inherits(ChangeStatus,_React$Component);function ChangeStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeStatus.__proto__||Object.getPrototypeOf(ChangeStatus)).call.apply(_ref,[this].concat(args))),_this),_this.getActionFromList=function(key){var availableActions=_this.props.availableActions;return availableActions.find(function(action){return action.key===key;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeStatus,[{key:'render',value:function render(){var _this2=this;var _props=this.props,applicationId=_props.applicationId,user=_props.user;var link='/'+user.getManufacturerCode()+'/oil/formula/'+applicationId+'/edit';var actions=[{key:'edit',isShown:true,Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{className:'_height_40 _width_pc_100 _max_width_180 _margin_right_20'}));}},{key:'approve',isShown:this.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].APPROVED),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Approve',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:_this2.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].APPROVED).action,type:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].green});}},{key:'deactivate',isShown:this.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Deactivate',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:_this2.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED).action,color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].red});}},{key:'incomplete',isShown:this.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].INCOMPLETE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Incomplete',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:_this2.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].INCOMPLETE).action,type:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].lightBlue});}},{key:'submit',isShown:this.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].PENDING),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Submit',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:_this2.getActionFromList(__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].PENDING).action,type:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].orange});}}];if(actions.filter(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('isShown')).length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Actions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__change-status-buttons-wrapper'},actions.map(function(_ref2){var key=_ref2.key,isShown=_ref2.isShown,Component=_ref2.Component;return isShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,{key:key});})));}}]);return ChangeStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submittedBy=_ref.submittedBy,manufacturerAddress=_ref.manufacturerAddress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Contact details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Name',value:submittedBy?submittedBy.firstName+' '+submittedBy.lastName:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Email',value:submittedBy?submittedBy.email:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Address',value:manufacturerAddress?[manufacturerAddress.address1,manufacturerAddress.address2,manufacturerAddress.address3,manufacturerAddress.address4,manufacturerAddress.city,manufacturerAddress.state,manufacturerAddress.postalCode,manufacturerAddress.country].filter(function(object){return object;}).join(', '):'N/A'}));});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(34);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var user=_ref.user,applicationStatus=_ref.applicationStatus,applicationId=_ref.applicationId,name=_ref.name;var downloadLetter=function downloadLetter(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["f" /* oilAPI */].downloadFormulaCertLetter(applicationId),{responseType:'blob'}).then(function(_ref2){var data=_ref2.data;Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["b" /* downloadFile */])(data,'Formula_Certification_Letter_'+name+'.pdf');});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Downloads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__downloads-section-buttons-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__downloads-section-button',onClick:downloadLetter},'Formulation Certification Letter')));});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormulaTypeSection__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Notes__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GeneralInformation__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContactDetails__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Components_Button__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsApplication=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(props){_classCallCheck(this,DetailsApplication);var _this=_possibleConstructorReturn(this,(DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call(this,props));_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;if(!error||error.ops){var _this$setState;delete inputErrors[field];_this.setState((_this$setState={},_defineProperty(_this$setState,field,value),_defineProperty(_this$setState,'inputErrors',inputErrors),_this$setState));}};};_this.handleSelect=function(fieldName){return function(input){var _this$setState2;var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var selectedItem=input.value||input;delete newInputErrors[fieldName];_this.someDataWasInputted=true;_this.setState((_this$setState2={},_defineProperty(_this$setState2,fieldName,selectedItem),_defineProperty(_this$setState2,'inputErrors',newInputErrors),_this$setState2));};};_this.handleFileSelect=function(files){var newInputErrors=_this.state.inputErrors;delete newInputErrors.testReports;_this.someDataWasInputted=true;_this.setState(function(prevState){return{testReports:[].concat(_toConsumableArray(prevState.testReports),_toConsumableArray(files)),inputErrors:newInputErrors};});};_this.handleRemoveFile=function(index){return function(){var testReports=_this.state.testReports;if(testReports[index].created){_this.filesIdsToDelete.push(testReports[index].id);}var newInputErrors=_this.state.inputErrors;if(testReports.length===1)newInputErrors.testReports=true;_this.someDataWasInputted=true;_this.setState(function(prevState){prevState.testReports.splice(index,1);return{testReports:prevState.testReports,inputErrors:newInputErrors};});};};_this.handleBackButtonClick=function(){var user=_this.props.user;user.goToList();};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.validateForm=function(){var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))newInputErrors[fieldName]=true;});return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length)reject();else resolve();});});};_this.submitFormula=function(){var _this$state=_this.state,formulatorNumber=_this$state.formulatorNumber,manufacturerAddress=_this$state.manufacturerAddress,description=_this$state.description,notes=_this$state.notes,testReports=_this$state.testReports;var _this$props=_this.props,user=_this$props.user,match=_this$props.match,updateSingleListEntry=_this$props.updateSingleListEntry;_this.validateForm().then(function(){var headers={'Content-Type':'multipart/form-data'};var dataPayload={id:match.params.applicationId,formulatorNumber:formulatorNumber,manufacturerAddress:manufacturerAddress,description:description,notes:notes,fileIdsToDelete:_this.filesIdsToDelete};var data=new FormData();data.append('requestJson',JSON.stringify(dataPayload));testReports.forEach(function(file){if(!file.created)data.append('reports',file);});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].updateFormula,data,{headers:headers}).then(function(_ref){var data=_ref.data;updateSingleListEntry(match.params.applicationId)(data);_this.someDataWasInputted=false;__WEBPACK_IMPORTED_MODULE_9_dom_managers_notification__["a" /* default */].success(1,'Formulation details successfully updated');user.goToList();});});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this._closeModal();user.goTo(location);};_this._openModal();return false;}return true;};_this.state={inputErrors:{},isModalOpen:false};_this.filesIdsToDelete=[];_this.requiredFields=['formulatorNumber','manufacturerAddress','testReports'];var applicationData=props.applicationData;if(applicationData){_this.state=Object.assign({},_this.state,applicationData);}_this.someDataWasInputted=false;return _this;}_createClass(DetailsApplication,[{key:'componentDidUpdate',value:function componentDidUpdate(){var applicationData=this.props.applicationData;if(applicationData&&!this.state.formulatorNumber){this.setState(function(prevState){return Object.assign({},prevState,applicationData);});}}},{key:'render',value:function render(){var _state=this.state,inputErrors=_state.inputErrors,description=_state.description,formulatorNumber=_state.formulatorNumber,manufacturerAddress=_state.manufacturerAddress,notes=_state.notes,testReports=_state.testReports,isModalOpen=_state.isModalOpen;var _props=this.props,user=_props.user,match=_props.match,applicationData=_props.applicationData,manufacturerAddresses=_props.manufacturerAddresses;var applicationId=match.params.applicationId;if(!applicationData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{user:user,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{var applicationStatus=applicationData.applicationStatus,isReadAcrossFormula=applicationData.isReadAcrossFormula,baseOilNumber=applicationData.baseOilNumber,isPaid=applicationData.isPaid,submissionDate=applicationData.submissionDate,baseFormulaBaseOilNumber=applicationData.baseFormulaBaseOilNumber,engineType=applicationData.engineType,approvalDate=applicationData.approvalDate,submittedBy=applicationData.submittedBy;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+applicationStatus.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{applicationStatus:applicationStatus,applicationId:applicationId,handleBackButtonClick:this.handleBackButtonClick,loadInProgress:!applicationData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FormulaTypeSection__["a" /* default */],{isReadAcrossFormula:isReadAcrossFormula,baseOilNumber:baseOilNumber,isPaid:isPaid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GeneralInformation__["a" /* default */],{submissionDate:submissionDate,approvalDate:approvalDate,formulatorNumber:formulatorNumber,baseFormulaBaseOilNumber:baseFormulaBaseOilNumber,engineType:engineType,isReadAcrossFormula:isReadAcrossFormula,description:description,handleInputChange:this.handleInputChange,inputErrors:inputErrors}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Notes__["a" /* default */],{user:user,notes:notes,handleInputChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ContactDetails__["a" /* default */],{user:user,submittedBy:submittedBy,manufacturerAddress:manufacturerAddress,handleSelect:this.handleSelect,inputErrors:inputErrors,applicationStatus:applicationStatus,manufacturerAddresses:manufacturerAddresses}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__["a" /* default */],{isEditable:user.isInternal()||applicationStatus==='INCOMPLETE',handleFileSelect:this.handleFileSelect,handleRemoveFile:this.handleRemoveFile,files:testReports,error:inputErrors.testReports?'Please upload at least one report':'',editableStateSectionHeader:'Upload Test Report and Supporting Documentation',sectionHeaderClassName:'_margin_top_0 _font_size_14',httpParams:{currentId:applicationId,currentMethod:__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].downloadReport,fileIdFieldName:'id'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_ApplicationActions__["a" /* default */],{saveButtonLabel:'Save',saveButtonAction:this.submitFormula,cancelButtonLabel:'Cancel',cancelButtonAction:this.handleBackButtonClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_13_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_13_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleEditClick=_ref.handleEditClick,applicationStatus=_ref.applicationStatus,handleBackButtonClick=_ref.handleBackButtonClick,applicationId=_ref.applicationId,loadInProgress=_ref.loadInProgress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:handleBackButtonClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Oil Formulation Details'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase())));});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var isReadAcrossFormula=_ref.isReadAcrossFormula,baseOilNumber=_ref.baseOilNumber,isPaid=_ref.isPaid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Formulation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Formulation Type',value:isReadAcrossFormula?'Read Across Formulation':'Base Formulation'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Base Oil Number',value:baseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_90',textClassName:'text__binary-status-text '+(isPaid?'true':'false'),label:'Payment Status',value:isPaid?'Paid':'Unpaid'}));});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var user=_ref.user,notes=_ref.notes,handleInputChange=_ref.handleInputChange;if(notes||user.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes||'',handleInputChange:handleInputChange('notes'),disabled:!user.isInternal()}));}else{return null;}}

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Input__ = __webpack_require__(14);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submissionDate=_ref.submissionDate,approvalDate=_ref.approvalDate,formulatorNumber=_ref.formulatorNumber,baseFormulaBaseOilNumber=_ref.baseFormulaBaseOilNumber,engineType=_ref.engineType,isReadAcrossFormula=_ref.isReadAcrossFormula,description=_ref.description,handleInputChange=_ref.handleInputChange,inputErrors=_ref.inputErrors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Submission Date',value:submissionDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Approval Date',value:approvalDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',maxLength:250,label:'Formulation Number *',value:formulatorNumber,error:inputErrors.formulatorNumber,onChange:handleInputChange('formulatorNumber')}),isReadAcrossFormula&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Read Across Source',value:baseFormulaBaseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Engine Oil Type',value:engineType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Description',maxLength:250,value:description,error:inputErrors.description,onChange:handleInputChange('description')}));});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submittedBy=_ref.submittedBy,manufacturerAddress=_ref.manufacturerAddress,user=_ref.user,inputErrors=_ref.inputErrors,handleSelect=_ref.handleSelect,applicationStatus=_ref.applicationStatus,manufacturerAddresses=_ref.manufacturerAddresses;var getSelectedAddress=function getSelectedAddress(value,possibleItemsList){return possibleItemsList.find(function(address){var isSame=true;Object.keys(address.value).forEach(function(addressField){if(address.value[addressField]!==value[addressField])isSame=false;});return isSame;});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Contact details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Name',value:submittedBy?submittedBy.firstName+' '+submittedBy.lastName:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Email',value:submittedBy?submittedBy.email:''}),user.isInternal()&&applicationStatus!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].DEACTIVATED||applicationStatus===__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].INCOMPLETE?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{selectionList:manufacturerAddresses,type:'primary',mainWrapperClassName:'_width_pc_100',defaultItem:manufacturerAddress?getSelectedAddress(manufacturerAddress,manufacturerAddresses):{},label:'Select Address *',itemNameIndicator:'name',error:inputErrors.manufacturerAddress,unclearable:true,handleSelect:handleSelect('manufacturerAddress')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Address',value:manufacturerAddress?[manufacturerAddress.address1,manufacturerAddress.address2,manufacturerAddress.address3,manufacturerAddress.address4,manufacturerAddress.city,manufacturerAddress.state,manufacturerAddress.postalCode,manufacturerAddress.country].filter(function(object){return object;}).join(', '):'N/A'}));});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_routing__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Scenes_NotFoundScene__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__List__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Application__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Modal__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Scenes
 */var OilBranderRouter=function(_React$Component){_inherits(OilBranderRouter,_React$Component);function OilBranderRouter(props){_classCallCheck(this,OilBranderRouter);props.updateUserRole(__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName);var _this=_possibleConstructorReturn(this,(OilBranderRouter.__proto__||Object.getPrototypeOf(OilBranderRouter)).call(this,props));_this.roleSwitch=function(){var user=_this.props.user;if(user.getActiveRole()!==__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName){user.changeMenu(__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.serverName);}};_this.componentDidMount=function(){_this.roleSwitch();};_this.createActionsList=function(application){var user=_this.props.user;var currentYear=new Date().getFullYear();var isInternalUser=user.isInternal();var actions=[__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DETAILS];if((isInternalUser||application.applicationStatus!==__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].APPROVED)&&application.applicationStatus!==__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].EDIT);}if(application.applicationStatus===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].INCOMPLETE){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].RESUBMIT);}if(isInternalUser&&application.applicationStatus!==__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DEACTIVATE);}if(isInternalUser&&application.applicationStatus===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].PENDING){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].APPROVE);}if(isInternalUser&&application.applicationStatus===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].PENDING){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].INCOMPLETE);}if(currentYear>application.year){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].ROLL_OVER);}if(isInternalUser||application.applicationStatus===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].APPROVED&&application.isPaid){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].E_SIGN_AGREEMENT);}return actions;};_this.selectAction=function(actionKey,application){var user=_this.props.user;switch(actionKey){case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DEACTIVATE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Deactivate this application?';_this.modalConfirmAction=_this._changeStatus(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].deactivateBrand(application.id),__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].INCOMPLETE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to mark this application as Incomplete?';_this.modalConfirmAction=_this._changeStatus(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].incompleteBrand(application.id),__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].INCOMPLETE,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].APPROVE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Approve this application?';_this.modalConfirmAction=_this._changeStatus(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].approveBrand(application.id),__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].APPROVED,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].RESUBMIT:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Resubmit this application?';_this.modalConfirmAction=_this._changeStatus(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].pendBrand(application.id),__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].PENDING,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].ROLL_OVER:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to roll the brand over to the current year?';_this.modalConfirmAction=_this._rollOver(application.id,resolve);_this.setState({isModalOpen:true});});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DETAILS:return new Promise(function(resolve,reject){user.goTo('/'+user.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.listSceneUrlPostfix+'/'+application.id);});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].EDIT:return new Promise(function(resolve,reject){user.goTo('/'+user.getManufacturerCode()+'/'+__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.nameForUrl+__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.listSceneUrlPostfix+'/'+application.id+'/edit');});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].E_SIGN_AGREEMENT:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to generate and e-sign the Brand License Agreement?';_this.modalConfirmAction=_this.eSignAgreement(application.id,resolve);_this.setState({isModalOpen:true});});default:return function(){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].error('note','No such action');};}};_this._changeStatus=function(api,newStatusString,cb){return function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].patch(api).then(function(_ref){var data=_ref.data;cb(data||newStatusString);__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(_this._closeModal);});};};_this._rollOver=function(applicationId,cb){return function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].rollOverBrand(applicationId)).then(function(_ref2){var data=_ref2.data;__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Your brand has been successfully rolled over.');if(cb)cb(data);}).finally(_this._closeModal);});};};_this.eSignAgreement=function(applicationId){return function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].eSignBrandLicense(applicationId)).then(function(){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Brand License Agreement has been successfully generated and sent for e-signature to DocuSign.');}).finally(_this._closeModal);});};};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.renderScene=function(Scene){return function(_ref3){var match=_ref3.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene,{user:_this.props.user,createActionsList:_this.createActionsList,selectAction:_this.selectAction,match:match,manufacturerAddresses:_this.props.manufacturerAddresses});};};_this.state={isModalOpen:false};return _this;}_createClass(OilBranderRouter,[{key:'render',value:function render(){var _state=this.state,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess;var rootRoute=''+__WEBPACK_IMPORTED_MODULE_4_constants_routing__["d" /* ROUTE */].OIL_MANUFACTURER+__WEBPACK_IMPORTED_MODULE_5_constants_roles__["a" /* ROLES */].OIL_BRANDER.listSceneUrlPostfix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:rootRoute+'/:applicationId',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_9__Application__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:''+rootRoute,render:this.renderScene(__WEBPACK_IMPORTED_MODULE_8__List__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:this.renderScene(__WEBPACK_IMPORTED_MODULE_7_Scenes_NotFoundScene__["a" /* default */])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_11_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_11_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))));}}]);return OilBranderRouter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OilBranderRouter);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrandList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FiltersSection__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableHeader__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Row__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['name','number','formulaBaseOilNumber'];var BrandList=function(_React$Component){_inherits(BrandList,_React$Component);function BrandList(props){_classCallCheck(this,BrandList);var _this=_possibleConstructorReturn(this,(BrandList.__proto__||Object.getPrototypeOf(BrandList)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,applicationStatus:'All',selectedType:'All',sortedBy:'number',sortAsc:-1,filter:{},searchString:''};_this.updateListData=function(){var user=_this.props.user;var filter=_this.state.filter;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["f" /* oilAPI */].brandsList(filter.brandSignStatus,filter.year)).then(function(_ref){var list=_ref.data;__WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',list,user.getManufacturerCode()).then(function(){_this.listRequestInProgress=false;_this._loadFromStore();});});};_this._loadFromStore=function(){var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_lists',user.getManufacturerCode()).then(function(list){_this.brandsList=list;_this.forceUpdate();});};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this.handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},function(){user.updateURLSearchString({activePage:activePage});});};_this._filterList=function(componentList){var _this$state=_this.state,filter=_this$state.filter,searchString=_this$state.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return componentList.filter(function(element){for(var filterFieldName in filter){switch(filterFieldName){case'brandSignStatus':break;default:if(element[filterFieldName]!==filter[filterFieldName])return false;}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this._sortList=function(a,b){var _this$state2=_this.state,sortedBy=_this$state2.sortedBy,sortAsc=_this$state2.sortAsc;switch(sortedBy){case'isPaid':case'isReadAcrossFormula':return a[sortedBy]>b[sortedBy]?sortAsc:-sortAsc;case'year':return+a[sortedBy]>+b[sortedBy]?sortAsc:-sortAsc;default:if(a[sortedBy]&&b[sortedBy])return a[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')>b[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;else return a[sortedBy]>b[sortedBy]?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){var user=_this.props.user;_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc,activePage:1};},function(){user.updateURLSearchString({sortedBy:_this.state.sortedBy,sortAsc:_this.state.sortAsc,activePage:1});});};};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var selectedValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(selectedValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=selectedValue;if(filterFieldName==='year'){if(filterElement==='All'){user.saveSelectedYear('');}else{user.saveSelectedYear(filterElement);}}_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});if(filterFieldName==='brandSignStatus'||filterFieldName==='year')_this.updateListData();});};};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this._getList=function(){var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var _this$props=_this.props,user=_this$props.user,createActionsList=_this$props.createActionsList,selectAction=_this$props.selectAction;var resultList=[];var resultLength=0;if(!_this.brandsList.length){if(_this.listRequestInProgress){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'no-spinner-div',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_EmptyList__["a" /* default */],{key:'empty'},'No brands for selected manufacturer.')];}}else{var filteredList=_this._filterList(_this.brandsList).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_EmptyList__["a" /* default */],{key:'empty'},'No brands found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(brand,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Row__["a" /* default */],{key:brand.id,user:user,brand:brand,isOdd:!!(index%2),sortedBy:sortedBy,availableActionsList:createActionsList(brand),selectAction:selectAction,updateListEntry:_this.updateListEntry,deleteListEntry:_this.deleteListEntry});});resultLength=filteredList.length;}}return{resultList:resultList,resultLength:resultLength};};_this.updateListEntry=function(oldEntry,newEntry){var user=_this.props.user;var dataSource=newEntry.status?newEntry:Object.assign({},oldEntry,{status:newEntry});if(typeof newEntry==='string'){oldEntry.status=newEntry;}else if(newEntry.year===oldEntry.year){var oldEntryIndex=_this.brandsList.indexOf(oldEntry);_this.brandsList.splice(oldEntryIndex,1,newEntry);}else{_this.brandsList.push(newEntry);}__WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',dataSource,user.getManufacturerCode());};_this.deleteListEntry=function(oldEntry){var user=_this.props.user;var oldEntryIndex=_this.brandsList.indexOf(oldEntry);_this.brandsList.splice(oldEntryIndex,1);__WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__["a" /* default */].delete(user.getActiveRole()+'_lists',oldEntry);};var storedState=props.user.getStoredState('brandListState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);_this.listRequestInProgress=true;_this.engineTypes=[];_this.brandsList=[];return _this;}_createClass(BrandList,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["f" /* oilAPI */].engineTypes).then(function(_ref2){var data=_ref2.data;_this2.engineTypes=data;_this2.forceUpdate();});this._loadFromStore();this.handleSelectFilter('year')(user.getSelectedYear()||new Date().getFullYear());this.updateListData();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var user=this.props.user;user.saveState('brandListState',this.state,['year']);}},{key:'render',value:function render(){var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,filter=_state.filter,searchString=_state.searchString;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Brand List',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_10_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowCountSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,filterState:filter,engineTypes:this.engineTypes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this.handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return BrandList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__ = __webpack_require__(90);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var outCount=_ref.outCount,handleRowCountSelect=_ref.handleRowCountSelect,rowsCount=_ref.rowsCount,handleSelectFilter=_ref.handleSelectFilter,filterState=_ref.filterState,engineTypes=_ref.engineTypes;var BRAND_STATUSES=[{name:'All',value:'All'},{name:'Approved',value:'APPROVED'},{name:'Pending',value:'PENDING'},{name:'Incomplete',value:'INCOMPLETE'},{name:'Deactivated',value:'DEACTIVATED'}];var FEE_STATUSES=[{name:'All',value:'All'},{name:'Unpaid',value:false},{name:'Paid',value:true}];var AGREEMENT_STATUSES=[{name:'All',value:'All'},{name:'Signed',value:true},{name:'Not signed',value:false}];var currentYear=new Date().getFullYear();var engineTypesWithAllField=['All'].concat(engineTypes);var getSelectedItem=function getSelectedItem(key,possibleItemsList){if(filterState[key]===undefined)return possibleItemsList[0];return possibleItemsList.find(function(item){return(item.value===undefined?item:item.value)===filterState[key];});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:FEE_STATUSES,handleSelect:handleSelectFilter('isPaid'),placeholder:'All',defaultItem:getSelectedItem('isPaid',FEE_STATUSES),label:'by Fee Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:AGREEMENT_STATUSES,handleSelect:handleSelectFilter('brandSignStatus'),placeholder:'All',defaultItem:getSelectedItem('brandSignStatus',AGREEMENT_STATUSES),label:'by Agreement Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:BRAND_STATUSES,handleSelect:handleSelectFilter('applicationStatus'),placeholder:'All',defaultItem:getSelectedItem('applicationStatus',BRAND_STATUSES),label:'by Application Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:engineTypesWithAllField,handleSelect:handleSelectFilter('formulaEngineType'),label:'by Engine Oil Type',placeholder:'All',defaultItem:filterState.formulaEngineType||engineTypesWithAllField[0],type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__["a" /* default */],{endYear:currentYear+1,yearPickAction:handleSelectFilter('year'),label:'by Year',year:filterState.year,withAllOption:true,width:160,height:18})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowCountSelect,selectedRowsCount:rowsCount})));});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('number')+' _width_pc_12',onClick:handleSortClick('number')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Brand No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('name')+' _width_pc_22',onClick:handleSortClick('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Brand Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('formulaBaseOilNumber')+' _width_pc_12',onClick:handleSortClick('formulaBaseOilNumber')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Base Oil Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('formulaEngineType')+' _width_pc_10',onClick:handleSortClick('formulaEngineType')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Engine Oil Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('year')+' _width_pc_8',onClick:handleSortClick('year')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Year'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('applicationStatus')+' _width_pc_12',onClick:handleSortClick('applicationStatus')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('isPaid')+' _width_pc_12',onClick:handleSortClick('isPaid')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Fee status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element  _width_pc_18'}));});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._selectAction=function(actionKey){var _this$props=_this.props,brand=_this$props.brand,selectAction=_this$props.selectAction,updateListEntry=_this$props.updateListEntry,deleteListEntry=_this$props.deleteListEntry;selectAction(actionKey,brand).then(function(updatedData){if(actionKey!==__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DELETE)updateListEntry(brand,updatedData);else deleteListEntry(brand);});},_this._getStatusColor=function(){var brand=_this.props.brand;if(brand&&brand.applicationStatus){return'list-scene__status-label_'+brand.applicationStatus.toString().toLowerCase();}return'';},_this._getFormulaReadableStatus=function(){var brand=_this.props.brand;if(brand&&brand.applicationStatus){return brand.applicationStatus[0].toUpperCase()+brand.applicationStatus.slice(1).toLowerCase();}return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _this2=this;var _props=this.props,brand=_props.brand,availableActionsList=_props.availableActionsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandRowId'+brand.number,className:'list-scene__table-row '+this._getBackgroundColourStyle(),onClick:function onClick(){_this2._selectAction(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DETAILS);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandNumberField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('number')+' _width_pc_12'},brand.number||'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandNameField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('name')+' _width_pc_22'},brand.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandBaseOilFormulaNumberField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('formulaBaseOilNumber')+' _width_pc_12'},brand.formulaBaseOilNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandEngineTypeField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('formulaEngineType')+' _width_pc_10'},brand.formulaEngineType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandYearField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('year')+' _width_pc_8'},brand.year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('applicationStatus')},this._getFormulaReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandFeeStatusField',className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_90 _margin_0',textClassName:'text__binary-status-text '+(brand.isPaid?'true':'false')+' _margin_0 '+this._getTextColourStyle('isPaid'),value:brand.isPaid?'Paid':'Unpaid'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'brandActionsField',className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{placeholder:'Actions',selectionList:availableActionsList,multiSelect:true,handleSelect:this._selectAction,type:__WEBPACK_IMPORTED_MODULE_2_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()}));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={brand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_routing__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Scenes_NotFoundScene__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Create__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Details__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Edit__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OilBranderRouter=function(_React$Component){_inherits(OilBranderRouter,_React$Component);function OilBranderRouter(props){_classCallCheck(this,OilBranderRouter);var _this=_possibleConstructorReturn(this,(OilBranderRouter.__proto__||Object.getPrototypeOf(OilBranderRouter)).call(this,props));_this.updateAddressesList=function(){var manufacturerAddresses=_this.props.manufacturerAddresses;var manufacturerAddress=_this.state.applicationData.manufacturerAddress;var manufacturerAddressesWithCurrent=[].concat(_toConsumableArray(manufacturerAddresses));if(manufacturerAddress){var address=manufacturerAddresses.find(function(address){var isSame=true;Object.keys(address.value).forEach(function(addressField){if(address.value[addressField]!==manufacturerAddress[addressField])isSame=false;});return isSame;});if(!address){address={name:[manufacturerAddress.address1,manufacturerAddress.address2,manufacturerAddress.address3,manufacturerAddress.address4,manufacturerAddress.city,manufacturerAddress.state,manufacturerAddress.postalCode,manufacturerAddress.country].filter(function(object){return object;}).join(', '),value:Object.assign({},manufacturerAddress)};if(address.name){manufacturerAddressesWithCurrent.unshift(address);}}}_this.setState({manufacturerAddressesWithCurrent:manufacturerAddressesWithCurrent});};_this.updateListEntry=function(newEntry){var user=_this.props.user;var applicationData=_this.state.applicationData;var dataSource=newEntry.applicationStatus?newEntry:Object.assign({},applicationData,{applicationStatus:newEntry});__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',dataSource,user.getManufacturerCode());_this.setState({applicationData:dataSource});};_this.deleteListEntry=function(){var user=_this.props.user;var applicationData=_this.state.applicationData;__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].delete(user.getActiveRole()+'_lists',applicationData);};_this.renderScene=function(Scene){var manufacturerAddresses=_this.props.manufacturerAddresses;var _this$state=_this.state,applicationData=_this$state.applicationData,manufacturerAddressesWithCurrent=_this$state.manufacturerAddressesWithCurrent;return function(_ref){var match=_ref.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene,Object.assign({},_this.props,{manufacturerAddresses:isFinite(match.params.applicationId)?manufacturerAddressesWithCurrent:manufacturerAddresses,updateListEntry:_this.updateListEntry,deleteListEntry:_this.deleteListEntry,applicationData:applicationData,updateApplicationData:_this.updateApplicationData,match:match}));};};_this.state={manufacturerAddressesWithCurrent:[]};return _this;}_createClass(OilBranderRouter,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var match=this.props.match;if(isFinite(match.params.applicationId)){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].brand(match.params.applicationId)).then(function(_ref2){var data=_ref2.data;_this2.setState({applicationData:data});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].downloadBrandDocumentsList(data.number,data.year)).then(function(_ref3){var data=_ref3.data;var applicationData=_this2.state.applicationData;applicationData.licenseAgreementList=data.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_11_moment___default()(a.date).isAfter(b.date)?-1:1;});_this2.setState({applicationData:applicationData});});});}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.state.manufacturerAddressesWithCurrent.length&&this.state.applicationData&&this.props.manufacturerAddresses)this.updateAddressesList();}},{key:'render',value:function render(){var rootRoute=''+__WEBPACK_IMPORTED_MODULE_4_constants_routing__["d" /* ROUTE */].OIL_BRANDER+__WEBPACK_IMPORTED_MODULE_9_constants_roles__["a" /* ROLES */].OIL_BRANDER.listSceneUrlPostfix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:rootRoute+'/new',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_6__Create__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:rootRoute+'/:applicationId',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_7__Details__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:rootRoute+'/:applicationId/edit',render:this.renderScene(__WEBPACK_IMPORTED_MODULE_8__Edit__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:this.renderScene(__WEBPACK_IMPORTED_MODULE_5_Scenes_NotFoundScene__["a" /* default */])}));}}]);return OilBranderRouter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OilBranderRouter);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormulaCreate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Modal__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormulaCreate=function(_React$Component){_inherits(FormulaCreate,_React$Component);function FormulaCreate(props){_classCallCheck(this,FormulaCreate);var _this=_possibleConstructorReturn(this,(FormulaCreate.__proto__||Object.getPrototypeOf(FormulaCreate)).call(this,props));_this.handleSelect=function(fieldName){return function(input){var _this$setState;var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var selectedItem=input;delete newInputErrors[fieldName];_this.someDataWasInputted=true;_this.setState((_this$setState={},_defineProperty(_this$setState,fieldName,selectedItem),_defineProperty(_this$setState,'inputErrors',newInputErrors),_this$setState));};};_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;if(!error||error.ops){var _this$setState2;delete inputErrors[field];_this.someDataWasInputted=true;_this.setState((_this$setState2={},_defineProperty(_this$setState2,field,value),_defineProperty(_this$setState2,'inputErrors',inputErrors),_this$setState2));}};};_this.handleBaseOilNumberInput=function(value,error){var inputErrors=_this.state.inputErrors;if(!error||error.ops){delete inputErrors.formulaBaseOilNumber;_this.someDataWasInputted=true;_this.setState({formulaBaseOilNumber:value.toUpperCase(),inputErrors:inputErrors});}};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.validateForm=function(){var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))newInputErrors[fieldName]=true;});return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length)reject();else resolve();});});};_this.submitBrand=function(){var _this$state=_this.state,brandName=_this$state.brandName,formulaBaseOilNumber=_this$state.formulaBaseOilNumber,selectedYear=_this$state.selectedYear,manufacturerAddress=_this$state.manufacturerAddress,description=_this$state.description;var user=_this.props.user;_this.validateForm().then(function(){var dataPayload={name:brandName,description:description,year:selectedYear,formulaBaseOilNumber:formulaBaseOilNumber.trim(),manufacturerAddress:manufacturerAddress.value};_this.modalBody='Are you sure you want to submit this application?';_this.modalConfirmAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].submitBrand,dataPayload).then(function(){__WEBPACK_IMPORTED_MODULE_7_dom_managers_notification__["a" /* default */].success(1,'Your application was submitted successfully');_this.someDataWasInputted=false;user.goToList(false,false);}).catch(function(error){var errorMessage=error.response.data.message;if(errorMessage==='Cannot submit/approve the application. The formulation on which it is based isn\'t Approved.'||errorMessage==='Sorry there\'s no such Formulation.'){var inputErrors=_this.state.inputErrors;inputErrors.formulaBaseOilNumber=true;_this.setState({inputErrors:inputErrors});}}).finally(function(){_this.setState({requestInProcess:false});_this._closeModal();});});};_this._openModal();});};_this.handleBackButtonClick=function(){var user=_this.props.user;user.goToList();};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this._closeModal();user.goTo(location);};_this._openModal();return false;}return true;};var currentYear=new Date().getFullYear();_this.yearsList=[currentYear,currentYear+1];_this.state={brandName:'',inputErrors:{},formulaBaseOilNumber:'',selectedYear:'',manufacturerAddress:'',description:'',isModalOpen:false,requestInProcess:false};_this.requiredFields=['brandName','formulaBaseOilNumber','selectedYear','manufacturerAddress'];_this.someDataWasInputted=false;return _this;}_createClass(FormulaCreate,[{key:'render',value:function render(){var _state=this.state,brandName=_state.brandName,formulaBaseOilNumber=_state.formulaBaseOilNumber,selectedYear=_state.selectedYear,manufacturerAddress=_state.manufacturerAddress,description=_state.description,inputErrors=_state.inputErrors,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess;var manufacturerAddresses=this.props.manufacturerAddresses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:this.handleBackButtonClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'New Brand Application')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Brand Name *',maxLength:250,value:brandName,error:inputErrors.brandName,onChange:this.handleInputChange('brandName')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _margin_right_30',inputClassName:'input__input-field_primary',label:'Base Oil Number *',maxLength:250,value:formulaBaseOilNumber,error:inputErrors.formulaBaseOilNumber,onChange:this.handleBaseOilNumberInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:this.yearsList,defaultItem:selectedYear,type:'primary',inputClassName:'',dropDownClassName:'',label:'Year *',error:inputErrors.selectedYear,handleSelect:this.handleSelect('selectedYear')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Description',maxLength:250,placeholder:'Provide some description if necessary',value:description,onChange:this.handleInputChange('description')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:manufacturerAddresses,type:'primary',mainWrapperClassName:'_width_pc_100',defaultItem:manufacturerAddress,label:'Select Address *',error:inputErrors.manufacturerAddress,itemNameIndicator:'name',handleSelect:this.handleSelect('manufacturerAddress')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_ApplicationActions__["a" /* default */],{saveButtonLabel:'Submit',saveButtonAction:this.submitBrand,cancelButtonLabel:'Cancel',cancelButtonAction:this.handleBackButtonClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}]);return FormulaCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrandTypeSection__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotesSection__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeneralInformation__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChangeStatus__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactDetails__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ESignDownloadSection__ = __webpack_require__(1038);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var DetailsApplication=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsApplication);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call.apply(_ref,[this].concat(args))),_this),_this._handleBackClick=function(){var user=_this.props.user;user.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsApplication,[{key:'render',value:function render(){var _props=this.props,user=_props.user,match=_props.match,applicationData=_props.applicationData,createActionsList=_props.createActionsList,updateListEntry=_props.updateListEntry,deleteListEntry=_props.deleteListEntry,selectAction=_props.selectAction;var applicationId=match.params.applicationId;if(!applicationData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* default */],{user:user,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{var applicationStatus=applicationData.applicationStatus,number=applicationData.number,year=applicationData.year,isPaid=applicationData.isPaid,submissionDate=applicationData.submissionDate,approvalDate=applicationData.approvalDate,name=applicationData.name,formulaBaseOilNumber=applicationData.formulaBaseOilNumber,formulaEngineType=applicationData.formulaEngineType,description=applicationData.description,submittedBy=applicationData.submittedBy,manufacturerAddress=applicationData.manufacturerAddress,notes=applicationData.notes;var availableActions=createActionsList(applicationData);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+applicationStatus.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* default */],{applicationStatus:applicationStatus,applicationId:applicationId,availableActions:availableActions,user:user,loadInProgress:!applicationData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BrandTypeSection__["a" /* default */],{number:number,year:year,isPaid:isPaid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GeneralInformation__["a" /* default */],{submissionDate:submissionDate,approvalDate:approvalDate,name:name,formulaBaseOilNumber:formulaBaseOilNumber,formulaEngineType:formulaEngineType,description:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NotesSection__["a" /* default */],{notes:notes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContactDetails__["a" /* default */],{submittedBy:submittedBy,manufacturerAddress:manufacturerAddress}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ChangeStatus__["a" /* default */],{user:user,applicationId:applicationId,applicationData:applicationData,updateListEntry:updateListEntry,deleteListEntry:deleteListEntry,selectAction:selectAction,availableActions:availableActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ESignDownloadSection__["a" /* default */],{applicationId:applicationId,name:name,licenseAgreementList:applicationData.licenseAgreementList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Back',backButtonAction:this._handleBackClick})));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleEditClick=_ref.handleEditClick,applicationStatus=_ref.applicationStatus,user=_ref.user,applicationId=_ref.applicationId,loadInProgress=_ref.loadInProgress,availableActions=_ref.availableActions;var link='/'+user.getManufacturerCode()+'/oil/brand/'+applicationId+'/edit';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Oil Brand Details'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,availableActions.includes(__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ACTION */].EDIT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase())));});

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var number=_ref.number,year=_ref.year,isPaid=_ref.isPaid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Brand Number',value:number}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Year',value:year}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_90',textClassName:'text__binary-status-text '+(isPaid?'true':'false'),label:'Payment Status',value:isPaid?'Paid':'Unpaid'}));});

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes;if(!notes)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,disabled:true}));}

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submissionDate=_ref.submissionDate,approvalDate=_ref.approvalDate,name=_ref.name,formulaBaseOilNumber=_ref.formulaBaseOilNumber,formulaEngineType=_ref.formulaEngineType,description=_ref.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Submission Date',value:submissionDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Approval Date',value:approvalDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Brand Name',value:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Base Oil Number',value:formulaBaseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Engine Type',value:formulaEngineType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Description',value:description}));});

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeStatus=function(_React$Component){_inherits(ChangeStatus,_React$Component);function ChangeStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangeStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeStatus.__proto__||Object.getPrototypeOf(ChangeStatus)).call.apply(_ref,[this].concat(args))),_this),_this.isActionAllowed=function(actionKey){var availableActions=_this.props.availableActions;return availableActions.find(function(act){return act===actionKey;});},_this.performAction=function(actionKey){return function(){var _this$props=_this.props,updateListEntry=_this$props.updateListEntry,deleteListEntry=_this$props.deleteListEntry,selectAction=_this$props.selectAction,applicationData=_this$props.applicationData;selectAction(actionKey,applicationData).then(function(updatedData){if(actionKey!==__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].DELETE)updateListEntry(updatedData);else deleteListEntry();});};},_this.getApproveButton=function(){if(_this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].APPROVE))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Approve',buttonClassName:'_height_40 _width_120 _margin_right_25  _margin_top_30',onClick:_this.performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].APPROVE),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green});return null;},_this.getDeactivateButton=function(){if(_this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].DEACTIVATE))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Deactivate',buttonClassName:'_height_40 _width_120 _margin_right_25  _margin_top_30',onClick:_this.performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].DEACTIVATE),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].red});return null;},_this.getIncompleteButton=function(){if(_this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].INCOMPLETE))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Incomplete',buttonClassName:'_height_40 _width_120 _margin_right_25  _margin_top_30',onClick:_this.performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].INCOMPLETE),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].lightBlue});return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeStatus,[{key:'getSubmitButton',value:function getSubmitButton(){if(this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].RESUBMIT))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Submit',buttonClassName:'_height_40 _width_120 _margin_right_25  _margin_top_30',onClick:this.performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].RESUBMIT),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].orange});return null;}},{key:'getRolloverButton',value:function getRolloverButton(){if(this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].ROLL_OVER))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Roll Over',buttonClassName:'_height_40 _width_120 _margin_right_25  _margin_top_30',iconClassName:'rollover-icon',onClick:this.performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].ROLL_OVER),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}));return null;}},{key:'getESignButton',value:function getESignButton(){if(this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].E_SIGN_AGREEMENT))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].E_SIGN_AGREEMENT,buttonClassName:'_height_40 _width_160 _margin_right_25  _margin_top_30',onClick:this.performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].E_SIGN_AGREEMENT),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}));return null;}},{key:'render',value:function render(){var _props=this.props,availableActions=_props.availableActions,applicationId=_props.applicationId,user=_props.user;var eSignActionsList=[this.getESignButton()].filter(function(button){return button;});var rollOwerActionsList=[this.getRolloverButton()].filter(function(button){return button;});var statusActionList=[this.getDeactivateButton(),this.getIncompleteButton(),this.getSubmitButton(),this.getApproveButton()].filter(function(button){return button;});if(!(eSignActionsList.length+rollOwerActionsList.length+statusActionList.length))return null;var firstDelimiterNeeded=eSignActionsList.length&&(rollOwerActionsList.length||statusActionList.length);var secondDelimiterNeeded=rollOwerActionsList.length&&statusActionList.length;var link='/'+user.getManufacturerCode()+'/oil/brand/'+applicationId+'/edit';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Actions'),availableActions.includes(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].EDIT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{className:'_height_40 _width_pc_100 _max_width_180 _margin_top_30 _margin_right_30'})),eSignActionsList,!!firstDelimiterNeeded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__delimiter_vertical'}),rollOwerActionsList,!!secondDelimiterNeeded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__delimiter_vertical'}),statusActionList);}}]);return ChangeStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submittedBy=_ref.submittedBy,manufacturerAddress=_ref.manufacturerAddress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Contact details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Name',value:submittedBy?submittedBy.firstName+' '+submittedBy.lastName:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Email',value:submittedBy?submittedBy.email:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Address',value:manufacturerAddress?[manufacturerAddress.address1,manufacturerAddress.address2,manufacturerAddress.address3,manufacturerAddress.address4,manufacturerAddress.city,manufacturerAddress.state,manufacturerAddress.postalCode,manufacturerAddress.country].filter(function(object){return object;}).join(', '):'N/A'}));});

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ESignDownloadSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ESignDownloadSection=function(_React$Component){_inherits(ESignDownloadSection,_React$Component);function ESignDownloadSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ESignDownloadSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ESignDownloadSection.__proto__||Object.getPrototypeOf(ESignDownloadSection)).call.apply(_ref,[this].concat(args))),_this),_this.downloadLetter=function(){var _this$props=_this.props,applicationId=_this$props.applicationId,name=_this$props.name;__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].downloadBrandCertLetter(applicationId),{responseType:'blob'}).then(function(_ref2){var data=_ref2.data;Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["b" /* downloadFile */])(data,'Brand_Certification_Letter_'+name+'.pdf');});},_this.downloadAgreement=function(envelopeId,name){return function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["e" /* manufacturerAPI */].eSignDocumentDownload(envelopeId,name),{responseType:'blob'}).then(function(_ref3){var data=_ref3.data;Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["b" /* downloadFile */])(data,name);});};},_this.getDocumentReadableStatus=function(document){if(document.status){return document.status[0].toUpperCase()+document.status.slice(1).toLowerCase();}return'';},_this.getDocumentsList=function(){var licenseAgreementList=_this.props.licenseAgreementList;if(!licenseAgreementList||!licenseAgreementList.length)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__row_small',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_100'},'No documents of this type for selected brand'));return licenseAgreementList.map(function(document,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__row_small',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_50'},document.fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_20'},_this.getDocumentReadableStatus(document)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_15'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(document.date).local().format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__download-icon _cursor_pointer',onClick:_this.downloadAgreement(document.id,document.fileName)})));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ESignDownloadSection,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Downloads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__downloads-section-buttons-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__downloads-section-button',onClick:this.downloadLetter},'Oil Brand Certification Letter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__downloads-section-list-header'},'Brand License Agreement'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper _border_all_1 _padding_left_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small _margin_bottom_16 _margin_top_12 _border_none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_50'},'Document'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_20'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_15'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_15 _text_align_center'},'Download')),this.getDocumentsList()));}}]);return ESignDownloadSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BrandTypeSection__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Notes__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GeneralInformation__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContactDetails__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Button__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsApplication=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(props){_classCallCheck(this,DetailsApplication);var _this=_possibleConstructorReturn(this,(DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call(this,props));_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;if(!error||error.ops){var _this$setState;delete inputErrors[field];_this.someDataWasInputted=true;_this.setState((_this$setState={},_defineProperty(_this$setState,field,value),_defineProperty(_this$setState,'inputErrors',inputErrors),_this$setState));}};};_this.handleSelect=function(fieldName){return function(input){var _this$setState2;var inputErrors=_this.state.inputErrors;delete inputErrors[fieldName];_this.someDataWasInputted=true;_this.setState((_this$setState2={},_defineProperty(_this$setState2,fieldName,input.value),_defineProperty(_this$setState2,'inputErrors',inputErrors),_this$setState2));};};_this.validateForm=function(){var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))newInputErrors[fieldName]=true;});return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length)reject();else resolve();});});};_this.updateBrand=function(){var _this$state=_this.state,name=_this$state.name,manufacturerAddress=_this$state.manufacturerAddress,description=_this$state.description,notes=_this$state.notes;var _this$props=_this.props,user=_this$props.user,match=_this$props.match;_this.validateForm().then(function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["f" /* oilAPI */].updateBrand,{id:match.params.applicationId,name:name,manufacturerAddress:manufacturerAddress,description:description,notes:notes}).then(function(){__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'Brand details successfully updated');_this.someDataWasInputted=false;user.goToList();});});};_this.handleBackButtonClick=function(){var user=_this.props.user;user.goToList();};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this._closeModal();user.goTo(location);};_this._openModal();return false;}return true;};_this.state={inputErrors:{},isModalOpen:false};var applicationData=props.applicationData;if(applicationData){_this.state.name=applicationData.name;_this.state.description=applicationData.description;_this.state.manufacturerAddress=applicationData.manufacturerAddress;_this.state.notes=applicationData.notes;}_this.requiredFields=['manufacturerAddress','name'];_this.someDataWasInputted=false;return _this;}_createClass(DetailsApplication,[{key:'componentDidUpdate',value:function componentDidUpdate(){var applicationData=this.props.applicationData;if(applicationData&&!this.state.name)this.setState({name:applicationData.name,description:applicationData.description,manufacturerAddress:applicationData.manufacturerAddress,notes:applicationData.notes});}},{key:'render',value:function render(){var _state=this.state,inputErrors=_state.inputErrors,name=_state.name,description=_state.description,manufacturerAddress=_state.manufacturerAddress,notes=_state.notes,isModalOpen=_state.isModalOpen;var _props=this.props,user=_props.user,match=_props.match,applicationData=_props.applicationData,manufacturerAddresses=_props.manufacturerAddresses;var applicationId=match.params.applicationId;if(!applicationData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{handleBackButtonClick:this.handleBackButtonClick,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{var applicationStatus=applicationData.applicationStatus,number=applicationData.number,year=applicationData.year,isPaid=applicationData.isPaid,submissionDate=applicationData.submissionDate,approvalDate=applicationData.approvalDate,formulaBaseOilNumber=applicationData.formulaBaseOilNumber,formulaEngineType=applicationData.formulaEngineType,submittedBy=applicationData.submittedBy;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+applicationStatus.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{applicationStatus:applicationStatus,applicationId:applicationId,handleBackButtonClick:this.handleBackButtonClick,loadInProgress:!applicationData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BrandTypeSection__["a" /* default */],{number:number,year:year,isPaid:isPaid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GeneralInformation__["a" /* default */],{submissionDate:submissionDate,approvalDate:approvalDate,name:name,formulaBaseOilNumber:formulaBaseOilNumber,formulaEngineType:formulaEngineType,description:description,inputErrors:inputErrors,handleInputChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Notes__["a" /* default */],{user:user,notes:notes,handleInputChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ContactDetails__["a" /* default */],{submittedBy:submittedBy,manufacturerAddress:manufacturerAddress,handleSelect:this.handleSelect,inputErrors:inputErrors,user:user,applicationStatus:applicationStatus,manufacturerAddresses:manufacturerAddresses}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{saveButtonLabel:'Save',saveButtonAction:this.updateBrand,backButtonLabel:'Cancel',backButtonAction:this.handleBackButtonClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_12_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_12_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleEditClick=_ref.handleEditClick,applicationStatus=_ref.applicationStatus,handleBackButtonClick=_ref.handleBackButtonClick,applicationId=_ref.applicationId,loadInProgress=_ref.loadInProgress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:handleBackButtonClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Oil Brand Details'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase())));});

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var number=_ref.number,year=_ref.year,isPaid=_ref.isPaid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Brand Number',value:number}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_36 _margin_right_30',textClassName:'text__text_primary',label:'Year',value:year}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_90',textClassName:'text__binary-status-text '+(isPaid?'true':'false'),label:'Payment Status',value:isPaid?'Paid':'Unpaid'}));});

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var user=_ref.user,notes=_ref.notes,handleInputChange=_ref.handleInputChange;if(notes||user.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes||'',handleInputChange:handleInputChange('notes'),disabled:!user.isInternal()}));}else{return null;}}

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Input__ = __webpack_require__(14);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submissionDate=_ref.submissionDate,approvalDate=_ref.approvalDate,name=_ref.name,formulaBaseOilNumber=_ref.formulaBaseOilNumber,formulaEngineType=_ref.formulaEngineType,description=_ref.description,inputErrors=_ref.inputErrors,handleInputChange=_ref.handleInputChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Submission Date',value:submissionDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Approval Date',value:approvalDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Brand name',maxLength:250,value:name,error:inputErrors.description,onChange:handleInputChange('name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Based on Base Oil Number',value:formulaBaseOilNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Engine Type',value:formulaEngineType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Description',maxLength:250,value:description,error:inputErrors.description,onChange:handleInputChange('description')}));});

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var submittedBy=_ref.submittedBy,manufacturerAddress=_ref.manufacturerAddress,user=_ref.user,inputErrors=_ref.inputErrors,handleSelect=_ref.handleSelect,applicationStatus=_ref.applicationStatus,manufacturerAddresses=_ref.manufacturerAddresses;var getSelectedAddress=function getSelectedAddress(value,possibleItemsList){return possibleItemsList.find(function(address){var isSame=true;Object.keys(address.value).forEach(function(addressField){if(address.value[addressField]!==value[addressField])isSame=false;});return isSame;});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Contact details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Name',value:submittedBy?submittedBy.firstName+' '+submittedBy.lastName:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Email',value:submittedBy?submittedBy.email:''}),user.isInternal()&&applicationStatus!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].DEACTIVATED||applicationStatus===__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].INCOMPLETE?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{selectionList:manufacturerAddresses,type:'primary',mainWrapperClassName:'_width_pc_100',defaultItem:manufacturerAddress?getSelectedAddress(manufacturerAddress,manufacturerAddresses):{},label:'Select Address *',itemNameIndicator:'name',error:inputErrors.manufacturerAddress,handleSelect:handleSelect('manufacturerAddress')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Address',value:manufacturerAddress?[manufacturerAddress.address1,manufacturerAddress.address2,manufacturerAddress.address3,manufacturerAddress.address4,manufacturerAddress.city,manufacturerAddress.state,manufacturerAddress.postalCode,manufacturerAddress.country].filter(function(object){return object;}).join(', '):'N/A'}));});

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_trailer__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_routing__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Application__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultSelectedTrailer={id:'',name:'',year:'',emptyTrailerWeight:'',over80Wide:false,couplerRatingWithBrakes:'',couplerRatingWithoutBrakes:'',strapRating:'',hookRating:'',winchRating:'',numberOfAxles:'',grossAxleWeightRating:'',grossVehicleWeightRating:'',maxLoadCapacity:'',status:''};var TrailerManufacturer=function(_React$Component){_inherits(TrailerManufacturer,_React$Component);function TrailerManufacturer(props){_classCallCheck(this,TrailerManufacturer);var _this=_possibleConstructorReturn(this,(TrailerManufacturer.__proto__||Object.getPrototypeOf(TrailerManufacturer)).call(this,props));_this.roleSwitch=function(){var user=_this.props.user;if(user.getActiveRole()!==__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){user.changeMenu(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName);}};_this._loadFromStore=function(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_lists',user.getManufacturerCode()).then(function(trailerList){_this.setState({trailerList:trailerList},cb);});};_this._toggleApplication=function(){var action=_this.props.history.action;var applicationMode=__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSED;switch(action){case __WEBPACK_IMPORTED_MODULE_5_constants_routing__["a" /* ACTION */].POP:applicationMode=_this._togglePOPAction();break;case __WEBPACK_IMPORTED_MODULE_5_constants_routing__["a" /* ACTION */].PUSH:case __WEBPACK_IMPORTED_MODULE_5_constants_routing__["a" /* ACTION */].REPLACE:applicationMode=_this._togglePRAction();break;default:break;}if(applicationMode){_this.setState({applicationMode:applicationMode});}};_this._togglePOPAction=function(){var applicationMode=_this.state.applicationMode;if(_this._hashHasApplicationState()){if(applicationMode!==__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENED){return __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENED;}else{return null;}}else{if(applicationMode!==__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSED){return __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSED;}else{return null;}}};_this._togglePRAction=function(){var applicationMode=_this.state.applicationMode;if(_this._hashHasApplicationState()){if(applicationMode!==__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENED&&applicationMode!==__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENING){return __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENING;}else{return null;}}else{if(applicationMode!==__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSED&&applicationMode!==__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSING){return __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSING;}else{return null;}}};_this._hashHasApplicationState=function(){var hash=_this.props.location.hash;return hash.indexOf(__WEBPACK_IMPORTED_MODULE_5_constants_routing__["b" /* HASH */].ADD)!==-1||hash.indexOf(__WEBPACK_IMPORTED_MODULE_5_constants_routing__["b" /* HASH */].EDIT)!==-1;};_this.updateLocationState=function(link,hash){return function(){var _this$props=_this.props,history=_this$props.history,location=_this$props.location,user=_this$props.user;var prevLink=location.pathname+location.hash;if(prevLink!==link+hash){history.replace('/'+user.getManufacturerCode()+'/'+link+location.search+hash);}};};_this.handleInputChange=function(type){return function(value){if(type!=='name'){if(type!=='couplerRatingWithBrakes'&&type!=='couplerRatingWithoutBrakes'){value=_this._removeZero(value);}if(value[0]==='0')value=(+value).toString();}_this.setState(function(prevState){return{selectedTrailer:Object.assign({},prevState.selectedTrailer,_defineProperty({},type,value))};});};};_this._removeZero=function(value){return+value===0?'':value;};_this.handleCheckboxChange=function(){_this.setState(function(prevState){return{selectedTrailer:Object.assign({},prevState.selectedTrailer,{over80Wide:!prevState.selectedTrailer.over80Wide})};});};_this.updateList=function(newTrailer){var trailerList=_this.state.trailerList;var index=trailerList.findIndex(function(trailer){return+trailer.id===+newTrailer.id;});var state={trailerList:[].concat(_toConsumableArray(trailerList))};if(index!==-1){if(newTrailer.status===null){state.trailerList.splice(index,1);state.selectedTrailer=Object.assign({},defaultSelectedTrailer);_this.selectTrailer(null)();}else if(newTrailer.status===__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED){state.trailerList[index]=newTrailer;state.selectedTrailer=Object.assign({},defaultSelectedTrailer);_this.selectTrailer(null)();}else if(newTrailer.isRollOver){state.trailerList.push(newTrailer);}else{state.trailerList[index]=newTrailer;state.selectedTrailer=newTrailer;}}else{state.trailerList.unshift(newTrailer);state.selectedTrailer=Object.assign({},defaultSelectedTrailer);}_this.setState(state);};_this.selectTrailer=function(selectedTrailer){return function(){_this.setState({selectedTrailer:selectedTrailer||defaultSelectedTrailer},function(){if(selectedTrailer===null){_this.updateLocationState(''+__WEBPACK_IMPORTED_MODULE_5_constants_routing__["c" /* LINK */].LIST.TRAILER,'')();}else{_this.updateLocationState(''+__WEBPACK_IMPORTED_MODULE_5_constants_routing__["c" /* LINK */].LIST.TRAILER,'#edit='+selectedTrailer.id)();}});};};_this.calcRightMarginForApplication=function(){var marginRight=135;var section=document.getElementsByClassName('ect-section')[0];var root=document.getElementsByClassName('ect-root')[0];if(section&&root){if(section.clientHeight>root.clientHeight){if(/chrome/i.test(navigator.userAgent)){marginRight=150;}if(/firefox/i.test(navigator.userAgent)){marginRight=148;}}}return marginRight;};_this.state={trailerList:[],selectedTrailer:Object.assign({},defaultSelectedTrailer),applicationMode:__WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSED,listRequestInProcess:true};return _this;}_createClass(TrailerManufacturer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;this.roleSwitch();this._loadFromStore();__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].trailers).then(function(_ref){var trailerList=_ref.data;__WEBPACK_IMPORTED_MODULE_9__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',trailerList,user.getManufacturerCode()).then(function(){_this2._loadFromStore(function(){_this2.setState({listRequestInProcess:false},function(){var __isEditMode=function __isEditMode(){var hash=_this2.props.location.hash;return hash.indexOf(__WEBPACK_IMPORTED_MODULE_5_constants_routing__["b" /* HASH */].EDIT)!==-1;};var __getIdFromHash=function __getIdFromHash(){var hash=_this2.props.location.hash;return hash.split('edit=')[1].split('?')[0];};if(__isEditMode()){var selectedTrailer=_this2.state.trailerList.find(function(trailer){return+trailer.id===+__getIdFromHash();});if(!selectedTrailer)selectedTrailer=Object.assign({},defaultSelectedTrailer);if(!_this2.state.selectedTrailer||+selectedTrailer.id!==+_this2.state.selectedTrailer.id){_this2.setState({selectedTrailer:selectedTrailer});}}});});});});}},{key:'componentDidUpdate',value:function componentDidUpdate(){this._toggleApplication();}},{key:'render',value:function render(){var _state=this.state,applicationMode=_state.applicationMode,selectedTrailer=_state.selectedTrailer,trailerList=_state.trailerList,listRequestInProcess=_state.listRequestInProcess;var _props=this.props,history=_props.history,location=_props.location,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ect-section _position_relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__List__["a" /* default */],{list:trailerList,updateLocationState:this.updateLocationState,updateList:this.updateList,selectTrailer:this.selectTrailer,listRequestInProcess:listRequestInProcess,user:user})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Application__["a" /* default */],{applicationMode:applicationMode,marginRight:this.calcRightMarginForApplication(),updateList:this.updateList,updateLocationState:this.updateLocationState,selectedTrailer:selectedTrailer,selectTrailer:this.selectTrailer,handleInputChange:this.handleInputChange,handleCheckboxChange:this.handleCheckboxChange,user:user,history:history,location:location}));}}]);return TrailerManufacturer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TrailerManufacturer);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Row__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltersSection__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableHeader__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['id','name'];var List=function(_React$Component){_inherits(List,_React$Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this._handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},user.updateURLSearchString({activePage:activePage}));};_this._filterList=function(componentList){var _this$state=_this.state,filter=_this$state.filter,searchString=_this$state.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return componentList.filter(function(element){for(var filterFieldName in filter){switch(filterFieldName){case'status':if(element[filterFieldName].toLowerCase()!==filter[filterFieldName].toLowerCase()){return false;}break;default:if(element[filterFieldName]!==filter[filterFieldName]){return false;}}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(newFilterFieldValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=newFilterFieldValue;if(filterFieldName==='year'){if(filterElement==='All'){user.saveSelectedYear('');}else{user.saveSelectedYear(filterElement);}}_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});});};};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this._sortList=function(a,b){var _this$state2=_this.state,sortedBy=_this$state2.sortedBy,sortAsc=_this$state2.sortAsc;switch(sortedBy){case'id':return+a.id>+b.id?sortAsc:-sortAsc;default:return a[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')>b[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc};},_this.props.user.updateURLSearchString({sortedBy:sortedBy,sortAsc:_this.state.sortAsc}));};};_this._getList=function(){var _this$state3=_this.state,expandedRowId=_this$state3.expandedRowId,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,currentModelYear=_this$state3.currentModelYear,sortedBy=_this$state3.sortedBy,yearRequestInProcess=_this$state3.yearRequestInProcess;var _this$props=_this.props,list=_this$props.list,updateLocationState=_this$props.updateLocationState,selectTrailer=_this$props.selectTrailer,user=_this$props.user,updateList=_this$props.updateList,listRequestInProcess=_this$props.listRequestInProcess;var filteredList=_this._filterList(list).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=selectedRowsCount?activePage*selectedRowsCount:filteredList.length;var resultList=[];var resultLength=0;if(!list.length||yearRequestInProcess){if(listRequestInProcess||yearRequestInProcess){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'spinner',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_EmptyList__["a" /* default */],{key:'empty'},'No trailers for selected manufacturer.')];}}else if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_EmptyList__["a" /* default */],{key:'empty'},'No trailers found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(trailer,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Row__["a" /* default */],{key:trailer.id,trailer:trailer,isOdd:!!(index%2),toggleRow:_this.toggleRow,expandedRowId:expandedRowId,updateLocationState:updateLocationState,currentModelYear:currentModelYear,selectTrailer:selectTrailer,updateList:updateList,user:user,sortedBy:sortedBy});});resultLength=filteredList.length;}return{resultList:resultList,resultLength:resultLength};};_this.toggleRow=function(expandedRowId){return function(){if(expandedRowId===_this.state.expandedRowId)expandedRowId='';_this.setState({expandedRowId:expandedRowId});};};_this.defaultState={expandedRowId:0,activePage:1,selectedRowsCount:10,selectedStatus:'All',selectedYear:0,currentModelYear:0,sortedBy:'id',sortAsc:-1,filter:{year:0},searchString:''};var storedState=props.user.getStoredState('listState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);_this.state.yearRequestInProcess=!_this.state.filter.year;return _this;}_createClass(List,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */].currentModelYear).then(function(_ref){var currentModelYear=_ref.data;_this2.setState(function(prevState){return{currentModelYear:currentModelYear,filter:Object.assign({},prevState.filter,{year:user.getSelectedYear()||currentModelYear}),yearRequestInProcess:false};});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.user.saveState('listState',this.state,['currentModelYear','yearRequestInProcess','selectedYear']);}},{key:'render',value:function render(){var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortAsc=_state.sortAsc,sortedBy=_state.sortedBy,filter=_state.filter,currentModelYear=_state.currentModelYear,searchString=_state.searchString;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Trailer Model List',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_10_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowsSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,filterState:filter,currentModelYear:currentModelYear}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);List.propTypes={list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(props){_classCallCheck(this,Row);var _this=_possibleConstructorReturn(this,(Row.__proto__||Object.getPrototypeOf(Row)).call(this,props));_this._getRowState=function(){var _this$props=_this.props,expandedRowId=_this$props.expandedRowId,trailer=_this$props.trailer;return expandedRowId===trailer.id?'expanded':'collapsed';};_this._getStatusColor=function(){var trailer=_this.props.trailer;if(trailer&&trailer.status){return'list-scene__status-label_'+trailer.status.toString().toLowerCase();}return'';};_this._getTrailerReadableStatus=function(){var trailer=_this.props.trailer;if(trailer&&trailer.status){return trailer.status[0].toUpperCase()+trailer.status.slice(1).toLowerCase();}return'';};_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';};_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';};_this._getAdditionalRowStyles=function(trailerId){var expandedRowId=_this.props.expandedRowId;return expandedRowId===trailerId?'_height_60':'_height_0';};_this._selectAction=function(value){var _this$props2=_this.props,selectTrailer=_this$props2.selectTrailer,trailer=_this$props2.trailer;switch(value){case __WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].ROLL_OVER:_this.$modalBody='Are you sure you want to roll the trailer over?';_this.$confirmModalAction=_this._confirmRollOver;break;case __WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].EDIT:return selectTrailer(trailer)();case __WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DEACTIVATE:_this.$modalBody='Are you sure you want to Deactivate this application?';_this.$confirmModalAction=_this._confirmDeactivate;break;case __WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].REACTIVATE:_this.$modalBody='Are you sure you want to Reactivate this application?';_this.$confirmModalAction=_this._confirmReactivate;break;case __WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DELETE:_this.$modalBody='Are you sure you want to Delete this application?';_this.$confirmModalAction=_this._confirmDelete;break;default:return null;}_this.setState({isModalOpen:true});};_this._confirmDeactivate=function(){var requestInProcess=_this.state.requestInProcess;var _this$props3=_this.props,trailer=_this$props3.trailer,updateList=_this$props3.updateList;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */].deactivate(trailer.id)).then(function(){__WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(function(){_this._closeModal();updateList(Object.assign({},trailer,{status:__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED}));});});};_this._confirmReactivate=function(){var requestInProcess=_this.state.requestInProcess;var _this$props4=_this.props,trailer=_this$props4.trailer,updateList=_this$props4.updateList;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */].reactivate(trailer.id)).then(function(){__WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(function(){_this._closeModal();updateList(Object.assign({},trailer,{status:__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].INCOMPLETE}));});});};_this._confirmRollOver=function(){var requestInProcess=_this.state.requestInProcess;var _this$props5=_this.props,trailer=_this$props5.trailer,updateList=_this$props5.updateList;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */].rollOver(trailer.id)).then(function(_ref){var data=_ref.data;updateList(Object.assign({},data,{isRollOver:true}));__WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__["a" /* default */].success(1,'Your trailer has been successfully rolled over.');}).finally(function(){_this._closeModal();});});};_this._confirmDelete=function(){var requestInProcess=_this.state.requestInProcess;var _this$props6=_this.props,trailer=_this$props6.trailer,updateList=_this$props6.updateList;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3_api_requests__["h" /* trailerAPI */].delete(trailer.id)).then(function(){__WEBPACK_IMPORTED_MODULE_5_dom_managers_notification__["a" /* default */].success(1,'The trailer was deleted successfully.');_this._closeModal();updateList(Object.assign({},trailer,{status:null}));}).catch(function(){_this._closeModal();});});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this._getStringWithUnits=function(value,units){if(value!==null||value!==undefined){return units?value.toString()+' '+units:value.toString();}return'-';};_this._createActionsList=function(){var _this$props7=_this.props,trailer=_this$props7.trailer,currentModelYear=_this$props7.currentModelYear,user=_this$props7.user;var actions=[];actions.push(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].ROLL_OVER);if(trailer.status!==__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED){if(user.isInternal()||+trailer.year>=+currentModelYear){actions.push(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].EDIT);}if(user.isInternal()||trailer.status===__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].APPROVED&&+trailer.year>=+currentModelYear){actions.push(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DEACTIVATE);}}if(trailer.status===__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED){if(user.isInternal()||+trailer.year>=+currentModelYear){actions.push(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].REACTIVATE);}}if(trailer.status===__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].INCOMPLETE||trailer.status===__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].DEACTIVATED){actions.push(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DELETE);}return actions;};_this.state={isModalOpen:false,requestInProcess:false};_this.$modalBody='';_this.$confirmModalAction=function(){};return _this;}_createClass(Row,[{key:'render',value:function render(){var _state=this.state,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess;var _props=this.props,toggleRow=_props.toggleRow,trailer=_props.trailer,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'trailerRowId'+trailer.id,className:'list-scene__expandable-row-wrapper list-scene__expandable-row-wrapper_'+this._getRowState()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row '+this._getBackgroundColourStyle()+' _margin_bottom_0',onClick:toggleRow(trailer.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expand-icon list-scene__expand-icon_'+this._getRowState()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerIdField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n            '+this._getTextColourStyle('id')+' _width_pc_12'},trailer.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerNameField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n            '+this._getTextColourStyle('name')+' _width_pc_50'},trailer.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('status')},this._getTrailerReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerActionsField',className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_28'},!user.isInspector()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Select__["a" /* default */],{placeholder:'Actions',selectionList:this._createActionsList(),handleSelect:this._selectAction,defaultItem:'',isSlave:true,type:__WEBPACK_IMPORTED_MODULE_7_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row list-scene__expandable-row_'+this._getRowState()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column _width_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-body'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Empty Trailer Weight'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerWeightField',className:'list-scene__expandable-row_column-body'},this._getStringWithUnits(trailer.emptyTrailerWeight,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Over ','80"',' Wide'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerOver9000Field',className:'list-scene__expandable-row_column-body'},trailer.over80Wide?'Yes':'No')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Coupler Rating w/o Brakes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerCouplerRatingField',className:'list-scene__expandable-row_column-body'},trailer.couplerRatingWithoutBrakes)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Coupler Rating w/Brakes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerCouplerRatingWithBrakesField',className:'list-scene__expandable-row_column-body'},trailer.couplerRatingWithBrakes)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Hook Rating'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerHookRatingField',className:'list-scene__expandable-row_column-body'},trailer.hookRating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Rope/Strap Rating'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerStrapRatingField',className:'list-scene__expandable-row_column-body'},trailer.strapRating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Axles'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerNumberOfAxlesField',className:'list-scene__expandable-row_column-body'},trailer.numberOfAxles)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Winch Rating'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-body'},trailer.winchRating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'GAWR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerGAWRField',className:'list-scene__expandable-row_column-body'},this._getStringWithUnits(trailer.grossAxleWeightRating,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'GVWR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerGVWRField',className:'list-scene__expandable-row_column-body'},this._getStringWithUnits(trailer.grossVehicleWeightRating,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'},'Max Load Capacity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trailerLoadCapacityField',className:'list-scene__expandable-row_column-body'},this._getStringWithUnits(trailer.maxLoadCapacity,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column _width_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expandable-row_column-body'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.$modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'No',buttonClassName:'_width_135 _height_40',onClick:this._closeModal,color:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].gray,type:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["b" /* buttonType */].secondary}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_width_135 _height_40',onClick:this.$confirmModalAction}))));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={trailer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,expandedRowId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),toggleRow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Filters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_YearPicker__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_RowsSelector__ = __webpack_require__(29);
var statuses=['All','Approved','Incomplete','Deactivated'];function Filters(_ref){var outCount=_ref.outCount,handleRowsSelect=_ref.handleRowsSelect,rowsCount=_ref.rowsCount,handleSelectFilter=_ref.handleSelectFilter,filterState=_ref.filterState,currentModelYear=_ref.currentModelYear;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'By Status',placeholder:'All',withoutSearch:true,defaultItem:filterState.status,selectionList:statuses,handleSelect:handleSelectFilter('status'),type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_YearPicker__["a" /* default */],{endYear:currentModelYear+1,yearPickAction:handleSelectFilter('year'),year:filterState.year,width:160,height:18})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowsSelect,selectedRowsCount:rowsCount})));}

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('id')+' _width_pc_12',onClick:handleSortClick('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('name')+' _width_pc_50',onClick:handleSortClick('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('status')+' _width_pc_12',onClick:handleSortClick('status')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_28'}));});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_trailer__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Checkbox__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Info__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Application=function(_React$Component){_inherits(Application,_React$Component);function Application(props){_classCallCheck(this,Application);var _this=_possibleConstructorReturn(this,(Application.__proto__||Object.getPrototypeOf(Application)).call(this,props));_this._toggleAnimation=function(){var applicationMode=_this.props.applicationMode;switch(applicationMode){case __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENED:return'_top_105';case __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSED:return'_top_negative_985';case __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].OPENING:return'_translate_bottom';case __WEBPACK_IMPORTED_MODULE_3_constants_trailer__["a" /* APPLICATION_MODE */].CLOSING:return'_translate_top';default:return'';}};_this._completeCheck=function(closeApplication){var selectTrailer=_this.props.selectTrailer;_this.showErrors=false;_this.setState({invalidFields:{}},function(){if(closeApplication)selectTrailer(null)();});};_this._handleSubmit=function(){var submitInProcess=_this.state.submitInProcess;var _this$props=_this.props,updateList=_this$props.updateList,selectedTrailer=_this$props.selectedTrailer;if(submitInProcess)return null;var data=_this._removeFieldsForRequestBody(selectedTrailer);var showSubmitMessage=function showSubmitMessage(){if(_this._hasInputErrors()){__WEBPACK_IMPORTED_MODULE_7_dom_managers_notification__["a" /* default */].success(1,'Your application was saved in Incomplete status.');}else{__WEBPACK_IMPORTED_MODULE_7_dom_managers_notification__["a" /* default */].success(1,'Your application was submitted and approved successfully.');}};_this.showErrors=true;_this._checkRequiredFields(data).then(function(){_this.setState({submitInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].trailers,data).then(function(_ref){var data=_ref.data;showSubmitMessage();updateList(data);_this._completeCheck(selectedTrailer.id);}).finally(function(){_this.setState({submitInProcess:false});});});}).catch(function(){__WEBPACK_IMPORTED_MODULE_7_dom_managers_notification__["a" /* default */].error(1,'Please check the required fields.');_this.forceUpdate();});};_this._removeFieldsForRequestBody=function(data){data=Object.assign({},data);if(!data.id){delete data.id;}delete data.status;delete data.submitInProcess;delete data.user;delete data.submittedOn;delete data.primaryAccount;return data;};_this._checkTrailerInput=function(){var selectedTrailer=_this.props.selectedTrailer;var couplerRatingWithBrakes=false;var couplerRatingWithoutBrakes=false;if(selectedTrailer.couplerRatingWithBrakes!==''||selectedTrailer.couplerRatingWithoutBrakes!==''){if(+selectedTrailer.couplerRatingWithBrakes===0&&+selectedTrailer.couplerRatingWithoutBrakes===0){couplerRatingWithBrakes=true;couplerRatingWithoutBrakes=true;}else{if(+selectedTrailer.couplerRatingWithBrakes!==0){couplerRatingWithBrakes=+selectedTrailer.couplerRatingWithBrakes<+selectedTrailer.grossVehicleWeightRating;couplerRatingWithoutBrakes=false;}else if(+selectedTrailer.couplerRatingWithoutBrakes){couplerRatingWithBrakes=false;couplerRatingWithoutBrakes=+selectedTrailer.couplerRatingWithoutBrakes<+selectedTrailer.grossVehicleWeightRating;}}}return{grossVehicleWeightRating:+selectedTrailer.grossVehicleWeightRating>+selectedTrailer.grossAxleWeightRating*+selectedTrailer.numberOfAxles,couplerRatingWithBrakes:couplerRatingWithBrakes,couplerRatingWithoutBrakes:couplerRatingWithoutBrakes,strapRating:+selectedTrailer.strapRating<1.5*+selectedTrailer.winchRating,hookRating:+selectedTrailer.hookRating<1.5*+selectedTrailer.strapRating,maxLoadCapacity:+selectedTrailer.maxLoadCapacity>+selectedTrailer.grossVehicleWeightRating-+selectedTrailer.emptyTrailerWeight};};_this._isError=function(field){var invalidFields=_this.state.invalidFields;return _this.showErrors&&invalidFields[field]||_this._checkTrailerInput()[field];};_this._hasInputErrors=function(){var invalidFields=_this.state.invalidFields;var errors=_this._checkTrailerInput();if(Object.keys(invalidFields).length)return true;return Object.keys(errors).find(function(errorKey){return errors[errorKey];});};_this._getSubmitButtonLabel=function(){if(_this._hasInputErrors()){return'Save Incomplete';}return'Submit';};_this._checkRequiredFields=function(data){var invalidFields=_this.state.invalidFields;var isInvalidListChanged=false;data=Object.assign({},data);delete data.id;delete data.status;delete data.submitInProcess;delete data.user;delete data.submittedOn;return new Promise(function(resolve,reject){for(var key in data){if(data[key].toString()===''){if(!invalidFields[key]){invalidFields[key]=true;isInvalidListChanged=true;}}else{if(invalidFields[key]){delete invalidFields[key];isInvalidListChanged=true;}}}if(isInvalidListChanged){_this.setState({invalidFields:invalidFields},function(){if(Object.keys(invalidFields).length){reject();}else{resolve();}});}else{if(Object.keys(invalidFields).length){reject();}else{resolve();}}});};_this._getTrailerReadableStatus=function(){var selectedTrailer=_this.props.selectedTrailer;if(selectedTrailer&&selectedTrailer.status){return selectedTrailer.status[0].toUpperCase()+selectedTrailer.status.slice(1).toLowerCase();}return'';};_this._isYearEditable=function(){var selectedTrailer=_this.props.selectedTrailer;return!selectedTrailer.status;};_this.state={submitInProcess:false,invalidFields:{},modelYears:[]};_this.showErrors=false;return _this;}_createClass(Application,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].getPermissibleModelYears).then(function(_ref2){var data=_ref2.data;var modelYears=data.sort();_this2.setState({modelYears:modelYears});});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var selectedTrailer=this.props.selectedTrailer;this._checkRequiredFields(selectedTrailer).catch(function(){});}},{key:'render',value:function render(){var _state=this.state,submitInProcess=_state.submitInProcess,modelYears=_state.modelYears;var _props=this.props,selectedTrailer=_props.selectedTrailer,handleCheckboxChange=_props.handleCheckboxChange,handleInputChange=_props.handleInputChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'scene__new-trailer-window-wrapper '+this._toggleAnimation()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scene__new-trailer-window'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-header ect-header_size_s _border_bottom_1 _position_relative _height_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-header__text _color_dark_blue'},'Trailer Application'),selectedTrailer.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-application__id _font_size_16 _color_gray _font_weight_300 _padding_left_135'},'ID ',selectedTrailer.id),selectedTrailer.status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__status __status_'+selectedTrailer.status.toLowerCase()+'\n              __status_application _width_150 _height_40 _border_radius_20 _position_absolute _right_120 _bottom_negative_20 _color_white'},this._getTrailerReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ect-body _flex _padding_horizontal_90 _padding_top_40 _padding_bottom_20 _border_bottom_1 _flex_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_30 _padding_right_20 _box-sizing_border-box _min_width_240'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Trailer Name',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',value:selectedTrailer.name,error:this._isError('name'),tabIndex:1,onChange:handleInputChange('name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_flex _ai_center _jc_between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Checkbox__["a" /* default */],{label:'Over 80" Wide',value:selectedTrailer.over80Wide,onChange:handleCheckboxChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Rope/Strap Rating',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.strapRating,error:this._isError('strapRating'),tabIndex:7,onChange:handleInputChange('strapRating')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Rope Rating should be \u2265 1.5 * Winch Rating'),triggerWrapperClassName:'_position_absolute _top_8 _right_7 _z_index_200'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_14 _padding_horizontal_20 _box-sizing_border-box _min_width_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Select__["a" /* default */],{label:'Model Year',mainWrapperClassName:'_width_pc_100 _margin_bottom_4 _margin_top_0',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _margin_top_0 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_6 _border_radius_bottom_right_6 _top_55',top:56,disabled:!this._isYearEditable(),defaultItem:selectedTrailer.year.toString(),error:this._isError('year'),selectionList:modelYears,tabIndex:2,isSlave:true,withoutSearch:true,handleSelect:handleInputChange('year')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Axles',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,digitsAfterDot:0,value:selectedTrailer.numberOfAxles,error:this._isError('numberOfAxles'),tabIndex:8,onChange:handleInputChange('numberOfAxles')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_14 _padding_horizontal_20 _box-sizing_border-box _min_width_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Empty Trailer Weight',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.emptyTrailerWeight,error:this._isError('emptyTrailerWeight'),tabIndex:3,onChange:handleInputChange('emptyTrailerWeight')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Winch Rating',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.winchRating,error:this._isError('winchRating'),tabIndex:9,onChange:handleInputChange('winchRating')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_14 _padding_horizontal_20 _box-sizing_border-box _min_width_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Coupler Rating w/o Brakes',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.couplerRatingWithoutBrakes,error:this._isError('couplerRatingWithoutBrakes'),tabIndex:4,onChange:handleInputChange('couplerRatingWithoutBrakes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Coupler Rating w/o Brakes should be \u2265 GVWR if it is ','>',' 0 and Coupler Rating w/Brakes = 0 (Coupler Rating w/o Brakes may be equal to 0 if Coupler Rating w/Brakes ','>',' 0).'),triggerWrapperClassName:'_position_absolute _top_8 _right_7 _z_index_200'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'GAWR',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.grossAxleWeightRating,error:this._isError('grossAxleWeightRating'),tabIndex:10,onChange:handleInputChange('grossAxleWeightRating')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_14 _padding_horizontal_20 _box-sizing_border-box _min_width_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Coupler Rating w/Brakes',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.couplerRatingWithBrakes,error:this._isError('couplerRatingWithBrakes'),tabIndex:5,onChange:handleInputChange('couplerRatingWithBrakes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Coupler Rating w/Brakes should be \u2265 GVWR if it is ','>',' 0 (Coupler Rating w/Brakes may be equal to 0 if Coupler Rating w/o Brakes ','>',' 0).'),triggerWrapperClassName:'_position_absolute _top_8 _right_7 _z_index_200'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'GVWR',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.grossVehicleWeightRating,error:this._isError('grossVehicleWeightRating'),tabIndex:11,onChange:handleInputChange('grossVehicleWeightRating')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'GVWR should be \u2264 GAWR * Number of Axles'),triggerWrapperClassName:'_position_absolute _top_8 _right_7 _z_index_200'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_14 _padding_left_20 _box-sizing_border-box _min_width_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Hook Rating',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.hookRating,error:this._isError('hookRating'),tabIndex:6,onChange:handleInputChange('hookRating')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Hook Rating should be \u2265 1.5 * Rope Rating'),triggerWrapperClassName:'_position_absolute _top_8 _right_7 _z_index_200'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Max Load Capacity',mainWrapperClassName:'_margin_bottom_24',labelClassName:'_font_size_10 _min_height_26 _block',inputClassName:'_height_30 _border_radius_6 _width_pc_100',isNumeric:true,value:selectedTrailer.maxLoadCapacity,error:this._isError('maxLoadCapacity'),tabIndex:12,onChange:handleInputChange('maxLoadCapacity')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Info__["a" /* default */],{triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Maximum Load Capacity should be \u2264 (Standard GVWR - Empty Trailer Weight)'),triggerWrapperClassName:'_position_absolute _top_8 _right_7 _z_index_200'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ect-footer _flex _ai_center _jc_end _padding_horizontal_120 _padding_vertical_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Button__["c" /* default */],{label:'Cancel',type:__WEBPACK_IMPORTED_MODULE_6_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_6_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_120',onClick:this._completeCheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Button__["c" /* default */],{label:this._getSubmitButtonLabel(),disabledWithSpinner:submitInProcess,onClick:this._handleSubmit,buttonClassName:'_height_40 _width_160'}))));}}]);return Application;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Application);Application.defaultProps={selectedTrailer:{id:'',name:'',year:'',emptyTrailerWeight:'',over80Wide:false,couplerRatingWithBrakes:'',couplerRatingWithoutBrakes:'',strapRating:'',hookRating:'',winchRating:'',numberOfAxles:'',grossAxleWeightRating:'',grossVehicleWeightRating:'',maxLoadCapacity:'',status:''}};

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentManufacturer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Application__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentFamily__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FamilyList__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentManufacturer=Object(__WEBPACK_IMPORTED_MODULE_4_HOC_User__["a" /* default */])(_class=function(_React$Component){_inherits(ComponentManufacturer,_React$Component);function ComponentManufacturer(props){_classCallCheck(this,ComponentManufacturer);var _this=_possibleConstructorReturn(this,(ComponentManufacturer.__proto__||Object.getPrototypeOf(ComponentManufacturer)).call(this,props));_this.roleSwitch=function(){var user=_this.props.user;if(user.getActiveRole()!==__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName){user.changeMenu(__WEBPACK_IMPORTED_MODULE_6_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName);}};_this.updateListData=function(){var user=_this.props.user;var _this$state=_this.state,familiesRequestInProcess=_this$state.familiesRequestInProcess,componentsRequestInProcess=_this$state.componentsRequestInProcess;if(familiesRequestInProcess)++_this.familiesRequestIndex;else _this.familiesRequestIndex=0;var familiesRequestIndex=_this.familiesRequestIndex;_this.setState({familiesRequestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["c" /* componentFamilyAPI */].list).then(function(_ref){var familiesList=_ref.data;if(familiesRequestIndex>=_this.familiesRequestIndex){__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_families_lists',familiesList,user.getManufacturerCode()).then(function(){_this.loadFromStore(function(){_this.setState({familiesRequestInProcess:false});});});}});});if(componentsRequestInProcess)++_this.componentsRequestIndex;else _this.componentsRequestIndex=0;var componentsRequestIndex=_this.componentsRequestIndex;_this.setState({componentsRequestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].list).then(function(_ref2){var componentList=_ref2.data;if(componentsRequestIndex>=_this.componentsRequestIndex){__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',componentList,user.getManufacturerCode()).then(function(){_this.loadFromStore(function(){_this.setState({componentsRequestInProcess:false});});});}});});};_this.updateComponentListEntry=function(oldEntry,newEntry){var user=_this.props.user;if(typeof newEntry==='string'){oldEntry.applicationStatus=newEntry;__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',oldEntry,user.getManufacturerCode());}else{__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',newEntry,user.getManufacturerCode());}_this.loadFromStore();_this.updateListData();};_this.updateFamiliesListEntry=function(oldEntry,newEntry){var user=_this.props.user;if(typeof newEntry==='string'){oldEntry.status=newEntry;__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_families_lists',oldEntry,user.getManufacturerCode());}else{__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_families_lists',newEntry,user.getManufacturerCode());}_this.loadFromStore();_this.updateListData();};_this.loadFromStore=function(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_lists',user.getManufacturerCode()).then(function(components){_this.setState({components:components},cb);});__WEBPACK_IMPORTED_MODULE_14__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_families_lists',user.getManufacturerCode()).then(function(families){_this.setState({families:families},cb);});};_this.createAvailableForThisStatusActionsList=function(componentStatus){var user=_this.props.user;var userIsInternal=user.isInternal();var actions=[__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].EDIT];if(componentStatus===__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].DEACTIVATED){actions.push(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].REACTIVATE);}if(componentStatus===__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].PENDING||componentStatus===__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].APPROVED){actions.push(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DEACTIVATE);}if(componentStatus===__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].PENDING&&userIsInternal){actions.push(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].APPROVE);}if(userIsInternal&&componentStatus!==__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].DEACTIVATED&&componentStatus!==__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].INCOMPLETE){actions.push(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].INCOMPLETE);}if(componentStatus===__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].INCOMPLETE){actions.push(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].RESUBMIT);}return actions;};_this.performActionFunction=function(actionKey,actionSubjectId){var user=_this.props.user;switch(actionKey){case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DEACTIVATE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Deactivate this application?';_this.modalConfirmAction=_this._getChangeStatusAction(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].deactivate(actionSubjectId),__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].DEACTIVATED,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].INCOMPLETE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to mark this application as Incomplete?';_this.modalConfirmAction=_this._getChangeStatusAction(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].incomplete(actionSubjectId),__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].INCOMPLETE,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].REACTIVATE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Reactivate this application?';_this.modalConfirmAction=_this._getChangeStatusAction(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].reactivate(actionSubjectId),__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].INCOMPLETE,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].APPROVE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Approve this application?';_this.modalConfirmAction=_this._getChangeStatusAction(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].approve(actionSubjectId),__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].APPROVED,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].RESUBMIT:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to Resubmit this application?';_this.modalConfirmAction=_this._getChangeStatusAction(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].submit(actionSubjectId),__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].PENDING,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS:return new Promise(function(resolve,reject){user.goTo('/'+user.getManufacturerCode()+'/component/application/'+actionSubjectId+'/details');});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].EDIT:return new Promise(function(resolve,reject){user.goTo('/'+user.getManufacturerCode()+'/component/application/'+actionSubjectId+'/edit');});default:return function(){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].error('note','No such action');};}};_this.createFamilyActionsList=function(familyStatus){var user=_this.props.user;var actions=[__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].EDIT];if(user.isInternal()){actions.push(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].APPROVE);}return actions;};_this.performFamilyActionFunction=function(actionKey,actionSubjectId){var user=_this.props.user;switch(actionKey){case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].APPROVE:return new Promise(function(resolve,reject){_this.modalBody='Are you sure you want to approve all component applications in this component family?';_this.modalConfirmAction=_this._getChangeStatusAction(__WEBPACK_IMPORTED_MODULE_3_api_requests__["c" /* componentFamilyAPI */].approve(actionSubjectId),__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* STATUS */].APPROVED,resolve);_this._openModal();});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS:return new Promise(function(resolve,reject){user.goTo(user.getFamiliesLink()+'/'+actionSubjectId+'/details');});case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].EDIT:return new Promise(function(resolve,reject){user.goTo(user.getFamiliesLink()+'/'+actionSubjectId+'/edit');});default:return function(){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].error('note','No such action');};}};_this._getChangeStatusAction=function(api,newStatusString,cb){return function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].patch(api).then(function(_ref3){var data=_ref3.data;cb(data||newStatusString);__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(_this._closeModal);});};};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.state={isModalOpen:false,types:'',categories:'',families:'',components:'',componentsRequestInProcess:true,familiesRequestInProcess:true,requestInProcess:false,currentModelYear:new Date().getFullYear()};_this.componentsRequestIndex=0;_this.familiesRequestIndex=0;return _this;}_createClass(ComponentManufacturer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.roleSwitch();this.updateListData();__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].types).then(function(_ref4){var data=_ref4.data;_this2.setState({types:data});});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].categories).then(function(_ref5){var data=_ref5.data;_this2.setState({categories:data});});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref6){var data=_ref6.data;_this2.setState({currentModelYear:data[1]||data[0]});});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,isModalOpen=_state.isModalOpen,types=_state.types,categories=_state.categories,families=_state.families,components=_state.components,componentsRequestInProcess=_state.componentsRequestInProcess,familiesRequestInProcess=_state.familiesRequestInProcess,requestInProcess=_state.requestInProcess,currentModelYear=_state.currentModelYear;var _props=this.props,match=_props.match,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:''+match.path,render:function render(_ref7){var match=_ref7.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__List__["a" /* default */],{match:match,createAvailableForThisStatusActionsList:_this3.createAvailableForThisStatusActionsList,performActionFunction:_this3.performActionFunction,user:user,types:types,categories:categories,families:families,components:components,currentModelYear:currentModelYear,componentsRequestInProcess:componentsRequestInProcess,familiesRequestInProcess:familiesRequestInProcess,updateComponentListEntry:_this3.updateComponentListEntry});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+'/family',render:function render(_ref8){var match=_ref8.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FamilyList__["a" /* default */],{match:match,createFamilyActionsList:_this3.createFamilyActionsList,performFamilyActionFunction:_this3.performFamilyActionFunction,updateFamiliesListEntry:_this3.updateFamiliesListEntry,user:user,types:types,categories:categories,families:families,components:components,componentsRequestInProcess:componentsRequestInProcess,familiesRequestInProcess:familiesRequestInProcess});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+'/family/:familyId',render:function render(_ref9){var match=_ref9.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ComponentFamily__["a" /* default */],{match:match,createFamilyActionsList:_this3.createFamilyActionsList,performFamilyActionFunction:_this3.performFamilyActionFunction,updateFamiliesListEntry:_this3.updateFamiliesListEntry,user:user,types:types,categories:categories,families:families,components:components,componentsRequestInProcess:componentsRequestInProcess,familiesRequestInProcess:familiesRequestInProcess});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+'/application/:applicationId',render:function render(_ref10){var match=_ref10.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Application__["a" /* default */],{match:match,createAvailableForThisStatusActionsList:_this3.createAvailableForThisStatusActionsList,performActionFunction:_this3.performActionFunction,updateComponentListEntry:_this3.updateComponentListEntry,user:user,types:types,categories:categories,families:families,components:components,componentsRequestInProcess:componentsRequestInProcess,familiesRequestInProcess:familiesRequestInProcess});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Button__["c" /* default */],{label:'No',buttonClassName:'_width_135 _height_40',onClick:this._closeModal,color:__WEBPACK_IMPORTED_MODULE_12_Components_Button__["a" /* buttonColor */].gray,type:__WEBPACK_IMPORTED_MODULE_12_Components_Button__["b" /* buttonType */].secondary}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_width_135 _height_40',onClick:this.modalConfirmAction}))));}}]);return ComponentManufacturer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Row__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltersSection__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableHeader__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['id','description'];var List=function(_React$Component){_inherits(List,_React$Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,sortedBy:'id',sortAsc:-1,filter:{},searchString:''};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this._handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},function(){user.updateURLSearchString({activePage:activePage});});};_this._sortList=function(a,b){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortAsc=_this$state.sortAsc;switch(sortedBy){case'id':return+a.id>+b.id?sortAsc:-sortAsc;case'componentType':return a.componentType.componentTypeName.toLowerCase()>b.componentType.componentTypeName.toLowerCase()?sortAsc:-sortAsc;default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){var user=_this.props.user;_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc,activePage:1};},function(){user.updateURLSearchString({sortedBy:_this.state.sortedBy,sortAsc:_this.state.sortAsc,activePage:1});});};};_this._filterList=function(componentList){var _this$state2=_this.state,filter=_this$state2.filter,searchString=_this$state2.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return componentList.filter(function(element){for(var filterFieldName in filter){switch(filterFieldName){case'categoryId':if(element.componentType[filterFieldName]!==filter[filterFieldName]){return false;}break;case'componentType':if(element[filterFieldName].componentTypeCode!==filter[filterFieldName]){return false;}break;case'applicationStatus':if(element[filterFieldName].toLowerCase()!==filter[filterFieldName].toLowerCase()){return false;}break;case'submissionDate':if(new Date(element.submissionDate).getFullYear()!==filter[filterFieldName]){return false;}break;default:if(element[filterFieldName]!==filter[filterFieldName]){return false;}}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(newFilterFieldValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=newFilterFieldValue;if(filterFieldName==='categoryId')delete newFilterState.componentType;if(filterFieldName==='submissionDate'){if(filterElement==='All'){user.saveSelectedYear('');}else{user.saveSelectedYear(filterElement);}}_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});});};};_this._getList=function(){var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var _this$props=_this.props,user=_this$props.user,createAvailableForThisStatusActionsList=_this$props.createAvailableForThisStatusActionsList,performActionFunction=_this$props.performActionFunction,components=_this$props.components,componentsRequestInProcess=_this$props.componentsRequestInProcess,updateComponentListEntry=_this$props.updateComponentListEntry;var resultList=[];var resultLength=0;if(!components.length){if(componentsRequestInProcess){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'spinner',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__["a" /* default */],{key:'empty'},'No components for selected manufacturer.')];}}else{var filteredList=_this._filterList(components).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__["a" /* default */],{key:'empty'},'No components found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(component,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Row__["a" /* default */],{key:component.id,user:user,sortedBy:sortedBy,component:component,isOdd:!!(index%2),availableActionsList:createAvailableForThisStatusActionsList(component.applicationStatus),performActionFunction:performActionFunction,updateComponentListEntry:updateComponentListEntry});});resultLength=filteredList.length;}}return{resultList:resultList,resultLength:resultLength};};var storedState=props.user.getStoredState('listState',_this.defaultState);if(!props.user.isInternal()&&storedState.filter)delete storedState.filter.submissionDate;props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);// NMMA-3004
// if (props.user.getSelectedYear()) {
// this.state.filter.submissionDate = props.user.getSelectedYear();
// }
if(!props.user.isInternal())delete _this.state.filter.submissionDate;return _this;}_createClass(List,[{key:'componentWillUnmount',value:function componentWillUnmount(){var user=this.props.user;user.saveState('listState',this.state,['submissionDate']);}},{key:'render',value:function render(){var _props=this.props,types=_props.types,categories=_props.categories,user=_props.user,currentModelYear=_props.currentModelYear;var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,filter=_state.filter,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,searchString=_state.searchString;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Component List',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_7_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowsSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,filterState:filter,types:types,categories:categories,currentModelYear:currentModelYear,user:user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._selectAction=function(actionKey){var _this$props=_this.props,component=_this$props.component,performActionFunction=_this$props.performActionFunction,updateComponentListEntry=_this$props.updateComponentListEntry;performActionFunction(actionKey,component.id).then(function(updatedData){return updateComponentListEntry(component,updatedData);});},_this._getStatusColor=function(){var component=_this.props.component;if(component&&component.applicationStatus){return'list-scene__status-label_'+component.applicationStatus.toString().toLowerCase();}return'';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getComponentReadableStatus=function(){var component=_this.props.component;if(component&&component.applicationStatus){return component.applicationStatus[0].toUpperCase()+component.applicationStatus.slice(1).toLowerCase();}return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _this2=this;var _props=this.props,component=_props.component,availableActionsList=_props.availableActionsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentListRowID'+component.id,className:'list-scene__table-row '+this._getBackgroundColourStyle(),onClick:function onClick(){_this2._selectAction(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DETAILS);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentIDField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('id')+' _width_pc_8'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentSubmissionDateField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('submissionDate')+' _width_pc_8'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(component.submissionDate).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentTypeField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('componentType')+' _width_pc_12'},component.componentType.componentTypeName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentDescriptionField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('description')+' list-scene__table-row-element_place_filler'},component.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('applicationStatus')},this._getComponentReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{placeholder:'Actions',withoutSearch:true,multiSelect:true,selectionList:availableActionsList,handleSelect:this._selectAction,type:__WEBPACK_IMPORTED_MODULE_3_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()}));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FiltersSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var statuses=['All','Approved','Incomplete','Deactivated','Pending'];var FiltersSection=function(_React$Component){_inherits(FiltersSection,_React$Component);function FiltersSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FiltersSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FiltersSection.__proto__||Object.getPrototypeOf(FiltersSection)).call.apply(_ref,[this].concat(args))),_this),_this.getFormattedListForSelect=function(nameFieldName,valueFieldName,dataObject,filterFieldName,filterValue){var formattedList=dataObject.map(function(entry){return{name:entry[nameFieldName],value:entry[valueFieldName]};});formattedList.sort(function(_ref2,_ref3){var a=_ref2.name;var b=_ref3.name;return a.toLowerCase()>b.toLowerCase()?1:-1;});formattedList.unshift({name:'All',value:'All'});if(filterFieldName){return formattedList.filter(function(item){return item[filterFieldName]===filterValue;});}else{return formattedList;}},_this._getSelectedItem=function(itemValue,itemsList){var selectedItem=itemsList.find(function(item){return item.value===itemValue;});if(selectedItem){return selectedItem;}else{return itemsList[0];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FiltersSection,[{key:'render',value:function render(){var _props=this.props,handleSelectFilter=_props.handleSelectFilter,filterState=_props.filterState,outCount=_props.outCount,handleRowsSelect=_props.handleRowsSelect,rowsCount=_props.rowsCount,categories=_props.categories,types=_props.types,user=_props.user,currentModelYear=_props.currentModelYear;var categoriesOptions=[];var typesOptions=[];if(categories.length&&types.length){categoriesOptions=this.getFormattedListForSelect('name','id',categories);typesOptions=filterState.categoryId?this.getFormattedListForSelect('componentTypeName','componentTypeCode',categories.find(function(category){return category.id===filterState.categoryId;}).componentTypes):this.getFormattedListForSelect('componentTypeName','componentTypeCode',types);if(typesOptions.length===2)typesOptions.shift();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Category',selectionList:categoriesOptions,withoutSearch:true,defaultItem:this._getSelectedItem(filterState.categoryId,categoriesOptions),itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,isLoading:!categoriesOptions.length,handleSelect:handleSelectFilter('categoryId')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Type',selectionList:typesOptions,withoutSearch:true,defaultItem:this._getSelectedItem(filterState.componentType,typesOptions),itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,isLoading:!typesOptions.length,handleSelect:handleSelectFilter('componentType')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Status',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,withoutSearch:true,defaultItem:filterState.applicationStatus,placeholder:'All',selectionList:statuses,handleSelect:handleSelectFilter('applicationStatus')}),user.isInternal()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__["a" /* default */],{endYear:currentModelYear+1,yearPickAction:handleSelectFilter('submissionDate'),label:'by Year',year:filterState.submissionDate,withAllOption:true,width:160,height:18})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowsSelect,selectedRowsCount:rowsCount})));}}]);return FiltersSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('id')+' _width_pc_8',onClick:handleSortClick('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('submissionDate')+' _width_pc_8',onClick:handleSortClick('submissionDate')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Submission Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('componentType')+' _width_pc_12',onClick:handleSortClick('componentType')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('description')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('description')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Component Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('applicationStatus')+' _width_pc_12',onClick:handleSortClick('applicationStatus')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_12'}));});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Application; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__New__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Details__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Edit__ = __webpack_require__(1069);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Application=function(_React$Component){_inherits(Application,_React$Component);function Application(props){_classCallCheck(this,Application);var _this=_possibleConstructorReturn(this,(Application.__proto__||Object.getPrototypeOf(Application)).call(this,props));_this.changeStatus=function(actionKey){return function(){var _this$props=_this.props,match=_this$props.match,performActionFunction=_this$props.performActionFunction,updateComponentListEntry=_this$props.updateComponentListEntry;var applicationId=match.params.applicationId;var _this$state=_this.state,componentType=_this$state.componentType,componentTypeFieldValues=_this$state.componentTypeFieldValues,componentTestReports=_this$state.componentTestReports,submissionDate=_this$state.submissionDate,description=_this$state.description;performActionFunction(actionKey,applicationId).then(function(data){if(typeof data==='string'){_this.setState({applicationStatus:data},function(){updateComponentListEntry({},{applicationStatus:data,componentTestReports:componentTestReports,componentType:componentType,componentTypeFieldValues:componentTypeFieldValues,description:description,id:+applicationId,submissionDate:submissionDate});});}else{_this.setState(Object.assign({},data),function(){updateComponentListEntry({},data);});}});};};_this.state={componentType:{},componentTypeFieldValues:[],componentTestReports:[],applicationStatus:'',submissionDate:'',submittedBy:{},requestInProcess:true,fieldsList:[]};_this.types=[];_this.categories=[];_this.families=[];return _this;}_createClass(Application,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var match=this.props.match;var applicationId=match.params.applicationId;if(isFinite(applicationId)){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].componentInfo(applicationId)).then(function(_ref){var data=_ref.data;_this2.setState(Object.assign({},data));});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(this.state.requestInProcess&&this.state.applicationStatus&&this.props.types&&this.props.families&&this.props.categories){var fieldsList=this.props.types.find(function(type){return type.id===_this3.state.componentType.id;}).componentTypeFields;this.setState({fieldsList:fieldsList,requestInProcess:false});}}},{key:'render',value:function render(){var _this4=this;var _props=this.props,match=_props.match,user=_props.user,createAvailableForThisStatusActionsList=_props.createAvailableForThisStatusActionsList,updateComponentListEntry=_props.updateComponentListEntry,types=_props.types,categories=_props.categories,families=_props.families,components=_props.components,familiesRequestInProcess=_props.familiesRequestInProcess;var _state=this.state,applicationStatus=_state.applicationStatus,requestInProcess=_state.requestInProcess,fieldsList=_state.fieldsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path.slice(0,-14)+'new',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__New__["a" /* default */],Object.assign({},_this4.state,{types:types,categories:categories,components:components,families:families,updateComponentListEntry:updateComponentListEntry,familiesRequestInProcess:familiesRequestInProcess,user:user}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+'/details',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Details__["a" /* default */],Object.assign({},_this4.state,{user:user,requestInProcess:requestInProcess,categories:categories,families:families,changeStatus:_this4.changeStatus,availableActions:createAvailableForThisStatusActionsList(applicationStatus)}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+'/edit',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Edit__["a" /* default */],Object.assign({},_this4.state,{user:user,fieldsList:fieldsList,categories:categories,components:components,families:families,requestInProcess:requestInProcess,updateComponentListEntry:updateComponentListEntry,familiesRequestInProcess:familiesRequestInProcess,updateStoredData:_this4.updateStoredData}));}}));}}]);return Application;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeneralInformation__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ComponentsFileCopyList__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FamilyInfo__ = __webpack_require__(1061);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewApplication=function(_React$Component){_inherits(NewApplication,_React$Component);function NewApplication(props){_classCallCheck(this,NewApplication);var _this=_possibleConstructorReturn(this,(NewApplication.__proto__||Object.getPrototypeOf(NewApplication)).call(this,props));_this.handleSelectCategory=function(newCategory){var category=_this.state.category;var inputErrors=_this.state.inputErrors;delete inputErrors.category;if(newCategory!==category){if(newCategory){_this.setState({category:newCategory,type:null},function(){if(newCategory.componentTypes.length===1){_this.handleSelectType(newCategory.componentTypes[0]);}});}else{_this.setState({category:null,type:null,additionalFields:{}});}}};_this.handleSelectType=function(newType){var type=_this.state.type;var inputErrors=_this.state.inputErrors;delete inputErrors.type;if(newType!==type){_this.someDataWasInputted=true;_this.setState(function(prevState){return{type:newType,description:!prevState.type||prevState.type.id!==newType.id?'':prevState.description,additionalFields:_this.generateAdditionalFields(newType),files:[],family:''};});}};_this.handleSelectFamily=function(family){_this.setState({family:family});};_this.generateAdditionalFields=function(type){var fields={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=type.componentTypeFields[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var field=_step.value;fields[field.id]={required:field.required,value:''};}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return fields;};_this.handleAdditionalFieldChange=function(id){return function(event){var inputErrors=_this.state.inputErrors;var newValue=event.target?event.target.value:event.value||event;_this.someDataWasInputted=true;delete inputErrors[id];_this.setState(function(prevState){return{additionalFields:Object.assign({},prevState.additionalFields,_defineProperty({},id,Object.assign({},prevState.additionalFields[id],{value:newValue}))),inputErrors:inputErrors};});};};_this.handleDescriptionChange=function(value){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;if(value.length<251){delete inputErrors.description;_this.setState({description:value,inputErrors:inputErrors});}else{inputErrors.description='Description must be 250 characters max';_this.setState({inputErrors:inputErrors});}};_this.handleFileSelect=function(files){_this.someDataWasInputted=true;_this.setState(function(prevState){return{files:[].concat(_toConsumableArray(prevState.files),_toConsumableArray(files))};});};_this.handleRemoveFile=function(index){return function(){_this.someDataWasInputted=true;_this.setState(function(prevState){prevState.files.splice(index,1);return{files:prevState.files};});};};_this.openFileCopyModal=function(){var componentsWithTestReports=_this.state.componentsWithTestReports;if(componentsWithTestReports.length){_this.modalHeader='';_this.modalBody=_this.getFileCopyModalBody(componentsWithTestReports);_this.modalConfirmAction=_this.copyFilesFromExistingReport;_this.setState({modalIsCopyTestReports:true},function(){_this._openModal();});}else{__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error('note','No components','There no existing components with test reports.');}};_this.getFileCopyModalBody=function(componentsWithTestReports){return function(){var componentIdForTestReportsCopy=_this.state.componentIdForTestReportsCopy;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ComponentsFileCopyList__["a" /* default */],{selectReportIdForFileCopy:_this.selectReportIdForFileCopy,selectedReportId:componentIdForTestReportsCopy,components:componentsWithTestReports});};};_this.selectReportIdForFileCopy=function(componentId){_this.setState({componentIdForTestReportsCopy:componentId});};_this.copyFilesFromExistingReport=function(){var componentIdForTestReportsCopy=_this.state.componentIdForTestReportsCopy;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].componentReportsInfo(componentIdForTestReportsCopy)).then(function(_ref){var componentReportsList=_ref.data;_this.someDataWasInputted=true;if(componentReportsList.length){componentReportsList.forEach(function(report){_this.fileIdsToCopy.push(report.id);});}_this.setState(function(prevState){return{files:[].concat(_toConsumableArray(prevState.files),_toConsumableArray(componentReportsList))};});}).finally(function(){_this._closeModal();});});};_this.validateForm=function(){var _this$state=_this.state,additionalFields=_this$state.additionalFields,files=_this$state.files,family=_this$state.family;var inputErrors=_this.state.inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))inputErrors[fieldName]=true;});var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=Object.keys(additionalFields)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var key=_step2.value;if(additionalFields[key].required&&(isEmptyString(additionalFields[key].value)||isEmptyArray(additionalFields[key].value)||isEmptyObject(additionalFields[key].value))){inputErrors[key]=true;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return new Promise(function(resolve,reject){_this.setState({inputErrors:inputErrors},function(){if(Object.keys(_this.state.inputErrors).length){__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','Please check you information and try again.');reject();}else if(isEmptyArray(files)&&!family){__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','Select Family or upload at least one individual report file.');reject();}else{resolve();}});});};_this.handleSubmitClick=function(){var _this$state2=_this.state,type=_this$state2.type,description=_this$state2.description,additionalFields=_this$state2.additionalFields,files=_this$state2.files,family=_this$state2.family;var _this$props=_this.props,user=_this$props.user,updateComponentListEntry=_this$props.updateComponentListEntry;_this.validateForm().then(function(){var headers={'Content-Type':'multipart/form-data'};var requestJSON={};requestJSON.description=description;requestJSON.componentTypeId=type.id;requestJSON.fieldValues=Object.keys(additionalFields).map(function(key){return{fieldId:key,value:additionalFields[key].value};});requestJSON.fileIdsToCopy=_this.fileIdsToCopy;requestJSON.componentFamilyId=family?family.id:null;var data=new FormData();data.append('requestJson',JSON.stringify(requestJSON));files.forEach(function(file){return data.append('reports',file);});_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to submit this application?';_this.modalConfirmAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].create,data,{headers:headers}).then(function(_ref2){var data=_ref2.data;__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].success('note','Your application was submitted successfully.');_this.someDataWasInputted=false;_this._closeModal();updateComponentListEntry({},data);user.goToList();}).catch(function(){_this._closeModal();});});};_this._openModal();});};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};_this.setState({isModalOpen:false,requestInProcess:false,modalIsCopyTestReports:false},function(){if(typeof cb==='function')cb();});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalHeader='Confirmation';_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this._closeModal(function(){user.goTo(location);});};_this._openModal();return false;}return true;};_this.state={type:'',category:'',description:'',additionalFields:{},files:[],isModalOpen:false,requestInProcess:false,componentIdForTestReportsCopy:'',family:'',modalIsCopyTestReports:false,inputErrors:{},componentsWithTestReports:[]};_this.someDataWasInputted=false;_this.fileIdsToCopy=[];_this.requiredFields=['type','category','description'];return _this;}_createClass(NewApplication,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].listWithReports).then(function(_ref3){var componentsWithTestReports=_ref3.data;_this2.setState({componentsWithTestReports:componentsWithTestReports});});}},{key:'render',value:function render(){var _state=this.state,isModalOpen=_state.isModalOpen,type=_state.type,category=_state.category,description=_state.description,additionalFields=_state.additionalFields,inputErrors=_state.inputErrors,files=_state.files,requestInProcess=_state.requestInProcess,family=_state.family,componentIdForTestReportsCopy=_state.componentIdForTestReportsCopy,modalIsCopyTestReports=_state.modalIsCopyTestReports;var _props=this.props,user=_props.user,categories=_props.categories,families=_props.families,familiesRequestInProcess=_props.familiesRequestInProcess;var types=category?category.componentTypes:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{user:user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Select__["a" /* default */],{selectionList:categories||[],type:'primary',mainWrapperClassName:'_margin_right_30',itemNameIndicator:'name',label:'Component Category * ',isLoading:!categories.length,error:inputErrors.category,unclearable:true,handleSelect:this.handleSelectCategory}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Select__["a" /* default */],{selectionList:types,type:'primary',itemNameIndicator:'componentTypeName',label:'Component Type *',isLoading:!categories.length,disabled:!types.length,error:inputErrors.type,defaultItem:type||{},isSlave:true,unclearable:true,handleSelect:this.handleSelectType})),type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GeneralInformation__["a" /* default */],{handleAdditionalFieldChange:this.handleAdditionalFieldChange,type:type,types:category?category.componentTypes:[],category:category,categories:categories,inputErrors:inputErrors,additionalFields:additionalFields}),type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Component Description * (250 char. max)',value:description,onChange:this.handleDescriptionChange,error:inputErrors.description})),type&&type.allowComponentFamily&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FamilyInfo__["a" /* default */],{family:family,families:families,componentType:type,familiesRequestInProcess:familiesRequestInProcess,handleSelectFamily:this.handleSelectFamily}),type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_FilePicker__["a" /* default */],{editableStateSectionHeader:'Upload Component-specific Test Report'+(family?'':' *'),sectionHeaderClassName:'scene_section-header',infoMessage:'Test reports in this section are component-specific and available for this component only',files:files,handleFileSelect:this.handleFileSelect,handleRemoveFile:this.handleRemoveFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'Copy from another component',type:'',color:'',buttonClassName:'ect-file-picker__button _height_34 _width_145 _opacity_1',onClick:this.openFileCopyModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{cancelButtonLabel:'Cancel',saveButtonLabel:'Submit',saveButtonAction:this.handleSubmitClick,cancelButtonAction:user.goBack})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Modal__["a" /* default */],{isOpen:isModalOpen},this.modalHeader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},this.modalHeader),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},typeof this.modalBody==='function'?this.modalBody():this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_8_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,disabled:modalIsCopyTestReports&&!componentIdForTestReportsCopy,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}]);return NewApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var user=_ref.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList(false);}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'New Component Application'));});

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentGeneralInformation=function(_React$Component){_inherits(ComponentGeneralInformation,_React$Component);function ComponentGeneralInformation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ComponentGeneralInformation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ComponentGeneralInformation.__proto__||Object.getPrototypeOf(ComponentGeneralInformation)).call.apply(_ref,[this].concat(args))),_this),_this.getFieldsBySelectedType=function(){var _this$props=_this.props,type=_this$props.type,additionalFields=_this$props.additionalFields,handleAdditionalFieldChange=_this$props.handleAdditionalFieldChange,inputErrors=_this$props.inputErrors;if(!type)return null;return type.componentTypeFields.map(function(field,index){if(!field.active)return null;if(field.fieldName===null)field.fieldName=field.fieldNameCode;var label=field.required?field.fieldName.toLowerCase()+' *':field.fieldName.toLowerCase();if(field.componentTypeFieldValues.length)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{key:field.id,type:'primary',mainWrapperClassName:''+(index%2===0?'_margin_right_30':''),defaultItem:additionalFields[field.id],selectionList:field.componentTypeFieldValues,error:inputErrors[field.id],itemNameIndicator:'value',label:label,capitalizeLabel:true,handleSelect:handleAdditionalFieldChange(field.id)});else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary '+(index%2===0?'_margin_right_30':''),inputClassName:'input__input-field_primary',key:field.id,label:label,error:inputErrors[field.id],capitalizeLabel:true,value:additionalFields[field.id].value,onChange:handleAdditionalFieldChange(field.id)});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ComponentGeneralInformation,[{key:'render',value:function render(){var type=this.props.type;if(!type)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Information'),this.getFieldsBySelectedType());}}]);return ComponentGeneralInformation;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ComponentGeneralInformation);

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentsFileCopyList=function(_React$Component){_inherits(ComponentsFileCopyList,_React$Component);function ComponentsFileCopyList(){_classCallCheck(this,ComponentsFileCopyList);return _possibleConstructorReturn(this,(ComponentsFileCopyList.__proto__||Object.getPrototypeOf(ComponentsFileCopyList)).apply(this,arguments));}_createClass(ComponentsFileCopyList,[{key:'getList',value:function getList(){var _props=this.props,selectReportIdForFileCopy=_props.selectReportIdForFileCopy,selectedReportId=_props.selectedReportId,components=_props.components;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper _margin_top_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_15'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small _width_pc_25'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__header-item_small list__row-item_place-filler'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_max_height_vh_40 _overflow_x_auto'},components.map(function(component,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__row_small list__row_selectable '+(selectedReportId==component.id?'list__row_selected':''),key:index,onClick:function onClick(){selectReportIdForFileCopy(component.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_15'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_25'},component.componentType.componentTypeName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_place-filler'},component.description));})));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'_min_width_480'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Copy Test Reports'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_12 _font_weight_100 _color_light_gray _margin_bottom_10 _margin_top_20'},'Select existing component to copy test reports from'),this.getList());}}]);return ComponentsFileCopyList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ComponentsFileCopyList);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditApplication=function(_React$Component){_inherits(EditApplication,_React$Component);function EditApplication(props){_classCallCheck(this,EditApplication);var _this=_possibleConstructorReturn(this,(EditApplication.__proto__||Object.getPrototypeOf(EditApplication)).call(this,props));_this.getFamilyData=function(){var family=_this.props.family;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].info(family.id)).then(function(_ref){var data=_ref.data;_this.setState({familyInfo:data,requestInProcess:false});});});};_this.state={familyInfo:'',requestInProcess:false};return _this;}_createClass(EditApplication,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.family){this.getFamilyData();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.family&&!this.state.requestInProcess&&(!this.state.familyInfo||this.props.family.id!==this.state.familyInfo.id)){this.getFamilyData();}}},{key:'render',value:function render(){var _props=this.props,family=_props.family,families=_props.families,componentType=_props.componentType,handleSelectFamily=_props.handleSelectFamily,familiesRequestInProcess=_props.familiesRequestInProcess;var _state=this.state,familyInfo=_state.familyInfo,requestInProcess=_state.requestInProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:families.filter(function(availableFamily){return availableFamily.type.id===componentType.id;}),type:'primary',mainWrapperClassName:'_margin_right_30',itemNameIndicator:'name',label:'Select existing family',placeholder:'Select Component Family',defaultItem:family?families.find(function(availableFamily){return availableFamily.id===family.id;}):{},isLoading:familiesRequestInProcess,handleSelect:handleSelectFamily}),family?requestInProcess?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_FilePicker__["a" /* default */],{isEditable:false,sectionHeaderClassName:'scene_section-header _margin_top_20',notEditableStateSectionHeader:'Uploaded Family documents',infoMessage:'Test reports in this section are shared across the Component Family. Please edit Component Family to add / remove documents.',files:familyInfo.testReports,httpParams:{currentId:familyInfo.id,fileIdFieldName:'id',currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].downloadReport}}):null);}}]);return EditApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeneralInformation__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotesSection__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactInformation__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChangeStatus__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FamilyInfo__ = __webpack_require__(1068);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsApplication=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsApplication);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call.apply(_ref,[this].concat(args))),_this),_this._handleBackClick=function(){var user=_this.props.user;user.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsApplication,[{key:'render',value:function render(){var _props=this.props,user=_props.user,match=_props.match,applicationStatus=_props.applicationStatus,componentType=_props.componentType,componentTypeFieldValues=_props.componentTypeFieldValues,description=_props.description,submissionDate=_props.submissionDate,notes=_props.notes,submittedBy=_props.submittedBy,componentTestReports=_props.componentTestReports,changeStatus=_props.changeStatus,availableActions=_props.availableActions,requestInProcess=_props.requestInProcess,categories=_props.categories,family=_props.family;var applicationId=match.params.applicationId;if(requestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{user:user,applicationId:applicationId,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+applicationStatus.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{applicationStatus:applicationStatus,applicationId:applicationId,user:user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GeneralInformation__["a" /* default */],{type:componentType,category:categories.find(function(cat){return cat.id===componentType.categoryId;}),componentTypeFieldValues:componentTypeFieldValues,description:description,submissionDate:submissionDate,id:applicationId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NotesSection__["a" /* default */],{notes:notes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ContactInformation__["a" /* default */],{submittedBy:submittedBy}),!!family&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FamilyInfo__["a" /* default */],{family:family,user:user}),!!componentTestReports.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__["a" /* default */],{isEditable:false,sectionHeaderClassName:'scene_section-header',notEditableStateSectionHeader:'Uploaded Component-specific documents',infoMessage:'Test reports in this section are component-specific and available for this component only',files:componentTestReports,listSectionId:'individual_test_reports',httpParams:{currentId:applicationId,currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].downloadReport,fileIdFieldName:'id'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ChangeStatus__["a" /* default */],{availableActions:availableActions,applicationId:applicationId,changeStatus:changeStatus,user:user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Back',backButtonAction:this._handleBackClick})));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var applicationStatus=_ref.applicationStatus,user=_ref.user,applicationId=_ref.applicationId,loadInProgress=_ref.loadInProgress;var link='/'+user.getManufacturerCode()+'/component/application/'+applicationId+'/edit';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList(false);}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component Details'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_EditApplicationButton__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase())));});

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var description=_ref.description,type=_ref.type,category=_ref.category,id=_ref.id,componentTypeFieldValues=_ref.componentTypeFieldValues,submissionDate=_ref.submissionDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Component ID',value:id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _margin_right_30',textClassName:'text__text_primary',label:'Component Category',value:category.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Component Type',value:type.componentTypeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Submission Date',value:submissionDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).format('MM / DD / YYYY')}),componentTypeFieldValues.map(function(field,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary '+(index%2===0?'_margin_right_30':''),textClassName:'text__text_primary',key:field.componentTypeFieldId,label:field.componentTypeFieldName,value:field.componentTypeFieldValue});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Component Name',value:description}));});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes;if(!notes)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,disabled:true}));}

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContactInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
function ContactInformation(_ref){var submittedBy=_ref.submittedBy;if(!submittedBy)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Contact details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Name',value:(submittedBy.firstName||'')+' '+(submittedBy.lastName||'')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Email',value:submittedBy.email||''}));}

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeStatus=function(_React$Component){_inherits(ChangeStatus,_React$Component);function ChangeStatus(){_classCallCheck(this,ChangeStatus);return _possibleConstructorReturn(this,(ChangeStatus.__proto__||Object.getPrototypeOf(ChangeStatus)).apply(this,arguments));}_createClass(ChangeStatus,[{key:'render',value:function render(){var _props=this.props,availableActions=_props.availableActions,applicationId=_props.applicationId,changeStatus=_props.changeStatus,user=_props.user;var link='/'+user.getManufacturerCode()+'/component/application/'+applicationId+'/edit';var actions=[{key:'edit',isShown:true,Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_EditApplicationButton__["a" /* default */],{className:'_height_40 _width_pc_100 _max_width_180 _margin_right_20'}));}},{key:'approve',isShown:availableActions.includes(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].APPROVE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{label:'Approve',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:changeStatus(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].APPROVE),color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].green});}},{key:'deactivate',isShown:availableActions.includes(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DEACTIVATE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{label:'Deactivate',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:changeStatus(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DEACTIVATE),color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].red});}},{key:'incomplete',isShown:availableActions.includes(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].INCOMPLETE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{label:'Incomplete',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:changeStatus(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].INCOMPLETE),type:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].lightBlue});}},{key:'reactivate',isShown:availableActions.includes(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].REACTIVATE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{label:'Reactivate',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:changeStatus(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].REACTIVATE),type:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].green});}},{key:'submit',isShown:availableActions.includes(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].RESUBMIT),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Button__["c" /* default */],{label:'Submit',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:changeStatus(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].RESUBMIT),type:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_3_Components_Button__["a" /* buttonColor */].green});}}];if(actions.filter(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('isShown')).length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Actions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__change-status-buttons-wrapper'},actions.map(function(_ref){var key=_ref.key,isShown=_ref.isShown,Component=_ref.Component;return isShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,{key:key});})));}}]);return ChangeStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_FilePicker__ = __webpack_require__(26);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var family=_ref.family,user=_ref.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Family name',clickHandler:function clickHandler(){user.goToFamilyDetails(family.id);},value:family.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_FilePicker__["a" /* default */],{isEditable:false,sectionHeaderClassName:'scene_section-header _margin_top_20',notEditableStateSectionHeader:'Uploaded Family documents',infoMessage:'Test reports in this section are shared across the Component Family. Please edit Component Family to add / remove documents.',files:family.testReports,listSectionId:'family_test_reports',httpParams:{currentId:family.id,fileIdFieldName:'id',currentMethod:__WEBPACK_IMPORTED_MODULE_1_api_requests__["c" /* componentFamilyAPI */].downloadReport}}));});

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GeneralInformation__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Notes__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FamilyInfo__ = __webpack_require__(1073);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditApplication=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(EditApplication,_React$Component);function EditApplication(props){_classCallCheck(this,EditApplication);var _this=_possibleConstructorReturn(this,(EditApplication.__proto__||Object.getPrototypeOf(EditApplication)).call(this,props));_this.isUserCanEdit=function(){var _this$props=_this.props,user=_this$props.user,applicationStatus=_this$props.applicationStatus;return user.isInternal()||applicationStatus===__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].INCOMPLETE;};_this.handleSubmitClick=function(){var _this$state=_this.state,description=_this$state.description,componentTypeFieldValues=_this$state.componentTypeFieldValues,componentTestReports=_this$state.componentTestReports,family=_this$state.family,notes=_this$state.notes;var _this$props2=_this.props,match=_this$props2.match,updateComponentListEntry=_this$props2.updateComponentListEntry,user=_this$props2.user;var applicationId=match.params.applicationId;if(_this.someDataWasInputted){_this.validateForm().then(function(){var requestJSON={};requestJSON.description=description;requestJSON.fieldValues=componentTypeFieldValues.map(function(field){return{fieldId:field.componentTypeFieldId,value:field.componentTypeFieldValue};});requestJSON.notes=notes;requestJSON.filesIdsToDelete=_this.filesIdsToDelete;requestJSON.componentFamilyId=family?family.id:null;var data=new FormData();data.append('requestJson',JSON.stringify(requestJSON));componentTestReports.filter(function(file){return!file.created;}).forEach(function(file){return data.append('reports',file);});_this.modalBody='Are you sure you want to save changes in this Type Accepted application?';_this.modalConfirmAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].componentInfo(applicationId),data).then(function(_ref){var data=_ref.data;_this.someDataWasInputted=false;__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'Your changes were saved successfully.');updateComponentListEntry({},data);}).finally(function(){_this._closeModal();user.goToList();});});};_this._openModal();});}else{user.goToList();}};_this.validateForm=function(){var _this$state2=_this.state,componentTypeFieldValues=_this$state2.componentTypeFieldValues,componentTestReports=_this$state2.componentTestReports,family=_this$state2.family;var _this$props3=_this.props,fieldsList=_this$props3.fieldsList,applicationStatus=_this$props3.applicationStatus;var inputErrors=_this.state.inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))inputErrors[fieldName]=true;});var _loop=function _loop(key){var fieldData=fieldsList.find(function(element){return element.id===componentTypeFieldValues[key].componentTypeFieldId;});if(fieldData.required&&(isEmptyString(componentTypeFieldValues[key].componentTypeFieldValue)||isEmptyArray(componentTypeFieldValues[key].componentTypeFieldValue)||isEmptyObject(componentTypeFieldValues[key].componentTypeFieldValue))){inputErrors[key]=true;}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(componentTypeFieldValues)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;_loop(key);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return new Promise(function(resolve,reject){_this.setState({inputErrors:inputErrors},function(){if(Object.keys(_this.state.inputErrors).length){__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','Please check you information and try again.');reject();}else if(isEmptyArray(componentTestReports)&&!family&&applicationStatus!==__WEBPACK_IMPORTED_MODULE_12_constants_index__["c" /* STATUS */].DEACTIVATED&&!_this.componentHadFamily){__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','Select Family or upload at least one individual report file.');reject();}else{resolve();}});});};_this.handleRemoveFile=function(index){return function(){var componentTestReports=_this.state.componentTestReports;_this.someDataWasInputted=true;if(componentTestReports[index].created){_this.filesIdsToDelete.push(componentTestReports[index].id);}_this.setState(function(prevState){prevState.componentTestReports.splice(index,1);return{componentTestReports:prevState.componentTestReports};});};};_this.handleFileSelect=function(files){_this.someDataWasInputted=true;_this.setState(function(prevState){return{componentTestReports:[].concat(_toConsumableArray(prevState.componentTestReports),_toConsumableArray(files))};});};_this.handleAdditionalInputChange=function(index){return function(event){var _this$state3=_this.state,componentTypeFieldValues=_this$state3.componentTypeFieldValues,inputErrors=_this$state3.inputErrors;_this.someDataWasInputted=true;delete inputErrors[index];var newValue=event.target?event.target.value:event.value||event;componentTypeFieldValues[index].componentTypeFieldValue=newValue;_this.setState({componentTypeFieldValues:componentTypeFieldValues,inputErrors:inputErrors});};};_this.handleInputChange=function(name){return function(value){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;delete inputErrors[name];if(value.length>251&&name==='description'){inputErrors[name]='Description must be 250 characters max';_this.setState({inputErrors:inputErrors});}else{var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,'inputErrors',inputErrors),_this$setState));}};};_this.handleSelectFamily=function(family){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;delete inputErrors.componentTestReports;_this.setState({family:family});};_this.handleBackButtonClick=function(){var user=_this.props.user;user.goBack();};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this._closeModal();user.goTo(location);};_this._openModal();return false;}return true;};_this.state={description:props.description,notes:props.notes,family:props.family,componentTypeFieldValues:props.componentTypeFieldValues,componentTestReports:props.componentTestReports,isModalOpen:false,requestInProcess:false,inputErrors:{}};_this.filesIdsToDelete=[];_this.someDataWasInputted=false;_this.requiredFields=['description'];_this.componentHadFamily=!!_this.props.family;return _this;}_createClass(EditApplication,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.description&&this.state.description===undefined){this.componentHadFamily=!!this.props.family;this.setState({description:this.props.description,notes:this.props.notes,family:this.props.family,componentTypeFieldValues:this.props.componentTypeFieldValues,componentTestReports:this.props.componentTestReports});}}},{key:'render',value:function render(){var _state=this.state,componentTypeFieldValues=_state.componentTypeFieldValues,description=_state.description,notes=_state.notes,componentTestReports=_state.componentTestReports,family=_state.family,isModalOpen=_state.isModalOpen,inputErrors=_state.inputErrors;var _props=this.props,user=_props.user,match=_props.match,id=_props.id,componentType=_props.componentType,submissionDate=_props.submissionDate,applicationStatus=_props.applicationStatus,fieldsList=_props.fieldsList,categories=_props.categories,families=_props.families,familiesRequestInProcess=_props.familiesRequestInProcess;var applicationId=match.params.applicationId;if(this.props.requestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{user:user,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+applicationStatus.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{user:user,applicationStatus:applicationStatus}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GeneralInformation__["a" /* default */],{isUserCanEdit:this.isUserCanEdit(),componentTypeFieldValues:componentTypeFieldValues,description:description,fieldsList:fieldsList,id:id,type:componentType,category:categories.find(function(cat){return cat.id===componentType.categoryId;}),submissionDate:submissionDate,handleAdditionalInputChange:this.handleAdditionalInputChange,handleInputChange:this.handleInputChange,inputErrors:inputErrors}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Notes__["a" /* default */],{user:user,notes:notes,handleChange:this.handleInputChange('notes')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__FamilyInfo__["a" /* default */],{isEditable:componentType.allowComponentFamily,family:family,families:families,familiesRequestInProcess:familiesRequestInProcess,componentType:componentType,handleSelectFamily:this.handleSelectFamily}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__["a" /* default */],{isEditable:this.isUserCanEdit(),editableStateSectionHeader:'Upload Component-specific Test Report'+(family?'':' *'),notEditableStateSectionHeader:'Uploaded Component-specific documents',sectionHeaderClassName:'scene_section-header',infoMessage:'Test reports in this section are component-specific and available for this component only',listSectionId:'individual_test_reports',files:componentTestReports,httpParams:{currentId:applicationId,currentMethod:__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].downloadReport,fileIdFieldName:'id'},handleFileSelect:this.handleFileSelect,handleRemoveFile:this.handleRemoveFile})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_ApplicationActions__["a" /* default */],{cancelButtonLabel:'Cancel',saveButtonLabel:'Save',saveButtonAction:this.handleSubmitClick,cancelButtonAction:user.goBack}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_10_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:this.state.requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}}]);return EditApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var applicationStatus=_ref.applicationStatus,loadInProgress=_ref.loadInProgress,user=_ref.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList(false);}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Edit Component Details'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+applicationStatus.toLowerCase()},applicationStatus.toLowerCase()));});

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var requestInProcess=_ref.requestInProcess,id=_ref.id,type=_ref.type,submissionDate=_ref.submissionDate,isUserCanEdit=_ref.isUserCanEdit,description=_ref.description,componentTypeFieldValues=_ref.componentTypeFieldValues,fieldsList=_ref.fieldsList,handleAdditionalInputChange=_ref.handleAdditionalInputChange,handleInputChange=_ref.handleInputChange,category=_ref.category,inputErrors=_ref.inputErrors;function getEditableFields(){if(isUserCanEdit){return componentTypeFieldValues.map(function(field,index){return showEditableField(field,index);});}else{return componentTypeFieldValues.map(function(field,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{key:field.componentTypeFieldId,mainWrapperClassName:'text__wrapper_primary '+(index%2===0?'_margin_right_30':''),textClassName:'text__text_primary',label:field.componentTypeFieldName,value:field.componentTypeFieldValue});});}}function showEditableField(field,index){var fieldData=fieldsList.find(function(element){return element.fieldName===field.componentTypeFieldName;});if(fieldData.componentTypeFieldValues.length){var defaultItem=fieldData.componentTypeFieldValues.find(function(element){return element.value===field.componentTypeFieldValue;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{key:field.componentTypeFieldId,type:'primary',mainWrapperClassName:''+(index%2===0?'_margin_right_30':''),selectionList:fieldData.componentTypeFieldValues,defaultItem:defaultItem,itemNameIndicator:'value',error:inputErrors[index],label:''+field.componentTypeFieldName+(fieldData.required?' *':''),handleSelect:handleAdditionalInputChange(index)});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary '+(index%2===0?'_margin_right_30':''),inputClassName:'input__input-field_primary',key:field.componentTypeFieldId,label:''+field.componentTypeFieldName+(fieldData.required?' *':''),value:field.componentTypeFieldValue,error:inputErrors[index],onChange:handleAdditionalInputChange(index)});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Component ID',value:id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _margin_right_30',textClassName:'text__text_primary',label:'Component Category',value:category.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Component Type',value:type.componentTypeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Submission Date',value:submissionDate&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).format('MM / DD / YYYY')}),getEditableFields(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',inputClassName:'input__input-field_primary',label:'Component Description * (250 char. max)',value:description,onChange:handleInputChange('description'),error:inputErrors.description}));});

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes,handleChange=_ref.handleChange,user=_ref.user;if(notes||user.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes||'',handleInputChange:handleChange,disabled:!user.isInternal()}));}else{return null;}}

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Select__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditApplication=function(_React$Component){_inherits(EditApplication,_React$Component);function EditApplication(props){_classCallCheck(this,EditApplication);var _this=_possibleConstructorReturn(this,(EditApplication.__proto__||Object.getPrototypeOf(EditApplication)).call(this,props));_this.getFamilyData=function(){var family=_this.props.family;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].info(family.id)).then(function(_ref){var data=_ref.data;_this.setState({familyInfo:data,requestInProcess:false});});});};_this.state={familyInfo:'',requestInProcess:false};return _this;}_createClass(EditApplication,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.family){this.getFamilyData();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.family&&!this.state.requestInProcess&&(!this.state.familyInfo||this.props.family.id!==this.state.familyInfo.id)){this.getFamilyData();}}},{key:'render',value:function render(){var _props=this.props,isEditable=_props.isEditable,family=_props.family,families=_props.families,componentType=_props.componentType,handleSelectFamily=_props.handleSelectFamily,familiesRequestInProcess=_props.familiesRequestInProcess;var _state=this.state,familyInfo=_state.familyInfo,requestInProcess=_state.requestInProcess;if(!isEditable&&!family)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Family'),isEditable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Select__["a" /* default */],{selectionList:families.filter(function(availableFamily){return availableFamily.type.id===componentType.id;}),type:'primary',mainWrapperClassName:'_margin_right_30',itemNameIndicator:'name',label:'Select existing family',placeholder:'Select Component Family',defaultItem:family?families.find(function(availableFamily){return availableFamily.id===family.id;}):{},isLoading:familiesRequestInProcess,handleSelect:handleSelectFamily}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Family name',value:family.name}),family&&requestInProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'})),family&&!requestInProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_FilePicker__["a" /* default */],{isEditable:false,sectionHeaderClassName:'scene_section-header _margin_top_20',notEditableStateSectionHeader:'Uploaded Family documents',infoMessage:'Test reports in this section are shared across the Component Family. Please edit Component Family to add / remove documents.',listSectionId:'family_test_reports',files:familyInfo.testReports,httpParams:{currentId:familyInfo.id,fileIdFieldName:'id',currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].downloadReport}}));}}]);return EditApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Application; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__New__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Details__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Edit__ = __webpack_require__(1089);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Application=function(_React$Component){_inherits(Application,_React$Component);function Application(props){_classCallCheck(this,Application);var _this=_possibleConstructorReturn(this,(Application.__proto__||Object.getPrototypeOf(Application)).call(this,props));_this.changeStatus=function(newStatusString){var _this$state$familyInf=_this.state.familyInfo,id=_this$state$familyInf.id,name=_this$state$familyInf.name,notes=_this$state$familyInf.notes,submissionDate=_this$state$familyInf.submissionDate,type=_this$state$familyInf.type,components=_this$state$familyInf.components;var updateFamiliesListEntry=_this.props.updateFamiliesListEntry;components.forEach(function(component){return component.applicationStatus=newStatusString;});_this.setState(function(prevState){return{familyInfo:Object.assign({},prevState.familyInfo,{status:newStatusString,components:components})};},function(){updateFamiliesListEntry({},{id:id,name:name,notes:notes,status:_this.state.familyInfo.status,submissionDate:submissionDate,type:type});});};_this.updateFamilyInfo=function(data){var updateFamiliesListEntry=_this.props.updateFamiliesListEntry;_this.setState({familyInfo:Object.assign({},data)},function(){updateFamiliesListEntry({},data);});};_this.state={familyInfo:{name:'',type:{},notes:'',testReports:[],status:'',components:[]},requestInProcess:true};return _this;}_createClass(Application,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var match=this.props.match;var familyId=match.params.familyId;if(isFinite(familyId)){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["c" /* componentFamilyAPI */].info(familyId)).then(function(_ref){var data=_ref.data;_this2.setState({familyInfo:data});});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if((this.state.familyInfo.name||!isFinite(this.props.match.params.familyId))&&this.state.requestInProcess&&this.props.components&&this.props.types&&this.props.families&&this.props.categories){this.setState({requestInProcess:false});}if(prevProps.match.params.familyId!==this.props.match.params.familyId){if(isFinite(this.props.match.params.familyId)){this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["c" /* componentFamilyAPI */].info(_this3.props.match.params.familyId)).then(function(_ref2){var data=_ref2.data;_this3.setState({familyInfo:data});});});}}}},{key:'render',value:function render(){var _this4=this;var _props=this.props,match=_props.match,user=_props.user,createFamilyActionsList=_props.createFamilyActionsList,performFamilyActionFunction=_props.performFamilyActionFunction,updateFamiliesListEntry=_props.updateFamiliesListEntry,types=_props.types,categories=_props.categories,components=_props.components,componentsRequestInProcess=_props.componentsRequestInProcess;var _state=this.state,requestInProcess=_state.requestInProcess,familyInfo=_state.familyInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path.slice(0,-9)+'new',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__New__["a" /* default */],Object.assign({},_this4.state,{types:types,categories:categories,components:components,user:user,componentsRequestInProcess:componentsRequestInProcess,updateFamiliesListEntry:updateFamiliesListEntry}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+'/details',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Details__["a" /* default */],Object.assign({},_this4.state,{user:user,match:match,requestInProcess:requestInProcess,performFamilyActionFunction:performFamilyActionFunction,updateFamiliesListEntry:updateFamiliesListEntry,categories:categories,changeStatus:_this4.changeStatus,availableActions:createFamilyActionsList(familyInfo.status)}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+'/edit',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Edit__["a" /* default */],Object.assign({},_this4.state,{user:user,fieldsList:_this4.fieldsList,categories:categories,components:components,requestInProcess:requestInProcess,componentsRequestInProcess:componentsRequestInProcess,createFamilyActionsList:createFamilyActionsList,performFamilyActionFunction:performFamilyActionFunction,updateFamiliesListEntry:_this4.updateFamilyInfo}));}}));}}]);return Application;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchFileLoadList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ComponentList__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers__ = __webpack_require__(34);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BatchFileLoadList=function(_React$Component){_inherits(BatchFileLoadList,_React$Component);function BatchFileLoadList(props){_classCallCheck(this,BatchFileLoadList);var _this=_possibleConstructorReturn(this,(BatchFileLoadList.__proto__||Object.getPrototypeOf(BatchFileLoadList)).call(this,props));_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;if(!error||error.ops){var _this$setState;var newInputErrors=inputErrors;delete newInputErrors[field];_this.setState((_this$setState={},_defineProperty(_this$setState,field,value),_defineProperty(_this$setState,'inputErrors',newInputErrors),_this$setState));}};};_this.handleCategorySelect=function(selectedCategory){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;var newInputErrors=inputErrors;delete newInputErrors.selectedCategory;_this.setState({selectedCategory:selectedCategory,selectedType:'',inputErrors:newInputErrors},function(){_this.handleTypeSelect(selectedCategory.componentTypes[0]);});};_this.handleTypeSelect=function(selectedType){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;var newInputErrors=inputErrors;delete newInputErrors.selectedType;_this.setState({selectedType:selectedType,inputErrors:newInputErrors,familyComponents:[]},_this.getAvailableComponentsList);};_this.handleFileSelect=function(files){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;var newInputErrors=inputErrors;delete newInputErrors.files;_this.setState(function(prevState){return{files:[].concat(_toConsumableArray(prevState.files),_toConsumableArray(files)),inputErrors:newInputErrors};});};_this.handleRemoveFile=function(index){return function(){_this.someDataWasInputted=true;_this.setState(function(prevState){prevState.files.splice(index,1);return{files:prevState.files};});};};_this.getAvailableComponentsList=function(){var components=_this.props.components;var selectedType=_this.state.selectedType;__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["b" /* componentAPI */].listWithoutFamily).then(function(_ref){var noFamilyList=_ref.data;var availableComponentsList=components.filter(function(component){return component.componentType.id===selectedType.id;});availableComponentsList.forEach(function(component){if(!noFamilyList.find(function(componentWithNoFamily){return componentWithNoFamily.id===component.id;}))component.disabled=true;});_this.setState({availableComponentsList:availableComponentsList});});};_this.selectComponentForAdd=function(component){var availableComponentsList=_this.state.availableComponentsList;if(!component.disabled){component.checked=!component.checked;_this.setState({availableComponentsList:availableComponentsList});}};_this.togleAllComponentsForAdd=function(togleTo){return function(event){var availableComponentsList=_this.state.availableComponentsList;Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["h" /* stopPropagation */])(event);availableComponentsList.forEach(function(component){if(!component.disabled){component.checked=togleTo;}_this.setState({availableComponentsList:availableComponentsList});});};};_this.addComponents=function(){var _this$state=_this.state,availableComponentsList=_this$state.availableComponentsList,familyComponents=_this$state.familyComponents;_this.someDataWasInputted=true;var componentsToAdd=availableComponentsList.filter(function(component){return component.checked;});availableComponentsList=availableComponentsList.filter(function(component){return!component.checked;});componentsToAdd.forEach(function(component){component.checked=false;component.newlyAdded=true;_this.componentsIdsToAdd.push(component.id);});familyComponents.push.apply(familyComponents,_toConsumableArray(componentsToAdd));_this.setState({availableComponentsList:availableComponentsList,familyComponents:familyComponents});};_this.selectComponentForDeletion=function(component){return function(event){var familyComponents=_this.state.familyComponents;Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["h" /* stopPropagation */])(event);component.checked=!component.checked;_this.setState({familyComponents:familyComponents});};};_this.deleteComponents=function(){var _this$state2=_this.state,availableComponentsList=_this$state2.availableComponentsList,familyComponents=_this$state2.familyComponents;_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to remove selected components from component family?';_this.modalConfirmAction=function(){_this.someDataWasInputted=true;var componentsToDelete=familyComponents.filter(function(component){return component.checked;});familyComponents=familyComponents.filter(function(component){return!component.checked;});componentsToDelete.forEach(function(component){component.checked=false;delete component.newlyAdded;var additionListIndex=_this.componentsIdsToAdd.indexOf(component.id);_this.componentsIdsToAdd.splice(additionListIndex,1);});availableComponentsList.push.apply(availableComponentsList,_toConsumableArray(componentsToDelete));_this.setState({familyComponents:familyComponents,availableComponentsList:availableComponentsList},_this.closeModal);};_this.openModal();};_this.deleteAllComponents=function(){var _this$state3=_this.state,availableComponentsList=_this$state3.availableComponentsList,familyComponents=_this$state3.familyComponents;_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to remove selected components from component family?';_this.modalConfirmAction=function(){_this.someDataWasInputted=true;familyComponents.forEach(function(component){component.checked=false;delete component.newlyAdded;var additionListIndex=_this.componentsIdsToAdd.indexOf(component.id);_this.componentsIdsToAdd.splice(additionListIndex,1);});availableComponentsList.push.apply(availableComponentsList,_toConsumableArray(familyComponents));_this.setState({familyComponents:[],availableComponentsList:availableComponentsList},_this.closeModal);};_this.openModal();};_this.deleteSingleComponent=function(component){var _this$state4=_this.state,availableComponentsList=_this$state4.availableComponentsList,familyComponents=_this$state4.familyComponents;_this.someDataWasInputted=true;var componentIndex=familyComponents.indexOf(component);familyComponents.splice(componentIndex,1);component.checked=false;delete component.newlyAdded;var additionListIndex=_this.componentsIdsToAdd.indexOf(component.id);_this.componentsIdsToAdd.splice(additionListIndex,1);availableComponentsList.push(component);_this.setState({familyComponents:familyComponents,availableComponentsList:availableComponentsList});};_this.validateForm=function(){var user=_this.props.user;var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))newInputErrors[fieldName]=true;});return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','Please check you information and try again.');reject();}else if(isEmptyArray(_this.state.files)&&!user.isInternal()){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','At least one file needs to be uploaded.');reject();}else{resolve();}});});};_this.submitFamily=function(){var _this$props=_this.props,user=_this$props.user,updateFamiliesListEntry=_this$props.updateFamiliesListEntry;var _this$state5=_this.state,name=_this$state5.name,selectedType=_this$state5.selectedType,files=_this$state5.files;_this.validateForm().then(function(){var headers={'Content-Type':'multipart/form-data'};var requestJSON={name:name,componentTypeId:selectedType.id,componentsToAdd:_this.componentsIdsToAdd};var dataPayload=new FormData();dataPayload.append('requestJson',JSON.stringify(requestJSON));files.forEach(function(file){return dataPayload.append('reports',file);});_this.modalBody='Are you sure you want to submit this application?';_this.modalConfirmAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["c" /* componentFamilyAPI */].submit,dataPayload,{headers:headers}).then(function(_ref2){var data=_ref2.data;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your application was submitted successfully');_this.someDataWasInputted=false;updateFamiliesListEntry({},data);_this.closeModal();user.goToFamilyDetails(data.id);}).catch(function(error){_this.setState({requestInProcess:false},_this.closeModal);});});};_this.openModal();});};_this.openModal=function(){_this.setState({isModalOpen:true});};_this.closeModal=function(cb){_this.setState({isModalOpen:false},function(){if(typeof cb==='function')cb();});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalHeader='Confirmation';_this.modalBody='You have unsaved data. Are you sure you want to exit application without saving?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this.closeModal(function(){user.goTo(location);});};_this.openModal();return false;}return true;};_this.state={name:'',categories:'',selectedCategory:'',selectedType:'',listRequestInProcess:true,files:[],additionalFilterFields:[],inputErrors:{},requestInProcess:false,isModalOpen:false,familyComponents:[],availableComponentsList:[]};_this.requiredFields=['name','selectedCategory','selectedType'];_this.componentsIdsToAdd=[];_this.initialized=false;return _this;}_createClass(BatchFileLoadList,[{key:'componentDidMount',value:function componentDidMount(){if(!this.initialized)this.initializeInfo();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!this.initialized)this.initializeInfo();}},{key:'initializeInfo',value:function initializeInfo(){if(this.props.categories&&this.props.components&&!this.props.componentsRequestInProcess){var filteredCategories=this.props.categories.map(function(category){return{name:category.name,componentTypes:category.componentTypes.map(function(type){if(type.allowComponentFamily){return{componentTypeName:type.componentTypeName,id:type.id};}else{return null;}}).filter(function(type){return type;})};}).filter(function(category){return!!category.componentTypes.length;});this.initialized=true;this.setState({categories:filteredCategories,selectedCategory:filteredCategories[0],selectedType:filteredCategories[0].componentTypes[0]},this.getAvailableComponentsList);}}},{key:'render',value:function render(){var _props=this.props,user=_props.user,componentsRequestInProcess=_props.componentsRequestInProcess;var _state=this.state,categories=_state.categories,selectedCategory=_state.selectedCategory,selectedType=_state.selectedType,files=_state.files,inputErrors=_state.inputErrors,name=_state.name,requestInProcess=_state.requestInProcess,isModalOpen=_state.isModalOpen,familyComponents=_state.familyComponents,availableComponentsList=_state.availableComponentsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'New Component Family')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section scene_section_two-columns_uneven'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["a" /* Input */],{mainWrapperClassName:'_width_pc_100',styleClass:__WEBPACK_IMPORTED_MODULE_5_Components_Input__["c" /* inputStyleClasses */].primary,label:'Component Family Name *',maxLength:250,alwaysTextField:true,error:inputErrors.name,value:name,onChange:this.handleInputChange('name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:categories||[],type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].primary,defaultItem:selectedCategory,label:'Component Category *',itemNameIndicator:'name',unclearable:true,isLoading:!categories,error:inputErrors.selectedCategory,handleSelect:this.handleCategorySelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{selectionList:selectedCategory?selectedCategory.componentTypes:[],type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].primary,defaultItem:selectedType,label:'Component Type *',itemNameIndicator:'componentTypeName',unclearable:true,disabled:!selectedCategory,error:inputErrors.selectedType,handleSelect:this.handleTypeSelect})),selectedType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ComponentList__["a" /* default */],{familyComponents:familyComponents,user:user,components:availableComponentsList||[],selectComponentForAdd:this.selectComponentForAdd,togleAllComponentsForAdd:this.togleAllComponentsForAdd,addComponents:this.addComponents,selectComponentForDeletion:this.selectComponentForDeletion,componentsRequestInProcess:componentsRequestInProcess,deleteComponents:this.deleteComponents,deleteAllComponents:this.deleteAllComponents,deleteSingleComponent:this.deleteSingleComponent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__["a" /* default */],{files:files,editableStateSectionHeader:'Upload Test Report '+(user.isInternal()?'':'*'),sectionHeaderClassName:'scene_section-header',handleFileSelect:this.handleFileSelect,error:inputErrors.files?'  Upload at least one file':'',handleRemoveFile:this.handleRemoveFile}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{cancelButtonLabel:'Cancel',saveButtonLabel:'Submit',saveButtonAction:this.submitFamily,cancelButtonAction:function cancelButtonAction(){user.goToList(false);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Modal__["a" /* default */],{isOpen:isModalOpen},this.modalHeader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},this.modalHeader),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},typeof this.modalBody==='function'?this.modalBody():this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_6_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_6_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}]);return BatchFileLoadList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Row__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableHeader__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentList=function(_React$Component){_inherits(ComponentList,_React$Component);function ComponentList(props){_classCallCheck(this,ComponentList);var _this=_possibleConstructorReturn(this,(ComponentList.__proto__||Object.getPrototypeOf(ComponentList)).call(this,props));_this._handleActivePageChange=function(activePage){_this.setState({activePage:activePage});};_this._sortList=function(a,b){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortAsc=_this$state.sortAsc;switch(sortedBy){case'id':return+a.id>+b.id?sortAsc:-sortAsc;default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:prevState.sortedBy===sortedBy?-prevState.sortAsc:1,activePage:1};});};};_this.handleSearchStringInput=function(value){_this.setState({searchString:value,activePage:1});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var filter=_this.state.filter;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;if(newFilterFieldValue==='All')delete filter[filterFieldName];else filter[filterFieldName]=newFilterFieldValue;_this.setState({filter:filter,activePage:1});};};_this._getList=function(){var _this$state2=_this.state,activePage=_this$state2.activePage,selectedRowsCount=_this$state2.selectedRowsCount,sortedBy=_this$state2.sortedBy;var _this$props=_this.props,familyComponents=_this$props.familyComponents,user=_this$props.user,selectComponentForDeletion=_this$props.selectComponentForDeletion,deleteSingleComponent=_this$props.deleteSingleComponent;var resultList=[].concat(_toConsumableArray(familyComponents.sort(_this._sortList)));var resultLength=resultList.length;var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:resultList.length;resultList=resultList.slice(sliceFrom,sliceTo).map(function(component){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Row__["a" /* default */],{key:component.id,user:user,sortedBy:sortedBy,component:component,selectComponentForDeletion:selectComponentForDeletion,deleteSingleComponent:deleteSingleComponent});});return{resultList:resultList,resultLength:resultLength};};_this.state={activePage:1,selectedRowsCount:10,sortedBy:'id',sortAsc:-1,filter:{},searchString:''};return _this;}_createClass(ComponentList,[{key:'render',value:function render(){var _props=this.props,components=_props.components,familyComponents=_props.familyComponents,selectComponentForAdd=_props.selectComponentForAdd,togleAllComponentsForAdd=_props.togleAllComponentsForAdd,addComponents=_props.addComponents,deleteComponents=_props.deleteComponents,deleteAllComponents=_props.deleteAllComponents,componentsRequestInProcess=_props.componentsRequestInProcess;var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;var selectedToDeleteAmount=familyComponents.filter(function(component){return component.checked;}).length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label _margin_bottom_0 _line-height_normal'},'You are allowed to add components once to only one Component Family. If you want to add the component to a different Component Family, you have to delete it from the family it belongs.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100 _flex _flex_nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_flex _jc_end'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].primarySmall,multiSelect:true,withCheckBoxes:true,selectionList:components,itemNameIndicator:['id','description'],handleSelect:selectComponentForAdd,placeholder:'Search/Select Component by ID or Name',mainWrapperClassName:'_width_pc_100',dropDownClassName:'_max_height_201',selectAll:togleAllComponentsForAdd(true),unselectAll:togleAllComponentsForAdd(false),isLoading:!components.length&&componentsRequestInProcess,disabledInfoText:'Component is already added to another component family'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'+ Add Selected',buttonClassName:'button__small button__small_square _margin_top_22 _margin_left_10',color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].gray,onClick:addComponents})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__delimiter_horisontal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100 _flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Remove all',buttonClassName:'button__small button__small_square',color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].red,onClick:deleteAllComponents}),!!selectedToDeleteAmount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Remove  Selected ('+selectedToDeleteAmount+')',buttonClassName:'button__small button__small_square _margin_left_10 _width_110',color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].gray,onClick:deleteComponents})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy,familyComponents:familyComponents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper'},resultList),familyComponents.length>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer _jc_center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount})));}}]);return ComponentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getComponentReadableStatus=function(){var component=_this.props.component;if(component&&component.applicationStatus){return component.applicationStatus[0].toUpperCase()+component.applicationStatus.slice(1).toLowerCase();}return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,component=_props.component,selectComponentForDeletion=_props.selectComponentForDeletion,deleteSingleComponent=_props.deleteSingleComponent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentListRowID'+component.id,className:'list__row list__row_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(component.checked?'__checkbox_checked':'__checkbox_empty')+' _cursor_pointer',onClick:selectComponentForDeletion(component)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentIDField',className:'list__row-item list__row-item_small '+this._getTextColourStyle('id')+' _width_pc_12'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentDescriptionField',className:'list__row-item list__row-item_small '+this._getTextColourStyle('description')+' list__row-item_place-filler'},component.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentStatusField',className:'list__status-label_small list__status-label_'+component.applicationStatus.toLowerCase()+' '+this._getTextColourStyle('applicationStatus')},this._getComponentReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__remove-icon',onClick:function onClick(){deleteSingleComponent(component);}})));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy,deleteComponents=_ref.deleteComponents,familyComponents=_ref.familyComponents,deleteAllComponents=_ref.deleteAllComponents;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small _margin_top_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('id')+' _width_pc_12',onClick:handleSortClick('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('description')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('description')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('applicationStatus')+' _width_pc_18',onClick:handleSortClick('applicationStatus')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_12 _cursor_pointer',onClick:deleteAllComponents},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Remove')));});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeneralInformation__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotesSection__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChangeStatus__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContactInformation__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ComponentList__ = __webpack_require__(1085);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailsApplication=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DetailsApplication);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call.apply(_ref,[this].concat(args))),_this),_this._handleBackClick=function(){var user=_this.props.user;user.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailsApplication,[{key:'render',value:function render(){var _props=this.props,user=_props.user,match=_props.match,availableActions=_props.availableActions,performFamilyActionFunction=_props.performFamilyActionFunction,changeStatus=_props.changeStatus,requestInProcess=_props.requestInProcess,categories=_props.categories;var _props$familyInfo=this.props.familyInfo,name=_props$familyInfo.name,type=_props$familyInfo.type,components=_props$familyInfo.components,notes=_props$familyInfo.notes,testReports=_props$familyInfo.testReports,status=_props$familyInfo.status,submittedBy=_props$familyInfo.submittedBy;var familyId=match.params.familyId;if(requestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{user:user,familyId:familyId,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+status.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{status:status,familyId:familyId,user:user,performFamilyActionFunction:performFamilyActionFunction,type:type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GeneralInformation__["a" /* default */],{type:type,category:categories?categories.find(function(cat){return cat.id===type.categoryId;}):'',name:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ComponentList__["a" /* default */],{components:components,user:user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NotesSection__["a" /* default */],{notes:notes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ContactInformation__["a" /* default */],{submittedBy:submittedBy}),!!testReports.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__["a" /* default */],{isEditable:false,files:testReports,httpParams:{currentId:familyId,fileIdFieldName:'id',currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].downloadReport}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ChangeStatus__["a" /* default */],{familyId:familyId,availableActions:availableActions,performFamilyActionFunction:performFamilyActionFunction,changeStatus:changeStatus}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Back',backButtonAction:this._handleBackClick})));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status,user=_ref.user,familyId=_ref.familyId,loadInProgress=_ref.loadInProgress,type=_ref.type,performFamilyActionFunction=_ref.performFamilyActionFunction;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToFamilyList(false);}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,type?type.componentTypeName:'',' Component Family'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_EditApplicationButton__["a" /* default */],{onClick:function onClick(){return performFamilyActionFunction(__WEBPACK_IMPORTED_MODULE_1_constants_index_js__["a" /* ACTION */].EDIT,familyId);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+status.toLowerCase()},status.toLowerCase().replace('_',' '))));});

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var type=_ref.type,category=_ref.category,name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Component Family Name',value:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _margin_right_30',textClassName:'text__text_primary',label:'Component Category',value:category?category.name:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Component Type',value:type.componentTypeName}));});

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes;if(!notes)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component Family notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,disabled:true}));}

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeStatus=function(_React$Component){_inherits(ChangeStatus,_React$Component);function ChangeStatus(){_classCallCheck(this,ChangeStatus);return _possibleConstructorReturn(this,(ChangeStatus.__proto__||Object.getPrototypeOf(ChangeStatus)).apply(this,arguments));}_createClass(ChangeStatus,[{key:'render',value:function render(){var _props=this.props,familyId=_props.familyId,availableActions=_props.availableActions,performFamilyActionFunction=_props.performFamilyActionFunction,changeStatus=_props.changeStatus;if(!availableActions.includes(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].APPROVE))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Actions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__change-status-buttons-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{className:'_height_40 _width_pc_100 _max_width_180 _margin_right_20',onClick:function onClick(){return performFamilyActionFunction(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].EDIT,familyId);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Approve',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:function onClick(){performFamilyActionFunction(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].APPROVE,familyId).then(function(updatedData){return changeStatus(updatedData);});},type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green})));}}]);return ChangeStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContactInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
function ContactInformation(_ref){var submittedBy=_ref.submittedBy;if(!submittedBy)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Contact details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Name',value:(submittedBy.firstName||'')+' '+(submittedBy.lastName||'')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Email',value:submittedBy.email||''}));}

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Row__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltersSection__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableHeader__ = __webpack_require__(1088);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['id','description'];var ComponentList=function(_React$Component){_inherits(ComponentList,_React$Component);function ComponentList(props){_classCallCheck(this,ComponentList);var _this=_possibleConstructorReturn(this,(ComponentList.__proto__||Object.getPrototypeOf(ComponentList)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,sortedBy:'id',sortAsc:-1,filter:{},searchString:''};_this._handleActivePageChange=function(activePage){_this.setState({activePage:activePage});};_this._sortList=function(a,b){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortAsc=_this$state.sortAsc;switch(sortedBy){case'id':return+a.id>+b.id?sortAsc:-sortAsc;default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:prevState.sortedBy===sortedBy?-prevState.sortAsc:1,activePage:1};});};};_this._filterList=function(componentList){var _this$state2=_this.state,filter=_this$state2.filter,searchString=_this$state2.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return componentList.filter(function(element){for(var filterFieldName in filter){if(element[filterFieldName].toLowerCase()!==filter[filterFieldName].toLowerCase()){return false;}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this.handleSearchStringInput=function(value){_this.setState({searchString:value,activePage:1});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var filter=_this.state.filter;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;if(newFilterFieldValue==='All')delete filter[filterFieldName];else filter[filterFieldName]=newFilterFieldValue;_this.setState({filter:filter,activePage:1});};};_this._getList=function(){var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var _this$props=_this.props,user=_this$props.user,components=_this$props.components;var resultList=[];var resultLength=0;var filteredList=_this._filterList(components).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_EmptyList__["a" /* default */],{key:'empty'},'No components found with selected filters.')];}else{resultLength=filteredList.length;resultList=filteredList.slice(sliceFrom,sliceTo).map(function(component,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Row__["a" /* default */],{key:component.id,user:user,sortedBy:sortedBy,component:component});});}return{resultList:resultList,resultLength:resultLength};};_this.state={activePage:1,selectedRowsCount:10,sortedBy:'id',sortAsc:-1,filter:{},searchString:''};return _this;}_createClass(ComponentList,[{key:'render',value:function render(){var components=this.props.components;if(!components.length)return null;var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,filter=_state.filter,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,searchString=_state.searchString;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltersSection__["a" /* default */],{handleSelectFilter:this.handleSelectFilter,filterState:filter,searchString:searchString,handleSearchStringInput:this.handleSearchStringInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper'},resultList),components.length>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer _jc_center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount})));}}]);return ComponentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getComponentReadableStatus=function(){var component=_this.props.component;if(component&&component.applicationStatus){return component.applicationStatus[0].toUpperCase()+component.applicationStatus.slice(1).toLowerCase();}return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,component=_props.component,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentListRowID'+component.id,className:'list__row list__row_small list__row_selectable',onClick:function onClick(){user.goTo('/'+user.getManufacturerCode()+'/component/application/'+component.id+'/details');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentIDField',className:'list__row-item list__row-item_small '+this._getTextColourStyle('id')+' _width_pc_12'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentDescriptionField',className:'list__row-item list__row-item_small '+this._getTextColourStyle('description')+' list__row-item_place-filler'},component.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentStatusField',className:'list__status-label_small list__status-label_'+component.applicationStatus.toLowerCase()+' '+this._getTextColourStyle('applicationStatus')},this._getComponentReadableStatus())));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FiltersSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var statuses=['All','Approved','Incomplete','Deactivated','Pending'];var FiltersSection=function(_React$Component){_inherits(FiltersSection,_React$Component);function FiltersSection(){_classCallCheck(this,FiltersSection);return _possibleConstructorReturn(this,(FiltersSection.__proto__||Object.getPrototypeOf(FiltersSection)).apply(this,arguments));}_createClass(FiltersSection,[{key:'render',value:function render(){var _props=this.props,handleSelectFilter=_props.handleSelectFilter,filterState=_props.filterState,searchString=_props.searchString,handleSearchStringInput=_props.handleSearchStringInput;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list__utility-section  _margin_bottom_20 _margin_top_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{mainWrapperClassName:'_width_450 _height_20 _margin_top_10',styleClass:__WEBPACK_IMPORTED_MODULE_2_Components_Input__["c" /* inputStyleClasses */].searchBarSmall,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:handleSearchStringInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Status',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,withoutSearch:true,defaultItem:filterState.applicationStatus,placeholder:'All',selectionList:statuses,handleSelect:handleSelectFilter('applicationStatus')})));}}]);return FiltersSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('id')+' _width_pc_12',onClick:handleSortClick('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('description')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('description')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('applicationStatus')+' _width_pc_12',onClick:handleSortClick('applicationStatus')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})));});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GeneralInformation__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotesSection__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ComponentList__ = __webpack_require__(1093);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var DetailsApplication=Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(DetailsApplication,_React$Component);function DetailsApplication(props){_classCallCheck(this,DetailsApplication);var _this=_possibleConstructorReturn(this,(DetailsApplication.__proto__||Object.getPrototypeOf(DetailsApplication)).call(this,props));_this.handleInputChange=function(field){return function(value,error){var inputErrors=_this.state.inputErrors;_this.someDataWasInputted=true;if(!error||error.ops){var _this$setState;var newInputErrors=inputErrors;delete newInputErrors[field];_this.setState((_this$setState={},_defineProperty(_this$setState,field,value),_defineProperty(_this$setState,'inputErrors',newInputErrors),_this$setState));}};};_this.handleFileSelect=function(files){_this.someDataWasInputted=true;_this.setState(function(prevState){return{testReports:[].concat(_toConsumableArray(prevState.testReports),_toConsumableArray(files))};});};_this.handleRemoveFile=function(index){return function(){var testReports=_this.state.testReports;_this.someDataWasInputted=true;if(testReports[index].created){_this.fileIdsToDelete.push(testReports[index].id);}testReports.splice(index,1);_this.setState({testReports:testReports});};};_this.getAvailableComponentsList=function(){var components=_this.props.components;var selectedType=_this.state.selectedType;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].listWithoutFamily).then(function(_ref){var noFamilyList=_ref.data;var availableComponentsList=components.filter(function(component){return component.componentType.id===selectedType.id;});availableComponentsList.forEach(function(component){if(!noFamilyList.find(function(componentWithNoFamily){return componentWithNoFamily.id===component.id;}))component.disabled=true;});_this.setState({availableComponentsList:availableComponentsList});});};_this.getAvailableComponentsList=function(){var components=_this.props.components;var type=_this.props.familyInfo.type;var familyComponents=_this.state.familyComponents;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].listWithoutFamily).then(function(_ref2){var noFamilyList=_ref2.data;var availableComponentsList=components.filter(function(component){var componentAvailable=component.componentType.id===type.id;if(componentAvailable){componentAvailable=!familyComponents.find(function(alreadyAddedComponent){return alreadyAddedComponent.id===component.id;});}return componentAvailable;});availableComponentsList.forEach(function(component){if(!noFamilyList.find(function(componentWithNoFamily){return componentWithNoFamily.id===component.id;}))component.disabled=true;});_this.setState({availableComponentsList:availableComponentsList});});};_this.selectComponentForAdd=function(component){var availableComponentsList=_this.state.availableComponentsList;if(!component.disabled){component.checked=!component.checked;_this.setState({availableComponentsList:availableComponentsList});}};_this.togleAllComponentsForAdd=function(togleTo){return function(event){var availableComponentsList=_this.state.availableComponentsList;Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["h" /* stopPropagation */])(event);availableComponentsList.forEach(function(component){if(!component.disabled){component.checked=togleTo;}_this.setState({availableComponentsList:availableComponentsList});});};};_this.addComponents=function(){var _this$state=_this.state,availableComponentsList=_this$state.availableComponentsList,familyComponents=_this$state.familyComponents;_this.someDataWasInputted=true;var componentsToAdd=availableComponentsList.filter(function(component){return component.checked;});availableComponentsList=availableComponentsList.filter(function(component){return!component.checked;});componentsToAdd.forEach(function(component){component.checked=false;component.newlyAdded=true;var deletionListIndex=_this.componentsIdsToDelete.indexOf(component.id);if(deletionListIndex!==-1){_this.componentsIdsToDelete.splice(deletionListIndex,1);}else{_this.componentsIdsToAdd.push(component.id);}});familyComponents.push.apply(familyComponents,_toConsumableArray(componentsToAdd));_this.setState({availableComponentsList:availableComponentsList,familyComponents:familyComponents});};_this.selectComponentForDeletion=function(component){return function(event){var familyComponents=_this.state.familyComponents;Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["h" /* stopPropagation */])(event);component.checked=!component.checked;_this.setState({familyComponents:familyComponents});};};_this.deleteComponents=function(){var _this$state2=_this.state,availableComponentsList=_this$state2.availableComponentsList,familyComponents=_this$state2.familyComponents;_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to remove selected components from component family?';_this.modalConfirmAction=function(){_this.someDataWasInputted=true;var componentsToDelete=familyComponents.filter(function(component){return component.checked;});familyComponents=familyComponents.filter(function(component){return!component.checked;});componentsToDelete.forEach(function(component){component.checked=false;delete component.newlyAdded;var additionListIndex=_this.componentsIdsToAdd.indexOf(component.id);if(additionListIndex!==-1){_this.componentsIdsToAdd.splice(additionListIndex,1);}else{_this.componentsIdsToDelete.push(component.id);}});availableComponentsList.push.apply(availableComponentsList,_toConsumableArray(componentsToDelete));_this.setState({familyComponents:familyComponents,availableComponentsList:availableComponentsList},_this.closeModal);};_this.openModal();};_this.deleteAllComponents=function(){var _this$state3=_this.state,availableComponentsList=_this$state3.availableComponentsList,familyComponents=_this$state3.familyComponents;if(familyComponents.length){_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to remove selected components from component family?';_this.modalConfirmAction=function(){_this.someDataWasInputted=true;familyComponents.forEach(function(component){component.checked=false;delete component.newlyAdded;var additionListIndex=_this.componentsIdsToAdd.indexOf(component.id);if(additionListIndex!==-1){_this.componentsIdsToAdd.splice(additionListIndex,1);}else{_this.componentsIdsToDelete.push(component.id);}});availableComponentsList.push.apply(availableComponentsList,_toConsumableArray(familyComponents));_this.setState({familyComponents:[],availableComponentsList:availableComponentsList},_this.closeModal);};_this.openModal();}};_this.deleteSingleComponent=function(component){var _this$state4=_this.state,availableComponentsList=_this$state4.availableComponentsList,familyComponents=_this$state4.familyComponents;_this.someDataWasInputted=true;var componentIndex=familyComponents.indexOf(component);familyComponents.splice(componentIndex,1);component.checked=false;delete component.newlyAdded;var additionListIndex=_this.componentsIdsToAdd.indexOf(component.id);if(additionListIndex!==-1){_this.componentsIdsToAdd.splice(additionListIndex,1);}else{_this.componentsIdsToDelete.push(component.id);}availableComponentsList.push(component);_this.setState({familyComponents:familyComponents,availableComponentsList:availableComponentsList});};_this._handleBackClick=function(){var user=_this.props.user;user.goBack();};_this.validateForm=function(){var user=_this.props.user;var inputErrors=_this.state.inputErrors;var newInputErrors=inputErrors;var isEmptyArray=function isEmptyArray(object){return object.length!==undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!object.length;};var isEmptyString=function isEmptyString(object){return!object.length&&typeof object==='string'&&!object.length;};var isEmptyObject=function isEmptyObject(object){return object.length===undefined&&(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&!Object.keys(object).length;};_this.requiredFields.forEach(function(fieldName){if(isEmptyString(_this.state[fieldName])||isEmptyArray(_this.state[fieldName])||isEmptyObject(_this.state[fieldName]))newInputErrors[fieldName]=true;});return new Promise(function(resolve,reject){_this.setState({inputErrors:newInputErrors},function(){if(Object.keys(_this.state.inputErrors).length){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','Please check you information and try again.');reject();}else if(isEmptyArray(_this.state.testReports)&&!user.isInternal()){__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].error('note','Cannot submit the application.','At least one file needs to be uploaded.');reject();}else{resolve();}});});};_this.updateFamily=function(){var _this$props=_this.props,user=_this$props.user,familyInfo=_this$props.familyInfo,updateFamiliesListEntry=_this$props.updateFamiliesListEntry;var _this$state5=_this.state,name=_this$state5.name,notes=_this$state5.notes,testReports=_this$state5.testReports;if(_this.someDataWasInputted){_this.validateForm().then(function(){var headers={'Content-Type':'multipart/form-data'};var requestJSON={name:name,fileIdsToDelete:_this.fileIdsToDelete,notes:notes,componentsToAdd:_this.componentsIdsToAdd,componentsToDelete:_this.componentsIdsToDelete};var dataPayload=new FormData();dataPayload.append('requestJson',JSON.stringify(requestJSON));testReports.forEach(function(file){if(!file.created)dataPayload.append('reports',file);});_this.modalBody='Are you sure you want to save this Component Family?';_this.modalConfirmAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].info(familyInfo.id),dataPayload,{headers:headers}).then(function(_ref3){var data=_ref3.data;__WEBPACK_IMPORTED_MODULE_10_dom_managers_notification__["a" /* default */].success(1,'Changes successfully submitted');_this.someDataWasInputted=false;updateFamiliesListEntry(data);_this.closeModal();user.goToFamilyDetails(familyInfo.id);}).catch(function(error){_this.setState({requestInProcess:false},_this.closeModal);});});};_this.openModal();});}else{user.goToFamilyDetails(familyInfo.id);}};_this.openModal=function(){_this.setState({isModalOpen:true});};_this.closeModal=function(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};_this.setState({isModalOpen:false,requestInProcess:false},function(){if(typeof cb==='function')cb();});};_this.blockUnconfirmedTransition=function(location){var user=_this.props.user;if(_this.someDataWasInputted){_this.modalHeader='Confirmation';_this.modalBody='Are you sure you want to cancel changes that you made to this Component Family?';_this.modalConfirmAction=function(){_this.someDataWasInputted=false;_this.closeModal(function(){user.goTo(location);});};_this.openModal();return false;}return true;};_this.state={name:props.familyInfo.name,notes:props.familyInfo.notes,testReports:props.familyInfo.testReports||[],familyComponents:props.familyInfo.components?[].concat(_toConsumableArray(props.familyInfo.components)):[],inputErrors:{},requestInProcess:false,isModalOpen:false,availableComponentsList:''};_this.componentsIdsToAdd=[];_this.componentsIdsToDelete=[];_this.fileIdsToDelete=[];_this.someDataWasInputted=false;_this.requiredFields=['name'];return _this;}_createClass(DetailsApplication,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.requestInProcess&&this.props.familyInfo.name&&!this.state.availableComponentsList){this.getAvailableComponentsList();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(!prevProps.familyInfo.name&&this.props.familyInfo.name){this.setState({name:this.props.familyInfo.name,notes:this.props.familyInfo.notes,testReports:this.props.familyInfo.testReports,familyComponents:[].concat(_toConsumableArray(this.props.familyInfo.components))},function(){_this2.someDataWasInputted=false;});}if(!this.props.requestInProcess&&this.props.familyInfo.name&&!this.state.availableComponentsList||!prevProps.components.length&&this.props.components.length){this.getAvailableComponentsList();}}},{key:'render',value:function render(){var _props=this.props,user=_props.user,match=_props.match,familyDataRequestInProcess=_props.requestInProcess,categories=_props.categories,componentsRequestInProcess=_props.componentsRequestInProcess;var _props$familyInfo=this.props.familyInfo,type=_props$familyInfo.type,status=_props$familyInfo.status;var _state=this.state,name=_state.name,notes=_state.notes,testReports=_state.testReports,familyComponents=_state.familyComponents,inputErrors=_state.inputErrors,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess,availableComponentsList=_state.availableComponentsList;var familyId=match.params.familyId;if(familyDataRequestInProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */],{user:user,familyId:familyId,loadInProgress:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _width_pc_100 _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image'}))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+status.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */],{status:status,familyId:familyId,user:user,type:type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__GeneralInformation__["a" /* default */],{type:type,category:categories.find(function(cat){return cat.id===type.categoryId;}),name:name,inputErrors:inputErrors,handleInputChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ComponentList__["a" /* default */],{familyComponents:familyComponents,user:user,components:availableComponentsList||[],selectComponentForAdd:this.selectComponentForAdd,togleAllComponentsForAdd:this.togleAllComponentsForAdd,addComponents:this.addComponents,selectComponentForDeletion:this.selectComponentForDeletion,deleteComponents:this.deleteComponents,deleteAllComponents:this.deleteAllComponents,componentsRequestInProcess:componentsRequestInProcess,deleteSingleComponent:this.deleteSingleComponent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NotesSection__["a" /* default */],{notes:notes,handleInputChange:this.handleInputChange,disabled:!user.isInternal()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_FilePicker__["a" /* default */],{files:testReports,editableStateSectionHeader:'Upload Test Report '+(user.isInternal()?'':'*'),sectionHeaderClassName:'scene_section-header',doNotRemoveFiles:!user.isInternal(),handleRemoveFile:this.handleRemoveFile,handleFileSelect:this.handleFileSelect,httpParams:{currentId:familyId,fileIdFieldName:'id',currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["c" /* componentFamilyAPI */].downloadReport}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{cancelButtonLabel:'Cancel',saveButtonLabel:'Save',saveButtonAction:this.updateFamily,cancelButtonAction:this._handleBackClick})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Modal__["a" /* default */],{isOpen:isModalOpen},this.modalHeader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},this.modalHeader),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},typeof this.modalBody==='function'?this.modalBody():this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_12_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_12_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}));}}}]);return DetailsApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status,user=_ref.user,applicationId=_ref.applicationId,loadInProgress=_ref.loadInProgress,type=_ref.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToFamilyList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,type?type.componentTypeName:'',' Component Family'),!loadInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+status.toLowerCase()},status.toLowerCase().replace('_',' ')));});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Input__ = __webpack_require__(14);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var type=_ref.type,category=_ref.category,name=_ref.name,inputErrors=_ref.inputErrors,handleInputChange=_ref.handleInputChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{mainWrapperClassName:'_width_pc_100',styleClass:__WEBPACK_IMPORTED_MODULE_2_Components_Input__["c" /* inputStyleClasses */].primary,label:'Component Family Name *',maxLength:250,alwaysTextField:true,error:inputErrors.name,value:name,onChange:handleInputChange('name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _margin_right_30',textClassName:'text__text_primary',label:'Component Category',value:category.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Component Type',value:type.componentTypeName}));});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes,handleInputChange=_ref.handleInputChange,disabled=_ref.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component Family notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,handleInputChange:handleInputChange('notes'),disabled:disabled}));}

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Row__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableHeader__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentList=function(_React$Component){_inherits(ComponentList,_React$Component);function ComponentList(props){_classCallCheck(this,ComponentList);var _this=_possibleConstructorReturn(this,(ComponentList.__proto__||Object.getPrototypeOf(ComponentList)).call(this,props));_this._handleActivePageChange=function(activePage){_this.setState({activePage:activePage});};_this._sortList=function(a,b){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortAsc=_this$state.sortAsc;switch(sortedBy){case'id':return+a.id>+b.id?sortAsc:-sortAsc;default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:prevState.sortedBy===sortedBy?-prevState.sortAsc:1,activePage:1};});};};_this.handleSearchStringInput=function(value){_this.setState({searchString:value,activePage:1});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var filter=_this.state.filter;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;if(newFilterFieldValue==='All')delete filter[filterFieldName];else filter[filterFieldName]=newFilterFieldValue;_this.setState({filter:filter,activePage:1});};};_this._getList=function(){var _this$state2=_this.state,activePage=_this$state2.activePage,selectedRowsCount=_this$state2.selectedRowsCount,sortedBy=_this$state2.sortedBy;var _this$props=_this.props,familyComponents=_this$props.familyComponents,user=_this$props.user,selectComponentForDeletion=_this$props.selectComponentForDeletion,deleteSingleComponent=_this$props.deleteSingleComponent;var resultList=[].concat(_toConsumableArray(familyComponents.sort(_this._sortList)));var resultLength=resultList.length;var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:resultList.length;resultList=resultList.slice(sliceFrom,sliceTo).map(function(component){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Row__["a" /* default */],{key:component.id,user:user,sortedBy:sortedBy,component:component,selectComponentForDeletion:selectComponentForDeletion,deleteSingleComponent:deleteSingleComponent});});return{resultList:resultList,resultLength:resultLength};};_this.state={activePage:1,selectedRowsCount:10,sortedBy:'id',sortAsc:-1,filter:{},searchString:''};return _this;}_createClass(ComponentList,[{key:'render',value:function render(){var _props=this.props,components=_props.components,familyComponents=_props.familyComponents,selectComponentForAdd=_props.selectComponentForAdd,togleAllComponentsForAdd=_props.togleAllComponentsForAdd,addComponents=_props.addComponents,deleteComponents=_props.deleteComponents,deleteAllComponents=_props.deleteAllComponents,componentsRequestInProcess=_props.componentsRequestInProcess;var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;var selectedToDeleteAmount=familyComponents.filter(function(component){return component.checked;}).length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Component List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label _margin_bottom_0 _line-height_normal'},'You are allowed to add components once to only one Component Family. If you want to add the component to a different Component Family, you have to delete it from the family it belongs.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100 _flex _flex_nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_flex _jc_end'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].primarySmall,multiSelect:true,withCheckBoxes:true,selectionList:components,itemNameIndicator:['id','description'],handleSelect:selectComponentForAdd,placeholder:'Search/Select Component by ID or Name',mainWrapperClassName:'_width_pc_100',dropDownClassName:'_max_height_201',selectAll:togleAllComponentsForAdd(true),unselectAll:togleAllComponentsForAdd(false),isLoading:!components.length&&componentsRequestInProcess,disabledInfoText:'Component is already added to another component family'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'+ Add Selected',buttonClassName:'button__small button__small_square _margin_top_22 _margin_left_10',color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].gray,onClick:addComponents})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__delimiter_horisontal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100 _flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Remove all',buttonClassName:'button__small button__small_square',color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].red,onClick:deleteAllComponents}),!!selectedToDeleteAmount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Button__["c" /* default */],{label:'Remove  Selected ('+selectedToDeleteAmount+')',buttonClassName:'button__small button__small_square _margin_left_10 _width_110',color:__WEBPACK_IMPORTED_MODULE_5_Components_Button__["a" /* buttonColor */].gray,onClick:deleteComponents})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy,familyComponents:familyComponents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__wrapper'},resultList),familyComponents.length>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer _jc_center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount})));}}]);return ComponentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getComponentReadableStatus=function(){var component=_this.props.component;if(component&&component.applicationStatus){return component.applicationStatus[0].toUpperCase()+component.applicationStatus.slice(1).toLowerCase();}return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,component=_props.component,selectComponentForDeletion=_props.selectComponentForDeletion,deleteSingleComponent=_props.deleteSingleComponent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentListRowID'+component.id,className:'list__row list__row_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small list__row-item_component _width_pc_8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(component.checked?'__checkbox_checked':'__checkbox_empty')+' _cursor_pointer',onClick:selectComponentForDeletion(component)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentIDField',className:'list__row-item list__row-item_small '+this._getTextColourStyle('id')+' _width_pc_12'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentDescriptionField',className:'list__row-item list__row-item_small '+this._getTextColourStyle('description')+' list__row-item_place-filler'},component.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentStatusField',className:'list__status-label_small list__status-label_'+component.applicationStatus.toLowerCase()+' '+this._getTextColourStyle('applicationStatus')},this._getComponentReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row-item list__row-item_small _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__remove-icon',onClick:function onClick(){deleteSingleComponent(component);}})));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy,deleteComponents=_ref.deleteComponents,familyComponents=_ref.familyComponents,deleteAllComponents=_ref.deleteAllComponents;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__row list__header list__header_small _margin_top_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('id')+' _width_pc_12',onClick:handleSortClick('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('description')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('description')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('applicationStatus')+' _width_pc_18',onClick:handleSortClick('applicationStatus')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_12 _cursor_pointer',onClick:deleteAllComponents},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Remove')));});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FamiliesList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Row__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltersSection__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableHeader__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['name','type'];var FamiliesList=function(_React$Component){_inherits(FamiliesList,_React$Component);function FamiliesList(props){_classCallCheck(this,FamiliesList);var _this=_possibleConstructorReturn(this,(FamiliesList.__proto__||Object.getPrototypeOf(FamiliesList)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,sortedBy:'submissionDate',sortAsc:-1,filter:{},searchString:''};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this._handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},function(){user.updateURLSearchString({activePage:activePage});});};_this._sortList=function(a,b){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortAsc=_this$state.sortAsc;switch(sortedBy){case'submissionDate':return __WEBPACK_IMPORTED_MODULE_8_moment___default()(a.submissionDate).isAfter(b.submissionDate)?sortAsc:-sortAsc;case'componentType':return a.type.componentTypeName.toLowerCase()>b.type.componentTypeName.toLowerCase()?sortAsc:-sortAsc;default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){var user=_this.props.user;_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc,activePage:1};},function(){user.updateURLSearchString({sortedBy:_this.state.sortedBy,sortAsc:_this.state.sortAsc,activePage:1});});};};_this._filterList=function(familiesList){var _this$state2=_this.state,filter=_this$state2.filter,searchString=_this$state2.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return familiesList.filter(function(element){for(var filterFieldName in filter){switch(filterFieldName){case'categoryId':if(element.type[filterFieldName]!==filter[filterFieldName]){return false;}break;case'componentType':if(element.type.componentTypeCode!==filter[filterFieldName]){return false;}break;default:if(element[filterFieldName]!==filter[filterFieldName]){return false;}}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(newFilterFieldValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=newFilterFieldValue;if(filterFieldName==='categoryId')delete newFilterState.componentType;_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});});};};_this._getList=function(){var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var _this$props=_this.props,user=_this$props.user,createFamilyActionsList=_this$props.createFamilyActionsList,performFamilyActionFunction=_this$props.performFamilyActionFunction,families=_this$props.families,familiesRequestInProcess=_this$props.familiesRequestInProcess,updateFamiliesListEntry=_this$props.updateFamiliesListEntry;var resultList=[];var resultLength=0;if(!families.length){if(familiesRequestInProcess){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'spinner',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__["a" /* default */],{key:'empty'},'No families for selected manufacturer.')];}}else{var filteredList=_this._filterList(families).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__["a" /* default */],{key:'empty'},'No families found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(family,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Row__["a" /* default */],{key:family.id,user:user,sortedBy:sortedBy,family:family,isOdd:!!(index%2),availableActionsList:createFamilyActionsList(family.status),performActionFunction:performFamilyActionFunction,updateFamiliesListEntry:updateFamiliesListEntry});});resultLength=filteredList.length;}}return{resultList:resultList,resultLength:resultLength};};var storedState=props.user.getStoredState('familyListState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);return _this;}_createClass(FamiliesList,[{key:'componentWillUnmount',value:function componentWillUnmount(){var user=this.props.user;user.saveState('familyListState',this.state,[]);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.match.params!==this.props.match.params){this.props.user.saveState('familyListState',this.state,[]);}}},{key:'render',value:function render(){var _props=this.props,types=_props.types,categories=_props.categories;var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,filter=_state.filter,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,searchString=_state.searchString;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Family List',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_7_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowsSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,filterState:filter,types:types,categories:categories}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return FamiliesList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._selectAction=function(actionKey){var _this$props=_this.props,family=_this$props.family,performActionFunction=_this$props.performActionFunction,updateFamiliesListEntry=_this$props.updateFamiliesListEntry;performActionFunction(actionKey,family.id).then(function(updatedData){return updateFamiliesListEntry(family,updatedData);});},_this._getStatusColor=function(){var family=_this.props.family;if(family&&family.status){return'list-scene__status-label_'+family.status.toString().toLowerCase();}return'';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getFamilyReadableStatus=function(){var family=_this.props.family;if(family&&family.status){return(family.status[0].toUpperCase()+family.status.slice(1).toLowerCase()).replace('_',' ');}return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _this2=this;var _props=this.props,family=_props.family,availableActionsList=_props.availableActionsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'familyListRowId'+family.id,className:'list-scene__table-row '+this._getBackgroundColourStyle(),onClick:function onClick(){_this2._selectAction(__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ACTION */].DETAILS);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'componentSubmissionDateField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('submissionDate')+' _width_pc_8'},__WEBPACK_IMPORTED_MODULE_4_moment___default()(family.submissionDate).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'familyTypeField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('componentType')+' _width_pc_20'},family.type.componentTypeName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'familyNameField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('name')+' list-scene__table-row-element_place_filler'},family.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'familyStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('status')},this._getFamilyReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{placeholder:'Actions',withoutSearch:true,multiSelect:true,selectionList:availableActionsList,handleSelect:this._selectAction,type:__WEBPACK_IMPORTED_MODULE_2_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()}));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={family:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FiltersSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var statuses=[{name:'All',value:'All'},{name:'Pending',value:'PENDING'},{name:'Approved',value:'APPROVED'}];var FiltersSection=function(_React$Component){_inherits(FiltersSection,_React$Component);function FiltersSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FiltersSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FiltersSection.__proto__||Object.getPrototypeOf(FiltersSection)).call.apply(_ref,[this].concat(args))),_this),_this.getFormattedListForSelect=function(nameFieldName,valueFieldName,dataObject,filterFieldName,filterValue){var formattedList=dataObject.map(function(entry){return{name:entry[nameFieldName],value:entry[valueFieldName]};});formattedList.sort(function(_ref2,_ref3){var a=_ref2.name;var b=_ref3.name;return a.toLowerCase()>b.toLowerCase()?1:-1;});formattedList.unshift({name:'All',value:'All'});if(filterFieldName){return formattedList.filter(function(item){return item[filterFieldName]===filterValue;});}else{return formattedList;}},_this._getSelectedItem=function(itemValue,itemsList){var selectedItem=itemsList.find(function(item){return item.value===itemValue;});if(selectedItem){return selectedItem;}else{return itemsList[0];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FiltersSection,[{key:'render',value:function render(){var _props=this.props,handleSelectFilter=_props.handleSelectFilter,filterState=_props.filterState,outCount=_props.outCount,handleRowsSelect=_props.handleRowsSelect,rowsCount=_props.rowsCount,categories=_props.categories,types=_props.types;var categoriesOptions=[];var typesOptions=[];if(categories.length&&types.length){categoriesOptions=this.getFormattedListForSelect('name','id',categories);typesOptions=filterState.categoryId?this.getFormattedListForSelect('componentTypeName','componentTypeCode',categories.find(function(category){return category.id===filterState.categoryId;}).componentTypes):this.getFormattedListForSelect('componentTypeName','componentTypeCode',types);if(typesOptions.length===2)typesOptions.shift();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Category',selectionList:categoriesOptions,withoutSearch:true,defaultItem:this._getSelectedItem(filterState.categoryId,categoriesOptions),itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,isLoading:!categoriesOptions.length,handleSelect:handleSelectFilter('categoryId')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Type',selectionList:typesOptions,withoutSearch:true,defaultItem:this._getSelectedItem(filterState.componentType,typesOptions),itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,isLoading:!typesOptions.length,handleSelect:handleSelectFilter('componentType')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Status',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,itemNameIndicator:'name',withoutSearch:true,defaultItem:this._getSelectedItem('status',statuses),placeholder:'All',selectionList:statuses,handleSelect:handleSelectFilter('status')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowsSelect,selectedRowsCount:rowsCount})));}}]);return FiltersSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('submissionDate')+' _width_pc_8',onClick:handleSortClick('submissionDate')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Submission Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('componentType')+' _width_pc_20',onClick:handleSortClick('componentType')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('name')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('status')+' _width_pc_15',onClick:handleSortClick('status')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('actions')+' _width_pc_12'}));});

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatManufacturer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HOC_User__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__List__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Application__ = __webpack_require__(1105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoatManufacturer=Object(__WEBPACK_IMPORTED_MODULE_4_HOC_User__["a" /* default */])(_class=function(_React$Component){_inherits(BoatManufacturer,_React$Component);function BoatManufacturer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BoatManufacturer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BoatManufacturer.__proto__||Object.getPrototypeOf(BoatManufacturer)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentModelYear:'',requestInProcess:false,isModalOpen:false},_this.roleSwitch=function(){var user=_this.props.user;if(user.getActiveRole()!==__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){user.changeMenu(__WEBPACK_IMPORTED_MODULE_7_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName);}},_this.createActionsList=function(boat){var currentModelYear=_this.state.currentModelYear;var user=_this.props.user;var boatInPastYears=(+boat.year||+boat.boatSpecifications.year)<+currentModelYear;var userIsInternal=user.isInternal();var additionalActionsAllowed=userIsInternal||!boatInPastYears;var actions=[__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DETAILS];if(!user.isInspector()){if(boat.status===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DRAFT){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DELETE);}// if (boatInPastYears) {
actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].ROLL_OVER);// }
if(boat.status!==__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DRAFT&&boat.status!==__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED&&additionalActionsAllowed){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DEACTIVATE);}if(boat.status===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED&&additionalActionsAllowed){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].REACTIVATE);}if(boat.status===__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DRAFT||boat.status!==__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED&&additionalActionsAllowed){actions.push(__WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].EDIT);}}return actions;},_this.selectAction=function(actionKey,boat){var user=_this.props.user;switch(actionKey){case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].ROLL_OVER:return new Promise(function(resolve,reject){_this.$modalBody='Are you sure you want to roll the boat over?';_this.$confirmModalAction=_this._confirmRollOver(boat,resolve);_this.setState({isModalOpen:true});});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DEACTIVATE:return new Promise(function(resolve,reject){_this.$modalBody='Are you sure you want to Deactivate this application?';_this.$confirmModalAction=_this._confirmDeactivate(boat,resolve);_this.setState({isModalOpen:true});});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].REACTIVATE:return new Promise(function(resolve,reject){_this.$modalBody='Are you sure you want to Reactivate this application?';_this.$confirmModalAction=_this._confirmReactivate(boat,resolve);_this.setState({isModalOpen:true});});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DELETE:return new Promise(function(resolve,reject){_this.$modalBody='Are you sure you want to Delete this application?';_this.$confirmModalAction=_this._confirmDelete(boat,resolve);_this.setState({isModalOpen:true});});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].DETAILS:return new Promise(function(resolve,reject){return user.goToApplicationDetails(boat.id);});case __WEBPACK_IMPORTED_MODULE_6_constants_index__["a" /* ACTION */].EDIT:return new Promise(function(resolve,reject){return user.goToApplicationStep(boat.id,'boat_specifications');});default:return null;}},_this._confirmDeactivate=function(boat,cb){return function(){var requestInProcess=_this.state.requestInProcess;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].deactivate(boat.id)).then(function(_ref2){var data=_ref2.data;cb(data||__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].DEACTIVATED);__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(function(){_this._closeModal();});});};},_this._confirmReactivate=function(boat,cb){return function(){var requestInProcess=_this.state.requestInProcess;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].reactivate(boat.id)).then(function(_ref3){var data=_ref3.data;cb(data||__WEBPACK_IMPORTED_MODULE_6_constants_index__["c" /* STATUS */].INCOMPLETE);__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'The status was updated successfully.');}).finally(function(){_this._closeModal();});});};},_this._confirmRollOver=function(boat,cb){return function(){var requestInProcess=_this.state.requestInProcess;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].rollOver(boat.id)).then(function(_ref4){var data=_ref4.data;cb(data);__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'Your boat has been successfully rolled over.');}).finally(function(){_this._closeModal();});});};},_this._confirmDelete=function(boat,cb){return function(){var requestInProcess=_this.state.requestInProcess;if(requestInProcess)return null;_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].details(boat.id)).then(function(_ref5){var data=_ref5.data;cb(data);__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success(1,'The boat was deleted successfully.');_this._closeModal();}).catch(function(){_this._closeModal();});});};},_this._closeModal=function(){_this.setState({isModalOpen:false,requestInProcess:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BoatManufacturer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.roleSwitch();__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref6){var data=_ref6.data;_this2.setState({currentModelYear:data[1]||data[0]});});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess,currentModelYear=_state.currentModelYear;var _props=this.props,match=_props.match,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+'/application/:applicationId',render:function render(_ref7){var match=_ref7.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Application__["a" /* default */],{user:user,match:match,createActionsList:_this3.createActionsList,selectAction:_this3.selectAction});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:''+match.path,render:function render(_ref8){var match=_ref8.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__List__["a" /* default */],{user:user,currentModelYear:currentModelYear,createActionsList:_this3.createActionsList,selectAction:_this3.selectAction});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.$modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'No',buttonClassName:'_width_135 _height_40',onClick:this._closeModal,color:__WEBPACK_IMPORTED_MODULE_9_Components_Button__["a" /* buttonColor */].gray,type:__WEBPACK_IMPORTED_MODULE_9_Components_Button__["b" /* buttonType */].secondary}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_width_135 _height_40',onClick:this.$confirmModalAction}))));}}]);return BoatManufacturer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Row__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltersSection__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableHeader__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['id','name'];var List=function(_React$Component){_inherits(List,_React$Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_this._loadFromStore=function(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_lists',user.getManufacturerCode()).then(function(boatList){_this.setState({boatList:boatList},cb);});};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this._handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},user.updateURLSearchString({activePage:activePage}));};_this._filterList=function(boatList){var _this$state=_this.state,filter=_this$state.filter,searchString=_this$state.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return boatList.filter(function(element){for(var filterFieldName in filter){if(element[filterFieldName].toString().toLowerCase()!==filter[filterFieldName].toString().toLowerCase()){return false;}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var filter=_this.state.filter;var user=_this.props.user;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;if(newFilterFieldValue==='All')delete filter[filterFieldName];else filter[filterFieldName]=newFilterFieldValue;if(filterFieldName==='year'){if(filterElement==='All'){user.saveSelectedYear('');}else{user.saveSelectedYear(filterElement);}}_this.setState({filter:filter,activePage:1},function(){user.updateURLSearchString({filter:filter,activePage:1});});};};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this._sortList=function(a,b){var _this$state2=_this.state,sortedBy=_this$state2.sortedBy,sortAsc=_this$state2.sortAsc;switch(sortedBy){case'id':return+a.id>+b.id?sortAsc:-sortAsc;default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc};},_this.props.user.updateURLSearchString({sortedBy:sortedBy,sortAsc:_this.state.sortAsc}));};};_this._getList=function(){var _this$state3=_this.state,boatList=_this$state3.boatList,expandedRowId=_this$state3.expandedRowId,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy,listRequestInProcess=_this$state3.listRequestInProcess;var _this$props=_this.props,user=_this$props.user,currentModelYear=_this$props.currentModelYear,createActionsList=_this$props.createActionsList,selectAction=_this$props.selectAction;var filteredList=_this._filterList(boatList).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=selectedRowsCount?activePage*selectedRowsCount:filteredList.length;var resultList=[];var resultLength=0;if(!boatList.length){if(listRequestInProcess){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'spinner',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_EmptyList__["a" /* default */],{key:'empty'},'No boats for selected manufacturer.')];}}else if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_EmptyList__["a" /* default */],{key:'empty'},'No boats found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(boat,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Row__["a" /* default */],{key:boat.id,boat:boat,isOdd:!!(index%2),toggleRow:_this.toggleRow,expandedRowId:expandedRowId,currentModelYear:currentModelYear,createActionsList:createActionsList,selectAction:selectAction,user:user,updateListEntry:_this.updateListEntry,deleteListEntry:_this.deleteListEntry,sortedBy:sortedBy});});resultLength=filteredList.length;}return{resultList:resultList,resultLength:resultLength};};_this.toggleRow=function(expandedRowId){return function(){if(expandedRowId===_this.state.expandedRowId)expandedRowId='';_this.setState({expandedRowId:expandedRowId});};};_this.updateListEntry=function(oldEntry,newEntry){var user=_this.props.user;var boatList=_this.state.boatList;var dataSource=newEntry.status?newEntry:Object.assign({},oldEntry,{status:newEntry});if(typeof newEntry==='string'){oldEntry.status=newEntry;}else if(newEntry.year===oldEntry.year){var oldEntryIndex=boatList.indexOf(oldEntry);boatList.splice(oldEntryIndex,1,newEntry);}else{boatList.push(newEntry);}__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',dataSource,user.getManufacturerCode());_this.setState({boatList:boatList});};_this.deleteListEntry=function(oldEntry){var user=_this.props.user;var boatList=_this.state.boatList;var oldEntryIndex=boatList.indexOf(oldEntry);boatList.splice(oldEntryIndex,1);__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].delete(user.getActiveRole()+'_lists',oldEntry);_this.setState({boatList:boatList});};_this.defaultState={expandedRowId:0,activePage:1,selectedRowsCount:10,sortedBy:'id',sortAsc:-1,filter:{year:''}};var storedState=props.user.getStoredState('boatListState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({boatList:[],listRequestInProcess:true,isModalOpen:false},_this.defaultState,storedState);return _this;}_createClass(List,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;this.handleSelectFilter('year')(user.getSelectedYear()||'');this._loadFromStore();__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].list).then(function(_ref){var data=_ref.data;__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',data,user.getManufacturerCode()).then(function(){_this2._loadFromStore(function(){_this2.setState({listRequestInProcess:false});});});});}},{key:'componentDidUpdate',value:function componentDidUpdate(){if((!this.state.filter||!this.state.filter.year)&&this.props.currentModelYear){this.handleSelectFilter('year')(this.props.currentModelYear);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.user.saveState('boatListState',this.state,['boatList','listRequestInProcess','isModalOpen','year']);}},{key:'render',value:function render(){var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortAsc=_state.sortAsc,sortedBy=_state.sortedBy,filter=_state.filter,searchString=_state.searchString;var currentModelYear=this.props.currentModelYear;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Master Model List',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_11_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltersSection__["a" /* default */],{handleRowsSelect:this.handleRowsSelect,handleSelectFilter:this.handleSelectFilter,filterState:filter,currentModelYear:currentModelYear,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);List.propTypes={list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this.state={rowData:{},rowDataRequestInProcess:true},_this._getRowState=function(){var _this$props=_this.props,expandedRowId=_this$props.expandedRowId,boat=_this$props.boat;return expandedRowId===boat.id?'expanded':'collapsed';},_this._getStatusColor=function(){var boat=_this.props.boat;if(boat&&boat.status){return'list-scene__status-label_'+boat.status.toString().toLowerCase();}return'';},_this._getTrailerReadableStatus=function(){var boat=_this.props.boat;if(boat&&boat.status){return boat.status[0].toUpperCase()+boat.status.slice(1).toLowerCase();}return'';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_this._getAdditionalRowStyles=function(){var _this$props2=_this.props,expandedRowId=_this$props2.expandedRowId,boat=_this$props2.boat;var classes='_overflow_hidden ';classes+=expandedRowId===boat.id?'_expanded _height_60':'_collapsed _height_0';return classes;},_this._getSpeedValue=function(){var rowData=_this.state.rowData;return!Object.keys(rowData).length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'ect-spinner__image'})):rowData.maxSpeedLessThan30?'<30  Mph.':rowData.passesTestAtFullPower?'>30 Mph.':rowData.maneuveringSpeed?rowData.maneuveringSpeed.toFixed(2)+' Mph.':'-';},_this._getFixedValue=function(value,units){var rowData=_this.state.rowData;return!Object.keys(rowData).length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'ect-spinner__image'})):value?value.toFixed(2)+' '+(units||''):'-';},_this._getValue=function(value){var rowData=_this.state.rowData;return!Object.keys(rowData).length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'ect-spinner__image'})):value?value:'-';},_this._getColWidth=function(){var rowData=_this.state.rowData;return rowData.engineType==='INBOARD'?'_width_pc_10':'_width_pc_11';},_this.selectAction=function(action){var _this$props3=_this.props,boat=_this$props3.boat,selectAction=_this$props3.selectAction,updateListEntry=_this$props3.updateListEntry,deleteListEntry=_this$props3.deleteListEntry;selectAction(action,boat).then(function(updatedData){if(action!==__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DELETE)updateListEntry(boat,updatedData);else deleteListEntry(boat);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;var rowData=this.state.rowData;var _props=this.props,expandedRowId=_props.expandedRowId,boat=_props.boat;if(expandedRowId===boat.id&&!Object.keys(rowData).length){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].details(boat.id)).then(function(_ref2){var rowData=_ref2.data;_this2.setState({rowDataRequestInProcess:false,rowData:rowData});});}}},{key:'render',value:function render(){var _this3=this;var rowData=this.state.rowData;var _props2=this.props,toggleRow=_props2.toggleRow,boat=_props2.boat,createActionsList=_props2.createActionsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'boatListRowID'+boat.id,className:'list-scene__expandable-row-wrapper list-scene__expandable-row-wrapper_'+this._getRowState()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row '+this._getBackgroundColourStyle()+' _margin_bottom_0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_8 _cursor_pointer',onClick:toggleRow(boat.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__expand-icon list-scene__expand-icon_'+this._getRowState()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatIdField',onClick:function onClick(){return _this3.selectAction(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS);},className:'list-scene__table-row-element list-scene__table-row-element_text-element\n            '+this._getTextColourStyle('id')+' _width_pc_10'},boat.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatNameField',onClick:function onClick(){return _this3.selectAction(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS);},className:'list-scene__table-row-element list-scene__table-row-element_text-element\n            '+this._getTextColourStyle('name')+' _width_pc_36'},boat.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatTypeField',onClick:function onClick(){return _this3.selectAction(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS);},className:'list-scene__table-row-element list-scene__table-row-element_text-element\n            '+this._getTextColourStyle('name')+' _width_pc_12'},boat.boatType?boat.boatType.replace(/_/g,' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatEngineTypeField',onClick:function onClick(){return _this3.selectAction(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS);},className:'list-scene__table-row-element list-scene__table-row-element_text-element\n            '+this._getTextColourStyle('name')+' _width_pc_12'},boat.engineType?boat.engineType.replace(/_/g,' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_10',onClick:function onClick(){return _this3.selectAction(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ACTION */].DETAILS);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('status')},this._getTrailerReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatActionsField',className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Select__["a" /* default */],{placeholder:'Actions',selectionList:createActionsList(boat),multiSelect:true,handleSelect:this.selectAction,type:__WEBPACK_IMPORTED_MODULE_4_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-list__row_expandable _flex '+this._getAdditionalRowStyles(boat.id)+' _background_color_simple_gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' _height_pc_100 _width_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Max Speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatMaxSpeedField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getSpeedValue())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'HP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatMaxHPField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getFixedValue(rowData.apprMaxHP))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'HP w/o Remote'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatMaxHPWithoutRemoteField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getFixedValue(rowData.apprMaxHPDualSteering))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Persons'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatMaxPersonsField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getValue(rowData.appMaxNumberOfPersons))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Person Wgt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatMaxPersonsWeightField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getFixedValue(rowData.appMaxPersonsWeight,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Max Weight'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatMaxWeightField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getFixedValue(rowData.appMaxWeight,'Lbs.'))),rowData.engineType==='INBOARD'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Engine Drive Wgt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatEngineDriveWeightField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getFixedValue(rowData.engineAndDriveWeight,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Boat Wgt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boarCalculatedWeightField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},this._getFixedValue(rowData.calBoatWeight,'Lbs.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Inspection Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatInspectionDateField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '+this._getColWidth()+' _height_pc_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'},'Correction Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'boatCorrectionDateField',className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'},'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' _height_pc_100 _width_20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'}))));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={boat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,expandedRowId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),toggleRow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,createActionsList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selectAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Filters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_YearPicker__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_RowsSelector__ = __webpack_require__(29);
function Filters(_ref){var allRowsCount=_ref.allRowsCount,selectedRowsCount=_ref.selectedRowsCount,outCount=_ref.outCount,handleRowsSelect=_ref.handleRowsSelect,rowsCount=_ref.rowsCount,handleSelectFilter=_ref.handleSelectFilter,filterState=_ref.filterState,currentModelYear=_ref.currentModelYear;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["d" /* BOAT_STATUSES */],handleSelect:handleSelectFilter('status'),placeholder:'All',defaultItem:__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["d" /* BOAT_STATUSES */].find(function(item){return item.value===filterState['status'];}),label:'by Application Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["e" /* BOAT_TYPE_LIST */],handleSelect:handleSelectFilter('boatType'),label:'by Boat Type',placeholder:'All',defaultItem:__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["e" /* BOAT_TYPE_LIST */].find(function(item){return item.value===filterState['boatType'];}),itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_YearPicker__["a" /* default */],{endYear:currentModelYear+1,yearPickAction:handleSelectFilter('year'),year:filterState.year,width:160,height:18})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_RowsSelector__["a" /* default */],{allRowsCount:allRowsCount,selectedRowsCount:selectedRowsCount,handleRowsSelect:handleRowsSelect})));}

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-body-col expand-button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('id')+' _width_pc_10',onClick:handleSortClick('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('name')+' _width_pc_36',onClick:handleSortClick('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Boat Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('boatType')+' _width_pc_12',onClick:handleSortClick('boatType')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Boat Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('engineType')+' _width_pc_12',onClick:handleSortClick('engineType')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Engine Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('status')+' _width_pc_10',onClick:handleSortClick('status')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_12'}));});

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatManufacturer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_actions_boat__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Details__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__New__ = __webpack_require__(1111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{boat:state.boat};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setBoatDetails:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4_store_actions_boat__["d" /* setBoatDetails */],dispatch),clearBoatDetails:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4_store_actions_boat__["a" /* clearBoatDetails */],dispatch),updateBoatDetails:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4_store_actions_boat__["e" /* updateBoatDetails */],dispatch)};};var BoatManufacturer=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),_dec(_class=function(_React$Component){_inherits(BoatManufacturer,_React$Component);function BoatManufacturer(props){_classCallCheck(this,BoatManufacturer);var _this=_possibleConstructorReturn(this,(BoatManufacturer.__proto__||Object.getPrototypeOf(BoatManufacturer)).call(this,props));_this.state={boatDetailsRequestInProcess:!(props.match.params.applicationId==='new')};return _this;}_createClass(BoatManufacturer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,setBoatDetails=_props.setBoatDetails,match=_props.match;if(isFinite(match.params.applicationId)){setBoatDetails(match.params.applicationId).then(function(){return _this2.setState({boatDetailsRequestInProcess:false});});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearBoatDetails();}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,match=_props2.match,user=_props2.user;var boatDetailsRequestInProcess=this.state.boatDetailsRequestInProcess;if(boatDetailsRequestInProcess)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _height_100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'ect-spinner__image',style:{width:50,height:50}})))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:''+match.path,render:function render(_ref){var match=_ref.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Details__["a" /* default */],Object.assign({},_this3.props,{match:match,boatDetailsRequestInProcess:boatDetailsRequestInProcess}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+'/:step',render:function render(_ref2){var match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__New__["a" /* default */],Object.assign({},_this3.props,{match:match}));}}));}}]);return BoatManufacturer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Details; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasicInfo__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BoatInfo__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GeneralInfo__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BoatSystems__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BoatWeight__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CubicCapacity__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PersonWeightCapacity__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PowerCapacity__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BoatFloatation__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AdditionalFiles__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BoatStatus__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__registerIDBWorker__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Details=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(Details,_React$Component);function Details(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Details);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Details.__proto__||Object.getPrototypeOf(Details)).call.apply(_ref,[this].concat(args))),_this),_this.$$disablePrint=function(event){event.preventDefault();},_this.performAction=function(actionKey){return function(){var _this$props=_this.props,selectAction=_this$props.selectAction,boat=_this$props.boat,user=_this$props.user;selectAction(actionKey,boat).then(function(updatedData){if(actionKey!==__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ACTION */].DELETE){_this.updateListEntry(updatedData);_this.forceUpdate();}else{_this.deleteListEntry(boat);user.goToList();}});};},_this.updateListEntry=function(newEntry){var _this$props2=_this.props,user=_this$props2.user,boat=_this$props2.boat,updateBoatDetails=_this$props2.updateBoatDetails;var dataSource=newEntry.status?newEntry:Object.assign({},boat,{status:newEntry});var newListEntry={boatType:dataSource.boatType,engineType:dataSource.engineType,id:dataSource.id,lengthFeet:dataSource.boatSpecifications.lengthFeet,lengthInches:dataSource.boatSpecifications.lengthInches,name:dataSource.boatSpecifications.name,status:dataSource.status,submittedOn:dataSource.submittedOn,user:'',year:dataSource.boatSpecifications.year};__WEBPACK_IMPORTED_MODULE_16__registerIDBWorker__["a" /* default */].insert(user.getActiveRole()+'_lists',newListEntry,user.getManufacturerCode());updateBoatDetails(dataSource);},_this.deleteListEntry=function(oldEntry){var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_16__registerIDBWorker__["a" /* default */].delete(user.getActiveRole()+'_lists',oldEntry);},_this._goBack=function(){var _this$props3=_this.props,user=_this$props3.user,history=_this$props3.history;if(history.length===1){user.goToList();}else{user.goBack();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Details,[{key:'render',value:function render(){var _props=this.props,user=_props.user,boat=_props.boat,createActionsList=_props.createActionsList,boatDetailsRequestInProcess=_props.boatDetailsRequestInProcess;var actionsList=createActionsList(boat);var canEdit=actionsList.find(function(act){return act===__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ACTION */].EDIT;})&&!user.isInspector();var canDelete=actionsList.find(function(act){return act===__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ACTION */].DELETE;})&&!user.isInspector();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'print-link',onClick:this.$$disablePrint,href:'javascript:window.print()'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper detailsScene__content-wrapper '+boat.status.toLowerCase()+'\n          '+(document.documentMode||/Edge/.test(navigator.userAgent)?'display-block-on-print':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{applicationStatus:boat.status,boat:boat,canEdit:canEdit,canDelete:canDelete,loadInProgress:boatDetailsRequestInProcess,performAction:this.performAction,user:user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BasicInfo__["a" /* default */],{boat:boat,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BoatInfo__["a" /* default */],{boatSpecifications:boat.boatSpecifications,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GeneralInfo__["a" /* default */],{boatSpecifications:boat.boatSpecifications,dualSteering:boat.dualSteering,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BoatSystems__["a" /* default */],{boatSystems:boat.boatSystems,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CubicCapacity__["a" /* default */],{cubicCapacity:boat.cubicCapacity,boatType:boat.boatType,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BoatWeight__["a" /* default */],{plateType:boat.plateType,personPowerCapacity:boat.personPowerCapacity,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PersonWeightCapacity__["a" /* default */],{personPowerCapacity:boat.personPowerCapacity,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PowerCapacity__["a" /* default */],{powerCapacity:boat.powerCapacity,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoatFloatation__["a" /* default */],{floatationCapacity:boat.floatationCapacity,applicationId:boat.id,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__AdditionalFiles__["a" /* default */],{additionalFiles:boat.additionalFiles,applicationId:boat.id,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),!!actionsList.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__BoatStatus__["a" /* default */],{actionsList:actionsList,canEdit:canEdit,performAction:this.performAction,user:user,boat:boat,boatDetailsRequestInProcess:boatDetailsRequestInProcess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_ApplicationActions__["a" /* default */],{backButtonAction:this._goBack,backButtonLabel:'Back',boatDetailsRequestInProcess:boatDetailsRequestInProcess}))));}}]);return Details;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return System; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var System=function(_React$Component){_inherits(System,_React$Component);function System(){var _ref;var _temp,_this,_ret;_classCallCheck(this,System);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=System.__proto__||Object.getPrototypeOf(System)).call.apply(_ref,[this].concat(args))),_this),_this.getCurrentClass=function(){var classes='';if(_this.props.isPrintable)classes+=' invisible';if(_this.props.isActive)classes+=' active';return classes;},_this.getSystemName=function(index){var _this$props=_this.props,boatSystems=_this$props.boatSystems,system=_this$props.system,allSystemsList=_this$props.allSystemsList;if(!allSystemsList.length)return'';var fullName=allSystemsList.find(function(sys){return sys.id===system.componentSystemId;}).name;var systemName=fullName.split('(')[0].trim();var sameTypeSystems=0;var systemOrder=1;boatSystems.forEach(function(otherSystem,otherIndex){if(otherSystem.componentSystemId===system.componentSystemId){sameTypeSystems++;if(otherIndex<index)systemOrder++;}});if(sameTypeSystems!==1)systemName=systemName+(' ('+systemOrder+')');return systemName;},_this.handleSystemChoose=function(key){return function(){var _this$props2=_this.props,handleSystemChoose=_this$props2.handleSystemChoose,currentSystemIndex=_this$props2.currentSystemIndex;if(key!==currentSystemIndex)handleSystemChoose(key);else handleSystemChoose(-1);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(System,[{key:'render',value:function render(){var _props=this.props,indexKey=_props.indexKey,system=_props.system;var name=this.getSystemName();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner '+this.getCurrentClass(),onClick:this.handleSystemChoose(indexKey)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-icon boat-systems-scene__banner-icon_type_'+system.componentSystemId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-text'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-valid-label'}));}}]);return System;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdditionalSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdditionalSection=function(_React$Component){_inherits(AdditionalSection,_React$Component);function AdditionalSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdditionalSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdditionalSection.__proto__||Object.getPrototypeOf(AdditionalSection)).call.apply(_ref,[this].concat(args))),_this),_this.getInputValue=function(id){var system=_this.props.system;if(!system)return'';var element=system.optionValueRequests.find(function(option){return option.optionId===id;});if(element)return element.value;else return'';},_this.__isVisible=function(){return _this.props.isActive?'':'__invisible';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdditionalSection,[{key:'render',value:function render(){var _this2=this;var currentSystemConfiguration=this.props.currentSystemConfiguration;if(!currentSystemConfiguration)return null;if(!currentSystemConfiguration.options||!currentSystemConfiguration.options.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-systems-details-section__system-additional-info-section '+this.__isVisible()},currentSystemConfiguration.options.map(function(input,index){var units='';switch(input.optionType){case'INCHES':units='In.';break;case'SQUARE_INCHES':units='Sq. In.';break;case'CUBUC_FOOT':units='Cu. Ft.';break;default:break;}switch(input.optionType){case'VARIANTS':case'INTEGER':case'INCHES':case'STRING':case'SQUARE_INCHES':case'CUBUC_FOOT':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{key:input.id,label:input.name,value:_this2.getInputValue(input.id),style:{gridColumn:1,gridRow:index+1},units:units,decimalDigits:2}));default:return input.options.map(function(input,index){if(input.optionType===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:input.id,className:'grid-cell multi',style:{gridColumn:2,gridRow:index+1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-label'},input.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-fields-wrapper'},input.options.map(function(input){var units=input.optionType==='SQUARE_INCHES'?'Sq. In.':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{key:input.id,label:input.name,value:_this2.getInputValue(input.id),units:units,decimalDigits:2});})));}return null;});}}));}}]);return AdditionalSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombinationSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CombinationSection=function(_React$Component){_inherits(CombinationSection,_React$Component);function CombinationSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CombinationSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CombinationSection.__proto__||Object.getPrototypeOf(CombinationSection)).call.apply(_ref,[this].concat(args))),_this),_this.getAddedComponentsList=function(){var _this$props=_this.props,allComponents=_this$props.allComponents,system=_this$props.system;var resultComponents=[];if(system.ruleValueRequests&&system.ruleValueRequests.length){system.ruleValueRequests.forEach(function(rule){if(rule.componentIdWithQuantityMap){Object.keys(rule.componentIdWithQuantityMap).forEach(function(key){var component=allComponents[key];if(component){component.quantity=rule.componentIdWithQuantityMap[key];}resultComponents.push(component);});}});}return resultComponents.filter(function(component){return component;});},_this.__isVisible=function(){return _this.props.isActive?'':'__invisible';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CombinationSection,[{key:'render',value:function render(){var _props=this.props,system=_props.system,allComponents=_props.allComponents;if(!system)return null;if(!Object.keys(allComponents).length)return null;var components=this.getAddedComponentsList();if(!components.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-systems-details-section__components-list '+this.__isVisible()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_30'},'Manufacturer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_10 _margin_left_20'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_15 _margin_left_20'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_30 _margin_left_20'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_10 _text_align_center'},'Qty')),components.map(function(component,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:component.id+index,className:'boat-systems-details-section__components-list-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_30'},component.manufacturerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_10 _margin_left_20'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_15 _margin_left_20'},component.componentType.componentTypeName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_30 _margin_left_20'},component.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-details-section__components-list-item _width_pc_10 _text_align_center'},component.quantity));}));}}]);return CombinationSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoatStatus=function(_React$Component){_inherits(BoatStatus,_React$Component);function BoatStatus(props){_classCallCheck(this,BoatStatus);var _this=_possibleConstructorReturn(this,(BoatStatus.__proto__||Object.getPrototypeOf(BoatStatus)).call(this,props));_this.isActionAllowed=function(action){var actionsList=_this.props.actionsList;return actionsList.find(function(act){return act===action;});};_this.state={isModalOpen:false};return _this;}_createClass(BoatStatus,[{key:'render',value:function render(){var _props=this.props,canEdit=_props.canEdit,isFinalReview=_props.isFinalReview,performAction=_props.performAction,boatDetailsRequestInProcess=_props.boatDetailsRequestInProcess,boat=_props.boat,user=_props.user;if(user.isInspector())return null;if(boatDetailsRequestInProcess)return null;var actions=[{key:'edit',isShown:canEdit,Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{className:'_height_40 _width_pc_100 _max_width_180 _margin_right_20',onClick:performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].EDIT,boat)});}},{key:'print',isShown:!isFinalReview&&this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].PRINT),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Print',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].PRINT,boat),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green});}},{key:'roll',isShown:!isFinalReview&&this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].ROLL_OVER),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Roll Over',buttonClassName:'_height_40 _width_120 _margin_right_20',iconClassName:'rollover-icon',onClick:performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].ROLL_OVER,boat),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}),boat.status!=='DRAFT'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions-delimiter'}));}},{key:'deactivate',isShown:this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].DEACTIVATE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Deactivate',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].DEACTIVATE,boat),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].red});}},{key:'reactivate',isShown:this.isActionAllowed(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].REACTIVATE),Component:function Component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Reactivate',buttonClassName:'_height_40 _width_120 _margin_right_20',onClick:performAction(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ACTION */].REACTIVATE,boat),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green});}}];if(actions.filter(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('isShown')).length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Actions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__change-status-buttons-wrapper'},actions.map(function(_ref){var key=_ref.key,isShown=_ref.isShown,Component=_ref.Component;return isShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,{key:key});})));}}]);return BoatStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoatManufacturer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BoatTypeSelect__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EngineTypeSelect__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BoatSpecifications__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CubicCapacityScene__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PersonPowerCapacity__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PowerCapacity__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FloatationCapacity__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddComponents__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FinalReview__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LoadAdditionalDocuments__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Header__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__StepNavBar__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_Components_TransitionBlockerModal__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_actions_boat__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux_es_connect_connect__ = __webpack_require__(269);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var mapStateToProps=function mapStateToProps(){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectBoatType:Object(__WEBPACK_IMPORTED_MODULE_22_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_23__store_actions_boat__["b" /* selectBoatType */],dispatch),selectEngineType:Object(__WEBPACK_IMPORTED_MODULE_22_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_23__store_actions_boat__["c" /* selectEngineType */],dispatch),updateBoatDetails:Object(__WEBPACK_IMPORTED_MODULE_22_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_23__store_actions_boat__["e" /* updateBoatDetails */],dispatch)};};var BoatManufacturer=(_dec=Object(__WEBPACK_IMPORTED_MODULE_24_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=_dec(_class=function(_React$Component){_inherits(BoatManufacturer,_React$Component);function BoatManufacturer(props){var _stepsValidation;_classCallCheck(this,BoatManufacturer);var _this=_possibleConstructorReturn(this,(BoatManufacturer.__proto__||Object.getPrototypeOf(BoatManufacturer)).call(this,props));_this.getActiveStepsValidation=function(stepsValidation,boat){var activeStepIds=Object(__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["C" /* getBoatSteps */])(boat.boatType,boat.engineType).map(function(step){return step.id;});return Object.keys(stepsValidation).reduce(function(activeStepsValidation,stepId){if(activeStepIds.includes(stepId))activeStepsValidation[stepId]=stepsValidation[stepId];return activeStepsValidation;},{});};_this.goToStep=function(nextStepPointer,isStepValid){var stepIsChanged=_this.state.stepIsChanged;var _this$props=_this.props,user=_this$props.user,boat=_this$props.boat,match=_this$props.match;var step=match.params.step;var steps=Object(__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["C" /* getBoatSteps */])(boat.boatType,boat.engineType);if(nextStepPointer==='next'){var currentStepIndex=steps.findIndex(function(st){return st.id===step;});nextStepPointer=steps[currentStepIndex+1].id;}else if(nextStepPointer==='prev'){var _currentStepIndex=steps.findIndex(function(st){return st.id===step;});nextStepPointer=steps[_currentStepIndex-1].id;}if(isStepValid&&stepIsChanged&&isFinite(boat.id)){__WEBPACK_IMPORTED_MODULE_18_dom_managers_notification__["a" /* default */].autosave();}_this.setState(function(prevState){return{stepsValidation:Object.assign({},prevState.stepsValidation,_defineProperty({},step,isStepValid)),stepIsChanged:!prevState.stepsValidation[nextStepPointer],unsavedDataPresents:!isStepValid||!isFinite(boat.id)||!!Object.keys(prevState.stepsValidation).find(function(stepId){return prevState.stepsValidation[stepId]===false&&stepId!==step;})};},function(){user.saveState('boatStepsState',{id:boat.id,steps:_this.state.stepsValidation});user.goToApplicationStep(boat.id,nextStepPointer);});};_this.markStepAsRedacted=function(){var _this$props2=_this.props,boat=_this$props2.boat,match=_this$props2.match;var step=match.params.step;var stepsValidation=_this.state.stepsValidation;var steps=Object(__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["C" /* getBoatSteps */])(boat.boatType,boat.engineType);var stepIndex=steps.findIndex(function(st){return st.id===step;});steps.forEach(function(otherStep,index){if(index>stepIndex&&stepsValidation[otherStep.id])delete stepsValidation[otherStep.id];});_this.setState({stepsValidation:stepsValidation,stepIsChanged:true,unsavedDataPresents:true});};_this.markCurrentStepAsSaved=function(){var step=_this.props.match.params.step;var stepsValidation=_this.state.stepsValidation;stepsValidation[step]=true;_this.setState({stepsValidation:stepsValidation,stepIsChanged:false,unsavedDataPresents:false});};_this.handleBoatSubmit=function(){var stepsValidation=_this.state.stepsValidation;var _this$props3=_this.props,user=_this$props3.user,boat=_this$props3.boat;var allStepsValid=true;Object(__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["C" /* getBoatSteps */])(boat.boatType,boat.engineType).forEach(function(step){if(!stepsValidation[step.id]&&step.id!==__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].FINAL_REVIEW){allStepsValid=false;stepsValidation[step.id]=false;}});if(allStepsValid){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].submit(boat.id)).then(function(){_this.setState({stepIsChanged:false,unsavedDataPresents:false},function(){__WEBPACK_IMPORTED_MODULE_18_dom_managers_notification__["a" /* default */].success('note','Your application was submitted successfully.');user.goToList(false,{elements:'default',rowsCount:'default',activePage:'default',sortedBy:'id',sortOrder:-1,filter:{status:'APPROVED',boatType:boat.boatType,year:boat.boatSpecifications.year}});});});}else{__WEBPACK_IMPORTED_MODULE_18_dom_managers_notification__["a" /* default */].error(1,'Not all steps a filled','Please fill all previous steps to submit boat.');_this.setState({stepsValidation:stepsValidation},function(){user.saveState('boatStepsState',{id:boat.id,steps:stepsValidation});});}};_this.handleDeleteDraft=function(){var _this$props4=_this.props,boat=_this$props4.boat,user=_this$props4.user;if(isFinite(boat.id)){_this.modalConfirmAction=function(){_this.setState({isModalOpen:false,unsavedDataPresents:false},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].details(boat.id)).then(function(){user.goToList();__WEBPACK_IMPORTED_MODULE_18_dom_managers_notification__["a" /* default */].success(1,'Draft application was deleted successfully.');});});};}else{_this.modalConfirmAction=function(){_this.setState({isModalOpen:false,unsavedDataPresents:false},function(){__WEBPACK_IMPORTED_MODULE_18_dom_managers_notification__["a" /* default */].success(1,'Draft application was deleted successfully.');user.goToList();});};}_this.modalBody='Are you sure you want to Delete this draft application?';_this.setState({isModalOpen:true});};_this.closeModal=function(){_this.setState({isModalOpen:false});};_this.maxLengthIs26=function(){var boatType=_this.props.boat.boatType;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["b" /* BOAT */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["g" /* CATAMARAN */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["u" /* SAILBOAT */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["r" /* PONTOON */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["n" /* JON_BOAT */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["s" /* PWC */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["l" /* INFLATABLE */])return true;if(boatType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["f" /* CANOE_KAYAK */])return true;return false;};_this.getNavBar=function(handleMoveToNextStep,handleMoveToArbitraryStep){var stepsValidation=_this.state.stepsValidation;var _this$props5=_this.props,boat=_this$props5.boat,match=_this$props5.match;var step=match.params.step;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__StepNavBar__["a" /* default */],{step:step,stepsList:Object(__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["C" /* getBoatSteps */])(boat.boatType,boat.engineType),stepsValidation:stepsValidation,handleMoveToNextStep:handleMoveToNextStep,handleMoveToArbitraryStep:handleMoveToArbitraryStep});};_this.getHeader=function(handleSaveStepAsync){var _this$props6=_this.props,boat=_this$props6.boat,user=_this$props6.user,match=_this$props6.match;var step=match.params.step;switch(step){case'boat_type':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */],{boat:boat,text:'Select Boat Type',user:user});case'engine_type':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */],{boat:boat,text:'Select Engine Type',user:user});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */],{boat:boat,handleSaveStep:handleSaveStepAsync,handleDeleteDraft:_this.handleDeleteDraft,markCurrentStepAsSaved:_this.markCurrentStepAsSaved,stepIsChanged:_this.state.stepIsChanged,user:user});}};_this.initNewBoat=function(){var _this$props7=_this.props,user=_this$props7.user,clearBoatDetails=_this$props7.clearBoatDetails;clearBoatDetails();localStorage.removeItem('boatStepsState');user.replaceLocation('/'+user.getManufacturerCode()+'/boat/application/New/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].BOAT_TYPE);return null;};_this.state={stepsValidation:(_stepsValidation={},_defineProperty(_stepsValidation,__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].FINAL_REVIEW,true),_defineProperty(_stepsValidation,__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].LOAD_DOCUMENTS,true),_stepsValidation),stepIsChanged:true,isModalOpen:false,unsavedDataPresents:false};_this.modalBody='';_this.modalConfirmAction={};return _this;}_createClass(BoatManufacturer,[{key:'componentDidMount',value:function componentDidMount(){var stepsValidation=this.state.stepsValidation;var _props=this.props,user=_props.user,boat=_props.boat,match=_props.match;var _match$params=match.params,applicationId=_match$params.applicationId,step=_match$params.step;var storedStepsState=user.getStoredState('boatStepsState');var stepIsChanged=false;if(storedStepsState.id&&+storedStepsState.id===+applicationId){stepsValidation=storedStepsState.steps;stepIsChanged=!stepsValidation[step];}else{if(boat.status==='APPROVED'){Object(__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["C" /* getBoatSteps */])(boat.boatType,boat.engineType).forEach(function(boatStep){stepsValidation[boatStep.id]=true;});}else{if(boat.boatType)stepsValidation[__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].BOAT_TYPE]=true;if(boat.engineType)stepsValidation[__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].ENGINE_TYPE]=true;stepIsChanged=true;}}stepsValidation=this.getActiveStepsValidation(stepsValidation,boat);this.setState({stepsValidation:stepsValidation,stepIsChanged:stepIsChanged},function(){user.saveState('boatStepsState',{id:applicationId,steps:stepsValidation});});}},{key:'componentDidUpdate',value:function componentDidUpdate(previousProps){var _props2=this.props,boat=_props2.boat,user=_props2.user;if(boat.boatType!==previousProps.boat.boatType||boat.engineType!==previousProps.boat.engineType){var stepsValidation=this.getActiveStepsValidation(this.state.stepsValidation,boat);this.setState({stepsValidation:stepsValidation},function(){user.saveState('boatStepsState',{id:boat.id,steps:stepsValidation});});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var stepsValidation=this.state.stepsValidation;var _props3=this.props,user=_props3.user,boat=_props3.boat;user.saveState('boatStepsState',{id:boat.id,steps:stepsValidation});}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,user=_props4.user,boat=_props4.boat,selectBoatType=_props4.selectBoatType,selectEngineType=_props4.selectEngineType,updateBoatDetails=_props4.updateBoatDetails,match=_props4.match;var _state=this.state,stepIsChanged=_state.stepIsChanged,isModalOpen=_state.isModalOpen,unsavedDataPresents=_state.unsavedDataPresents;var basePath=match.path.slice(0,-6);if(user.isInspector())user.goToList();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper\n          '+(document.documentMode||/Edge/.test(navigator.userAgent)?'display-block-on-print':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/InitNewBoat',render:this.initNewBoat}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].BOAT_TYPE,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BoatTypeSelect__["a" /* default */],{getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,boat:boat,selectBoatType:selectBoatType,goToStep:_this2.goToStep,markStepAsRedacted:_this2.markStepAsRedacted,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].ENGINE_TYPE,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EngineTypeSelect__["a" /* default */],{getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,boat:boat,selectEngineType:selectEngineType,goToStep:_this2.goToStep,markStepAsRedacted:_this2.markStepAsRedacted,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].BOAT_SPECIFICATIONS,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BoatSpecifications__["a" /* default */],{user:user,boat:boat,getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,goToStep:_this2.goToStep,markStepAsRedacted:_this2.markStepAsRedacted,maxLengthIs26:_this2.maxLengthIs26,updateBoatDetails:updateBoatDetails,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].ADD_COMPONENTS,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AddComponents__["a" /* default */],{getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,user:user,boat:boat,goToStep:_this2.goToStep,markStepAsRedacted:_this2.markStepAsRedacted,updateBoatDetails:updateBoatDetails,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].CUBIC_CAPACITY,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CubicCapacityScene__["a" /* default */],{user:user,boat:boat,getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,goToStep:_this2.goToStep,updateBoatDetails:updateBoatDetails,markStepAsRedacted:_this2.markStepAsRedacted,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].WEIGHT_CAPACITY,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PersonPowerCapacity__["a" /* default */],{user:user,boat:boat,getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,goToStep:_this2.goToStep,updateBoatDetails:updateBoatDetails,markStepAsRedacted:_this2.markStepAsRedacted,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].POWER_CAPACITY,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PowerCapacity__["a" /* default */],{user:user,boat:boat,getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,goToStep:_this2.goToStep,updateBoatDetails:updateBoatDetails,markStepAsRedacted:_this2.markStepAsRedacted,stepIsChanged:stepIsChanged});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].FLOATATION_CAPACITY,render:function render(){return boat.engineType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["q" /* OUTBOARD */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FloatationCapacity__["a" /* default */],{user:user,boat:boat,getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,goToStep:_this2.goToStep,updateBoatDetails:updateBoatDetails,markStepAsRedacted:_this2.markStepAsRedacted,stepIsChanged:stepIsChanged}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].LOAD_DOCUMENTS});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].LOAD_DOCUMENTS,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__LoadAdditionalDocuments__["a" /* default */],Object.assign({boat:boat,getNavBar:_this2.getNavBar,getHeader:_this2.getHeader,goToStep:_this2.goToStep,handleDeleteDraft:_this2.handleDeleteDraft,stepIsChanged:stepIsChanged,markStepAsRedacted:_this2.markStepAsRedacted},_this2.props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:basePath+'/'+__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["x" /* STEP_ID */].FINAL_REVIEW,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FinalReview__["a" /* default */],Object.assign({getNavBar:_this2.getNavBar,actionsList:boat.status==='DRAFT'?[__WEBPACK_IMPORTED_MODULE_5_constants_index__["a" /* ACTION */].DELETE]:[],getHeader:_this2.getHeader,handleBoatSubmit:_this2.handleBoatSubmit,goToStep:_this2.goToStep,markStepAsRedacted:_this2.markStepAsRedacted,handleDeleteDraft:_this2.handleDeleteDraft,stepIsChanged:stepIsChanged},_this2.props));}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_19_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_19_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_Components_TransitionBlockerModal__["a" /* default */],{blockTransitions:unsavedDataPresents,transitionWhitelist:__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["c" /* BOAT_APPLICATION_ALLOWED_UNCONFIRMED_TRANSITIONS */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},'You have unsaved data. Are you sure you want to exit application without saving?')));}}]);return BoatManufacturer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class)||_class);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectBoat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Info__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_managers_notification__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectBoat=function(_React$Component){_inherits(SelectBoat,_React$Component);function SelectBoat(props){_classCallCheck(this,SelectBoat);var _this=_possibleConstructorReturn(this,(SelectBoat.__proto__||Object.getPrototypeOf(SelectBoat)).call(this,props));_this.handleSelectBoatType=function(type){return function(){var _this$props=_this.props,boat=_this$props.boat,selectBoatType=_this$props.selectBoatType,markStepAsRedacted=_this$props.markStepAsRedacted,goToStep=_this$props.goToStep;if(boat.status&&boat.status!=='DRAFT'&&boat.boatType!==type){__WEBPACK_IMPORTED_MODULE_3_dom_managers_notification__["a" /* default */].error(400,'Boat Type can only be changed in the application in the Draft status');}else{markStepAsRedacted();selectBoatType(type).then(function(){goToStep('next',true);});}};};_this.toggleBoatYachtSelector=function(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */];_this.setState(function(prevState){return{expandedBoatType:prevState.expandedBoatType===type?null:type,lastExpandedBoatType:type};});};_this.getChosenBoatTypeMarkClass=function(type){var boat=_this.props.boat;return type===boat.boatType?'selected':'';};_this.getVisibilityClassForBoatType=function(){return _this.state.expandedBoatType?'hide':'show';};_this.getAnimationClassForBoat=function(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */];var _this$state=_this.state,expandedBoatType=_this$state.expandedBoatType,lastExpandedBoatType=_this$state.lastExpandedBoatType;if(expandedBoatType)return expandedBoatType===type?'move-center':'hide';return lastExpandedBoatType===type?'move-back':'show';};_this.getSubAnimationClassForBoat=function(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */];return _this.state.expandedBoatType===type?'show-sub-type':'none-display';};_this.state={};return _this;}_createClass(SelectBoat,[{key:'render',value:function render(){var _this2=this;var expandedBoatType=this.state.expandedBoatType;var getHeader=this.props.getHeader;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section boat-type-section _jc_center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner boat '+this.getAnimationClassForBoat()+' '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */])+' '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["B" /* YACHT */]),onClick:function onClick(){return _this2.toggleBoatYachtSelector(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-sub-type-banner boat to-left '+this.getSubAnimationClassForBoat()+' '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'BOAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},'Less than 26 Ft. Long')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-sub-type-banner yacht to-right '+this.getSubAnimationClassForBoat()+' '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["B" /* YACHT */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["B" /* YACHT */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'YACHT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},'26 Ft. and longer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),expandedBoatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */]?'BACK':'BOAT / YACHT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Boat refers to a watercraft less than 26 feet in length and capable of being mechanically powered.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Yacht refers to a watercraft 26 feet in length or longer and capable of being mechanically powered.'))}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner sailboat '+this.getVisibilityClassForBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["u" /* SAILBOAT */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["u" /* SAILBOAT */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["u" /* SAILBOAT */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'SAILBOAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Sailboat: a boat designed or intended to use sails as the primary means of propulsion.')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner pontoon '+this.getVisibilityClassForBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["r" /* PONTOON */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["r" /* PONTOON */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["r" /* PONTOON */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'PONTOON'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Pontoon refers to a boat consisting of a rigid structure connecting at least two parallel sealed buoyancy chambers. The line of intersection of the buoyancy chambers and water surface produce more than a single closed curve when loaded to the maximum weight capacity.')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner catamaran '+this.getAnimationClassForBoat(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */]),onClick:function onClick(){return _this2.toggleBoatYachtSelector(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-sub-type-banner catamaran to-left '+this.getSubAnimationClassForBoat(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */])+' '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'CATAMARAN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},'Less than 26 Ft. Long')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-sub-type-banner yacht to-right '+this.getSubAnimationClassForBoat(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */])+' '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["B" /* YACHT */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["B" /* YACHT */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'YACHT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},'26 Ft. and longer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),expandedBoatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */]?'BACK':'CATAMARAN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Catamaran: a hull with two running surfaces separated by a section that is above the running surfaces. Select Catamaran for watercraft less than 26 feet in length.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Select Yacht for watercraft 26 feet in length or longer.'))}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner jonboat '+this.getVisibilityClassForBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["n" /* JON_BOAT */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["n" /* JON_BOAT */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["n" /* JON_BOAT */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'JONBOAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Jon Boat refers to a small flat-bottomed watercraft capable of being powered mechanically or by manual or sailing means.')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner pwc '+this.getVisibilityClassForBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["s" /* PWC */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["s" /* PWC */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["s" /* PWC */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'PWC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'PWC (Personal watercraft) is a vessel that uses an internal combustion engine powering a water jet pump as its primary source of propulsion and is designed to be operated by a person or persons sitting, standing, or kneeling on, rather than within, the confines of a hull.')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner inflatable '+this.getVisibilityClassForBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["l" /* INFLATABLE */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["l" /* INFLATABLE */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["l" /* INFLATABLE */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'INFLATABLE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},'Inflatable refers to a boat that achieves all or part of its intended structure, shape and buoyancy through the medium of inflation.')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'boat-type-banner kayak-canoe '+this.getVisibilityClassForBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["f" /* CANOE_KAYAK */])+'  '+this.getChosenBoatTypeMarkClass(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["f" /* CANOE_KAYAK */]),onClick:this.handleSelectBoatType(__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["f" /* CANOE_KAYAK */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'for-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'KAYAK / CANOE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Info__["a" /* default */],{triggerWrapperClassName:'_position_absolute _top_15 _left_5  _z_index_200',triggerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-info-mark __info-icon'}),popperElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info__tooltip-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Canoe - a watercraft that is designed to be manually propelled, with or without provision for auxiliary power, with neither end having a transverse dimension greater than 45% of its maximum beam and conforms to the following rules:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Canoe Length 14 ft. (4.25m) or less: Maximum Beam 1/3 Canoe Length'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Canoe Length over 14 ft. to 16 ft. (4.9m): Maximum Beam 1/4 Canoe Length'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Canoe Length over 16 ft. (over 4.9m): Maximum Beam 1/5 Canoe Length'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Kayak - a watercraft designed to be manually propelled, typically without provision for auxiliary power, with the occupant intended to be seated with legs approximately 90\xB0 from the torso.'))})))));}}]);return SelectBoat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EngineTypeSelectScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EngineTypeSelectScene=function(_React$Component){_inherits(EngineTypeSelectScene,_React$Component);function EngineTypeSelectScene(props){_classCallCheck(this,EngineTypeSelectScene);var _this=_possibleConstructorReturn(this,(EngineTypeSelectScene.__proto__||Object.getPrototypeOf(EngineTypeSelectScene)).call(this,props));_this.handleSelectEngineType=function(engineType){return function(){var _this$props=_this.props,markStepAsRedacted=_this$props.markStepAsRedacted,boat=_this$props.boat;if(boat.status&&boat.status!=='DRAFT'){__WEBPACK_IMPORTED_MODULE_2_dom_managers_notification__["a" /* default */].error(400,'Engine Type can only be changed in the application in the Draft status');}else{markStepAsRedacted();_this.setState({engineType:engineType});}};};_this.getSelectedEngineClass=function(type){var engineType=_this.state.engineType;return type===engineType?'selected':'';};_this._isValidStep=function(){var engineType=_this.state.engineType;return!!engineType;};_this.handleMoveToNextStep=function(){var engineType=_this.state.engineType;var _this$props2=_this.props,selectEngineType=_this$props2.selectEngineType,goToStep=_this$props2.goToStep;if(_this._isValidStep()){selectEngineType(engineType);goToStep('next',true);}else{__WEBPACK_IMPORTED_MODULE_2_dom_managers_notification__["a" /* default */].error(1,'No engine type','Please select boat engine type');}};_this.handleMoveToArbitraryStep=function(stepId){var engineType=_this.state.engineType;var _this$props3=_this.props,selectEngineType=_this$props3.selectEngineType,goToStep=_this$props3.goToStep,stepIsChanged=_this$props3.stepIsChanged;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}if(_this._isValidStep()){selectEngineType(engineType);goToStep(typeof stepId==='string'?stepId:'prev',true);}else{goToStep(typeof stepId==='string'?stepId:'prev',false);}};_this.state={engineType:props.boat.engineType||''};return _this;}_createClass(EngineTypeSelectScene,[{key:'render',value:function render(){var _props=this.props,getNavBar=_props.getNavBar,boat=_props.boat,getHeader=_props.getHeader;var outboardIndex=boat.engineTypesList.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["q" /* OUTBOARD */]);var inboardIndex=boat.engineTypesList.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["k" /* INBOARD */]);var nonPoweredIndex=boat.engineTypesList.indexOf(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["p" /* NON_POWERED */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'engine-type-section'},outboardIndex!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'engine-type-banner outboard '+this.getSelectedEngineClass(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["q" /* OUTBOARD */]),onClick:this.handleSelectEngineType(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["q" /* OUTBOARD */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'OUTBOARD')),inboardIndex!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'engine-type-banner inboard '+this.getSelectedEngineClass(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["k" /* INBOARD */]),onClick:this.handleSelectEngineType(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["k" /* INBOARD */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'INBOARD / STERNDRIVE')),nonPoweredIndex!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'engine-type-banner non-powered '+this.getSelectedEngineClass(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["p" /* NON_POWERED */]),onClick:this.handleSelectEngineType(__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["p" /* NON_POWERED */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'NON-POWERED'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',backButtonAction:this.handleMoveToArbitraryStep,saveButtonLabel:'Next Step',saveButtonAction:this.handleMoveToNextStep}));}}]);return EngineTypeSelectScene;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdditionalSection__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_Checkbox__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_GoogleSelect__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoatSpecifications=function(_React$Component){_inherits(BoatSpecifications,_React$Component);function BoatSpecifications(props){_classCallCheck(this,BoatSpecifications);var _this=_possibleConstructorReturn(this,(BoatSpecifications.__proto__||Object.getPrototypeOf(BoatSpecifications)).call(this,props));_this.updateRequiredFieldsList=function(){var _this$state=_this.state,ribFlag=_this$state.ribFlag,dieselPower=_this$state.dieselPower;var inherentBuoyancyVolumeIndex=_this.requiredFieldsList.indexOf('inherentBuoyancyVolume');if(ribFlag&&inherentBuoyancyVolumeIndex===-1)_this.requiredFieldsList.push('inherentBuoyancyVolume');else if(!ribFlag&&inherentBuoyancyVolumeIndex!==-1)_this.requiredFieldsList.splice(inherentBuoyancyVolumeIndex,1);var dieselPowerCodeIndex=_this.requiredFieldsList.indexOf('dieselPowerCode');if(dieselPower&&dieselPowerCodeIndex===-1)_this.requiredFieldsList.push('dieselPowerCode');else if(!dieselPower&&dieselPowerCodeIndex!==-1)_this.requiredFieldsList.splice(dieselPowerCodeIndex,1);};_this.handleInputChange=function(targetField){return function(value,error){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(error||!value&&_this.requiredFieldsList.indexOf(targetField)!==-1)_this.inputErrors[targetField]=error||true;else delete _this.inputErrors[targetField];_this.setState(_defineProperty({},targetField,value),function(){if(targetField==='lengthFeet'||targetField==='lengthInches'||targetField==='inboardLengthFeet'||targetField==='inboardLengthInches')_this.validateInboardLength();});};};_this.handleSelectYear=function(year){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(!year&&_this.requiredFieldsList.indexOf('year')!==-1)_this.inputErrors['year']=true;else delete _this.inputErrors['year'];_this.setState({year:year});};_this.validateInches=function(value){return value>=12;};_this.validateBoatLength=function(value){var _this$props=_this.props,boat=_this$props.boat,maxLengthIs26=_this$props.maxLengthIs26;_this.validateInboardLength();if(maxLengthIs26()&&value>=26)return'Max length can\'t be more than or equal 26 Ft.';if(boat.boatType===__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["B" /* YACHT */]&&value<26)return'Min length can\'t be less than 26 Ft.';};_this.validateInboardLength=function(){var _this$state2=_this.state,lengthFeet=_this$state2.lengthFeet,lengthInches=_this$state2.lengthInches,inboardLengthFeet=_this$state2.inboardLengthFeet,inboardLengthInches=_this$state2.inboardLengthInches;var metricInboardLength=(inboardLengthFeet?inboardLengthFeet/3.2808:0)+(inboardLengthInches?inboardLengthInches/39.3696:0);var metricLength=(lengthFeet?lengthFeet/3.2808:0)+(lengthInches?lengthInches/39.3696:0);if((lengthFeet||lengthInches)&&metricInboardLength>metricLength){_this.inputErrors['inboardLengthFeet']='Boat can\'t be bigger on inside';_this.inputErrors['inboardLengthInches']=true;}else{delete _this.inputErrors['inboardLengthFeet'];if(!_this.validateInches(inboardLengthInches))delete _this.inputErrors['inboardLengthInches'];}_this.forceUpdate();};_this.validateDisplacement=function(value){return value>9999?'Max displacement is 9999':false;};_this.handleSelect=function(field){return function(value){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();delete _this.inputErrors[field];_this.setState(_defineProperty({},field,value.value||value));};};_this.handleCityAndStateForCapacityTag=function(cityAndStateForCapacityTag){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();delete _this.inputErrors['cityAndStateForCapacityTag'];_this.setState({cityAndStateForCapacityTag:cityAndStateForCapacityTag});};_this.handleMoveToNextStep=function(){var goToStep=_this.props.goToStep;_this.saveData().then(function(id){goToStep('next',true,id);});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props2=_this.props,goToStep=_this$props2.goToStep,stepIsChanged=_this$props2.stepIsChanged;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.saveData().then(function(){goToStep(typeof stepId==='string'?stepId:'prev',true);}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});};_this.validateStep=function(){return new Promise(function(resolve,reject){_this.requiredFieldsList.forEach(function(field){if(_this.state[field]==='')_this.inputErrors[field]=true;if(field==='lengthFeet'||field==='lengthInches'||field==='inboardLengthFeet'||field==='inboardLengthInches')_this.validateInboardLength();if(field.includes('Inch')&&_this.validateInches(_this.state[field]))_this.inputErrors[field]=_this.validateInches(_this.state[field]);if(field==='lengthFeet'&&_this.validateBoatLength(_this.state[field]))_this.inputErrors['lengthFeet']=_this.validateBoatLength(_this.state[field]);if(field==='displacement'&&_this.validateDisplacement(_this.state[field]))_this.inputErrors['displacement']=_this.validateDisplacement(_this.state[field]);});_this.forceUpdate();if(Object.keys(_this.inputErrors).length)reject();else resolve();});};_this.saveData=function(){var _this$state3=_this.state,lengthInches=_this$state3.lengthInches,widthInches=_this$state3.widthInches;var _this$props3=_this.props,boat=_this$props3.boat,updateBoatDetails=_this$props3.updateBoatDetails;var id=boat.id,boatType=boat.boatType,engineType=boat.engineType;return new Promise(function(resolve,reject){_this.validateStep().then(function(){var data=Object.assign({},_this.state);if(data.lengthInches!==undefined)data.lengthInches=lengthInches||0;if(data.widthInches!==undefined)data.widthInches=widthInches||0;if(!data.dieselPowerCode)delete data.dieselPowerCode;if(boat.boatType===__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["n" /* JON_BOAT */])data.bottomContour='FLAT';var dataPayload=Object.assign({boatType:boatType,engineType:engineType},data);if(isFinite(id))dataPayload.id=id;var info={};__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].create,dataPayload).then(function(_ref){var serverData=_ref.data;info.id=serverData.id;info.boatSpecifications=Object.assign({},_this.state);info.isFloatationTestReportRequired=_this.state.lengthFeet<20;updateBoatDetails(info);resolve(info.id);}).catch(function(){reject();});}).catch(function(){var state=_this.state;for(var fieldName in state){if(_this.inputErrors[fieldName]){state[fieldName]='';}}_this.setState(state,function(){var data=Object.assign({},_this.state);updateBoatDetails({boatSpecifications:Object.assign({},data)});reject();});});});};_this.isError=function(field){return _this.inputErrors[field];};_this.toggleMotorType=function(){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();_this.setState(function(prevState){return{motorType:prevState.motorType===__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["w" /* SINGLE */]?__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["z" /* TWIN */]:__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["w" /* SINGLE */]};});};_this.toggleHasElectricPropulsion=function(){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();_this.setState(function(prevState){return{hasElectricPropulsion:!prevState.hasElectricPropulsion};});};_this.toggleValue=function(type){return function(){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();_this.setState(function(prevState){return _defineProperty({},type,!prevState[type]);},_this.updateRequiredFieldsList);};};_this.handleDieselToggle=function(){var dieselPower=_this.state.dieselPower;var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(!dieselPower){_this.requiredFieldsList.push('dieselPowerCode');_this.setState({dieselPower:true});}else{_this.requiredFieldsList.splice(_this.requiredFieldsList.indexOf('dieselPowerCode'),1);delete _this.inputErrors['dieselPowerCode'];_this.setState({dieselPower:false});}};_this.handleDieselTypeChose=function(value){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();delete _this.inputErrors['dieselPowerCode'];_this.setState({dieselPowerCode:value.toUpperCase()});};_this.state=Object.assign({},props.boat.boatSpecifications);_this.modelYears=[];_this.inputErrors={};_this.invalidInboardLenght=false;_this.requiredFieldsList=props.boat.specificationsRequiredFieldsList||[];return _this;}_createClass(BoatSpecifications,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].modelYears).then(function(_ref3){var data=_ref3.data;_this2.modelYears=data.sort();_this2.forceUpdate();});this.updateRequiredFieldsList();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var updateInfo={};this.requiredFieldsList=nextProps.boat.specificationsRequiredFieldsList||[];for(var key in nextProps.boat.boatSpecifications){if(nextProps.boat.boatSpecifications.hasOwnProperty(key)){if(!this.props.boat.boatSpecifications){updateInfo=nextProps.boat.boatSpecifications;break;}if(this.props.boat.boatSpecifications[key]!==nextProps.boat.boatSpecifications[key]){updateInfo[key]=nextProps.boat.boatSpecifications[key];}}}if(Object.keys(updateInfo).length){this.setState(updateInfo);}return true;}},{key:'render',value:function render(){var _this3=this;var _state=this.state,name=_state.name,year=_state.year,lengthFeet=_state.lengthFeet,lengthInches=_state.lengthInches,widthFeet=_state.widthFeet,widthInches=_state.widthInches,weightOfFinishedBoat=_state.weightOfFinishedBoat,weightOfUnfinishedBoat=_state.weightOfUnfinishedBoat,transformHeightAtCenterline=_state.transformHeightAtCenterline,fuelTankCapacity=_state.fuelTankCapacity,motorType=_state.motorType,dieselPower=_state.dieselPower,hasElectricPropulsion=_state.hasElectricPropulsion,engineAndDriveWeight=_state.engineAndDriveWeight,dieselPowerCode=_state.dieselPowerCode,displacement=_state.displacement,inboardLengthFeet=_state.inboardLengthFeet,inboardLengthInches=_state.inboardLengthInches,maxBoatBeamFeet=_state.maxBoatBeamFeet,maxBoatBeamInches=_state.maxBoatBeamInches,inboardArea=_state.inboardArea,unavInboardArea=_state.unavInboardArea,transformFlag=_state.transformFlag,ribFlag=_state.ribFlag,combinedAirChambersVolume=_state.combinedAirChambersVolume,inherentBuoyancyVolume=_state.inherentBuoyancyVolume,subType=_state.subType,bottomContour=_state.bottomContour,cityAndStateForCapacityTag=_state.cityAndStateForCapacityTag;var _props=this.props,boat=_props.boat,getNavBar=_props.getNavBar,getHeader=_props.getHeader,stepIsChanged=_props.stepIsChanged;var selectedBottomContour=boat.bottomContourList.find(function(bc){return bc.value===bottomContour;});var selectedEngineSubType=boat.engineSubTypesList.find(function(bc){return bc.value===subType;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(this.saveData),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section scene_section_two-columns _border_top_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{label:'Model Name *',mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',maxLength:250,error:this.isError('name'),value:name,onChange:this.handleInputChange('name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:this.modelYears,type:'primary',defaultItem:year&&year.toString(),disabled:boat.status!=='DRAFT'&&isFinite(boat.id),label:'Model Year *',error:this.isError('year'),handleSelect:this.handleSelectYear}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_GoogleSelect__["a" /* default */],{selectionList:this.stateCodes,inputClassName:'_border_radius_10 _height_40 _width_pc_100 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10 _top_65',itemClassName:'select__drop-down-item',defaultItem:cityAndStateForCapacityTag,placeholder:'Please start typing your City',label:'City and State *',error:this.isError('cityAndStateForCapacityTag'),handleSelect:this.handleCityAndStateForCapacityTag}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'google-powered-icon _position_absolute _right_15 _bottom_15 _height_20 _width_160'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section scene_section_two-columns boat-specification-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Specification'),lengthFeet!==undefined&&lengthInches!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'Overall Length *',value:lengthFeet,onChange:this.handleInputChange('lengthFeet'),styles:{width:165,height:40},error:this.isError('lengthFeet'),additionalValidation:this.validateBoatLength,units:'Ft.',isNumeric:true,digitsAfterDot:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'',value:lengthInches,onChange:this.handleInputChange('lengthInches'),styles:{width:165,height:40},error:this.isError('lengthInches'),units:'In.',additionalValidation:this.validateInches,isNumeric:true})),maxBoatBeamFeet!==undefined&&maxBoatBeamInches!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'Maximum Boat Beam * ',value:maxBoatBeamFeet,onChange:this.handleInputChange('maxBoatBeamFeet'),styles:{width:165,height:40},error:this.isError('maxBoatBeamFeet'),units:'Ft.',isNumeric:true,digitsAfterDot:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'',value:maxBoatBeamInches,onChange:this.handleInputChange('maxBoatBeamInches'),styles:{width:165,height:40},error:this.isError('maxBoatBeamInches'),units:'In.',additionalValidation:this.validateInches,isNumeric:true})),inboardLengthFeet!==undefined&&inboardLengthInches!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'Inboard Length *',value:inboardLengthFeet,onChange:this.handleInputChange('inboardLengthFeet'),styles:{width:165,height:40},error:this.isError('inboardLengthFeet'),units:'Ft.',isNumeric:true,digitsAfterDot:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'',value:inboardLengthInches,onChange:this.handleInputChange('inboardLengthInches'),styles:{width:165,height:40},error:this.isError('inboardLengthInches'),units:'In.',additionalValidation:this.validateInches,isNumeric:true})),inboardArea!==undefined&&unavInboardArea!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Inboard Area *',value:inboardArea,units:'Sq. Ft.',error:this.isError('inboardArea'),onChange:this.handleInputChange('inboardArea')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Unavailable Inboard Area *',value:unavInboardArea,units:'Sq. Ft.',error:this.isError('unavInboardArea'),onChange:this.handleInputChange('unavInboardArea')})),widthFeet!==undefined&&widthInches!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'Overall Stern Width *',value:widthFeet,onChange:this.handleInputChange('widthFeet'),styles:{width:165,height:40},error:this.isError('widthFeet'),units:'Ft.',isNumeric:true,digitsAfterDot:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["b" /* MultiInput */],{label:'',value:widthInches,onChange:this.handleInputChange('widthInches'),styles:{width:165,height:40},units:'In.',additionalValidation:this.validateInches,isNumeric:true})),weightOfUnfinishedBoat!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Weight of Unfinished Boat (does not include fuel)*',value:weightOfUnfinishedBoat,units:'Lbs.',error:this.isError('weightOfUnfinishedBoat'),onChange:this.handleInputChange('weightOfUnfinishedBoat')}),bottomContour!==undefined&&(boat.bottomContourList.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:boat.bottomContourList,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',defaultItem:selectedBottomContour,itemNameIndicator:'name',label:'Bottom Contour *',error:this.isError('bottomContour'),handleSelect:this.handleSelect('bottomContour')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'static-input-plug'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Bottom Contour *'),'Flat')),weightOfFinishedBoat!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:boat.engineType===__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["p" /* NON_POWERED */]?'Boat Dry Weight *':'Weight of Finished Boat (does not include fuel)*',value:weightOfFinishedBoat,units:'Lbs.',error:this.isError('weightOfFinishedBoat'),onChange:this.handleInputChange('weightOfFinishedBoat')}),transformHeightAtCenterline!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Transom Height at Centerline *',value:transformHeightAtCenterline,units:'In.',error:this.isError('transformHeightAtCenterline'),onChange:this.handleInputChange('transformHeightAtCenterline')}),engineAndDriveWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:boat.boatType===__WEBPACK_IMPORTED_MODULE_9__constants_boatApplication__["r" /* PONTOON */]?'Engine and Drive Weight *':'Engine and Drive Weight including Batt *',value:engineAndDriveWeight,units:'Lbs.',error:this.isError('engineAndDriveWeight'),onChange:this.handleInputChange('engineAndDriveWeight')}),fuelTankCapacity!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Fuel Tank Capacity *',value:fuelTankCapacity,units:'Gals.',error:this.isError('fuelTankCapacity'),onChange:this.handleInputChange('fuelTankCapacity')}),displacement!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Displacement *',value:displacement,units:'cc',additionalValidation:this.validateDisplacement,error:this.isError('displacement'),onChange:this.handleInputChange('displacement'),digitsAfterDot:0})),transformFlag!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section air-chambers-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Air Chambers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Checkbox__["a" /* default */],{value:transformFlag,label:'Transom',onChange:this.toggleValue('transformFlag'),labelType:'_margin_left_10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_Checkbox__["a" /* default */],{value:ribFlag,label:'RIB',onChange:this.toggleValue('ribFlag'),labelType:'_margin_left_30'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary _margin_right_30',inputClassName:'input__input-field_primary',label:'Combined Volume of all Air Chambers *',value:combinedAirChambersVolume,units:' Cu. Ft.',onChange:this.handleInputChange('combinedAirChambersVolume'),error:this.isError('combinedAirChambersVolume')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Inherent Buoyancy Volume *',value:inherentBuoyancyVolume,units:' Cu. Ft.',onChange:this.handleInputChange('inherentBuoyancyVolume'),disabled:!ribFlag,error:this.isError('inherentBuoyancyVolume')})),subType!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Engine'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:boat.engineSubTypesList,mainWrapperClassName:'_width_330',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',defaultItem:selectedEngineSubType,itemNameIndicator:'name',label:'Sub Type',error:this.isError('subType'),handleSelect:this.handleSelect('subType')})),(motorType!==undefined||dieselPower!==undefined)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AdditionalSection__["a" /* default */],{motorType:motorType,hasElectricPropulsion:hasElectricPropulsion,dieselPower:dieselPower,dieselPowerCode:dieselPowerCode,isError:this.isError,handleDieselToggle:this.handleDieselToggle,handleDieselTypeChose:this.handleDieselTypeChose,toggleMotorType:this.toggleMotorType,toggleHasElectricPropulsion:this.toggleHasElectricPropulsion}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_ApplicationActions__["a" /* default */],{backButtonLabel:boat.status==='DRAFT'||!isFinite(boat.id)?'Prev. Step':'',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this3.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return BoatSpecifications;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BoatSpecifications);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Checkbox__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var dieselPower=_ref.dieselPower,motorType=_ref.motorType,toggleMotorType=_ref.toggleMotorType,hasElectricPropulsion=_ref.hasElectricPropulsion,toggleHasElectricPropulsion=_ref.toggleHasElectricPropulsion,dieselPowerCode=_ref.dieselPowerCode,handleDieselToggle=_ref.handleDieselToggle,handleDieselTypeChose=_ref.handleDieselTypeChose,isError=_ref.isError;var getDefaultDieselPowerCode=function getDefaultDieselPowerCode(){return dieselPowerCode?dieselPowerCode[0].toUpperCase()+dieselPowerCode.slice(1).toLowerCase():'';};if(motorType!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section motor-specification-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Motor Specifications'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Slider__["a" /* default */],{state:motorType===__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["w" /* SINGLE */],mainWrapperClassName:'green',label:'Motor Type',onLabel:'Single',offLabel:'Twin',toggleAction:toggleMotorType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Slider__["a" /* default */],{state:!hasElectricPropulsion,mainWrapperClassName:'green',label:'Electric Propulsion',onLabel:'No',offLabel:'Yes',toggleAction:toggleHasElectricPropulsion}));}if(dieselPower!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section  fuel-type-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Fuel Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Checkbox__["a" /* default */],{value:dieselPower,label:'Diesel Power',onChange:handleDieselToggle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:__WEBPACK_IMPORTED_MODULE_4_constants_boatApplication__["h" /* DIESEL_POWER_TYPE */],mainWrapperClassName:'_width_330',inputClassName:'_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',defaultItem:getDefaultDieselPowerCode(),label:'Diesel Power Type',disabled:!dieselPower,handleSelect:handleDieselTypeChose,error:isError('dieselPowerCode')}));}return null;});

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleSelect=function(_React$Component){_inherits(GoogleSelect,_React$Component);function GoogleSelect(props){_classCallCheck(this,GoogleSelect);var _this=_possibleConstructorReturn(this,(GoogleSelect.__proto__||Object.getPrototypeOf(GoogleSelect)).call(this,props));_this.getDropDownList=function(){var searchResults=_this.state.searchResults;var itemClassName=_this.props.itemClassName;return searchResults.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'select__drop-down-item select__drop-down-item_primary '+itemClassName,onClick:_this.handleSelect(element)},element);});};_this.openDropDown=function(event){if(!_this.state.isOpen){document.addEventListener('click',_this.closeDropDown);_this.setState({isOpen:true});}else{event.nativeEvent.stopImmediatePropagation();}};_this.closeDropDown=function(){if(_this.state.isOpen){document.removeEventListener('click',_this.closeDropDown);}_this.setState({isOpen:false,searchValue:_this.lastSelected});};_this.handleInputChange=function(_ref){var target=_ref.target;_this.setState({searchValue:target.value},function(){if(_this.places&&target.value){_this.places.getPlacePredictions({input:target.value,types:['(cities)']},function(predictions){var searchResults=[];if(predictions){predictions.forEach(function(prediction){return searchResults.push(prediction.description);});}_this.setState({searchResults:searchResults});});}});};_this.handleSelect=function(searchValue){return function(event){event.stopPropagation();event.nativeEvent.stopPropagation();_this.lastSelected=searchValue;_this.setState({searchValue:searchValue},function(){return _this.props.handleSelect(searchValue);});};};_this.handleClearInputClick=function(event){var searchValue=_this.state.searchValue;var _this$props=_this.props,defaultItem=_this$props.defaultItem,handleSelect=_this$props.handleSelect;if(searchValue||defaultItem){event.stopPropagation();if(event.nativeEvent)event.nativeEvent.stopImmediatePropagation();_this.setState({searchValue:''},function(){if(defaultItem)handleSelect('',event);});}};_this.state={isOpen:false,searchValue:null,searchResults:[]};_this.places=null;_this.lastSelected='';return _this;}_createClass(GoogleSelect,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.places&&window.google){this.places=$$initService();}if(this.state.searchValue===null&&this.props.defaultItem){this.lastSelected=this.props.defaultItem;this.setState({searchValue:this.props.defaultItem});}if(!this.state.isOpen&&this.state.searchValue!==this.props.defaultItem){this.lastSelected=this.props.defaultItem;this.setState({searchValue:this.props.defaultItem});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.closeDropDown);}},{key:'render',value:function render(){var _state=this.state,isOpen=_state.isOpen,searchValue=_state.searchValue;var _props=this.props,label=_props.label,placeholder=_props.placeholder,error=_props.error,capitalizeLabel=_props.capitalizeLabel,disabled=_props.disabled,inputClassName=_props.inputClassName,dropDownClassName=_props.dropDownClassName,inputFieldWrapperClassName=_props.inputFieldWrapperClassName,mainWrapperClassName=_props.mainWrapperClassName,labelClassName=_props.labelClassName,tabIndex=_props.tabIndex;var updatedLabel=label&&capitalizeLabel?label[0].toUpperCase()+label.slice(1).toLowerCase():label;var errorTextElement=error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-select-error'},error):null;var isOpenClass=isOpen?'open':'';var errorClass=''+(error?'error':'');var mainWrapperClasses='select__main-wrapper select__main-wrapper_primary\n    '+errorClass+' '+mainWrapperClassName;var labelClasses='select__label select__label_primary '+labelClassName;var inputFieldWrapperClasses='select__input-field-wrapper\n    select__input-field-wrapper_primary '+inputFieldWrapperClassName;// const loadPlaceholderClasses = `select__loading-placeholder select__loading-placeholder_primary ${inputClassName}`;
var inputFieldClasses='select__input select__input_primary\n                   '+inputClassName+' '+(disabled?'select__input_primary_disabled':'')+' '+isOpenClass+' '+errorClass;var inputFieldIconClasses='select__clear-input-icon select__clear-input-icon_primary\n              '+(searchValue?'select__clear-input-icon_primary_clear-mode':'');var dropDownListClasses='select__drop-down-list select__drop-down-list_primary\n    '+isOpenClass+' '+dropDownClassName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:mainWrapperClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelClasses},updatedLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputFieldWrapperClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:searchValue,className:inputFieldClasses,placeholder:placeholder,disabled:disabled,onChange:this.handleInputChange,tabIndex:tabIndex,onFocus:this.openDropDown,onClick:this.openDropDown}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputFieldIconClasses,onClick:this.handleClearInputClick}),errorTextElement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dropDownListClasses},this.getDropDownList()));}}]);return GoogleSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);GoogleSelect.propTypes={defaultItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,handleSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),capitalizeLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,inputClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dropDownClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mainWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputFieldWrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,itemClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tabIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};GoogleSelect.defaultProps={defaultItem:'',handleSelect:function handleSelect(){},label:'',placeholder:'',error:'',capitalizeLabel:false,disabled:false,inputClassName:'',dropDownClassName:'',mainWrapperClassName:'',inputFieldWrapperClassName:'',labelClassName:'',itemClassName:'',tabIndex:0};/* harmony default export */ __webpack_exports__["a"] = (GoogleSelect);function $$initService(){if(window.google){return new window.google.maps.places.AutocompleteService();}else{return null;}}

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CubicCapacityScene;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CubicCapacity__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BoatDimensions__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
function CubicCapacityScene(props){if(props.boat.boatType===__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["r" /* PONTOON */])return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BoatDimensions__["a" /* default */],props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CubicCapacity__["a" /* default */],props);}

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CubicCapacityInput__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_boatApplication__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CubicCapacity=function(_React$Component){_inherits(CubicCapacity,_React$Component);function CubicCapacity(props){_classCallCheck(this,CubicCapacity);var _this=_possibleConstructorReturn(this,(CubicCapacity.__proto__||Object.getPrototypeOf(CubicCapacity)).call(this,props));_this.validateStep=function(){var _this$state=_this.state,isManual=_this$state.isManual,cubicCapacity=_this$state.cubicCapacity,isAreas=_this$state.isAreas,areas=_this$state.areas,calculationLength=_this$state.calculationLength,volumeWithinMotor=_this$state.volumeWithinMotor;return new Promise(function(resolve,reject){if(isManual){if(cubicCapacity){resolve();}else{_this.errors.cubicCapacity=true;_this.forceUpdate();reject();}}else{var stepValid=true;if(isAreas){Object.keys(areas).forEach(function(areaName){if(areas[areaName].area===undefined||areas[areaName].area===''||areas[areaName].area===null||_this.errors[areaName]&&_this.errors[areaName].area){if(!_this.errors[areaName])_this.errors[areaName]={};_this.errors[areaName].area=_this.errors[areaName].area||true;stepValid=false;}});}else{Object.keys(areas).forEach(function(areaName){_this.tableRows.forEach(function(rowName){if(areas[areaName][rowName]===undefined||areas[areaName][rowName]===''||areas[areaName][rowName]===null||_this.errors[areaName]&&_this.errors[areaName][rowName]){if(!_this.errors[areaName])_this.errors[areaName]={};_this.errors[areaName][rowName]=_this.errors[areaName][rowName]||true;stepValid=false;}});});}if(calculationLength===undefined||calculationLength===''||calculationLength===null||_this.errors.calculationLength){_this.errors.calculationLength=_this.errors.calculationLength||true;stepValid=false;}if(volumeWithinMotor===undefined||volumeWithinMotor===''||volumeWithinMotor===null||_this.errors.volumeWithinMotor){_this.errors.volumeWithinMotor=_this.errors.volumeWithinMotor||true;stepValid=false;}if(stepValid){resolve();}else{_this.forceUpdate();reject();}}});};_this.isEmptyInputs=function(){var _this$state2=_this.state,isAreas=_this$state2.isAreas,areas=_this$state2.areas,calculationLength=_this$state2.calculationLength,volumeWithinMotor=_this$state2.volumeWithinMotor;var emptyInputs=true;if(isAreas){Object.keys(areas).forEach(function(areaName){if(areas[areaName].area===undefined||areas[areaName].area===''||areas[areaName].area===null||_this.errors[areaName]&&_this.errors[areaName].area)emptyInputs=false;});}else{Object.keys(areas).forEach(function(areaName){_this.tableRows.forEach(function(rowName){if(areas[areaName][rowName]===undefined||areas[areaName][rowName]===''||areas[areaName][rowName]===null||_this.errors[areaName]&&_this.errors[areaName][rowName])emptyInputs=false;});});}if(calculationLength===undefined||calculationLength===''||calculationLength===null||_this.errors.calculationLength)emptyInputs=false;if(volumeWithinMotor===undefined||volumeWithinMotor===''||volumeWithinMotor===null||_this.errors.volumeWithinMotor)emptyInputs=false;return emptyInputs;};_this.handleCapacityInputTypeChange=function(isManual){return function(){_this.setState({isManual:isManual},function(){_this.errors={};});};};_this.toggleAreasInput=function(){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();_this.setState(function(prevState){return{isAreas:!prevState.isAreas};},function(){if(!_this.state.isAreas){for(var field in _this.state.areas){_this.areasCalculation(field,_this.state.areas,true);}}});};_this.handleInputChange=function(targetField){return function(value){var markStepAsRedacted=_this.props.markStepAsRedacted;var isManual=_this.state.isManual;markStepAsRedacted();if(value!==null){if(_this.errors[targetField])delete _this.errors[targetField];_this.setState(_defineProperty({},targetField,value),function(){if(!isManual)_this.mainCalculation();});}};};_this.handleAreaChange=function(columnName){return function(value){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(value!==null){var cubicCapacityMatrix=Object.assign({},_this.state.areas);cubicCapacityMatrix[columnName].area=value;if(_this.errors[columnName]&&_this.errors[columnName].area)delete _this.errors[columnName].area;_this.setState({areas:cubicCapacityMatrix},_this.mainCalculation);}};};_this.handleMatrixChange=function(columnName,rowName){return function(value,error){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(value===''||error){if(!_this.errors[columnName])_this.errors[columnName]={};_this.errors[columnName][rowName]=error||true;}else{if(_this.errors[columnName]&&_this.errors[columnName][rowName])delete _this.errors[columnName][rowName];}var cubicCapacityMatrix=Object.assign({},_this.state.areas);cubicCapacityMatrix[columnName][rowName]=value;_this.areasCalculation(columnName,cubicCapacityMatrix);_this.setState({areas:cubicCapacityMatrix});};};_this.mainCalculation=function(){var _this$state3=_this.state,volumeWithinMotor=_this$state3.volumeWithinMotor,calculationLength=_this$state3.calculationLength,areas=_this$state3.areas;var id=_this.props.boat.id;var allEnteredAreas=function checkAllAreas(){var allAreasEntered={};Object.keys(areas).forEach(function(element){if(areas[element].area)allAreasEntered[element]=areas[element].area;});return allAreasEntered;}();if(volumeWithinMotor&&calculationLength&&Object.keys(allEnteredAreas).length===5){var index=++_this.mainCalculationRequestIndex;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].calculateCapacity(id),{calculationLength:+calculationLength,volumeWithinMotor:+volumeWithinMotor,areas:allEnteredAreas}).then(function(_ref){var data=_ref.data;_this.mainCalculationRequest[index]=+data.toFixed(2);_this.setState({cubicCapacity:_this.mainCalculationRequest[_this.mainCalculationRequest.length-1]});});}};_this.areasCalculation=function(type,matrix,isWithoutIndexes){var id=_this.props.boat.id;var enteredFields=[];Object.keys(matrix[type]).forEach(function(element){if(element!=='area'&&matrix[type][element])enteredFields.push(matrix[type][element]);});var cubicCapacityMatrix={};if(enteredFields.length>=_this.tableRows.length){Object.keys(matrix[type]).forEach(function(element){cubicCapacityMatrix[element]=matrix[type][element]!==''?parseFloat(matrix[type][element]):0;});var index=++_this.calculationRequestIndex;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].checkMatrix(id),Object.assign({type:type},cubicCapacityMatrix)).then(function(response){_this.calculationRequest[index]=+response.data.toFixed(2);_this.saveCapacity(type,matrix,isWithoutIndexes?+response.data.toFixed(2):_this.calculationRequest[_this.calculationRequest.length-1]);});}else{_this.saveCapacity(type,matrix,undefined);}};_this.saveCapacity=function(type,matrix,data){if(data===undefined)delete matrix[type].area;else matrix[type].area=data;_this.setState(function(prevState){return{areas:Object.assign({},prevState.areas,_defineProperty({},type,Object.assign({},matrix[type])))};},function(){return _this.mainCalculation();});};_this.sendCapacityToBackEnd=function(){var id=_this.props.boat.id;var _this$state4=_this.state,isManual=_this$state4.isManual,isAreas=_this$state4.isAreas,cubicCapacity=_this$state4.cubicCapacity,areas=_this$state4.areas,calculationLength=_this$state4.calculationLength,volumeWithinMotor=_this$state4.volumeWithinMotor;return new Promise(function(resolve,reject){var data={manualCubicCapacity:isManual,manualAreas:isAreas,boatId:id};if(isManual){data.cubicCapacity=parseFloat(cubicCapacity);}else{if(isAreas){data.areas=[].concat(_toConsumableArray(Object.keys(areas).map(function(type){return{type:type,area:parseFloat(areas[type].area)};})));}else{var newAreas=areas;data.areas=[].concat(_toConsumableArray(Object.keys(newAreas).map(function(type){Object.keys(newAreas[type]).forEach(function(element){return newAreas[type][element]=parseFloat(newAreas[type][element]);});delete newAreas[type].type;return Object.assign({type:type},newAreas[type]);})));}data.calculationLength=calculationLength;data.volumeWithinMotor=volumeWithinMotor;}__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].saveCubicCapacity,data).then(resolve).catch(reject);});};_this.handleMoveToNextStep=function(){var _this$props=_this.props,updateBoatDetails=_this$props.updateBoatDetails,goToStep=_this$props.goToStep;_this.validateStep().then(function(){_this.sendCapacityToBackEnd().then(function(){updateBoatDetails({cubicCapacity:Object.assign({},_this.state)});goToStep('next',true);});});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props2=_this.props,goToStep=_this$props2.goToStep,stepIsChanged=_this$props2.stepIsChanged,updateBoatDetails=_this$props2.updateBoatDetails;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.validateStep().then(function(){_this.sendCapacityToBackEnd().then(function(){updateBoatDetails({cubicCapacity:Object.assign({},_this.state)});goToStep(typeof stepId==='string'?stepId:'prev',true);});}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});};_this.state=props.boat.cubicCapacity;_this.calculationRequest=[];_this.calculationRequestIndex=0;_this.mainCalculationRequest=[];_this.mainCalculationRequestIndex=0;_this.errors={};_this.tableRows=['a','b','c','d'];if(props.boat.boatType!==__WEBPACK_IMPORTED_MODULE_5__constants_boatApplication__["n" /* JON_BOAT */]&&props.boat.boatType!==__WEBPACK_IMPORTED_MODULE_5__constants_boatApplication__["g" /* CATAMARAN */])_this.tableRows.unshift('beam');if(props.boat.boatType!==__WEBPACK_IMPORTED_MODULE_5__constants_boatApplication__["n" /* JON_BOAT */])_this.tableRows.push('e','f');if(props.boat.boatType===__WEBPACK_IMPORTED_MODULE_5__constants_boatApplication__["g" /* CATAMARAN */])_this.tableRows.push('g','h');return _this;}_createClass(CubicCapacity,[{key:'render',value:function render(){var _this2=this;var isManual=this.state.isManual;var _props=this.props,getHeader=_props.getHeader,getNavBar=_props.getNavBar,stepIsChanged=_props.stepIsChanged,updateBoatDetails=_props.updateBoatDetails,boat=_props.boat;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(function(){return new Promise(function(resolve,reject){_this2.validateStep().then(function(){_this2.sendCapacityToBackEnd();updateBoatDetails({cubicCapacity:Object.assign({},_this2.state)});resolve();});});}),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section cubic-capacity-input-type-section _border_top_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Cubic Capacity Input'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cubic-capacity-type-button-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(isManual?'active':''),onClick:this.handleCapacityInputTypeChange(true)},'Manual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(isManual?'':'active'),onClick:this.handleCapacityInputTypeChange(false)},'Matrix')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Attention: Future data calculations depend on the selected option.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CubicCapacityInput__["a" /* default */],Object.assign({errors:this.errors,areaTypes:this.state.areas,tableRows:this.tableRows,handleInputChange:this.handleInputChange,handleMatrixChange:this.handleMatrixChange,toggleAreasInput:this.toggleAreasInput,handleAreaChange:this.handleAreaChange,isEmptyInputs:this.isEmptyInputs,boat:boat},this.state)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this2.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return CubicCapacity;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CubicCapacity);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_CalculatedOutput__ = __webpack_require__(229);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var CubicCapacityInput=function(_React$Component){_inherits(CubicCapacityInput,_React$Component);function CubicCapacityInput(props){_classCallCheck(this,CubicCapacityInput);var _this=_possibleConstructorReturn(this,(CubicCapacityInput.__proto__||Object.getPrototypeOf(CubicCapacityInput)).call(this,props));_this.showSelectedAreaPicture=function(areaStyleName){return function(){_this.setState({areaPictureStyle:areaStyleName});};};_this.showDefaultAreaPicture=function(){_this.setState({areaPictureStyle:'default-picture'});};_this.getManualInputField=function(){var _this$props=_this.props,cubicCapacity=_this$props.cubicCapacity,handleInputChange=_this$props.handleInputChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Capacity Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Cubic Capacity *',error:_this.isError('cubicCapacity'),value:cubicCapacity,onChange:handleInputChange('cubicCapacity'),units:'Cu. Ft.'}));};_this.isError=function(field,subField){return subField?_this.props.errors[field]&&_this.props.errors[field][subField]:_this.props.errors[field];};_this.getMatrixInputField=function(){var _this$props2=_this.props,areas=_this$props2.areas,calculationLength=_this$props2.calculationLength,volumeWithinMotor=_this$props2.volumeWithinMotor,cubicCapacity=_this$props2.cubicCapacity,handleInputChange=_this$props2.handleInputChange,handleMatrixChange=_this$props2.handleMatrixChange,isAreas=_this$props2.isAreas,toggleAreasInput=_this$props2.toggleAreasInput,tableRows=_this$props2.tableRows,boat=_this$props2.boat,isEmptyInputs=_this$props2.isEmptyInputs;var areaPictureStyle=_this.state.areaPictureStyle;var getAreaPictureTypeStyle=function getAreaPictureTypeStyle(boatType){if(boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */]||boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["u" /* SAILBOAT */])return'boat';if(boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */])return'catamaran';if(boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["n" /* JON_BOAT */])return'jonboat';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Capacity Data',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Slider__["a" /* default */],{state:isAreas,label:'Areas Only',onLabel:'On',offLabel:'Off',toggleAction:toggleAreasInput})),(boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["b" /* BOAT */]||boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["u" /* SAILBOAT */]||boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["g" /* CATAMARAN */]||boat.boatType===__WEBPACK_IMPORTED_MODULE_1_constants_boatApplication__["n" /* JON_BOAT */])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'area-picture '+getAreaPictureTypeStyle(boat.boatType)+' '+areaPictureStyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:0,cellSpacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Dimensions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Eight Length Fwd (AA)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quarter Length FWD (A)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Amid Ships (B)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quarter Length Alt (C)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Transom (D)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tableRows.map(function(rowName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:isAreas?'hidden':'',key:rowName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowName==='beam'?'Full Beam':rowName),_this.tableColumns.map(function(columnName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:columnName,className:_this.isError([columnName],[rowName])?'invalid-cell':columnName+'  '+rowName+' '+_this.props.errors+'  '+_this.props.errors[columnName]+'  '+(_this.props.errors[columnName]?_this.props.errors[columnName][rowName]:'none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{isNumeric:true,unitsTop:10,inputClassName:'_height_pc_100 _width_pc_100',inputFieldWrapperClassName:'_height_pc_100 _width_pc_100',value:areas[columnName][rowName],onChange:handleMatrixChange(columnName,rowName),onBlur:_this.showDefaultAreaPicture,onFocus:_this.showSelectedAreaPicture(columnName),units:'In.'}));}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,_this.getAreaTableRow()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Cubic Capacity Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary _margin_right_30',inputClassName:'input__input-field_primary',label:'Calculation Length *',error:_this.isError('calculationLength'),value:calculationLength,onChange:handleInputChange('calculationLength'),units:'In.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Volume Within Motor *',error:_this.isError('volumeWithinMotor'),value:volumeWithinMotor,onChange:handleInputChange('volumeWithinMotor'),units:'Cu. In.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Calculated Cubic Capacity',value:isEmptyInputs()?cubicCapacity:'',units:'Cu. Ft.'}));};_this.getAreaTableRow=function(){var _this$props3=_this.props,areas=_this$props3.areas,isAreas=_this$props3.isAreas,handleAreaChange=_this$props3.handleAreaChange;if(isAreas){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Area'),_this.tableColumns.map(function(columnName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:columnName,className:_this.isError(columnName,'area')?'error':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{isNumeric:true,unitsTop:10,inputClassName:'_height_pc_100 _width_pc_100',inputFieldWrapperClassName:'_height_pc_100 _width_pc_100',value:areas[columnName].area!==undefined?areas[columnName].area:'',error:_this.isError(columnName,'area'),onChange:handleAreaChange(columnName,'area'),onBlur:_this.showDefaultAreaPicture,onFocus:_this.showSelectedAreaPicture(columnName),units:'In.'}));}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'output'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Area'),_this.tableColumns.map(function(columnName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:columnName},areas[columnName].area!==undefined?(+areas[columnName].area).toFixed(2)+' In.':'No data');}));};_this.state={calculationLengthError:null,volumeWithinMotorError:null,cubicCapacityError:null,areaPictureStyle:'default-picture'};_this.tableColumns=Object.keys(props.areaTypes).sort();return _this;}_createClass(CubicCapacityInput,[{key:'render',value:function render(){var isManual=this.props.isManual;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section cubic-capacity-input-section'},isManual?this.getManualInputField():this.getMatrixInputField());}}]);return CubicCapacityInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CubicCapacityInput);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MatrixInput__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_CalculatedOutput__ = __webpack_require__(229);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoatDimensions=function(_React$Component){_inherits(BoatDimensions,_React$Component);function BoatDimensions(props){_classCallCheck(this,BoatDimensions);var _this=_possibleConstructorReturn(this,(BoatDimensions.__proto__||Object.getPrototypeOf(BoatDimensions)).call(this,props));_this.showSelectedAreaPicture=function(areaStyleName){return function(){_this.setState({areaPictureStyle:areaStyleName});};};_this.showDefaultAreaPicture=function(){_this.setState({areaPictureStyle:'default-picture'});};_this.handleMatrixChange=function(matrixName){return function(columnId,rowId){return function(value,error){var markStepAsRedacted=_this.props.markStepAsRedacted;var _this$state=_this.state,invalidCells=_this$state.invalidCells,tubes=_this$state.tubes;markStepAsRedacted();if(error||!value){invalidCells[columnId][rowId]=true;}else{if(invalidCells[columnId][rowId])delete invalidCells[columnId][rowId];}tubes[columnId][rowId]=value;if(_this.calculatedColumns[columnId])delete _this.calculatedColumns[columnId];_this.setState({tubes:tubes,invalidCells:invalidCells},function(){_this.isMatrixFilled(matrixName,rowId).then(function(){if(!_this.isFirstTypeForLastValue){_this.isFirstTypeForLastValue=true;if(_this.timerIndex)clearTimeout(_this.timerIndex);_this.timerIndex=setTimeout(function(){_this.isFirstTypeForLastValue=false;_this.calculateData();},1000);}});});};};};_this.toggleThreeTubes=function(){var markStepAsRedacted=_this.props.markStepAsRedacted;var _this$state2=_this.state,hasCenterTube=_this$state2.hasCenterTube,invalidCells=_this$state2.invalidCells,tubes=_this$state2.tubes;markStepAsRedacted();if(!hasCenterTube){_this.boatDimensionsTable.columns.splice(1,0,{name:'Center',targetFieldId:'CENTER'});_this.boatVolumeTable.columns.splice(1,0,{name:'Center',targetFieldId:'CENTER'});tubes.CENTER={diameter:0,sectionLength:0,totalLength:0,totalVolumePerTube:0,type:'CENTER',volumeOfEndCap:0,volumeOfNoseCone:0,volumeOfOthers:0,volumeOfSection:0};var state={hasCenterTube:true,tubes:tubes};if(!invalidCells.CENTER)state.invalidCells=Object.assign({},invalidCells,{CENTER:{}});_this.setState(state);}else{_this.boatDimensionsTable.columns.splice(1,1);_this.boatVolumeTable.columns.splice(1,1);delete invalidCells.CENTER;var _state={hasCenterTube:false,invalidCells:invalidCells};_this.setState(_state);}};_this.isMatrixFilled=function(matrixName){var _this$state3=_this.state,invalidCells=_this$state3.invalidCells,tubes=_this$state3.tubes;var table=matrixName==='tubeBody'?_this.boatDimensionsTable:_this.boatVolumeTable;return new Promise(function(resolve,reject){var matrixFilled=true;table.columns.forEach(function(column){table.rows.forEach(function(row){if(row.isInput&&(invalidCells[column.targetFieldId][row.targetFieldId]||tubes[column.targetFieldId][row.targetFieldId]===undefined||tubes[column.targetFieldId][row.targetFieldId]===null)){matrixFilled=false;}});if(matrixName==='tubeNose'&&matrixFilled&&!_this.calculatedColumns[column.targetFieldId]){_this.calculatedColumns[column.targetFieldId]=true;resolve();}});if(matrixFilled)resolve();else reject();});};_this.validateStep=function(){var _this$state4=_this.state,invalidCells=_this$state4.invalidCells,tubes=_this$state4.tubes;return new Promise(function(resolve,reject){_this.boatDimensionsTable.columns.forEach(function(column){_this.boatDimensionsTable.rows.forEach(function(row){if((tubes[column.targetFieldId][row.targetFieldId]<=0||tubes[column.targetFieldId][row.targetFieldId]===undefined)&&row.isInput){invalidCells[column.targetFieldId][row.targetFieldId]=true;}});});_this.boatVolumeTable.columns.forEach(function(column){_this.boatVolumeTable.rows.forEach(function(row){if((tubes[column.targetFieldId][row.targetFieldId]===undefined||tubes[column.targetFieldId][row.targetFieldId]===null)&&row.isInput){invalidCells[column.targetFieldId][row.targetFieldId]=true;}});});Object.keys(invalidCells).forEach(function(columnId){if(Object.keys(invalidCells[columnId]).length){reject();_this.setState({invalidCells:invalidCells});}});resolve();});};_this.calculateData=function(isFinal){var id=_this.props.boat.id;var _this$state5=_this.state,hasCenterTube=_this$state5.hasCenterTube,tubes=_this$state5.tubes;var dataPayload={hasCenterTube:hasCenterTube,tubes:[],saveCalculations:!!isFinal};_this.boatDimensionsTable.columns.forEach(function(column){var tube={'type':column.targetFieldId};_this.boatDimensionsTable.rows.forEach(function(row){if(row.isInput&&tubes[column.targetFieldId][row.targetFieldId]!==undefined){tube[row.targetFieldId]=tubes[column.targetFieldId][row.targetFieldId];}});_this.boatVolumeTable.rows.forEach(function(row){if(row.isInput&&tubes[column.targetFieldId][row.targetFieldId]!==undefined){tube[row.targetFieldId]=tubes[column.targetFieldId][row.targetFieldId];}});dataPayload.tubes.push(tube);});return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].calculatPontoonCapacity(id),dataPayload).then(function(_ref){var data=_ref.data;var portData=0;var starPortData=0;var thirdRailData=0;data.tubes.forEach(function(tube){switch(tube.type){case'PORT':portData=tube;break;case'STARBOARD':starPortData=tube;break;case'CENTER':thirdRailData=tube;break;default:break;}});var tubes={'PORT':Object.assign({},_this.state.tubes.PORT,{volumeOfSection:portData.volumeOfSection,totalVolumePerTube:portData.totalVolumePerTube}),'STARBOARD':Object.assign({},_this.state.tubes.STARBOARD,{volumeOfSection:starPortData.volumeOfSection,totalVolumePerTube:starPortData.totalVolumePerTube}),'CENTER':{}};if(hasCenterTube&&thirdRailData!==0)tubes['CENTER']=Object.assign({},_this.state.tubes.CENTER,{volumeOfSection:thirdRailData.volumeOfSection,totalVolumePerTube:thirdRailData.totalVolumePerTube});_this.setState({tubes:tubes,calculatedPontoonDiameter:data.avgOfDiameter,calculatedPontoonLength:data.avgOfTotalLength,calculatedTubesVolume:data.totalVolumeOfAllTubes},resolve());}).catch(function(){reject();});});};_this.handleMoveToNextStep=function(){var _this$props=_this.props,updateBoatDetails=_this$props.updateBoatDetails,goToStep=_this$props.goToStep;_this.validateStep().then(function(){_this.calculateData(true).then(function(){updateBoatDetails({cubicCapacity:Object.assign({},_this.state)});goToStep('next',true);});});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props2=_this.props,goToStep=_this$props2.goToStep,stepIsChanged=_this$props2.stepIsChanged,updateBoatDetails=_this$props2.updateBoatDetails;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.validateStep().then(function(){_this.calculateData().then(function(){updateBoatDetails({cubicCapacity:Object.assign({},_this.state)});goToStep(typeof stepId==='string'?stepId:'prev',true);});}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});};_this.state=Object.assign({},props.boat.cubicCapacity,{calculatedPontoonDiameter:props.boat.cubicCapacity.calculatedPontoonDiameter||0,calculatedPontoonLength:props.boat.cubicCapacity.calculatedPontoonLength||0,calculatedTubesVolume:props.boat.cubicCapacity.calculatedTubesVolume||0,areaPictureStyle:'default-picture'});_this.boatDimensionsTable={columns:[{name:'Port',targetFieldId:'PORT'},{name:'Starboard',targetFieldId:'STARBOARD'}],rows:[{name:'Pontoon Section Length',units:' In.',targetFieldId:'sectionLength',isInput:true,digitsAfterDot:2},{name:'Total Pontoon Length',units:' In.',targetFieldId:'totalLength',isInput:true,digitsAfterDot:0},{name:'Pontoon Diameter',units:' In.',targetFieldId:'diameter',isInput:true,digitsAfterDot:2}]};_this.boatVolumeTable={columns:[{name:'Port',targetFieldId:'PORT'},{name:'Starboard',targetFieldId:'STARBOARD'}],rows:[{name:'Volume Pontoon Section',units:'Cu.Ft',targetFieldId:'volumeOfSection',isInput:false,digitsAfterDot:2},{name:'Volume of End Cap',units:'Cu.Ft',targetFieldId:'volumeOfEndCap',isInput:true,digitsAfterDot:2},{name:'Volume of Nose Cone',units:'Cu.Ft',targetFieldId:'volumeOfNoseCone',isInput:true,digitsAfterDot:2},{name:'Volume of Others',units:'Cu.Ft',targetFieldId:'volumeOfOthers',isInput:true,digitsAfterDot:2,allowNegative:true},{name:'Total Volume per Tube',units:'Cu.Ft',targetFieldId:'totalVolumePerTube',isInput:false,digitsAfterDot:2}]};if(_this.state.hasCenterTube){_this.boatDimensionsTable.columns.splice(1,0,{name:'Center',targetFieldId:'CENTER'});_this.boatVolumeTable.columns.splice(1,0,{name:'Center',targetFieldId:'CENTER'});}_this.calculatedColumns={};return _this;}_createClass(BoatDimensions,[{key:'render',value:function render(){var _this2=this;var _state2=this.state,hasCenterTube=_state2.hasCenterTube,tubes=_state2.tubes,invalidCells=_state2.invalidCells,calculatedPontoonDiameter=_state2.calculatedPontoonDiameter,calculatedPontoonLength=_state2.calculatedPontoonLength,calculatedTubesVolume=_state2.calculatedTubesVolume,areaPictureStyle=_state2.areaPictureStyle;var _props=this.props,getNavBar=_props.getNavBar,getHeader=_props.getHeader,stepIsChanged=_props.stepIsChanged,updateBoatDetails=_props.updateBoatDetails;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(function(){return new Promise(function(resolve){_this2.validateStep().then(function(){_this2.calculateData(true).then(function(){updateBoatDetails({cubicCapacity:Object.assign({},_this2.state)});resolve();});});});}),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section tube-amount-choose-section _border_top_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Pontoon Tubes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Slider__["a" /* default */],{state:hasCenterTube!==true,mainWrapperClassName:'green',label:'Number of Tubes',onLabel:'Two',offLabel:'Three',toggleAction:this.toggleThreeTubes}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section boat-dimensions-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Dimensions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MatrixInput__["a" /* default */],{areas:tubes,table:this.boatDimensionsTable,handleMatrixChange:this.handleMatrixChange('tubeBody'),showSelectedAreaPicture:this.showSelectedAreaPicture,showDefaultAreaPicture:this.showDefaultAreaPicture,invalidCells:invalidCells}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'output-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_CalculatedOutput__["b" /* CalculatedOutput */],{mainWrapperClassName:'_margin_right_30',label:'Average of Pontoon Diameter',value:calculatedPontoonDiameter,units:' In.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Average of Total Pontoon Length',value:calculatedPontoonLength,units:'In.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'area-picture '+areaPictureStyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Volume'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MatrixInput__["a" /* default */],{areas:tubes,table:this.boatVolumeTable,handleMatrixChange:this.handleMatrixChange('tubeNose'),showSelectedAreaPicture:this.showSelectedAreaPicture,showDefaultAreaPicture:this.showDefaultAreaPicture,invalidCells:invalidCells}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Total Volume of All Tubes',value:calculatedTubesVolume,units:'Cu. Ft.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this2.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return BoatDimensions;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BoatDimensions);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var MatrixInput=function(_React$Component){_inherits(MatrixInput,_React$Component);function MatrixInput(){_classCallCheck(this,MatrixInput);return _possibleConstructorReturn(this,(MatrixInput.__proto__||Object.getPrototypeOf(MatrixInput)).apply(this,arguments));}_createClass(MatrixInput,[{key:'render',value:function render(){var _props=this.props,areas=_props.areas,table=_props.table,handleMatrixChange=_props.handleMatrixChange,invalidCells=_props.invalidCells,showSelectedAreaPicture=_props.showSelectedAreaPicture,showDefaultAreaPicture=_props.showDefaultAreaPicture;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'matrix-input-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:0,cellSpacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),table.columns.map(function(column){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:column.name},column.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,table.rows.map(function(row){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:row.name,className:!row.isInput?'output':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),table.columns.map(function(column){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:row.name+column.name,className:invalidCells[column.targetFieldId][row.targetFieldId]&&'invalid-cell'},row.isInput?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Input__["a" /* Input */],{isNumeric:true,unitsTop:10,inputClassName:'_height_pc_100 _width_pc_100',inputFieldWrapperClassName:'_height_pc_100',key:row.name+column.name+'output',value:areas[column.targetFieldId][row.targetFieldId]!==undefined?areas[column.targetFieldId][row.targetFieldId]:'',onChange:handleMatrixChange(column.targetFieldId,row.targetFieldId),onBlur:showDefaultAreaPicture,onFocus:showSelectedAreaPicture(row.targetFieldId),units:row.units||column.units,digitsAfterDot:row.digitsAfterDot,allowNegative:!!row.allowNegative}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-output'},(areas[column.targetFieldId][row.targetFieldId]?areas[column.targetFieldId][row.targetFieldId].toFixed(2):'')+' '+row.units||column.units));}));}))));}}]);return MatrixInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MatrixInput);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonPowerCapacity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_type_1_png__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_type_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_type_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_type_4_png__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_type_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_type_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__personPowerCapacityEligibility__ = __webpack_require__(1125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PersonPowerCapacity=function(_React$Component){_inherits(PersonPowerCapacity,_React$Component);function PersonPowerCapacity(props){_classCallCheck(this,PersonPowerCapacity);var _this=_possibleConstructorReturn(this,(PersonPowerCapacity.__proto__||Object.getPrototypeOf(PersonPowerCapacity)).call(this,props));_this.calculateData=function(){var id=_this.props.boat.id;var showSpecifiedEngineWeight=_this.shouldShowSpecifiedEngineWeight();var _this$state=_this.state,calBoatWeight=_this$state.calBoatWeight,plateType=_this$state.plateType,reqMaxHP=_this$state.reqMaxHP,reqMaxWeight=_this$state.reqMaxWeight,reqMaxNumberOfPersons=_this$state.reqMaxNumberOfPersons,reqMaxPersonsWeight=_this$state.reqMaxPersonsWeight,reqMaxHPDualSteering=_this$state.reqMaxHPDualSteering,reqSpecifiedEngineWeight=_this$state.reqSpecifiedEngineWeight,preferredTagType=_this$state.preferredTagType,useManufacturerEngineWeight=_this$state.useManufacturerEngineWeight,apprMaxHP=_this$state.apprMaxHP,appMaxWeight=_this$state.appMaxWeight,appMaxNumberOfPersons=_this$state.appMaxNumberOfPersons,appMaxPersonsWeight=_this$state.appMaxPersonsWeight,apprMaxHPDualSteering=_this$state.apprMaxHPDualSteering,overrideApprovedValues=_this$state.overrideApprovedValues;return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].calculatePersonWeightCapacity(id),{reqMaxHP:reqMaxHP,reqMaxWeight:reqMaxWeight,reqMaxNumberOfPersons:reqMaxNumberOfPersons,reqMaxPersonsWeight:reqMaxPersonsWeight,reqMaxHPDualSteering:reqMaxHPDualSteering,reqSpecifiedEngineWeight:showSpecifiedEngineWeight?reqSpecifiedEngineWeight||0:0,preferredTagType:preferredTagType,useManufacturerEngineWeight:useManufacturerEngineWeight,overrideApprovedValues:overrideApprovedValues}).then(function(_ref){var data=_ref.data;var newState=_this.state;if(!_this.isEmptyInputs()){for(var stateFieldName in _this.state){if(_this.state[stateFieldName]!==undefined&&data[stateFieldName]!==undefined){newState[stateFieldName]=data[stateFieldName]>0?data[stateFieldName]:0;delete _this.inputErrors[stateFieldName];}}if(apprMaxHP!==undefined)newState.apprMaxHP=_this.choseApprovedValue(newState.calcMaxHP,_this.state.reqMaxHP);if(appMaxWeight!==undefined)newState.appMaxWeight=_this.choseApprovedValue(newState.calMaxWeight,_this.state.reqMaxWeight);if(appMaxNumberOfPersons!==undefined)newState.appMaxNumberOfPersons=_this.choseApprovedValue(newState.calMaxNumberOfPersons,_this.state.reqMaxNumberOfPersons);if(appMaxPersonsWeight!==undefined)newState.appMaxPersonsWeight=_this.choseApprovedValue(newState.calMaxPersonsWeight,_this.state.reqMaxPersonsWeight);if(apprMaxHPDualSteering!==undefined)newState.apprMaxHPDualSteering=_this.choseApprovedValue(newState.calcMaxHPDualSteering,_this.state.reqMaxHPDualSteering);}if(calBoatWeight!==undefined&&data.calBoatWeight)newState.calBoatWeight=data.calBoatWeight;if(reqSpecifiedEngineWeight!==undefined&&data.specifiedEngineWeight!==undefined){newState.reqSpecifiedEngineWeight=data.specifiedEngineWeight>0?data.specifiedEngineWeight:'';}if(data.useManufacturerEngineWeight!==undefined){newState.useManufacturerEngineWeight=!!data.useManufacturerEngineWeight;}if(plateType!==undefined&&data.plateType){var _plateType=data.plateType.replace(/_/g,' ').toLowerCase();newState.plateType=_plateType[0].toUpperCase()+_plateType.slice(1,_plateType.length);}_this.setState(newState,function(){_this.recalculationPending=false;resolve();});}).catch(function(){_this.recalculationPending=false;reject();});});};_this.isEmptyInputs=function(){var dualSteering=_this.props.boat.dualSteering;var emptyInputs=false;Object.keys(_this.state).filter(function(stateFieldName){return stateFieldName.includes('req');}).forEach(function(inputStateFieldName){if(_this.isOptionalField(inputStateFieldName))return;if(!_this.state[inputStateFieldName]){if(dualSteering)emptyInputs=true;else if(!dualSteering&&inputStateFieldName!=='reqMaxHPDualSteering')emptyInputs=true;}});return emptyInputs;};_this.isOptionalField=function(fieldName){return fieldName==='reqSpecifiedEngineWeight'&&!_this.isSpecifiedEngineWeightRequired();};_this.isElectricOutboard=function(){var _this$props$boat=_this.props.boat,engineType=_this$props$boat.engineType,boatSpecifications=_this$props$boat.boatSpecifications;return engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["q" /* OUTBOARD */]&&!!(boatSpecifications&&boatSpecifications.hasElectricPropulsion);};_this.getBoatOverallLength=function(){var boat=_this.props.boat;if(boat.boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["r" /* PONTOON */]){var pontoonLengthInches=Number(boat.cubicCapacity&&boat.cubicCapacity.calculatedPontoonLength);return isFinite(pontoonLengthInches)&&pontoonLengthInches>0?pontoonLengthInches/12:NaN;}var lengthFeet=Number(boat.boatSpecifications&&boat.boatSpecifications.lengthFeet);var lengthInches=Number(boat.boatSpecifications&&boat.boatSpecifications.lengthInches||0);return isFinite(lengthFeet)&&lengthFeet>0?lengthFeet+lengthInches/12:NaN;};_this.shouldShowSpecifiedEngineWeight=function(){var _this$props$boat2=_this.props.boat,boatType=_this$props$boat2.boatType,engineType=_this$props$boat2.engineType;var overallLength=_this.getBoatOverallLength();if(_this.shouldShowTagTypeSelection()){return engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["q" /* OUTBOARD */]&&_this.state.preferredTagType==='MODERN'&&_this.state.useManufacturerEngineWeight;}return engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["q" /* OUTBOARD */]&&(boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["r" /* PONTOON */]||boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["b" /* BOAT */]&&isFinite(overallLength)&&overallLength>=20&&overallLength<26);};_this.shouldShowTagTypeSelection=function(){var _this$props$boat3=_this.props.boat,boatType=_this$props$boat3.boatType,engineType=_this$props$boat3.engineType;var overallLength=_this.getBoatOverallLength();return(boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["b" /* BOAT */]||boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["r" /* PONTOON */])&&(engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["q" /* OUTBOARD */]||engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["k" /* INBOARD */])&&Object(__WEBPACK_IMPORTED_MODULE_11__personPowerCapacityEligibility__["a" /* isTagTypeSelectionLengthEligible */])(overallLength,boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["r" /* PONTOON */]);};_this.shouldShowEngineWeightSelection=function(){return _this.shouldShowTagTypeSelection()&&_this.props.boat.engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["q" /* OUTBOARD */]&&_this.state.preferredTagType==='MODERN';};_this.isSpecifiedEngineWeightRequired=function(){var dualSteering=_this.props.boat.dualSteering;if(_this.shouldShowTagTypeSelection())return _this.shouldShowSpecifiedEngineWeight();return _this.shouldShowSpecifiedEngineWeight()&&(dualSteering||_this.isElectricOutboard());};_this.getSpecifiedEngineWeightSubLabel=function(){if(_this.shouldShowTagTypeSelection())return'Required when using the manufacturer engine weight.';if(_this.isSpecifiedEngineWeightRequired()){return'Required for boats with dual steering or electric propulsion.';}return'Leave blank to continue calculating engine weight based on the S-30 table.';};_this.getPersistedStepState=function(){return Object.assign({},_this.state,{reqSpecifiedEngineWeight:_this.shouldShowSpecifiedEngineWeight()?_this.state.reqSpecifiedEngineWeight:''});};_this.recalculateAfterSelection=function(){var hasRequestedInputErrors=Object.keys(_this.inputErrors).some(function(stateFieldName){return stateFieldName.includes('req');});if(!_this.isEmptyInputs()&&!hasRequestedInputErrors&&!_this.recalculationPending){_this.recalculationPending=true;_this.calculateData().catch(function(){});}};_this.selectTagType=function(preferredTagType){if(_this.isElectricOutboard())return;var markStepAsRedacted=_this.props.markStepAsRedacted;var updates={preferredTagType:preferredTagType};if(preferredTagType==='LEGACY'){updates.useManufacturerEngineWeight=false;delete _this.inputErrors.reqSpecifiedEngineWeight;}markStepAsRedacted();_this.setState(updates,_this.recalculateAfterSelection);};_this.toggleTagType=function(){_this.selectTagType(_this.state.preferredTagType==='MODERN'?'LEGACY':'MODERN');};_this.toggleEngineWeightSource=function(){if(_this.isElectricOutboard())return;var markStepAsRedacted=_this.props.markStepAsRedacted;var useManufacturerEngineWeight=!_this.state.useManufacturerEngineWeight;if(!useManufacturerEngineWeight)delete _this.inputErrors.reqSpecifiedEngineWeight;markStepAsRedacted();_this.setState({useManufacturerEngineWeight:useManufacturerEngineWeight},function(){if(!useManufacturerEngineWeight)_this.recalculateAfterSelection();});};_this.validatePersonsWeight=function(){var _this$state2=_this.state,reqMaxNumberOfPersons=_this$state2.reqMaxNumberOfPersons,reqMaxPersonsWeight=_this$state2.reqMaxPersonsWeight,overrideApprovedValues=_this$state2.overrideApprovedValues;if(_this.props.boat.boatType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["r" /* PONTOON */]){if(reqMaxNumberOfPersons!==undefined||reqMaxPersonsWeight!==undefined){if(!overrideApprovedValues&&(+reqMaxNumberOfPersons-0.5)*141>+reqMaxPersonsWeight)_this.inputErrors.reqMaxPersonsWeight='Persons Weight can\'t be less than (Persons * 141 Lbs.).';else if(_this.inputErrors.reqMaxPersonsWeight==='Persons Weight can\'t be less than (Persons * 141 Lbs.).')delete _this.inputErrors.reqMaxPersonsWeight;_this.forceUpdate();}}else if(reqMaxNumberOfPersons!==undefined||reqMaxPersonsWeight!==undefined){if(!overrideApprovedValues&&(+reqMaxNumberOfPersons-0.5)*141-32>+reqMaxPersonsWeight)_this.inputErrors.reqMaxPersonsWeight='Persons Weight can\'t be less than (Persons * 141 Lbs.) - 32 Lbs.';else if(_this.inputErrors.reqMaxPersonsWeight==='Persons Weight can\'t be less than (Persons * 141 Lbs.) - 32 Lbs.')delete _this.inputErrors.reqMaxPersonsWeight;_this.forceUpdate();}};_this.validateMaximumWeight=function(){var _this$state3=_this.state,reqMaxWeight=_this$state3.reqMaxWeight,reqMaxPersonsWeight=_this$state3.reqMaxPersonsWeight;if(reqMaxWeight!==undefined||reqMaxPersonsWeight!==undefined){if(+reqMaxPersonsWeight>+reqMaxWeight)_this.inputErrors.reqMaxWeight='Max Weight can\'t be less than Persons Weight';else if(_this.inputErrors.reqMaxWeight==='Max Weight can\'t be less than Persons Weight')delete _this.inputErrors.reqMaxWeight;_this.forceUpdate();}};_this.validateStep=function(){return new Promise(function(resolve,reject){if(_this.recalculationPending){__WEBPACK_IMPORTED_MODULE_6_dom_managers_notification__["a" /* default */].error('note','Calculation in progress','Please wait, while system recalculate values');reject();}else{Object.keys(_this.state).filter(function(stateFieldName){return!stateFieldName.includes('app')&&!stateFieldName.includes('App')&&stateFieldName!=='plateType'&&stateFieldName!=='preferredTagType'&&stateFieldName!=='useManufacturerEngineWeight';}).forEach(function(field){if(_this.state[field]!==undefined&&!_this.isOptionalField(field)&&(!_this.state[field]||+_this.state[field]<=0)){if(!_this.inputErrors[field]){if(field.includes('cal'))_this.inputErrors[field]='The calculated values are invalid. Please verify input data';else _this.inputErrors[field]=true;}}else delete _this.inputErrors[field];if(field==='reqMaxPersonsWeight')_this.validatePersonsWeight();if(field==='reqMaxWeight')_this.validateMaximumWeight();});_this.forceUpdate();if(Object.keys(_this.inputErrors).length)reject();else resolve();}});};_this.handleInputChange=function(targetField){return function(value,error){var markStepAsRedacted=_this.props.markStepAsRedacted;var isOptionalBlank=_this.isOptionalField(targetField)&&!value&&!error;markStepAsRedacted();if(!value&&!isOptionalBlank||error){if(!_this.inputErrors[targetField])_this.inputErrors[targetField]=true;_this.setState(_defineProperty({},targetField,value));}else{if(_this.inputErrors[targetField])delete _this.inputErrors[targetField];_this.setState(_defineProperty({},targetField,value),function(){if(targetField==='reqMaxNumberOfPersons'||targetField==='reqMaxPersonsWeight')_this.validatePersonsWeight();if(targetField==='reqMaxWeight'||targetField==='reqMaxPersonsWeight')_this.validateMaximumWeight();if(targetField==='reqSpecifiedEngineWeight')return;if(!_this.isEmptyInputs()&&!Object.keys(_this.inputErrors).filter(function(stateFieldName){return stateFieldName.includes('req');}).length){if(!_this.recalculationPending){_this.recalculationPending=true;if(_this.timerIndex)clearTimeout(_this.timerIndex);_this.timerIndex=setTimeout(function(){_this.calculateData();},1000);}}});}};};_this.handleSpecifiedEngineWeightBlur=function(){_this.recalculateAfterSelection();};_this.choseApprovedValue=function(calc,req){var overrideApprovedValues=_this.state.overrideApprovedValues;if(overrideApprovedValues||!isFinite(calc))return req;return calc<req?calc:req;};_this.toggleOverride=function(){var markStepAsRedacted=_this.props.markStepAsRedacted;var _this$state4=_this.state,calMaxNumberOfPersons=_this$state4.calMaxNumberOfPersons,calMaxPersonsWeight=_this$state4.calMaxPersonsWeight,calMaxWeight=_this$state4.calMaxWeight,calcMaxHP=_this$state4.calcMaxHP,calcMaxHPDualSteering=_this$state4.calcMaxHPDualSteering,reqMaxNumberOfPersons=_this$state4.reqMaxNumberOfPersons,reqMaxPersonsWeight=_this$state4.reqMaxPersonsWeight,reqMaxWeight=_this$state4.reqMaxWeight,reqMaxHP=_this$state4.reqMaxHP,reqMaxHPDualSteering=_this$state4.reqMaxHPDualSteering,appMaxNumberOfPersons=_this$state4.appMaxNumberOfPersons,appMaxPersonsWeight=_this$state4.appMaxPersonsWeight,appMaxWeight=_this$state4.appMaxWeight,apprMaxHP=_this$state4.apprMaxHP,apprMaxHPDualSteering=_this$state4.apprMaxHPDualSteering,overrideApprovedValues=_this$state4.overrideApprovedValues;if(_this.inputErrors.reqMaxPersonsWeight)delete _this.inputErrors.reqMaxPersonsWeight;markStepAsRedacted();_this.setState({overrideApprovedValues:!overrideApprovedValues},function(){var newState={};if(apprMaxHP!==undefined)newState.apprMaxHP=_this.choseApprovedValue(calcMaxHP,reqMaxHP);if(appMaxWeight!==undefined)newState.appMaxWeight=_this.choseApprovedValue(calMaxWeight,reqMaxWeight);if(appMaxNumberOfPersons!==undefined)newState.appMaxNumberOfPersons=_this.choseApprovedValue(calMaxNumberOfPersons,reqMaxNumberOfPersons);if(appMaxPersonsWeight!==undefined)newState.appMaxPersonsWeight=_this.choseApprovedValue(calMaxPersonsWeight,reqMaxPersonsWeight);if(apprMaxHPDualSteering!==undefined)newState.apprMaxHPDualSteering=_this.choseApprovedValue(calcMaxHPDualSteering,reqMaxHPDualSteering);_this.setState(newState);});};_this.handleMoveToNextStep=function(){var _this$props=_this.props,updateBoatDetails=_this$props.updateBoatDetails,goToStep=_this$props.goToStep;_this.validateStep().then(function(){_this.calculateData().then(function(){updateBoatDetails({personPowerCapacity:_this.getPersistedStepState()});goToStep('next',true);});});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props2=_this.props,updateBoatDetails=_this$props2.updateBoatDetails,goToStep=_this$props2.goToStep,stepIsChanged=_this$props2.stepIsChanged;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.validateStep().then(function(){updateBoatDetails({personPowerCapacity:_this.getPersistedStepState()});_this.calculateData().then(function(){goToStep(typeof stepId==='string'?stepId:'prev',true);}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});}).catch(function(){var newState=_this.state;for(var fieldName in _this.state){if(_this.inputErrors[fieldName]){newState[fieldName]='';}}_this.setState(newState,function(){updateBoatDetails({personPowerCapacity:_this.getPersistedStepState()});goToStep(typeof stepId==='string'?stepId:'prev',false);});});};var personPowerCapacity=props.boat.personPowerCapacity||{};var persistedPlateType=props.boat.plateType||personPowerCapacity.plateType||'';var hasModernPlateType=/(?:PLATE_TYPE_|Plate type )(?:[4-9]|10)$/i.test(persistedPlateType);var hasSpecifiedEngineWeight=Number(personPowerCapacity.reqSpecifiedEngineWeight)>0;var hasElectricPropulsion=props.boat.engineType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["q" /* OUTBOARD */]&&props.boat.boatSpecifications&&props.boat.boatSpecifications.hasElectricPropulsion;var persistedUseManufacturerEngineWeight=personPowerCapacity.useManufacturerEngineWeight!==undefined?personPowerCapacity.useManufacturerEngineWeight:hasSpecifiedEngineWeight;_this.state=Object.assign({},personPowerCapacity,{preferredTagType:hasElectricPropulsion?'MODERN':personPowerCapacity.preferredTagType||(hasModernPlateType?'MODERN':'LEGACY'),useManufacturerEngineWeight:hasElectricPropulsion?true:persistedUseManufacturerEngineWeight,reqSpecifiedEngineWeight:hasElectricPropulsion&&persistedUseManufacturerEngineWeight===false?'':personPowerCapacity.reqSpecifiedEngineWeight});_this.recalculationPending=false;_this.inputErrors={};return _this;}_createClass(PersonPowerCapacity,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.stepIsChanged)this.calculateData();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,calMaxNumberOfPersons=_state.calMaxNumberOfPersons,calMaxPersonsWeight=_state.calMaxPersonsWeight,calMaxWeight=_state.calMaxWeight,calcMaxHP=_state.calcMaxHP,calcMaxHPDualSteering=_state.calcMaxHPDualSteering,reqMaxNumberOfPersons=_state.reqMaxNumberOfPersons,reqMaxPersonsWeight=_state.reqMaxPersonsWeight,reqMaxWeight=_state.reqMaxWeight,reqMaxHP=_state.reqMaxHP,reqMaxHPDualSteering=_state.reqMaxHPDualSteering,appMaxNumberOfPersons=_state.appMaxNumberOfPersons,appMaxPersonsWeight=_state.appMaxPersonsWeight,appMaxWeight=_state.appMaxWeight,apprMaxHP=_state.apprMaxHP,apprMaxHPDualSteering=_state.apprMaxHPDualSteering,calBoatWeight=_state.calBoatWeight,plateType=_state.plateType,overrideApprovedValues=_state.overrideApprovedValues,reqSpecifiedEngineWeight=_state.reqSpecifiedEngineWeight,preferredTagType=_state.preferredTagType,useManufacturerEngineWeight=_state.useManufacturerEngineWeight;var _props=this.props,user=_props.user,boat=_props.boat,getNavBar=_props.getNavBar,getHeader=_props.getHeader,stepIsChanged=_props.stepIsChanged,updateBoatDetails=_props.updateBoatDetails;var showSpecifiedEngineWeight=this.shouldShowSpecifiedEngineWeight();var electricOutboard=this.isElectricOutboard();var hasCalculatedValues=calMaxNumberOfPersons!==undefined||calMaxPersonsWeight!==undefined||calMaxWeight!==undefined||calcMaxHP!==undefined||calcMaxHPDualSteering!==undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(function(){return new Promise(function(resolve){_this2.validateStep().then(function(){_this2.calculateData();updateBoatDetails({personPowerCapacity:_this2.getPersistedStepState()});resolve();}).catch(function(){});});}),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),(calBoatWeight!==undefined||plateType!==undefined)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section person-weight-capacities-section _border_top_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_margin_bottom_20'},''+(calBoatWeight!==undefined&&'Boat Weight')+(calBoatWeight!==undefined&&plateType!==undefined&&' / ')+(plateType!==undefined&&'Plate Type')),calBoatWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{mainWrapperClassName:'_margin_right_30',label:'Calculated Weight',color:'gray',value:calBoatWeight||'',units:'Lbs.'}),plateType!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Plate Type',color:'gray',removeUnderlines:true,value:plateType})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section person-weight-capacities-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Requested Person/ Weight Capacities'),this.shouldShowTagTypeSelection()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'capacity-tag-preferences'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'capacity-tag-preference-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'capacity-tag-image'+(preferredTagType==='LEGACY'?' capacity-tag-image_selected':''),onClick:function onClick(){return _this2.selectTagType('LEGACY');},disabled:electricOutboard,'aria-label':'Select Legacy capacity tag','aria-pressed':preferredTagType==='LEGACY'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__images_type_1_png___default.a,alt:'Legacy capacity tag preview'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Slider__["a" /* default */],{state:preferredTagType!=='MODERN',mainWrapperClassName:'green',onLabel:'Legacy',offLabel:'New',toggleAction:this.toggleTagType,disabled:electricOutboard}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'capacity-tag-image'+(preferredTagType==='MODERN'?' capacity-tag-image_selected':''),onClick:function onClick(){return _this2.selectTagType('MODERN');},disabled:electricOutboard,'aria-label':'Select Modern capacity tag','aria-pressed':preferredTagType==='MODERN'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__images_type_4_png___default.a,alt:'Modern capacity tag preview'}))),this.shouldShowEngineWeightSelection()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'capacity-tag-engine-weight-selector'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Slider__["a" /* default */],{state:!useManufacturerEngineWeight,mainWrapperClassName:'green',label:'Engine Weight Source',onLabel:'S-30 Engine Weight',offLabel:'MFR Engine Weight',toggleAction:this.toggleEngineWeightSource,disabled:electricOutboard}))),hasCalculatedValues?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'reminder'},'You can use request values to change approved values.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The input values could not be more than maximum calculated.'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'reminder'},'You can use request values to change approved values.'),(reqMaxNumberOfPersons!==undefined||reqMaxPersonsWeight!==undefined)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper _margin_right_30'},reqMaxNumberOfPersons!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["b" /* MultiInput */],{label:'Maximum Persons *',value:reqMaxNumberOfPersons||'',onChange:this.handleInputChange('reqMaxNumberOfPersons'),styles:{height:40},error:this.inputErrors['reqMaxNumberOfPersons'],isNumeric:true}),reqMaxPersonsWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["b" /* MultiInput */],{label:'Maximum '+(boat.boatType!==__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["s" /* PWC */]?'Persons ':'')+'Weight *',value:reqMaxPersonsWeight||'',onChange:this.handleInputChange('reqMaxPersonsWeight'),styles:{height:40},error:this.inputErrors['reqMaxPersonsWeight'],units:'Lbs.',isNumeric:true})),reqMaxWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Maximum Weight *',value:reqMaxWeight||'',units:'Lbs.',error:this.inputErrors['reqMaxWeight'],onChange:this.handleInputChange('reqMaxWeight')}),reqMaxHP!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary _margin_right_30',inputClassName:'input__input-field_primary',label:'Maximum Horsepower *',value:reqMaxHP||'',units:'HP',onChange:this.handleInputChange('reqMaxHP'),error:this.inputErrors['reqMaxHP']}),reqMaxHPDualSteering!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'input__main-wrapper_primary',inputClassName:'input__input-field_primary',label:'Maximum Horsepower without Remote Steering *',value:reqMaxHPDualSteering||'',units:'HP',onChange:this.handleInputChange('reqMaxHPDualSteering'),error:this.inputErrors['reqMaxHPDualSteering']}),showSpecifiedEngineWeight&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Input__["a" /* Input */],{isNumeric:true,mainWrapperClassName:'ect-full-input',inputClassName:'input__input-field_primary',label:'Outboard Engine Running Weight - Including prop shaft, prop, and fluids (Do not include Controls, Rigging, Battery and Portable Fuel Weight)'+(this.isSpecifiedEngineWeightRequired()?' *':''),subLabel:this.getSpecifiedEngineWeightSubLabel(),secondarySubLabel:boat.boatSpecifications&&boat.boatSpecifications.motorType===__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["z" /* TWIN */]?'Twin Engines - Enter weight for the combined engines.':'',subLabelIconClassName:'input__sub-label-icon_attention',value:reqSpecifiedEngineWeight||'',units:'Lbs.',onChange:this.handleInputChange('reqSpecifiedEngineWeight'),onBlur:this.handleSpecifiedEngineWeightBlur,error:this.inputErrors['reqSpecifiedEngineWeight']})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section scene_section_two-columns'+(user.isInternal()?'_uneven':'')+' person-weight-capacities-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_margin_bottom_20'},'Calculated and Approved Person/ Weight Capacities'),user.isInternal()&&boat.boatType!==__WEBPACK_IMPORTED_MODULE_7_constants_boatApplication__["s" /* PWC */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_width_pc_100 _flex _ai_center _jc_start _margin_bottom_20 _padding_left_4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_Slider__["a" /* default */],{state:!overrideApprovedValues,mainWrapperClassName:'green',label:'Override with requested',onLabel:'Off',offLabel:'On',toggleAction:this.toggleOverride})),(calMaxNumberOfPersons!==undefined||calMaxPersonsWeight!==undefined)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-output-fields-wrapper'},calMaxNumberOfPersons!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["a" /* CalculatedMultiOutput */],{label:'Calculated Maximum Persons',color:'gray',value:calMaxNumberOfPersons,error:this.inputErrors['calMaxPersonsWeight']?!!this.inputErrors['calMaxNumberOfPersons']:this.inputErrors['calMaxNumberOfPersons']}),calMaxPersonsWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["a" /* CalculatedMultiOutput */],{label:'Maximum Persons Weight',color:'gray',value:calMaxPersonsWeight,error:this.inputErrors['calMaxPersonsWeight'],units:'Lbs.'})),(appMaxNumberOfPersons!==undefined||appMaxPersonsWeight!==undefined)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-output-fields-wrapper'},appMaxNumberOfPersons!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["a" /* CalculatedMultiOutput */],{label:'Approved Maximum Persons',color:'green',value:appMaxNumberOfPersons,error:this.inputErrors['appMaxNumberOfPersons']}),appMaxPersonsWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["a" /* CalculatedMultiOutput */],{label:'Maximum Persons Weight',color:'green',value:appMaxPersonsWeight,error:this.inputErrors['appMaxPersonsWeight'],units:'Lbs.'})),calMaxWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Calculated Maximum Weight',color:'gray',value:calMaxWeight,error:this.inputErrors['calMaxWeight'],units:'Lbs.'}),appMaxWeight!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Approved Maximum Weight',value:appMaxWeight,error:this.inputErrors['appMaxWeight'],units:'Lbs.'}),calcMaxHP!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Calculated Maximum Horsepower',color:'gray',value:calcMaxHP,error:this.inputErrors['calcMaxHP'],units:'HP'}),apprMaxHP!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Approved Maximum Horsepower',value:apprMaxHP,error:this.inputErrors['apprMaxHP'],units:'HP'}),calcMaxHPDualSteering!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Calculated Maximum Horsepower without Remote Steering',color:'gray',value:calcMaxHPDualSteering,error:this.inputErrors['calcMaxHPDualSteering'],units:'HP'}),apprMaxHPDualSteering!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_CalculatedOutput__["b" /* CalculatedOutput */],{label:'Approved Maximum Horsepower without remote Steering',value:apprMaxHPDualSteering,error:this.inputErrors['apprMaxHPDualSteering'],units:'HP'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this2.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return PersonPowerCapacity;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/type-1.9a566126.png";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/type-4.4bd4022e.png";

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isTagTypeSelectionLengthEligible; });
var isTagTypeSelectionLengthEligible=function isTagTypeSelectionLengthEligible(overallLength,isPontoon){return isFinite(overallLength)&&overallLength>0&&(overallLength<26||isPontoon&&overallLength>26);};

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonPowerCapacity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Slider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Checkbox__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_ApplicationActions__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PersonPowerCapacity=function(_React$Component){_inherits(PersonPowerCapacity,_React$Component);function PersonPowerCapacity(props){_classCallCheck(this,PersonPowerCapacity);var _this=_possibleConstructorReturn(this,(PersonPowerCapacity.__proto__||Object.getPrototypeOf(PersonPowerCapacity)).call(this,props));_this.getRequiredFieldsList=function(){var _this$state=_this.state,maxSpeedLessThan30=_this$state.maxSpeedLessThan30,passesTestAtFullPower=_this$state.passesTestAtFullPower;var newState=_this.state;_this.requiredFieldsList=[];if(!maxSpeedLessThan30&&!passesTestAtFullPower){_this.requiredFieldsList.push('maneuveringSpeed');}else{delete newState.maneuveringSpeed;var index=_this.inputErrors.indexOf('maneuveringSpeed');if(index!==-1){_this.inputErrors.splice(index,1);}}_this.setState(newState);};_this.toggleValue=function(type){return function(){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();_this.setState(function(prevState){return _defineProperty({},type,!prevState[type]);},_this.getRequiredFieldsList);};};_this.handleSpeedInput=function(targetField){return function(value,error){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();var index=_this.inputErrors.indexOf(targetField);if((error||!value||value<1)&&_this.requiredFieldsList.indexOf(targetField)!==-1){if(index===-1)_this.inputErrors.push(targetField);}else if(index!==-1){_this.inputErrors.splice(index,1);}_this.setState(_defineProperty({},targetField,value));};};_this.validateStep=function(){return new Promise(function(resolve,reject){_this.requiredFieldsList.forEach(function(field){var index=_this.inputErrors.indexOf(field);if((!_this.state[field]||_this.state[field]==='')&&index===-1)_this.inputErrors.push(field);});if(_this.inputErrors.length){_this.forceUpdate();reject();}else{resolve();}});};_this.handleMoveToNextStep=function(){var _this$props=_this.props,boat=_this$props.boat,updateBoatDetails=_this$props.updateBoatDetails,goToStep=_this$props.goToStep;_this.validateStep().then(function(){updateBoatDetails({powerCapacity:Object.assign({},_this.state)});__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].savePowerCapacity(boat.id),_this.state).then(function(){return goToStep('next',true);});});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props2=_this.props,boat=_this$props2.boat,updateBoatDetails=_this$props2.updateBoatDetails,goToStep=_this$props2.goToStep,stepIsChanged=_this$props2.stepIsChanged;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.validateStep().then(function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].savePowerCapacity(boat.id),_this.state).then(function(){updateBoatDetails({powerCapacity:Object.assign({},_this.state)});goToStep(typeof stepId==='string'?stepId:'prev',true);});}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});};_this.state=Object.assign({},props.boat.powerCapacity);_this.inputErrors=[];_this.requiredFieldsList=[];_this.inputErrors=[];_this.requiredFieldsList=[];return _this;}_createClass(PersonPowerCapacity,[{key:'componentDidMount',value:function componentDidMount(){this.getRequiredFieldsList();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,boat=_props.boat,updateBoatDetails=_props.updateBoatDetails,getNavBar=_props.getNavBar,getHeader=_props.getHeader,stepIsChanged=_props.stepIsChanged;var _state=this.state,passesTestAtFullPower=_state.passesTestAtFullPower,maxSpeedLessThan30=_state.maxSpeedLessThan30,maneuveringSpeed=_state.maneuveringSpeed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(function(){return new Promise(function(resolve){_this2.validateStep().then(function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].savePowerCapacity(boat.id),_this2.state).then(function(){updateBoatDetails({powerCapacity:Object.assign({},_this2.state)});resolve();});});});}),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section power-capacity-section _border_top_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Max Power Capacity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Slider__["a" /* default */],{state:maxSpeedLessThan30,mainWrapperClassName:'green',label:'Maximum Speed',onLabel:'< 30 Mph',offLabel:'> 30 Mph',toggleAction:this.toggleValue('maxSpeedLessThan30')}),!maxSpeedLessThan30&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'additional-info-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Checkbox__["a" /* default */],{value:passesTestAtFullPower,label:'Passes Test At Full Power',onChange:this.toggleValue('passesTestAtFullPower')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["a" /* Input */],{isNumeric:true,inputClassName:'_border_radius_10 _margin_bottom_20 _margin_top_12 _height_40 _width_330',label:'Maneuvering Speed',value:maneuveringSpeed||'',onChange:this.handleSpeedInput('maneuveringSpeed'),disabled:passesTestAtFullPower?'disabled':'',error:this.inputErrors.indexOf('maneuveringSpeed')!==-1,units:'Mph'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this2.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return PersonPowerCapacity;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FloatationCapacity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_DatePicker__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FloatationCapacity=function(_React$Component){_inherits(FloatationCapacity,_React$Component);function FloatationCapacity(props){_classCallCheck(this,FloatationCapacity);var _this=_possibleConstructorReturn(this,(FloatationCapacity.__proto__||Object.getPrototypeOf(FloatationCapacity)).call(this,props));_this.__isValidDate=function(){var testDate=_this.state.testDate;return testDate.isValid&&testDate.isValid();};_this.handleDateChoose=function(utcDate,error){var files=_this.state.files;var _this$props=_this.props,markStepAsRedacted=_this$props.markStepAsRedacted,boat=_this$props.boat;markStepAsRedacted();if(error)_this.errors.testDate='Provide valid date, or completely delete it';if(!files.length&&boat.isFloatationTestReportRequired){_this.errors.files='Test Report File should be uploaded';}if(utcDate&&utcDate.isAfter(_this.currentDate)){_this.errors.testDate='Cannot select Flotation Test Date in the future';}else if(!error){delete _this.errors.testDate;}_this.setState({testDate:utcDate});};_this.handleInputChange=function(targetField){return function(value,error){var _this$state=_this.state,mhaPersonsCapacity=_this$state.mhaPersonsCapacity,mhaPersonsCapacityRefDepth=_this$state.mhaPersonsCapacityRefDepth;var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(!value||error){if(!_this.inputErrors[targetField])_this.inputErrors[targetField]=true;_this.setState(_defineProperty({},targetField,value));}else{if(_this.inputErrors[targetField])delete _this.inputErrors[targetField];_this.setState(_defineProperty({},targetField,value),function(){var newVal=_this.state[targetField];if(targetField==='mhaPersonsCapacity'){if(newVal!==undefined){if(newVal>10)_this.inputErrors.mhaPersonsCapacity='Max Heel Angle at Persons Capacity should be no greater than 10 degrees.';//else if (this.inputErrors.mhaPersonsCapacity = 'Max Heel Angle at Persons Capacity should be no greater than 10 degrees.') delete this.inputErrors.mhaPersonsCapacity;
}}else if(targetField==='mhaPersonsCapacityRefDepth'){if(newVal!==undefined){if(newVal<-6)_this.inputErrors.mhaPersonsCapacityRefDepth='Reference Depth should be taken from no greater than -6 inches.';//else if (this.inputErrors.mhaPersonsCapacityRefDepth = 'Reference Depth should be taken from no greater than -6 inches.') delete this.inputErrors.mhaPersonsCapacityRefDepth;
}}else if(targetField==='mhaStarboardStability'){if(newVal!==undefined){if(newVal>30)_this.inputErrors.mhaStarboardStability='Max Heel Angle on Starboard Stability Test should be no greater than 30 degrees.';}}else if(targetField==='mhaStarboardStabilityRefDepth'){if(newVal!==undefined){if(newVal<-12)_this.inputErrors.mhaStarboardStabilityRefDepth='Reference Depth should be taken from no greater than -12 inches.';}}else if(targetField==='mhaPortStability'){if(newVal!==undefined){if(newVal>30)_this.inputErrors.mhaPortStability='Max Heel Angle on Port Stability Test should be no greater than 30 degrees.';}}else if(targetField==='mhaPortStabilityRefDepth'){if(newVal!==undefined){if(newVal<-12)_this.inputErrors.mhaPortStabilityRefDepth='Reference Depth should be taken from no greater than -12 inches.';}}else if(targetField==='mhaWithoutPersons'){if(newVal!==undefined){if(newVal>10)_this.inputErrors.mhaWithoutPersons='Max Heel Angle without Persons should be no greater than 10 degrees.';}}else if(targetField==='mhaWithoutPersonsRefDepth'){if(newVal!==undefined){if(newVal<-6)_this.inputErrors.mhaWithoutPersonsRefDepth='Reference Depth should be taken from no greater than -6 inches.';}}if(_this.state['mhaPersonsCapacity']&&!_this.inputErrors.mhaPersonsCapacity&&_this.state['mhaPersonsCapacityRefDepth']&&!_this.inputErrors.mhaPersonsCapacityRefDepth&&_this.state['mhaStarboardStability']&&!_this.inputErrors.mhaStarboardStability&&_this.state['mhaStarboardStabilityRefDepth']&&!_this.inputErrors.mhaStarboardStabilityRefDepth&&_this.state['mhaPortStability']&&!_this.inputErrors.mhaPortStability&&_this.state['mhaPortStabilityRefDepth']&&!_this.inputErrors.mhaPortStabilityRefDepth&&_this.state['mhaWithoutPersons']&&!_this.inputErrors.mhaWithoutPersons&&_this.state['mhaWithoutPersonsRefDepth']&&!_this.inputErrors.mhaWithoutPersonsRefDepth){_this.setState({uploadAvailable:true});}else{_this.setState({uploadAvailable:false});}_this.forceUpdate();});}};};_this.handleFileSelect=function(files){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(!_this.__isValidDate())_this.errors.testDate=true;delete _this.errors.files;_this.setState(function(prevState){return{files:[].concat(_toConsumableArray(prevState.files),_toConsumableArray(files))};});};_this.handleRemoveFile=function(index){return function(){var files=_this.state.files;var _this$props2=_this.props,markStepAsRedacted=_this$props2.markStepAsRedacted,boat=_this$props2.boat;markStepAsRedacted();if(files[index].created){_this.filesIdsToDelete.push(files[index].id);}if(!_this.errors.testDate&&files.length===1&&boat.isFloatationTestReportRequired){_this.errors.files='Test Report File should be uploaded';}if(files.length===1){delete _this.errors.testDate;}_this.setState(function(prevState){return{files:prevState.files.filter(function(_,prevIndex){return index!==prevIndex;})};});};};_this.validateStep=function(){var files=_this.state.files;var boat=_this.props.boat;if(boat.isFloatationTestReportRequired){if(!files.length)_this.errors.files='Test Report File should be uploaded';if(!_this.__isValidDate())_this.errors.testDate=true;}else{if(_this.__isValidDate()&&!files.length)_this.errors.files='Test Report File should be uploaded';if(files.length&&!_this.__isValidDate())_this.errors.testDate=true;}_this.forceUpdate();};_this.saveFloatationTestReports=function(){var _this$state2=_this.state,files=_this$state2.files,testDate=_this$state2.testDate;var boat=_this.props.boat;return new Promise(function(resolve,reject){if(files.length||boat.floatationCapacity.testDate&&boat.floatationCapacity.testDate.isSame(testDate)){var requestJSON={testDate:testDate.utc()};var data=new FormData();data.append('json',JSON.stringify(requestJSON));files.filter(function(file){return!file.created;}).forEach(function(file){return data.append('reports',file);});__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].uploadFloatationTestReports(boat.id),data).then(resolve).catch(function(){_this.setState({testDate:boat.floatationCapacity.testDate,files:boat.floatationCapacity.files},function(){reject();});});}else{resolve();}});};_this.deleteFloatationTestReports=function(){var files=_this.state.files;var boat=_this.props.boat;return new Promise(function(resolve,reject){if(_this.filesIdsToDelete.length){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].deleteFloatationTestReports(boat.id),_this.filesIdsToDelete).then(function(){_this.filesIdsToDelete=[];_this.setState({files:files.filter(function(_ref){var id=_ref.id;return!_this.filesIdsToDelete.includes(id);})});resolve();}).catch(function(){_this.filesIdsToDelete=[];_this.setState({testDate:boat.floatationCapacity.testDate,files:files});reject();});}else{resolve();}});};_this.saveData=function(){var _this$props3=_this.props,boat=_this$props3.boat,updateBoatDetails=_this$props3.updateBoatDetails;var testDate=_this.state.testDate;_this.validateStep();return new Promise(function(resolve,reject){if(Object.keys(_this.errors).length){reject();}else{_this.saveFloatationTestReports().then(function(){return _this.deleteFloatationTestReports();}).then(function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].getFloatationTestReports(boat.id)).then(function(_ref2){var data=_ref2.data;_this.setState({files:data});updateBoatDetails({floatationCapacity:{testDate:testDate,files:data}});});resolve();}).catch(function(){reject();});}});};_this.handleMoveToNextStep=function(){var goToStep=_this.props.goToStep;_this.saveData().then(function(){goToStep('next',true);});};_this.handleUploadReq=function(){_this.setState({showControlFields:true,showUploadButton:false});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props4=_this.props,goToStep=_this$props4.goToStep,stepIsChanged=_this$props4.stepIsChanged;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.saveData().then(function(){goToStep(typeof stepId==='string'?stepId:'prev',true);}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});};_this.state={testDate:props.boat.floatationCapacity.testDate?props.boat.floatationCapacity.testDate:'',files:props.boat.floatationCapacity.files?[].concat(_toConsumableArray(props.boat.floatationCapacity.files)):[],uploadAvailable:false};_this.errors={};_this.filesIdsToDelete=[];_this.inputErrors={};_this.currentDate=__WEBPACK_IMPORTED_MODULE_1_moment___default()().utc().hour(23).minute(59).second(59).millisecond(999);return _this;}_createClass(FloatationCapacity,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(nextProps.boat.floatationCapacity.files){if(nextProps.boat.floatationCapacity.files.length>this.state.files.length+this.filesIdsToDelete.length){this.setState(Object.assign({},nextProps.boat.floatationCapacity,{testDate:nextProps.boat.floatationCapacity.testDate?nextProps.boat.floatationCapacity.testDate:''}));}}return true;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,getNavBar=_props.getNavBar,getHeader=_props.getHeader,stepIsChanged=_props.stepIsChanged,boat=_props.boat;var _state=this.state,testDate=_state.testDate,files=_state.files,showControlFields=_state.showControlFields,showUploadButton=_state.showUploadButton,mhaPersonsCapacity=_state.mhaPersonsCapacity,mhaPersonsCapacityRefDepth=_state.mhaPersonsCapacityRefDepth,mhaStarboardStability=_state.mhaStarboardStability,mhaStarboardStabilityRefDepth=_state.mhaStarboardStabilityRefDepth,mhaPortStability=_state.mhaPortStability,mhaPortStabilityRefDepth=_state.mhaPortStabilityRefDepth,mhaWithoutPersons=_state.mhaWithoutPersons,mhaWithoutPersonsRefDepth=_state.mhaWithoutPersonsRefDepth,uploadAvailable=_state.uploadAvailable;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(this.saveData),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _border_top_1 floatation-test-date-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Flotation Test Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'reminder'},'If Flotation Test Date is selected, upload the Test Report',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If Boat <20 Ft - application step Flotation is required'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_DatePicker__["a" /* default */],{error:this.errors.testDate,selectedDate:testDate,handleSelectDate:this.handleDateChoose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _border_top_1 floatation-test-upload-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Upload Test Report'),showControlFields===undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Button__["c" /* default */],{label:'Upload Test Report',buttonClassName:'_height_30 _font_size_14',fontSize:14,onClick:function onClick(){return _this2.handleUploadReq();}}),showControlFields!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'reminder'},'Please provide the Max Heel Angle for the specified tests and indicate the reference depth they were taken from.'),showControlFields!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'group-label'},'Max Heel Angles: '),showControlFields!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper _margin_right_10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:'Angle Persons Capacity * ',value:mhaPersonsCapacity||'',onChange:this.handleInputChange('mhaPersonsCapacity'),styles:{height:40},error:this.inputErrors['mhaPersonsCapacity'],units:'\xB0',isNumeric:true,allowNegative:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:' Ref. Depth *',value:mhaPersonsCapacityRefDepth||'',onChange:this.handleInputChange('mhaPersonsCapacityRefDepth'),styles:{height:40},error:this.inputErrors['mhaPersonsCapacityRefDepth'],units:'in.',isNumeric:true,allowNegative:true})),showControlFields!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper _margin_right_10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:'Angle Starboard Stability * ',value:mhaStarboardStability||'',onChange:this.handleInputChange('mhaStarboardStability'),styles:{height:40},error:this.inputErrors['mhaStarboardStability'],units:'\xB0',isNumeric:true,allowNegative:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:' Ref. Depth *',value:mhaStarboardStabilityRefDepth||'',onChange:this.handleInputChange('mhaStarboardStabilityRefDepth'),styles:{height:40},error:this.inputErrors['mhaStarboardStabilityRefDepth'],units:'in.',isNumeric:true,allowNegative:true})),showControlFields!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper _margin_right_10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:'Angle Port Stability * ',value:mhaPortStability||'',onChange:this.handleInputChange('mhaPortStability'),styles:{height:40},error:this.inputErrors['mhaPortStability'],units:'\xB0',isNumeric:true,allowNegative:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:' Ref. Depth *',value:mhaPortStabilityRefDepth||'',onChange:this.handleInputChange('mhaPortStabilityRefDepth'),styles:{height:40},error:this.inputErrors['mhaPortStabilityRefDepth'],units:'in.',isNumeric:true,allowNegative:true})),showControlFields!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-input-fields-wrapper _margin_right_10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:'Angle Without Persons * ',value:mhaWithoutPersons||'',onChange:this.handleInputChange('mhaWithoutPersons'),styles:{height:40},error:this.inputErrors['mhaWithoutPersons'],units:'\xB0',isNumeric:true,allowNegative:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_Input__["b" /* MultiInput */],{label:' Ref. Depth *',value:mhaWithoutPersonsRefDepth||'',onChange:this.handleInputChange('mhaWithoutPersonsRefDepth'),styles:{height:40},error:this.inputErrors['mhaWithoutPersonsRefDepth'],units:'in.',isNumeric:true,allowNegative:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Components_FilePicker__["a" /* default */],{mainWrapperClassName:'_box-sizing_border-box',handleFileSelect:this.handleFileSelect,handleRemoveFile:this.handleRemoveFile,isEditable:uploadAvailable,notEditableStateSectionHeader:'Flotation Test Reports',files:files,httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_3_api_requests__["a" /* boatAPI */].downloadReport,currentId:boat.id},error:this.errors.files})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this2.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return FloatationCapacity;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Systems__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdditionalSection__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SteeringSystemSection__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CombinationPicker__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CombinationSection__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Button__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INFO={1:['Please select one Blower.'],2:['Configuration 1 (under 12 m): Please select one or two Side Light or Combination Side Light, one Combination Masthead/Anchor Light or one All-around Light, and one optional Tricolor Light.','Configuration 2 (12 m and over): Please select one or two Side Light or Combination Side Light, and one Masthead Light or Combination Masthead/Anchor Light, and one Stern Light, and one optional Tricolor Light.'],3:['Please select at least one Bilge Pump.'],4:['Please select one Horn (5 to 12m, 12 to 20m, or more than 20m).'],5:['Please select at least one Steering Wheel and at least one Steering Helm Assembly (Electrical, Hydraulic or Mechanical).'],6:['Please select at least one Tank, at least one Fill Hose, at least one Feed Hose, and at least one Vent Hose.']};var AddComponents=function(_React$Component){_inherits(AddComponents,_React$Component);function AddComponents(props){_classCallCheck(this,AddComponents);var _this=_possibleConstructorReturn(this,(AddComponents.__proto__||Object.getPrototypeOf(AddComponents)).call(this,props));_this.handleSystemAdd=function(system){var markStepAsRedacted=_this.props.markStepAsRedacted;var _this$state=_this.state,boatSystems=_this$state.boatSystems,selectedTypes=_this$state.selectedTypes;markStepAsRedacted();var componentSystemId=system.id;boatSystems.push({componentSystemId:componentSystemId,name:'',ruleValueRequests:[],optionValueRequests:[]});selectedTypes[boatSystems.length-1]={};_this.setState({boatSystems:boatSystems,selectedTypes:selectedTypes},function(){_this.setSystemsNames(system);_this.handleSystemChoose(_this.state.boatSystems.length-1,boatSystems.length===1);});};_this.handleSystemChoose=function(key,doNotSavePreviousSystem){var _this$state2=_this.state,boatSystems=_this$state2.boatSystems,currentSystem=_this$state2.currentSystem;var updateBoatDetails=_this.props.updateBoatDetails;if(key!==currentSystem.index){var chooseSystem=function chooseSystem(){var fullName=_this.allSystemsList.find(function(sys){return sys.id===boatSystems[key].componentSystemId;}).name;var systemName=fullName.split('(')[1]&&fullName.split('(')[1].split(')')[0];_this.additionalSectionName=systemName||boatSystems[key].name;var newSystem={};var selectedCombination={};var combinations=[];var createNewSystemDataEntry=function createNewSystemDataEntry(data){newSystem=data;newSystem.index=key;combinations=newSystem.combinations;selectedCombination=_this.getChosenCombination(combinations,boatSystems[key]);_this.setState({currentSystem:newSystem,selectedCombination:selectedCombination,selectedManufacturersFilters:{}},function(){var boatSystems=_this.state.boatSystems;updateBoatDetails({boatSystems:boatSystems});});};if(_this.systemStructures[boatSystems[key].componentSystemId]){createNewSystemDataEntry(_this.systemStructures[boatSystems[key].componentSystemId]);}else{__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getBoatSystemStructure(boatSystems[key].componentSystemId)).then(function(_ref){var data=_ref.data;createNewSystemDataEntry(data);});}};if(!doNotSavePreviousSystem){_this.saveSystem(currentSystem.index).finally(function(){chooseSystem();});}else{chooseSystem();}}};_this.getChosenCombination=function(combinations,system){var selectedCombination=combinations[0];var maxMatchedRules=0;if(combinations.length>1){combinations.forEach(function(combination){var matchedRules=0;combination.requiredRules.forEach(function(combinationRule){system.ruleValueRequests.forEach(function(systemRule){if(systemRule.ruleId===combinationRule.id)matchedRules+=Object.keys(systemRule.componentIdWithQuantityMap).length;});});if(matchedRules>maxMatchedRules){maxMatchedRules=matchedRules;selectedCombination=combination;}});}return selectedCombination;};_this.handleCombinationChoose=function(index){var _this$state3=_this.state,boatSystems=_this$state3.boatSystems,currentSystem=_this$state3.currentSystem,invalidList=_this$state3.invalidList;var _this$props=_this.props,markStepAsRedacted=_this$props.markStepAsRedacted,updateBoatDetails=_this$props.updateBoatDetails;markStepAsRedacted();var selectedCombination=currentSystem.combinations[index];delete invalidList[currentSystem.index];_this.setState({selectedCombination:selectedCombination,invalidList:invalidList,invalidComponents:{},selectedManufacturersFilters:{}},function(){_this.validateNotSelectedSystem(currentSystem.index);updateBoatDetails({boatSystems:boatSystems});});};_this.handleTypeChose=function(ruleId){return function(type){if(_this.loadedTypes[type.typeId]===undefined){_this.loadedTypes[type.typeId]=false;_this.loadComponentTypeData(type.typeId);}var newSelectedTypes=_this.state.selectedTypes;newSelectedTypes[_this.state.currentSystem.index][ruleId]=type.typeId;_this.setState({selectedTypes:newSelectedTypes});};};_this.handleSelectManufacturerFilter=function(combinationSingleTypeHolderId){return function(manufacturer){var selectedManufacturersFilters=_this.state.selectedManufacturersFilters;selectedManufacturersFilters[combinationSingleTypeHolderId]=manufacturer;_this.setState({selectedManufacturersFilters:selectedManufacturersFilters});};};_this.selectSingleType=function(ruleId,type){if(_this.loadedTypes[type.typeId]===undefined){_this.loadedTypes[type.typeId]=false;_this.loadComponentTypeData(type.typeId);}if(!type)return'No Components\' types found';if(!_this.state.selectedTypes[_this.state.currentSystem.index][ruleId]){var newSelectedTypes=_this.state.selectedTypes;newSelectedTypes[_this.state.currentSystem.index][ruleId]=type.typeId;_this.setState({selectedTypes:newSelectedTypes});}return type.value;};_this.loadComponentTypeData=function(typeId){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getComponentsByType(typeId,true)).then(function(_ref2){var data=_ref2.data;var newAllComponents=_this.state.allComponents;newAllComponents[typeId]=data;_this.loadedTypes[typeId]=true;var newAllManufacturers=_this.state.allManufacturers;newAllManufacturers[typeId]=Object.keys(data.reduce(_this.manufacturersOfSingleTypeReducer,{})).sort();_this.setState({allComponents:newAllComponents,allManufacturers:newAllManufacturers});});};_this.manufacturersOfSingleTypeReducer=function(accumulator,component){accumulator[component.manufacturerName]=true;return accumulator;};_this.handleSystemDelete=function(index){return function(event){var boatSystems=_this.state.boatSystems;event.stopPropagation();if(_this.isSystemEmpty(index)){if(boatSystems[index].id){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].deleteSystem(boatSystems[index].id)).then(function(){_this.deleteSystem(index);});}else{_this.deleteSystem(index);}}else{_this.modalBody=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Are you sure you want to remove this Component System? All previously entered data will be lost.');_this.modalConfirmAction=function(){if(boatSystems[index].id){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].deleteSystem(boatSystems[index].id)).then(function(){_this.deleteSystem(index);__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success('note','The Component System was removed successfully.');});}else{_this.deleteSystem(index);__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].success('note','The Component System was removed successfully.');}};_this.setState({isModalOpen:true});}};};_this.deleteSystem=function(index){var _this$props2=_this.props,markStepAsRedacted=_this$props2.markStepAsRedacted,updateBoatDetails=_this$props2.updateBoatDetails;var _this$state4=_this.state,boatSystems=_this$state4.boatSystems,currentSystem=_this$state4.currentSystem,dualSteering=_this$state4.dualSteering;markStepAsRedacted();var dualSteeringFlagIsFalse=dualSteering&&currentSystem.id===5&&boatSystems.filter(function(system){return system.componentSystemId===5;}).length===1;if(dualSteeringFlagIsFalse)_this.handleDualSteeringCheck();var deletedElements=boatSystems.splice(index,1);updateBoatDetails({boatSystems:boatSystems});_this.updateValidationAfterDelete(index,deletedElements);var currentSystemIndex=currentSystem.index;var newState={boatSystems:boatSystems,isModalOpen:false};if(dualSteeringFlagIsFalse){newState.dualSteering=false;}if(index<=currentSystemIndex)newState.currentSystem={};_this.setState(newState,function(){if(_this.state.boatSystems.length&&index<=currentSystemIndex){_this.setSystemsNames(deletedElements[0]);if(currentSystemIndex===0)_this.handleSystemChoose(0,true);else _this.handleSystemChoose(currentSystemIndex-1,true);}});};_this.setSystemsNames=function(_ref3){var systemTypeToRename=_ref3.componentSystemId;var boatSystems=_this.state.boatSystems;boatSystems.forEach(function(system,index){if(!systemTypeToRename||systemTypeToRename===system.componentSystemId){var fullName=_this.allSystemsList.find(function(sys){return sys.id===system.componentSystemId;}).name;var systemName=fullName.split('(')[0].trim();var sameTypeSystems=0;var systemOrder=1;boatSystems.forEach(function(otherSystem,otherIndex){if(otherSystem.componentSystemId===system.componentSystemId){sameTypeSystems++;if(otherIndex<index)systemOrder++;}});if(sameTypeSystems!==1)systemName=systemName+(' ('+systemOrder+')');boatSystems[index].name=systemName;}});_this.setState({boatSystems:boatSystems});};_this.updateValidationAfterDelete=function(index,deletedElements){var _this$state5=_this.state,invalidList=_this$state5.invalidList,validList=_this$state5.validList,invalidComponents=_this$state5.invalidComponents;delete validList[index];delete invalidList[index];Object.keys(validList).sort().forEach(function(key){if(key>index){validList[key-1]=validList[key];delete validList[key];}});Object.keys(invalidList).sort().forEach(function(key){if(key>index){invalidList[key-1]=invalidList[key];delete invalidList[key];}});if(deletedElements[0].ruleValueRequests)deletedElements[0].ruleValueRequests.forEach(function(rule){Object.keys(rule.componentIdWithQuantityMap).forEach(function(componentId){delete invalidComponents[componentId];});});_this.setState({invalidComponents:invalidComponents,validList:validList,invalidList:invalidList});};_this.isSystemEmpty=function(index){var boatSystems=_this.state.boatSystems;var activeSystem=boatSystems[index];for(var i in activeSystem.optionValueRequests){if(activeSystem.optionValueRequests[i].value!=='')return false;}for(var _i in activeSystem.ruleValueRequests){if(activeSystem.ruleValueRequests[_i].value!=='')return false;}return true;};_this.closeModal=function(){_this.setState({isModalOpen:false});};_this.selectComponent=function(ruleId,component){var markStepAsRedacted=_this.props.markStepAsRedacted;var _this$state6=_this.state,boatSystems=_this$state6.boatSystems,currentSystem=_this$state6.currentSystem,invalidList=_this$state6.invalidList,savedComponents=_this$state6.savedComponents;if(!component)return;markStepAsRedacted();var newSavedComponents=savedComponents;component.componentType={};component.componentType.id=component.componentTypeId;component.componentType.componentTypeName=_this.allTypesList.find(function(type){return+type.id===+component.componentTypeId;}).componentTypeName;component.applicationStatus='APPROVED';newSavedComponents.push(component);var activeSystem=boatSystems[currentSystem.index];var existingRule=activeSystem.ruleValueRequests.find(function(rule){return rule.ruleId===ruleId;});if(!existingRule){activeSystem.ruleValueRequests.push({ruleId:ruleId,componentIdWithQuantityMap:{}});existingRule=activeSystem.ruleValueRequests[activeSystem.ruleValueRequests.length-1];}existingRule.componentIdWithQuantityMap[component.id]=1;_this.setState({boatSystems:boatSystems,savedComponents:newSavedComponents},function(){if(invalidList[currentSystem.index])_this.validateNotSelectedSystem(currentSystem.index);});};_this.handleAdditionalInput=function(optionId){return function(value){var _this$state7=_this.state,boatSystems=_this$state7.boatSystems,currentSystem=_this$state7.currentSystem;var element=boatSystems[currentSystem.index].optionValueRequests.find(function(option){return+option.optionId===+optionId;});if(element)element.value=value;else boatSystems[currentSystem.index].optionValueRequests.push({optionId:optionId,value:value});_this.setState({boatSystems:boatSystems});};};_this.removeComponent=function(ruleId,componentId){return function(){var markStepAsRedacted=_this.props.markStepAsRedacted;var _this$state8=_this.state,boatSystems=_this$state8.boatSystems,currentSystem=_this$state8.currentSystem,invalidList=_this$state8.invalidList,invalidComponents=_this$state8.invalidComponents;var activeSystem=boatSystems[currentSystem.index];markStepAsRedacted();var ruleValueRequest=activeSystem.ruleValueRequests.find(function(rule){return rule.ruleId===ruleId;});delete ruleValueRequest.componentIdWithQuantityMap[componentId];if(!Object.keys(ruleValueRequest.componentIdWithQuantityMap).length){var index=activeSystem.ruleValueRequests.findIndex(function(rule){return rule.ruleId===ruleId;});activeSystem.ruleValueRequests.splice(index,1);}delete invalidComponents[componentId];_this.setState({boatSystems:boatSystems,invalidComponents:invalidComponents},function(){if(invalidList[currentSystem.index])_this.validateNotSelectedSystem(currentSystem.index);});};};_this.updateQuantity=function(ruleId,componentId,inc){return function(){var _this$state9=_this.state,boatSystems=_this$state9.boatSystems,currentSystem=_this$state9.currentSystem;var activeSystem=boatSystems[currentSystem.index];if(inc)++activeSystem.ruleValueRequests.find(function(rule){return rule.ruleId===ruleId;}).componentIdWithQuantityMap[componentId];else--activeSystem.ruleValueRequests.find(function(rule){return rule.ruleId===ruleId;}).componentIdWithQuantityMap[componentId];_this.setState({boatSystems:boatSystems});};};_this.validateNotSelectedSystem=function(key){var savedComponents=_this.state.savedComponents;var savedSystemData=_this.state.boatSystems[key];var dataRequests=[];if(!_this.systemStructures[savedSystemData.componentSystemId]){dataRequests.push(__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getBoatSystemStructure(savedSystemData.componentSystemId)));}var savedComponentsWithoutDataIds=[];if(savedSystemData.ruleValueRequests)savedSystemData.ruleValueRequests.forEach(function(savedRule){var _loop=function _loop(savedComponentId){if(!savedComponents.find(function(component){return+component.id===+savedComponentId;})){savedComponentsWithoutDataIds.push(savedComponentId);}};for(var savedComponentId in savedRule.componentIdWithQuantityMap){_loop(savedComponentId);}});if(savedComponentsWithoutDataIds.length){dataRequests.push(__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getComponent(savedComponentsWithoutDataIds)));}return Promise.all(dataRequests).then(function(result){var systemStructureTemplate=result.find(function(response){return response.data&&response.data.combinations;});if(systemStructureTemplate){systemStructureTemplate=systemStructureTemplate.data;_this.systemStructures[savedSystemData.componentSystemId]=systemStructureTemplate;}else{systemStructureTemplate=_this.systemStructures[savedSystemData.componentSystemId];}var newSavedComponents=result.find(function(response){return response.data&&response.data[0]&&response.data[0].componentType;});newSavedComponents=newSavedComponents?newSavedComponents.data:[];var selectedCombinationStructureTemplate=_this.getChosenCombination(systemStructureTemplate.combinations,savedSystemData);var systemInvalid=false;var newInvalidComponents={};var newInvalidSystems={};var newValidSystems={};var chosenTypeIdsForEachCombinationRule=[];selectedCombinationStructureTemplate.requiredRules.forEach(function(ruleTemplate){var savedRuleData=savedSystemData.ruleValueRequests?savedSystemData.ruleValueRequests.find(function(savedRule){return savedRule.ruleId===ruleTemplate.id;}):null;if(!savedRuleData||!Object.keys(savedRuleData.componentIdWithQuantityMap).length){if(!ruleTemplate.optional){systemInvalid=true;if(!newInvalidSystems[key])newInvalidSystems[key]={};newInvalidSystems[key][ruleTemplate.id]=true;}}else{var _loop2=function _loop2(savedComponentId){var componentData=[].concat(_toConsumableArray(newSavedComponents),_toConsumableArray(_this.state.savedComponents)).find(function(component){return+component.id===+savedComponentId;});if(!chosenTypeIdsForEachCombinationRule[ruleTemplate.id]&&ruleTemplate.componentTypeIds.indexOf(componentData.componentType.id)!==-1){chosenTypeIdsForEachCombinationRule[ruleTemplate.id]=componentData.componentType.id;}if(!componentData.manufacturerIsActive||componentData.applicationStatus!=='APPROVED'||ruleTemplate.componentTypeIds.indexOf(componentData.componentType.id)===-1){systemInvalid=true;newInvalidComponents[savedComponentId]=true;if(!newInvalidSystems[key])newInvalidSystems[key]={};newInvalidSystems[key][ruleTemplate.id]=true;}};for(var savedComponentId in savedRuleData.componentIdWithQuantityMap){_loop2(savedComponentId);}}});if(!systemInvalid)newValidSystems[key]=true;var newSelectedTypes=_this.state.selectedTypes;newSelectedTypes[key]=chosenTypeIdsForEachCombinationRule;_this.setState(function(prevState){var newInvalidList=Object.assign({},prevState.invalidList,newInvalidSystems);var newValidList=Object.assign({},prevState.validList,newValidSystems);if(systemInvalid)delete newValidList[key];else delete newInvalidList[key];return{invalidList:newInvalidList,validList:newValidList,invalidComponents:Object.assign({},prevState.invalidComponents,newInvalidComponents),selectedTypes:newSelectedTypes,savedComponents:[].concat(_toConsumableArray(newSavedComponents),_toConsumableArray(prevState.savedComponents))};},function(){_this.AmountOfNotValidatedSystems--;});});};_this.validateSystemBeforeSave=function(key){var _this$state10=_this.state,boatSystems=_this$state10.boatSystems,invalidList=_this$state10.invalidList,validList=_this$state10.validList,invalidComponents=_this$state10.invalidComponents,selectedCombinationStructureTemplate=_this$state10.selectedCombination;var savedSystemData=boatSystems[key];return new Promise(function(resolve,reject){var systemInvalid=false;var newInvalidSystems=invalidList;var newValidSystems=validList;selectedCombinationStructureTemplate.requiredRules.forEach(function(ruleTemplate){var savedRuleData=savedSystemData.ruleValueRequests?savedSystemData.ruleValueRequests.find(function(savedRule){return savedRule.ruleId===ruleTemplate.id;}):null;if(!savedRuleData||!Object.keys(savedRuleData.componentIdWithQuantityMap).length){if(!ruleTemplate.optional){systemInvalid=true;if(!newInvalidSystems[key])newInvalidSystems[key]={};newInvalidSystems[key][ruleTemplate.id]=true;}}else{for(var savedComponentId in savedRuleData.componentIdWithQuantityMap){if(invalidComponents[savedComponentId]){systemInvalid=true;if(!newInvalidSystems[key])newInvalidSystems[key]={};newInvalidSystems[key][ruleTemplate.id]=true;}}}});if(!systemInvalid)newValidSystems[key]=true;_this.setState({invalidList:newInvalidSystems,validList:newValidSystems},function(){if(systemInvalid)reject();else resolve();});});};_this.saveSystem=function(key){var _this$state11=_this.state,boatSystems=_this$state11.boatSystems,selectedCombination=_this$state11.selectedCombination;var id=_this.props.boat.id;var activeSystem=boatSystems[key];return new Promise(function(resolve,reject){_this.validateSystemBeforeSave(key).then(function(){var systemDataPull=Object.assign({boatId:id,description:''},activeSystem,{ruleValueRequests:[]});var deleteList=[];activeSystem.ruleValueRequests.forEach(function(filledType,typeIndex){if(selectedCombination.requiredRules.find(function(rule){return filledType.ruleId===rule.id;})){systemDataPull.ruleValueRequests.push(filledType);}else{deleteList.push(typeIndex);}});var spliceShift=0;deleteList.forEach(function(index){activeSystem.ruleValueRequests.splice(index-spliceShift,1);spliceShift++;});if(activeSystem.id)systemDataPull.id=activeSystem.id;delete systemDataPull.name;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].saveSystem,systemDataPull).then(function(_ref4){var data=_ref4.data;activeSystem.id=data.id;_this.setState({boatSystems:boatSystems},function(){resolve();});});}).catch(function(){reject();});});};_this.sendErrorMessage=function(){var _this$state12=_this.state,invalidList=_this$state12.invalidList,invalidComponents=_this$state12.invalidComponents;if(Object.keys(invalidComponents).length){__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error(2,'Cannot save application.','Please check the Component Systems');}else if(Object.keys(invalidList).length){__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Invalid system configuration','Add components to all systems or delete empty ones');}};_this.handleMoveToNextStep=function(){var _this$state13=_this.state,currentSystem=_this$state13.currentSystem,boatSystems=_this$state13.boatSystems;var _this$props3=_this.props,goToStep=_this$props3.goToStep,updateBoatDetails=_this$props3.updateBoatDetails;if(currentSystem.index!==undefined){_this.saveSystem(currentSystem.index).then(function(){if(_this.isValidData()){updateBoatDetails({boatSystems:boatSystems});if(_this.AmountOfNotValidatedSystems<=0){goToStep('next',true);}else{__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Calculation in progress','Please wait, while system recalculate values');}}else{_this.sendErrorMessage();}}).catch(_this.sendErrorMessage);}else{if(_this.isValidData()){if(_this.AmountOfNotValidatedSystems<=0){goToStep('next',true);}else{__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Calculation in progress','Please wait, while system recalculate values');}}else{_this.sendErrorMessage();}}};_this.handleMoveToArbitraryStep=function(stepId){var _this$state14=_this.state,currentSystem=_this$state14.currentSystem,boatSystems=_this$state14.boatSystems;var _this$props4=_this.props,goToStep=_this$props4.goToStep,stepIsChanged=_this$props4.stepIsChanged,updateBoatDetails=_this$props4.updateBoatDetails;var step=typeof stepId==='string'?stepId:'prev';if(!stepIsChanged){if(_this.AmountOfNotValidatedSystems<=0){return goToStep(step,true);}else{return __WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Calculation in progress','Please wait, while system recalculate values');}}if(currentSystem.index!==undefined){_this.saveSystem(currentSystem).then(function(){if(_this.isValidData()){updateBoatDetails({boatSystems:boatSystems});if(_this.AmountOfNotValidatedSystems<=0){goToStep(step,true);}else{__WEBPACK_IMPORTED_MODULE_8_dom_managers_notification__["a" /* default */].error('note','Calculation in progress','Please wait, while system recalculate values');}}else{goToStep(step,false);}}).catch(function(){goToStep(step,false);});}else{if(_this.isValidData())goToStep(step,true);else goToStep(step,false);}};_this.handleDualSteeringCheck=function(){var _this$props5=_this.props,markStepAsRedacted=_this$props5.markStepAsRedacted,updateBoatDetails=_this$props5.updateBoatDetails;var id=_this.props.boat.id;var dualSteering=_this.state.dualSteering;dualSteering=!dualSteering;__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].saveSteeringSystem(id,dualSteering)).then(function(){markStepAsRedacted();updateBoatDetails({dualSteering:dualSteering});_this.setState({dualSteering:dualSteering});});};_this.isValidData=function(){var _this$state15=_this.state,invalidList=_this$state15.invalidList,invalidComponents=_this$state15.invalidComponents;return!Object.keys(invalidList).length&&!Object.keys(invalidComponents).length;};_this.getCombinationCompositionReminder=function(){var currentSystem=_this.state.currentSystem;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__configuration-composition-wrapper'},INFO[currentSystem.id].map(function(str,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'boat-systems-scene__configuration-composition-text'},str);}));};_this.state={isModalOpen:false,currentSystem:{},allComponents:{},allManufacturers:{},savedComponents:[],selectedCombination:{},invalidList:{},validList:{},invalidComponents:{},boatSystems:[].concat(_toConsumableArray(props.boat.boatSystems||[])),dualSteering:props.boat.dualSteering!==undefined?props.boat.dualSteering:undefined,selectedTypes:{},selectedManufacturersFilters:{}};_this.loadedTypes={};_this.additionalSectionName='';_this.allSystemsList=[];_this.systemStructures={};_this.AmountOfNotValidatedSystems=0;return _this;}_createClass(AddComponents,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var boatSystems=this.state.boatSystems;var dataRequests=[__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["g" /* systemAPI */].getAvailableBoatSystemsList),__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["b" /* componentAPI */].types)];Promise.all(dataRequests).then(function(result){_this2.allSystemsList=result[0].data;_this2.allTypesList=result[1].data;_this2.setState({invalidList:{},validList:{}},function(){_this2.AmountOfNotValidatedSystems=boatSystems.length;Promise.all(boatSystems.map(function(systemEntry,index){_this2.setSystemsNames(boatSystems[index]);return _this2.validateNotSelectedSystem(index);})).then(function(){if(boatSystems.length)_this2.handleSystemChoose(0,true);});});});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var _this3=this;var boatSystems=this.state.boatSystems;if(this.props.boat.boatSystems){if(boatSystems.length<nextProps.boat.boatSystems.length){this.setState({boatSystems:nextProps.boat.boatSystems,invalidList:{},validList:{},dualSteering:nextProps.boat.boatSpecifications.dualSteering},function(){_this3.AmountOfNotValidatedSystems=boatSystems.length;Promise.all(boatSystems.map(function(systemEntry,index){_this3.setSystemsNames(boatSystems[index]);return _this3.validateNotSelectedSystem(index);})).then(function(){if(boatSystems.length)_this3.handleSystemChoose(0,true);});});}}return true;}},{key:'render',value:function render(){var _this4=this;var _state=this.state,boatSystems=_state.boatSystems,currentSystem=_state.currentSystem,allComponents=_state.allComponents,selectedCombination=_state.selectedCombination,isModalOpen=_state.isModalOpen,invalidList=_state.invalidList,validList=_state.validList,dualSteering=_state.dualSteering,invalidComponents=_state.invalidComponents,savedComponents=_state.savedComponents,selectedManufacturersFilters=_state.selectedManufacturersFilters,allManufacturers=_state.allManufacturers;var _props=this.props,getNavBar=_props.getNavBar,stepIsChanged=_props.stepIsChanged,getHeader=_props.getHeader,updateBoatDetails=_props.updateBoatDetails;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(function(){return new Promise(function(resolve,reject){if(_this4.isValidData()){_this4.saveSystem(currentSystem.index).then(function(){updateBoatDetails({boatSystems:boatSystems});resolve();});}else{_this4.sendErrorMessage();reject();}});}),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Systems__["a" /* default */],{boatSystems:boatSystems,currentSystem:currentSystem,invalidList:invalidList,validList:validList,allSystemsList:this.allSystemsList,handleSystemChoose:this.handleSystemChoose,handleSystemAdd:this.handleSystemAdd,handleSystemDelete:this.handleSystemDelete}),dualSteering!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SteeringSystemSection__["a" /* default */],{dualSteering:dualSteering,currentSystem:currentSystem,handleDualSteeringCheck:this.handleDualSteeringCheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AdditionalSection__["a" /* default */],{boatSystems:boatSystems,currentSystem:currentSystem,additionalSectionName:this.additionalSectionName,handleAdditionalInput:this.handleAdditionalInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CombinationPicker__["a" /* default */],{boatSystems:boatSystems,currentSystem:currentSystem,allComponents:allComponents,selectedCombination:selectedCombination,handleCombinationChoose:this.handleCombinationChoose,getCombinationCompositionReminder:this.getCombinationCompositionReminder}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CombinationSection__["a" /* default */],{boatSystems:boatSystems,currentSystem:currentSystem,allComponents:allComponents,allTypes:this.allTypesList,loadedTypes:this.loadedTypes,savedComponents:savedComponents,selectedCombination:selectedCombination,invalidList:invalidList,invalidComponents:invalidComponents,selectComponent:this.selectComponent,removeComponent:this.removeComponent,updateQuantity:this.updateQuantity,handleTypeChose:this.handleTypeChose,selectSingleType:this.selectSingleType,selectedTypes:this.state.selectedTypes[currentSystem.index],getCombinationCompositionReminder:this.getCombinationCompositionReminder,manufacturersList:allManufacturers,selectedManufacturersFilters:selectedManufacturersFilters,handleSelectManufacturerFilter:this.handleSelectManufacturerFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this4.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body'},this.modalBody),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_11_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_11_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))));}}]);return AddComponents;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Systems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Systems=function(_React$Component){_inherits(Systems,_React$Component);function Systems(props){_classCallCheck(this,Systems);var _this=_possibleConstructorReturn(this,(Systems.__proto__||Object.getPrototypeOf(Systems)).call(this,props));_this.getCurrentClass=function(index){var _this$props=_this.props,currentSystem=_this$props.currentSystem,invalidList=_this$props.invalidList,validList=_this$props.validList;if(index===+currentSystem.index)return'active';if(invalidList[index])return'invalid';if(validList[index])return'valid';return'';};_this.getSelectedElements=function(){var _this$props2=_this.props,boatSystems=_this$props2.boatSystems,handleSystemDelete=_this$props2.handleSystemDelete;var selectedSystemsBannersList=boatSystems.map(function(system,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'system'+index,className:'boat-systems-scene__banner '+_this.getCurrentClass(index),onClick:_this.handleSystemChoose(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-icon boat-systems-scene__banner-icon_type_'+system.componentSystemId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-text'},system.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-delete-button',onClick:handleSystemDelete(index)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-valid-label'}));});selectedSystemsBannersList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banners-delimiter'}));return selectedSystemsBannersList.length>1?selectedSystemsBannersList:null;};_this.getAvailableSystemsBanners=function(){var isOpen=_this.state.isOpen;var _this$props3=_this.props,boatSystems=_this$props3.boatSystems,allSystemsList=_this$props3.allSystemsList;return allSystemsList.filter(function(system){return boatSystems.filter(function(boatSystem){return system.id===boatSystem.componentSystemId;}).length<system.maxQuantity;}).map(function(system,index){var openIconLeftShift=(index+1)*70;var nameSliceIndex=system.name.search(/\([^0-9]+/);var name=nameSliceIndex!==-1?system.name.slice(0,nameSliceIndex):system.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:system.id,className:'boat-systems-scene__banner',onClick:_this.handleSystemAdd(system),style:{left:isOpen?0:-openIconLeftShift}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-icon boat-systems-scene__banner-icon_type_'+system.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-text'},name));});};_this.handleSystemAdd=function(system){return function(){var handleSystemAdd=_this.props.handleSystemAdd;handleSystemAdd(system);_this.toggleSystems();};};_this.handleSystemChoose=function(system){return function(){var handleSystemChoose=_this.props.handleSystemChoose;handleSystemChoose(system);};};_this.toggleSystems=function(){_this.setState(function(prevState){return{isOpen:!prevState.isOpen};});};_this.state={isOpen:true};return _this;}_createClass(Systems,[{key:'render',value:function render(){var invalidList=this.props.invalidList;var addSystemBannersList=this.getAvailableSystemsBanners();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section boat-systems-scene__banners-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Boat Systems'),Object.keys(invalidList).length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banners-section-error-text'},'If the Component System is added, all required Components must be filled *'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banners-wrapper'},this.getSelectedElements(),!!addSystemBannersList.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner add-system _z_index_10 _background_color_white',onClick:this.toggleSystems},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-icon'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__banner-text'},'Add System')),addSystemBannersList)));}}]);return Systems;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdditionalSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Input__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdditionalSection=function(_React$Component){_inherits(AdditionalSection,_React$Component);function AdditionalSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdditionalSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdditionalSection.__proto__||Object.getPrototypeOf(AdditionalSection)).call.apply(_ref,[this].concat(args))),_this),_this.getInputValue=function(id){var _this$props=_this.props,boatSystems=_this$props.boatSystems,currentSystem=_this$props.currentSystem;var activeSystem=boatSystems[currentSystem.index];if(!activeSystem)return'';var element=activeSystem.optionValueRequests.find(function(option){return option.optionId===id;});if(element)return element.value;return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdditionalSection,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentSystem=_props.currentSystem,handleAdditionalInput=_props.handleAdditionalInput,additionalSectionName=_props.additionalSectionName;if(!currentSystem.options||!currentSystem.options.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,additionalSectionName),currentSystem.options.sort(function(a,b){return a.id-b.id;}).map(function(input){var units='';switch(input.optionType){case'INCHES':units='In.';break;case'SQUARE_INCHES':units='Sq. In.';break;case'CUBUC_FOOT':units='Cu. Ft.';break;default:break;}switch(input.optionType){case'VARIANTS':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:input.id,className:'boat-systems-scene__additional-info-single-input-wrapper '+(currentSystem.id===1?'blow':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{defaultItem:_this2.getInputValue(input.id),type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primary,mainWrapperClassName:'_width_210 _margin_top_0',inputClassName:'_border_radius_10 _height_40  _margin_top_12',dropDownClassName:'_border_radius_bottom_left_10 _border_radius_bottom_right_10',selectionList:input.optionVariants.split(', '),label:input.name,handleSelect:handleAdditionalInput(input.id)}));case'INTEGER':case'INCHES':case'STRING':case'SQUARE_INCHES':case'CUBUC_FOOT':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:input.id,className:'boat-systems-scene__additional-info-single-input-wrapper '+(currentSystem.id===1?'blow':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["a" /* Input */],{isNumeric:true,inputClassName:'_border_radius_10 _margin_top_12 _height_40 _width_210',label:input.name,value:_this2.getInputValue(input.id),onChange:handleAdditionalInput(input.id),units:units}));default:return input.options.map(function(input){if(input.optionType===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:input.id,className:'boat-systems-scene__additional-info-multi-input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__additional-info-multi-input-label'},input.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__additional-info-multi-input-fields-wrapper'},input.options.map(function(input){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Input__["b" /* MultiInput */],{key:input.id,label:input.name,value:_this2.getInputValue(input.id),onChange:handleAdditionalInput(input.id),units:input.optionType==='SQUARE_INCHES'?'Sq. In.':'',numbersOnly:true,styles:{width:110,height:40}});})));}return null;});}}));}}]);return AdditionalSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Checkbox__ = __webpack_require__(89);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var dualSteering=_ref.dualSteering,currentSystem=_ref.currentSystem,handleDualSteeringCheck=_ref.handleDualSteeringCheck;if(currentSystem&&currentSystem.id===5){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section  dual-steering-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Steering system'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label'},'Steering System consists of Steering Wheel and Electrical Steering Helm or Hydraulic Steering Helm or Mechanical Helm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Checkbox__["a" /* default */],{value:dualSteering,onChange:handleDualSteeringCheck,label:'Dual-Steering',labelType:'_margin_left_10'}));}else{return null;}});

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var boatSystems=_ref.boatSystems,currentSystem=_ref.currentSystem,allComponents=_ref.allComponents,selectedCombination=_ref.selectedCombination,handleCombinationChoose=_ref.handleCombinationChoose,getCombinationCompositionReminder=_ref.getCombinationCompositionReminder;var activeSystem=boatSystems[currentSystem.index];if(!activeSystem||currentSystem.combinations.length<=1)return null;function _handleCombinationChoose(index){return function(){handleCombinationChoose(index);};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,activeSystem.name),getCombinationCompositionReminder(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boat-systems-scene__configuration-chose-button-holder'},currentSystem.combinations.map(function(combination,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:combination.id,className:'boat-systems-scene__configuration-chose-button '+(selectedCombination.id===combination.id?'active':''),onClick:_handleCombinationChoose(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Configuration '+(index+1)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'boat-systems-scene__configuration-additional-reminder-text'},'Attention: Choosing Configuration allows to add different component types.'));});

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombinationSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CombinationSection=function(_React$Component){_inherits(CombinationSection,_React$Component);function CombinationSection(props){_classCallCheck(this,CombinationSection);var _this=_possibleConstructorReturn(this,(CombinationSection.__proto__||Object.getPrototypeOf(CombinationSection)).call(this,props));_this.isMaxComponents=function(rule){var _this$props=_this.props,boatSystems=_this$props.boatSystems,currentSystem=_this$props.currentSystem;var activeSystem=boatSystems[currentSystem.index];var ruleValueRequest=activeSystem.ruleValueRequests?activeSystem.ruleValueRequests.find(function(element){return element.ruleId===rule.id;}):null;if(ruleValueRequest&&ruleValueRequest.componentIdWithQuantityMap){if(Object.keys(ruleValueRequest.componentIdWithQuantityMap).length===rule.maxComponentQuantity)return'equal';if(Object.keys(ruleValueRequest.componentIdWithQuantityMap).length>rule.maxComponentQuantity)return'more';}return'';};_this.handleSelectComponent=function(ruleId){return function(component){var selectComponent=_this.props.selectComponent;selectComponent(ruleId,component);};};_this.getSelectedType=function(rule,availableTypesList){var selectedTypes=_this.props.selectedTypes;return availableTypesList.find(function(type){return type.typeId===selectedTypes[rule.id];});};_this.getAvailableComponentsList=function(ruleId){var _this$props2=_this.props,selectedTypes=_this$props2.selectedTypes,boatSystems=_this$props2.boatSystems,currentSystem=_this$props2.currentSystem,allComponents=_this$props2.allComponents,selectedManufacturersFilters=_this$props2.selectedManufacturersFilters;var activeSystem=boatSystems[currentSystem.index];var ruleValueRequest=activeSystem.ruleValueRequests?activeSystem.ruleValueRequests.find(function(rule){return rule.ruleId===ruleId;}):null;if(!selectedTypes[ruleId]||!allComponents[selectedTypes[ruleId]])return[];if(!ruleValueRequest)return allComponents[selectedTypes[ruleId]].filter(function(component){return!selectedManufacturersFilters[ruleId]||component.manufacturerName===selectedManufacturersFilters[ruleId];});return allComponents[selectedTypes[ruleId]].filter(function(component){return!ruleValueRequest.componentIdWithQuantityMap[component.id]&&(!selectedManufacturersFilters[ruleId]||component.manufacturerName===selectedManufacturersFilters[ruleId]);});};_this.getAddedComponentsList=function(combinationSingleTypeHolder){var _this$props3=_this.props,savedComponents=_this$props3.savedComponents,boatSystems=_this$props3.boatSystems,currentSystem=_this$props3.currentSystem;var activeSystem=boatSystems[currentSystem.index];var typeHolderComponents=activeSystem.ruleValueRequests?activeSystem.ruleValueRequests.find(function(ruleElement){return ruleElement.ruleId===combinationSingleTypeHolder.id;}):null;if(typeHolderComponents){return Object.keys(typeHolderComponents.componentIdWithQuantityMap).map(function(key){var component=savedComponents.find(function(component){return component.id===+key;});if(component)component.quantity=typeHolderComponents.componentIdWithQuantityMap[key];return component;}).filter(function(component){return component;});}else{return[];}};_this.getStyle=function(rule){var _this$props4=_this.props,currentSystem=_this$props4.currentSystem,invalidList=_this$props4.invalidList;if(_this.isMaxComponents(rule))return'filled';if(invalidList[currentSystem.index]&&invalidList[currentSystem.index][rule.id])return'error';return'';};_this.hasInvalidComponents=function(){var _this$props5=_this.props,selectedCombination=_this$props5.selectedCombination,invalidComponents=_this$props5.invalidComponents;var isBad=false;selectedCombination.requiredRules.forEach(function(rule){var components=_this.getAddedComponentsList(rule);components.forEach(function(component){if(invalidComponents[component.id])isBad=true;});});return isBad;};_this.getAvailableTypesList=function(componentTypeIds){var allTypes=_this.props.allTypes;return componentTypeIds.map(function(typeId){var typeData=allTypes.find(function(type){return+type.id===+typeId;});if(typeData.active){return{typeId:typeId,value:typeData.componentTypeName};}else{return null;}}).filter(function(type){return type;});};_this.state={selectedTypes:{}};return _this;}_createClass(CombinationSection,[{key:'render',value:function render(){var _this2=this;var _props=this.props,boatSystems=_props.boatSystems,currentSystem=_props.currentSystem,selectedCombination=_props.selectedCombination,removeComponent=_props.removeComponent,updateQuantity=_props.updateQuantity,invalidComponents=_props.invalidComponents,handleTypeChose=_props.handleTypeChose,selectSingleType=_props.selectSingleType,loadedTypes=_props.loadedTypes,selectedTypes=_props.selectedTypes,getCombinationCompositionReminder=_props.getCombinationCompositionReminder,manufacturersList=_props.manufacturersList,handleSelectManufacturerFilter=_props.handleSelectManufacturerFilter,selectedManufacturersFilters=_props.selectedManufacturersFilters;var activeSystem=boatSystems[currentSystem.index];if(!activeSystem)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section system-configuration-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Add Components'),currentSystem.combinations.length<=1&&getCombinationCompositionReminder(),this.hasInvalidComponents()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type-set-quantity-label error'},'One or more of the Components is not type accepted. Please change you selection.'),selectedCombination.requiredRules.map(function(combinationSingleTypeHolder){var availableTypesList=_this2.getAvailableTypesList(combinationSingleTypeHolder.componentTypeIds);var typeHolderExistingComponents=_this2.getAddedComponentsList(combinationSingleTypeHolder);var selectedType=_this2.getSelectedType(combinationSingleTypeHolder,availableTypesList);var componentAndManufacturerFieldDisabled=_this2.isMaxComponents(combinationSingleTypeHolder)||!selectedType;var isSteeringHelm=combinationSingleTypeHolder.id===10&&selectedCombination.id===6;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:combinationSingleTypeHolder.id,className:'component-type-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'type-set-header '+_this2.getStyle(combinationSingleTypeHolder)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type-set-quantity-label '+(isSteeringHelm?'type-set-quantity-label_for-steering':'')+' '+(_this2.isMaxComponents(combinationSingleTypeHolder)==='more'?'error':'')},_this2.isMaxComponents(combinationSingleTypeHolder)?'Only '+combinationSingleTypeHolder.maxComponentQuantity+' Component(s) can be added':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type-name'},availableTypesList.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primarySmall,label:isSteeringHelm?'Steering Helm Assembly':'',withoutSearch:true,selectionList:availableTypesList,defaultItem:selectedType,placeholder:'Please select...',itemNameIndicator:'value',error:_this2.getStyle(combinationSingleTypeHolder)==='error'?' ':'',disabled:_this2.isMaxComponents(combinationSingleTypeHolder)||!availableTypesList.length,handleSelect:handleTypeChose(combinationSingleTypeHolder.id)}):selectSingleType(combinationSingleTypeHolder.id,availableTypesList[0])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'_flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primarySmall,mainWrapperClassName:'_margin_right_30 '+(isSteeringHelm?'_margin_top_22':''),dropDownClassName:'_max_height_120',isLoading:loadedTypes[selectedTypes[combinationSingleTypeHolder.id]]===false,selectionList:manufacturersList[selectedTypes[combinationSingleTypeHolder.id]],defaultItem:selectedManufacturersFilters[combinationSingleTypeHolder.id],handleSelect:handleSelectManufacturerFilter(combinationSingleTypeHolder.id),placeholder:'Manufacturer',disabled:componentAndManufacturerFieldDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primarySmall,mainWrapperClassName:''+(isSteeringHelm?'_margin_top_22':''),dropDownClassName:'_max_height_120',isLoading:loadedTypes[selectedTypes[combinationSingleTypeHolder.id]]===false,selectionList:_this2.getAvailableComponentsList(combinationSingleTypeHolder.id),itemNameIndicator:['id','description'],isSlave:true,defaultItem:'',handleSelect:_this2.handleSelectComponent(combinationSingleTypeHolder.id),error:_this2.getStyle(combinationSingleTypeHolder)==='error'?' ':'',placeholder:''+(availableTypesList.length?'Type Accepted Number':'No Components found'),disabled:componentAndManufacturerFieldDisabled}))),typeHolderExistingComponents.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'components-list selected'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column manufacturer'},'Manufacturer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column id'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column type'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column description'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column qty'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column action'})),typeHolderExistingComponents.map(function(component){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:component.id,className:invalidComponents[component.id]?'deprecated-component':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column manufacturer'},component.manufacturerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column id'},component.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column type'},component.componentType.componentTypeName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column description'},component.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column qty'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(!component.quantity||component.quantity===1?'hidden':''),onClick:updateQuantity(combinationSingleTypeHolder.id,component.id)},'-'),component.quantity||1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(component.quantity<combinationSingleTypeHolder.maxQuantity?'':'hidden'),onClick:updateQuantity(combinationSingleTypeHolder.id,component.id,true)},'+')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delete',onClick:removeComponent(combinationSingleTypeHolder.id,component.id)})));})));}));}}]);return CombinationSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonPowerCapacity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Details_BasicInfo__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Details_BoatInfo__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Details_GeneralInfo__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Details_BoatSystems__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Details_CubicCapacity__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Details_BoatWeight__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Details_PersonWeightCapacity__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Details_PowerCapacity__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Details_BoatFloatation__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Details_Header__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Details_AdditionalFiles__ = __webpack_require__(377);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var PersonPowerCapacity=function(_React$Component){_inherits(PersonPowerCapacity,_React$Component);function PersonPowerCapacity(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PersonPowerCapacity);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PersonPowerCapacity.__proto__||Object.getPrototypeOf(PersonPowerCapacity)).call.apply(_ref,[this].concat(args))),_this),_this.handleMoveToArbitraryStep=function(stepId){var goToStep=_this.props.goToStep;goToStep(typeof stepId==='string'?stepId:'prev',true);},_this.handleSubmitButtonClick=function(){var handleBoatSubmit=_this.props.handleBoatSubmit;handleBoatSubmit();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PersonPowerCapacity,[{key:'render',value:function render(){var _props=this.props,user=_props.user,goToStep=_props.goToStep,boat=_props.boat,getNavBar=_props.getNavBar,handleDeleteDraft=_props.handleDeleteDraft,actionsList=_props.actionsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Details_Header__["a" /* default */],{actionsList:actionsList,isFinalReview:true,performAction:function performAction(){return function(){handleDeleteDraft();};},user:user,boat:boat}),getNavBar&&getNavBar(function(){},this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Details_BasicInfo__["a" /* default */],{boat:boat}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Details_BoatInfo__["a" /* default */],{boatSpecifications:boat.boatSpecifications,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Details_GeneralInfo__["a" /* default */],{boatSpecifications:boat.boatSpecifications,dualSteering:boat.dualSteering,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Details_BoatSystems__["a" /* default */],{boatSystems:boat.boatSystems,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Details_CubicCapacity__["a" /* default */],{cubicCapacity:boat.cubicCapacity,boatType:boat.boatType,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Details_BoatWeight__["a" /* default */],{plateType:boat.plateType,personPowerCapacity:boat.personPowerCapacity,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Details_PersonWeightCapacity__["a" /* default */],{personPowerCapacity:boat.personPowerCapacity,goToStep:goToStep,isFinalReview:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Details_PowerCapacity__["a" /* default */],{powerCapacity:boat.powerCapacity,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Details_BoatFloatation__["a" /* default */],{floatationCapacity:boat.floatationCapacity,applicationId:boat.id,isFinalReview:true,goToStep:goToStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Details_AdditionalFiles__["a" /* default */],{additionalFiles:boat.additionalFiles,applicationId:boat.id,goToStep:goToStep,isFinalReview:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_ApplicationActions__["a" /* default */],{saveButtonLabel:'Submit',saveButtonAction:this.handleSubmitButtonClick,backButtonLabel:'Prev. Step',backButtonAction:this.handleMoveToArbitraryStep}));}}]);return PersonPowerCapacity;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadAdditionalDocuments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_FilePicker__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoadAdditionalDocuments=function(_React$Component){_inherits(LoadAdditionalDocuments,_React$Component);function LoadAdditionalDocuments(props){_classCallCheck(this,LoadAdditionalDocuments);var _this=_possibleConstructorReturn(this,(LoadAdditionalDocuments.__proto__||Object.getPrototypeOf(LoadAdditionalDocuments)).call(this,props));_this.handleFileSelect=function(files){var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();_this.setState(function(prevState){return{files:[].concat(_toConsumableArray(prevState.files),_toConsumableArray(files))};});};_this.handleRemoveFile=function(index){return function(){var files=_this.state.files;var markStepAsRedacted=_this.props.markStepAsRedacted;markStepAsRedacted();if(files[index].created){_this.filesIdsToDelete.push(files[index].id);}_this.setState(function(prevState){prevState.files.splice(index,1);return{files:prevState.files};});};};_this.saveAdditionalFiles=function(){var files=_this.state.files;var boat=_this.props.boat;return new Promise(function(resolve,reject){if(files.length){var data=new FormData();files.filter(function(file){return!file.created;}).forEach(function(file){return data.append('reports',file);});__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].uploadAdditionalDocs(boat.id),data).then(function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].getAdditionalDocs(boat.id)).then(function(_ref){var data=_ref.data;_this.setState({files:data},resolve);});}).catch(function(){_this.setState({files:boat.additionalFiles},function(){reject();});});}else{resolve();}});};_this.deleteAdditionalFiles=function(){var files=_this.state.files;var boat=_this.props.boat;return new Promise(function(resolve,reject){if(_this.filesIdsToDelete.length){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].deleteAdditionalDocs(boat.id),_this.filesIdsToDelete).then(function(){_this.filesIdsToDelete.forEach(function(fileId){var deletedFileIndex=files.findIndex(function(file){return file.id===fileId;});files.splice(deletedFileIndex,1);});_this.filesIdsToDelete=[];resolve();}).catch(function(){_this.filesIdsToDelete=[];_this.setState({files:boat.additionalFiles});reject();});}else{resolve();}});};_this.saveData=function(){var updateBoatDetails=_this.props.updateBoatDetails;return new Promise(function(resolve,reject){_this.saveAdditionalFiles().then(function(){return _this.deleteAdditionalFiles();}).then(function(){updateBoatDetails({additionalFiles:_this.state.files});resolve();}).catch(function(){reject();});});};_this.handleMoveToNextStep=function(){var goToStep=_this.props.goToStep;_this.saveData().then(function(){goToStep('next',true);});};_this.handleMoveToArbitraryStep=function(stepId){var _this$props=_this.props,goToStep=_this$props.goToStep,stepIsChanged=_this$props.stepIsChanged;if(!stepIsChanged){return goToStep(typeof stepId==='string'?stepId:'prev',true);}_this.saveData().then(function(){goToStep(typeof stepId==='string'?stepId:'prev',true);}).catch(function(){goToStep(typeof stepId==='string'?stepId:'prev',false);});};_this.state={files:props.boat.additionalFiles?[].concat(_toConsumableArray(props.boat.additionalFiles)):[]};_this.filesIdsToDelete=[];return _this;}_createClass(LoadAdditionalDocuments,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(nextProps.boat.additionalFiles){if(nextProps.boat.additionalFiles>this.state.files.length+this.filesIdsToDelete.length){this.setState({files:Object.assign({},nextProps.boat.additionalFiles)});}}return true;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,getNavBar=_props.getNavBar,getHeader=_props.getHeader,stepIsChanged=_props.stepIsChanged,boat=_props.boat;var files=this.state.files;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,getHeader(this.saveData),getNavBar(this.handleMoveToNextStep,this.handleMoveToArbitraryStep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_FilePicker__["a" /* default */],{mainWrapperClassName:'_box-sizing_border-box',handleFileSelect:this.handleFileSelect,handleRemoveFile:this.handleRemoveFile,files:files,httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].downloadFile,currentId:boat.id},editableStateSectionHeader:'Upload Additional Documents',uploadButtonText:'Upload file'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Prev. Step',saveButtonLabel:'Next Step',saveButtonAction:stepIsChanged?this.handleMoveToNextStep:function(){_this2.handleMoveToArbitraryStep('next');},backButtonAction:this.handleMoveToArbitraryStep}));}}]);return LoadAdditionalDocuments;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var boat=_ref.boat,handleSaveStep=_ref.handleSaveStep,handleDeleteDraft=_ref.handleDeleteDraft,markCurrentStepAsSaved=_ref.markCurrentStepAsSaved,stepIsChanged=_ref.stepIsChanged,user=_ref.user,text=_ref.text;var getBoatTypeKey=function getBoatTypeKey(){var boatType=__WEBPACK_IMPORTED_MODULE_3_constants_boatApplication__["e" /* BOAT_TYPE_LIST */].find(function(type){return type.value===boat.boatType;});return boatType.name;};var Buttons=handleSaveStep?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,stepIsChanged&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'Save',type:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["a" /* buttonColor */].blue,buttonClassName:'_height_30 _width_90',onClick:function onClick(){handleSaveStep().then(function(){markCurrentStepAsSaved();__WEBPACK_IMPORTED_MODULE_2_dom_managers_notification__["a" /* default */].success('note','Your changes were saved successfully.');});}}),boat.status==='DRAFT'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'Delete',type:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_1_Components_Button__["a" /* buttonColor */].planeRed,buttonClassName:'_height_30 _width_90',onClick:handleDeleteDraft})):null;var headerText=text?text:''+(isFinite(boat.id)?'':'New ')+getBoatTypeKey()+' Application';//TODO header wrapped in div instead section to avoid conflict with old pre-bem styles change it if they will be removed
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'application-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-text-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:function onClick(){user.goToList();}},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,headerText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-buttons-wrapper'},Buttons));});

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NAVBAR_TABS=[{id:'generalInformation',name:'General Information',steps:['boat_type','engine_type','boat_specifications']},{id:'addComponents',name:'Add Components',steps:['add_components']},{id:'boatCalculations',name:'Boat Calculations',steps:['cubic_capacity','weight_capacity','power_capacity','floatation_capacity']},{id:'loadDocks',name:'Additional Documents',steps:['load_documents']},{id:'finalReview',name:'Final Review',steps:['final_review']}];var STATUSES={valid:'valid',empty:'empty',invalid:'invalid',current:'current'};var StepNavBar=function(_React$Component){_inherits(StepNavBar,_React$Component);function StepNavBar(props){_classCallCheck(this,StepNavBar);var _this=_possibleConstructorReturn(this,(StepNavBar.__proto__||Object.getPrototypeOf(StepNavBar)).call(this,props));_this.getTabsList=function(){var _this$props=_this.props,step=_this$props.step,stepsList=_this$props.stepsList;var currentTabIndex='';var tabsList=[];NAVBAR_TABS.forEach(function(tab){var steps=[];tab.steps.forEach(function(stepId){if(stepsList.find(function(st){return st.id===stepId;}))steps.push(stepId);if(stepId===step){currentTabIndex=tabsList.length;}});if(steps.length)tabsList.push({id:tab.id,name:tab.name,steps:steps});});_this.setState({tabsList:tabsList,currentTabIndex:currentTabIndex});};_this.goToStep=function(stepId){return function(){var _this$props2=_this.props,step=_this$props2.step,stepsList=_this$props2.stepsList,handleMoveToArbitraryStep=_this$props2.handleMoveToArbitraryStep,handleMoveToNextStep=_this$props2.handleMoveToNextStep;var currentStepIndex=stepsList.findIndex(function(st){return st.id===step;});var nextStepIndex=stepsList.findIndex(function(st){return st.id===stepId;});//TODO uncomment this string to allow quick steps navigation for debugging
//if (nextStepIndex !== currentStepIndex && process.env.NODE_ENV === 'development') return handleMoveToArbitraryStep(stepId);
if(nextStepIndex<currentStepIndex)handleMoveToArbitraryStep(stepId);else if(nextStepIndex-1===currentStepIndex)handleMoveToNextStep();else if(_this.checkIfPreviousStepsAreValid(nextStepIndex))handleMoveToArbitraryStep(stepId);};};_this.checkIfPreviousStepsAreValid=function(nextStepIndex){var _this$props3=_this.props,stepsList=_this$props3.stepsList,stepsValidation=_this$props3.stepsValidation;var previousStepsAreValid=true;stepsList.forEach(function(step,index){if(index<nextStepIndex&&!stepsValidation[step.id])previousStepsAreValid=false;});return previousStepsAreValid;};_this.goToTab=function(tabIndex){return function(){var stepsValidation=_this.props.stepsValidation;var tabsList=_this.state.tabsList;var lastValidStepId=tabsList[tabIndex].steps[0];tabsList[tabIndex].steps.forEach(function(stepId){if(stepsValidation[stepId])lastValidStepId=stepId;});_this.goToStep(lastValidStepId)();};};_this.getTabStatus=function(tabIndex){var _this$state=_this.state,currentTabIndex=_this$state.currentTabIndex,tabsList=_this$state.tabsList;var stepsValidation=_this.props.stepsValidation;var status=null;if(!tabsList[tabIndex])return STATUSES.empty;if(tabIndex===currentTabIndex){status=STATUSES.current;}else{tabsList[tabIndex].steps.forEach(function(stepId){if(stepsValidation[stepId]!==undefined){status=stepsValidation[stepId]?status||STATUSES.valid:STATUSES.invalid;}else{status=STATUSES.empty;}});}return status;};_this.getStepStatus=function(stepId){var _this$props4=_this.props,stepsValidation=_this$props4.stepsValidation,step=_this$props4.step;if(stepId===step)return STATUSES.current;else if(stepsValidation[stepId]===undefined)return STATUSES.empty;else if(stepsValidation[stepId])return STATUSES.valid;else if(!stepsValidation[stepId])return STATUSES.invalid;};_this.getSteps=function(){var _this$state2=_this.state,tabsList=_this$state2.tabsList,currentTabIndex=_this$state2.currentTabIndex;var stepsList=_this.props.stepsList;if(!tabsList[currentTabIndex]||tabsList[currentTabIndex].steps.length===1)return null;var steps=tabsList[currentTabIndex].steps;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'steps-wrapper'},steps.map(function(stepId){var step=stepsList.find(function(st){return st.id===stepId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:stepId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step '+_this.getStepStatus(stepId),onClick:_this.goToStep(stepId)},step?step.name:'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step-delimiter '+_this.getStepStatus(stepId)}));}));};_this.state={currentTabIndex:'',tabsList:[]};return _this;}_createClass(StepNavBar,[{key:'componentDidMount',value:function componentDidMount(){this.getTabsList();}},{key:'render',value:function render(){var _this2=this;var tabsList=this.state.tabsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'step-navbar-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-wrapper'},tabsList.map(function(tab,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:tab.id,className:'tab '+_this2.getTabStatus(index),onClick:_this2.goToTab(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),tab.name);})),this.getSteps());}}]);return StepNavBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (StepNavBar);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransitionBlockerModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Modal__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransitionBlockerModal=Object(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(TransitionBlockerModal,_React$Component);function TransitionBlockerModal(props){_classCallCheck(this,TransitionBlockerModal);var _this=_possibleConstructorReturn(this,(TransitionBlockerModal.__proto__||Object.getPrototypeOf(TransitionBlockerModal)).call(this,props));_this.showUnsavedDataWarning=function(location){_this.modalConfirmAction=function(){_this.setState({isModalOpen:false},function(){_this.transitionConfirmedByUser=true;_this.props.history.push(location);});};_this.setState({isModalOpen:true});};_this.closeModal=function(){_this.setState({isModalOpen:false});};_this.blockUnconfirmedTransition=function(location){if(_this.transitionConfirmedByUser||_this.props.transitionWhitelist.find(function(allowedTransitionNamePart){return location.pathname.includes(allowedTransitionNamePart);})){_this.transitionConfirmedByUser=false;return true;}_this.showUnsavedDataWarning(location);return false;};_this.state={isModalOpen:false};_this.transitionConfirmedByUser=false;return _this;}_createClass(TransitionBlockerModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,this.props.blockTransitions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["c" /* Prompt */],{message:this.blockUnconfirmedTransition}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Modal__["a" /* default */],{isOpen:this.state.isModalOpen},this.props.children,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:'Yes',buttonClassName:'_height_40 _width_160',onClick:this.modalConfirmAction}))));}}]);return TransitionBlockerModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component))||_class;

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inspection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__List__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Details__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__New__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Edit__ = __webpack_require__(1162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var readableStatuses=[{name:'All',value:'All'},{name:'Inspection Pending',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].REPORT_PENDING},{name:'Inspection Incomplete',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].REPORT_INCOMPLETE},{name:'Variation Pending',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].RESPONSE_PENDING},{name:'Variation Incomplete',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].RESPONSE_INCOMPLETE},{name:'Complete',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].COMPLETE}];var Inspection=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(Inspection,_React$Component);function Inspection(props){var _this2=this;_classCallCheck(this,Inspection);var _this=_possibleConstructorReturn(this,(Inspection.__proto__||Object.getPrototypeOf(Inspection)).call(this,props));_this.roleSwitch=function(){var _this$props=_this.props,user=_this$props.user,match=_this$props.match;var URLRole='';Object.keys(__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */]).forEach(function(roleKey){if(match.params.manufacturerRole===__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */][roleKey].nameForUrl)URLRole=__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */][roleKey];});if(URLRole&&user.getActiveRole()!==URLRole.serverName){user.changeMenu(URLRole.serverName);}};_this._loadFromStore=function(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};var user=_this.props.user;__WEBPACK_IMPORTED_MODULE_12__registerIDBWorker__["a" /* default */].select('INSPEC_'+user.getActiveRole()+'_LISTS',user.getManufacturerCode()).then(function(inspectionList){_this.setState({inspectionList:inspectionList},cb);});};_this._updateEntry=function(entry){var inspectionList=_this.state.inspectionList;var user=_this.props.user;var inspectionIndex=-1;if(entry.response!==undefined){inspectionIndex=inspectionList.findIndex(function(inspect){return+inspect.id===+entry.id;});if(inspectionIndex!==-1){inspectionList[inspectionIndex]=entry;}else{inspectionList.push(entry);inspectionIndex=inspectionList.length-1;}}else{inspectionIndex=inspectionList.findIndex(function(inspect){if(inspect.response){return+inspect.response.id===+entry.id;}return false;});if(inspectionIndex!==-1){inspectionList[inspectionIndex].response=entry;}}_this.setState({inspectionList:inspectionList},function(){__WEBPACK_IMPORTED_MODULE_12__registerIDBWorker__["a" /* default */].insert('INSPEC_'+user.getActiveRole()+'_LISTS',inspectionList[inspectionIndex],user.getManufacturerCode());});};_this._deleteEntry=function(id){var inspectionList=_this.state.inspectionList;var user=_this.props.user;var inspectionIndex=inspectionList.findIndex(function(inspect){return+inspect.id===+id;});if(inspectionIndex){__WEBPACK_IMPORTED_MODULE_12__registerIDBWorker__["a" /* default */].delete('INSPEC_'+user.getActiveRole()+'_LISTS',inspectionList[inspectionIndex]).then(function(){inspectionList.splice(inspectionIndex,1);_this.setState({inspectionList:inspectionList});});}};_this.markStepAsRedacted=function(){_this.$hasUnsavedData=true;};_this.createActionList=function(inspection){var user=_this.props.user;var list=[__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DETAILS];if(user.isInspector()){if(inspection.status!==__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE){list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].EDIT);}if(inspection.status===__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].INCOMPLETE){list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].RESUBMIT);}}if(!user.isInternal()&&!user.isInspector()){if(inspection.response&&inspection.response.status===__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].INCOMPLETE){list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].EDIT);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE);}}if(user.isInternal()){list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].EDIT);switch(inspection.status){case __WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].PENDING:list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].INCOMPLETE_REPORT);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].APPROVE_WITHOUT_RESPONSE);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].APPROVE_WITH_RESPONSE);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].E_SIGN_REPORT);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DELETE);break;case __WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].INCOMPLETE:list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].RESUBMIT);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DELETE);break;case __WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE:list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].INCOMPLETE_REPORT);if(inspection.vresponseRequired&&(!inspection.response||inspection.response.status!==__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE)){list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DELETE_RESPONSE);}else if(!inspection.vresponseRequired){list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].NEED_RESPONSE);}if(inspection.response){switch(inspection.response.status){case __WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].INCOMPLETE:list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE);break;case __WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].PENDING:list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE);list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].APPROVE_RESPONSE);break;case __WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE:list.push(__WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE);break;}}break;}}return list;};_this.performAction=function(action,id){var cb=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};return function(){var user=_this.props.user;switch(action){case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DETAILS:return user.goToInspectionDetails(id);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].EDIT:return user.goToInspectionEdit(id);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].APPROVE_WITHOUT_RESPONSE:return _this._handleApproveReport(id,false,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].APPROVE_WITH_RESPONSE:return _this._handleApproveReport(id,true,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].INCOMPLETE_REPORT:return _this._handleIncompleteReport(id,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].RESUBMIT:return _this._handleResubmitReport(id,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].NEED_RESPONSE:return _this._handleRequestResponse(id,true,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DELETE_RESPONSE:return _this._handleRequestResponse(id,false,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].DELETE:return _this._handleDeleteReport(id,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE:return _this._handleIncompleteResponse(id,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].APPROVE_RESPONSE:return _this._handleApproveResponse(id,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE:return _this._handleSubmitResponse(id,cb);case __WEBPACK_IMPORTED_MODULE_8_constants_index__["a" /* ACTION */].E_SIGN_REPORT:return _this.handleESignReport(id,cb);}};};_this._handleSubmitResponse=function(id,cb){var $submit=function $submit(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].submitVarianceResponse(id)).then(function(_ref){var data=_ref.data;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Variation Response documentation has been submitted successfully.');_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to submit Variation Response documentation to NMMA?';_this.$modalAction=$submit;_this._openModal();};_this._handleApproveReport=function(id,needResponse,cb){var $approve=function $approve(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].approveReport(id,needResponse)).then(function(_ref2){var data=_ref2.data;_this.$hasUnsavedData=false;if(needResponse){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Variation Response request has been sent successfully.');}else{__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Record Application has been approved successfully.');}_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};if(needResponse){_this.$modalBody='Are you sure you want to approve this Inspection report and request a Variation response from the manufacturer?';}else{_this.$modalBody='Are you sure you want to approve this Inspection report without requesting a Variation response from the manufacturer?';}_this.$modalAction=$approve;_this._openModal();};_this._handleIncompleteReport=function(id,cb){var $incomplete=function $incomplete(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].incompleteReport(id)).then(function(_ref3){var data=_ref3.data;_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Report has been marked as incomplete successfully.');_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to mark this Inspection Report as Incomplete?';_this.$modalAction=$incomplete;_this._openModal();};_this._handleIncompleteResponse=function(id,cb){var $incomplete=function $incomplete(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].incompleteResponse(id)).then(function(_ref4){var data=_ref4.data;_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Variation Response has been marked as incomplete successfully.');_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to mark this Variation Response as Incomplete?';_this.$modalAction=$incomplete;_this._openModal();};_this._handleApproveResponse=function(id,cb){var $approve=function $approve(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].approveResponse(id)).then(function(_ref5){var data=_ref5.data;_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Variation Response has been completed successfully.');_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to Approve this Variation Response?';_this.$modalAction=$approve;_this._openModal();};_this.handleESignReport=function(id){_this.$modalBody='Are you sure you want to generate and e-sign the inspection report?';_this.$modalAction=function(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].eSignReport(id)).then(function(){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Inspection report has been successfully generated and sent for e-signature to DocuSign.');}).finally(function(){_this._closeModal();});});};_this._openModal();};_this.handleUpdate=function(callback){_this.$modalBody='Are you sure you want to Update this Inspection Record application?';_this.$modalAction=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({requestInProcess:true},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return callback();case 2:result=_context.sent;if(result.report!==null&&result.response!==null){_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Record application has been updated successfully. Click Submit button to complete submission.');_this._closeModal(undefined,_this.handleGoBackClick);if(result.report)_this._updateEntry(result.report);if(result.response)_this._updateEntry(result.response);}else{_this._closeModal();}case 4:case'end':return _context.stop();}}},_callee,_this2);})));case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));_this._openModal();};_this.handleSaveAndSubmit=function(callback){_this.$modalBody='You are about to save your changes and submit the application for processing. Are you sure you want to proceed?';_this.$modalAction=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.setState({requestInProcess:true},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return callback();case 2:result=_context3.sent;if(result.report!==null&&result.response!==null){_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Record application has been updated and submitted successfully.');_this._closeModal(undefined,_this.handleGoBackClick);if(result.report)_this._updateEntry(result.report);if(result.response)_this._updateEntry(result.response);if(result.entry.data)_this._updateEntry(result.entry.data);}else{_this._closeModal();}case 4:case'end':return _context3.stop();}}},_callee3,_this2);})));case 1:case'end':return _context4.stop();}}},_callee4,_this2);}));_this._openModal();};_this.handleSubmitReport=function(inspectionId,requestJson,documents){var user=_this.props.user;var $submit=function $submit(){var data=new FormData();data.append('requestJson',JSON.stringify(requestJson));documents.filter(function(file){return!file.created;}).forEach(function(file){data.append('reports',file);});_this.setState({requestInProcess:true},function(){var request={};if(isFinite(inspectionId)){request.url=__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].inspectionDetails(inspectionId);request.method='post';}else{request.url=__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].submitInspectionRequest;request.method='post';}__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */][request.method](request.url,data).then(function(_ref10){var data=_ref10.data;_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Report has been submitted successfully');_this._updateEntry(data);_this._closeModal(undefined,function(){user.saveSelectedYear(requestJson.year);_this.handleGoBackClick({filter:{year:requestJson.year}});});}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to submit the Inspection Report?';_this.$modalAction=$submit;_this._openModal();};_this.handleSubmitResponse=function(requestJson,documents){var $submit=function $submit(){var data=new FormData();data.append('requestJson',JSON.stringify(requestJson));documents.filter(function(file){return!file.created;}).forEach(function(file){data.append('reports',file);});_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].saveVarianceResponse,data).then(function(_ref11){var data=_ref11.data;_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your application has been submitted successfully');_this._updateEntry(data);_this._closeModal(undefined,_this.handleGoBackClick);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to approve this Inspection report and request Variation response from the manufacturer?';_this.$modalAction=$submit;_this._openModal();};_this._handleRequestResponse=function(id,isRequired,cb){var $requestResponse=function $requestResponse(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].requestResponse(id,isRequired)).then(function(_ref12){var data=_ref12.data;_this.$hasUnsavedData=false;if(isRequired){__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Variation Response request has been sent successfully.');}else{__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Variation Response request has been canceled successfully.');}_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};if(isRequired){_this.$modalBody='Are you sure you want to Submit Variation Response request?';}else{_this.$modalBody='Are you sure you want to cancel Variation Response request?';}_this.$modalAction=$requestResponse;_this._openModal();};_this._handleResubmitReport=function(id,cb){var $resubmit=function $resubmit(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].resubmitReport(id)).then(function(_ref13){var data=_ref13.data;_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Report has been resubmitted successfully.');_this._updateEntry(data);cb(data);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to Resubmit the Inspection Report?';_this.$modalAction=$resubmit;_this._openModal();};_this._handleDeleteReport=function(id){var location=_this.props.location;var $delete=function $delete(){_this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].deleteReport(id)).then(function(){_this.$hasUnsavedData=false;__WEBPACK_IMPORTED_MODULE_11_dom_managers_notification__["a" /* default */].success(1,'Your Inspection Record application has been deleted successfully');_this._closeModal(undefined,function(){if(location.pathname.includes('/details')){_this.handleGoBackClick();}});_this._deleteEntry(id);}).finally(function(){_this._closeModal();});});};_this.$modalBody='Are you sure you want to delete this Inspection Record application?';_this.$modalAction=$delete;_this._openModal();};_this.getReadableStatus=function(inspection,value){var resultStatus=null;var $getResponseStatus=function $getResponseStatus(){if(inspection.response.status===__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE){return readableStatuses[readableStatuses.length-1];}else{return readableStatuses.find(function(status){return status.value==='RESPONSE_'+inspection.response.status;});}};var $getReportStatus=function $getReportStatus(){if(inspection.status===__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE){return readableStatuses[readableStatuses.length-1];}else{return readableStatuses.find(function(status){return status.value==='REPORT_'+inspection.status;});}};if(inspection.status===__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].COMPLETE){if(inspection.vresponseRequired&&inspection.status!==__WEBPACK_IMPORTED_MODULE_8_constants_index__["c" /* STATUS */].INCOMPLETE){if(inspection.response){resultStatus=$getResponseStatus();}else{resultStatus=$getReportStatus();}}}if(!resultStatus){resultStatus=$getReportStatus();}if(resultStatus){if(!value){return resultStatus.name;}else{return resultStatus.value;}}return'';};_this.handleGoBackClick=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var user=_this.props.user;if(params.nativeEvent)params=false;user.goToInspectionList(params);};_this._blockUnconfirmedTransition=function(_ref14){var pathname=_ref14.pathname;var user=_this.props.user;if(_this.$hasUnsavedData){_this.$modalBody='You have unsaved data. Are you sure you want to exit Inspection Record Application without saving?';_this.$modalAction=function(){_this.$hasUnsavedData=false;_this._closeModal(undefined,user.goTo(pathname));};_this._openModal();return false;}return true;};_this._openModal=function(){_this.setState({isModalOpen:true});};_this._closeModal=function(event){var cb=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};_this.setState({isModalOpen:false,requestInProcess:false},cb);};_this.getDetailsLink=function(model){var user=_this.props.user;var role='';var detailsString='';if(model.boatType){role=__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.nameForUrl;detailsString='application/';}else{role=__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.nameForUrl;detailsString='#edit=';}return'/'+user.getManufacturerCode()+'/'+role+'/'+detailsString+model.id;};_this.state={inspectionList:[],currentModelYear:'',isModalOpen:false,requestInProcess:false,listRequestInProcess:true,manufacturerAddresses:[]};_this.$modalBody='';_this.$modalAction=function(){};_this.$hasUnsavedData=false;_this.statuses=[{name:'All',value:'All'},{name:'Inspection Pending',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].REPORT_PENDING},{name:'Inspection Incomplete',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].REPORT_INCOMPLETE},{name:'Variation Pending',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].RESPONSE_PENDING},{name:'Variation Incomplete',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].RESPONSE_INCOMPLETE},{name:'Complete',value:__WEBPACK_IMPORTED_MODULE_8_constants_index__["b" /* INSPECTION_STATUS */].COMPLETE}];if(props.user.isInspector()){_this.statuses.splice(3,2);}if(!props.user.isInspector()&&!props.user.isInternal()){_this.statuses.splice(1,2);}return _this;}_createClass(Inspection,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var user=this.props.user;this.roleSwitch();var $$getMethod=function $$getMethod(){if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_4_api_requests__["a" /* boatAPI */].currentModelYear;}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_4_api_requests__["h" /* trailerAPI */].currentModelYear;}};__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get($$getMethod()).then(function(_ref15){var data=_ref15.data;_this3.setState({currentModelYear:data[0]?data[1]||data[0]:data});});__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["e" /* manufacturerAPI */].addressesList(this.props.user.getManufacturerCode())).then(function(_ref16){var data=_ref16.data;var manufacturerAddresses=data.map(function(addressObject){return{name:[addressObject.Address1,addressObject.Address2,addressObject.Address3,addressObject.Address4,addressObject.City,addressObject.State,addressObject.PostalCode,addressObject.Country].filter(function(object){return object;}).join(', '),value:{'mnfCity':addressObject.City,'mnfAddress':[addressObject.Address1,addressObject.Address2,addressObject.Address3,addressObject.Address4].filter(function(object){return object;}).join(', '),'mnfCountry':addressObject.Country,'mnfCountryId':addressObject.CountryId,'mnfPostalCode':addressObject.PostalCode,'mnfState':addressObject.State}};});_this3.setState({manufacturerAddresses:manufacturerAddresses});});this._loadFromStore();__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].inspectionList(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_13_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName)).then(function(_ref17){var inspectionList=_ref17.data;__WEBPACK_IMPORTED_MODULE_12__registerIDBWorker__["a" /* default */].insert('INSPEC_'+user.getActiveRole()+'_LISTS',inspectionList,user.getManufacturerCode()).then(function(){_this3._loadFromStore(function(){_this3.setState({listRequestInProcess:false});});});});}},{key:'render',value:function render(){var _this4=this;var _state=this.state,isModalOpen=_state.isModalOpen,requestInProcess=_state.requestInProcess,manufacturerAddresses=_state.manufacturerAddresses;var _props=this.props,user=_props.user,match=_props.match;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{exact:true,path:match.url,render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__List__["a" /* default */],Object.assign({user:user},_this4.state,{createActionList:_this4.createActionList,getReadableStatus:_this4.getReadableStatus,statuses:_this4.statuses,performAction:_this4.performAction}));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{exact:true,path:match.url+'/new',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__New__["a" /* default */],{user:user,getDetailsLink:_this4.getDetailsLink,handleSubmitReport:_this4.handleSubmitReport,markStepAsRedacted:_this4.markStepAsRedacted,handleGoBackClick:_this4.handleGoBackClick,getReadableStatus:_this4.getReadableStatus,manufacturerAddresses:manufacturerAddresses});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:match.url+'/:inspectionId/details',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Details__["a" /* default */],{user:user,getDetailsLink:_this4.getDetailsLink,handleSubmitReport:_this4.handleSubmitReport,handleSubmitResponse:_this4.handleSubmitResponse,markStepAsRedacted:_this4.markStepAsRedacted,createActionList:_this4.createActionList,performAction:_this4.performAction,handleGoBackClick:_this4.handleGoBackClick,getReadableStatus:_this4.getReadableStatus,manufacturerAddresses:manufacturerAddresses});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:match.url+'/:inspectionId/edit',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Edit__["a" /* default */],{user:user,getDetailsLink:_this4.getDetailsLink,handleUpdate:_this4.handleUpdate,handleSaveAndSubmit:_this4.handleSaveAndSubmit,markStepAsRedacted:_this4.markStepAsRedacted,handleGoBackClick:_this4.handleGoBackClick,getReadableStatus:_this4.getReadableStatus,manufacturerAddresses:manufacturerAddresses});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Modal__["a" /* default */],{isOpen:isModalOpen},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'ect-modal-header'},'Confirmation'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ect-modal-body'},this.$modalBody),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('footer',{className:'ect-modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'No',type:__WEBPACK_IMPORTED_MODULE_9_Components_Button__["b" /* buttonType */].secondary,color:__WEBPACK_IMPORTED_MODULE_9_Components_Button__["a" /* buttonColor */].gray,buttonClassName:'_height_40 _width_160',onClick:this._closeModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_Button__["c" /* default */],{label:'Yes',disabledWithSpinner:requestInProcess,buttonClassName:'_height_40 _width_160',onClick:this.$modalAction}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Prompt */],{message:this._blockUnconfirmedTransition}));}}]);return Inspection;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component))||_class;

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Row__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FiltersSection__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableHeader__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['userName','location'];var List=function(_React$Component){_inherits(List,_React$Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,sortedBy:'inspectionDate',sortAsc:-1,filter:{},searchString:'',year:''};_this.getCurrentYear=function(){var user=_this.props.user;return new Promise(function(resolve,reject){switch(user.getActiveRole()){case __WEBPACK_IMPORTED_MODULE_11_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref){var data=_ref.data;resolve(data[1]||data[0]);});break;case __WEBPACK_IMPORTED_MODULE_11_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].currentModelYear).then(function(_ref2){var data=_ref2.data;resolve(data);});break;default:{var selectedYear=new Date().getFullYear();resolve(selectedYear);break;}}});};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this._handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},function(){user.updateURLSearchString({activePage:activePage});});};_this._sortList=function(a,b){var _this$state=_this.state,sortedBy=_this$state.sortedBy,sortAsc=_this$state.sortAsc;switch(sortedBy){case'inspectionDate':return __WEBPACK_IMPORTED_MODULE_9_moment___default()(a.inspectionDate).isAfter(b.inspectionDate)?sortAsc:-sortAsc;case'year':return+a.year>+b.year?sortAsc:-sortAsc;case'user':{var userA=a.user.firstName+' '+a.user.lastName;var userB=b.user.firstName+' '+b.user.lastName;return userA>userB?sortAsc:-sortAsc;}default:return(a[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')>(b[sortedBy]||' ').toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){var user=_this.props.user;_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc,activePage:1};},function(){user.updateURLSearchString({sortedBy:_this.state.sortedBy,sortAsc:_this.state.sortAsc,activePage:1});});};};_this._filterList=function(inspectionList){var _this$state2=_this.state,filter=_this$state2.filter,searchString=_this$state2.searchString;var getReadableStatus=_this.props.getReadableStatus;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){switch(SEARCHABLE_FIELDS[searchableFieldIndex]){case'userName':{var userName=element.user?element.user.firstName+' '+element.user.lastName:'';if(userName.toLowerCase().includes(searchString.toLowerCase())){return true;}else{break;}}default:if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){return element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase());}}}return false;};return inspectionList.filter(function(inspection){for(var filterFieldName in filter){switch(filterFieldName){case'year':if(+inspection.year!==+filter.year){return false;}break;case'status':if(getReadableStatus(inspection,true)!==filter.status){return false;}break;default:return false;}}return!searchString||doesSearchableFieldsContainSearchString(inspection);});};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var newFilterFieldValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(newFilterFieldValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=newFilterFieldValue;if(filterFieldName==='year'){if(filterElement==='All'){user.saveSelectedYear('');}else{user.saveSelectedYear(filterElement);}}_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});});};};_this._getList=function(){var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var _this$props=_this.props,user=_this$props.user,inspectionList=_this$props.inspectionList,createActionList=_this$props.createActionList,listRequestInProcess=_this$props.listRequestInProcess,performAction=_this$props.performAction,getReadableStatus=_this$props.getReadableStatus;var filteredList=_this._filterList(inspectionList).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;var resultList=[];var resultLength=0;if(!inspectionList.length){if(listRequestInProcess){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner _height_120',key:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_EmptyList__["a" /* default */],{key:'0'},'No Inspections for selected manufacturer.')];}}else if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Components_EmptyList__["a" /* default */],{key:'0'},'No Inspections found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(inspection,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Row__["a" /* default */],{key:inspection.id,user:user,sortedBy:sortedBy,inspection:inspection,isOdd:!!(index%2),actionList:createActionList(inspection),performAction:performAction,getReadableStatus:getReadableStatus,updateListEntryAfterStatusChange:_this.updateListEntryAfterStatusChange});});resultLength=filteredList.length;}return{resultList:resultList,resultLength:resultLength};};var storedState=props.user.getStoredState('inspectionListState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);return _this;}_createClass(List,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;if(!user.getSelectedYear()){this.getCurrentYear().then(function(currentYear){_this2.handleSelectFilter('year')(currentYear);});}else{this.handleSelectFilter('year')(user.getSelectedYear());}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var user=this.props.user;user.saveState('inspectionListState',this.state,['inspectionList','listRequestInProcess','year']);}},{key:'render',value:function render(){var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,filter=_state.filter,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,searchString=_state.searchString;var _props=this.props,currentModelYear=_props.currentModelYear,statuses=_props.statuses;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Inspection list',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_10_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowsSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,filterState:filter,statuses:statuses,currentModelYear:currentModelYear}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this._handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._selectAction=function(actionKey){var _this$props=_this.props,inspection=_this$props.inspection,performAction=_this$props.performAction;if(actionKey===__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE||actionKey===__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].APPROVE_RESPONSE||actionKey===__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE){performAction(actionKey,inspection.response.id)();}else{performAction(actionKey,inspection.id)();}},_this._getStatusColor=function(){var _this$props2=_this.props,inspection=_this$props2.inspection,user=_this$props2.user;if(user.isInspector()){if(inspection&&inspection.status){return'list-scene__status-label_'+inspection.status.toString().toLowerCase();}}else{if(inspection.status===__WEBPACK_IMPORTED_MODULE_4_constants_index__["c" /* STATUS */].COMPLETE){if(inspection.vresponseRequired){if(inspection&&inspection.response&&inspection.response.status){return'list-scene__status-label_'+inspection.response.status.toString().toLowerCase();}}else{if(inspection&&inspection.status){return'list-scene__status-label_'+inspection.status.toString().toLowerCase();}}}else{if(inspection&&inspection.status){return'list-scene__status-label_'+inspection.status.toString().toLowerCase();}}}return'';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _this2=this;var _props=this.props,inspection=_props.inspection,actionList=_props.actionList,getReadableStatus=_props.getReadableStatus;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionListRowID'+inspection.id,onClick:function onClick(){return _this2._selectAction(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ACTION */].DETAILS);},className:'list-scene__table-row '+this._getBackgroundColourStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionInspectionDateField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('inspectionDate')+' _width_pc_12'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(inspection.inspectionDate).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionInspectorNameField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('inspectorName')+' _width_pc_14'},inspection.user?inspection.user.firstName+' '+inspection.user.lastName:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionInspectionAddressField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('location')+' _width_pc_14'},inspection.mnfCity?(inspection.mnfCity?inspection.mnfCity+', ':'')+' '+(inspection.mnfState||''):'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionYearField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('year')+' _width_pc_8'},inspection.year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionDescriptionField',className:'list-scene__table-row-element list-scene__table-row-element_text-element\n        '+this._getTextColourStyle('description')+' list-scene__table-row-element_place_filler'},inspection.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inspectionStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('status')+' _width_150'},getReadableStatus(inspection))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{placeholder:'Actions',mainWrapperClassName:'_width_120',withoutSearch:true,multiSelect:true,selectionList:actionList,handleSelect:this._selectAction,type:__WEBPACK_IMPORTED_MODULE_3_Components_Select__["b" /* selectType */].listActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()}));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={inspection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};Row.defaultProps={inspection:{user:{firstName:'',lastName:''}}};

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FiltersSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltersSection=function(_React$Component){_inherits(FiltersSection,_React$Component);function FiltersSection(){_classCallCheck(this,FiltersSection);return _possibleConstructorReturn(this,(FiltersSection.__proto__||Object.getPrototypeOf(FiltersSection)).apply(this,arguments));}_createClass(FiltersSection,[{key:'render',value:function render(){var _props=this.props,outCount=_props.outCount,handleRowsSelect=_props.handleRowsSelect,rowsCount=_props.rowsCount,currentModelYear=_props.currentModelYear,handleSelectFilter=_props.handleSelectFilter,filterState=_props.filterState,statuses=_props.statuses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{label:'by Status',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter,withoutSearch:true,defaultItem:statuses.find(function(status){return status.value===filterState.status;}),placeholder:'All',selectionList:statuses,itemNameIndicator:'name',handleSelect:handleSelectFilter('status')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__["a" /* default */],{endYear:+currentModelYear+1,yearPickAction:handleSelectFilter('year'),year:+filterState.year,withAllOption:true,width:160,height:18})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowsSelect,selectedRowsCount:rowsCount})));}}]);return FiltersSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('inspectionDate')+' _width_pc_12',onClick:handleSortClick('inspectionDate')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Inspection Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('user')+' _width_pc_14',onClick:handleSortClick('user')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Inspector Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('location')+' _width_pc_14',onClick:handleSortClick('location')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Inspection Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('year')+' _width_pc_8',onClick:handleSortClick('year')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Model Year'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('description')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('description')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('status')+' _width_pc_18',onClick:handleSortClick('status')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Inspection Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _width_pc_12'}));});

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Details; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Report__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Response__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actoins__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Details=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(Details,_React$Component);function Details(props){_classCallCheck(this,Details);var _this=_possibleConstructorReturn(this,(Details.__proto__||Object.getPrototypeOf(Details)).call(this,props));_this._updateStatus=function(entry){var state={};if(entry.response!==undefined){state=entry;}else{state.response=entry;}_this.setState(state);};_this.performAction=function(action,id){return function(){var performAction=_this.props.performAction;performAction(action,id,_this._updateStatus)();};};_this.state={id:'',description:'',status:'',year:'',inspectionDate:'',documents:[],requestInProcess:false};return _this;}_createClass(Details,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var inspectionId=this.props.match.params.inspectionId;if(isFinite(inspectionId)){this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_2_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3_api_requests__["d" /* inspectionAPI */].inspectionDetails(inspectionId)).then(function(_ref){var inspection=_ref.data;inspection.address=[inspection.mnfAddress,inspection.mnfCity,inspection.mnfState,inspection.mnfPostalCode,inspection.mnfCountryId].filter(function(object){return object;}).join(', ');_this2.setState(Object.assign({},inspection,{requestInProcess:false}));});});}}},{key:'render',value:function render(){var _state=this.state,id=_state.id,status=_state.status,response=_state.response,requestInProcess=_state.requestInProcess,vresponseRequired=_state.vresponseRequired;var _props=this.props,getReadableStatus=_props.getReadableStatus,handleGoBackClick=_props.handleGoBackClick,createActionList=_props.createActionList,markStepAsRedacted=_props.markStepAsRedacted,handleSubmitReport=_props.handleSubmitReport,user=_props.user,getDetailsLink=_props.getDetailsLink;var showResponse=status!==__WEBPACK_IMPORTED_MODULE_7_constants_index__["c" /* STATUS */].INCOMPLETE&&vresponseRequired;var actions=createActionList(this.state);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},!requestInProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{inspection:this.state,user:user,id:id,actions:actions,performAction:this.performAction,readableStatus:getReadableStatus(this.state),handleGoBackClick:handleGoBackClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Report__["a" /* default */],Object.assign({},this.state,{user:user,getDetailsLink:getDetailsLink,inspector:this.state.user,inspectionId:id,handleSubmitReport:handleSubmitReport,markStepAsRedacted:markStepAsRedacted,createActionList:createActionList,handleGoBackClick:handleGoBackClick})),showResponse&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Response__["a" /* default */],{response:response}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actoins__["a" /* default */],{reportStatus:status,id:id,responseId:response?response.id:null,user:user,performAction:this.performAction,actions:actions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Back',backButtonAction:handleGoBackClick}))));}}]);return Details;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status,readableStatus=_ref.readableStatus,handleGoBackClick=_ref.handleGoBackClick,isDetails=_ref.isDetails,inspection=_ref.inspection,user=_ref.user,actions=_ref.actions,performAction=_ref.performAction,id=_ref.id;var _getStatusColor=function _getStatusColor(){if(user.isInspector()){if(inspection&&inspection.status){return inspection.status.toString().toLowerCase();}}else{if(inspection.status===__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* STATUS */].COMPLETE){if(inspection.vresponseRequired){if(inspection.response&&inspection.response.status){return inspection.response.status.toString().toLowerCase();}}else{if(inspection&&inspection.status){return inspection.status.toString().toLowerCase();}}}else{if(inspection&&inspection.status){return inspection.status.toString().toLowerCase();}}}return'';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:handleGoBackClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_width_450'},'Inspection Record Application'),actions.includes(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].EDIT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{onClick:performAction(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].EDIT,id)}),actions.includes(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].DELETE)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].DELETE,buttonClassName:'_height_30 _width_100 _margin_left_10',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACTION */].DELETE,id),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].red}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+_getStatusColor()+' _width_210'},readableStatus.toLowerCase()));});

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeneralInformation__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubHeader__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListOfModels__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotesSection__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportDocumentation__ = __webpack_require__(1150);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Report=function(_React$Component){_inherits(Report,_React$Component);function Report(){_classCallCheck(this,Report);return _possibleConstructorReturn(this,(Report.__proto__||Object.getPrototypeOf(Report)).apply(this,arguments));}_createClass(Report,[{key:'render',value:function render(){var _props=this.props,id=_props.id,status=_props.status,description=_props.description,inspectionDate=_props.inspectionDate,year=_props.year,models=_props.models,notes=_props.notes,documents=_props.documents,yearList=_props.yearList,user=_props.user,inspector=_props.inspector,getDetailsLink=_props.getDetailsLink,approvalDate=_props.approvalDate,address=_props.address;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SubHeader__["a" /* default */],{label:'Inspection Report',number:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GeneralInformation__["a" /* default */],{user:user,status:status,description:description,inspectionDate:inspectionDate,approvalDate:approvalDate,year:year,inspector:inspector,address:address,yearList:yearList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ListOfModels__["a" /* default */],{models:models,getDetailsLink:getDetailsLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotesSection__["a" /* default */],{notes:notes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReportDocumentation__["a" /* default */],{user:user,inspectionModelYear:year,documents:documents,id:id}));}}]);return Report;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GeneralInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
function GeneralInformation(_ref){var user=_ref.user,status=_ref.status,description=_ref.description,inspectionDate=_ref.inspectionDate,year=_ref.year,inspector=_ref.inspector,approvalDate=_ref.approvalDate,address=_ref.address;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Description',alwaysTextField:true,value:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Inspection Date',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(inspectionDate).local(true).format('MM / DD / YYYY')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Inspector name',value:inspector?inspector.firstName+' '+inspector.lastName:'NMMA Inspector'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Model Year',value:year}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Address',value:address}),status===__WEBPACK_IMPORTED_MODULE_3_constants_index__["b" /* INSPECTION_STATUS */].COMPLETE&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Approval date',value:approvalDate?__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).local(true).format('MM / DD / YYYY'):'N/A'}));}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ListOfModels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_index__ = __webpack_require__(9);
function ListOfModels(_ref){var models=_ref.models,getDetailsLink=_ref.getDetailsLink;var _getRowStyles=function _getRowStyles(status){if(status===__WEBPACK_IMPORTED_MODULE_1_constants_index__["c" /* STATUS */].DEACTIVATED)return'__row_deactivated';return'__row_active';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_padding_bottom_20'},'List of Models'),models.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'selected-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_14'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_45'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_18'},models[0].boatType?'Type':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_18'},models[0].engineType?'Engine Type':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body'},models.map(function(model){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:model.id,href:getDetailsLink(model),target:'_blank',rel:'noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:model.id,className:'selected-list__body_row '+_getRowStyles(model.status),style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_14'},model.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_45'},model.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_18'},model.boatType?model.boatType.replace(/_/,' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_18'},model.engineType?model.engineType.replace(/_/,' '):'')));}))));}ListOfModels.defaultProps={models:[],selectedModelList:[]};

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes;if(!notes)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,disabled:true}));}

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReportDocumentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_FilePicker__ = __webpack_require__(26);
function ReportDocumentation(_ref){var documents=_ref.documents,id=_ref.id,user=_ref.user,inspectionModelYear=_ref.inspectionModelYear;if(!user.isInternal()&&!user.isInspector())return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section',onClick:function onClick(){user.goTo(user.getDocumentsLink({chosenYear:inspectionModelYear,filter:{typeTitle:'Inspection Report'}}));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_cursor_pointer _flex _ai_center'},'Please click here to access Inspection Report Documentation.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_name_icon _width_20 _height_20 _margin_left_10'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Inspection Report Documentation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label'},'Please upload inspection report and signature page'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_FilePicker__["a" /* default */],{editableStateSectionHeader:'',notEditableStateSectionHeader:'',isEditable:false,sectionHeaderClassName:'_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16',mainWrapperClassName:'_min_height_auto',uploadButtonText:'Upload',httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_1_api_requests__["d" /* inspectionAPI */].downloadReportDocument,currentId:id},files:documents||[]}));}ReportDocumentation.defaultProps={documents:[]};

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Response; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubHeader__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotesSection__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResponseDocumentation__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeneralInformation__ = __webpack_require__(1154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Response=function(_React$Component){_inherits(Response,_React$Component);function Response(){_classCallCheck(this,Response);return _possibleConstructorReturn(this,(Response.__proto__||Object.getPrototypeOf(Response)).apply(this,arguments));}_createClass(Response,[{key:'render',value:function render(){var response=this.props.response;if(!response)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SubHeader__["a" /* default */],{label:'Variation Response',number:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GeneralInformation__["a" /* default */],{status:response.status,submittedBy:response.submittedBy,submissionDate:response.submissionDate,approvalDate:response.approvalDate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__NotesSection__["a" /* default */],{notes:response.notes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResponseDocumentation__["a" /* default */],{varDocuments:response.varDocuments,id:response.id}));}}]);return Response;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes;if(!notes)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes,disabled:true}));}

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ResponseDocumentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_FilePicker__ = __webpack_require__(26);
function ResponseDocumentation(_ref){var varDocuments=_ref.varDocuments,id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Variation Response Documentation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label'},'Please upload Variation Response and supporting documentation if any.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_FilePicker__["a" /* default */],{editableStateSectionHeader:'',notEditableStateSectionHeader:'',isEditable:false,sectionHeaderClassName:'_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16',mainWrapperClassName:'_min_height_auto',uploadButtonText:'Upload',httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_1_api_requests__["d" /* inspectionAPI */].downloadResponseDocument,currentId:id},files:varDocuments||[]}));}ResponseDocumentation.defaultProps={varDocuments:[]};

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GeneralInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
function GeneralInformation(_ref){var submittedBy=_ref.submittedBy,submissionDate=_ref.submissionDate,status=_ref.status,approvalDate=_ref.approvalDate;submissionDate=__WEBPACK_IMPORTED_MODULE_2_moment___default()(submissionDate).local(true);submissionDate=submissionDate.isValid()?submissionDate.format('MM / DD / YYYY'):'MM / DD / YYYY';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Variation Date',value:submissionDate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Submitted By',value:submittedBy?submittedBy.firstName+' '+submittedBy.lastName:'N/A'}),status===__WEBPACK_IMPORTED_MODULE_3_constants_index__["b" /* INSPECTION_STATUS */].COMPLETE&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Approval date',value:approvalDate?__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).local(true).format('MM / DD / YYYY'):'N/A'}));}

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Actions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__ = __webpack_require__(49);
function Actions(_ref){var id=_ref.id,responseId=_ref.responseId,reportStatus=_ref.reportStatus,actions=_ref.actions,performAction=_ref.performAction;var eSignActionsList=[];var responseActionsList=[];var reportActionList=[];if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].E_SIGN_REPORT)){eSignActionsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].E_SIGN_REPORT,buttonClassName:'_height_40 _width_160 _margin_right_20 _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].E_SIGN_REPORT,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].darkGreen}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].NEED_RESPONSE)){responseActionsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].NEED_RESPONSE,buttonClassName:'_height_40 _width_120 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].NEED_RESPONSE,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].darkGreen}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].DELETE_RESPONSE)){responseActionsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].DELETE_RESPONSE,buttonClassName:'_height_40 _width_120 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].DELETE_RESPONSE,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].darkRed}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_WITH_RESPONSE)){responseActionsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_WITH_RESPONSE,buttonClassName:'_height_40 _width_120 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_WITH_RESPONSE,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].darkGreen}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].INCOMPLETE_REPORT)){reportActionList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].INCOMPLETE_REPORT,buttonClassName:'_height_40 _width_120 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].INCOMPLETE_REPORT,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].lightBlue}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_WITHOUT_RESPONSE)){reportActionList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_WITHOUT_RESPONSE,buttonClassName:'_height_40 _width_160 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_WITHOUT_RESPONSE,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].RESUBMIT)){reportActionList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].RESUBMIT,buttonClassName:'_height_40 _width_120 _margin_right_20 _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].RESUBMIT,id),type:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["b" /* buttonType */].primary,color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE)){reportActionList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE,buttonClassName:'_height_40 _width_120 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].INCOMPLETE_RESPONSE,responseId),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].lightBlue}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_RESPONSE)){reportActionList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_RESPONSE,buttonClassName:'_height_40 _width_120 _margin_right_20  _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].APPROVE_RESPONSE,responseId),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}));}if(actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE)){reportActionList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Button__["c" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE,buttonClassName:'_height_40 _width_120 _margin_right_20 _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].SUBMIT_RESPONSE,responseId),color:__WEBPACK_IMPORTED_MODULE_2_Components_Button__["a" /* buttonColor */].green}));}if(!(reportActionList.length+responseActionsList.length+eSignActionsList.length))return null;var firstDelimiterNeeded=eSignActionsList.length&&(reportActionList.length||responseActionsList.length);var secondDelimiterNeeded=reportActionList.length&&responseActionsList.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section detailsScene__change-status-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Actions'),actions.includes(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].EDIT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_EditApplicationButton__["a" /* default */],{className:'_height_40 _width_pc_100 _max_width_180 _margin_right_30 _margin_top_30',onClick:performAction(__WEBPACK_IMPORTED_MODULE_1_constants_index__["a" /* ACTION */].EDIT,id)}),eSignActionsList,!!firstDelimiterNeeded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__delimiter_vertical'}),responseActionsList,!!secondDelimiterNeeded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__delimiter_vertical'}),reportActionList);}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return New; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GeneralInformation__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListOfModels__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Notes__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportDocumentation__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_roles__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_index__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var New=function(_React$Component){_inherits(New,_React$Component);function New(props){_classCallCheck(this,New);var _this=_possibleConstructorReturn(this,(New.__proto__||Object.getPrototypeOf(New)).call(this,props));_this.handleSelect=function(key){return function(value){var _this$setState;var errors=_this.state.errors;var markStepAsRedacted=_this.props.markStepAsRedacted;delete errors[key];markStepAsRedacted();_this.setState((_this$setState={},_defineProperty(_this$setState,key,value),_defineProperty(_this$setState,'errors',errors),_this$setState));};};_this.handleInputChange=function(key){return function(value){var _this$setState2;var errors=_this.state.errors;var markStepAsRedacted=_this.props.markStepAsRedacted;delete errors[key];markStepAsRedacted();_this.setState((_this$setState2={},_defineProperty(_this$setState2,key,value),_defineProperty(_this$setState2,'errors',errors),_this$setState2));};};_this.handleYearSelect=function(year){var errors=_this.state.errors;var _this$props=_this.props,markStepAsRedacted=_this$props.markStepAsRedacted,user=_this$props.user;var $$getMethod=function $$getMethod(year){if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_10_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].approvedBoatsByYear(year);}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_10_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].trailersByYear(year,true);}};delete errors.year;markStepAsRedacted();_this.setState({year:year,errors:errors},function(){var modelList=[];if(year){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get($$getMethod(year)).then(function(_ref){var approvedList=_ref.data;modelList=approvedList;}).finally(function(){_this.setState({modelList:modelList,selectedModelList:[]});});}else{_this.setState({modelList:modelList,selectedModelList:[]});}});};_this.handleSelectFromList=function(model){var _this$state=_this.state,modelList=_this$state.modelList,errors=_this$state.errors;var markStepAsRedacted=_this.props.markStepAsRedacted;var selectedModelIndex=modelList.findIndex(function(element){return+model.id===+element.id;});modelList.splice(selectedModelIndex,1);delete errors.selectedModelList;markStepAsRedacted();_this.setState(function(prevState){return{selectedModelList:[].concat(_toConsumableArray(prevState.selectedModelList),[model]),modelList:modelList,errors:errors};});};_this.handleRemoveFromList=function(model,index){return function(){var _this$state2=_this.state,modelList=_this$state2.modelList,selectedModelList=_this$state2.selectedModelList,errors=_this$state2.errors;var markStepAsRedacted=_this.props.markStepAsRedacted;selectedModelList.splice(index,1);modelList.push(model);if(!selectedModelList.length)errors.selectedModelList='At least one model needs to be selected.';markStepAsRedacted();_this.setState({modelList:modelList,selectedModelList:selectedModelList,errors:errors});};};_this.handleFileSelect=function(addedFiles){var errors=_this.state.errors;var markStepAsRedacted=_this.props.markStepAsRedacted;delete errors.documents;markStepAsRedacted();_this.setState(function(prevState){return{documents:[].concat(_toConsumableArray(prevState.documents),_toConsumableArray(addedFiles)),errors:errors};});};_this.handleFileRemove=function(fileIndex){return function(){var _this$state3=_this.state,documents=_this$state3.documents,errors=_this$state3.errors;var markStepAsRedacted=_this.props.markStepAsRedacted;documents.splice(fileIndex,1);if(!documents.length){errors.documents=true;}markStepAsRedacted();_this.setState({documents:documents,errors:errors});};};_this._handleSubmitReportClick=function(){var _this$state4=_this.state,status=_this$state4.status,year=_this$state4.year,description=_this$state4.description,inspectionDate=_this$state4.inspectionDate,selectedModelList=_this$state4.selectedModelList,documents=_this$state4.documents,notes=_this$state4.notes,address=_this$state4.address;var _this$props2=_this.props,user=_this$props2.user,handleSubmitReport=_this$props2.handleSubmitReport,inspectionId=_this$props2.inspectionId;var $$getRequiredFields=function $$getRequiredFields(){var fields=['description','address'];if(status===''){fields.push('year','inspectionDate','selectedModelList');if(!user.isInternal())fields.push('documents');}else if(status===__WEBPACK_IMPORTED_MODULE_11_constants_index__["c" /* STATUS */].INCOMPLETE){fields.push('year','inspectionDate','selectedModelList');if(!user.isInternal())fields.push('documents');}return fields;};var $$validate=function $$validate(){return new Promise(function(resolve,reject){var errors=_this.state.errors;var fields=$$getRequiredFields();var hasErrors=!!Object.keys(errors).length;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=fields[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var field=_step.value;var data=_this.state[field];if(data.length!==undefined?!data.length:!data){if(field==='selectedModelList')errors.selectedModelList='At least one model needs to be selected.';else errors[field]=true;hasErrors=true;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(hasErrors){_this.setState({errors:errors},reject);}else{resolve(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_10_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName);}});};$$validate().then(function(boatInspecFlag){var requestJson=Object.assign({inspectionDate:inspectionDate.utc(),modelIds:selectedModelList.map(function(model){return model.id;}),year:year,description:description,notes:notes,boatInspecFlag:boatInspecFlag},address.value);handleSubmitReport(inspectionId,requestJson,documents);}).catch(function(){Object(__WEBPACK_IMPORTED_MODULE_3_utils__["a" /* consoleError */])('Report has errors');});};_this.state={id:'',description:'',status:'',year:'',inspectionDate:'',documents:[],yearList:[],errors:{},modelList:[],selectedModelList:[],requestInProcess:false,address:''};return _this;}_createClass(New,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;var $$getMethod=function $$getMethod(){if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_10_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].modelYears;}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_10_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].getPermissibleModelYears;}};__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get($$getMethod()).then(function(_ref2){var yearList=_ref2.data;_this2.setState({yearList:yearList});});}},{key:'render',value:function render(){var _state=this.state,description=_state.description,inspectionDate=_state.inspectionDate,year=_state.year,notes=_state.notes,documents=_state.documents,yearList=_state.yearList,errors=_state.errors,selectedModelList=_state.selectedModelList,modelList=_state.modelList,address=_state.address;var _props=this.props,user=_props.user,handleGoBackClick=_props.handleGoBackClick,getDetailsLink=_props.getDetailsLink,manufacturerAddresses=_props.manufacturerAddresses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],{handleGoBackClick:handleGoBackClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GeneralInformation__["a" /* default */],{errors:errors,description:description,inspectionDate:inspectionDate,year:year,yearList:yearList,address:address,manufacturerAddresses:manufacturerAddresses,handleSelect:this.handleSelect,handleInputChange:this.handleInputChange,handleYearSelect:this.handleYearSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ListOfModels__["a" /* default */],{selectedModelList:selectedModelList,modelList:modelList,getDetailsLink:getDetailsLink,errors:errors,handleSelectFromList:this.handleSelectFromList,handleRemoveFromList:this.handleRemoveFromList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Notes__["a" /* default */],{notes:notes,user:user,handleInputChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ReportDocumentation__["a" /* default */],{documents:documents,user:user,errors:errors,inspectionDate:inspectionDate,handleFileSelect:this.handleFileSelect,handleFileRemove:this.handleFileRemove}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Components_ApplicationActions__["a" /* default */],{backButtonLabel:'Cancel',saveButtonLabel:'Submit',saveButtonAction:this._handleSubmitReportClick,backButtonAction:handleGoBackClick})));}}]);return New;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleGoBackClick=_ref.handleGoBackClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:handleGoBackClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_width_450'},'Inspection Record Application'));});

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GeneralInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_DatePicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
function GeneralInformation(_ref){var description=_ref.description,inspectionDate=_ref.inspectionDate,year=_ref.year,yearList=_ref.yearList,errors=_ref.errors,handleInputChange=_ref.handleInputChange,handleSelect=_ref.handleSelect,handleYearSelect=_ref.handleYearSelect,address=_ref.address,manufacturerAddresses=_ref.manufacturerAddresses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Input__["a" /* Input */],{mainWrapperClassName:'_width_pc_100',styleClass:__WEBPACK_IMPORTED_MODULE_1_Components_Input__["c" /* inputStyleClasses */].primary,label:'Description *',maxLength:250,alwaysTextField:true,error:errors.description,value:description,onChange:handleInputChange('description')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_DatePicker__["a" /* default */],{label:'Inspection Date *',error:__WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().hour(23).minute(59).second(59).isBefore(inspectionDate)&&'Cannot select Inspection Date in the future'||errors.inspectionDate,selectedDate:inspectionDate,mainWrapperClassName:'input__main-wrapper_primary _margin_right_30 _margin_top_18',handleSelectDate:handleSelect('inspectionDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:yearList,defaultItem:year,mainWrapperClassName:'input__main-wrapper_primary',type:'primary',label:'Model Year *',error:errors.year,handleSelect:handleYearSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_Select__["a" /* default */],{selectionList:manufacturerAddresses,defaultItem:address,mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',type:'primary',label:'Select Address *',itemNameIndicator:'name',error:errors.address,handleSelect:handleSelect('address')}));}

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ListOfModels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
function ListOfModels(_ref){var selectedModelList=_ref.selectedModelList,status=_ref.status,modelList=_ref.modelList,errors=_ref.errors,handleRemoveFromList=_ref.handleRemoveFromList,handleSelectFromList=_ref.handleSelectFromList,getDetailsLink=_ref.getDetailsLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_padding_bottom_20'},'List of Models'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].primarySmall,mainWrapperClassName:'_width_pc_80 _margin_top_12',dropDownClassName:'_max_height_120',selectionList:modelList,multiSelect:true,itemNameIndicator:['id','name'],error:errors.selectedModelList,handleSelect:handleSelectFromList,placeholder:'Id or Name'}),selectedModelList.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'selected-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'_flex _stretch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_14'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_45'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_18'},selectedModelList[0].boatType?'Type':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_18'},selectedModelList[0].engineType?'Engine Type':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_5'},'Remove')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body'},selectedModelList.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:model.id,className:'selected-list__body_row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:getDetailsLink(model),target:'_blank',rel:'noreferrer',className:'_flex _stretch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_14'},model.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_45'},model.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_18'},model.boatType?model.boatType.replace(/_/,' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_18'},model.engineType?model.engineType.replace(/_/,' '):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_5 __remove-icon',onClick:handleRemoveFromList(model,index)}));}))));}ListOfModels.defaultProps={selectedModelList:[]};

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes,user=_ref.user,handleInputChange=_ref.handleInputChange;if(notes||user.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes||'',handleInputChange:handleInputChange('notes'),disabled:!user.isInternal()}));}else{return null;}}

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReportDocumentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_FilePicker__ = __webpack_require__(26);
function ReportDocumentation(_ref){var documents=_ref.documents,errors=_ref.errors,handleFileRemove=_ref.handleFileRemove,handleFileSelect=_ref.handleFileSelect;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Inspection Report Documentation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label'},'Please upload inspection report and signature page'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_FilePicker__["a" /* default */],{editableStateSectionHeader:'',notEditableStateSectionHeader:'',error:errors.documents?'Please upload at least one file':'',sectionHeaderClassName:'_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16',mainWrapperClassName:'_min_height_auto',uploadButtonText:'Upload',handleFileSelect:handleFileSelect,handleRemoveFile:handleFileRemove,files:documents}));}ReportDocumentation.defaultProps={documents:[]};

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inspection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Report__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Response__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Components_ApplicationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultState={report:{id:'',description:'',status:'',year:'',inspectionDate:'',models:[],documents:[],yearList:[],errors:{},modelList:[],manufacturerAddressesWithCurrent:[],address:''},response:{varDocuments:[],error:false},requestInProcess:false};var Inspection=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(_class=function(_React$Component){_inherits(Inspection,_React$Component);function Inspection(props){var _this2=this;_classCallCheck(this,Inspection);var _this=_possibleConstructorReturn(this,(Inspection.__proto__||Object.getPrototypeOf(Inspection)).call(this,props));_this.updateInspectionAddress=function(){var manufacturerAddresses=_this.props.manufacturerAddresses;var report=_this.state.report;var _this$state$report=_this.state.report,mnfCity=_this$state$report.mnfCity,mnfAddress=_this$state$report.mnfAddress,mnfCountry=_this$state$report.mnfCountry,mnfCountryId=_this$state$report.mnfCountryId,mnfPostalCode=_this$state$report.mnfPostalCode,mnfState=_this$state$report.mnfState;var currentAddressValue={'mnfCity':mnfCity,'mnfAddress':mnfAddress,'mnfCountry':mnfCountry,'mnfCountryId':mnfCountryId,'mnfPostalCode':mnfPostalCode,'mnfState':mnfState};var manufacturerAddressesWithCurrent=[].concat(_toConsumableArray(manufacturerAddresses));var address=manufacturerAddresses.find(function(address){var isSame=true;Object.keys(address.value).forEach(function(addressField){if(address.value[addressField]!==currentAddressValue[addressField])isSame=false;});return isSame;});if(!address){address={name:[currentAddressValue.mnfAddress,currentAddressValue.mnfCity,currentAddressValue.mnfState,currentAddressValue.mnfPostalCode,currentAddressValue.mnfCountryId].filter(function(object){return object;}).join(', '),value:Object.assign({},currentAddressValue)};if(address.name){manufacturerAddressesWithCurrent.unshift(address);}else{report.initializedWithoutAddress=true;address='';}}report.manufacturerAddressesWithCurrent=manufacturerAddressesWithCurrent;report.address=address;_this.setState({report:report});};_this.handleInputChange=function(key){return function(value){var report=_this.state.report;var markStepAsRedacted=_this.props.markStepAsRedacted;if(value!=='')delete report.errors[key];markStepAsRedacted();report[key]=value;_this.setState({report:report});};};_this.handleInspectionDateChange=function(value){var report=_this.state.report;var markStepAsRedacted=_this.props.markStepAsRedacted;if(value!=='')delete report.errors.inspectionDate;if(__WEBPACK_IMPORTED_MODULE_8_moment___default()().utc().hour(23).minute(59).second(59).isBefore(value)){report.errors.inspectionDate='Cannot select Inspection Date in the future';}markStepAsRedacted();report.inspectionDate=value;_this.setState({report:report});};_this.handleYearSelect=function(year){var isListShouldBeCleared=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var report=_this.state.report;var _this$props=_this.props,markStepAsRedacted=_this$props.markStepAsRedacted,user=_this$props.user;var $$getMethod=function $$getMethod(year){if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_11_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_4_api_requests__["a" /* boatAPI */].approvedBoatsByYear(year);}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_11_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_4_api_requests__["h" /* trailerAPI */].trailersByYear(year,true);}};markStepAsRedacted();if(isListShouldBeCleared){report.models=[];}if(year===''){report.year=year;report.modelList=[];_this.setState({report:report});}else{report.year=year;delete report.errors.year;__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get($$getMethod(year)).then(function(_ref){var approvedList=_ref.data;report.modelList=approvedList.filter(function(model){return!report.models.find(function(rm){return+model.id===+rm.id;});});}).finally(function(){_this.setState({report:report});});}};_this.handleSelectFromList=function(model){var report=_this.state.report;var markStepAsRedacted=_this.props.markStepAsRedacted;var selectedModelIndex=report.modelList.findIndex(function(element){return+model.id===+element.id;});report.modelList.splice(selectedModelIndex,1);delete report.errors.models;markStepAsRedacted();report.models.push(model);_this.setState({report:report});};_this.handleRemoveFromList=function(model,index){return function(){var report=_this.state.report;var markStepAsRedacted=_this.props.markStepAsRedacted;report.models.splice(index,1);if(model.status!==__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].DEACTIVATED){report.modelList.push(model);}if(!report.models.length)report.errors.models='At least one model needs to be selected.';markStepAsRedacted();_this.setState({report:report});};};_this.handleReportFileSelect=function(addedFiles){var _report$documents;var report=_this.state.report;var markStepAsRedacted=_this.props.markStepAsRedacted;delete report.errors.documents;if(!report.documents)report.documents=[];(_report$documents=report.documents).push.apply(_report$documents,_toConsumableArray(addedFiles));markStepAsRedacted();_this.setState({report:report});};_this.handleReportFileRemove=function(fileIndex){return function(){var report=_this.state.report;var markStepAsRedacted=_this.props.markStepAsRedacted;if(report.documents[fileIndex].id){_this.reportFileIdsToDelete.push(report.documents[fileIndex].id);}report.documents.splice(fileIndex,1);if(!report.documents.length){report.errors.documents=true;}markStepAsRedacted();_this.setState({report:report});};};_this.handleResponseFileSelect=function(addedFiles){var _response$varDocument;var response=_this.state.response;var markStepAsRedacted=_this.props.markStepAsRedacted;if(!response.varDocuments)response.varDocuments=[];(_response$varDocument=response.varDocuments).push.apply(_response$varDocument,_toConsumableArray(addedFiles));response.error=false;markStepAsRedacted();_this.setState({response:response});};_this.handleResponseFileRemove=function(fileIndex){return function(){var response=_this.state.response;var markStepAsRedacted=_this.props.markStepAsRedacted;if(response.varDocuments&&!response.varDocuments.length){response.error=true;}if(response.varDocuments[fileIndex].id){_this.responseFileIdsToDelete.push(response.varDocuments[fileIndex].id);}response.varDocuments.splice(fileIndex,1);markStepAsRedacted();_this.setState({response:response});};};_this.handleNotesChange=function(notes){_this.setState(function(prevState){return{response:Object.assign({},prevState.response,{notes:notes})};});};_this._handleUpdateClick=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var report,handleUpdate,reportResult,responseResult,resultUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:report=_this.state.report;handleUpdate=_this.props.handleUpdate;_context2.next=4;return _this._updateReport();case 4:reportResult=_context2.sent;_context2.next=7;return _this._updateResponse();case 7:responseResult=_context2.sent;if(!(report.status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].COMPLETE)){_context2.next=11;break;}if(!(report.vresponseRequired&&responseResult===null)){_context2.next=11;break;}return _context2.abrupt('return',_this.setState(function(prevState){return{response:Object.assign({},prevState.response,{error:true})};}));case 11:if(!Object.keys(report.errors).length){_context2.next=13;break;}return _context2.abrupt('return',null);case 13:resultUpdate=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:result={};if(!reportResult){_context.next=5;break;}_context.next=4;return reportResult();case 4:result.report=_context.sent;case 5:if(!responseResult){_context.next=9;break;}_context.next=8;return responseResult();case 8:result.response=_context.sent;case 9:return _context.abrupt('return',result);case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function resultUpdate(){return _ref3.apply(this,arguments);};}();handleUpdate(resultUpdate);case 15:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleSaveAndSubmit=function(_ref4){var isSubmitInspectionShown=_ref4.isSubmitInspectionShown,isSubmitVariationShown=_ref4.isSubmitVariationShown;return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this$state,report,response,handleSaveAndSubmit,reportResult,responseResult,resultUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this$state=_this.state,report=_this$state.report,response=_this$state.response;handleSaveAndSubmit=_this.props.handleSaveAndSubmit;_context4.next=4;return _this._updateReport();case 4:reportResult=_context4.sent;_context4.next=7;return _this._updateResponse();case 7:responseResult=_context4.sent;if(!(report.status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].COMPLETE)){_context4.next=11;break;}if(!(report.vresponseRequired&&responseResult===null)){_context4.next=11;break;}return _context4.abrupt('return',_this.setState(function(prevState){return{response:Object.assign({},prevState.response,{error:true})};}));case 11:if(!Object.keys(report.errors).length){_context4.next=13;break;}return _context4.abrupt('return',null);case 13:resultUpdate=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:result={};if(!reportResult){_context3.next=5;break;}_context3.next=4;return reportResult();case 4:result.report=_context3.sent;case 5:if(!responseResult){_context3.next=9;break;}_context3.next=8;return responseResult();case 8:result.response=_context3.sent;case 9:if(!isSubmitInspectionShown){_context3.next=13;break;}_context3.next=12;return __WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].resubmitReport(report.id));case 12:result.entry=_context3.sent;case 13:if(!isSubmitVariationShown){_context3.next=17;break;}_context3.next=16;return __WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].patch(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].submitVarianceResponse(response.id));case 16:result.entry=_context3.sent;case 17:return _context3.abrupt('return',result);case 18:case'end':return _context3.stop();}}},_callee3,_this2);}));return function resultUpdate(){return _ref6.apply(this,arguments);};}();handleSaveAndSubmit(resultUpdate);case 15:case'end':return _context4.stop();}}},_callee4,_this2);}));};_this._updateReport=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var _this$state$report2,id,status,year,description,inspectionDate,documents,notes,models,address,initializedWithoutAddress,user,isUserManufacturer,$$getRequiredFields,$$validateReport,validationResult,requestJson;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_this$state$report2=_this.state.report,id=_this$state$report2.id,status=_this$state$report2.status,year=_this$state$report2.year,description=_this$state$report2.description,inspectionDate=_this$state$report2.inspectionDate,documents=_this$state$report2.documents,notes=_this$state$report2.notes,models=_this$state$report2.models,address=_this$state$report2.address,initializedWithoutAddress=_this$state$report2.initializedWithoutAddress;user=_this.props.user;isUserManufacturer=!user.isInternal()&&!user.isInspector();$$getRequiredFields=function $$getRequiredFields(){var fields=[];if(user.isInternal()){fields.push('description');if(status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].INCOMPLETE){fields.push('year','inspectionDate','models');if(id)fields.push('documents');}}else if(user.isInspector()){if(status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].INCOMPLETE){fields.push('year','inspectionDate','models','documents');}if(status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].PENDING){fields.push('description');}}if(!initializedWithoutAddress)fields.push('address');return fields;};$$validateReport=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var report,fields,hasErrors,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,field,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:report=_this.state.report;fields=$$getRequiredFields();if(fields.length){_context5.next=4;break;}return _context5.abrupt('return',null);case 4:hasErrors=!!Object.keys(report.errors).length;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context5.prev=8;for(_iterator=fields[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){field=_step.value;data=_this.state.report[field];if(field==='models'&&!data.length){report.errors.models='At least one model needs to be selected.';}if(data.length!==undefined?!data.length:!data){report.errors[field]=true;hasErrors=true;}}_context5.next=16;break;case 12:_context5.prev=12;_context5.t0=_context5['catch'](8);_didIteratorError=true;_iteratorError=_context5.t0;case 16:_context5.prev=16;_context5.prev=17;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 19:_context5.prev=19;if(!_didIteratorError){_context5.next=22;break;}throw _iteratorError;case 22:return _context5.finish(19);case 23:return _context5.finish(16);case 24:if(!hasErrors){_context5.next=27;break;}_this.setState({report:report},function(){return null;});return _context5.abrupt('return',true);case 27:return _context5.abrupt('return',null);case 28:case'end':return _context5.stop();}}},_callee5,_this2,[[8,12,16,24],[17,,19,23]]);}));return function $$validateReport(){return _ref8.apply(this,arguments);};}();_context7.next=7;return $$validateReport();case 7:validationResult=_context7.sent;if(!(validationResult===null&&!isUserManufacturer)){_context7.next=15;break;}requestJson=Object.assign({inspectionDate:inspectionDate.utc(),year:year,description:description,notes:notes},address.value);requestJson.modelIds=[].concat(_toConsumableArray(models.map(function(model){return model.id;})));if(_this.reportFileIdsToDelete.length){requestJson.fileIdsToDelete=[].concat(_toConsumableArray(_this.reportFileIdsToDelete));}return _context7.abrupt('return',_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:data=new FormData();data.append('requestJson',JSON.stringify(requestJson));if(documents&&documents.length){documents.filter(function(file){return!file.created;}).forEach(function(file){data.append('reports',file);});}return _context6.abrupt('return',__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].inspectionDetails(id),data).then(function(_ref10){var data=_ref10.data;_this.reportFileIdsToDelete=[];return data;}).catch(function(){return null;}));case 4:case'end':return _context6.stop();}}},_callee6,_this2);})));case 15:return _context7.abrupt('return',null);case 16:case'end':return _context7.stop();}}},_callee7,_this2);}));_this._updateResponse=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var response,_this$state$report3,status,vresponseRequired,user,$$validateResponse,validationResult,requestJson;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:response=_this.state.response;_this$state$report3=_this.state.report,status=_this$state$report3.status,vresponseRequired=_this$state$report3.vresponseRequired;user=_this.props.user;$$validateResponse=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(!user.isInspector()){_context8.next=2;break;}return _context8.abrupt('return',null);case 2:if(!(status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].COMPLETE&&vresponseRequired)){_context8.next=18;break;}if(!(response.status!==__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].INCOMPLETE)){_context8.next=11;break;}if(!user.isInternal()){_context8.next=8;break;}return _context8.abrupt('return',true);case 8:return _context8.abrupt('return',null);case 9:_context8.next=16;break;case 11:if(!((!response.varDocuments||!response.varDocuments.length)&&!user.isInternal())){_context8.next=15;break;}return _context8.abrupt('return',null);case 15:return _context8.abrupt('return',true);case 16:_context8.next=19;break;case 18:return _context8.abrupt('return',false);case 19:case'end':return _context8.stop();}}},_callee8,_this2);}));return function $$validateResponse(){return _ref12.apply(this,arguments);};}();_context10.next=6;return $$validateResponse();case 6:validationResult=_context10.sent;if(!validationResult){_context10.next=13;break;}requestJson={id:response.id,notes:response.notes||''};if(_this.responseFileIdsToDelete.length){requestJson.fileIdsToDelete=[].concat(_toConsumableArray(_this.responseFileIdsToDelete));_this.responseFileIdsToDelete=[];}return _context10.abrupt('return',_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:data=new FormData();data.append('requestJson',JSON.stringify(requestJson));if(response.varDocuments&&response.varDocuments.length){response.varDocuments.filter(function(file){return!file.created;}).forEach(function(file){data.append('reports',file);});}return _context9.abrupt('return',__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].saveVarianceResponse,data).then(function(_ref14){var data=_ref14.data;return data;}).catch(function(){return null;}));case 4:case'end':return _context9.stop();}}},_callee9,_this2);})));case 13:return _context10.abrupt('return',validationResult);case 14:case'end':return _context10.stop();}}},_callee10,_this2);}));defaultState.report.errors={};_this.state=Object.assign({},defaultState);_this.reportFileIdsToDelete=[];_this.responseFileIdsToDelete=[];return _this;}_createClass(Inspection,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var _props=this.props,user=_props.user,match=_props.match;var inspectionId=match.params.inspectionId;if(isFinite(inspectionId)){this.setState({requestInProcess:true},function(){__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4_api_requests__["d" /* inspectionAPI */].inspectionDetails(inspectionId)).then(function(_ref15){var report=_ref15.data;var $$getMethod=function $$getMethod(){if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_11_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_4_api_requests__["a" /* boatAPI */].modelYears;}if(user.getActiveRole()===__WEBPACK_IMPORTED_MODULE_11_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName){return __WEBPACK_IMPORTED_MODULE_4_api_requests__["h" /* trailerAPI */].getPermissibleModelYears;}};var response=Object.assign({},defaultState.response,report.response);delete report.response;report.inspectionDate=__WEBPACK_IMPORTED_MODULE_8_moment___default()(report.inspectionDate).local();__WEBPACK_IMPORTED_MODULE_3_api_http__["a" /* default */].get($$getMethod()).then(function(_ref16){var yearList=_ref16.data;_this3.setState({report:Object.assign({},defaultState.report,report,{yearList:yearList}),response:response,requestInProcess:false},function(){_this3.handleYearSelect(_this3.state.report.year,false);});});});});}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.manufacturerAddresses&&!this.state.report.manufacturerAddressesWithCurrent.length&&!this.state.requestInProcess){this.updateInspectionAddress();}}},{key:'render',value:function render(){var _state=this.state,report=_state.report,response=_state.response,requestInProcess=_state.requestInProcess;var _props2=this.props,getReadableStatus=_props2.getReadableStatus,handleGoBackClick=_props2.handleGoBackClick,markStepAsRedacted=_props2.markStepAsRedacted,user=_props2.user,match=_props2.match,getDetailsLink=_props2.getDetailsLink;var inspectionId=match.params.inspectionId;var showResponse=report.status!==__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].INCOMPLETE&&report.vresponseRequired;var isSubmitInspectionShown=report.status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].INCOMPLETE;var isSubmitVariationShown=report.status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].COMPLETE&&response.status===__WEBPACK_IMPORTED_MODULE_9_constants_index__["c" /* STATUS */].INCOMPLETE;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */],{report:report,response:response,user:user,readableStatus:getReadableStatus(Object.assign({},report,{response:response})),handleGoBackClick:handleGoBackClick}),!requestInProcess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Report__["a" /* default */],{report:report,user:user,getDetailsLink:getDetailsLink,inspectionId:inspectionId,handleInputChange:this.handleInputChange,handleInspectionDateChange:this.handleInspectionDateChange,handleYearSelect:this.handleYearSelect,handleSelectFromList:this.handleSelectFromList,handleRemoveFromList:this.handleRemoveFromList,handleFileSelect:this.handleReportFileSelect,handleFileRemove:this.handleReportFileRemove,markStepAsRedacted:markStepAsRedacted}),showResponse&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Response__["a" /* default */],{response:response,user:user,handleFileSelect:this.handleResponseFileSelect,handleFileRemove:this.handleResponseFileRemove,handleNotesChange:this.handleNotesChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Components_ApplicationActions__["a" /* default */],Object.assign({backButtonLabel:'Cancel',saveButtonLabel:'Save',saveButtonAction:this._handleUpdateClick,backButtonAction:handleGoBackClick},(isSubmitInspectionShown||isSubmitVariationShown)&&{saveAndSubmitButtonLabel:'Save And Submit',saveAndSubmitAction:this.handleSaveAndSubmit({isSubmitInspectionShown:isSubmitInspectionShown,isSubmitVariationShown:isSubmitVariationShown})})))));}}]);return Inspection;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component))||_class;

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status,readableStatus=_ref.readableStatus,handleGoBackClick=_ref.handleGoBackClick,isDetails=_ref.isDetails,report=_ref.report,response=_ref.response,user=_ref.user;var _getStatusColor=function _getStatusColor(){if(user.isInspector()){if(report&&report.status){return report.status.toString().toLowerCase();}}else{if(report.status===__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* STATUS */].COMPLETE){if(report.vresponseRequired){if(response&&response.status){return response.status.toString().toLowerCase();}}else{if(report&&report.status){return report.status.toString().toLowerCase();}}}else{if(report&&report.status){return report.status.toString().toLowerCase();}}}return'';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-header detailsScene__scene-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go-back-to-list-header-button',onClick:handleGoBackClick},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_width_450'},'Inspection Record Application'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detailsScene__status-label '+_getStatusColor()+' _width_210'},readableStatus.toLowerCase()));});

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeneralInformation__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubHeader__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListOfModels__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notes__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportDocumentation__ = __webpack_require__(1168);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Report=function(_React$Component){_inherits(Report,_React$Component);function Report(){_classCallCheck(this,Report);return _possibleConstructorReturn(this,(Report.__proto__||Object.getPrototypeOf(Report)).apply(this,arguments));}_createClass(Report,[{key:'render',value:function render(){var _props=this.props,report=_props.report,user=_props.user,handleInputChange=_props.handleInputChange,handleYearSelect=_props.handleYearSelect,handleSelectFromList=_props.handleSelectFromList,handleRemoveFromList=_props.handleRemoveFromList,handleFileSelect=_props.handleFileSelect,handleFileRemove=_props.handleFileRemove,handleInspectionDateChange=_props.handleInspectionDateChange,getDetailsLink=_props.getDetailsLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SubHeader__["a" /* default */],{label:'Inspection Report',number:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GeneralInformation__["a" /* default */],{user:user,errors:report.errors,status:report.status,description:report.description,inspectionDate:report.inspectionDate,approvalDate:report.approvalDate,year:report.year,yearList:report.yearList,address:report.address,manufacturerAddressesWithCurrent:report.manufacturerAddressesWithCurrent,handleInputChange:handleInputChange,handleInspectionDateChange:handleInspectionDateChange,handleYearSelect:handleYearSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ListOfModels__["a" /* default */],{models:report.models,getDetailsLink:getDetailsLink,modelList:report.modelList,status:report.status,errors:report.errors,handleSelectFromList:handleSelectFromList,handleRemoveFromList:handleRemoveFromList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Notes__["a" /* default */],{notes:report.notes,user:user,handleInputChange:handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReportDocumentation__["a" /* default */],{documents:report.documents,user:user,id:report.id,errors:report.errors,status:report.status,inspectionModelYear:report.year,handleFileSelect:handleFileSelect,handleFileRemove:handleFileRemove}));}}]);return Report;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GeneralInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Text__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_DatePicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_Select__ = __webpack_require__(7);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function GeneralInformation(_ref){var user=_ref.user,status=_ref.status,description=_ref.description,inspectionDate=_ref.inspectionDate,year=_ref.year,yearList=_ref.yearList,errors=_ref.errors,handleInputChange=_ref.handleInputChange,handleYearSelect=_ref.handleYearSelect,handleInspectionDateChange=_ref.handleInspectionDateChange,approvalDate=_ref.approvalDate,address=_ref.address,manufacturerAddressesWithCurrent=_ref.manufacturerAddressesWithCurrent;var _isCanEditDescription=function _isCanEditDescription(){if(user.isInternal())return true;if(user.isInspector()&&status!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].COMPLETE)return true;};var _isCanEditInspectionDate=function _isCanEditInspectionDate(){if(user.isInternal()||user.isInspector()){if(status!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].COMPLETE&&status!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].PENDING)return true;}return false;};var _isCanEditModelYear=function _isCanEditModelYear(){if(user.isInternal()||user.isInspector()){if(status!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].COMPLETE&&status!==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].PENDING)return true;}return false;};var _isCanEditAddressField=function _isCanEditAddressField(){return!!((user.isInternal()||user.isInspector())&&status==__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].INCOMPLETE);};var _getDescription=function _getDescription(){if(_isCanEditDescription()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Input__["a" /* Input */],{mainWrapperClassName:'_width_pc_100',styleClass:__WEBPACK_IMPORTED_MODULE_4_Components_Input__["c" /* inputStyleClasses */].primary,label:'Description *',maxLength:250,alwaysTextField:true,error:errors.description,value:description,onChange:handleInputChange('description')});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Description',value:description});}};var _getInspectionDate=function _getInspectionDate(){if(_isCanEditInspectionDate()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_DatePicker__["a" /* default */],{label:'Inspection Date *',error:errors.inspectionDate,selectedDate:inspectionDate,mainWrapperClassName:'input__main-wrapper_primary _margin_right_30 _margin_top_18',handleSelectDate:handleInspectionDateChange});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _margin_right_30',textClassName:'text__text_primary',label:'Inspection Date',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(inspectionDate).local(true).format('MM / DD / YYYY')});}};var _getModelYearDate=function _getModelYearDate(){if(_isCanEditModelYear()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Select__["a" /* default */],{selectionList:yearList,defaultItem:year,mainWrapperClassName:'input__main-wrapper_primary',type:'primary',label:'Model Year *',error:errors.year,handleSelect:handleYearSelect});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary',textClassName:'text__text_primary',label:'Model Year',value:year});}};var _getAddressField=function _getAddressField(){if(_isCanEditAddressField()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_Select__["a" /* default */],{selectionList:manufacturerAddressesWithCurrent,defaultItem:address,mainWrapperClassName:'input__main-wrapper_primary _width_pc_100',type:'primary',label:'Select Address *',itemNameIndicator:'name',error:errors.address,handleSelect:handleInputChange('address')});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary _width_pc_100',textClassName:'text__text_primary',label:'Address',value:(typeof address==='undefined'?'undefined':_typeof(address))==='object'?address.name:address});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section _padding_top_0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'General Info'),_getDescription(),_getInspectionDate(),_getModelYearDate(),_getAddressField(),status===__WEBPACK_IMPORTED_MODULE_3_constants_index__["b" /* INSPECTION_STATUS */].COMPLETE&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Text__["a" /* default */],{mainWrapperClassName:'text__wrapper_primary  _width_pc_100',textClassName:'text__text_primary',label:'Approval date',value:approvalDate?__WEBPACK_IMPORTED_MODULE_2_moment___default()(approvalDate).local(true).format('MM / DD / YYYY'):'N/A'}));}

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ListOfModels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Select__ = __webpack_require__(7);
function ListOfModels(_ref){var models=_ref.models,status=_ref.status,modelList=_ref.modelList,errors=_ref.errors,handleRemoveFromList=_ref.handleRemoveFromList,handleSelectFromList=_ref.handleSelectFromList,getDetailsLink=_ref.getDetailsLink;var isEditable=status!==__WEBPACK_IMPORTED_MODULE_1_constants_index__["c" /* STATUS */].COMPLETE&&status!==__WEBPACK_IMPORTED_MODULE_1_constants_index__["c" /* STATUS */].PENDING;var _getRowStyles=function _getRowStyles(status){if(status===__WEBPACK_IMPORTED_MODULE_1_constants_index__["c" /* STATUS */].DEACTIVATED)return'__row_deactivated';return'__row_active';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_padding_bottom_20'},'List of Models'),isEditable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Select__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_2_Components_Select__["b" /* selectType */].primarySmall,mainWrapperClassName:'_width_pc_80 _margin_top_12',dropDownClassName:'_max_height_120',selectionList:modelList,multiSelect:true,itemNameIndicator:['id','name'],error:errors.models,handleSelect:handleSelectFromList,placeholder:'Id or Name'}),models.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'selected-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'_flex _stretch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_14'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_45'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_18'},models[0].boatType?'Type':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_18'},models[0].engineType?'Engine Type':'')),isEditable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__header_text _width_pc_5'},'Remove')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body'},models.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:model.id,className:'selected-list__body_row '+_getRowStyles(model.status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:getDetailsLink(model),target:'_blank',rel:'noreferrer',className:'_flex _stretch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_14'},model.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_45'},model.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_18'},model.boatType?model.boatType.replace(/_/,' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_18'},model.engineType?model.engineType.replace(/_/,' '):'')),isEditable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list__body_text _width_pc_5 __remove-icon',onClick:handleRemoveFromList(model,index)}));}))));}ListOfModels.defaultProps={models:[]};

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes,user=_ref.user,handleInputChange=_ref.handleInputChange;if(notes||user.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes||'',handleInputChange:handleInputChange('notes'),disabled:!user.isInternal()}));}else{return null;}}

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReportDocumentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(9);
function ReportDocumentation(_ref){var documents=_ref.documents,status=_ref.status,id=_ref.id,errors=_ref.errors,handleFileRemove=_ref.handleFileRemove,handleFileSelect=_ref.handleFileSelect,user=_ref.user,inspectionModelYear=_ref.inspectionModelYear;var isEditable=status===__WEBPACK_IMPORTED_MODULE_3_constants_index__["c" /* STATUS */].INCOMPLETE;if(!user.isInternal()&&!user.isInspector())return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section',onClick:function onClick(){user.goTo(user.getDocumentsLink({chosenYear:inspectionModelYear,filter:{typeTitle:'Inspection Report'}}));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'_cursor_pointer _flex _ai_center'},'Please click here to access Inspection Report Documentation.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-file-picker__col_name_icon _width_20 _height_20 _margin_left_10'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Inspection Report Documentation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label'},'Please upload inspection report and signature page'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_FilePicker__["a" /* default */],{editableStateSectionHeader:'',notEditableStateSectionHeader:'',isEditable:isEditable,error:errors.documents?'Please upload at least one file':'',sectionHeaderClassName:'_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16',mainWrapperClassName:'_min_height_auto',uploadButtonText:'Upload',handleFileSelect:handleFileSelect,handleRemoveFile:handleFileRemove,httpParams:{currentMethod:__WEBPACK_IMPORTED_MODULE_1_api_requests__["d" /* inspectionAPI */].downloadReportDocument,currentId:id},files:documents||[]}));}ReportDocumentation.defaultProps={documents:[]};

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Response; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubHeader__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notes__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResponseDocumentation__ = __webpack_require__(1171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Response=function(_React$Component){_inherits(Response,_React$Component);function Response(){_classCallCheck(this,Response);return _possibleConstructorReturn(this,(Response.__proto__||Object.getPrototypeOf(Response)).apply(this,arguments));}_createClass(Response,[{key:'render',value:function render(){var _props=this.props,response=_props.response,user=_props.user,handleFileSelect=_props.handleFileSelect,handleFileRemove=_props.handleFileRemove,handleNotesChange=_props.handleNotesChange;if(!response)return null;if(user.isInspector())return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SubHeader__["a" /* default */],{label:'Variation Response',number:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Notes__["a" /* default */],{notes:response.notes,user:user,handleNotesChange:handleNotesChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResponseDocumentation__["a" /* default */],{varDocuments:[].concat(_toConsumableArray(response.varDocuments||[])),error:response.error,status:response.status,user:user,handleFileSelect:handleFileSelect,handleFileRemove:handleFileRemove}));}}]);return Response;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Notes__ = __webpack_require__(36);
function NotesSection(_ref){var notes=_ref.notes,user=_ref.user,handleNotesChange=_ref.handleNotesChange;if(notes||user.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Notes__["a" /* default */],{text:notes||'',handleInputChange:handleNotesChange,disabled:!user.isInternal()}));}else{return null;}}

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ResponseDocumentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_FilePicker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_index__ = __webpack_require__(9);
function ResponseDocumentation(_ref){var varDocuments=_ref.varDocuments,user=_ref.user,handleFileRemove=_ref.handleFileRemove,handleFileSelect=_ref.handleFileSelect,error=_ref.error,status=_ref.status;var isEditable=status===__WEBPACK_IMPORTED_MODULE_2_constants_index__["c" /* STATUS */].INCOMPLETE;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,'Variation Response Documentation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__main-alert-label'},'Please upload Variation Response and supporting documentation if any.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_FilePicker__["a" /* default */],{editableStateSectionHeader:'',notEditableStateSectionHeader:'',isEditable:isEditable,error:error?'Please upload at least one file':'',handleRemoveFile:handleFileRemove,handleFileSelect:handleFileSelect,sectionHeaderClassName:'_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16',mainWrapperClassName:'_min_height_auto',uploadButtonText:'Upload',files:varDocuments||[]}));}ResponseDocumentation.defaultProps={varDocuments:[]};

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_Pagination__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltersSection__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableHeader__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Row__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Components_Input__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEARCHABLE_FIELDS=['fileName','typeTitle'];var DocumentsList=function(_React$Component){_inherits(DocumentsList,_React$Component);function DocumentsList(props){_classCallCheck(this,DocumentsList);var _this=_possibleConstructorReturn(this,(DocumentsList.__proto__||Object.getPrototypeOf(DocumentsList)).call(this,props));_this.defaultState={activePage:1,selectedRowsCount:10,status:'All',selectedType:'All',sortedBy:'fileName',sortAsc:-1,filter:{},searchString:'',currentYear:'',chosenYear:''};_this.roleSwitch=function(){var _this$props=_this.props,user=_this$props.user,match=_this$props.match;var URLRole='';Object.keys(__WEBPACK_IMPORTED_MODULE_12_constants_roles__["a" /* ROLES */]).forEach(function(roleKey){if(match.params.manufacturerRole===__WEBPACK_IMPORTED_MODULE_12_constants_roles__["a" /* ROLES */][roleKey].nameForUrl)URLRole=__WEBPACK_IMPORTED_MODULE_12_constants_roles__["a" /* ROLES */][roleKey];});if(URLRole&&user.getActiveRole()!==URLRole.serverName){user.changeMenu(URLRole.serverName);}};_this.getCurrentYear=function(){var user=_this.props.user;return new Promise(function(resolve,reject){switch(user.getActiveRole()){case __WEBPACK_IMPORTED_MODULE_12_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref){var data=_ref.data;resolve(data[1]||data[0]);});break;case __WEBPACK_IMPORTED_MODULE_12_constants_roles__["a" /* ROLES */].COMPONENT_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["a" /* boatAPI */].currentModelYear).then(function(_ref2){var data=_ref2.data;resolve(data[1]||data[0]);});break;case __WEBPACK_IMPORTED_MODULE_12_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName:__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["h" /* trailerAPI */].currentModelYear).then(function(_ref3){var data=_ref3.data;resolve(data);});break;default:resolve(new Date().getFullYear());break;}});};_this._loadFromStore=function(){var user=_this.props.user;var chosenYear=_this.state.chosenYear;__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].select(user.getActiveRole()+'_documents',''+user.getManufacturerCode()+chosenYear).then(function(list){_this.documentsList=list;_this.initDocumentTypes(list);_this.forceUpdate();});};_this.initDocumentTypes=function(data){_this.documentTypes=['All'];var allPossibleDocumentTypes={};data.forEach(function(documentEntry){allPossibleDocumentTypes[documentEntry.typeTitle]=true;});Object.keys(allPossibleDocumentTypes).forEach(function(type){_this.documentTypes.push(type);});};_this.handleRowsSelect=function(rowsCountSelected,totalRowsCount){var user=_this.props.user;var selectedRowsCount=rowsCountSelected&&rowsCountSelected<totalRowsCount?rowsCountSelected:0;var state={selectedRowsCount:selectedRowsCount,activePage:1};_this.setState(state,user.updateURLSearchString(state));};_this.handleActivePageChange=function(activePage){var user=_this.props.user;_this.setState({activePage:activePage},function(){user.updateURLSearchString({activePage:activePage});});};_this._filterList=function(componentList){var _this$state=_this.state,filter=_this$state.filter,searchString=_this$state.searchString;var doesSearchableFieldsContainSearchString=function doesSearchableFieldsContainSearchString(element){for(var searchableFieldIndex in SEARCHABLE_FIELDS){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]]){if(element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase().includes(searchString.toLowerCase()))return true;}}return false;};return componentList.filter(function(element){for(var filterFieldName in filter){switch(filterFieldName){case'status':if(element[filterFieldName].toLowerCase()!==filter[filterFieldName].toLowerCase())return false;break;default:if(element[filterFieldName]!==filter[filterFieldName])return false;}}return!searchString||doesSearchableFieldsContainSearchString(element);});};_this._sortList=function(a,b){var _this$state2=_this.state,sortedBy=_this$state2.sortedBy,sortAsc=_this$state2.sortAsc;switch(sortedBy){default:if(a[sortedBy]&&b[sortedBy])return a[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')>b[sortedBy].toString().toLowerCase().replace(/\s+/g,' ')?sortAsc:-sortAsc;else return a[sortedBy]>b[sortedBy]?sortAsc:-sortAsc;}};_this.handleSort=function(sortedBy){return function(){var user=_this.props.user;_this.setState(function(prevState){return{sortedBy:sortedBy,sortAsc:-prevState.sortAsc,activePage:1};},function(){user.updateURLSearchString({sortedBy:_this.state.sortedBy,sortAsc:_this.state.sortAsc,activePage:1});});};};_this.handleSelectFilter=function(filterFieldName){return function(filterElement){var user=_this.props.user;var selectedValue=filterElement.value!==undefined?filterElement.value:filterElement;var newFilterState=_this.state.filter;if(selectedValue==='All')delete newFilterState[filterFieldName];else newFilterState[filterFieldName]=selectedValue;_this.setState({filter:newFilterState,activePage:1},function(){user.updateURLSearchString({filter:_this.state.filter,activePage:1});});};};_this.handleSearchStringInput=function(value){var user=_this.props.user;_this.setState({searchString:value,activePage:1},function(){user.updateURLSearchString({searchString:value});});};_this.handleYearSelect=function(year){var user=_this.props.user;user.saveSelectedYear(year);_this.setState({chosenYear:year},function(){_this.listRequestInProgress=true;user.updateURLSearchString({chosenYear:year});_this.updateListData();});};_this.handleDownloadClick=function(envelopeId,name){return function(){__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].eSignDocumentDownload(envelopeId,name),{responseType:'blob'}).then(function(_ref4){var data=_ref4.data;Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["b" /* downloadFile */])(data,name);});};};_this._getList=function(){var _this$state3=_this.state,activePage=_this$state3.activePage,selectedRowsCount=_this$state3.selectedRowsCount,sortedBy=_this$state3.sortedBy;var user=_this.props.user;var resultList=[];var resultLength=0;if(!_this.documentsList.length){if(_this.listRequestInProgress){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'no-spinner-div',className:'ect-spinner _height_120'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-spinner__image',style:{width:50,height:50}}))];}else{resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__["a" /* default */],{key:0},'No documents for selected manufacturer.')];}}else{var filteredList=_this._filterList(_this.documentsList).sort(_this._sortList);var sliceFrom=(activePage-1)*selectedRowsCount;var sliceTo=+selectedRowsCount?activePage*selectedRowsCount:filteredList.length;if(!filteredList.length){resultList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Components_EmptyList__["a" /* default */],{key:0},'No documents found with selected filters.')];}else{resultList=filteredList.slice(sliceFrom,sliceTo).map(function(document,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Row__["a" /* default */],{key:document.id,user:user,document:document,isOdd:!!(index%2),sortedBy:sortedBy,handleDownloadClick:_this.handleDownloadClick});});resultLength=filteredList.length;}}return{resultList:resultList,resultLength:resultLength};};var storedState=props.user.getStoredState('documentsListState',_this.defaultState);props.user.updateURLSearchString(storedState);_this.state=Object.assign({},_this.defaultState,storedState);_this.listRequestInProgress=true;_this.engineTypes=[];_this.documentsList=[];_this.documentTypes=['All'];return _this;}_createClass(DocumentsList,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var user=this.props.user;this.roleSwitch();this.currentRole=user.getActiveRole();this.getCurrentYear().then(function(currentYear){_this2.setState({currentYear:currentYear},function(){_this2.handleYearSelect(user.getSelectedYear()||currentYear);});});}},{key:'updateListData',value:function updateListData(){var _this3=this;var user=this.props.user;var chosenYear=this.state.chosenYear;this.currentRole=user.getActiveRole();this._loadFromStore();__WEBPACK_IMPORTED_MODULE_1_api_http__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2_api_requests__["e" /* manufacturerAPI */].eSignDocumentsList(chosenYear,this.currentRole)).then(function(_ref5){var data=_ref5.data;__WEBPACK_IMPORTED_MODULE_10__registerIDBWorker__["a" /* default */].insert(_this3.currentRole+'_documents',data,''+user.getManufacturerCode()+chosenYear).then(function(){_this3.listRequestInProgress=false;_this3._loadFromStore();});});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this4=this;var user=this.props.user;if(user.getActiveRole()!==this.currentRole){this.documentsList=[];this.listRequestInProgress=true;this.getCurrentYear().then(function(currentYear){_this4.setState({currentYear:currentYear},function(){_this4.handleYearSelect(user.getSelectedYear()||currentYear);});});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var user=this.props.user;user.saveState('documentsListState',this.state,['chosenYear']);}},{key:'render',value:function render(){var _state=this.state,activePage=_state.activePage,selectedRowsCount=_state.selectedRowsCount,sortedBy=_state.sortedBy,sortAsc=_state.sortAsc,filter=_state.filter,searchString=_state.searchString,currentYear=_state.currentYear,chosenYear=_state.chosenYear;var _getList=this._getList(),resultList=_getList.resultList,resultLength=_getList.resultLength;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__scene-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scene__content-wrapper list-scene__content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'scene__scene-header list-scene__scene-header'},'Documents',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Components_Input__["a" /* Input */],{mainWrapperClassName:'list-scene__header-search-field-wrapper',styleClass:__WEBPACK_IMPORTED_MODULE_11_Components_Input__["c" /* inputStyleClasses */].searchBar,placeholder:'Type here to search',maxLength:250,value:searchString,onChange:this.handleSearchStringInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltersSection__["a" /* default */],{outCount:resultLength,handleRowCountSelect:this.handleRowsSelect,rowsCount:selectedRowsCount,handleSelectFilter:this.handleSelectFilter,handleYearSelect:this.handleYearSelect,filterState:filter,chosenYear:chosenYear,currentYear:currentYear,documentTypes:this.documentTypes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TableHeader__["a" /* default */],{handleSortClick:this.handleSort,order:sortAsc===1,sortedBy:sortedBy}),resultList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'list-scene__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Components_RowsSelector__["a" /* default */],{allRowsCount:resultLength,selectedRowsCount:selectedRowsCount,handleRowsSelect:this.handleRowsSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Components_Pagination__["a" /* default */],{className:'_height_80',activePage:activePage,handleClick:this.handleActivePageChange,allRowsCount:resultLength,selectedRowsCount:selectedRowsCount}))));}}]);return DocumentsList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Select__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__ = __webpack_require__(90);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var outCount=_ref.outCount,handleRowCountSelect=_ref.handleRowCountSelect,rowsCount=_ref.rowsCount,handleSelectFilter=_ref.handleSelectFilter,filterState=_ref.filterState,currentYear=_ref.currentYear,documentTypes=_ref.documentTypes,handleYearSelect=_ref.handleYearSelect,chosenYear=_ref.chosenYear;var DOCUMENTS_STATUSES=[{name:'All',value:'All'},{name:'Sent',value:'sent'},{name:'Completed',value:'completed'},{name:'Voided',value:'voided'},{name:'Delivered',value:'delivered'},{name:'Declined',value:'declined'}];var getSelectedItem=function getSelectedItem(key,possibleItemsList){if(filterState[key]===undefined)return possibleItemsList[0];return possibleItemsList.find(function(item){return(item.value||item)===filterState[key];});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-filters-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__utility-section-filters-header'},'Filter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Components_YearPicker__["a" /* default */],{endYear:currentYear+1,yearPickAction:handleYearSelect,label:'by Year',year:chosenYear,width:160,height:18}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:DOCUMENTS_STATUSES,handleSelect:handleSelectFilter('status'),placeholder:'All',defaultItem:getSelectedItem('status',DOCUMENTS_STATUSES),label:'by Status',itemNameIndicator:'name',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Select__["a" /* default */],{selectionList:documentTypes,handleSelect:handleSelectFilter('typeTitle'),placeholder:'All',defaultItem:getSelectedItem('typeTitle',documentTypes),label:'by Type',type:__WEBPACK_IMPORTED_MODULE_1_Components_Select__["b" /* selectType */].listFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'list-scene__utility-section-rows-select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_RowsSelector__["a" /* default */],{allRowsCount:outCount,handleRowsSelect:handleRowCountSelect,selectedRowsCount:rowsCount})));});

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var handleSortClick=_ref.handleSortClick,order=_ref.order,sortedBy=_ref.sortedBy;function createClasses(key){if(sortedBy===key)return(order?'asc':'desc')+' active';return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('fileName')+' list-scene__table-row-element_place_filler',onClick:handleSortClick('fileName')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Document Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('type')+' _width_pc_22',onClick:handleSortClick('type')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Document Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('date')+' _width_pc_12',onClick:handleSortClick('date')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Document Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element '+createClasses('status')+' _width_pc_12',onClick:handleSortClick('status')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element-sort-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-header-element _text_align_center _jc_center _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Download')));});

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this._getStatusColor=function(){var document=_this.props.document;if(document&&document.status){return'list-scene__status-label_'+document.status.toString().toLowerCase();}return'';},_this._getDocumentReadableStatus=function(){var document=_this.props.document;if(document&&document.status){return document.status[0].toUpperCase()+document.status.slice(1).toLowerCase();}return'';},_this._getBackgroundColourStyle=function(){var isOdd=_this.props.isOdd;return isOdd?'_background_color_pale_gray':'_background_color_white';},_this._getTextColourStyle=function(key){var sortedBy=_this.props.sortedBy;if(sortedBy===key)return'active';return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,document=_props.document,handleDownloadClick=_props.handleDownloadClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'documentRowId'+document.id,className:'list-scene__table-row '+this._getBackgroundColourStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_left '+this._getStatusColor()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'documentNameField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('fileName')+' list-scene__table-row-element_place_filler'},document.fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'documentTypeField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('type')+' _width_pc_22'},document.typeTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'documentEngineTypeField',className:'list-scene__table-row-element list-scene__table-row-element_text-element '+this._getTextColourStyle('date')+' _width_pc_12'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(document.date).local(true).format('MM / DD / YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'documentStatusField',className:'list-scene__status-label '+this._getStatusColor()+' '+this._getTextColourStyle('status')},this._getDocumentReadableStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'documentDownloadButton',className:'list-scene__table-row-element list-scene__table-row-element_item-element _jc_center _width_pc_12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'__download-icon _cursor_pointer',onClick:handleDownloadClick(document.id,document.fileName)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-scene__status-bar_right '+this._getStatusColor()}));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Row.propTypes={document:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__annualCompliance__ = __webpack_require__(380);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var warning=_ref.warning,_ref$warnings=_ref.warnings,warnings=_ref$warnings===undefined?[]:_ref$warnings,onDismiss=_ref.onDismiss;var root=document.getElementById('root');if(!warning){root.classList.remove('modal-open');root.classList.remove('annual-compliance-modal-open');return null;}var isRestricted=warning.level===__WEBPACK_IMPORTED_MODULE_3__annualCompliance__["a" /* COMPLIANCE_LEVEL */].RESTRICTED;root.classList.remove(isRestricted?'modal-open':'annual-compliance-modal-open');var displayedWarnings=isRestricted?warnings:[warning];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Components_Modal__["a" /* default */],{isOpen:true,className:isRestricted?'annual-compliance-modal--restricted':'annual-compliance-modal',rootClassName:isRestricted?'annual-compliance-modal-open':'modal-open'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'annual-compliance-modal__warnings'},displayedWarnings.map(function(displayedWarning,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'annual-compliance-modal__warning',key:displayedWarning.role+'-'+displayedWarning.itemType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'ect-modal-header'},displayedWarning.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ect-modal-body annual-compliance-modal__body'},displayedWarning.message),index<displayedWarnings.length-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'ect-modal-footer'},isRestricted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'annual-compliance-modal__logout-message'},'Use Log out in the header to exit ECT.'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Components_Button__["c" /* default */],{label:'OK',buttonClassName:'_height_40 _width_160',onClick:onDismiss})));});

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainNavigation__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Profile__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdditionNavigation__ = __webpack_require__(1181);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components
 */var Header=function(_React$Component){_inherits(Header,_React$Component);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:'render',value:function render(){var _props=this.props,user=_props.user,logOut=_props.logOut,changeMenu=_props.changeMenu,location=_props.location,isComplianceRestricted=_props.isComplianceRestricted;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{id:'header',className:'_z_index_max'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-header _z_index_max '+(isComplianceRestricted?'compliance-restricted':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* default */],null),user.token&&!isComplianceRestricted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MainNavigation__["a" /* default */],{user:user,location:location,changeMenu:changeMenu}),user.token&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Profile__["a" /* default */],{user:user,logOut:logOut})),user.token&&!isComplianceRestricted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AdditionNavigation__["a" /* default */],{user:user,location:location}));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LogoComponent=function LogoComponent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'});};/* harmony default export */ __webpack_exports__["a"] = (LogoComponent);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_roles__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainNavigationComponent=function(_React$Component){_inherits(MainNavigationComponent,_React$Component);function MainNavigationComponent(props){_classCallCheck(this,MainNavigationComponent);var _this=_possibleConstructorReturn(this,(MainNavigationComponent.__proto__||Object.getPrototypeOf(MainNavigationComponent)).call(this,props));_this.handleResetManufacturer=function(){var user=_this.props.user;user.goToDashboard();};_this.getBackToDashboardButton=function(){var user=_this.props.user;var manufacturerNameToDisplay=user.getManufacturerName()+' ('+user.getManufacturerCode()+')';var inspectorNameToDisplay=user.getInspectorName()+' ('+user.getInspectorCode()+')';if(!user.isInternal()&&!user.isInspector())return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'to-dashboard-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dash'}),manufacturerNameToDisplay);if(user.selectedManufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'to-dashboard-button',onClick:_this.handleResetManufacturer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dash'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),manufacturerNameToDisplay);}if(user.selectedInspector)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'to-dashboard-button',onClick:user.selectInspector(null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dash'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),inspectorNameToDisplay);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'to-dashboard-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dash'}));};_this.getActiveMenu=function(){var user=_this.props.user;var classes=user.isMultipleRoles()?'active-menu-item multiple-menu-item':'active-menu-item';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,onClick:_this.handleActiveMenuClick},__WEBPACK_IMPORTED_MODULE_1_constants_roles__["b" /* ROLE_MENU_NAMES */][user.getActiveRole()],_this.getMenuList());};_this.getMenuList=function(){var isOpen=_this.state.isOpen;var user=_this.props.user;var menuList=[];var getMenuElement=function getMenuElement(role){if(!__WEBPACK_IMPORTED_MODULE_1_constants_roles__["b" /* ROLE_MENU_NAMES */][role])return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-list-item',key:role,onClick:_this.handleMenuClick(role)},__WEBPACK_IMPORTED_MODULE_1_constants_roles__["b" /* ROLE_MENU_NAMES */][role]);};var deleteRolesWithSameMenuListLink=function deleteRolesWithSameMenuListLink(rolesList){var unDuplicatedList=rolesList.filter(function(roleToCheckForDuplicates,roleToCheckIndex){var roleToCheckMenuEntryName=__WEBPACK_IMPORTED_MODULE_1_constants_roles__["b" /* ROLE_MENU_NAMES */][roleToCheckForDuplicates];var followingDuplicatesList=rolesList.filter(function(possibleDuplicateRole,possibleDuplicateIndex){return roleToCheckMenuEntryName===__WEBPACK_IMPORTED_MODULE_1_constants_roles__["b" /* ROLE_MENU_NAMES */][possibleDuplicateRole]&&roleToCheckIndex<possibleDuplicateIndex;});return followingDuplicatesList.length===0;});return unDuplicatedList;};if(user.isInternal()){var allRolesServerNamesList=Object.keys(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */]).map(function(roleKey){return __WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][roleKey].serverName;});menuList=deleteRolesWithSameMenuListLink(allRolesServerNamesList).filter(function(role){return role!==user.getActiveRole();}).map(function(role){return getMenuElement(role);}).filter(function(element){return element;});}else if(user.isInspector()){var _allRolesServerNamesList=Object.keys(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */]).map(function(roleKey){return __WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][roleKey].serverName;});menuList=_allRolesServerNamesList.filter(function(role){return(role===__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].BOAT_MANUFACTURER.serverName||role===__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */].TRAILER_MANUFACTURER.serverName)&&role!==user.getActiveRole();}).map(function(role){return getMenuElement(role);}).filter(function(element){return element;});}else{menuList=deleteRolesWithSameMenuListLink(user.roles).filter(function(role){return role!==user.getActiveRole();}).map(function(role){return getMenuElement(role);}).filter(function(element){return element;});}var classes='menu-list '+(isOpen?' open':'');var resultList=[];for(var i=0;i<menuList.length-1;i++){resultList.push(menuList[i]);resultList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{key:'hr_'+i}));}resultList.push(menuList[menuList.length-1]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},resultList);};_this.handleActiveMenuClick=function(){var isOpen=_this.state.isOpen;if(isOpen){_this.closeMenu();}else{_this.setState({isOpen:true});document.addEventListener('click',_this.closeMenu);}};_this.closeMenu=function(){_this.setState({isOpen:false});document.removeEventListener('click',_this.closeMenu);};_this.handleMenuClick=function(role){return function(){var user=_this.props.user;var roleNameForURL='';Object.keys(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */]).forEach(function(roleKey){if(__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][roleKey].serverName===role)roleNameForURL=__WEBPACK_IMPORTED_MODULE_1_constants_roles__["a" /* ROLES */][roleKey].nameForUrl;});if(user.isInspector()||user.isInternal()){user.goToDashboard(roleNameForURL);}else{user.goToSummary(user.getManufacturerCode(),roleNameForURL);}};};_this.state={isOpen:false};return _this;}_createClass(MainNavigationComponent,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,user=_props.user,changeMenu=_props.changeMenu;changeMenu(user.getActiveRole());}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.closeMenu);}},{key:'render',value:function render(){var user=this.props.user;if(!user.roles||!user.roles.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'main-navigation _z_index_max'},this.getBackToDashboardButton(),this.getActiveMenu());}}]);return MainNavigationComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MainNavigationComponent);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProfileComponent=function(_React$Component){_inherits(ProfileComponent,_React$Component);function ProfileComponent(props){_classCallCheck(this,ProfileComponent);var _this=_possibleConstructorReturn(this,(ProfileComponent.__proto__||Object.getPrototypeOf(ProfileComponent)).call(this,props));_this.openDropDown=function(){if(!_this.state.isOpen){_this.setState({isOpen:true});document.addEventListener('click',_this.closeDropDown);}};_this.closeDropDown=function(){if(_this.state.isOpen){_this.setState({isOpen:false});document.removeEventListener('click',_this.closeDropDown);}};_this.getDropDownContent=function(){var logOut=_this.props.logOut;if(_this.state.isOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-dropDown-item',onClick:logOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Log out'));}else{return null;}};_this.state={isOpen:false};return _this;}_createClass(ProfileComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.closeDropDown);}},{key:'render',value:function render(){var user=this.props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile '+(this.state.isOpen?'open':''),onClick:this.openDropDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,user.firstName+' '+user.lastName),this.getDropDownContent());}}]);return ProfileComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ProfileComponent);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdditionNavigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdditionNavigation=function(_Component){_inherits(AdditionNavigation,_Component);function AdditionNavigation(props){_classCallCheck(this,AdditionNavigation);var _this=_possibleConstructorReturn(this,(AdditionNavigation.__proto__||Object.getPrototypeOf(AdditionNavigation)).call(this,props));_this._goTo=function(link){var _this$props=_this.props,user=_this$props.user,location=_this$props.location;return function(){var prevLink=location.pathname+location.hash;_this.setState({isOpen:false},function(){if(prevLink!==link){user.goTo(link);}else{window.location.reload();}});};};_this._getLinks=function(){var additionalMenu=_this.state.additionalMenu;var _this$props2=_this.props,user=_this$props2.user,location=_this$props2.location;if(!user.getActiveRole())return[];if(user.isInspector()&&!user.isManufacturerSelected())return[];if(!additionalMenu)return[];return additionalMenu[user.getRoleName()].map(function(menu,index){var isSelected=location.pathname===menu.link;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index+1,onClick:_this._goTo(menu.link),className:'additional-menu-item '+(menu.index===1?'new':'')+' '+(isSelected?'active':'')},menu.name);});};_this._openMenu=function(event){Object(__WEBPACK_IMPORTED_MODULE_1_helpers__["h" /* stopPropagation */])(event);document.addEventListener('click',_this._closeMenu);_this.setState(function(prevState){return{isOpen:!prevState.isOpen};});};_this._closeMenu=function(event){Object(__WEBPACK_IMPORTED_MODULE_1_helpers__["h" /* stopPropagation */])(event);document.removeEventListener('click',_this._closeMenu);_this.setState({isOpen:false});};_this._getMenuClass=function(isEmpty){var isOpen=_this.state.isOpen;if(!isEmpty||isOpen===undefined)return'';return isOpen?'additional-navigation-open':'additional-navigation-close';};_this.state={isOpen:false};return _this;}_createClass(AdditionNavigation,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this._closeMenu);}},{key:'render',value:function render(){var links=this._getLinks();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'additional-navigation-wrapper'},!!links.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-button',onClick:this._openMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'additional-navigation '+this._getMenuClass(links.length)},links));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){var additionalMenu=nextProps.user.getAditionalMenu();return{additionalMenu:additionalMenu};}}]);return AdditionNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var Footer=function Footer(){var currentYear=__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()).format('YYYY');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'main-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA9 '+currentYear+' National Marine Manufacturers Association'));};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_utils__ = __webpack_require__(109);
var isLocalhost=Boolean(window.location.hostname==='localhost'||window.location.hostname==='[::1]'||window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if('serviceWorker'in navigator){var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';navigator.serviceWorker.ready.then(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["b" /* consoleLog */])('This web app is being served cache-first by a service worker.');});if(isLocalhost){checkValidServiceWorker(swUrl);}else{registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["b" /* consoleLog */])('New content is available, please refresh.');}else{Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["b" /* consoleLog */])('Content is cached for offline use.');}}};};}).catch(function(error){return Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["a" /* consoleError */])('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){fetch(swUrl).then(function(response){if(response.status!==404){registerValidSW(swUrl);}else{navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}}).catch(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__app_utils__["b" /* consoleLog */])('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.8d125bd2.js